webpackJsonp([39,34],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../react-lib/src/styles/A11yHidden.js
var A11yHidden = __webpack_require__(133);

// EXTERNAL MODULE: ../react-lib/src/styles/ButtonColor.js
var ButtonColor = __webpack_require__(163);

// EXTERNAL MODULE: ../design-system/index.js + 1 modules
var design_system = __webpack_require__(100);

// CONCATENATED MODULE: ../react-lib/src/styles/DSTokenMap.js

// EXTERNAL MODULE: ../react-lib/src/styles/Elevation.js
var Elevation = __webpack_require__(151);

// EXTERNAL MODULE: ../react-lib/src/styles/Font.js
var Font = __webpack_require__(62);

// EXTERNAL MODULE: ../react-lib/src/types/Enum.js
var Enum = __webpack_require__(6);

// CONCATENATED MODULE: ../react-lib/src/styles/FooterTheme.js
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }



var FooterTheme =
/*#__PURE__*/
function (_Enum) {
  _inherits(FooterTheme, _Enum);

  function FooterTheme() {
    _classCallCheck(this, FooterTheme);

    return _possibleConstructorReturn(this, _getPrototypeOf(FooterTheme).apply(this, arguments));
  }

  return FooterTheme;
}(Enum["a" /* default */]);

FooterTheme.LIGHT = new FooterTheme('light');
FooterTheme.DARK = new FooterTheme('dark');
FooterTheme.isLocked = true;

// EXTERNAL MODULE: ../react-lib/src/styles/MediaQuery.js + 2 modules
var MediaQuery = __webpack_require__(18);

// CONCATENATED MODULE: ../react-lib/src/styles/NavBarTheme.js
function NavBarTheme__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { NavBarTheme__typeof = function _typeof(obj) { return typeof obj; }; } else { NavBarTheme__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return NavBarTheme__typeof(obj); }

function NavBarTheme__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function NavBarTheme__possibleConstructorReturn(self, call) { if (call && (NavBarTheme__typeof(call) === "object" || typeof call === "function")) { return call; } return NavBarTheme__assertThisInitialized(self); }

function NavBarTheme__assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function NavBarTheme__getPrototypeOf(o) { NavBarTheme__getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return NavBarTheme__getPrototypeOf(o); }

function NavBarTheme__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) NavBarTheme__setPrototypeOf(subClass, superClass); }

function NavBarTheme__setPrototypeOf(o, p) { NavBarTheme__setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return NavBarTheme__setPrototypeOf(o, p); }



var NavBarTheme =
/*#__PURE__*/
function (_Enum) {
  NavBarTheme__inherits(NavBarTheme, _Enum);

  function NavBarTheme() {
    NavBarTheme__classCallCheck(this, NavBarTheme);

    return NavBarTheme__possibleConstructorReturn(this, NavBarTheme__getPrototypeOf(NavBarTheme).apply(this, arguments));
  }

  _createClass(NavBarTheme, [{
    key: "isTransparent",
    value: function isTransparent() {
      return this.value === 'transparent';
    }
  }]);

  return NavBarTheme;
}(Enum["a" /* default */]);

NavBarTheme.TRANSPARENT = new NavBarTheme('transparent');
NavBarTheme.OPAQUE = new NavBarTheme('opaque');
NavBarTheme.isLocked = true;

// EXTERNAL MODULE: ../react-lib/src/styles/Spacing.js
var Spacing = __webpack_require__(46);

// EXTERNAL MODULE: ../react-lib/src/styles/ZIndex.js
var ZIndex = __webpack_require__(78);

// EXTERNAL MODULE: ../react-lib/src/styles/Color.js
var Color = __webpack_require__(137);

// CONCATENATED MODULE: ../react-lib/src/styles/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return A11yHidden["a" /* default */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return ButtonColor["a" /* default */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "d", function() { return design_system["b" /* DSTokenMap */]; });
/* unused concated harmony import Elevation */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return Elevation["a" /* default */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "f", function() { return Font["d" /* default */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "g", function() { return Font["b" /* FontSize */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "h", function() { return Font["c" /* FontWeight */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "e", function() { return Font["a" /* FONT_FAMILY */]; });
/* unused concated harmony import FooterTheme */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return FooterTheme; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "j", function() { return MediaQuery["b" /* default */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "i", function() { return MediaQuery["b" /* default */]; });
/* unused concated harmony import NavBarTheme */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return NavBarTheme; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "k", function() { return Spacing["a" /* default */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "l", function() { return ZIndex["a" /* default */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "c", function() { return Color["a" /* default */]; });













/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

if (true) {
  module.exports = __webpack_require__(171)
} else {
  module.exports = require("./cjs/react.development.js")
}


/***/ }),
/* 4 */,
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/* harmony default export */ __webpack_exports__["a"] = (isArray);


/***/ }),
/* 6 */,
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return sym; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TASK; });
/* unused harmony export HELPER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MATCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CANCEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SAGA_ACTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SELF_CANCELLATION; });
/* unused harmony export konst */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return kTrue; });
/* unused harmony export kFalse */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return noop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return ident; });
/* harmony export (immutable) */ __webpack_exports__["g"] = check;
/* unused harmony export hasOwn */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return is; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return object; });
/* harmony export (immutable) */ __webpack_exports__["t"] = remove;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return array; });
/* harmony export (immutable) */ __webpack_exports__["i"] = deferred;
/* unused harmony export arrayOfDeffered */
/* harmony export (immutable) */ __webpack_exports__["j"] = delay;
/* unused harmony export createMockTask */
/* unused harmony export autoInc */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return uid; });
/* harmony export (immutable) */ __webpack_exports__["q"] = makeIterator;
/* harmony export (immutable) */ __webpack_exports__["p"] = log;
/* harmony export (immutable) */ __webpack_exports__["k"] = deprecate;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return updateIncentive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return internalErr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return createSetContextWarning; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return wrapSagaDispatch; });
/* unused harmony export cloneableGenerator */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var sym = function sym(id) {
  return '@@redux-saga/' + id;
};

var TASK = /*#__PURE__*/sym('TASK');
var HELPER = /*#__PURE__*/sym('HELPER');
var MATCH = /*#__PURE__*/sym('MATCH');
var CANCEL = /*#__PURE__*/sym('CANCEL_PROMISE');
var SAGA_ACTION = /*#__PURE__*/sym('SAGA_ACTION');
var SELF_CANCELLATION = /*#__PURE__*/sym('SELF_CANCELLATION');
var konst = function konst(v) {
  return function () {
    return v;
  };
};
var kTrue = /*#__PURE__*/konst(true);
var kFalse = /*#__PURE__*/konst(false);
var noop = function noop() {};
var ident = function ident(v) {
  return v;
};

function check(value, predicate, error) {
  if (!predicate(value)) {
    log('error', 'uncaught at check', error);
    throw new Error(error);
  }
}

var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn(object, property) {
  return is.notUndef(object) && hasOwnProperty.call(object, property);
}

var is = {
  undef: function undef(v) {
    return v === null || v === undefined;
  },
  notUndef: function notUndef(v) {
    return v !== null && v !== undefined;
  },
  func: function func(f) {
    return typeof f === 'function';
  },
  number: function number(n) {
    return typeof n === 'number';
  },
  string: function string(s) {
    return typeof s === 'string';
  },
  array: Array.isArray,
  object: function object(obj) {
    return obj && !is.array(obj) && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object';
  },
  promise: function promise(p) {
    return p && is.func(p.then);
  },
  iterator: function iterator(it) {
    return it && is.func(it.next) && is.func(it.throw);
  },
  iterable: function iterable(it) {
    return it && is.func(Symbol) ? is.func(it[Symbol.iterator]) : is.array(it);
  },
  task: function task(t) {
    return t && t[TASK];
  },
  observable: function observable(ob) {
    return ob && is.func(ob.subscribe);
  },
  buffer: function buffer(buf) {
    return buf && is.func(buf.isEmpty) && is.func(buf.take) && is.func(buf.put);
  },
  pattern: function pattern(pat) {
    return pat && (is.string(pat) || (typeof pat === 'undefined' ? 'undefined' : _typeof(pat)) === 'symbol' || is.func(pat) || is.array(pat));
  },
  channel: function channel(ch) {
    return ch && is.func(ch.take) && is.func(ch.close);
  },
  helper: function helper(it) {
    return it && it[HELPER];
  },
  stringableFunc: function stringableFunc(f) {
    return is.func(f) && hasOwn(f, 'toString');
  }
};

var object = {
  assign: function assign(target, source) {
    for (var i in source) {
      if (hasOwn(source, i)) {
        target[i] = source[i];
      }
    }
  }
};

function remove(array, item) {
  var index = array.indexOf(item);
  if (index >= 0) {
    array.splice(index, 1);
  }
}

var array = {
  from: function from(obj) {
    var arr = Array(obj.length);
    for (var i in obj) {
      if (hasOwn(obj, i)) {
        arr[i] = obj[i];
      }
    }
    return arr;
  }
};

function deferred() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var def = _extends({}, props);
  var promise = new Promise(function (resolve, reject) {
    def.resolve = resolve;
    def.reject = reject;
  });
  def.promise = promise;
  return def;
}

function arrayOfDeffered(length) {
  var arr = [];
  for (var i = 0; i < length; i++) {
    arr.push(deferred());
  }
  return arr;
}

function delay(ms) {
  var val = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  var timeoutId = void 0;
  var promise = new Promise(function (resolve) {
    timeoutId = setTimeout(function () {
      return resolve(val);
    }, ms);
  });

  promise[CANCEL] = function () {
    return clearTimeout(timeoutId);
  };

  return promise;
}

function createMockTask() {
  var _ref;

  var running = true;
  var _result = void 0,
      _error = void 0;

  return _ref = {}, _ref[TASK] = true, _ref.isRunning = function isRunning() {
    return running;
  }, _ref.result = function result() {
    return _result;
  }, _ref.error = function error() {
    return _error;
  }, _ref.setRunning = function setRunning(b) {
    return running = b;
  }, _ref.setResult = function setResult(r) {
    return _result = r;
  }, _ref.setError = function setError(e) {
    return _error = e;
  }, _ref;
}

function autoInc() {
  var seed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  return function () {
    return ++seed;
  };
}

var uid = /*#__PURE__*/autoInc();

var kThrow = function kThrow(err) {
  throw err;
};
var kReturn = function kReturn(value) {
  return { value: value, done: true };
};
function makeIterator(next) {
  var thro = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : kThrow;
  var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var isHelper = arguments[3];

  var iterator = { name: name, next: next, throw: thro, return: kReturn };

  if (isHelper) {
    iterator[HELPER] = true;
  }
  if (typeof Symbol !== 'undefined') {
    iterator[Symbol.iterator] = function () {
      return iterator;
    };
  }
  return iterator;
}

/**
  Print error in a useful way whether in a browser environment
  (with expandable error stack traces), or in a node.js environment
  (text-only log output)
 **/
function log(level, message) {
  var error = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  /*eslint-disable no-console*/
  if (typeof window === 'undefined') {
    console.log('redux-saga ' + level + ': ' + message + '\n' + (error && error.stack || error));
  } else {
    console[level](message, error);
  }
}

function deprecate(fn, deprecationWarning) {
  return function () {
    if (false) log('warn', deprecationWarning);
    return fn.apply(undefined, arguments);
  };
}

var updateIncentive = function updateIncentive(deprecated, preferred) {
  return deprecated + ' has been deprecated in favor of ' + preferred + ', please update your code';
};

var internalErr = function internalErr(err) {
  return new Error('\n  redux-saga: Error checking hooks detected an inconsistent state. This is likely a bug\n  in redux-saga code and not yours. Thanks for reporting this in the project\'s github repo.\n  Error: ' + err + '\n');
};

var createSetContextWarning = function createSetContextWarning(ctx, props) {
  return (ctx ? ctx + '.' : '') + 'setContext(props): argument ' + props + ' is not a plain object';
};

var wrapSagaDispatch = function wrapSagaDispatch(dispatch) {
  return function (action) {
    return dispatch(Object.defineProperty(action, SAGA_ACTION, { value: true }));
  };
};

var cloneableGenerator = function cloneableGenerator(generatorFunc) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var history = [];
    var gen = generatorFunc.apply(undefined, args);
    return {
      next: function next(arg) {
        history.push(arg);
        return gen.next(arg);
      },
      clone: function clone() {
        var clonedGen = cloneableGenerator(generatorFunc).apply(undefined, args);
        history.forEach(function (arg) {
          return clonedGen.next(arg);
        });
        return clonedGen;
      },
      return: function _return(value) {
        return gen.return(value);
      },
      throw: function _throw(exception) {
        return gen.throw(exception);
      }
    };
  };
};

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/* harmony default export */ __webpack_exports__["a"] = (isObject);


/***/ }),
/* 9 */,
/* 10 */,
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export detach */
/* harmony export (immutable) */ __webpack_exports__["g"] = take;
/* unused harmony export takem */
/* unused harmony export put */
/* unused harmony export all */
/* unused harmony export race */
/* harmony export (immutable) */ __webpack_exports__["c"] = call;
/* unused harmony export apply */
/* unused harmony export cps */
/* harmony export (immutable) */ __webpack_exports__["e"] = fork;
/* unused harmony export spawn */
/* unused harmony export join */
/* harmony export (immutable) */ __webpack_exports__["d"] = cancel;
/* harmony export (immutable) */ __webpack_exports__["f"] = select;
/* harmony export (immutable) */ __webpack_exports__["a"] = actionChannel;
/* unused harmony export cancelled */
/* unused harmony export flush */
/* unused harmony export getContext */
/* unused harmony export setContext */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return asEffect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(7);


var IO = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__utils__["u" /* sym */])('IO');
var TAKE = 'TAKE';
var PUT = 'PUT';
var ALL = 'ALL';
var RACE = 'RACE';
var CALL = 'CALL';
var CPS = 'CPS';
var FORK = 'FORK';
var JOIN = 'JOIN';
var CANCEL = 'CANCEL';
var SELECT = 'SELECT';
var ACTION_CHANNEL = 'ACTION_CHANNEL';
var CANCELLED = 'CANCELLED';
var FLUSH = 'FLUSH';
var GET_CONTEXT = 'GET_CONTEXT';
var SET_CONTEXT = 'SET_CONTEXT';

var TEST_HINT = '\n(HINT: if you are getting this errors in tests, consider using createMockTask from redux-saga/utils)';

var effect = function effect(type, payload) {
  var _ref;

  return _ref = {}, _ref[IO] = true, _ref[type] = payload, _ref;
};

var detach = function detach(eff) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(asEffect.fork(eff), __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].object, 'detach(eff): argument must be a fork effect');
  eff[FORK].detached = true;
  return eff;
};

function take() {
  var patternOrChannel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '*';

  if (arguments.length) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(arguments[0], __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'take(patternOrChannel): patternOrChannel is undefined');
  }
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].pattern(patternOrChannel)) {
    return effect(TAKE, { pattern: patternOrChannel });
  }
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].channel(patternOrChannel)) {
    return effect(TAKE, { channel: patternOrChannel });
  }
  throw new Error('take(patternOrChannel): argument ' + String(patternOrChannel) + ' is not valid channel or a valid pattern');
}

take.maybe = function () {
  var eff = take.apply(undefined, arguments);
  eff[TAKE].maybe = true;
  return eff;
};

var takem = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__utils__["k" /* deprecate */])(take.maybe, /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__utils__["w" /* updateIncentive */])('takem', 'take.maybe'));

function put(channel, action) {
  if (arguments.length > 1) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(channel, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'put(channel, action): argument channel is undefined');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(channel, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].channel, 'put(channel, action): argument ' + channel + ' is not a valid channel');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(action, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'put(channel, action): argument action is undefined');
  } else {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(channel, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'put(action): argument action is undefined');
    action = channel;
    channel = null;
  }
  return effect(PUT, { channel: channel, action: action });
}

put.resolve = function () {
  var eff = put.apply(undefined, arguments);
  eff[PUT].resolve = true;
  return eff;
};

put.sync = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__utils__["k" /* deprecate */])(put.resolve, /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__utils__["w" /* updateIncentive */])('put.sync', 'put.resolve'));

function all(effects) {
  return effect(ALL, effects);
}

function race(effects) {
  return effect(RACE, effects);
}

function getFnCallDesc(meth, fn, args) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(fn, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, meth + ': argument fn is undefined');

  var context = null;
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].array(fn)) {
    var _fn = fn;
    context = _fn[0];
    fn = _fn[1];
  } else if (fn.fn) {
    var _fn2 = fn;
    context = _fn2.context;
    fn = _fn2.fn;
  }
  if (context && __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].string(fn) && __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(context[fn])) {
    fn = context[fn];
  }
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(fn, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func, meth + ': argument ' + fn + ' is not a function');

  return { context: context, fn: fn, args: args };
}

function call(fn) {
  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return effect(CALL, getFnCallDesc('call', fn, args));
}

function apply(context, fn) {
  var args = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  return effect(CALL, getFnCallDesc('apply', { context: context, fn: fn }, args));
}

function cps(fn) {
  for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }

  return effect(CPS, getFnCallDesc('cps', fn, args));
}

function fork(fn) {
  for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    args[_key3 - 1] = arguments[_key3];
  }

  return effect(FORK, getFnCallDesc('fork', fn, args));
}

function spawn(fn) {
  for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    args[_key4 - 1] = arguments[_key4];
  }

  return detach(fork.apply(undefined, [fn].concat(args)));
}

function join() {
  for (var _len5 = arguments.length, tasks = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    tasks[_key5] = arguments[_key5];
  }

  if (tasks.length > 1) {
    return all(tasks.map(function (t) {
      return join(t);
    }));
  }
  var task = tasks[0];
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(task, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'join(task): argument task is undefined');
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(task, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].task, 'join(task): argument ' + task + ' is not a valid Task object ' + TEST_HINT);
  return effect(JOIN, task);
}

function cancel() {
  for (var _len6 = arguments.length, tasks = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
    tasks[_key6] = arguments[_key6];
  }

  if (tasks.length > 1) {
    return all(tasks.map(function (t) {
      return cancel(t);
    }));
  }
  var task = tasks[0];
  if (tasks.length === 1) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(task, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'cancel(task): argument task is undefined');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(task, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].task, 'cancel(task): argument ' + task + ' is not a valid Task object ' + TEST_HINT);
  }
  return effect(CANCEL, task || __WEBPACK_IMPORTED_MODULE_0__utils__["d" /* SELF_CANCELLATION */]);
}

function select(selector) {
  for (var _len7 = arguments.length, args = Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
    args[_key7 - 1] = arguments[_key7];
  }

  if (arguments.length === 0) {
    selector = __WEBPACK_IMPORTED_MODULE_0__utils__["l" /* ident */];
  } else {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(selector, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'select(selector,[...]): argument selector is undefined');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(selector, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func, 'select(selector,[...]): argument ' + selector + ' is not a function');
  }
  return effect(SELECT, { selector: selector, args: args });
}

/**
  channel(pattern, [buffer])    => creates an event channel for store actions
**/
function actionChannel(pattern, buffer) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(pattern, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'actionChannel(pattern,...): argument pattern is undefined');
  if (arguments.length > 1) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(buffer, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'actionChannel(pattern, buffer): argument buffer is undefined');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(buffer, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].buffer, 'actionChannel(pattern, buffer): argument ' + buffer + ' is not a valid buffer');
  }
  return effect(ACTION_CHANNEL, { pattern: pattern, buffer: buffer });
}

function cancelled() {
  return effect(CANCELLED, {});
}

function flush(channel) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(channel, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].channel, 'flush(channel): argument ' + channel + ' is not valid channel');
  return effect(FLUSH, channel);
}

function getContext(prop) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(prop, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].string, 'getContext(prop): argument ' + prop + ' is not a string');
  return effect(GET_CONTEXT, prop);
}

function setContext(props) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(props, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].object, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* createSetContextWarning */])(null, props));
  return effect(SET_CONTEXT, props);
}

var createAsEffectType = function createAsEffectType(type) {
  return function (effect) {
    return effect && effect[IO] && effect[type];
  };
};

var asEffect = {
  take: /*#__PURE__*/createAsEffectType(TAKE),
  put: /*#__PURE__*/createAsEffectType(PUT),
  all: /*#__PURE__*/createAsEffectType(ALL),
  race: /*#__PURE__*/createAsEffectType(RACE),
  call: /*#__PURE__*/createAsEffectType(CALL),
  cps: /*#__PURE__*/createAsEffectType(CPS),
  fork: /*#__PURE__*/createAsEffectType(FORK),
  join: /*#__PURE__*/createAsEffectType(JOIN),
  cancel: /*#__PURE__*/createAsEffectType(CANCEL),
  select: /*#__PURE__*/createAsEffectType(SELECT),
  actionChannel: /*#__PURE__*/createAsEffectType(ACTION_CHANNEL),
  cancelled: /*#__PURE__*/createAsEffectType(CANCELLED),
  flush: /*#__PURE__*/createAsEffectType(FLUSH),
  getContext: /*#__PURE__*/createAsEffectType(GET_CONTEXT),
  setContext: /*#__PURE__*/createAsEffectType(SET_CONTEXT)
};

/***/ }),
/* 12 */,
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(1);

// EXTERNAL MODULE: ../node_modules/classnames/index.js
var classnames = __webpack_require__(24);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ../react-lib/src/styles/styled-system/index.js + 21 modules
var styled_system = __webpack_require__(123);

// EXTERNAL MODULE: ../react-lib/src/styles/index.js + 3 modules
var styles = __webpack_require__(2);

// EXTERNAL MODULE: ../react-lib/src/styles/Font.js
var Font = __webpack_require__(62);

// EXTERNAL MODULE: ../react-lib/src/components/buttons/Button/Button.types.js
var Button_types = __webpack_require__(94);

// CONCATENATED MODULE: ../react-lib/src/components/buttons/Button/Button.jsx
var _buttonTypeToTextColo;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








var buttonTypeToTextColor = (_buttonTypeToTextColo = {}, _defineProperty(_buttonTypeToTextColo, Button_types["a" /* ButtonType */].DEFAULT, styles["b" /* ButtonColor */].BUTTON_DEFAULT_COLOR), _defineProperty(_buttonTypeToTextColo, Button_types["a" /* ButtonType */].PRIMARY, styles["d" /* DSToken */].BACKGROUND_COLOR_PRIMARY), _defineProperty(_buttonTypeToTextColo, Button_types["a" /* ButtonType */].DARK, styles["b" /* ButtonColor */].BUTTON_DARK_COLOR), _defineProperty(_buttonTypeToTextColo, Button_types["a" /* ButtonType */].TEXT, styles["d" /* DSToken */].INTERACTIVE_TEXT_COLOR_LINK_PRIMARY), _defineProperty(_buttonTypeToTextColo, Button_types["a" /* ButtonType */].TEXT_LIGHT, styles["d" /* DSToken */].INTERACTIVE_TEXT_COLOR_LINK_PRIMARY_INVERSE), _defineProperty(_buttonTypeToTextColo, Button_types["a" /* ButtonType */].TERTIARY, styles["b" /* ButtonColor */].BUTTON_TERTIARY_COLOR), _buttonTypeToTextColo);
var StyledButton = styled_components_browser_esm["default"].button.withConfig({
  displayName: "Button__StyledButton",
  componentId: "sc-1257ed2-0"
})(["display:inline-block;margin-bottom:0;font-weight:normal;text-align:center;vertical-align:middle;cursor:pointer;white-space:nowrap;padding:", " ", ";border:1px solid transparent;font-size:", ";line-height:1.6;border-radius:", ";user-select:none;", " &:disabled{cursor:not-allowed;}&.", "{background:", ";border-color:", ";color:", ";&:hover{background:", ";}}&.", "{background:", ";border-color:", ";color:", ";&:hover{background:", ";border-color:", ";}}&.", "{background:", ";border-color:", ";color:", ";&:hover{background:", ";}}&.", ",&.", "{border:none;display:inline;outline-offset:0;outline:none;text-decoration:none;&:hover{text-decoration:underline;}}&.", "{background:", ";color:", ";&:hover{color:", ";}}&.", "{background:", ";color:", ";}&.", "{background:", ";}&.", "{color:", ";background:", ";&:hover{background:", ";}&:active{background:", ";}}"], styles["k" /* Spacing */].S, styles["k" /* Spacing */].M, styles["g" /* FontSize */].M, styles["d" /* DSToken */].BORDER_RADIUS, styled_system["b" /* margin */], Button_types["a" /* ButtonType */].DEFAULT, styles["b" /* ButtonColor */].BUTTON_DEFAULT_BACKGROUND, styles["b" /* ButtonColor */].BUTTON_DEFAULT_BORDER, buttonTypeToTextColor[Button_types["a" /* ButtonType */].DEFAULT], styles["b" /* ButtonColor */].BUTTON_DEFAULT_HOVER, Button_types["a" /* ButtonType */].PRIMARY, styles["c" /* Color */].GREEN_BASE, styles["c" /* Color */].GREEN_BASE, buttonTypeToTextColor[Button_types["a" /* ButtonType */].PRIMARY], styles["c" /* Color */].GREEN_BASE, styles["c" /* Color */].GREEN_BASE, Button_types["a" /* ButtonType */].DARK, styles["b" /* ButtonColor */].BUTTON_DARK_BACKGROUND, styles["b" /* ButtonColor */].BUTTON_DARK_BORDER, buttonTypeToTextColor[Button_types["a" /* ButtonType */].DARK], styles["b" /* ButtonColor */].BUTTON_DARK_HOVER, Button_types["a" /* ButtonType */].TEXT, Button_types["a" /* ButtonType */].TEXT_LIGHT, Button_types["a" /* ButtonType */].TEXT, styles["b" /* ButtonColor */].BUTTON_TEXT_BACKGROUND, buttonTypeToTextColor[Button_types["a" /* ButtonType */].TEXT], styles["d" /* DSToken */].INTERACTIVE_TEXT_COLOR_LINK_PRIMARY_PRESSED, Button_types["a" /* ButtonType */].TEXT_LIGHT, styles["b" /* ButtonColor */].BUTTON_TEXT_LIGHT_BACKGROUND, buttonTypeToTextColor[Button_types["a" /* ButtonType */].TEXT_LIGHT], Button_types["a" /* ButtonType */].DANGER, styles["c" /* Color */].RED_40, Button_types["a" /* ButtonType */].TERTIARY, buttonTypeToTextColor[Button_types["a" /* ButtonType */].TERTIARY], styles["b" /* ButtonColor */].BUTTON_TERTIARY_BACKGROUND, styles["b" /* ButtonColor */].BUTTON_TERTIARY_BACKGROUND_HOVER, styles["b" /* ButtonColor */].BUTTON_TERTIARY_BACKGROUND_PRESSED);

var getTextColor = function getTextColor(_ref) {
  var buttonType = _ref.buttonType;
  return buttonTypeToTextColor[buttonType] || 'black';
};

var StyledText = styled_components_browser_esm["default"].span.withConfig({
  displayName: "Button__StyledText",
  componentId: "sc-1257ed2-1"
})(["color:", ";font-weight:", ";"], getTextColor, Font["c" /* FontWeight */].NORMAL);
var ButtonContext = Object(react["createContext"])();

var Button_Button = function Button(_ref2) {
  var className = _ref2.className,
      buttonType = _ref2.buttonType,
      children = _ref2.children,
      other = _objectWithoutProperties(_ref2, ["className", "buttonType", "children"]);

  var buttonAppearance = {
    buttonType: buttonType
  };
  var finalClassName = classnames_default()(className, buttonType.toString());
  return react_default.a.createElement(StyledButton, _extends({
    className: finalClassName
  }, other), react_default.a.createElement(ButtonContext.Provider, {
    value: buttonAppearance
  }, children));
};

var Button_Text = function Text(_ref3) {
  var children = _ref3.children;
  var buttonAppearance = Object(react["useContext"])(ButtonContext);
  var buttonType = buttonAppearance ? buttonAppearance.buttonType : Button_types["a" /* ButtonType */].DEFAULT;
  return react_default.a.createElement(StyledText, {
    buttonType: buttonType
  }, children);
};

Button_Button.Text = Button_Text;
Button_Button.defaultProps = {
  type: 'button',
  className: '',
  buttonType: Button_types["a" /* ButtonType */].DEFAULT,
  'aria-label': undefined,
  role: undefined,
  tabIndex: undefined,
  disabled: undefined,
  'data-qa-id': undefined
};
Button_Button.types = Button_types["a" /* ButtonType */];
/* harmony default export */ var buttons_Button_Button = (Button_Button);
// CONCATENATED MODULE: ../react-lib/src/components/buttons/Button/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return buttons_Button_Button; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return Button_types["a" /* ButtonType */]; });



/***/ }),
/* 14 */,
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/lodash-es/isFunction.js
var isFunction = __webpack_require__(25);

// EXTERNAL MODULE: ../node_modules/lodash-es/_root.js
var _root = __webpack_require__(10);

// CONCATENATED MODULE: ../node_modules/lodash-es/_coreJsData.js


/** Used to detect overreaching core-js shims. */
var coreJsData = _root["a" /* default */]['__core-js_shared__'];

/* harmony default export */ var _coreJsData = (coreJsData);

// CONCATENATED MODULE: ../node_modules/lodash-es/_isMasked.js


/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(_coreJsData && _coreJsData.keys && _coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/* harmony default export */ var _isMasked = (isMasked);

// EXTERNAL MODULE: ../node_modules/lodash-es/isObject.js
var isObject = __webpack_require__(8);

// EXTERNAL MODULE: ../node_modules/lodash-es/_toSource.js
var _toSource = __webpack_require__(92);

// CONCATENATED MODULE: ../node_modules/lodash-es/_baseIsNative.js





/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var _baseIsNative_hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(_baseIsNative_hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!Object(isObject["a" /* default */])(value) || _isMasked(value)) {
    return false;
  }
  var pattern = Object(isFunction["a" /* default */])(value) ? reIsNative : reIsHostCtor;
  return pattern.test(Object(_toSource["a" /* default */])(value));
}

/* harmony default export */ var _baseIsNative = (baseIsNative);

// CONCATENATED MODULE: ../node_modules/lodash-es/_getValue.js
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/* harmony default export */ var _getValue = (getValue);

// CONCATENATED MODULE: ../node_modules/lodash-es/_getNative.js



/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = _getValue(object, key);
  return _baseIsNative(value) ? value : undefined;
}

/* harmony default export */ var _getNative = __webpack_exports__["a"] = (getNative);


/***/ }),
/* 16 */,
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return END; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isEnd; });
/* harmony export (immutable) */ __webpack_exports__["b"] = emitter;
/* unused harmony export INVALID_BUFFER */
/* unused harmony export UNDEFINED_INPUT_ERROR */
/* unused harmony export channel */
/* harmony export (immutable) */ __webpack_exports__["c"] = eventChannel;
/* harmony export (immutable) */ __webpack_exports__["e"] = stdChannel;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__buffers__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scheduler__ = __webpack_require__(98);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var CHANNEL_END_TYPE = '@@redux-saga/CHANNEL_END';
var END = { type: CHANNEL_END_TYPE };
var isEnd = function isEnd(a) {
  return a && a.type === CHANNEL_END_TYPE;
};

function emitter() {
  var subscribers = [];

  function subscribe(sub) {
    subscribers.push(sub);
    return function () {
      return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["t" /* remove */])(subscribers, sub);
    };
  }

  function emit(item) {
    var arr = subscribers.slice();
    for (var i = 0, len = arr.length; i < len; i++) {
      arr[i](item);
    }
  }

  return {
    subscribe: subscribe,
    emit: emit
  };
}

var INVALID_BUFFER = 'invalid buffer passed to channel factory function';
var UNDEFINED_INPUT_ERROR = 'Saga was provided with an undefined action';

if (false) {
  UNDEFINED_INPUT_ERROR += '\nHints:\n    - check that your Action Creator returns a non-undefined value\n    - if the Saga was started using runSaga, check that your subscribe source provides the action to its listeners\n  ';
}

function channel() {
  var buffer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_1__buffers__["a" /* buffers */].fixed();

  var closed = false;
  var takers = [];

  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(buffer, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].buffer, INVALID_BUFFER);

  function checkForbiddenStates() {
    if (closed && takers.length) {
      throw Object(__WEBPACK_IMPORTED_MODULE_0__utils__["m" /* internalErr */])('Cannot have a closed channel with pending takers');
    }
    if (takers.length && !buffer.isEmpty()) {
      throw Object(__WEBPACK_IMPORTED_MODULE_0__utils__["m" /* internalErr */])('Cannot have pending takers with non empty buffer');
    }
  }

  function put(input) {
    checkForbiddenStates();
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(input, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, UNDEFINED_INPUT_ERROR);
    if (closed) {
      return;
    }
    if (!takers.length) {
      return buffer.put(input);
    }
    for (var i = 0; i < takers.length; i++) {
      var cb = takers[i];
      if (!cb[__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* MATCH */]] || cb[__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* MATCH */]](input)) {
        takers.splice(i, 1);
        return cb(input);
      }
    }
  }

  function take(cb) {
    checkForbiddenStates();
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(cb, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func, "channel.take's callback must be a function");

    if (closed && buffer.isEmpty()) {
      cb(END);
    } else if (!buffer.isEmpty()) {
      cb(buffer.take());
    } else {
      takers.push(cb);
      cb.cancel = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["t" /* remove */])(takers, cb);
      };
    }
  }

  function flush(cb) {
    checkForbiddenStates(); // TODO: check if some new state should be forbidden now
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(cb, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func, "channel.flush' callback must be a function");
    if (closed && buffer.isEmpty()) {
      cb(END);
      return;
    }
    cb(buffer.flush());
  }

  function close() {
    checkForbiddenStates();
    if (!closed) {
      closed = true;
      if (takers.length) {
        var arr = takers;
        takers = [];
        for (var i = 0, len = arr.length; i < len; i++) {
          arr[i](END);
        }
      }
    }
  }

  return {
    take: take,
    put: put,
    flush: flush,
    close: close,
    get __takers__() {
      return takers;
    },
    get __closed__() {
      return closed;
    }
  };
}

function eventChannel(subscribe) {
  var buffer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : __WEBPACK_IMPORTED_MODULE_1__buffers__["a" /* buffers */].none();
  var matcher = arguments[2];

  /**
    should be if(typeof matcher !== undefined) instead?
    see PR #273 for a background discussion
  **/
  if (arguments.length > 2) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(matcher, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func, 'Invalid match function passed to eventChannel');
  }

  var chan = channel(buffer);
  var close = function close() {
    if (!chan.__closed__) {
      if (unsubscribe) {
        unsubscribe();
      }
      chan.close();
    }
  };
  var unsubscribe = subscribe(function (input) {
    if (isEnd(input)) {
      close();
      return;
    }
    if (matcher && !matcher(input)) {
      return;
    }
    chan.put(input);
  });
  if (chan.__closed__) {
    unsubscribe();
  }

  if (!__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(unsubscribe)) {
    throw new Error('in eventChannel: subscribe should return a function to unsubscribe');
  }

  return {
    take: chan.take,
    flush: chan.flush,
    close: close
  };
}

function stdChannel(subscribe) {
  var chan = eventChannel(function (cb) {
    return subscribe(function (input) {
      if (input[__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* SAGA_ACTION */]]) {
        cb(input);
        return;
      }
      Object(__WEBPACK_IMPORTED_MODULE_2__scheduler__["a" /* asap */])(function () {
        return cb(input);
      });
    });
  });

  return _extends({}, chan, {
    take: function take(cb, matcher) {
      if (arguments.length > 1) {
        Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(matcher, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func, "channel.take's matcher argument must be a function");
        cb[__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* MATCH */]] = matcher;
      }
      chan.take(cb);
    }
  });
}

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/lodash-es/_baseFlatten.js + 1 modules
var _baseFlatten = __webpack_require__(138);

// EXTERNAL MODULE: ../node_modules/lodash-es/_arrayMap.js
var _arrayMap = __webpack_require__(64);

// EXTERNAL MODULE: ../node_modules/lodash-es/_baseIteratee.js + 9 modules
var _baseIteratee = __webpack_require__(61);

// EXTERNAL MODULE: ../node_modules/lodash-es/_baseMap.js
var _baseMap = __webpack_require__(152);

// EXTERNAL MODULE: ../node_modules/lodash-es/isArray.js
var isArray = __webpack_require__(5);

// CONCATENATED MODULE: ../node_modules/lodash-es/map.js





/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */
function map(collection, iteratee) {
  var func = Object(isArray["a" /* default */])(collection) ? _arrayMap["a" /* default */] : _baseMap["a" /* default */];
  return func(collection, Object(_baseIteratee["a" /* default */])(iteratee, 3));
}

/* harmony default export */ var lodash_es_map = (map);

// CONCATENATED MODULE: ../node_modules/lodash-es/flatMap.js



/**
 * Creates a flattened array of values by running each element in `collection`
 * thru `iteratee` and flattening the mapped results. The iteratee is invoked
 * with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
 *   return [n, n];
 * }
 *
 * _.flatMap([1, 2], duplicate);
 * // => [1, 1, 2, 2]
 */
function flatMap(collection, iteratee) {
  return Object(_baseFlatten["a" /* default */])(lodash_es_map(collection, iteratee), 1);
}

/* harmony default export */ var lodash_es_flatMap = (flatMap);

// EXTERNAL MODULE: ../react-lib/src/types/Enum.js
var Enum = __webpack_require__(6);

// CONCATENATED MODULE: ../react-lib/src/styles/MediaQuery.js
/* unused harmony export XXS_MAX */
/* unused harmony export XS_MAX */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SM_MIN; });
/* unused harmony export SM_MAX */
/* unused harmony export MD_MIN */
/* unused harmony export MD_MAX */
/* unused harmony export LG_MIN */
/* unused harmony export PREFIX */
/* unused harmony export MQ_OR_DELIMETER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MediaQuery_MediaQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return matchesMediaQuery; });
/* unused harmony export getMediaSelector */
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }



var XXS_MAX = 374; // mostly iPhone 5

var XS_MAX = 767;
var SM_MIN = 768;
var SM_MAX = 991;
var MD_MIN = 992;
var MD_MAX = 1199;
var LG_MIN = 1200;
var PREFIX = '@media ';
var MQ_OR_DELIMETER = /[\n,]+/;

var MediaQuery_MediaQuery =
/*#__PURE__*/
function (_Enum) {
  _inherits(MediaQuery, _Enum);

  function MediaQuery() {
    _classCallCheck(this, MediaQuery);

    return _possibleConstructorReturn(this, _getPrototypeOf(MediaQuery).apply(this, arguments));
  }

  _createClass(MediaQuery, [{
    key: "getBreakpointString",
    // no space after `min-width in `(min-width:768px)` due to a bug in jest-styled-component
    // https://github.com/styled-components/jest-styled-components/issues/98
    //  ${MQ.MD_UP} and ${MQ.HD} will not work. Use ${MQ.getHDMediaQuery(MQ.MD_UP)} instead
    value: function getBreakpointString() {
      return this.value.substring(PREFIX.length).trim();
    }
  }], [{
    key: "getHDMediaQuery",
    value: function getHDMediaQuery(mq) {
      var hdStrings = MediaQuery.HD.getBreakpointString().split(MQ_OR_DELIMETER);
      var mqStrings = mq.getBreakpointString().split(MQ_OR_DELIMETER); // return a cartesian product of two array joins by 'and'
      // https://stackoverflow.com/a/16114118

      var hdMediaQueryString = lodash_es_flatMap(hdStrings, function (hdString) {
        return mqStrings.map(function (mqString) {
          return "".concat(hdString, " and ").concat(mqString);
        });
      }).join(',');
      return "".concat(PREFIX, " ").concat(hdMediaQueryString);
    }
  }]);

  return MediaQuery;
}(Enum["a" /* default */]);

MediaQuery_MediaQuery.XXS = new MediaQuery_MediaQuery("".concat(PREFIX, "(max-width:").concat(XXS_MAX, "px)"));
MediaQuery_MediaQuery.XS = new MediaQuery_MediaQuery("".concat(PREFIX, "(max-width:").concat(XS_MAX, "px)"));
MediaQuery_MediaQuery.XS_DOWN = new MediaQuery_MediaQuery("".concat(PREFIX, "(max-width:").concat(XS_MAX, "px)"));
MediaQuery_MediaQuery.NOT_XS = new MediaQuery_MediaQuery("".concat(PREFIX, "(min-width:").concat(SM_MIN, "px)"));
MediaQuery_MediaQuery.SM = new MediaQuery_MediaQuery("".concat(PREFIX, "(min-width:").concat(SM_MIN, "px) and (max-width:").concat(SM_MAX, "px)"));
MediaQuery_MediaQuery.SM_UP = new MediaQuery_MediaQuery("".concat(PREFIX, "(min-width:").concat(SM_MIN, "px)"));
MediaQuery_MediaQuery.SM_DOWN = new MediaQuery_MediaQuery("".concat(PREFIX, "(max-width:").concat(SM_MAX, "px)"));
MediaQuery_MediaQuery.NOT_SM = new MediaQuery_MediaQuery("".concat(PREFIX, "\n    (max-width:").concat(XS_MAX, "px),\n    (min-width:").concat(MD_MIN, "px)"));
MediaQuery_MediaQuery.MD = new MediaQuery_MediaQuery("".concat(PREFIX, "(min-width:").concat(MD_MIN, "px) and (max-width:").concat(MD_MAX, "px)"));
MediaQuery_MediaQuery.MD_UP = new MediaQuery_MediaQuery("".concat(PREFIX, "(min-width:").concat(MD_MIN, "px)"));
MediaQuery_MediaQuery.MD_DOWN = new MediaQuery_MediaQuery("".concat(PREFIX, "(max-width:").concat(MD_MAX, "px)"));
MediaQuery_MediaQuery.NOT_MD = new MediaQuery_MediaQuery("".concat(PREFIX, "\n    (max-width:").concat(SM_MAX, "px),\n    (min-width:").concat(LG_MIN, "px)"));
MediaQuery_MediaQuery.LG = new MediaQuery_MediaQuery("".concat(PREFIX, "(min-width:").concat(LG_MIN, "px)"));
MediaQuery_MediaQuery.NOT_LG = new MediaQuery_MediaQuery("".concat(PREFIX, "(max-width:").concat(MD_MAX, "px)"));
MediaQuery_MediaQuery.HD = new MediaQuery_MediaQuery("".concat(PREFIX, "\n  only screen and (-webkit-min-device-pixel-ratio:2),\n  only screen and (min--moz-device-pixel-ratio:2),\n  only screen and (-o-min-device-pixel-ratio:2/1),\n  only screen and (min-device-pixel-ratio:2),\n  only screen and (min-resolution:192dpi),\n  only screen and (min-resolution:2dppx)"));
MediaQuery_MediaQuery.isLocked = true;

var matchesMediaQuery = function matchesMediaQuery(mediaQuery) {
  return window.matchMedia && window.matchMedia(mediaQuery.getBreakpointString()).matches;
};
var getMediaSelector = function getMediaSelector(mediaQuery) {
  return mediaQuery.getBreakpointString();
};

/***/ }),
/* 19 */,
/* 20 */,
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/reselect/lib/index.js
var lib = __webpack_require__(201);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// CONCATENATED MODULE: ../utilities/invariant.js
/* harmony default export */ var invariant = (function (condition, message) {
  if (false) {
    // This nested if will allow all of this
    // code to be removed in prod through minification
    if (!condition) {
      throw new Error(message);
    }
  }
});
// CONCATENATED MODULE: ../react-lib/src/lib/redux-duck/createDuck.js


var createDuck_createDuck = function createDuck(_ref) {
  var initialState = _ref.initialState,
      rootSelector = _ref.rootSelector,
      name = _ref.name,
      actions = _ref.actions,
      effects = _ref.effects,
      selectors = _ref.selectors,
      externalActionHandlers = _ref.externalActionHandlers;
  // Build the action creators using a namespaced
  // action type
  var duckActions = {};
  Object.keys(actions).forEach(function (type) {
    var actionType = "".concat(name, "/").concat(type); // $FlowFixMe

    duckActions[type] = Object.assign(function (payload) {
      return {
        payload: payload,
        type: actionType
      };
    }, {
      actionType: actionType,
      toString: function toString() {
        return actionType;
      }
    });
  }); // Build selectors giving them access to the state and each other

  var duckSelectors = {};

  var selector = rootSelector || function (s) {
    return s[name];
  };

  var getDuckState = Object(lib["createSelector"])([selector], function (state) {
    invariant(state, "You have a missing reducer for duck: ".concat(name, ".", '\n', "Register it in the page's <Provider> component. More information here: https://github.com/roverdotcom/web/blob/master/src/frontend/docs/platform/ducks/connecting-components-to-state-management.md#the-top-level-container"));
    return state;
  });
  Object.keys(selectors).forEach(function (type) {
    duckSelectors[type] = selectors[type](getDuckState, lib["createSelector"], duckSelectors);
  }); // Build the effects by passing them the internal
  // actions and effects

  var duckEffects = {};
  Object.keys(effects).forEach(function (type) {
    duckEffects[type] = function (payload) {
      return function (dispatch, getState, extraArgs) {
        var effect = effects[type](payload);
        return effect(dispatch, getState, duckActions, duckEffects, duckSelectors, extraArgs);
      };
    };
  }); // Create the reducer

  var reducer = function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments.length > 1 ? arguments[1] : undefined;

    if (externalActionHandlers && externalActionHandlers[action.type]) {
      return externalActionHandlers[action.type](action)(state);
    }

    if (action.type.includes(name)) {
      var actionType = action.type.replace("".concat(name, "/"), '');
      var reduce = actions[actionType];

      if (reduce) {
        return reduce(action.payload)(state);
      }
    }

    return state;
  };

  return {
    actions: duckActions,
    effects: duckEffects,
    selectors: duckSelectors,
    reducer: reducer
  };
};
// CONCATENATED MODULE: ../react-lib/src/lib/redux-duck/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return createDuck_createDuck; });


/***/ }),
/* 22 */,
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isFunction_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isLength_js__ = __webpack_require__(59);



/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && Object(__WEBPACK_IMPORTED_MODULE_1__isLength_js__["a" /* default */])(value.length) && !Object(__WEBPACK_IMPORTED_MODULE_0__isFunction_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (isArrayLike);


/***/ }),
/* 24 */,
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObject_js__ = __webpack_require__(8);



/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_1__isObject_js__["a" /* default */])(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/* harmony default export */ __webpack_exports__["a"] = (isFunction);


/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayLikeKeys_js__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseKeys_js__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArrayLike_js__ = __webpack_require__(23);




/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__isArrayLike_js__["a" /* default */])(object) ? Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeKeys_js__["a" /* default */])(object) : Object(__WEBPACK_IMPORTED_MODULE_1__baseKeys_js__["a" /* default */])(object);
}

/* harmony default export */ __webpack_exports__["a"] = (keys);


/***/ }),
/* 27 */,
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isSymbol_js__ = __webpack_require__(42);


/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || Object(__WEBPACK_IMPORTED_MODULE_0__isSymbol_js__["a" /* default */])(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/* harmony default export */ __webpack_exports__["a"] = (toKey);


/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ../node_modules/lodash-es/isFunction.js
var isFunction = __webpack_require__(25);

// EXTERNAL MODULE: ../node_modules/lodash-es/mapValues.js
var mapValues = __webpack_require__(116);

// EXTERNAL MODULE: ../node_modules/lodash-es/isArray.js
var isArray = __webpack_require__(5);

// EXTERNAL MODULE: ../node_modules/react-broadcast/esm/react-broadcast.js
var react_broadcast = __webpack_require__(76);

// CONCATENATED MODULE: ../react-lib/src/utils/isShallowEqual.js
/* harmony default export */ var isShallowEqual = (function (objA, objB) {
  if (objA === objB) {
    return true;
  }

  var aKeys = Object.keys(objA);
  var bKeys = Object.keys(objB);
  var len = aKeys.length;

  if (bKeys.length !== len) {
    return false;
  }

  for (var i = 0; i < len; i += 1) {
    var key = aKeys[i];

    if (objA[key] !== objB[key]) {
      return false;
    }
  }

  return true;
});
// EXTERNAL MODULE: ../react-lib/src/components/utils/Redux/Provider.jsx + 5 modules
var Provider = __webpack_require__(58);

// CONCATENATED MODULE: ../react-lib/src/components/utils/Redux/Connect.jsx
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }









var Connect_getActions = function getActions(actions, dispatch, _ref) {
  var prevActions = _ref.prevActions,
      prevDispatchActions = _ref.prevDispatchActions;
  return Object(mapValues["a" /* default */])(actions, function (action, name) {
    if (!action || !Object(isFunction["a" /* default */])(action)) {
      throw new Error("Connect action values must be functions (action ".concat(name, ")"));
    }

    return action === prevActions[name] ? prevDispatchActions[name] : function () {
      return dispatch(action.apply(void 0, arguments));
    };
  });
};

var Connect_InnerConnect =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(InnerConnect, _PureComponent);

  function InnerConnect() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, InnerConnect);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(InnerConnect)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.unsubscribe = void 0;
    _this.state = {
      selectorProps: {},
      actionProps: {},
      effectProps: {}
    };
    _this.prevActions = {};
    _this.prevEffects = {};
    _this.prevDispatchActions = {};
    _this.prevDispatchEffects = {};
    _this.unmounted = false;

    _this.getActions = function () {
      var _assertThisInitialize = _assertThisInitialized(_this),
          store = _assertThisInitialize.store;

      var dispatchActions = Connect_getActions(_this.props.actions, store.dispatch, {
        prevActions: _this.prevActions,
        prevDispatchActions: _this.prevDispatchActions
      });
      _this.prevActions = _this.props.actions;
      _this.prevDispatchActions = dispatchActions;
      return dispatchActions;
    };

    _this.getEffects = function () {
      var _assertThisInitialize2 = _assertThisInitialized(_this),
          store = _assertThisInitialize2.store;

      var dispatchEffects = Connect_getActions(_this.props.effects, store.dispatch, {
        prevActions: _this.prevEffects,
        prevDispatchActions: _this.prevDispatchEffects
      });
      _this.prevEffects = _this.props.effects;
      _this.prevDispatchEffects = dispatchEffects;
      return dispatchEffects;
    };

    _this.updateState = function () {
      var _assertThisInitialize3 = _assertThisInitialized(_this),
          store = _assertThisInitialize3.store;

      var selector = _this.props.selector;
      var nextSelectorProps = selector(store.getState() || {}, _this.props);

      if (!isShallowEqual(nextSelectorProps, _this.state.selectorProps)) {
        // NOTE: In a nested form, if there is an action that causes FormA to unmount FormB,
        // FormB's reducer will be cleared before the update arrive. Since unsubscribe does not
        // affect actions that are already in progress, this function will run even unmounted.
        if (_this.unmounted) {
          return;
        }

        _this.setState(function () {
          return {
            selectorProps: nextSelectorProps,
            actionProps: _this.getActions(),
            effectProps: _this.getEffects(),
            dispatch: store.dispatch
          };
        });
      }
    };

    return _this;
  }

  _createClass(InnerConnect, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var _this2 = this;

      var store = this.store;
      var onMount = this.props.onMount;

      if (onMount) {
        if (Object(isArray["a" /* default */])(onMount)) {
          onMount.forEach(function (action) {
            store.dispatch(action());
          });
        } else {
          // $FlowFixMe
          store.dispatch(onMount());
        }
      }

      this.unsubscribe = store.subscribe(this.updateState);
      this.updateState();
      var selector = this.props.selector;
      var nextSelectorProps = selector(store.getState() || {}, this.props);
      this.setState(function () {
        return {
          selectorProps: nextSelectorProps,
          actionProps: _this2.getActions(),
          effectProps: _this2.getEffects(),
          dispatch: store.dispatch
        };
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var store = this.store;
      this.unsubscribe();
      this.unmounted = true;
      var onUnmount = this.props.onUnmount;

      if (onUnmount) {
        if (Object(isArray["a" /* default */])(onUnmount)) {
          onUnmount.forEach(function (action) {
            store.dispatch(action());
          });
        } else {
          // $FlowFixMe
          store.dispatch(onUnmount());
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children(_objectSpread({}, this.state.selectorProps, {}, this.state.actionProps, {}, this.state.effectProps, {
        dispatch: this.state.dispatch
      }));
    }
  }, {
    key: "store",
    get: function get() {
      return this.props.store || this.props.reduxStore;
    }
  }]);

  return InnerConnect;
}(react["PureComponent"]);

Connect_InnerConnect.defaultProps = {
  selector: function selector() {
    return {};
  },
  actions: {},
  effects: {},
  store: undefined,
  onMount: undefined,
  onUnmount: undefined
};

var Connect_Connect = function Connect(props) {
  return react_default.a.createElement(react_broadcast["b" /* Subscriber */], {
    channel: Provider["a" /* BROADCAST_CHANNEL */]
  }, function (context) {
    return react_default.a.createElement(Connect_InnerConnect, _extends({}, context, props));
  });
};

Connect_Connect.defaultProps = {
  selector: function selector() {
    return {};
  },
  actions: {},
  effects: {},
  store: undefined,
  onMount: undefined,
  onUnmount: undefined
};
/* harmony default export */ var Redux_Connect = __webpack_exports__["a"] = (Connect_Connect);

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rover_utilities_parseApiErrors__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__APIError__ = __webpack_require__(79);
/* eslint-disable no-console */



var DefaultAPIErrorHandler = function DefaultAPIErrorHandler(error) {
  var defaultErrorMessage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'There was an error.';
  if (!error.response) throw error; // Generic Error, so no processing is necessary
  // $FlowFixMe

  var response = error.response;
  var errors = Object(__WEBPACK_IMPORTED_MODULE_0__rover_utilities_parseApiErrors__["a" /* default */])(response);
  var message = errors.length ? errors.pop() : defaultErrorMessage; // FE-3685 Don't console.error during jest tests, it is noisy.

  if (!Object({"NODE_ENV":"production"}).JEST_WORKER_ID) {
    console.error( // $FlowFixMe
    "Error in DefaultAPIErrorHandler: STATUS: ".concat(response.status, ", MESSAGE: ").concat(typeof message === 'string' ? message : message.id));
  } // $FlowFixMe


  throw new __WEBPACK_IMPORTED_MODULE_1__APIError__["a" /* default */](message, response.status); // we throw the Error so that a duck can catch it and handle it
};

/* harmony default export */ __webpack_exports__["a"] = (DefaultAPIErrorHandler);

/***/ }),
/* 31 */,
/* 32 */,
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/* harmony default export */ __webpack_exports__["a"] = (eq);


/***/ }),
/* 34 */,
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ../node_modules/lodash-es/_listCacheClear.js
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/* harmony default export */ var _listCacheClear = (listCacheClear);

// EXTERNAL MODULE: ../node_modules/lodash-es/eq.js
var eq = __webpack_require__(33);

// CONCATENATED MODULE: ../node_modules/lodash-es/_assocIndexOf.js


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (Object(eq["a" /* default */])(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/* harmony default export */ var _assocIndexOf = (assocIndexOf);

// CONCATENATED MODULE: ../node_modules/lodash-es/_listCacheDelete.js


/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/* harmony default export */ var _listCacheDelete = (listCacheDelete);

// CONCATENATED MODULE: ../node_modules/lodash-es/_listCacheGet.js


/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/* harmony default export */ var _listCacheGet = (listCacheGet);

// CONCATENATED MODULE: ../node_modules/lodash-es/_listCacheHas.js


/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return _assocIndexOf(this.__data__, key) > -1;
}

/* harmony default export */ var _listCacheHas = (listCacheHas);

// CONCATENATED MODULE: ../node_modules/lodash-es/_listCacheSet.js


/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

/* harmony default export */ var _listCacheSet = (listCacheSet);

// CONCATENATED MODULE: ../node_modules/lodash-es/_ListCache.js






/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = _listCacheClear;
ListCache.prototype['delete'] = _listCacheDelete;
ListCache.prototype.get = _listCacheGet;
ListCache.prototype.has = _listCacheHas;
ListCache.prototype.set = _listCacheSet;

/* harmony default export */ var _ListCache = __webpack_exports__["a"] = (ListCache);


/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BUFFER_OVERFLOW */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return buffers; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(7);


var BUFFER_OVERFLOW = "Channel's Buffer overflow!";

var ON_OVERFLOW_THROW = 1;
var ON_OVERFLOW_DROP = 2;
var ON_OVERFLOW_SLIDE = 3;
var ON_OVERFLOW_EXPAND = 4;

var zeroBuffer = { isEmpty: __WEBPACK_IMPORTED_MODULE_0__utils__["o" /* kTrue */], put: __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */], take: __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */] };

function ringBuffer() {
  var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
  var overflowAction = arguments[1];

  var arr = new Array(limit);
  var length = 0;
  var pushIndex = 0;
  var popIndex = 0;

  var push = function push(it) {
    arr[pushIndex] = it;
    pushIndex = (pushIndex + 1) % limit;
    length++;
  };

  var take = function take() {
    if (length != 0) {
      var it = arr[popIndex];
      arr[popIndex] = null;
      length--;
      popIndex = (popIndex + 1) % limit;
      return it;
    }
  };

  var flush = function flush() {
    var items = [];
    while (length) {
      items.push(take());
    }
    return items;
  };

  return {
    isEmpty: function isEmpty() {
      return length == 0;
    },
    put: function put(it) {
      if (length < limit) {
        push(it);
      } else {
        var doubledLimit = void 0;
        switch (overflowAction) {
          case ON_OVERFLOW_THROW:
            throw new Error(BUFFER_OVERFLOW);
          case ON_OVERFLOW_SLIDE:
            arr[pushIndex] = it;
            pushIndex = (pushIndex + 1) % limit;
            popIndex = pushIndex;
            break;
          case ON_OVERFLOW_EXPAND:
            doubledLimit = 2 * limit;

            arr = flush();

            length = arr.length;
            pushIndex = arr.length;
            popIndex = 0;

            arr.length = doubledLimit;
            limit = doubledLimit;

            push(it);
            break;
          default:
          // DROP
        }
      }
    },
    take: take,
    flush: flush
  };
}

var buffers = {
  none: function none() {
    return zeroBuffer;
  },
  fixed: function fixed(limit) {
    return ringBuffer(limit, ON_OVERFLOW_THROW);
  },
  dropping: function dropping(limit) {
    return ringBuffer(limit, ON_OVERFLOW_DROP);
  },
  sliding: function sliding(limit) {
    return ringBuffer(limit, ON_OVERFLOW_SLIDE);
  },
  expanding: function expanding(initialSize) {
    return ringBuffer(initialSize, ON_OVERFLOW_EXPAND);
  }
};

/***/ }),
/* 37 */,
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stubFalse_js__ = __webpack_require__(200);



/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || __WEBPACK_IMPORTED_MODULE_1__stubFalse_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (isBuffer);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(106)(module)))

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// CONCATENATED MODULE: ../icons/svg/add-small.svg
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M17 15v-3a1 1 0 1 0-2 0v3h-3a1 1 0 1 0 0 2h3v3a1 1 0 1 0 2 0v-3h3a1 1 0 1 0 0-2h-3zm-1 9a8 8 0 1 1 0-16 8 8 0 0 1 0 16z"
});

var add_small_SvgAddSmall = function SvgAddSmall(props) {
  return react_default.a.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), _ref);
};

/* harmony default export */ var add_small = (__webpack_require__.p + "9de713ab6892b7d79b6f9eac60fa12c8.svg");

// CONCATENATED MODULE: ../icons/svg/alert-caution.svg
function alert_caution__extends() { alert_caution__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return alert_caution__extends.apply(this, arguments); }



var alert_caution__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M1.822 31a1.5 1.5 0 0 1-1.333-2.19L14.668 1.4a1.5 1.5 0 0 1 2.664 0l14.179 27.41A1.5 1.5 0 0 1 30.178 31H1.822zM16 3.177L2.643 29h26.714L16 3.177zM16 11a1 1 0 0 1 1 1v8a1 1 0 1 1-2 0v-8a1 1 0 0 1 1-1zm0 15.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"
});

var alert_caution_SvgAlertCaution = function SvgAlertCaution(props) {
  return react_default.a.createElement("svg", alert_caution__extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), alert_caution__ref);
};

/* harmony default export */ var alert_caution = (__webpack_require__.p + "4c8e412ee30308638e55bfd0c4a06782.svg");

// CONCATENATED MODULE: ../icons/svg/alert-error.svg
function alert_error__extends() { alert_error__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return alert_error__extends.apply(this, arguments); }



var alert_error__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M16 14.586l5.293-5.293a1 1 0 1 1 1.414 1.414L17.414 16l5.293 5.293a1 1 0 0 1-1.414 1.414L16 17.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L14.586 16l-5.293-5.293a1 1 0 0 1 1.414-1.414L16 14.586zM9.828 0h12.344a3 3 0 0 1 2.12.879l6.83 6.828A3 3 0 0 1 32 9.828v12.344a3 3 0 0 1-.879 2.12l-6.828 6.83a3 3 0 0 1-2.121.878H9.828a3 3 0 0 1-2.12-.879l-6.83-6.828A3 3 0 0 1 0 22.172V9.828a3 3 0 0 1 .879-2.12L7.707.877A3 3 0 0 1 9.828 0zm0 2a1 1 0 0 0-.707.293L2.293 9.12A1 1 0 0 0 2 9.828v12.344a1 1 0 0 0 .293.707l6.828 6.828a1 1 0 0 0 .707.293h12.344a1 1 0 0 0 .707-.293l6.828-6.828a1 1 0 0 0 .293-.707V9.828a1 1 0 0 0-.293-.707L22.88 2.293A1 1 0 0 0 22.172 2H9.828z"
});

var alert_error_SvgAlertError = function SvgAlertError(props) {
  return react_default.a.createElement("svg", alert_error__extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), alert_error__ref);
};

/* harmony default export */ var alert_error = (__webpack_require__.p + "b2ce745ca19fbeb40ea5426c7e0694a8.svg");

// CONCATENATED MODULE: ../icons/svg/alert-help.svg
function alert_help__extends() { alert_help__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return alert_help__extends.apply(this, arguments); }



var alert_help__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M15 17a1 1 0 0 1 1-1 4 4 0 1 0-4-4 1 1 0 1 1-2 0 6 6 0 1 1 7 5.917V19a1 1 0 1 1-2 0v-2zm1 15C7.163 32 0 24.837 0 16S7.163 0 16 0s16 7.163 16 16-7.163 16-16 16zm0-2c7.732 0 14-6.268 14-14S23.732 2 16 2 2 8.268 2 16s6.268 14 14 14zm0-4.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"
});

var alert_help_SvgAlertHelp = function SvgAlertHelp(props) {
  return react_default.a.createElement("svg", alert_help__extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), alert_help__ref);
};

/* harmony default export */ var alert_help = (__webpack_require__.p + "f8019854a426e0fa27175695d34cd26c.svg");

// CONCATENATED MODULE: ../icons/svg/alert-info.svg
function alert_info__extends() { alert_info__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return alert_info__extends.apply(this, arguments); }



var alert_info__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M15 22v-7h-1.5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5V22h1.5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5H15zm1 10C7.163 32 0 24.837 0 16S7.163 0 16 0s16 7.163 16 16-7.163 16-16 16zm0-2c7.732 0 14-6.268 14-14S23.732 2 16 2 2 8.268 2 16s6.268 14 14 14zm0-19.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"
});

var alert_info_SvgAlertInfo = function SvgAlertInfo(props) {
  return react_default.a.createElement("svg", alert_info__extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), alert_info__ref);
};

/* harmony default export */ var alert_info = (__webpack_require__.p + "4a16808cef410f87e8904cfe98535f20.svg");

// CONCATENATED MODULE: ../icons/svg/alert-success.svg
function alert_success__extends() { alert_success__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return alert_success__extends.apply(this, arguments); }



var alert_success__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M16 32C7.163 32 0 24.837 0 16S7.163 0 16 0s16 7.163 16 16-7.163 16-16 16zm0-2c7.732 0 14-6.268 14-14S23.732 2 16 2 2 8.268 2 16s6.268 14 14 14zm6.207-20.61a1 1 0 1 1 1.586 1.22l-10 13a1 1 0 0 1-1.5.097l-4-4a1 1 0 1 1 1.414-1.414l3.195 3.195L22.207 9.39z"
});

var alert_success_SvgAlertSuccess = function SvgAlertSuccess(props) {
  return react_default.a.createElement("svg", alert_success__extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), alert_success__ref);
};

/* harmony default export */ var alert_success = (__webpack_require__.p + "af2e80cfaeda348c73d17b574a170e4f.svg");

// CONCATENATED MODULE: ../icons/svg/android.svg
function android__extends() { android__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return android__extends.apply(this, arguments); }



var android__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M11.584 19.437c1.081 0 1.958.894 1.958 1.997v8.569c0 1.103-.877 1.997-1.958 1.997-1.08 0-1.957-.894-1.957-1.997v-8.569c0-1.102.876-1.997 1.957-1.997z"
});

var _ref2 =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M7.115 9.136a2.699 2.699 0 0 0-.012.23v12.981c0 1.396 1.083 2.521 2.428 2.521h12.938c1.345 0 2.428-1.125 2.428-2.52V9.365c0-.078-.003-.155-.01-.23H7.116z"
});

var _ref3 =
/*#__PURE__*/
react_default.a.createElement("path", {
  fillRule: "evenodd",
  d: "M7.75.028a.204.204 0 0 1 .282.077l2.065 3.65c.057.1.023.229-.076.287a.204.204 0 0 1-.281-.077L7.675.315A.213.213 0 0 1 7.75.029zm16.5 0a.213.213 0 0 1 .075.288l-2.065 3.65a.204.204 0 0 1-.281.076.213.213 0 0 1-.076-.287l2.065-3.65a.204.204 0 0 1 .282-.077z",
  clipRule: "evenodd"
});

var _ref4 =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M22.373 21.435c0-1.103-.876-1.997-1.957-1.997s-1.958.894-1.958 1.997v8.568c0 1.103.877 1.997 1.958 1.997 1.08 0 1.957-.894 1.957-1.997v-8.568zM5.915 12.289c0-1.103-.876-1.998-1.957-1.998S2 11.186 2 12.29v8.568c0 1.103.877 1.997 1.958 1.997s1.957-.894 1.957-1.997V12.29zm24.085 0c0-1.103-.877-1.998-1.958-1.998s-1.957.895-1.957 1.998v8.568c0 1.103.876 1.997 1.957 1.997S30 21.96 30 20.857v-8.568z"
});

var _ref5 =
/*#__PURE__*/
react_default.a.createElement("path", {
  fillRule: "evenodd",
  d: "M15.016.596c-4.378.43-7.789 3.7-7.843 7.687h17.654c-.054-3.987-3.465-7.256-7.844-7.687h-1.967zM12.36 5.72a1.01 1.01 0 0 0 1.01-1.012v-.005a1.01 1.01 0 0 0-1.015-1.007 1.01 1.01 0 0 0-1.01 1.012v.006A1.011 1.011 0 0 0 12.36 5.72zm7.56 0a1.01 1.01 0 0 0 1.01-1.012v-.005a1.01 1.01 0 0 0-1.015-1.007 1.01 1.01 0 0 0-1.01 1.012v.006A1.011 1.011 0 0 0 19.92 5.72z",
  clipRule: "evenodd"
});

var android_SvgAndroid = function SvgAndroid(props) {
  return react_default.a.createElement("svg", android__extends({
    fill: "#1B1F23",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), android__ref, _ref2, _ref3, _ref4, _ref5);
};

/* harmony default export */ var android = (__webpack_require__.p + "b21b9e305724d5b3b9ae9091413cf2c9.svg");

// CONCATENATED MODULE: ../icons/svg/arrow-left.svg
function arrow_left__extends() { arrow_left__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return arrow_left__extends.apply(this, arguments); }



var arrow_left__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M5.414 17l5.293 5.293a1 1 0 1 1-1.414 1.414l-6.647-6.646a1.5 1.5 0 0 1 0-2.122l6.647-6.646a1 1 0 1 1 1.414 1.414L5.414 15H29a1 1 0 1 1 0 2H5.414z"
});

var arrow_left_SvgArrowLeft = function SvgArrowLeft(props) {
  return react_default.a.createElement("svg", arrow_left__extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), arrow_left__ref);
};

/* harmony default export */ var arrow_left = (__webpack_require__.p + "0f730a1d5fa25384f6dc61e93157b978.svg");

// CONCATENATED MODULE: ../icons/svg/arrow-right.svg
function arrow_right__extends() { arrow_right__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return arrow_right__extends.apply(this, arguments); }



var arrow_right__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M26.793 17H3a1 1 0 1 1 0-2h23.793L21.5 9.707a1 1 0 0 1 1.414-1.414l6.647 6.646a1.5 1.5 0 0 1 0 2.122l-6.647 6.646a1 1 0 0 1-1.414-1.414L26.793 17z"
});

var arrow_right_SvgArrowRight = function SvgArrowRight(props) {
  return react_default.a.createElement("svg", arrow_right__extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), arrow_right__ref);
};

/* harmony default export */ var arrow_right = (__webpack_require__.p + "eea840ebbb6b8be26423716ef83f10f9.svg");

// CONCATENATED MODULE: ../icons/svg/boarding.svg
function boarding__extends() { boarding__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return boarding__extends.apply(this, arguments); }



var boarding__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M22 17v3a3 3 0 0 1-3 3h-2a3 3 0 0 1-3-3v-3h-3v2H9v-2H7a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h2v-9h2v9h14v-9h2v9h2a1 1 0 0 0 1-1V18a1 1 0 0 0-1-1h-2v2h-2v-2h-3zM2.442 14C.81 14-.163 13.536.015 12.228c.05-.357.19-.676.459-1.153.017-.03.489-.836.631-1.099C1.676 8.924 1.97 8.01 1.97 7s-.293-1.924-.864-2.976c-.142-.263-.614-1.07-.631-1.1-.27-.476-.41-.795-.459-1.152C-.163.464.81 0 2.442 0c4.011 0 7 3.064 7 7s-2.989 7-7 7zm0-2c2.895 0 5-2.157 5-5s-2.105-5-5-5c-.068 0-.132 0-.19.002.115.198.477.82.612 1.069C3.579 4.39 3.969 5.606 3.969 7c0 1.394-.39 2.61-1.105 3.93-.135.249-.498.87-.613 1.068l.19.002zM7 15h22a3 3 0 0 1 3 3v11a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V18a3 3 0 0 1 3-3zm7-2h-2v-2a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3v2h-2v-2a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v2zm2 4v3a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-3h-4z"
});

var boarding_SvgBoarding = function SvgBoarding(props) {
  return react_default.a.createElement("svg", boarding__extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), boarding__ref);
};

/* harmony default export */ var boarding = (__webpack_require__.p + "93a81f7b00e4f73c1414d3ed6c555dda.svg");

// CONCATENATED MODULE: ../icons/svg/calendar.svg
function calendar__extends() { calendar__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return calendar__extends.apply(this, arguments); }



var calendar__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M8 0a1 1 0 0 1 1 1v5H7V1a1 1 0 0 1 1-1zm16 0a1 1 0 0 1 1 1v5h-2V1a1 1 0 0 1 1-1zM2 12v17a1 1 0 0 0 1 1h26a1 1 0 0 0 1-1V12H2zm23-2v2h5V5a1 1 0 0 0-1-1h-2V2h2a3 3 0 0 1 3 3v24a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h2v2H3a1 1 0 0 0-1 1v5h23zm-4-8v2H11V2h10z"
});

var calendar_SvgCalendar = function SvgCalendar(props) {
  return react_default.a.createElement("svg", calendar__extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), calendar__ref);
};

/* harmony default export */ var calendar = (__webpack_require__.p + "69c9ebb832eafb58f5fae92c12689ba7.svg");

// CONCATENATED MODULE: ../icons/svg/call.svg
function call__extends() { call__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return call__extends.apply(this, arguments); }



var call__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M1 8c0-2.207 1.99-4.438 5.843-6.872a3 3 0 0 1 4.043.792l3.682 5.154a1.5 1.5 0 0 1-.16 1.933l-1.2 1.2a3.843 3.843 0 0 0-.289 5.113 23.954 23.954 0 0 0 1.788 1.973 23.97 23.97 0 0 0 1.973 1.788 3.843 3.843 0 0 0 5.113-.288l1.2-1.2a1.5 1.5 0 0 1 1.933-.16l5.154 3.68a3 3 0 0 1 .792 4.044C28.438 29.01 26.207 31 24 31c-3.383 0-8.607-3.192-13.707-8.293C4.972 17.386 1 11.275 1 8zm11.694-.108l-3.435-4.81A1 1 0 0 0 7.91 2.82C4.595 4.914 3 6.702 3 8c0 2.57 3.743 8.328 8.707 13.293C16.464 26.05 21.292 29 24 29c1.298 0 3.086-1.595 5.181-4.911a1 1 0 0 0-.264-1.348l-4.809-3.435-.9.901a5.843 5.843 0 0 1-7.774.438 25.911 25.911 0 0 1-2.141-1.938 25.927 25.927 0 0 1-1.938-2.14 5.843 5.843 0 0 1 .438-7.774l.9-.901z"
});

var call_SvgCall = function SvgCall(props) {
  return react_default.a.createElement("svg", call__extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), call__ref);
};

/* harmony default export */ var call = (__webpack_require__.p + "1c1c112f18ed73ed511171e80ea6ad06.svg");

// CONCATENATED MODULE: ../icons/svg/camera.svg
function camera__extends() { camera__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return camera__extends.apply(this, arguments); }



var camera__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M4 4V2.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5V4h21a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3h-5v-2h5a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h5v2H3a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h1zm12 24a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm0-2a6 6 0 1 0 0-12 6 6 0 0 0 0 12zm10-14a2 2 0 1 1 0-4 2 2 0 0 1 0 4z"
});

var camera_SvgCamera = function SvgCamera(props) {
  return react_default.a.createElement("svg", camera__extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), camera__ref);
};

/* harmony default export */ var camera = (__webpack_require__.p + "e2704873b5f25403219bba46824171ba.svg");

// CONCATENATED MODULE: ../icons/svg/cancel.svg
function cancel__extends() { cancel__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return cancel__extends.apply(this, arguments); }



var cancel__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  fillRule: "evenodd",
  d: "M16 0C7.163 0 0 7.163 0 16s7.163 16 16 16 16-7.163 16-16S24.837 0 16 0zM6.833 5.418A13.946 13.946 0 0 1 16 2c7.732 0 14 6.268 14 14 0 3.506-1.289 6.711-3.418 9.167L6.831 5.42zM5.419 6.833A13.946 13.946 0 0 0 2 16c0 7.732 6.268 14 14 14 3.506 0 6.711-1.289 9.167-3.419L5.42 6.833z"
});

var cancel_SvgCancel = function SvgCancel(props) {
  return react_default.a.createElement("svg", cancel__extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), cancel__ref);
};

/* harmony default export */ var cancel = (__webpack_require__.p + "4febf1e3d683ce2a31bd530d20415523.svg");

// CONCATENATED MODULE: ../icons/svg/car.svg
function car__extends() { car__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return car__extends.apply(this, arguments); }



var car__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  fillRule: "evenodd",
  d: "M24.555 2c.907 0 1.791.282 2.527.808a4.305 4.305 0 0 1 1.591 2.166l3.218 9.314c.073.21.109.43.109.647v12.512A3.56 3.56 0 0 1 28.444 31h-1.555a3.56 3.56 0 0 1-3.53-3.128H8.641A3.562 3.562 0 0 1 5.11 31H3.556A3.56 3.56 0 0 1 0 27.447v-12.51c0-.22.036-.439.108-.646l3.227-9.34a.997.997 0 0 1 .014-.044C3.939 3.243 5.513 2 7.444 2h17.111zm1.361 2.424a2.334 2.334 0 0 0-1.359-.435H7.444a2.34 2.34 0 0 0-2.208 1.58L2 14.935v12.512c0 .86.701 1.564 1.556 1.564H5.11c.855 0 1.557-.704 1.557-1.564v-.57c0-.55.448-.995 1-.995h16.666c.552 0 1 .445 1 .995v.57c0 .86.701 1.564 1.556 1.564h1.555c.855 0 1.556-.704 1.556-1.564V14.936l-3.234-9.36a2.315 2.315 0 0 0-.85-1.152zM7.218 7.018a1 1 0 0 1 .95-.683h15.664a1 1 0 0 1 .95.683l1.674 5.047a.99.99 0 0 1-.14.895c-.188.258-.49.412-.81.412H6.494c-.32 0-.622-.154-.81-.412a.99.99 0 0 1-.14-.895l1.674-5.047zm1.673 1.306l-1.014 3.058h16.246L23.11 8.324H8.89zM7.444 18.49a.342.342 0 0 0-.333.356v.012a.339.339 0 0 0 .209.318c.04.017.084.026.128.027a.343.343 0 0 0 .33-.357.342.342 0 0 0-.334-.356zm-2.333.351a2.336 2.336 0 0 1 2.333-2.34 2.336 2.336 0 0 1 2.334 2.345c0 1.3-1.045 2.346-2.334 2.346h-.007a2.354 2.354 0 0 1-1.655-.698 2.33 2.33 0 0 1-.671-1.653zm19.445-.35c-.17 0-.334.14-.334.356v.01a.341.341 0 0 0 .337.346.343.343 0 0 0 .33-.357.342.342 0 0 0-.333-.356zm-2.334.35a2.336 2.336 0 0 1 2.334-2.34 2.336 2.336 0 0 1 2.333 2.345c0 1.3-1.045 2.346-2.333 2.346h-.007a2.352 2.352 0 0 1-1.655-.697 2.327 2.327 0 0 1-.672-1.654z",
  clipRule: "evenodd"
});

var car_SvgCar = function SvgCar(props) {
  return react_default.a.createElement("svg", car__extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), car__ref);
};

/* harmony default export */ var car = (__webpack_require__.p + "533f5201587518f92695efd09305cca7.svg");

// CONCATENATED MODULE: ../icons/svg/carousel-left.svg
function carousel_left__extends() { carousel_left__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return carousel_left__extends.apply(this, arguments); }



var carousel_left__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M10.414 16l12.293 12.293a1 1 0 1 1-1.414 1.414L8.646 17.061a1.5 1.5 0 0 1 0-2.122L21.293 2.293a1 1 0 1 1 1.414 1.414L10.414 16z"
});

var carousel_left_SvgCarouselLeft = function SvgCarouselLeft(props) {
  return react_default.a.createElement("svg", carousel_left__extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), carousel_left__ref);
};

/* harmony default export */ var carousel_left = (__webpack_require__.p + "f54890adbefad5753b711d48d3d27543.svg");

// CONCATENATED MODULE: ../icons/svg/carousel-left-small.svg
function carousel_left_small__extends() { carousel_left_small__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return carousel_left_small__extends.apply(this, arguments); }



var carousel_left_small__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M19.68 22.27l-5.442-6.35 5.442-6.348a1 1 0 1 0-1.518-1.302l-5.722 6.675a1.5 1.5 0 0 0 0 1.952l5.722 6.675a1 1 0 1 0 1.518-1.302z"
});

var carousel_left_small_SvgCarouselLeftSmall = function SvgCarouselLeftSmall(props) {
  return react_default.a.createElement("svg", carousel_left_small__extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), carousel_left_small__ref);
};

/* harmony default export */ var carousel_left_small = (__webpack_require__.p + "e0b2cc102c57905574c82d157a63b6dd.svg");

// CONCATENATED MODULE: ../icons/svg/carousel-right.svg
function carousel_right__extends() { carousel_right__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return carousel_right__extends.apply(this, arguments); }



var carousel_right__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M21.793 16L9.5 3.707a1 1 0 0 1 1.414-1.414l12.647 12.646a1.5 1.5 0 0 1 0 2.122L10.914 29.707A1 1 0 0 1 9.5 28.293L21.793 16z"
});

var carousel_right_SvgCarouselRight = function SvgCarouselRight(props) {
  return react_default.a.createElement("svg", carousel_right__extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), carousel_right__ref);
};

/* harmony default export */ var carousel_right = (__webpack_require__.p + "feced4d4782a226eca46cb3a0cc81ab0.svg");

// CONCATENATED MODULE: ../icons/svg/carousel-right-small.svg
function carousel_right_small__extends() { carousel_right_small__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return carousel_right_small__extends.apply(this, arguments); }



var carousel_right_small__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M12.32 22.27l5.442-6.35-5.442-6.348a1 1 0 1 1 1.518-1.302l5.722 6.675a1.5 1.5 0 0 1 0 1.952l-5.721 6.675a1 1 0 1 1-1.519-1.302z"
});

var carousel_right_small_SvgCarouselRightSmall = function SvgCarouselRightSmall(props) {
  return react_default.a.createElement("svg", carousel_right_small__extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), carousel_right_small__ref);
};

/* harmony default export */ var carousel_right_small = (__webpack_require__.p + "7f56e5edf922950977b624a06ad3b006.svg");

// CONCATENATED MODULE: ../icons/svg/cat.svg
function cat__extends() { cat__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return cat__extends.apply(this, arguments); }



var cat__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M5.792 23.642C9.785 21.853 11.521 21.306 11 22c-1.372 1.829-2.273 3.187-2.704 4.076 1.399 1.102 3.095 2.114 5.11 3.01l-.812 1.828C4.569 27.347 1 21.857 1 16c0-5.105 2.308-9.297 6.393-12.002 2.372-1.571 5.274-2.59 8.483-2.99l1.117-.14L17 1.994c.007 1.1.007 1.98.002 3.958l-.001.717v.235c6.65-.394 10.717 3.415 10.985 8.551l2.344 1.563a1.5 1.5 0 0 1 .668 1.271c-.11 7.087-4.303 10.415-12.088 9.707l.18-1.992c5.72.52 8.843-1.231 9.679-5.428A1.996 1.996 0 0 1 28 19v-1.131l-2-1.334V16c0-4.517-3.537-7.8-9.877-7.008L15 9.132V8c0-.402 0-.82.002-1.335l.001-.717c.003-1.264.004-2.077.003-2.786-2.464.44-4.677 1.29-6.507 2.503C4.966 8.005 3 11.575 3 16c0 .294.01.587.032.878 5.382-1.658 7.705-2.218 6.968-1.68-2.55 1.861-4.51 3.802-5.88 5.82.428.904.983 1.781 1.672 2.624zM22 18a2 2 0 1 1 0-4 2 2 0 0 1 0 4zM13 6v3H8c1.333-2 3-3 5-3z"
});

var cat_SvgCat = function SvgCat(props) {
  return react_default.a.createElement("svg", cat__extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), cat__ref);
};

/* harmony default export */ var cat = (__webpack_require__.p + "3c1cd8b03d3de0b2189b7f5632afcf82.svg");

// CONCATENATED MODULE: ../icons/svg/chat-inbox.svg
function chat_inbox__extends() { chat_inbox__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return chat_inbox__extends.apply(this, arguments); }



var chat_inbox__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M14.348 26a36.39 36.39 0 0 1-10.08 5.617 1.5 1.5 0 0 1-1.954-1.826c.705-2.437 1.217-4.582 1.537-6.43A10.977 10.977 0 0 1 0 15v-4C0 4.925 4.925 0 11 0h10c6.075 0 11 4.925 11 11v4c0 6.075-4.925 11-11 11h-6.652zm-.973-1.78l.274-.22H21a9 9 0 0 0 9-9v-4a9 9 0 0 0-9-9H11a9 9 0 0 0-9 9v4a8.982 8.982 0 0 0 3.54 7.155l.473.362-.092.588c-.286 1.82-.757 3.914-1.414 6.282a34.472 34.472 0 0 0 8.868-5.168zM8 10h8v2H8v-2zm0 4h16v2H8v-2z"
});

var chat_inbox_SvgChatInbox = function SvgChatInbox(props) {
  return react_default.a.createElement("svg", chat_inbox__extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), chat_inbox__ref);
};

/* harmony default export */ var chat_inbox = (__webpack_require__.p + "8bf73ed7a1a5fcbe3ddc861727b9d1fa.svg");

// CONCATENATED MODULE: ../icons/svg/check.svg
function check__extends() { check__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return check__extends.apply(this, arguments); }



var check__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M26.191 4.412a1 1 0 1 1 1.618 1.176l-16 22a1 1 0 0 1-1.516.12l-6-6a1 1 0 1 1 1.414-1.415l5.173 5.172L26.19 4.412z"
});

var check_SvgCheck = function SvgCheck(props) {
  return react_default.a.createElement("svg", check__extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), check__ref);
};

/* harmony default export */ var check = (__webpack_require__.p + "c52d358ed1127f178ad3b1ff2d59e9be.svg");

// CONCATENATED MODULE: ../icons/svg/check-small.svg
function check_small__extends() { check_small__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return check_small__extends.apply(this, arguments); }



var check_small__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M21.614 11.21a1 1 0 0 1 .175 1.404l-7 9a1 1 0 0 1-1.496.093l-3-3a1 1 0 1 1 1.414-1.414l2.2 2.199 6.304-8.106a1 1 0 0 1 1.403-.175z"
});

var check_small_SvgCheckSmall = function SvgCheckSmall(props) {
  return react_default.a.createElement("svg", check_small__extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), check_small__ref);
};

/* harmony default export */ var check_small = (__webpack_require__.p + "11b4d640d39a22ad4647424e7042e0ac.svg");

// CONCATENATED MODULE: ../icons/svg/check-circle.svg
function check_circle__extends() { check_circle__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return check_circle__extends.apply(this, arguments); }



var check_circle__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M16 28c6.627 0 12-5.373 12-12S22.627 4 16 4 4 9.373 4 16s5.373 12 12 12z",
  fill: "#14A96D"
});

var check_circle__ref2 =
/*#__PURE__*/
react_default.a.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.614 11.21a1 1 0 0 1 .175 1.404l-7 9a1 1 0 0 1-1.496.093l-3-3a1 1 0 1 1 1.414-1.414l2.2 2.199 6.304-8.106a1 1 0 0 1 1.403-.175z",
  fill: "#fff"
});

var check_circle_SvgCheckCircle = function SvgCheckCircle(props) {
  return react_default.a.createElement("svg", check_circle__extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), check_circle__ref, check_circle__ref2);
};

/* harmony default export */ var check_circle = (__webpack_require__.p + "8ee59f88d48dcc8e8befada492a191dd.svg");

// CONCATENATED MODULE: ../icons/svg/cleaning.svg
function cleaning__extends() { cleaning__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return cleaning__extends.apply(this, arguments); }



var cleaning__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M25.405 28.377c-4.225 1.497-14.585 1.497-18.81 0l-.646 1.94a1 1 0 1 1-1.898-.633l.775-2.323c-1.769-1.528-2.687-4.058-2.811-7.527A3.001 3.001 0 0 1 3 14h1.083a6.009 6.009 0 0 1 3.572-4.524A5 5 0 1 1 17 7a6.994 6.994 0 0 1 5.75 3.006A5.002 5.002 0 0 1 27.9 14H29a3 3 0 0 1 .966 5.841c-.013.185-.03.389-.052.608a16.906 16.906 0 0 1-.604 3.158c-.471 1.57-1.163 2.854-2.14 3.743l.779 2.334a1 1 0 0 1-1.898.632l-.646-1.94zm.025-2.199a.845.845 0 0 1 .03-.02c.845-.571 1.493-1.657 1.934-3.125A14.963 14.963 0 0 0 27.947 20H4.023c.148 3.116 1.01 5.143 2.515 6.157l.032.021c2.696 1.763 16.164 1.763 18.86 0zM29 18a1 1 0 1 0 0-2H3a1 1 0 1 0 0 2h26zM6.126 14h19.703a3.001 3.001 0 0 0-3.401-1.946l-.71.137-.352-.63A4.997 4.997 0 0 0 17 9a4.99 4.99 0 0 0-4.05 2.067l-.488.672-.75-.356A4.002 4.002 0 0 0 6.126 14zm3.642-4.996a5.997 5.997 0 0 1 2.06.28 6.991 6.991 0 0 1 3.158-1.99 3 3 0 1 0-5.218 1.71zM25 8a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm0-2a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm-3 12v2h5.948L28 18h-6zm-4 0v2h2v-2h-2z"
});

var cleaning_SvgCleaning = function SvgCleaning(props) {
  return react_default.a.createElement("svg", cleaning__extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), cleaning__ref);
};

/* harmony default export */ var cleaning = (__webpack_require__.p + "152c004d1b1a1e6eb230808e90cf6240.svg");

// CONCATENATED MODULE: ../icons/svg/clear-small.svg
function clear_small__extends() { clear_small__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return clear_small__extends.apply(this, arguments); }



var clear_small__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M16 14.586l-2.293-2.293a1 1 0 0 0-1.414 1.414L14.586 16l-2.293 2.293a1 1 0 0 0 1.414 1.414L16 17.414l2.293 2.293a1 1 0 0 0 1.414-1.414L17.414 16l2.293-2.293a1 1 0 0 0-1.414-1.414L16 14.586zM16 24a8 8 0 1 1 0-16 8 8 0 0 1 0 16z"
});

var clear_small_SvgClearSmall = function SvgClearSmall(props) {
  return react_default.a.createElement("svg", clear_small__extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), clear_small__ref);
};

/* harmony default export */ var clear_small = (__webpack_require__.p + "5f9b2627b35db00615305f3dee66cefe.svg");

// CONCATENATED MODULE: ../icons/svg/close.svg
function close__extends() { close__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return close__extends.apply(this, arguments); }



var close__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M16 14.586L26.293 4.293a1 1 0 1 1 1.414 1.414L17.414 16l10.293 10.293a1 1 0 0 1-1.414 1.414L16 17.414 5.707 27.707a1 1 0 0 1-1.414-1.414L14.586 16 4.293 5.707a1 1 0 0 1 1.414-1.414L16 14.586z"
});

var close_SvgClose = function SvgClose(props) {
  return react_default.a.createElement("svg", close__extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), close__ref);
};

/* harmony default export */ var svg_close = (__webpack_require__.p + "0bfc6ecc5c39bc0b510a3abca7c32450.svg");

// CONCATENATED MODULE: ../icons/svg/collapse-small.svg
function collapse_small__extends() { collapse_small__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return collapse_small__extends.apply(this, arguments); }



var collapse_small__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M22.35 19.6L16 14.159l-6.35 5.443a1 1 0 1 1-1.3-1.519l6.674-5.72a1.5 1.5 0 0 1 1.952 0l6.675 5.72a1 1 0 0 1-1.302 1.519z"
});

var collapse_small_SvgCollapseSmall = function SvgCollapseSmall(props) {
  return react_default.a.createElement("svg", collapse_small__extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), collapse_small__ref);
};

/* harmony default export */ var collapse_small = (__webpack_require__.p + "d36c185bf21c683d0c965b4d59cbc1f3.svg");

// CONCATENATED MODULE: ../icons/svg/copy.svg
function copy__extends() { copy__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return copy__extends.apply(this, arguments); }



var copy__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M11.728 6A2.73 2.73 0 0 0 9 8.729v19.545A2.73 2.73 0 0 0 11.728 31h14.09a2.73 2.73 0 0 0 2.728-2.727V12.254l-6.254-6.253H11.728zM25.82 28.273H11.728V8.727h8.636v5.454h5.455v14.091zM4 25V4c0-1.655 1.345-3 3-3h10.75c1.653 0 3 1.345 3 3H7v24c-1.655 0-3-1.346-3-3z"
});

var copy_SvgCopy = function SvgCopy(props) {
  return react_default.a.createElement("svg", copy__extends({
    fill: "#1B1F23",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), copy__ref);
};

/* harmony default export */ var copy = (__webpack_require__.p + "c7794e0e89152818f4c3497e3e8ef1fc.svg");

// CONCATENATED MODULE: ../icons/svg/credit-card.svg
function credit_card__extends() { credit_card__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return credit_card__extends.apply(this, arguments); }



var credit_card__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M5 20a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1H5z"
});

var credit_card__ref2 =
/*#__PURE__*/
react_default.a.createElement("path", {
  fillRule: "evenodd",
  d: "M0 7a3 3 0 0 1 3-3h26a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V7zm3-1a1 1 0 0 0-1 1v3h28V7a1 1 0 0 0-1-1H3zM2 25V14h28v11a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1z"
});

var credit_card_SvgCreditCard = function SvgCreditCard(props) {
  return react_default.a.createElement("svg", credit_card__extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), credit_card__ref, credit_card__ref2);
};

/* harmony default export */ var credit_card = (__webpack_require__.p + "40b7db14fd2028a2301f481990fabcac.svg");

// CONCATENATED MODULE: ../icons/svg/daycare.svg
function daycare__extends() { daycare__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return daycare__extends.apply(this, arguments); }



var daycare__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M4.888 26.54A11.965 11.965 0 0 1 4 22c0-6.627 5.373-12 12-12s12 5.373 12 12c0 .282-.01.563-.029.84 1.924.122 2.853.16 4.029.16v2c-1.412 0-2.465-.052-5.102-.224-5.038-.329-7.498-.329-10.734.21-1.907.318-3.13.726-5.705 1.78C6.389 28.43 4.153 29 0 29v-2c1.94 0 3.412-.13 4.888-.46zm21.087-3.826c.016-.236.025-.474.025-.714 0-5.523-4.477-10-10-10S6 16.477 6 22c0 1.42.296 2.772.83 3.996a44.245 44.245 0 0 0 2.871-1.081c2.705-1.107 4.042-1.553 6.135-1.901 3.19-.532 5.643-.57 10.139-.3zM16 0a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0V1a1 1 0 0 1 1-1zm14.83 10.866a1 1 0 0 1-.366 1.366l-2.598 1.5a1 1 0 0 1-1-1.732l2.598-1.5a1 1 0 0 1 1.366.366zm-29.33 0a1 1 0 0 1 1.366-.366L5.464 12a1 1 0 1 1-1 1.732l-2.598-1.5a1 1 0 0 1-.366-1.366zm28.571-7.159a1 1 0 0 1 0 1.414l-4.95 4.95a1 1 0 0 1-1.414-1.414l4.95-4.95a1 1 0 0 1 1.414 0zm-28.253 0a1 1 0 0 1 1.414 0l4.95 4.95a1 1 0 0 1-1.414 1.414l-4.95-4.95a1 1 0 0 1 0-1.414zm20.048.793a1 1 0 0 1 .366 1.366l-1 1.732a1 1 0 1 1-1.732-1l1-1.732a1 1 0 0 1 1.366-.366zm-12 0a1 1 0 0 1 1.366.366l1 1.732a1 1 0 0 1-1.732 1l-1-1.732A1 1 0 0 1 9.866 4.5zM30 15a1 1 0 1 1 0 2 1 1 0 0 1 0-2zM2 16a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
});

var daycare_SvgDaycare = function SvgDaycare(props) {
  return react_default.a.createElement("svg", daycare__extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), daycare__ref);
};

/* harmony default export */ var daycare = (__webpack_require__.p + "2bb4ced7c0459c77dfc64247698e64e9.svg");

// CONCATENATED MODULE: ../icons/svg/dog.svg
function dog__extends() { dog__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return dog__extends.apply(this, arguments); }



var dog__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M5.094 7.244A4 4 0 0 1 6.5 7c3.314 0 5.073 3.595 5.939 9.464a53.76 53.76 0 0 1 .491 5.346c.055 1.218.07 2.13.07 3.19 0 3.396-2.115 6-6.5 6S0 28.396 0 25c0-1.06.015-1.973.07-3.19a53.58 53.58 0 0 1 .491-5.346c.376-2.55.92-4.67 1.688-6.252.456-2.638.919-4.04 1.9-5.445C5.649 2.617 8.11 1.384 12 1c4.86 0 8.01 1.995 9.653 5.445C22.736 8.72 23 10.858 23 14h-2c0-2.858-.236-4.77-1.153-6.695C18.535 4.55 16.087 3 12.1 2.995c-4.04.404-5.91 1.45-7.005 4.25zM6.5 29c3.178 0 4.5-1.627 4.5-4a63.42 63.42 0 0 0-.068-3.099 51.626 51.626 0 0 0-.472-5.145C9.737 11.855 8.34 9 6.5 9c-1.84 0-3.237 2.855-3.96 7.756a51.629 51.629 0 0 0-.472 5.145A63.47 63.47 0 0 0 2 25c0 2.373 1.322 4 4.5 4zm23.206-10H29a2 2 0 0 1-2-2v-1h-6v-2h9.496a1.5 1.5 0 0 1 1.5 1.5v.023C31.882 22.998 29.214 27 24 27h-7v-2h7c3.117 0 5.017-1.91 5.706-6zM17 15a2 2 0 1 1 0-4 2 2 0 0 1 0 4z"
});

var dog_SvgDog = function SvgDog(props) {
  return react_default.a.createElement("svg", dog__extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), dog__ref);
};

/* harmony default export */ var dog = (__webpack_require__.p + "cb2125f303d72b0a2f39c283b5ba30d2.svg");

// CONCATENATED MODULE: ../icons/svg/dog-size-giant.svg
function dog_size_giant__extends() { dog_size_giant__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return dog_size_giant__extends.apply(this, arguments); }



var dog_size_giant__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  fillRule: "evenodd",
  d: "M1.56 5.37s.2-.5.36-.96c.16-.48-.21-.78.26-1.27.15-.17.53-.47.5-.56-.12-.16.07-.06.2-.09.04 0 .52-.27.59-.3 0-.08.12-.03.22-.05.2-.07.43-.11.66-.15.04-.06.16-.2.22-.02l.56-.03c1.7 0 3 .8 3.57 1.63.58.84 2.66 5.42 4.57 5.95 1.9.52.65.86 7.5.52 2.51-.15 4.8.8 5.75 1.31.3.23.3.34.54.41.24.07 1.16.43 1.56 1.17.67.68 1.59 2.52 1.66 3.1.07.6 0 1.29.26 1.61.16.31.27 1.53.56 2.15.3.62.16 1.59.3 2 .12.42.6 2.08.6 3.02 0 .95-.16 2.85-.72 2-.1-.35-.18-.11-.18.5s-.01 1.58-.11 1.77c-.1.19-.2.35-.1.68.1.33 0 .76-.15 1-.14.23-.18.22-.14.46.03.25 0 .78-.62.78s-1.56-.13-1.7-.13c-.15 0-.63-.45-.27-.96.35-.51.6-.52.6-.86 0-.33.03-.79.06-.92.09-.31-.19-.59-.4-1-.2-.4-.52-.96-.7-1.37-.19-.41-.45-1.18-.78-.32-.2.64-.27.56-.27.93 0 .36-.1.66-.05.76.05.11-.1.18-.14.23-.04.21-.06.35 0 .6 0 .54.02.79-.1.89-.1.1-.22.14-.22.35s-.16.56-.58.56c-.43 0-1.35.05-1.6-.09s-.97-.43-.25-1.08c.26-.16.68.15.85-.7-.05-.76-.16-1-.25-1.45-.1-.44-.07-1.65-1.21-2.48s-1.53-1.87-1.63-2.34c-.1-.47-.61-1.27-2.82-.26-.97.48-1.17.43-1.82.43-.65 0-1.4.38-1.8.46-.42.08-.37-.04-.64 0s-.3.26-.47.34c-.52-.04-1-.92-1.96.38.07 1.12-.27 1.23-.27 1.46 0 .23 0 .82.07 1.07.07.26.08 1.03 0 1.03s-.35-1-.35-.09c.02.39-.05.27-.13.15a2.2 2.2 0 0 0 0 .94c.07.27.14.7-.06.15-.04.37-.01.9.06 1.13.03.6-.03.94-.92-.15-.2.08-.3.62-.3.94 0 .55-.07.61-.35.73-.27.1-.39.2-.5.2-.1 0-.32.17-.32.25-.1.05-.19-.24-.28-.24s-.19.24-.29.24c-.1 0-.25-.15-.58-.1-.33.04-.74-.02-.91-.14-.17-.12-.72-.22-.24-1-.73 0-1.1-.03-1.33-.1-.23.03-.48.03-.74-.1-.33 0-.87-.37-.14-1.03.33-.56.45-.35.83-.44.38-.1.47-.23.47-1.67.04-1.4-.14-2.91-.14-3.43s-.04-1.55-.23-2.35c-.46-.61-1.1-1.54-1.24-1.9-.17.35-.11.45-.43-.39-.32-.84-.37-.7-.57-1.12-.2-.42-.25-.82-.38-.75-.13.06-.16.07-.2-.55-.2-.56-.18-.55-.18-1.13-.02-.31.04-.45 0-.57-.05-.12-.34.2-.05-.42-.03-.57 0-.46-.07-.83-.06-.36-.12-.4-.06-.57.06-.17.03-.09-.06-.17-.1-.08-.1-.07-.06-.27.04-.2-.01-.26-.1-.32-.1-.06-.03-.13.1-.19.12-.06-.04-.2-.04-.32s-.2-.11-.13-.24c.08-.12 0-.26-.03-.33-.04-.07.19-.02.16-.22-.02-.2.02-.75-.07-.92-.03-.12-.07-.4 0-.58-.3-.07-.33-.1-.51-.27-.19-.18-.04-.17-.19-.23s-.05-.1-.03-.22C.92 8.84.5 8.72.78 8.2c.02-.2-.03-.1-.2-.15C.44 8 .44 7.91.37 7.82.3 7.73.12 7.8.08 7.57c-.04-.23-.13-.38-.04-.6.08-.21.05-.3 0-.44-.06-.14.16-.26.38-.33.22-.08.26-.35.55-.48.29-.13.6-.35.6-.35z",
  clipRule: "evenodd"
});

var dog_size_giant_SvgDogSizeGiant = function SvgDogSizeGiant(props) {
  return react_default.a.createElement("svg", dog_size_giant__extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), dog_size_giant__ref);
};

/* harmony default export */ var dog_size_giant = (__webpack_require__.p + "d50bf7048ffba8eef7d3520ef6fd5ec6.svg");

// CONCATENATED MODULE: ../icons/svg/dog-size-large.svg
function dog_size_large__extends() { dog_size_large__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return dog_size_large__extends.apply(this, arguments); }



var dog_size_large__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  fillRule: "evenodd",
  d: "M0 7.75c1.02-.38 2.44-.99 2.54-1.25.1-.27.05-.41.88-1.04.41-.33.52-.66 1.92-.66s1.16.05 1.91.66c.52.39.95.72 1.42 1-.09.44-.24.84-.09 1.47.17.38.36.63.55.85.2.23.76 1.53 1.07 1.75.3.23.1.3.72.3.34.02.9.54 1.07.82.17.28 1.78.36 4.22.13a9.77 9.77 0 0 1 3.44-.05c1.25.22 1.54.18 1.92.22.84.1 1.54.56 2.72.9 1.18.33 2.3 1.07 2.9 1.07s1.15.24 3.2-.78c.65-.38 1.32-.38 1.61-.38 0 .34-.47 1.26-1.8 1.8-1.02.45-2.64.79-3.52.7-.89-.1-1.08-.33-1.79-.3.4.79.81 1.4.94 2.18.22.85.29 2.9.29 4.21s.35 2.83 1 3.4 1 4.14 1 5.55c-.93.26-1.93.36-2.17-.63-.02-.32.42-.53.48-.8.07-.25.26-.61-.24-2-.57-1.32-.97-1.79-1.16-1.91-.2-.13-.43-.47-.43-.69h-.26c-.01.43-.07.7-.14.87-.07.17-.14.37-.12 1.08 0 .82.28 2.9-.9 3.02-1.13.06-1.42-.21-1.55-.7.17-.2.83-.51.98-.72.23-.23.28-.57.2-1.64-.1-1.06-.42-1.79-.58-2.02-.16-.23-.35-.54-.48-.71-.12-.18-.3-.26-.47-.43a17.05 17.05 0 0 1-1.42-2.06c-.16-.37-1.35-1.63-2.54-.69s-3.03 2.02-5.02 1.9c0 .2-.14.63-.23.68 0 .2-.05 1.76 0 2.3.05.53.23 3.1.23 3.58.02.23.12.48-.23.75-.02.5-.03.79.05 1.01.08.23.07.64.05.76-.14.37-.76.94-2.56.7-.01-.64.1-.64.18-.76.08-.12.78-.52.78-1.95a19.86 19.86 0 0 0-.09-1.84 7.87 7.87 0 0 1-.07-1.43c-.06-.34-.27-.62-.38-.66-.05.46.1 1.15.14 1.36.03.2.19 1.07.17 1.55 0 .44-.14.67-.35.84-.12.3-.09.98-.11 1.11-.02.27-.06.85-1.73.93-.21-.21-.48-.19-.58-.19 0-.33-.06-.85.93-1.34.03-1 .17-1.9.14-3.3-.06-1.4-.89-2.68-.96-3.72-.14-.63.02-.9-.18-1.5-.25-.91-.39-.65-.84-1.68-.45-1.03-.4-1.99-.49-2.7a4.53 4.53 0 0 0-.63-1.84 5.75 5.75 0 0 1-.72-2.3c-.1-.75-.1-.85-.15-1.29-.12-.39-.77-.78-.96-.6-.17.1-.56.07-.8-.18-.2-.13-.7-.2-1.18-.2-.5 0-1.17-.77-1.22-1.17-.23-.24-.46-.64-.46-.81-.03-.16-.07-.29-.04-.53z",
  clipRule: "evenodd"
});

var dog_size_large_SvgDogSizeLarge = function SvgDogSizeLarge(props) {
  return react_default.a.createElement("svg", dog_size_large__extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 33"
  }, props), dog_size_large__ref);
};

/* harmony default export */ var dog_size_large = (__webpack_require__.p + "a26aeedd16e7945b2b6c6b6ce6d0a05a.svg");

// CONCATENATED MODULE: ../icons/svg/dog-size-medium.svg
function dog_size_medium__extends() { dog_size_medium__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return dog_size_medium__extends.apply(this, arguments); }



var dog_size_medium__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M26.8 27.32v-.19c.02-.42.04-.85-.5-1-.06 0-.1-.07-.14-.12-.5-.62-1.07-1.17-1.37-1.96-.23-.6-.43-1.22-.58-1.83-.1-.41-.27-.81-.33-1.25-.06-.53-.08-1.07-.21-1.6a2.23 2.23 0 0 0-.6-1.2c-.45-.41-.87-.85-1.28-1.26.19-.78.08-1.58.47-2.27.07-.13 0-.3-.15-.38-.15-.1-.28-.06-.4.06-.17.17-.37.33-.48.57l-.31.61c-.32.57-.62.7-1.17.47-.58-.25-1.2-.31-1.83-.4-.63-.09-1.27-.18-1.9-.3-1.3-.24-2.3-1.04-3.33-1.8a.29.29 0 0 1-.08-.09c-.33-.6-.82-1.1-1.12-1.72A5.31 5.31 0 0 0 9.3 9.1c.07-.37-.1-.68-.29-.98a9.5 9.5 0 0 1-1-2c-.03-.08-.09-.14-.23-.11-.15.24-.27.53-.24.85.04.36-.14.69-.15 1.04 0 .14-.1.25-.24.26-.33.03-.7.12-.92-.22-.32-.5-.85-.82-1.03-1.49-.23.84.35 1.43.44 2.12-.13.2-.23.42-.4.56-.35.28-.43.7-.63 1.06-.08.14.04.36-.16.5-.3.2-.34.5-.32.82.01.19 0 .37-.05.56-.2.79-.04.98.51 1.3.12.07.21.2.44.19.33-.28.76-.17 1.15-.07.42.12.77.1 1.1-.15.33.26.41.6.38.97-.02.39.04.78-.1 1.17-.07.19-.07 2.29-.14 2.88a5.26 5.26 0 0 0 .63 3.02c.34.66.55 1.34.5 2.1-.03.37-.06.76.02 1.12.22.94 0 6.26 0 5.95-.6.24-.95.66-.94 1.43.65.03 1.3.03 1.93 0 .15-.13.25-.27.23-.4-.1-.6.24-1.14.15-1.73a.37.37 0 0 1 .06-.24c.21-.31.17-.67.19-1.02.02-.71-.11-1.43.12-2.12.13-.36.15-.73.12-1.1-.06-.74.11-1.45.14-2.18.01-.26.18-.38.43-.33.22.05.45.09.69.31-.02 1.57.05 3.19-.05 4.82l.01.01s.3 1.96-.94 3.47a.29.29 0 0 1-.1.05c-.11.1-.2.2-.17.4.48.12.98.04 1.47.05.19.01.38.04.56-.04.1-.03.5-1.85.41-2.45.12-.48.07-.98.07-1.48 0-.35-.03-.71.02-1.06.1-.72.24-1.43.24-2.16 0-.1.03-.2.06-.3.1-.38.18-1.16.2-1.2.04-.06.4-.22.62-.29.88-.25 1.7-.64 2.5-1.08.3-.15.61-.28.95-.31.24-.02.42.06.44.33.06.58.29 1.1.47 1.65.28.8.66 1.5 1.2 2.15.3.35.62.68.93 1.01.23.24.45.5.56.82.22.73.4 1.47.39 2.26 0 .59-.33.63-.66 1.02-.34.26-.32.25-.51.58.6.43 1.21.34 1.8.3.15-.02.3-.15.31-.29.03-.4.24-.77.16-1.16-.16-.84-.16-1.7-.22-2.54-.05-.75-.18-1.43-.77-1.96-.25-.22-.48-.48-.5-.84v-1.38c.01-.1.05-.2.18-.26.4.6.85 1.16 1.37 1.67.24.23.54.39.77.63.75.78 1.57 1.5 2.08 2.45.15-.02.11 2.08.13 2.34v-.01c0 .04 0 .04 0 0-.26.26-.43.6-.83.7-.2.04-.23.3-.07.45.16.14.35.23.58.22h.69c.73 0 .85-.12.9-.86v-.38c.04-1.06-.22-2.11-.13-3.18z"
});

var dog_size_medium_SvgDogSizeMedium = function SvgDogSizeMedium(props) {
  return react_default.a.createElement("svg", dog_size_medium__extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), dog_size_medium__ref);
};

/* harmony default export */ var dog_size_medium = (__webpack_require__.p + "98d0e4594a5ba87ff91d49f53bae7159.svg");

// CONCATENATED MODULE: ../icons/svg/dog-size-small.svg
function dog_size_small__extends() { dog_size_small__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return dog_size_small__extends.apply(this, arguments); }



var dog_size_small__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  fillRule: "evenodd",
  d: "M28.3 30.64c-.3-1.49-.36-3.02-1.23-4.38-.38-.6-.44-1.4-.66-2.1-.25-.79-.32-1.59-.24-2.42.06-.54.28-1.1 0-1.64-.3-.62-.56-1.27-1.1-1.74-.24-.22-.3-.46-.18-.78.18-.46.3-.94.25-1.44-.01-.26 0-.55-.43-.47-.26.05-.38-.1-.43-.38-.09-.53-.38-.89-.96-.94a.84.84 0 0 1-.41-.16c-.21-.16-.48-.3-.39-.65.03-.1.38.09.2-.21-.1-.17-.25-.16-.4-.06-.2.14-.42.05-.64.06-.39.01-.8.03-1.14.19-.11.05-.22.31-.44.44-.99.56-1.15.99-.87 2.12.05.24.01.38-.2.38-1.25-.05-2.54.29-3.7-.47-.32-.2-.68-.33-1.07-.32a1.42 1.42 0 0 1-1.32-.73c-.53-.88-1.08-1.74-1.6-2.62A6.4 6.4 0 0 0 9.2 10c-.28-.16-.65-.37-.86-.13-.42.5-.72.17-1.07-.03-.27-.15-.54-.31-.82-.43-.35-.16-.65-.02-.53.36.25.75-.06 1.36-.26 2.04-.23.77-.6 1.32-1.3 1.65-.43.2-.43.49-.24.88.35.7.95.95 1.65 1.1.38.1.89.1.9.7 0 1.4.7 2.64.96 4 .26 1.34.72 2.65 1 4 .26 1.3.38 2.64.6 3.96.1.53.08 1.05.04 1.59-.06.72-.59.87-1.1 1.08-.17.08-.28.23-.26.43.03.2.99.55 1.3.65 1.4.44 2.29-.01 2.71-1.4.48-1.57.56-3.2.8-4.8.14-.9.18-.94 1.05-.9 1.45.06 2.78-.36 4.11-.87.46-.17.94-.63 1.5-.33.73.39 1.4.88 1.78 1.67.37.77.98 1.36 1.56 1.97.53.57.96 1.22.97 2.07 0 .7-.28 1.17-.88 1.51-.2.11-.3.42-.06.56.5.28 1.04.2 1.56.08.41-.1.55-.44.56-.81.04-1.47.43-2.99-.57-4.32-.03-.05-.03-.12-.06-.25.26 0 .44.1.52.23.58.89 1.45 1.55 1.9 2.55.38.86.55 1.65-.17 2.4-.22.24-.28.53.06.64.49.16 1.04.22 1.49-.04.42-.24.35-.73.26-1.16zm-17.6-3.11a8.84 8.84 0 0 1-.31 2.64s.29-1.44.03-3.05c-.26-1.6.22-2.48.22-2.48s.08 1.6.06 2.89z",
  clipRule: "evenodd"
});

var dog_size_small_SvgDogSizeSmall = function SvgDogSizeSmall(props) {
  return react_default.a.createElement("svg", dog_size_small__extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), dog_size_small__ref);
};

/* harmony default export */ var dog_size_small = (__webpack_require__.p + "e20ad1411752699ee45c193528e743ff.svg");

// CONCATENATED MODULE: ../icons/svg/download.svg
function download__extends() { download__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return download__extends.apply(this, arguments); }



var download__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M15 20.793V3a1 1 0 1 1 2 0v17.793l5.293-5.293a1 1 0 0 1 1.414 1.414l-6.646 6.647a1.5 1.5 0 0 1-2.122 0l-6.646-6.647A1 1 0 1 1 9.707 15.5L15 20.793zM1 19a1 1 0 1 1 2 0v8a1 1 0 0 0 1 1h24a1 1 0 0 0 1-1v-8a1 1 0 1 1 2 0v8a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3v-8z"
});

var download_SvgDownload = function SvgDownload(props) {
  return react_default.a.createElement("svg", download__extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), download__ref);
};

/* harmony default export */ var download = (__webpack_require__.p + "ecb6519f97124ea33817ea946b2eb11c.svg");

// CONCATENATED MODULE: ../icons/svg/dropdown-small.svg
function dropdown_small__extends() { dropdown_small__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return dropdown_small__extends.apply(this, arguments); }



var dropdown_small__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M10.102 12h11.796a1.5 1.5 0 0 1 1.13 2.488l-5.899 6.74a1.5 1.5 0 0 1-2.117.142c-.073-.068-.073-.068-.14-.142l-5.899-6.74A1.5 1.5 0 0 1 10.103 12z"
});

var dropdown_small_SvgDropdownSmall = function SvgDropdownSmall(props) {
  return react_default.a.createElement("svg", dropdown_small__extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), dropdown_small__ref);
};

/* harmony default export */ var dropdown_small = (__webpack_require__.p + "5bc33e77cf65294558765a328991f6bd.svg");

// CONCATENATED MODULE: ../icons/svg/drop-in.svg
function drop_in__extends() { drop_in__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return drop_in__extends.apply(this, arguments); }



var drop_in__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M2.233 25.658a5.96 5.96 0 0 0 1.524 2.585 5.97 5.97 0 0 0 2.753 1.57 7.978 7.978 0 0 1 2.329-5.16 7.977 7.977 0 0 1 4.928-2.311 5.972 5.972 0 0 0-1.524-2.585 5.971 5.971 0 0 0-2.751-1.57 7.977 7.977 0 0 1-2.329 5.16 7.976 7.976 0 0 1-4.93 2.311zm-.224-1.988a5.978 5.978 0 0 0 3.74-1.737 5.979 5.979 0 0 0 1.749-3.912 5.976 5.976 0 0 0-3.74 1.736 5.977 5.977 0 0 0-1.749 3.913zm6.495 6.309a5.976 5.976 0 0 0 3.739-1.736 5.978 5.978 0 0 0 1.748-3.913 5.979 5.979 0 0 0-3.738 1.736 5.979 5.979 0 0 0-1.749 3.913zm9.296-3.984c.134-.66.2-1.332.2-2.004 3.56-.061 6.475-.453 8.593-1.075.927-.273 1.645-.577 2.105-.869.135-.086.236-.164.302-.227-.01-2.803-.26-5.852-.748-9.145C25.472 14.236 21.719 15 17 15c-2.115 0-4.036-.154-5.762-.464a10.002 10.002 0 0 0-2.042-.465c-1.28-.36-2.429-.824-3.448-1.396a79.247 79.247 0 0 0-.225 1.635 9.946 9.946 0 0 0-2.11.801c.153-1.357.349-2.757.588-4.198.027-1.567.781-3 1.999-3.914a5 5 0 0 1 5.505-4.974A5.989 5.989 0 0 1 16 0a5.99 5.99 0 0 1 4.494 2.024 5.004 5.004 0 0 1 4.103 3.005 6 6 0 0 1 5.402 5.885c.517 3.118.834 6.04.95 8.767.68.535 1.051 1.143 1.051 1.819 0 2.758-6.188 4.393-14.2 4.495zm10.17-15.49A4 4 0 0 0 24 7l-.101.001-.795.02-.198-.77A3.001 3.001 0 0 0 20 4h-.5l-.3-.4A3.992 3.992 0 0 0 16 2a3.993 3.993 0 0 0-3.263 1.686l-.39.548-.655-.154a3 3 0 0 0-3.667 3.308l.086.667-.586.332A3 3 0 0 0 6.04 10.51C8.51 12.157 12.16 13 17 13c4.846 0 8.5-.845 10.97-2.495zM13.657 29.657A8 8 0 1 1 2.343 18.343a8 8 0 0 1 11.314 11.314zm-.708-20.09a1 1 0 0 1-1.898-.633c.851-2.553 3.061-3.437 6.191-2.654a1 1 0 1 1-.485 1.94c-2.202-.55-3.326-.101-3.808 1.346z"
});

var drop_in_SvgDropIn = function SvgDropIn(props) {
  return react_default.a.createElement("svg", drop_in__extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), drop_in__ref);
};

/* harmony default export */ var drop_in = (__webpack_require__.p + "d975dbfd6a21759bfa3b0359c0e5a46b.svg");

// CONCATENATED MODULE: ../icons/svg/edit.svg
function edit__extends() { edit__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return edit__extends.apply(this, arguments); }



var edit__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M4.834 24.834l2.331 2.332 2.259-1.004 19.369-19.37a2.536 2.536 0 0 0-3.586-3.585L23.414 5l2.293 2.293-1.414 1.414L22 6.414 5.838 22.576l-1.004 2.258zM23.793 1.793a4.536 4.536 0 1 1 6.414 6.414L10.773 27.641c-.13.13-.284.236-.452.31l-7.727 3.435a1.5 1.5 0 0 1-1.98-1.98l3.434-7.727a1.5 1.5 0 0 1 .31-.452L23.793 1.793z"
});

var edit_SvgEdit = function SvgEdit(props) {
  return react_default.a.createElement("svg", edit__extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), edit__ref);
};

/* harmony default export */ var edit = (__webpack_require__.p + "18d9bb822e841de52bb74a0646e14cd1.svg");

// CONCATENATED MODULE: ../icons/svg/enhanced-background-check.svg
function enhanced_background_check__extends() { enhanced_background_check__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return enhanced_background_check__extends.apply(this, arguments); }



var enhanced_background_check__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.136 24c6.624 0 11.994-5.373 11.994-12S18.76 0 12.136 0C5.51 0 .14 5.373.14 12s5.37 12 11.995 12z",
  fill: "#13426B"
});

var enhanced_background_check__ref2 =
/*#__PURE__*/
react_default.a.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.136 24c6.624 0 11.994-5.373 11.994-12S18.76 0 12.136 0C5.51 0 .14 5.373.14 12s5.37 12 11.995 12z",
  fill: "#13426B"
});

var enhanced_background_check__ref3 =
/*#__PURE__*/
react_default.a.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.136 24c6.624 0 11.994-5.373 11.994-12S18.76 0 12.136 0C5.51 0 .14 5.373.14 12s5.37 12 11.995 12z",
  fill: "url(#enhanced-background-check_svg__paint0_linear)",
  fillOpacity: 0.1
});

var enhanced_background_check__ref4 =
/*#__PURE__*/
react_default.a.createElement("mask", {
  id: "enhanced-background-check_svg__a",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 25,
  height: 24
}, react_default.a.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.136 24c6.624 0 11.994-5.373 11.994-12S18.76 0 12.136 0C5.51 0 .14 5.373.14 12s5.37 12 11.995 12z",
  fill: "#fff"
}), react_default.a.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.136 24c6.624 0 11.994-5.373 11.994-12S18.76 0 12.136 0C5.51 0 .14 5.373.14 12s5.37 12 11.995 12z",
  stroke: "#fff"
}));

var enhanced_background_check__ref5 =
/*#__PURE__*/
react_default.a.createElement("g", {
  mask: "url(#enhanced-background-check_svg__a)"
}, react_default.a.createElement("g", {
  opacity: 0.394
}, react_default.a.createElement("mask", {
  id: "enhanced-background-check_svg__b",
  maskUnits: "userSpaceOnUse",
  x: 6,
  y: 5,
  width: 25,
  height: 24
}, react_default.a.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.96 5.33l11.22 11.302-12.205 12.294L6.962 17.66C7.22 11.501 18.96 5.33 18.96 5.33z",
  fill: "#fff"
})), react_default.a.createElement("g", {
  mask: "url(#enhanced-background-check_svg__b)"
}, react_default.a.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.21 19.21c5.063 0 9.166-4.134 9.166-9.232 0-5.1-4.103-9.232-9.165-9.232-5.062 0-9.165 4.133-9.165 9.232 0 5.098 4.103 9.232 9.165 9.232z",
  fill: "#000"
}))), react_default.a.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.51 5.117L12.286 4.07a1.022 1.022 0 0 0-.34 0L5.718 5.117c-.5.084-.866.52-.866 1.031v7.322c0 4.881 6.65 7.172 6.934 7.267a1.03 1.03 0 0 0 .656 0c.283-.095 6.935-2.386 6.935-7.267V6.148c0-.51-.367-.947-.867-1.031z",
  fill: "#fff"
}), react_default.a.createElement("mask", {
  id: "enhanced-background-check_svg__c",
  maskUnits: "userSpaceOnUse",
  x: 4,
  y: 4,
  width: 16,
  height: 17
}, react_default.a.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.51 5.117L12.286 4.07a1.022 1.022 0 0 0-.34 0L5.718 5.117c-.5.084-.866.52-.866 1.031v7.322c0 4.881 6.65 7.172 6.934 7.267a1.03 1.03 0 0 0 .656 0c.283-.095 6.935-2.386 6.935-7.267V6.148c0-.51-.367-.947-.867-1.031z",
  fill: "#fff"
})), react_default.a.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.326 10.064a.573.573 0 0 0-.164-.4l-.797-.802a.567.567 0 0 0-.797 0l-3.845 3.87L9 10.995a.567.567 0 0 0-.797 0l-.797.8a.573.573 0 0 0 0 .802l2.122 2.132.797.802a.566.566 0 0 0 .797 0l.797-.802 4.243-4.265a.573.573 0 0 0 .164-.4z",
  fill: "#E25829"
}), react_default.a.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.164 24.188c3.35 0 8.148-.456 9.32-.573a.372.372 0 0 0 .326-.288l1.373-6a.376.376 0 0 0-.395-.459c-1.73.135-7.443.56-10.624.56-3.271 0-8.909-.424-10.623-.559a.375.375 0 0 0-.395.459l1.372 5.999a.372.372 0 0 0 .326.288c1.173.117 5.98.573 9.32.573z",
  fill: "#00BD70"
}), react_default.a.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.629 19.878l-.948-.145-.424-.902c-.017-.037-.05-.081-.093-.081s-.075.044-.092.081l-.425.902-.948.145c-.047.008-.105.032-.105.091 0 .036.024.07.047.096l.687.701-.162.992c-.002.014-.004.026-.004.04 0 .051.024.099.08.099.025 0 .05-.01.075-.024l.847-.468.848.468c.022.014.049.024.075.024.055 0 .077-.048.077-.1 0-.013 0-.025-.002-.04l-.162-.99.685-.702c.025-.026.05-.06.05-.096 0-.06-.061-.083-.106-.09z",
  fill: "#fff"
}));

var _ref6 =
/*#__PURE__*/
react_default.a.createElement("defs", null, react_default.a.createElement("linearGradient", {
  id: "enhanced-background-check_svg__paint0_linear",
  x1: 0.141,
  y1: 0,
  x2: 0.141,
  y2: 24,
  gradientUnits: "userSpaceOnUse"
}, react_default.a.createElement("stop", {
  stopColor: "#fff",
  stopOpacity: 0.5
}), react_default.a.createElement("stop", {
  offset: 1,
  stopOpacity: 0.5
})));

var enhanced_background_check_SvgEnhancedBackgroundCheck = function SvgEnhancedBackgroundCheck(props) {
  return react_default.a.createElement("svg", enhanced_background_check__extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none"
  }, props), enhanced_background_check__ref, enhanced_background_check__ref2, enhanced_background_check__ref3, enhanced_background_check__ref4, enhanced_background_check__ref5, _ref6);
};

/* harmony default export */ var enhanced_background_check = (__webpack_require__.p + "6e6ae8e414b961e4f9e86f8962ff040f.svg");

// CONCATENATED MODULE: ../icons/svg/expand-small.svg
function expand_small__extends() { expand_small__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return expand_small__extends.apply(this, arguments); }



var expand_small__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M22.35 12.24a1 1 0 1 1 1.3 1.52l-6.674 5.72a1.5 1.5 0 0 1-1.952 0l-6.675-5.72a1 1 0 0 1 1.302-1.52L16 17.684l6.35-5.442z"
});

var expand_small_SvgExpandSmall = function SvgExpandSmall(props) {
  return react_default.a.createElement("svg", expand_small__extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), expand_small__ref);
};

/* harmony default export */ var expand_small = (__webpack_require__.p + "5ae7cc828dd680f290d0da199862cc90.svg");

// CONCATENATED MODULE: ../icons/svg/facebook-redesign.svg
function facebook_redesign__extends() { facebook_redesign__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return facebook_redesign__extends.apply(this, arguments); }



var facebook_redesign__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15 30c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15C6.716 0 0 6.716 0 15c0 8.284 6.716 15 15 15z",
  fill: "#3B5998"
});

var facebook_redesign__ref2 =
/*#__PURE__*/
react_default.a.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 12.815h1.464v-.182l.006-1.697c.005-1.272.862-2.139 2.293-2.313.262-.032.528-.045.792-.048.677-.007 1.355-.002 2.032-.002h.202v2.252h-.266c-.435 0-.871-.003-1.307 0-.43.004-.713.26-.713.639v1.344h2.307l-.28 2.18h-2.04v6.4h-3.023v-6.4H12v-2.173z",
  fill: "#fff"
});

var facebook_redesign_SvgFacebookRedesign = function SvgFacebookRedesign(props) {
  return react_default.a.createElement("svg", facebook_redesign__extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none"
  }, props), facebook_redesign__ref, facebook_redesign__ref2);
};

/* harmony default export */ var facebook_redesign = (__webpack_require__.p + "db0da0ff00ccd09a04d03c68e5def8c2.svg");

// CONCATENATED MODULE: ../icons/svg/favorite.svg
function favorite__extends() { favorite__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return favorite__extends.apply(this, arguments); }



var favorite__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M27.26 5.993c-2.57-3.008-6.922-2.866-9.846.057l-.707.707a1 1 0 0 1-1.414 0l-.707-.707c-2.919-2.918-7.398-3.063-9.832-.075C1.062 10.507 3.401 17.232 16 27.704 28.662 17.18 31.044 10.422 27.26 5.993zm1.521-1.3c4.766 5.58 1.82 13.644-12.148 25.08a1 1 0 0 1-1.267 0C1.47 18.396-1.419 10.386 3.204 4.713 6.439.74 12.294.929 16 4.636c3.705-3.705 9.408-3.89 12.781.058z"
});

var favorite_SvgFavorite = function SvgFavorite(props) {
  return react_default.a.createElement("svg", favorite__extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), favorite__ref);
};

/* harmony default export */ var favorite = (__webpack_require__.p + "13365ace016a1a3867964ac997178550.svg");

// CONCATENATED MODULE: ../icons/svg/favorite-fill.svg
function favorite_fill__extends() { favorite_fill__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return favorite_fill__extends.apply(this, arguments); }



var favorite_fill__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M28.781 4.694c4.766 5.579 1.82 13.643-12.148 25.08a1 1 0 0 1-1.267 0C1.47 18.394-1.419 10.385 3.204 4.712 6.439.74 12.294.929 16 4.636c3.705-3.705 9.408-3.89 12.781.058z"
});

var favorite_fill_SvgFavoriteFill = function SvgFavoriteFill(props) {
  return react_default.a.createElement("svg", favorite_fill__extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), favorite_fill__ref);
};

/* harmony default export */ var favorite_fill = (__webpack_require__.p + "121db9450b36c1d47e06e774acda24c9.svg");

// CONCATENATED MODULE: ../icons/svg/filters.svg
function filters__extends() { filters__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return filters__extends.apply(this, arguments); }



var filters__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M8.124 23.008A4.002 4.002 0 0 1 16 24a4 4 0 0 1-7.876.992c-.04.005-.082.008-.124.008H2a1 1 0 1 1 0-2h6c.042 0 .083.003.124.008zM24.874 15H30a1 1 0 1 1 0 2h-5.126A4.002 4.002 0 0 1 17 16a4 4 0 0 1 7.874-1zM11 7h19a1 1 0 1 1 0 2H11V7zm-9 8h13v2H2a1 1 0 1 1 0-2zm16 8h12a1 1 0 1 1 0 2H18v-2zM5 12a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm0-2a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm16 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm-9 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"
});

var filters_SvgFilters = function SvgFilters(props) {
  return react_default.a.createElement("svg", filters__extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), filters__ref);
};

/* harmony default export */ var filters = (__webpack_require__.p + "c63a5ee08b3b1bfd02ceb4908ab1ab81.svg");

// CONCATENATED MODULE: ../icons/svg/food.svg
function food__extends() { food__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return food__extends.apply(this, arguments); }



var food__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M3.04 25.002a52.633 52.633 0 0 0-.04 1.66C4.316 28.133 8.701 29 16 29s11.684-.868 12.999-2.337c-.018-2.628-.244-5.469-.68-8.523a7.159 7.159 0 0 1-.525.268C25.607 19.418 21.82 20 16 20s-9.607-.583-11.794-1.592a7.155 7.155 0 0 1-.525-.268 71.523 71.523 0 0 0-.508 4.564C5.093 24.204 8.706 25 14 25v2c-4.881 0-8.532-.647-10.96-1.998zm-1.037-9.104c.04-.626.442-1.182 1.144-1.663a5.49 5.49 0 0 1 1.9-3.016 5.5 5.5 0 0 1 5.294-6.217A6.004 6.004 0 0 1 21.47 4.53a6.004 6.004 0 0 1 3.476 4.662 5.504 5.504 0 0 1 4.052 5.146c.612.457.962.978.999 1.56.564 3.402.89 6.57.979 9.505.664.467 1.024 1 1.024 1.597 0 2.108-4.49 3.416-10.985 3.844A72.727 72.727 0 0 1 16 31c-1.84 0-3.51-.05-5.015-.156C4.49 30.416 0 29.108 0 27c0-.597.36-1.13 1.024-1.597.088-2.935.415-6.103.98-9.505zm3.195.763C7.109 17.486 10.592 18 16 18c4.712 0 7.964-.39 9.987-1.037a3.5 3.5 0 0 0-2.096-5.942l-.896-.099.005-.9a4.009 4.009 0 0 0-2.638-3.784l-.44-.16-.16-.44a4.002 4.002 0 0 0-7.688.592l-.18.923-.932-.123a3.5 3.5 0 0 0-3.845 4.374l.192.72-.635.39a3.497 3.497 0 0 0-1.476 4.147zm6.75-4.095a1 1 0 0 1-1.897-.632c.851-2.553 3.061-3.437 6.191-2.654a1 1 0 1 1-.485 1.94c-2.202-.55-3.326-.101-3.808 1.346zM16 25h2v2h-2v-2z"
});

var food_SvgFood = function SvgFood(props) {
  return react_default.a.createElement("svg", food__extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), food__ref);
};

/* harmony default export */ var food = (__webpack_require__.p + "0e40f8466ba7134351a6ffc8f6df7b61.svg");

// CONCATENATED MODULE: ../icons/svg/github.svg
function github__extends() { github__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return github__extends.apply(this, arguments); }



var github__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  fillRule: "evenodd",
  d: "M15.998 0C7.165 0 0 7.163 0 16c0 7.07 4.584 13.066 10.942 15.182.8.147 1.092-.347 1.092-.771 0-.38-.014-1.386-.021-2.721-4.45.966-5.39-2.145-5.39-2.145-.728-1.849-1.777-2.34-1.777-2.34-1.452-.993.11-.973.11-.973 1.606.113 2.451 1.649 2.451 1.649 1.427 2.445 3.745 1.738 4.657 1.329.145-1.033.559-1.739 1.015-2.138-3.552-.404-7.288-1.777-7.288-7.908 0-1.747.624-3.176 1.647-4.294-.165-.404-.714-2.032.158-4.234 0 0 1.342-.43 4.399 1.64A15.325 15.325 0 0 1 16 7.737a15.33 15.33 0 0 1 4.006.54c3.055-2.071 4.395-1.641 4.395-1.641.874 2.202.325 3.83.16 4.234 1.026 1.118 1.645 2.547 1.645 4.294 0 6.146-3.741 7.499-7.305 7.895.574.494 1.085 1.47 1.085 2.963 0 2.139-.02 3.864-.02 4.389 0 .428.29.926 1.1.77C27.42 29.06 32 23.068 32 16c0-8.838-7.164-16-16.002-16z",
  clipRule: "evenodd"
});

var github_SvgGithub = function SvgGithub(props) {
  return react_default.a.createElement("svg", github__extends({
    fill: "#1B1F23",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), github__ref);
};

/* harmony default export */ var github = (__webpack_require__.p + "c1866c14565459e5e07ed9dcdf3840a2.svg");

// CONCATENATED MODULE: ../icons/svg/google.svg
function google__extends() { google__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return google__extends.apply(this, arguments); }



var google__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M21.734 9.21C20.179 7.722 18.202 6.965 16 6.965c-3.907 0-7.213 2.638-8.393 6.183v.001c-.3.9-.47 1.861-.47 2.85 0 .989.17 1.95.47 2.85 1.18 3.545 4.486 6.184 8.393 6.184 2.018 0 3.736-.532 5.08-1.432 1.588-1.063 2.645-2.652 2.993-4.527H16v-5.802h14.127c.178.982.273 2.004.273 3.068 0 4.568-1.636 8.414-4.473 11.025C23.445 29.656 20.05 31 16 31c-5.864 0-10.937-3.361-13.405-8.264A14.994 14.994 0 0 1 1 16c0-2.42.58-4.711 1.595-6.736C5.063 4.36 10.136 1 16 1c4.043 0 7.438 1.486 10.036 3.907l-4.302 4.302z"
});

var google_SvgGoogle = function SvgGoogle(props) {
  return react_default.a.createElement("svg", google__extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), google__ref);
};

/* harmony default export */ var google = (__webpack_require__.p + "343fd8b4d95ba95b3f632c12a7ce3b60.svg");

// CONCATENATED MODULE: ../icons/svg/google-color.svg
function google_color__extends() { google_color__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return google_color__extends.apply(this, arguments); }



var google_color__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  fill: "#4285F4",
  fillRule: "evenodd",
  d: "M30.4 16.34c0-1.063-.095-2.085-.273-3.067H16v5.802h8.073c-.348 1.875-1.405 3.464-2.994 4.527v3.764h4.848c2.837-2.611 4.473-6.457 4.473-11.025z",
  clipRule: "evenodd"
});

var google_color__ref2 =
/*#__PURE__*/
react_default.a.createElement("path", {
  fill: "#34A853",
  fillRule: "evenodd",
  d: "M16 31c4.05 0 7.445-1.343 9.927-3.634l-4.848-3.764c-1.343.9-3.061 1.432-5.08 1.432-3.906 0-7.213-2.639-8.393-6.184H2.595v3.886C5.063 27.64 10.135 31 15.999 31z",
  clipRule: "evenodd"
});

var google_color__ref3 =
/*#__PURE__*/
react_default.a.createElement("path", {
  fill: "#FBBC05",
  fillRule: "evenodd",
  d: "M7.607 18.85c-.3-.9-.47-1.861-.47-2.85 0-.989.17-1.95.47-2.85V9.264H2.595A14.994 14.994 0 0 0 1 16c0 2.42.58 4.711 1.595 6.736l5.012-3.886z",
  clipRule: "evenodd"
});

var google_color__ref4 =
/*#__PURE__*/
react_default.a.createElement("path", {
  fill: "#EA4335",
  fillRule: "evenodd",
  d: "M16 6.966c2.202 0 4.18.757 5.734 2.243l4.302-4.302C23.438 2.487 20.043 1 15.999 1 10.136 1 5.063 4.361 2.595 9.264l5.011 3.886C8.786 9.605 12.093 6.966 16 6.966z",
  clipRule: "evenodd"
});

var google_color_SvgGoogleColor = function SvgGoogleColor(props) {
  return react_default.a.createElement("svg", google_color__extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), google_color__ref, google_color__ref2, google_color__ref3, google_color__ref4);
};

/* harmony default export */ var google_color = (__webpack_require__.p + "95f0b5a66e1c149d1747a2cf2d4538e9.svg");

// CONCATENATED MODULE: ../icons/svg/grooming.svg
function grooming__extends() { grooming__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return grooming__extends.apply(this, arguments); }



var grooming__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M6.039 13.547L9.586 10 8.322 8.737a5 5 0 1 1 1.209-1.62L11 8.586l1.469-1.47a5 5 0 1 1 1.209 1.62L12.414 10l3.547 3.547a3 3 0 0 1 .827 2.674l-2.437 12.997a3.41 3.41 0 0 1-6.114 1.372 7.272 7.272 0 0 1-4.718-8.286l1.327-6.633a3 3 0 0 1 .607-1.295 2.97 2.97 0 0 1 .586-.829zm1.358 14.332l-1.429-7.622-.487 2.44a5.27 5.27 0 0 0 1.916 5.182zm.056-12.918a1 1 0 0 0-.276.892L9.614 28.85a1.41 1.41 0 0 0 2.772 0l2.437-12.997a1 1 0 0 0-.276-.892L13.586 14H8.414l-.96.961zM5 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm12 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-7 8h2v2h-2v-2zm14 14v-2h-4v-2h4v-2h-4v-2h4v-2h-4v-2h4v-2h-4v-2h4v-2h-4v-2h7a5 5 0 0 1 5 5v12a5 5 0 0 1-5 5h-7v-2h4zm2-18v18h1a3 3 0 0 0 3-3V15a3 3 0 0 0-3-3h-1z"
});

var grooming_SvgGrooming = function SvgGrooming(props) {
  return react_default.a.createElement("svg", grooming__extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), grooming__ref);
};

/* harmony default export */ var grooming = (__webpack_require__.p + "ae959d54156dba8b543b31aa09ca2c1b.svg");

// CONCATENATED MODULE: ../icons/svg/haircut.svg
function haircut__extends() { haircut__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return haircut__extends.apply(this, arguments); }



var haircut__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M21 10h4V4h-2v2h-2V4h-2v2h-2V4h-2v2h-2V4h-2v2H9V4H7v6h4v-.5A1.5 1.5 0 0 1 12.5 8h7A1.5 1.5 0 0 1 21 9.5v.5zm0 2v3a5 5 0 0 1-10 0v-3H9v11a7 7 0 1 0 14 0V12h-2zm2-10h2.5A1.5 1.5 0 0 1 27 3.5v7a1.5 1.5 0 0 1-1.5 1.5H25v11a9 9 0 1 1-18 0V12h-.5A1.5 1.5 0 0 1 5 10.5v-7A1.5 1.5 0 0 1 6.5 2H9V0h2v2h2V0h2v2h2V0h2v2h2V0h2v2zm-10 8v5a3 3 0 1 0 6 0v-5h-6zm3 12a2 2 0 0 1 2 2v2a2 2 0 1 1-4 0v-2a2 2 0 0 1 2-2z"
});

var haircut_SvgHaircut = function SvgHaircut(props) {
  return react_default.a.createElement("svg", haircut__extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), haircut__ref);
};

/* harmony default export */ var haircut = (__webpack_require__.p + "784bd34b805ac756124cd7cacd5368ad.svg");

// CONCATENATED MODULE: ../icons/svg/hide.svg
function hide__extends() { hide__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return hide__extends.apply(this, arguments); }



var hide__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M2.182 16.44a.976.976 0 0 1 0-1.084c3.74-5.619 8.25-8.375 13.597-8.375 2.546 0 4.903.626 7.077 1.888l1.897-1.165C22.048 5.907 19.053 5 15.78 5 9.7 5 4.584 8.126.493 14.272a2.928 2.928 0 0 0 0 3.253 27.564 27.564 0 0 0 2.672 3.428l1.74-1.068a25.212 25.212 0 0 1-2.723-3.445zm5.948 6.139l-1.862 1.143c2.845 2.043 6.02 3.075 9.51 3.075 6.079 0 11.196-3.127 15.286-9.272a2.928 2.928 0 0 0 0-3.253c-.973-1.461-2.003-2.752-3.09-3.87l-1.75 1.074c1.105 1.091 2.156 2.384 3.151 3.88.22.33.22.755 0 1.084-3.74 5.62-8.25 8.375-13.596 8.375-2.771 0-5.318-.74-7.649-2.236z"
});

var hide__ref2 =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M21.612 14.306a5.85 5.85 0 0 1 .22 1.592c0 3.283-2.71 5.945-6.053 5.945a6.094 6.094 0 0 1-4.014-1.495l1.825-1.12c.63.4 1.382.633 2.189.633 2.228 0 4.035-1.774 4.035-3.963 0-.16-.01-.317-.028-.472l1.826-1.12zm-2.321-3.25a6.1 6.1 0 0 0-3.512-1.102c-3.343 0-6.053 2.661-6.053 5.944 0 .334.028.66.081.979l1.942-1.192c.113-2.09 1.874-3.75 4.03-3.75.557 0 1.089.111 1.572.312l1.94-1.19z"
});

var hide__ref3 =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M30.574 6.734L32 8.974 2.627 27l-1.426-2.24L30.574 6.733z"
});

var hide_SvgHide = function SvgHide(props) {
  return react_default.a.createElement("svg", hide__extends({
    fill: "#1B1F23",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), hide__ref, hide__ref2, hide__ref3);
};

/* harmony default export */ var hide = (__webpack_require__.p + "2c95302b0d4d3db7e989c23f1d413207.svg");

// CONCATENATED MODULE: ../icons/svg/home.svg
function home__extends() { home__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return home__extends.apply(this, arguments); }



var home__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M10 30v-5c0-3.552 2.448-6 6-6s6 2.448 6 6v5h6V13.568l-12-11.2-12 11.2V30h6zm2 2H2V15.435l-.318.296A1 1 0 0 1 .318 14.27L14.977.587a1.5 1.5 0 0 1 2.046 0l14.66 13.682a1 1 0 1 1-1.365 1.462L30 15.435V32H20v-7c0-2.448-1.552-4-4-4s-4 1.552-4 4v7z"
});

var home_SvgHome = function SvgHome(props) {
  return react_default.a.createElement("svg", home__extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), home__ref);
};

/* harmony default export */ var home = (__webpack_require__.p + "4ee97010203b983e3a2a351a58c57d2e.svg");

// CONCATENATED MODULE: ../icons/svg/info-small.svg
function info_small__extends() { info_small__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return info_small__extends.apply(this, arguments); }



var info_small__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M16 24a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm-.5-9a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.5-.5h-1zm0-4a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1z"
});

var info_small_SvgInfoSmall = function SvgInfoSmall(props) {
  return react_default.a.createElement("svg", info_small__extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), info_small__ref);
};

/* harmony default export */ var info_small = (__webpack_require__.p + "7c2af1f79e28f7897a862ec46b03e911.svg");

// CONCATENATED MODULE: ../icons/svg/instagram-redesign.svg
function instagram_redesign__extends() { instagram_redesign__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return instagram_redesign__extends.apply(this, arguments); }



var instagram_redesign__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15 30c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15C6.716 0 0 6.716 0 15c0 8.284 6.716 15 15 15z",
  fill: "#8A3AB9"
});

var instagram_redesign__ref2 =
/*#__PURE__*/
react_default.a.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.31 15.121c0-.686-.558-1.244-1.244-1.244-.686 0-1.245.558-1.245 1.244a1.246 1.246 0 0 0 2.489 0zM15.066 12.124a2.98 2.98 0 0 1 1.735.555h4.514v-.88a3.16 3.16 0 0 0-3.156-3.155h-6.316A3.16 3.16 0 0 0 8.687 11.8v.88h4.644a2.98 2.98 0 0 1 1.735-.556zm2.586-1.562c0-.193.158-.35.351-.35h1.084c.193 0 .35.157.35.35v1.083c0 .193-.157.351-.35.351h-1.084a.352.352 0 0 1-.35-.35v-1.084z",
  fill: "#fff"
});

var instagram_redesign__ref3 =
/*#__PURE__*/
react_default.a.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.064 15.121a3.001 3.001 0 0 1-2.998 2.998 3.001 3.001 0 0 1-2.713-4.271H8.687v4.32a3.16 3.16 0 0 0 3.156 3.155h6.316a3.16 3.16 0 0 0 3.156-3.155v-4.32H17.78c.182.387.285.818.285 1.273z",
  fill: "#fff"
});

var instagram_redesign_SvgInstagramRedesign = function SvgInstagramRedesign(props) {
  return react_default.a.createElement("svg", instagram_redesign__extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none"
  }, props), instagram_redesign__ref, instagram_redesign__ref2, instagram_redesign__ref3);
};

/* harmony default export */ var instagram_redesign = (__webpack_require__.p + "228c41dbf35d6dab392b85f68f0e4d91.svg");

// CONCATENATED MODULE: ../icons/svg/ios.svg
function ios__extends() { ios__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return ios__extends.apply(this, arguments); }



var ios__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M16.674 2.61C18.672.014 21.45 0 21.45 0s.413 2.443-1.572 4.796c-2.118 2.512-4.527 2.1-4.527 2.1s-.452-1.975 1.324-4.285zm-1.07 5.998c1.028 0 2.935-1.394 5.418-1.394 4.273 0 5.954 3 5.954 3s-3.288 1.66-3.288 5.684c0 4.54 4.096 6.106 4.096 6.106s-2.863 7.952-6.73 7.952c-1.777 0-3.158-1.181-5.03-1.181-1.906 0-3.799 1.225-5.032 1.225C7.463 30 3 22.457 3 16.393c0-5.966 3.776-9.095 7.318-9.095 2.303 0 4.09 1.31 5.286 1.31z"
});

var ios_SvgIos = function SvgIos(props) {
  return react_default.a.createElement("svg", ios__extends({
    fill: "#1B1F23",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), ios__ref);
};

/* harmony default export */ var ios = (__webpack_require__.p + "5199bfa07b1dfbd650ee4e81e96c9548.svg");

// CONCATENATED MODULE: ../icons/svg/link.svg
function link__extends() { link__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return link__extends.apply(this, arguments); }



var link__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M21.083 12.5c0 3.222-3.003 5.625-6.708 5.625V20C19.139 20 23 16.642 23 12.5 23 8.358 19.139 5 14.375 5h-5.75C3.862 5 0 8.358 0 12.5c0 3.433 2.653 6.327 6.273 7.218v-1.935c-2.545-.773-4.356-2.781-4.356-5.283 0-3.222 3.003-5.625 6.708-5.625h5.75c3.705 0 6.708 2.403 6.708 5.625z"
});

var link__ref2 =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M10.917 19.5c0-3.222 3.003-5.625 6.708-5.625V12C12.861 12 9 15.358 9 19.5s3.861 7.5 8.625 7.5h5.75C28.139 27 32 23.642 32 19.5c0-3.433-2.653-6.327-6.273-7.218v1.935c2.545.773 4.356 2.781 4.356 5.283 0 3.222-3.003 5.625-6.708 5.625h-5.75c-3.705 0-6.708-2.403-6.708-5.625z"
});

var link_SvgLink = function SvgLink(props) {
  return react_default.a.createElement("svg", link__extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), link__ref, link__ref2);
};

/* harmony default export */ var svg_link = (__webpack_require__.p + "c733e3a7d8777054fe55aacf15efef1a.svg");

// CONCATENATED MODULE: ../icons/svg/list.svg
function list__extends() { list__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return list__extends.apply(this, arguments); }



var list__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M4 10a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm0 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm0 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm7-19h18a1 1 0 1 1 0 2H11a1 1 0 1 1 0-2zm0 8h18a1 1 0 1 1 0 2H11a1 1 0 1 1 0-2zm0 8h18a1 1 0 1 1 0 2H11a1 1 0 1 1 0-2z"
});

var list_SvgList = function SvgList(props) {
  return react_default.a.createElement("svg", list__extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), list__ref);
};

/* harmony default export */ var list = (__webpack_require__.p + "1e90fc73c2cff9a93b3f788fcb185e46.svg");

// CONCATENATED MODULE: ../icons/svg/map.svg
function map__extends() { map__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return map__extends.apply(this, arguments); }



var map__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M26 12c0-6.089-4.172-10-10-10S6 5.911 6 12c0 4.193 3.315 10.068 10 17.512C22.685 22.068 26 16.192 26 12zM4 12C4 4.777 9.095 0 16 0s12 4.777 12 12c0 4.905-3.649 11.288-10.89 19.266a1.5 1.5 0 0 1-2.118.103c-.053-.05-.053-.05-.103-.103C7.65 23.288 4 16.906 4 12zm12 4a5 5 0 1 1 0-10 5 5 0 0 1 0 10zm0-2a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
});

var map_SvgMap = function SvgMap(props) {
  return react_default.a.createElement("svg", map__extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), map__ref);
};

/* harmony default export */ var map = (__webpack_require__.p + "4caee5adaab17b0f24f494eae36859b2.svg");

// CONCATENATED MODULE: ../icons/svg/menu-main.svg
function menu_main__extends() { menu_main__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return menu_main__extends.apply(this, arguments); }



var menu_main__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M3 9h26a1 1 0 1 1 0 2H3a1 1 0 1 1 0-2zm0 6h26a1 1 0 1 1 0 2H3a1 1 0 1 1 0-2zm0 6h26a1 1 0 1 1 0 2H3a1 1 0 1 1 0-2z"
});

var menu_main_SvgMenuMain = function SvgMenuMain(props) {
  return react_default.a.createElement("svg", menu_main__extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), menu_main__ref);
};

/* harmony default export */ var menu_main = (__webpack_require__.p + "0de7d99eecbc6e6bdb72bfa3387babdb.svg");

// CONCATENATED MODULE: ../icons/svg/menu-more.svg
function menu_more__extends() { menu_more__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return menu_more__extends.apply(this, arguments); }



var menu_more__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M16 10a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm0 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm0 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4z"
});

var menu_more_SvgMenuMore = function SvgMenuMore(props) {
  return react_default.a.createElement("svg", menu_more__extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), menu_more__ref);
};

/* harmony default export */ var menu_more = (__webpack_require__.p + "fb1fbe90ede0a8be7f144bd853355c28.svg");

// CONCATENATED MODULE: ../icons/svg/menu-more-alt.svg
function menu_more_alt__extends() { menu_more_alt__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return menu_more_alt__extends.apply(this, arguments); }



var menu_more_alt__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M7 18a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm9 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm9 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4z"
});

var menu_more_alt_SvgMenuMoreAlt = function SvgMenuMoreAlt(props) {
  return react_default.a.createElement("svg", menu_more_alt__extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), menu_more_alt__ref);
};

/* harmony default export */ var menu_more_alt = (__webpack_require__.p + "2a678e9de46161bd3335de9678215b8e.svg");

// CONCATENATED MODULE: ../icons/svg/minus.svg
function minus__extends() { minus__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return minus__extends.apply(this, arguments); }



var minus__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M3 15h26a1 1 0 1 1 0 2H3a1 1 0 1 1 0-2z"
});

var minus_SvgMinus = function SvgMinus(props) {
  return react_default.a.createElement("svg", minus__extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), minus__ref);
};

/* harmony default export */ var minus = (__webpack_require__.p + "c7e60c03d577fbf99dfe004e749dd192.svg");

// CONCATENATED MODULE: ../icons/svg/notification.svg
function notification__extends() { notification__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return notification__extends.apply(this, arguments); }



var notification__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M18 3.175C23.895 4.253 27.183 10.31 27.939 21 29.657 21 31 22.343 31 24a3 3 0 0 1-3 3h-7.1a5.002 5.002 0 0 1-9.8 0H4a3 3 0 1 1 0-6C4.811 10.31 8.104 4.253 14 3.175V3a2 2 0 1 1 4 0v.175zM18.83 27h-5.66a3.001 3.001 0 0 0 5.66 0zM6.065 21H22v2H4a1 1 0 1 0 0 2h24a1 1 0 1 0 0-2h-1a1 1 0 0 1-.998-.945C25.36 10.517 21.989 5 16 5c-5.803 0-9.149 5.18-9.934 16z"
});

var notification_SvgNotification = function SvgNotification(props) {
  return react_default.a.createElement("svg", notification__extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), notification__ref);
};

/* harmony default export */ var notification = (__webpack_require__.p + "f9a29ecfac786a05d328abddf5971513.svg");

// CONCATENATED MODULE: ../icons/svg/now-bolt.svg
function now_bolt__extends() { now_bolt__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return now_bolt__extends.apply(this, arguments); }



var now_bolt__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M18.393 3.866L7.98 18h7.187l-1.56 10.134L24.022 14h-7.187l1.56-10.134zm-.404-2.823c.93-1.262 2.929-.431 2.69 1.118L19.166 12h5.845c1.23 0 1.937 1.4 1.207 2.39L14.011 30.957c-.93 1.262-2.929.431-2.69-1.118L12.834 20H6.99c-1.23 0-1.938-1.4-1.208-2.39L17.989 1.043z"
});

var now_bolt_SvgNowBolt = function SvgNowBolt(props) {
  return react_default.a.createElement("svg", now_bolt__extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), now_bolt__ref);
};

/* harmony default export */ var now_bolt = (__webpack_require__.p + "b991db01d1c698de7994ddcfab995fb2.svg");

// CONCATENATED MODULE: ../icons/svg/now-bolt-fill.svg
function now_bolt_fill__extends() { now_bolt_fill__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return now_bolt_fill__extends.apply(this, arguments); }



var now_bolt_fill__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M20.68 2.161c.238-1.55-1.76-2.38-2.69-1.118L5.781 17.61C5.052 18.6 5.759 20 6.99 20h5.844l-1.513 9.839c-.239 1.55 1.76 2.38 2.69 1.118L26.218 14.39c.73-.99.023-2.39-1.207-2.39h-5.845l1.513-9.839z"
});

var now_bolt_fill_SvgNowBoltFill = function SvgNowBoltFill(props) {
  return react_default.a.createElement("svg", now_bolt_fill__extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), now_bolt_fill__ref);
};

/* harmony default export */ var now_bolt_fill = (__webpack_require__.p + "34b668db21dc3251dbe1fd48eb402c34.svg");

// CONCATENATED MODULE: ../icons/svg/pee.svg
function pee__extends() { pee__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return pee__extends.apply(this, arguments); }



var pee__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M23 9.29A7.003 7.003 0 0 1 27.929 17C30.209 17 32 18.79 32 21a4 4 0 0 1-4 4H18a4 4 0 0 1-3.465-2H7A7 7 0 0 1 4.014 9.667 4 4 0 0 1 8 6h1v2H8a2 2 0 0 0-1.988 2.225l.088.791-.751.263A5.002 5.002 0 0 0 7 21h8.878l.236.667A2.001 2.001 0 0 0 18 23h10a2 2 0 1 0 0-4h-2.755l.47-1.333A5.001 5.001 0 0 0 23 11.417V9.289zM10.042 25a3 3 0 0 1 1.6.463c1.236.78 1.916 1.808 1.916 3.037 0 2.294-1.722 3.5-5 3.5-1.634 0-3.67-.211-6.115-.631a2.94 2.94 0 0 1-2.355-3.611l.121-.486A3 3 0 0 1 3.12 25h6.923zM2.15 27.758l-.122.485a.94.94 0 0 0 .753 1.155c2.342.402 4.27.602 5.777.602 2.294 0 3-.494 3-1.5 0-.474-.285-.906-.982-1.346a1 1 0 0 0-.534-.154H3.12a1 1 0 0 0-.97.758zM11 0h2v10h-2V0zm8 0h2v12h-2V0zm-4 0h2v6h-2V0zm0 8h2v2h-2V8zm-4 4h2v2h-2v-2zm8 2h2v2h-2v-2z"
});

var pee_SvgPee = function SvgPee(props) {
  return react_default.a.createElement("svg", pee__extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), pee__ref);
};

/* harmony default export */ var pee = (__webpack_require__.p + "d6fd6ef487dc89aec4be3254c475058e.svg");

// CONCATENATED MODULE: ../icons/svg/pets.svg
function pets__extends() { pets__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return pets__extends.apply(this, arguments); }



var pets__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M11.506 9.287c-1.521 0-2.755-1.603-2.755-3.581s1.233-3.581 2.755-3.581c1.521 0 2.755 1.603 2.755 3.581s-1.234 3.581-2.755 3.581zM22.463 30.549c-1.34 0-2.634-.483-3.711-1.4l-.358-.307C17.3 27.9 16.877 27.574 16 27.574c-.877 0-1.3.326-2.394 1.269l-.358.307c-1.288 1.098-2.886 1.571-4.5 1.345-1.679-.238-3.152-1.2-4.15-2.709-1.943-2.94-1.403-7.137 1.204-9.354l7.446-6.336c1.619-1.379 3.885-1.379 5.504 0l7.446 6.336c2.607 2.218 3.147 6.414 1.204 9.354-.997 1.509-2.471 2.471-4.149 2.709a5.86 5.86 0 0 1-.79.054zM16 25.074c1.851 0 2.858.868 4.025 1.874l.346.297c.735.626 1.638.901 2.53.773.961-.136 1.818-.709 2.415-1.612 1.271-1.921.939-4.645-.737-6.071l-7.446-6.336c-.689-.586-1.576-.586-2.266 0l-7.446 6.336c-1.677 1.427-2.008 4.15-.737 6.071.598.903 1.455 1.477 2.415 1.612.896.127 1.793-.147 2.53-.773l.346-.297c1.167-1.006 2.174-1.874 4.025-1.874zM17.739 5.706c0 1.978 1.234 3.581 2.755 3.581s2.755-1.603 2.755-3.581-1.234-3.581-2.755-3.581c-1.522 0-2.755 1.603-2.755 3.581zm9.734 8.718c-1.381 0-2.5-1.357-2.5-3.03 0-1.673 1.119-3.03 2.5-3.03s2.5 1.357 2.5 3.03c0 1.673-1.119 3.03-2.5 3.03zM2.02 11.394c0 1.673 1.119 3.03 2.5 3.03s2.5-1.357 2.5-3.03c0-1.673-1.119-3.03-2.5-3.03s-2.5 1.357-2.5 3.03z"
});

var pets_SvgPets = function SvgPets(props) {
  return react_default.a.createElement("svg", pets__extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), pets__ref);
};

/* harmony default export */ var pets = (__webpack_require__.p + "f503d4917ed92ee971879886cae72b80.svg");

// CONCATENATED MODULE: ../icons/svg/pinterest-redesign.svg
function pinterest_redesign__extends() { pinterest_redesign__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return pinterest_redesign__extends.apply(this, arguments); }



var pinterest_redesign__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15 30c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15C6.716 0 0 6.716 0 15c0 8.284 6.716 15 15 15z",
  fill: "#C8232C"
});

var pinterest_redesign__ref2 =
/*#__PURE__*/
react_default.a.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.572 17.189l-.07.26c-.18.662-.36 1.326-.542 1.989-.113.41-.292.797-.5 1.171a10.195 10.195 0 0 1-1.099 1.586.176.176 0 0 1-.074.054.11.11 0 0 1-.15-.09 10.803 10.803 0 0 1-.125-1.186 9.09 9.09 0 0 1 .001-.93c.017-.3.048-.597.114-.89.057-.254.123-.506.186-.758l.765-3.053c.07-.282.14-.564.212-.845a.155.155 0 0 0-.008-.11 2.9 2.9 0 0 1-.226-.797 3.075 3.075 0 0 1-.025-.703c.039-.469.176-.907.472-1.292.188-.244.423-.435.723-.548.267-.1.543-.12.822-.059.387.085.64.317.78.662.075.189.102.385.1.585-.004.239-.05.47-.107.702-.095.389-.224.769-.349 1.15-.117.358-.234.716-.325 1.08-.085.339-.053.664.136.966.204.326.51.526.9.608.443.095.865.023 1.265-.174.308-.152.56-.367.779-.618.274-.315.477-.668.639-1.043a5.88 5.88 0 0 0 .388-1.344 7.35 7.35 0 0 0 .101-1.17 3.268 3.268 0 0 0-.276-1.402c-.323-.713-.872-1.216-1.621-1.527a4.192 4.192 0 0 0-1.06-.276 5.482 5.482 0 0 0-.943-.042c-.845.033-1.633.244-2.336.696a3.854 3.854 0 0 0-1.668 2.223c-.123.421-.17.851-.143 1.287.032.54.21 1.026.59 1.44.03.033.057.069.083.104a.297.297 0 0 1 .053.26c-.041.165-.086.33-.13.495-.022.085-.044.17-.069.253a.508.508 0 0 1-.037.096.288.288 0 0 1-.326.147.678.678 0 0 1-.114-.035 2.544 2.544 0 0 1-1.211-1.003 3.368 3.368 0 0 1-.45-1.072 4.589 4.589 0 0 1-.112-1.427 4.495 4.495 0 0 1 .436-1.603c.542-1.133 1.406-1.983 2.568-2.566a6.674 6.674 0 0 1 1.808-.593 8.294 8.294 0 0 1 1.576-.132c.935.009 1.83.185 2.672.579.976.458 1.744 1.127 2.276 2.028.284.481.467.995.553 1.54.054.34.054.683.04 1.025a7.032 7.032 0 0 1-.08.797c-.144.93-.449 1.807-1 2.598a4.551 4.551 0 0 1-1.41 1.327 4.295 4.295 0 0 1-1.613.567 4.086 4.086 0 0 1-.823.042c-.62-.037-1.175-.232-1.651-.614a1.5 1.5 0 0 1-.34-.38l-.025-.035z",
  fill: "#fff"
});

var pinterest_redesign_SvgPinterestRedesign = function SvgPinterestRedesign(props) {
  return react_default.a.createElement("svg", pinterest_redesign__extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none"
  }, props), pinterest_redesign__ref, pinterest_redesign__ref2);
};

/* harmony default export */ var pinterest_redesign = (__webpack_require__.p + "e58e27bd024d1539c500349c20fbbe44.svg");

// CONCATENATED MODULE: ../icons/svg/plus.svg
function plus__extends() { plus__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return plus__extends.apply(this, arguments); }



var plus__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M17 15h12a1 1 0 1 1 0 2H17v12a1 1 0 1 1-2 0V17H3a1 1 0 1 1 0-2h12V3a1 1 0 1 1 2 0v12z"
});

var plus_SvgPlus = function SvgPlus(props) {
  return react_default.a.createElement("svg", plus__extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), plus__ref);
};

/* harmony default export */ var plus = (__webpack_require__.p + "afa30fdbfd8b211d4ecbac2a05952346.svg");

// CONCATENATED MODULE: ../icons/svg/poop.svg
function poop__extends() { poop__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return poop__extends.apply(this, arguments); }



var poop__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M18 24h2v2h-2v-2zm-7.896-6h13.748a2 2 0 0 0 1.993-2.188 2.466 2.466 0 0 0-2.646-2.27 25.44 25.44 0 0 0-3.003.439C14.16 15.188 9.28 13.51 8.91 8.87c-1.237.991-2.104 2.298-2.615 3.942A4 4 0 0 0 10.104 18H10v2h11v-2H10.104zm-4.449.015a6 6 0 0 1-1.27-5.795c.862-2.774 2.598-4.83 5.168-6.114l1.756-.879-.323 1.937c-.719 4.316 3.119 5.995 8.818 4.855a27.408 27.408 0 0 1 3.242-.472A4.466 4.466 0 0 1 27.852 16a3.98 3.98 0 0 1-.648 2.184 4.002 4.002 0 0 1 2.12 6.04A4.002 4.002 0 0 1 28 32H4a4 4 0 0 1-1.325-7.775 4 4 0 0 1 2.98-6.21zM10.102 20H6a2 2 0 1 0 0 4h20a2 2 0 1 0 0-4H10.102zM28 26H4a2 2 0 1 0 0 4h24a2 2 0 1 0 0-4zm-12-2v2h10v-2H16zm-.707-22.293A1 1 0 0 1 16.707.293c1.724 1.724 1.724 3.69 0 5.414-.943.943-.943 1.643 0 2.586a1 1 0 0 1-1.414 1.414c-1.724-1.724-1.724-3.69 0-5.414.943-.943.943-1.643 0-2.586zm5 0A1 1 0 0 1 21.707.293c1.724 1.724 1.724 3.69 0 5.414-.943.943-.943 1.643 0 2.586a1 1 0 0 1-1.414 1.414c-1.724-1.724-1.724-3.69 0-5.414.943-.943.943-1.643 0-2.586z"
});

var poop_SvgPoop = function SvgPoop(props) {
  return react_default.a.createElement("svg", poop__extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), poop__ref);
};

/* harmony default export */ var poop = (__webpack_require__.p + "c2ea46e47697946c2ab5851563d1fb21.svg");

// CONCATENATED MODULE: ../icons/svg/rebook.svg
function rebook__extends() { rebook__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return rebook__extends.apply(this, arguments); }



var rebook__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M17.414 26l4.293 4.293a1 1 0 0 1-1.414 1.414l-5.647-5.646a1.5 1.5 0 0 1 0-2.122l5.647-5.646a1 1 0 0 1 1.414 1.414L17.414 24H23a7 7 0 0 0 7-7v-2a7 7 0 0 0-7-7h-1V6h1a9 9 0 0 1 9 9v2a9 9 0 0 1-9 9h-5.586zM14.586 6l-4.293-4.293A1 1 0 1 1 11.707.293l5.647 5.646a1.5 1.5 0 0 1 0 2.122l-5.647 5.646a1 1 0 0 1-1.414-1.414L14.586 8H9a7 7 0 0 0-7 7v2a7 7 0 0 0 7 7h1v2H9a9 9 0 0 1-9-9v-2a9 9 0 0 1 9-9h5.586z"
});

var rebook_SvgRebook = function SvgRebook(props) {
  return react_default.a.createElement("svg", rebook__extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), rebook__ref);
};

/* harmony default export */ var rebook = (__webpack_require__.p + "20a572de8b7c202cd1130d76abca0b11.svg");

// CONCATENATED MODULE: ../icons/svg/report.svg
function report__extends() { report__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return report__extends.apply(this, arguments); }



var report__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M10 16v2H3v13a1 1 0 1 1-2 0V1a1 1 0 0 1 2 0v1h12.5A1.5 1.5 0 0 1 17 3.5V6h12.793a1.5 1.5 0 0 1 1.06 2.56L25.415 14l5.44 5.44A1.5 1.5 0 0 1 29.793 22H15a3 3 0 0 1-3-3V7.01a.995.995 0 0 1 .2-.61L14 4H3v12h7zm4-8v11a1 1 0 0 0 1 1h13.586l-4.94-4.94a1.5 1.5 0 0 1 0-2.12L28.586 8H14z"
});

var report_SvgReport = function SvgReport(props) {
  return react_default.a.createElement("svg", report__extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), report__ref);
};

/* harmony default export */ var report = (__webpack_require__.p + "cda7f264e624058b9115672c1f4a9999.svg");

// CONCATENATED MODULE: ../icons/svg/report-alt.svg
function report_alt__extends() { report_alt__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return report_alt__extends.apply(this, arguments); }



var report_alt__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M2 15v2.142c4.897.813 8.089 2.372 10.966 4.88.61.53 2.544 2.373 2.366 2.208C17.502 26.245 19.092 27 22 27c6.543 0 8.834-9.196 3.754-12H17v1a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1v-1H2zm28.301 3.023a2 2 0 0 1 .012 3.953C29.522 25.675 26.544 29 22 29c-3.47 0-5.517-.972-8.029-3.304.148.138-1.749-1.67-2.319-2.167C8.897 21.128 5.859 19.704.859 18.99A1 1 0 0 1 0 18v-4a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v1h4v-1a1 1 0 0 1 1-1h10c.155 0 .308.036.447.106 2.131 1.065 3.378 2.883 3.854 4.917zM13 2a1 1 0 0 1 1 1v7a1 1 0 1 1-2 0V3a1 1 0 0 1 1-1zm6.414 5.586a1 1 0 0 1 0 1.414L18 10.414A1 1 0 0 1 16.586 9L18 7.586a1 1 0 0 1 1.414 0zm-12.828 0a1 1 0 0 1 1.414 0L9.414 9A1 1 0 1 1 8 10.414L6.586 9a1 1 0 0 1 0-1.414z"
});

var report_alt_SvgReportAlt = function SvgReportAlt(props) {
  return react_default.a.createElement("svg", report_alt__extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), report_alt__ref);
};

/* harmony default export */ var report_alt = (__webpack_require__.p + "6c29db6f394d03737b9c12ec6e677d02.svg");

// CONCATENATED MODULE: ../icons/svg/requests.svg
function requests__extends() { requests__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return requests__extends.apply(this, arguments); }



var requests__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M24 16H6v2h18v-2zm-6 4v2H6v-2h12zm-4 4H6v2h8v-2z"
});

var requests__ref2 =
/*#__PURE__*/
react_default.a.createElement("path", {
  fillRule: "evenodd",
  d: "M12 4a4 4 0 1 1 5 3.874V10h11a3 3 0 0 1 3 3v9.172a3 3 0 0 1-.879 2.12l-6.828 6.83a3 3 0 0 1-2.121.878H4a3 3 0 0 1-3-3V13a3 3 0 0 1 3-3h11V7.874A4.002 4.002 0 0 1 12 4zm4-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm13 11v9.013a1.609 1.609 0 0 0-.207-.013H22.5a1.5 1.5 0 0 0-1.5 1.5v6.293c0 .07.005.14.013.207H4a1 1 0 0 1-1-1V13a1 1 0 0 1 1-1h11v1a1 1 0 1 0 2 0v-1h11a1 1 0 0 1 1 1zm-1.414 11L23 28.586V24h4.586z",
  clipRule: "evenodd"
});

var requests_SvgRequests = function SvgRequests(props) {
  return react_default.a.createElement("svg", requests__extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), requests__ref, requests__ref2);
};

/* harmony default export */ var requests = (__webpack_require__.p + "3727a98a7075084a647e72127218a0af.svg");

// CONCATENATED MODULE: ../icons/svg/review-star.svg
function review_star__extends() { review_star__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return review_star__extends.apply(this, arguments); }



var review_star__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M16 3.236l-3.982 7.965a1.5 1.5 0 0 1-1.193.821l-7.626.763 5.308 5.308a1.5 1.5 0 0 1 .394 1.424L6.578 28.81l8.617-5.483a1.5 1.5 0 0 1 1.61 0l8.617 5.483-2.323-9.293a1.5 1.5 0 0 1 .394-1.424l5.308-5.308-7.626-.763a1.5 1.5 0 0 1-1.193-.821L16 3.236zm-5.648 6.824l4.306-8.613a1.5 1.5 0 0 1 2.684 0l4.306 8.613 8.402.84a1.5 1.5 0 0 1 .911 2.553l-5.854 5.854 2.56 10.234a1.5 1.5 0 0 1-2.261 1.63L16 25.185l-9.406 5.986a1.5 1.5 0 0 1-2.26-1.63l2.559-10.234-5.854-5.854A1.5 1.5 0 0 1 1.95 10.9l8.402-.84z"
});

var review_star_SvgReviewStar = function SvgReviewStar(props) {
  return react_default.a.createElement("svg", review_star__extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), review_star__ref);
};

/* harmony default export */ var review_star = (__webpack_require__.p + "00e5abcc25e6f5c8541943e3bfb164ca.svg");

// CONCATENATED MODULE: ../icons/svg/review-star-fill.svg
function review_star_fill__extends() { review_star_fill__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return review_star_fill__extends.apply(this, arguments); }



var review_star_fill__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M10.352 10.06l4.306-8.613a1.5 1.5 0 0 1 2.684 0l4.306 8.613 8.402.84a1.5 1.5 0 0 1 .911 2.553l-5.854 5.854 2.56 10.234a1.5 1.5 0 0 1-2.261 1.63L16 25.185l-9.406 5.986a1.5 1.5 0 0 1-2.26-1.63l2.559-10.234-5.854-5.854A1.5 1.5 0 0 1 1.95 10.9l8.402-.84z"
});

var review_star_fill_SvgReviewStarFill = function SvgReviewStarFill(props) {
  return react_default.a.createElement("svg", review_star_fill__extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), review_star_fill__ref);
};

/* harmony default export */ var review_star_fill = (__webpack_require__.p + "77cd4ca8f788e3c9d29c70cc0da41c65.svg");

// CONCATENATED MODULE: ../icons/svg/review-star-half.svg
function review_star_half__extends() { review_star_half__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return review_star_half__extends.apply(this, arguments); }



var review_star_half__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M16 25.185l-9.406 5.986a1.5 1.5 0 0 1-2.26-1.63l2.559-10.234-5.854-5.854A1.5 1.5 0 0 1 1.95 10.9l8.402-.84 4.306-8.613a1.5 1.5 0 0 1 1.347-.83"
});

var review_star_half_SvgReviewStarHalf = function SvgReviewStarHalf(props) {
  return react_default.a.createElement("svg", review_star_half__extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), review_star_half__ref);
};

/* harmony default export */ var review_star_half = (__webpack_require__.p + "d2579e7e0a130da20dc6f790fff54b77.svg");

// CONCATENATED MODULE: ../icons/svg/rightarrow-small.svg
function rightarrow_small__extends() { rightarrow_small__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return rightarrow_small__extends.apply(this, arguments); }



var rightarrow_small__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M12.32 22.27l5.442-6.35-5.442-6.348a1 1 0 0 1 1.519-1.302l5.72 6.675a1.5 1.5 0 0 1 0 1.952l-5.72 6.675a1 1 0 0 1-1.519-1.302z"
});

var rightarrow_small_SvgRightarrowSmall = function SvgRightarrowSmall(props) {
  return react_default.a.createElement("svg", rightarrow_small__extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), rightarrow_small__ref);
};

/* harmony default export */ var rightarrow_small = (__webpack_require__.p + "07bb19f55d1cb78bf1b87edc8171730b.svg");

// CONCATENATED MODULE: ../icons/svg/rover-logo.svg
function rover_logo__extends() { rover_logo__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return rover_logo__extends.apply(this, arguments); }



var rover_logo__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M75.671 49.538c.879-.12 1.504.144 1.9.608.67.78.693 2.13.201 3.173-1.17 2.478-3.352 4.784-8.24 5.684-4.038.798-8.89-2.11-11.513-5.295-2.116-2.57-5.449-6.955-7.936-10.227-1.886-2.482-3.287-4.324-3.302-4.251-1.518 7.19-1.84 12.039-2.05 15.223-.208 3.126-.309 4.646-1.331 5.198-1.61.869-8.85.47-9.204-5.364-.397-6.319 5.037-24.022 8.658-35.82.93-3.026 1.74-5.665 2.3-7.622-.138.06-.331.15-.553.25a43.39 43.39 0 0 1-1.722.76c-3.008 1.197-7.203-6.044-.954-8.198 22.911-7.893 31.024-1.984 31.627 7.981.282 4.655-1.074 8.628-3.35 11.922l-.064.09a22.597 22.597 0 0 1-2.09 2.556c-2.158 2.427-8.292 7.014-14.06 8.558 0 0 11.458 12.68 14.318 14.476 2.46 1.55 5.595.81 7.365.298zM63.102 12.74c-.228-3.772-2.653-5.552-7.578-4.466-3.09 8.02-5.747 16.274-7.196 21.424C57.081 28.606 63.49 19.11 63.102 12.74zm104.442 1.456c1.81-1.746 4.458-3.12 8.311-2.103 3.267.858 6.068 4.63 5.883 8.205-.343 6.619-4.41 8.546-7.506 7.839-3.769-.86-4.701-3.165-4.68-6.15.005-.778.288-2.42 1.198-3.214-2.356.862-4.883 4.066-5.898 7.209-1.787 5.536-2.865 13.812-2.334 19.926.322 3.714-9.695 2.735-9.401-1.5.201-2.905 1.157-14.416 3.163-21.995 1.138-4.302 2.267-7.901 3.264-10.408 1.406-3.539 2.347-3.519 3.59-3.48 2.281.073 4.075 3.049 4.41 5.671zM8.785 13.855c-1.144.181-3.369 1.4-2.962 3.822.28 1.666 1.127 3.134 2.384 4.155 1.06.858 2.342 1.323 3.266 1.183.904-.14 1.723-.564 2.305-1.202.81-.887 1.08-2.068.736-3.25-.455-1.567-2.752-5.196-5.73-4.708zM.66 28.719c-1.49-1.945-.12-3.939.794-4.573 2.37-1.667 6.077.545 7.208 1.724.853.89 1.172 2.033.88 3.146-.21.8-.725 1.512-1.449 2.01-.74.508-2.077.637-3.405.328-1.576-.367-3.002-1.296-4.027-2.635zm20.03-18.106c1.118-.23 3.642.151 4.242 2.602.412 1.686.228 3.383-.513 4.798-.625 1.191-1.611 2.084-2.512 2.274a3.928 3.928 0 0 1-2.591-.334c-1.098-.561-1.817-1.592-1.978-2.84-.213-1.653.432-5.92 3.351-6.5zm14.484 7.73c.028-2.497-2.4-3.406-3.578-3.424-3.067-.062-4.803 3.927-5.013 5.57-.158 1.241.297 2.391 1.251 3.169.686.558 1.576.868 2.506.877.95.01 2.165-.643 3.094-1.662 1.103-1.21 1.721-2.81 1.74-4.53zm-3.716 22.128c1.516-1.293 1.918-3.32 1.779-5.24-.598-8.219-13.232-12.403-16.133-12.478-2.822 2.145-8.53 11.768-5.791 18.933.693 1.816 2.915 3.358 4.941 3.582 2.294.252 3.77-1.213 5.249-2.68l.13-.13a4.04 4.04 0 0 1 1.716-.999 4.207 4.207 0 0 1 2.01-.127c2.164.395 4.332.646 6.1-.86z"
});

var rover_logo__ref2 =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M85.395 8.63c-9.31 1.255-13.144 18.252-13.194 25.008-.035 5.102 1.756 9.535 4.923 12.213 2.275 1.925 5.08 2.741 7.9 2.323 2.88-.431 6.325-3.669 8.775-8.248 2.907-5.437 4.209-12.224 3.652-19.192C96.64 10.61 88.967 8.123 85.395 8.63zm4.864 16.497c-.387 6.778-3.2 15.548-5.718 16.31-1.65.561-2.806-3.333-2.825-7.039-.045-8.71 4.015-17.799 6.419-17.645 1.982.126 2.332 4.74 2.124 8.374zm53.369 14.355c.459-.495.918-.99 1.504-1.359 2.745-1.733 4.552 1.557 3.132 3.912-2.516 4.173-5.487 6.34-10.785 6.054-4.829-.26-11.055-6.84-10.703-15.272.314-7.531 2.905-14.054 7.315-18.627 6.256-6.487 12.155-6.2 15.432-3.883 4.764 3.37 4.967 9.46 3.498 13.52-1.319 3.644-3.498 5.73-8.469 7.223-4.388 1.319-8.896 1.216-8.896 1.216s-.227 1.258-.242 2.742c-.025 2.588.644 6.151 3.979 6.424 2.255.184 3.245-.883 4.235-1.95zm-6.809-13.12c5.188.404 10.034-2.623 10.626-6.2.354-2.144-1.915-3.995-3.281-3.503-1.641.591-5.163 3.517-7.345 9.703zm-10.823-4.999c-1.986 15.16-11.188 24.996-17.888 26.703-1.681.428-11.07-5.674-6.513-35.178.746-4.837 3.73-4.7 6.938-3.127 3.14 1.54 3.97 4.619 3.462 7.363-.214 1.156-.532 2.483-.851 3.819-.467 1.95-.939 3.919-1.1 5.406-.991 9.128.851 13.125.851 13.125s6.01-5.09 7.668-19.75c.176-1.559.222-2.97.261-4.187.083-2.554.138-4.245 1.314-4.616 3.088-.974 6.755 3.59 5.858 10.442z"
});

var rover_logo_SvgRoverLogo = function SvgRoverLogo(props) {
  return react_default.a.createElement("svg", rover_logo__extends({
    width: 182,
    height: 60,
    fill: "#1B1F23",
    viewBox: "0 0 182 60"
  }, props), rover_logo__ref, rover_logo__ref2);
};

/* harmony default export */ var rover_logo = (__webpack_require__.p + "6ca770334e961ba4d080564c0e81bec5.svg");

// CONCATENATED MODULE: ../icons/svg/react-native.svg
function react_native__extends() { react_native__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return react_native__extends.apply(this, arguments); }



var react_native__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M16 19.056a2.838 2.838 0 1 0 0-5.675 2.838 2.838 0 0 0 0 5.675z"
});

var react_native__ref2 =
/*#__PURE__*/
react_default.a.createElement("path", {
  fillRule: "evenodd",
  d: "M16 11.241c-3.781 0-7.316.55-9.892 1.448-1.523.531-2.692 1.182-3.464 1.842-.79.676-1.063 1.27-1.063 1.689 0 .438.3 1.078 1.147 1.804.825.707 2.067 1.4 3.67 1.948 2.525.863 5.94 1.284 9.602 1.284 3.562 0 6.907-.446 9.413-1.277 1.664-.55 2.956-1.242 3.815-1.95.883-.727 1.191-1.366 1.191-1.809 0-.415-.283-1.013-1.106-1.7-.801-.668-2.006-1.324-3.553-1.857-2.568-.884-6.017-1.422-9.76-1.422zm-10.412-.044C8.368 10.227 12.087 9.66 16 9.66c3.876 0 7.506.556 10.275 1.509 1.668.574 3.06 1.31 4.05 2.138.97.808 1.675 1.808 1.675 2.913 0 1.14-.74 2.184-1.767 3.03-1.051.865-2.533 1.637-4.323 2.23-2.714.899-6.239 1.356-9.91 1.356-3.754 0-7.36-.427-10.114-1.368-1.737-.594-3.17-1.374-4.187-2.244C.706 18.374 0 17.334 0 16.22c0-1.088.67-2.08 1.617-2.89.963-.824 2.323-1.559 3.97-2.133z",
  clipRule: "evenodd"
});

var react_native__ref3 =
/*#__PURE__*/
react_default.a.createElement("path", {
  fillRule: "evenodd",
  d: "M21.154 3.852c-.98.36-2.15 1.076-3.384 2.15-2.048 1.783-4.238 4.502-6.107 7.745l-.103.177c-1.833 3.218-3.085 6.483-3.585 9.115-.3 1.584-.32 2.922-.134 3.921.19 1.022.568 1.555.93 1.765.38.219 1.085.279 2.137-.093 1.024-.361 2.246-1.09 3.52-2.205 2.01-1.757 4.08-4.505 5.91-7.677 1.78-3.086 3.065-6.207 3.597-8.792.353-1.716.4-3.181.216-4.28-.188-1.127-.589-1.714-.972-1.935-.36-.207-1.019-.26-2.025.11zm2.815-1.478c.988.57 1.522 1.731 1.741 3.044.225 1.343.153 3.012-.227 4.858-.577 2.801-1.942 6.083-3.776 9.263-1.876 3.252-4.048 6.163-6.238 8.078-1.382 1.208-2.774 2.06-4.035 2.506-1.233.435-2.486.528-3.451-.029-.943-.543-1.468-1.62-1.696-2.844-.233-1.247-.19-2.792.136-4.506.549-2.893 1.915-6.397 3.87-9.787l.252-.438h.004c1.881-3.169 4.071-5.87 6.184-7.71 1.331-1.158 2.664-1.995 3.875-2.44 1.185-.436 2.404-.547 3.36.005z",
  clipRule: "evenodd"
});

var react_native__ref4 =
/*#__PURE__*/
react_default.a.createElement("path", {
  fillRule: "evenodd",
  d: "M10.823 3.852c.98.36 2.15 1.076 3.384 2.15 2.049 1.783 4.238 4.502 6.108 7.745l.102.177c1.833 3.218 3.085 6.483 3.585 9.115.3 1.584.321 2.922.135 3.921-.191 1.022-.569 1.555-.932 1.765-.38.219-1.084.279-2.136-.093-1.024-.361-2.245-1.09-3.52-2.205-2.01-1.757-4.08-4.505-5.91-7.677-1.779-3.086-3.064-6.207-3.596-8.792-.354-1.716-.4-3.181-.217-4.28.189-1.127.589-1.714.972-1.935.36-.207 1.02-.26 2.025.11zM8.01 2.374c-.988.57-1.522 1.731-1.742 3.044-.225 1.343-.153 3.012.227 4.858.577 2.801 1.942 6.083 3.776 9.263 1.876 3.252 4.048 6.163 6.238 8.078 1.383 1.208 2.774 2.06 4.035 2.506 1.233.435 2.486.528 3.451-.029.943-.543 1.468-1.62 1.696-2.844.233-1.247.19-2.792-.135-4.506-.55-2.893-1.916-6.397-3.87-9.787l-.253-.438h-.004c-1.88-3.169-4.071-5.87-6.184-7.71-1.33-1.158-2.664-1.995-3.875-2.44-1.185-.436-2.403-.547-3.36.005z",
  clipRule: "evenodd"
});

var react_native_SvgReactNative = function SvgReactNative(props) {
  return react_default.a.createElement("svg", react_native__extends({
    fill: "#1B1F23",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), react_native__ref, react_native__ref2, react_native__ref3, react_native__ref4);
};

/* harmony default export */ var react_native = (__webpack_require__.p + "989908be1817f6af5d232b4369118b31.svg");

// CONCATENATED MODULE: ../icons/svg/search.svg
function search__extends() { search__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return search__extends.apply(this, arguments); }



var search__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M21.782 23.904c.78-.63 1.492-1.341 2.122-2.122l6.657 6.657a1.5 1.5 0 0 1-2.122 2.122l-6.657-6.657zM13 25C6.373 25 1 19.627 1 13S6.373 1 13 1s12 5.373 12 12-5.373 12-12 12zm0-2c5.523 0 10-4.477 10-10S18.523 3 13 3 3 7.477 3 13s4.477 10 10 10z"
});

var search_SvgSearch = function SvgSearch(props) {
  return react_default.a.createElement("svg", search__extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), search__ref);
};

/* harmony default export */ var search = (__webpack_require__.p + "0f1fb97d1f3993e058864b3106d7785f.svg");

// CONCATENATED MODULE: ../icons/svg/secure.svg
function secure__extends() { secure__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return secure__extends.apply(this, arguments); }



var secure__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M6 16a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1V17a1 1 0 0 0-1-1H6zm9 6.732A2 2 0 0 1 16 19a2 2 0 0 1 1 3.732V26a1 1 0 1 1-2 0v-3.268zM8 14V7a7 7 0 0 1 7-7h2a7 7 0 0 1 7 7v7h2a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V17a3 3 0 0 1 3-3h2zm2 0h12V7a5 5 0 0 0-5-5h-2a5 5 0 0 0-5 5v7zM5 26h6v2H5v-2zm16 0h6v2h-6v-2z"
});

var secure_SvgSecure = function SvgSecure(props) {
  return react_default.a.createElement("svg", secure__extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), secure__ref);
};

/* harmony default export */ var svg_secure = (__webpack_require__.p + "c104a671d9315e27afcd547369d5f78e.svg");

// CONCATENATED MODULE: ../icons/svg/settings.svg
function settings__extends() { settings__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return settings__extends.apply(this, arguments); }



var settings__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M8.512 23.737a1 1 0 0 1 1.203.042 9.99 9.99 0 0 0 2.649 1.54 1 1 0 0 1 .636.931V29a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-2.75a1 1 0 0 1 .636-.931 9.989 9.989 0 0 0 2.65-1.542 1 1 0 0 1 1.203-.042l1.861 1.303a1 1 0 0 0 1.393-.245l2.294-3.277a1 1 0 0 0-.245-1.392l-2.477-1.735a1 1 0 0 1-.416-.96 10.094 10.094 0 0 0 0-2.854 1 1 0 0 1 .417-.96l2.476-1.734a1 1 0 0 0 .245-1.393l-2.294-3.276a1 1 0 0 0-1.393-.246l-1.858 1.301a1 1 0 0 1-1.203-.042 9.99 9.99 0 0 0-2.653-1.544A1 1 0 0 1 19 5.75V3a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v2.75a1 1 0 0 1-.636.931 9.99 9.99 0 0 0-2.652 1.543 1 1 0 0 1-1.203.042l-1.856-1.3a1 1 0 0 0-1.392.246l-2.295 3.277a1 1 0 0 0 .246 1.392l2.472 1.732a1 1 0 0 1 .417.96 10.094 10.094 0 0 0 0 2.858 1 1 0 0 1-.416.96l-2.473 1.733a1 1 0 0 0-.246 1.392l2.295 3.277a1 1 0 0 0 1.392.245l1.86-1.301zm-.712 2.94a3 3 0 0 1-4.178-.737l-2.294-3.277a3 3 0 0 1 .737-4.178l1.984-1.39a12.14 12.14 0 0 1 0-2.186l-1.984-1.39a3 3 0 0 1-.737-4.178l2.294-3.276A3 3 0 0 1 7.8 5.328l1.26.882c.61-.434 1.26-.81 1.94-1.122V3a3 3 0 0 1 3-3h4a3 3 0 0 1 3 3v2.088c.681.313 1.331.69 1.942 1.123l1.261-.883a3 3 0 0 1 4.178.737l2.294 3.276a3 3 0 0 1-.736 4.179l-1.989 1.39a12.162 12.162 0 0 1 0 2.182l1.988 1.392a3 3 0 0 1 .736 4.178l-2.294 3.277a3 3 0 0 1-4.178.737l-1.264-.886c-.61.433-1.259.808-1.939 1.12V29a3 3 0 0 1-3 3h-4a3 3 0 0 1-3-3v-2.088a11.978 11.978 0 0 1-1.937-1.12l-1.263.885zM16 23a7 7 0 1 1 0-14 7 7 0 0 1 0 14zm0-2a5 5 0 1 0 0-10 5 5 0 0 0 0 10z"
});

var settings_SvgSettings = function SvgSettings(props) {
  return react_default.a.createElement("svg", settings__extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), settings__ref);
};

/* harmony default export */ var settings = (__webpack_require__.p + "293f14f9a4b17c38084fbc739463df49.svg");

// CONCATENATED MODULE: ../icons/svg/share.svg
function share__extends() { share__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return share__extends.apply(this, arguments); }



var share__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M19 16a1 1 0 0 1 1 1v4.586L28.586 13 20 4.414V9a1 1 0 0 1-1 1c-8.548 0-13.632 4.133-15.345 12.636C6.613 18.229 11.764 16 19 16zM2.988 30.152C2.801 31.372 1 31.235 1 30 1 15.9 6.724 8.43 18 8.018v-4.81a1.5 1.5 0 0 1 2.56-1.062l9.794 9.793a1.5 1.5 0 0 1 0 2.122l-9.793 9.793A1.5 1.5 0 0 1 18 22.793v-4.778c-8.895.274-13.802 4.273-15.012 12.137z"
});

var share_SvgShare = function SvgShare(props) {
  return react_default.a.createElement("svg", share__extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), share__ref);
};

/* harmony default export */ var share = (__webpack_require__.p + "b5f684f65f05cd60cf0db0ccfaf0d43d.svg");

// CONCATENATED MODULE: ../icons/svg/show.svg
function show__extends() { show__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return show__extends.apply(this, arguments); }



var show__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M2.213 15.693c-.223.34-.223.78 0 1.12 3.792 5.8 8.366 8.646 13.787 8.646 5.421 0 9.995-2.845 13.787-8.647.223-.34.223-.78 0-1.12-3.792-5.8-8.366-8.646-13.787-8.646-5.421 0-9.995 2.845-13.787 8.647zM.5 14.573C4.648 8.228 9.837 5 16 5s11.352 3.228 15.5 9.573a3.069 3.069 0 0 1 0 3.359c-4.148 6.345-9.337 9.573-15.5 9.573S4.648 24.277.5 17.932a3.069 3.069 0 0 1 0-3.359zM16 22.39a6.138 6.138 0 1 1 0-12.275 6.138 6.138 0 0 1 0 12.275zm0-2.046a4.092 4.092 0 1 0 0-8.183 4.092 4.092 0 0 0 0 8.184z"
});

var show_SvgShow = function SvgShow(props) {
  return react_default.a.createElement("svg", show__extends({
    fill: "#1B1F23",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), show__ref);
};

/* harmony default export */ var show = (__webpack_require__.p + "ac6b3d9701af3e2ad7fffe1ed11f8596.svg");

// CONCATENATED MODULE: ../icons/svg/sitting.svg
function sitting__extends() { sitting__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return sitting__extends.apply(this, arguments); }



var sitting__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M23.026 12H23v-.024l-5-4.615-10 9.23V30h2v-3a4 4 0 1 1 8 0v3h10V16.592L23.026 12zM30 15.716l1.678 1.55a1 1 0 0 1-1.356 1.469L30 18.438V32H16v-5a2 2 0 0 0-4 0v5H6V18.438l-.322.297a1 1 0 0 1-1.356-1.47L18 4.64l5 4.615V8.5A1.5 1.5 0 0 1 24.5 7h4A1.5 1.5 0 0 1 30 8.5v7.216zm-2-1.846V9h-3v2.1l3 2.77zM21 21h2v-3h-2v3zm4 0h1v2h-8v-2h1v-3a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v3zM2.442 14C.81 14-.163 13.536.015 12.228c.05-.357.19-.676.459-1.153.017-.03.489-.836.631-1.099C1.676 8.924 1.97 8.01 1.97 7s-.293-1.924-.864-2.976c-.142-.263-.614-1.07-.631-1.1-.27-.476-.41-.795-.459-1.152C-.163.464.81 0 2.442 0c4.011 0 7 3.064 7 7s-2.989 7-7 7zm0-2c2.895 0 5-2.157 5-5s-2.105-5-5-5c-.068 0-.132 0-.19.002.115.198.477.82.612 1.069C3.579 4.39 3.969 5.606 3.969 7c0 1.394-.39 2.61-1.105 3.93-.135.249-.498.87-.613 1.068l.19.002z"
});

var sitting_SvgSitting = function SvgSitting(props) {
  return react_default.a.createElement("svg", sitting__extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), sitting__ref);
};

/* harmony default export */ var sitting = (__webpack_require__.p + "6e3b7ac8f6eb32d18edd697315fc8c62.svg");

// CONCATENATED MODULE: ../icons/svg/stopwatch.svg
function stopwatch__extends() { stopwatch__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return stopwatch__extends.apply(this, arguments); }



var stopwatch__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M27.064 9.421A13.94 13.94 0 0 1 30 18c0 7.732-6.268 14-14 14S2 25.732 2 18C2 10.604 7.735 4.548 15 4.035V2h-2.5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H17v2.035a13.925 13.925 0 0 1 7.187 2.607l1.288-1.288a.5.5 0 0 1 .707 0l2.121 2.12a.5.5 0 0 1 0 .708l-1.239 1.239zM13.171 19H8a1 1 0 1 1 0-2h5.17a3.001 3.001 0 1 1 0 2zM16 30c6.627 0 12-5.373 12-12S22.627 6 16 6 4 11.373 4 18s5.373 12 12 12zm0-11a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3-8.418V8.457c4.057 1.274 7 5.064 7 9.542 0 5.523-4.477 10-10 10-4.1 0-7.625-2.468-9.168-6H9.07A8 8 0 1 0 19 10.582zM15 8h2v2h-2V8z"
});

var stopwatch_SvgStopwatch = function SvgStopwatch(props) {
  return react_default.a.createElement("svg", stopwatch__extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), stopwatch__ref);
};

/* harmony default export */ var stopwatch = (__webpack_require__.p + "5b26ceb9367cbbfabb4ea1b61df50a31.svg");

// CONCATENATED MODULE: ../icons/svg/storybook.svg
function storybook__extends() { storybook__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return storybook__extends.apply(this, arguments); }



var storybook__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M6.498 30.928L5.071 1.664H4l1.07 29.264h1.428z"
});

var storybook__ref2 =
/*#__PURE__*/
react_default.a.createElement("path", {
  fillRule: "evenodd",
  d: "M7.093 30.93L5.666 1.664 23.323.405l-.29 3.877L24.72 3.01l1.406 1.272V.204L28.982 0v32L7.093 30.93zM23.9 12.41l-4.596.114c.085-2.398-.942-2.626-1.513-2.626-.543 0-1.456.17-1.456 1.456 0 1.309 1.335 2.048 2.902 2.916 2.226 1.232 4.92 2.724 4.92 6.477 0 3.597-2.798 5.253-6.366 5.253-3.683 0-6.91-1.256-6.538-6.767h4.825c-.058 2.227.428 3.027 1.655 3.027.943 0 1.37-.543 1.37-1.456 0-1.383-1.39-2.199-2.99-3.137-2.167-1.271-4.718-2.767-4.718-6.2 0-3.425 2.256-5.71 6.281-5.71 4.026 0 6.338 2.2 6.224 6.653z",
  clipRule: "evenodd"
});

var storybook_SvgStorybook = function SvgStorybook(props) {
  return react_default.a.createElement("svg", storybook__extends({
    fill: "#1B1F23",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), storybook__ref, storybook__ref2);
};

/* harmony default export */ var storybook = (__webpack_require__.p + "9eb929c4a3b90a6a13356db1e4b745d5.svg");

// CONCATENATED MODULE: ../icons/svg/time.svg
function time__extends() { time__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return time__extends.apply(this, arguments); }



var time__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M17 15.586l5.707 5.707a1 1 0 0 1-1.414 1.414l-6-6A.997.997 0 0 1 15 16V9a1 1 0 1 1 2 0v6.586zM16 32C7.163 32 0 24.837 0 16S7.163 0 16 0s16 7.163 16 16-7.163 16-16 16zm0-2c7.732 0 14-6.268 14-14S23.732 2 16 2 2 8.268 2 16s6.268 14 14 14z"
});

var time_SvgTime = function SvgTime(props) {
  return react_default.a.createElement("svg", time__extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), time__ref);
};

/* harmony default export */ var time = (__webpack_require__.p + "aff8eb21e8edbd2038478a73f61d37ed.svg");

// CONCATENATED MODULE: ../icons/svg/trash.svg
function trash__extends() { trash__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return trash__extends.apply(this, arguments); }



var trash__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M7.667 13.607a.333.333 0 1 0 .666 0V5.056a.333.333 0 1 0-.666 0v8.551zM10.467 13.94h-.022a.334.334 0 0 1-.31-.355l.568-8.552a.34.34 0 0 1 .355-.31.334.334 0 0 1 .31.355l-.569 8.551a.333.333 0 0 1-.332.312zM5.2 13.63a.333.333 0 0 0 .333.31h.022a.334.334 0 0 0 .31-.355l-.568-8.552a.334.334 0 0 0-.665.044L5.2 13.63z",
  fill: "#fff"
});

var trash__ref2 =
/*#__PURE__*/
react_default.a.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.801.891l.586 1.796H15.2a.333.333 0 1 1 0 .667h-1.053l-.896 12.363a.334.334 0 0 1-.332.31h-9.85a.333.333 0 0 1-.332-.31L1.84 3.353H.787a.333.333 0 1 1 0-.666H5.6L6.185.89a.333.333 0 0 1 .317-.23h2.981c.145 0 .272.093.317.23zm-.559.437l.443 1.359H6.301l.444-1.359h2.497zM12.61 15.36h-9.23l-.87-12.005h10.97l-.87 12.005z",
  fill: "#fff"
});

var trash_SvgTrash = function SvgTrash(props) {
  return react_default.a.createElement("svg", trash__extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none"
  }, props), trash__ref, trash__ref2);
};

/* harmony default export */ var trash = (__webpack_require__.p + "2b596e3b483994800bb71e2dce1d3b31.svg");

// CONCATENATED MODULE: ../icons/svg/twitter-redesign.svg
function twitter_redesign__extends() { twitter_redesign__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return twitter_redesign__extends.apply(this, arguments); }



var twitter_redesign__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15 30c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15C6.716 0 0 6.716 0 15c0 8.284 6.716 15 15 15z",
  fill: "#1DA1F2"
});

var twitter_redesign__ref2 =
/*#__PURE__*/
react_default.a.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.473 10.286c-1.457 0-2.638 1.153-2.638 2.575 0 .202.023.399.068.587a7.55 7.55 0 0 1-5.437-2.69c-.227.38-.357.822-.357 1.294 0 .893.466 1.682 1.174 2.144a2.675 2.675 0 0 1-1.195-.322v.032c0 1.248.91 2.289 2.116 2.525a2.705 2.705 0 0 1-1.191.044 2.633 2.633 0 0 0 2.464 1.79A5.375 5.375 0 0 1 9.2 19.366a5.49 5.49 0 0 1-.63-.036 7.597 7.597 0 0 0 4.044 1.157c4.852 0 7.505-3.925 7.505-7.328 0-.112-.003-.223-.008-.333a5.296 5.296 0 0 0 1.317-1.334 5.37 5.37 0 0 1-1.515.406 2.594 2.594 0 0 0 1.16-1.425 5.36 5.36 0 0 1-1.676.625 2.664 2.664 0 0 0-1.925-.813z",
  fill: "#FFFFFE"
});

var twitter_redesign_SvgTwitterRedesign = function SvgTwitterRedesign(props) {
  return react_default.a.createElement("svg", twitter_redesign__extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none"
  }, props), twitter_redesign__ref, twitter_redesign__ref2);
};

/* harmony default export */ var twitter_redesign = (__webpack_require__.p + "14df33a8cb5d18bff3b83e072ccb55b9.svg");

// CONCATENATED MODULE: ../icons/svg/upload.svg
function upload__extends() { upload__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return upload__extends.apply(this, arguments); }



var upload__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M15 5.414l-5.293 5.293a1 1 0 0 1-1.414-1.414l6.646-6.647a1.5 1.5 0 0 1 2.122 0l6.646 6.647a1 1 0 0 1-1.414 1.414L17 5.414V23a1 1 0 1 1-2 0V5.414zM1 19a1 1 0 1 1 2 0v8a1 1 0 0 0 1 1h24a1 1 0 0 0 1-1v-8a1 1 0 1 1 2 0v8a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3v-8z"
});

var upload_SvgUpload = function SvgUpload(props) {
  return react_default.a.createElement("svg", upload__extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), upload__ref);
};

/* harmony default export */ var upload = (__webpack_require__.p + "efb16125830b36ccfc84a9282d762a76.svg");

// CONCATENATED MODULE: ../icons/svg/view.svg
function view__extends() { view__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return view__extends.apply(this, arguments); }



var view__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M2.522 15.453a1 1 0 0 0 0 1.094C6.23 22.218 10.701 25 16 25c5.3 0 9.77-2.782 13.478-8.453a1 1 0 0 0 0-1.094C25.771 9.782 21.3 7 16 7c-5.3 0-9.77 2.782-13.478 8.453zM.848 14.358C4.903 8.156 9.975 5 16 5c6.025 0 11.097 3.156 15.152 9.358a3 3 0 0 1 0 3.284C27.097 23.845 22.025 27 16 27 9.975 27 4.903 23.845.848 17.642a3 3 0 0 1 0-3.284zM16 22a6 6 0 1 1 0-12 6 6 0 0 1 0 12zm0-2a4 4 0 1 0 0-8 4 4 0 0 0 0 8z"
});

var view_SvgView = function SvgView(props) {
  return react_default.a.createElement("svg", view__extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), view__ref);
};

/* harmony default export */ var view = (__webpack_require__.p + "ffb11fcde08e5684d7d0bb0832e3112b.svg");

// CONCATENATED MODULE: ../icons/svg/walking.svg
function walking__extends() { walking__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return walking__extends.apply(this, arguments); }



var walking__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M1.8 15.4a4 4 0 0 1 .8-5.6l4.6-3.45a3 3 0 0 1 3.6 0l4.6 3.45a4 4 0 1 1-4.8 6.4c-.64-.48-1.177-.7-1.6-.7-.423 0-.96.22-1.6.7a4 4 0 0 1-5.6-.8zM9 13.5c.91 0 1.84.38 2.8 1.1a2 2 0 1 0 2.4-3.2L9.6 7.95a1 1 0 0 0-1.2 0L3.8 11.4a2 2 0 1 0 2.4 3.2c.96-.72 1.89-1.1 2.8-1.1zM1.5 8C.672 8 0 7.105 0 6s.672-2 1.5-2S3 4.895 3 6s-.672 2-1.5 2zM6 5C4.895 5 4 3.88 4 2.5S4.895 0 6 0s2 1.12 2 2.5S7.105 5 6 5zm6 0c-1.105 0-2-1.12-2-2.5S10.895 0 12 0s2 1.12 2 2.5S13.105 5 12 5zm4.5 3c-.828 0-1.5-.895-1.5-2s.672-2 1.5-2 1.5.895 1.5 2-.672 2-1.5 2zm-.7 22.4a4 4 0 0 1 .8-5.6l4.6-3.45a3 3 0 0 1 3.6 0l4.6 3.45a4 4 0 1 1-4.8 6.4c-.64-.48-1.177-.7-1.6-.7-.423 0-.96.22-1.6.7a4 4 0 0 1-5.6-.8zm4.4-.8c.96-.72 1.89-1.1 2.8-1.1.91 0 1.84.38 2.8 1.1a2 2 0 1 0 2.4-3.2l-4.6-3.45a1 1 0 0 0-1.2 0l-4.6 3.45a2 2 0 1 0 2.4 3.2zM15.5 23c-.828 0-1.5-.895-1.5-2s.672-2 1.5-2 1.5.895 1.5 2-.672 2-1.5 2zm4.5-3c-1.105 0-2-1.12-2-2.5s.895-2.5 2-2.5 2 1.12 2 2.5-.895 2.5-2 2.5zm6 0c-1.105 0-2-1.12-2-2.5s.895-2.5 2-2.5 2 1.12 2 2.5-.895 2.5-2 2.5zm4.5 3c-.828 0-1.5-.895-1.5-2s.672-2 1.5-2 1.5.895 1.5 2-.672 2-1.5 2z"
});

var walking_SvgWalking = function SvgWalking(props) {
  return react_default.a.createElement("svg", walking__extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), walking__ref);
};

/* harmony default export */ var walking = (__webpack_require__.p + "f5798eda524668f8542eed4adfc8c561.svg");

// CONCATENATED MODULE: ../icons/svg/water.svg
function water__extends() { water__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return water__extends.apply(this, arguments); }



var water__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M18.961 3.923a26.638 26.638 0 0 1 1.295-1.59l.744-.83.744.83a25.69 25.69 0 0 1 1.568 1.963c.282.392.537.774.76 1.143.591.984.928 1.82.928 2.561a4.001 4.001 0 0 1-3.322 3.943A6 6 0 0 1 10 10c0-1.047.491-2.271 1.363-3.693a24.01 24.01 0 0 1 1.34-1.945 38.334 38.334 0 0 1 2.574-3.052L16 .552l.723.758a37.044 37.044 0 0 1 .81.893c.482.55.965 1.128 1.428 1.72zM17.787 5.68a36.453 36.453 0 0 0-1.757-2.159L16 3.488l-.03.033c-.57.65-1.141 1.343-1.672 2.046-.47.621-.884 1.22-1.23 1.785C12.374 8.484 12 9.416 12 10a4 4 0 0 0 7.599 1.748A4.002 4.002 0 0 1 17 8c0-.68.283-1.44.787-2.32zm-9.378 6.852a7.97 7.97 0 0 0 .93 1.9 27.51 27.51 0 0 0-2.307.421c-1.698.392-2.736.889-2.978 1.082.11.131.292.28.561.436.51.23 1.328.525 2.417.776 2.341.54 5.539.853 8.96.853h.017c3.42 0 6.618-.313 8.959-.853 1.089-.251 1.907-.546 2.417-.776.269-.157.45-.305.56-.436-.24-.193-1.28-.69-2.977-1.082a27.505 27.505 0 0 0-2.307-.42 7.97 7.97 0 0 0 .93-1.901c3.81.617 6.305 1.758 6.406 3.366.564 3.402.89 6.57.979 9.505.664.467 1.024 1 1.024 1.597 0 2.108-4.49 3.416-10.985 3.844A72.727 72.727 0 0 1 16 31c-1.84 0-3.51-.05-5.015-.156C4.49 30.416 0 29.108 0 27c0-.597.36-1.13 1.024-1.597.088-2.935.415-6.103.98-9.505.1-1.608 2.595-2.75 6.405-3.366zm-5.37 12.47a52.633 52.633 0 0 0-.038 1.66C4.316 28.133 8.701 29 16 29s11.684-.868 12.999-2.337c-.018-2.628-.244-5.469-.68-8.523a7.159 7.159 0 0 1-.525.268C25.607 19.418 21.82 20 16 20s-9.607-.583-11.794-1.592a7.155 7.155 0 0 1-.525-.268 71.523 71.523 0 0 0-.508 4.564C5.093 24.204 8.706 25 14 25v2c-4.881 0-8.532-.647-10.96-1.998zM16 25h2v2h-2v-2zm4.312-19.537c-.253.35-.478.689-.67 1.007C19.225 7.164 19 7.723 19 8a2 2 0 1 0 4 0c0-.277-.225-.836-.642-1.53a14.922 14.922 0 0 0-.67-1.007c-.22-.307-.452-.611-.688-.906-.236.295-.468.6-.688.906z"
});

var water_SvgWater = function SvgWater(props) {
  return react_default.a.createElement("svg", water__extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), water__ref);
};

/* harmony default export */ var water = (__webpack_require__.p + "f5a059a0edb9c651d7ef05fc8eddf970.svg");

// CONCATENATED MODULE: ../icons/svg/web.svg
function web__extends() { web__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return web__extends.apply(this, arguments); }



var web__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M30.964 15C30.472 7.512 24.488 1.526 17 1.034V1h-2v.034C7.512 1.526 1.526 7.512 1.034 15H1v2h.034C1.526 24.488 7.512 30.472 15 30.964V31h2v-.036c7.488-.492 13.472-6.476 13.964-13.964H31v-2h-.036zM10.39 4.27C9.424 5.554 8.622 7.164 8.038 9H5.042a13.068 13.068 0 0 1 5.348-4.73zM3.996 11h3.516a23.752 23.752 0 0 0-.492 4H3.038c.106-1.408.438-2.754.958-4zm-.958 6H7.02c.054 1.394.224 2.736.492 4H3.996a12.887 12.887 0 0 1-.958-4zm2.004 6h2.994c.584 1.836 1.386 3.446 2.354 4.73A13.054 13.054 0 0 1 5.042 23zM15 28.872c-2.056-.55-3.826-2.758-4.9-5.872H15v5.872zM15 21H9.538a22.353 22.353 0 0 1-.518-4H15v4zm0-6H9.02c.058-1.408.236-2.754.518-4H15v4zm0-6h-4.9c1.074-3.114 2.844-5.322 4.9-5.87V9zm11.958 0h-2.992c-.586-1.836-1.386-3.446-2.356-4.73A13.081 13.081 0 0 1 26.958 9zM17 3.13c2.054.548 3.826 2.756 4.9 5.87H17V3.13zM17 11h5.46c.284 1.246.458 2.592.52 4H17v-4zm0 6h5.98a22.17 22.17 0 0 1-.52 4H17v-4zm0 11.872V23h4.9c-1.074 3.114-2.846 5.322-4.9 5.872zm4.61-1.142c.966-1.286 1.77-2.894 2.356-4.73h2.992a13.067 13.067 0 0 1-5.348 4.73zM28.004 21h-3.516c.268-1.264.438-2.606.492-4h3.98a12.83 12.83 0 0 1-.956 4zm-3.024-6a23.752 23.752 0 0 0-.492-4h3.516c.52 1.246.852 2.592.958 4H24.98z"
});

var web_SvgWeb = function SvgWeb(props) {
  return react_default.a.createElement("svg", web__extends({
    fill: "#1B1F23",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), web__ref);
};

/* harmony default export */ var web = (__webpack_require__.p + "9e2f5da2eb2d12cd0df50474574e3444.svg");

// CONCATENATED MODULE: ../icons/svg/xmark-small.svg
function xmark_small__extends() { xmark_small__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return xmark_small__extends.apply(this, arguments); }



var xmark_small__ref =
/*#__PURE__*/
react_default.a.createElement("path", {
  d: "M11.05 11.05a1 1 0 0 0 0 1.414L14.586 16l-3.536 3.536a1 1 0 0 0 1.414 1.414L16 17.414l3.535 3.536a1 1 0 0 0 1.415-1.414L17.414 16l3.536-3.536a1 1 0 1 0-1.415-1.414L16 14.586l-3.536-3.536a1 1 0 0 0-1.414 0z"
});

var xmark_small_SvgXmarkSmall = function SvgXmarkSmall(props) {
  return react_default.a.createElement("svg", xmark_small__extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), xmark_small__ref);
};

/* harmony default export */ var xmark_small = (__webpack_require__.p + "5fb6529da8b04c8b9081348f8bf43249.svg");

// CONCATENATED MODULE: ../icons/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "AddSmall", function() { return add_small_SvgAddSmall; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "AlertCaution", function() { return alert_caution_SvgAlertCaution; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "AlertError", function() { return alert_error_SvgAlertError; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "AlertHelp", function() { return alert_help_SvgAlertHelp; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "AlertInfo", function() { return alert_info_SvgAlertInfo; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "AlertSuccess", function() { return alert_success_SvgAlertSuccess; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Android", function() { return android_SvgAndroid; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ArrowLeft", function() { return arrow_left_SvgArrowLeft; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ArrowRight", function() { return arrow_right_SvgArrowRight; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Boarding", function() { return boarding_SvgBoarding; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Calendar", function() { return calendar_SvgCalendar; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Call", function() { return call_SvgCall; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Camera", function() { return camera_SvgCamera; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Cancel", function() { return cancel_SvgCancel; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Car", function() { return car_SvgCar; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "CarouselLeft", function() { return carousel_left_SvgCarouselLeft; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "CarouselLeftSmall", function() { return carousel_left_small_SvgCarouselLeftSmall; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "CarouselRight", function() { return carousel_right_SvgCarouselRight; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "CarouselRightSmall", function() { return carousel_right_small_SvgCarouselRightSmall; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Cat", function() { return cat_SvgCat; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ChatInbox", function() { return chat_inbox_SvgChatInbox; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Check", function() { return check_SvgCheck; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "CheckSmall", function() { return check_small_SvgCheckSmall; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "CheckCircle", function() { return check_circle_SvgCheckCircle; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Cleaning", function() { return cleaning_SvgCleaning; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ClearSmall", function() { return clear_small_SvgClearSmall; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Close", function() { return close_SvgClose; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "CollapseSmall", function() { return collapse_small_SvgCollapseSmall; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Copy", function() { return copy_SvgCopy; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "CreditCard", function() { return credit_card_SvgCreditCard; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Daycare", function() { return daycare_SvgDaycare; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Dog", function() { return dog_SvgDog; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "DogSizeGiant", function() { return dog_size_giant_SvgDogSizeGiant; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "DogSizeLarge", function() { return dog_size_large_SvgDogSizeLarge; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "DogSizeMedium", function() { return dog_size_medium_SvgDogSizeMedium; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "DogSizeSmall", function() { return dog_size_small_SvgDogSizeSmall; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Download", function() { return download_SvgDownload; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "DropdownSmall", function() { return dropdown_small_SvgDropdownSmall; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "DropIn", function() { return drop_in_SvgDropIn; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Edit", function() { return edit_SvgEdit; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "EnhancedBackgroundCheck", function() { return enhanced_background_check_SvgEnhancedBackgroundCheck; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ExpandSmall", function() { return expand_small_SvgExpandSmall; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Facebook", function() { return facebook_redesign_SvgFacebookRedesign; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Favorite", function() { return favorite_SvgFavorite; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "FavoriteFill", function() { return favorite_fill_SvgFavoriteFill; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Filters", function() { return filters_SvgFilters; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Food", function() { return food_SvgFood; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Github", function() { return github_SvgGithub; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Google", function() { return google_SvgGoogle; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "GoogleColor", function() { return google_color_SvgGoogleColor; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Grooming", function() { return grooming_SvgGrooming; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Haircut", function() { return haircut_SvgHaircut; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Hide", function() { return hide_SvgHide; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Home", function() { return home_SvgHome; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "InfoSmall", function() { return info_small_SvgInfoSmall; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Instagram", function() { return instagram_redesign_SvgInstagramRedesign; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "IOS", function() { return ios_SvgIos; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Link", function() { return link_SvgLink; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "List", function() { return list_SvgList; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Map", function() { return map_SvgMap; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "MenuMain", function() { return menu_main_SvgMenuMain; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "MenuMore", function() { return menu_more_SvgMenuMore; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "MenuMoreAlt", function() { return menu_more_alt_SvgMenuMoreAlt; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Minus", function() { return minus_SvgMinus; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Notification", function() { return notification_SvgNotification; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "NowBolt", function() { return now_bolt_SvgNowBolt; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "NowBoltFill", function() { return now_bolt_fill_SvgNowBoltFill; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Pee", function() { return pee_SvgPee; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Pets", function() { return pets_SvgPets; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Pinterest", function() { return pinterest_redesign_SvgPinterestRedesign; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Plus", function() { return plus_SvgPlus; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Poop", function() { return poop_SvgPoop; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Rebook", function() { return rebook_SvgRebook; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Report", function() { return report_SvgReport; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ReportAlt", function() { return report_alt_SvgReportAlt; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Requests", function() { return requests_SvgRequests; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ReviewStar", function() { return review_star_SvgReviewStar; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ReviewStarFill", function() { return review_star_fill_SvgReviewStarFill; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ReviewStarHalf", function() { return review_star_half_SvgReviewStarHalf; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "RightarrowSmall", function() { return rightarrow_small_SvgRightarrowSmall; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "RoverLogo", function() { return rover_logo_SvgRoverLogo; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "RxN", function() { return react_native_SvgReactNative; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Search", function() { return search_SvgSearch; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Secure", function() { return secure_SvgSecure; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Settings", function() { return settings_SvgSettings; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Share", function() { return share_SvgShare; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Show", function() { return show_SvgShow; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Sitting", function() { return sitting_SvgSitting; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Stopwatch", function() { return stopwatch_SvgStopwatch; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Storybook", function() { return storybook_SvgStorybook; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Time", function() { return time_SvgTime; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Trash", function() { return trash_SvgTrash; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Twitter", function() { return twitter_redesign_SvgTwitterRedesign; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Upload", function() { return upload_SvgUpload; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "View", function() { return view_SvgView; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Walking", function() { return walking_SvgWalking; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Water", function() { return water_SvgWater; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Web", function() { return web_SvgWeb; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "XmarkSmall", function() { return xmark_small_SvgXmarkSmall; });




































































































/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/lodash-es/_baseGetTag.js + 2 modules
var _baseGetTag = __webpack_require__(20);

// EXTERNAL MODULE: ../node_modules/lodash-es/isObjectLike.js
var isObjectLike = __webpack_require__(12);

// CONCATENATED MODULE: ../node_modules/lodash-es/_baseIsArguments.js



/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return Object(isObjectLike["a" /* default */])(value) && Object(_baseGetTag["a" /* default */])(value) == argsTag;
}

/* harmony default export */ var _baseIsArguments = (baseIsArguments);

// CONCATENATED MODULE: ../node_modules/lodash-es/isArguments.js



/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var isArguments_hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = _baseIsArguments(function() { return arguments; }()) ? _baseIsArguments : function(value) {
  return Object(isObjectLike["a" /* default */])(value) && isArguments_hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

/* harmony default export */ var lodash_es_isArguments = __webpack_exports__["a"] = (isArguments);


/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ALIGNMENT; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types_Enum__ = __webpack_require__(6);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }


var ALIGNMENT =
/*#__PURE__*/
function (_Enum) {
  _inherits(ALIGNMENT, _Enum);

  function ALIGNMENT() {
    _classCallCheck(this, ALIGNMENT);

    return _possibleConstructorReturn(this, _getPrototypeOf(ALIGNMENT).apply(this, arguments));
  }

  return ALIGNMENT;
}(__WEBPACK_IMPORTED_MODULE_0__types_Enum__["a" /* default */]);
ALIGNMENT.BASELINE = new ALIGNMENT('baseline');
ALIGNMENT.START = new ALIGNMENT('flex-start');
ALIGNMENT.CENTER = new ALIGNMENT('center');
ALIGNMENT.END = new ALIGNMENT('flex-end');
ALIGNMENT.STRETCH = new ALIGNMENT('stretch');
ALIGNMENT.SPACE_BETWEEN = new ALIGNMENT('space-between');
ALIGNMENT.SPACE_AROUND = new ALIGNMENT('space-around');
ALIGNMENT.isLocked = true;
/* unused harmony default export */ var _unused_webpack_default_export = ({
  ALIGNMENT: ALIGNMENT
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(12);



/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) == symbolTag);
}

/* harmony default export */ __webpack_exports__["a"] = (isSymbol);


/***/ }),
/* 43 */,
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WEB_FALLBACK_FONT_FAMILIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return headingStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return responsiveHeadingStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return paragraphStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return textStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(1);
/**
 * Do not edit directly
 * Generated on Thu, 20 Feb 2020 17:25:54 GMT
 */

var WEB_FALLBACK_FONT_FAMILIES = 'Avenir, Helvetica Neue, Helvetica, sans-serif';
var headingStyles = {
  '100': Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["font-family:Averta-Semibold,Avenir,Helvetica Neue,Helvetica,sans-serif;font-size:13px;font-weight:600 !important;line-height:1.25;margin-bottom:8px;"]),
  '200': Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["font-family:Averta-Semibold,Avenir,Helvetica Neue,Helvetica,sans-serif;font-size:16px;font-weight:600 !important;line-height:1.25;margin-bottom:12px;"]),
  '300': Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["font-family:Averta-Semibold,Avenir,Helvetica Neue,Helvetica,sans-serif;font-size:20px;font-weight:600 !important;line-height:1.25;margin-bottom:16px;"]),
  '400': Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["font-family:Averta-Extrabold,Avenir,Helvetica Neue,Helvetica,sans-serif;font-size:26px;font-weight:800 !important;line-height:1.25;margin-bottom:20px;"]),
  '500': Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["font-family:Averta-Extrabold,Avenir,Helvetica Neue,Helvetica,sans-serif;font-size:32px;font-weight:800 !important;line-height:1.25;margin-bottom:24px;"]),
  '600': Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["font-family:Averta-Extrabold,Avenir,Helvetica Neue,Helvetica,sans-serif;font-size:38px;font-weight:800 !important;line-height:1.25;margin-bottom:32px;"])
};
var responsiveHeadingStyles = {
  '400': Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["font-size:32px;"]),
  '500': Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["font-size:40px;"]),
  '600': Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["font-size:48px;"])
};
var paragraphStyles = {
  '100': Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["font-size:13px;font-weight:400 !important;line-height:1.5;margin-bottom:12px;"]),
  '200': Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["font-size:16px;font-weight:400 !important;line-height:1.5;margin-bottom:16px;"]),
  '300': Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["font-size:20px;font-weight:400 !important;line-height:1.5;margin-bottom:24px;"])
};
var textStyles = {
  '100': Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["font-size:13px;font-weight:400 !important;line-height:1.25;"]),
  '200': Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["font-size:16px;font-weight:400 !important;line-height:1.25;"]),
  '300': Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["font-size:20px;font-weight:400 !important;line-height:1.2;"])
};
var theme = {
  space: {
    '0x': '0px',
    '1x': '4px',
    '2x': '8px',
    '3x': '12px',
    '4x': '16px',
    '5x': '20px',
    '6x': '24px',
    '8x': '32px',
    '12x': '48px',
    '16x': '64px',
    '24x': '96px'
  },
  fontWeight: {
    regular: '400 !important',
    semibold: '600 !important',
    extrabold: '800 !important'
  },
  textAlign: {
    left: 'left',
    center: 'center',
    right: 'right'
  },
  textColor: {
    primary: '#1B1F23',
    primary_inverse: '#FFFFFF',
    secondary: '#40484F',
    secondary_inverse: '#F4F5F6',
    tertiary: '#66727C',
    tertiary_inverse: '#E8EBED',
    disabled: '#84909A',
    placeholder: '#66727C',
    error: '#E51A42',
    price: '#CC4E00'
  },
  textDecoration: {
    none: 'none',
    uppercase: 'uppercase'
  },
  textTransform: {
    none: 'none',
    underline: 'underline'
  }
};
/* harmony default export */ __webpack_exports__["b"] = (theme);

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__axiosUtils_client__ = __webpack_require__(225);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__axiosUtils_client__["a"]; });


/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Spacing; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types_Enum__ = __webpack_require__(6);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }



var Spacing =
/*#__PURE__*/
function (_Enum) {
  _inherits(Spacing, _Enum);

  function Spacing() {
    _classCallCheck(this, Spacing);

    return _possibleConstructorReturn(this, _getPrototypeOf(Spacing).apply(this, arguments));
  }

  _createClass(Spacing, [{
    key: "toString",
    value: function toString() {
      return "".concat(parseInt(this.value, 10), "px");
    }
  }, {
    key: "toNumber",
    value: function toNumber() {
      return this.value;
    }
  }]);

  return Spacing;
}(__WEBPACK_IMPORTED_MODULE_0__types_Enum__["a" /* default */]);

Spacing.XS = new Spacing(4);
Spacing.S = new Spacing(8);
Spacing.M = new Spacing(16);
Spacing.L = new Spacing(24);
Spacing.XL = new Spacing(48);
Spacing.XXL = new Spacing(64);
Spacing.XXXL = new Spacing(96);
Spacing.isLocked = true;


/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

/* harmony default export */ __webpack_exports__["a"] = (isIndex);


/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/lodash-es/_baseGetTag.js + 2 modules
var _baseGetTag = __webpack_require__(20);

// EXTERNAL MODULE: ../node_modules/lodash-es/isLength.js
var isLength = __webpack_require__(59);

// EXTERNAL MODULE: ../node_modules/lodash-es/isObjectLike.js
var isObjectLike = __webpack_require__(12);

// CONCATENATED MODULE: ../node_modules/lodash-es/_baseIsTypedArray.js




/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return Object(isObjectLike["a" /* default */])(value) &&
    Object(isLength["a" /* default */])(value.length) && !!typedArrayTags[Object(_baseGetTag["a" /* default */])(value)];
}

/* harmony default export */ var _baseIsTypedArray = (baseIsTypedArray);

// EXTERNAL MODULE: ../node_modules/lodash-es/_baseUnary.js
var _baseUnary = __webpack_require__(71);

// EXTERNAL MODULE: ../node_modules/lodash-es/_nodeUtil.js
var _nodeUtil = __webpack_require__(74);

// CONCATENATED MODULE: ../node_modules/lodash-es/isTypedArray.js




/* Node.js helper references. */
var nodeIsTypedArray = _nodeUtil["a" /* default */] && _nodeUtil["a" /* default */].isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? Object(_baseUnary["a" /* default */])(nodeIsTypedArray) : _baseIsTypedArray;

/* harmony default export */ var lodash_es_isTypedArray = __webpack_exports__["a"] = (isTypedArray);


/***/ }),
/* 49 */,
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/lodash-es/_ListCache.js + 6 modules
var _ListCache = __webpack_require__(35);

// CONCATENATED MODULE: ../node_modules/lodash-es/_stackClear.js


/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new _ListCache["a" /* default */];
  this.size = 0;
}

/* harmony default export */ var _stackClear = (stackClear);

// CONCATENATED MODULE: ../node_modules/lodash-es/_stackDelete.js
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

/* harmony default export */ var _stackDelete = (stackDelete);

// CONCATENATED MODULE: ../node_modules/lodash-es/_stackGet.js
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/* harmony default export */ var _stackGet = (stackGet);

// CONCATENATED MODULE: ../node_modules/lodash-es/_stackHas.js
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/* harmony default export */ var _stackHas = (stackHas);

// EXTERNAL MODULE: ../node_modules/lodash-es/_Map.js
var _Map = __webpack_require__(55);

// EXTERNAL MODULE: ../node_modules/lodash-es/_MapCache.js + 14 modules
var _MapCache = __webpack_require__(56);

// CONCATENATED MODULE: ../node_modules/lodash-es/_stackSet.js




/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof _ListCache["a" /* default */]) {
    var pairs = data.__data__;
    if (!_Map["a" /* default */] || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new _MapCache["a" /* default */](pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

/* harmony default export */ var _stackSet = (stackSet);

// CONCATENATED MODULE: ../node_modules/lodash-es/_Stack.js







/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new _ListCache["a" /* default */](entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = _stackClear;
Stack.prototype['delete'] = _stackDelete;
Stack.prototype.get = _stackGet;
Stack.prototype.has = _stackHas;
Stack.prototype.set = _stackSet;

/* harmony default export */ var _Stack = __webpack_exports__["a"] = (Stack);


/***/ }),
/* 51 */,
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defineProperty_js__ = __webpack_require__(118);


/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && __WEBPACK_IMPORTED_MODULE_0__defineProperty_js__["a" /* default */]) {
    Object(__WEBPACK_IMPORTED_MODULE_0__defineProperty_js__["a" /* default */])(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

/* harmony default export */ __webpack_exports__["a"] = (baseAssignValue);


/***/ }),
/* 53 */,
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

/* harmony default export */ __webpack_exports__["a"] = (identity);


/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(10);



/* Built-in method references that are verified to be native. */
var Map = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'Map');

/* harmony default export */ __webpack_exports__["a"] = (Map);


/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/lodash-es/_getNative.js + 4 modules
var _getNative = __webpack_require__(15);

// CONCATENATED MODULE: ../node_modules/lodash-es/_nativeCreate.js


/* Built-in method references that are verified to be native. */
var nativeCreate = Object(_getNative["a" /* default */])(Object, 'create');

/* harmony default export */ var _nativeCreate = (nativeCreate);

// CONCATENATED MODULE: ../node_modules/lodash-es/_hashClear.js


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = _nativeCreate ? _nativeCreate(null) : {};
  this.size = 0;
}

/* harmony default export */ var _hashClear = (hashClear);

// CONCATENATED MODULE: ../node_modules/lodash-es/_hashDelete.js
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/* harmony default export */ var _hashDelete = (hashDelete);

// CONCATENATED MODULE: ../node_modules/lodash-es/_hashGet.js


/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _hashGet_hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (_nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return _hashGet_hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/* harmony default export */ var _hashGet = (hashGet);

// CONCATENATED MODULE: ../node_modules/lodash-es/_hashHas.js


/** Used for built-in method references. */
var _hashHas_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _hashHas_hasOwnProperty = _hashHas_objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return _nativeCreate ? (data[key] !== undefined) : _hashHas_hasOwnProperty.call(data, key);
}

/* harmony default export */ var _hashHas = (hashHas);

// CONCATENATED MODULE: ../node_modules/lodash-es/_hashSet.js


/** Used to stand-in for `undefined` hash values. */
var _hashSet_HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (_nativeCreate && value === undefined) ? _hashSet_HASH_UNDEFINED : value;
  return this;
}

/* harmony default export */ var _hashSet = (hashSet);

// CONCATENATED MODULE: ../node_modules/lodash-es/_Hash.js






/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = _hashClear;
Hash.prototype['delete'] = _hashDelete;
Hash.prototype.get = _hashGet;
Hash.prototype.has = _hashHas;
Hash.prototype.set = _hashSet;

/* harmony default export */ var _Hash = (Hash);

// EXTERNAL MODULE: ../node_modules/lodash-es/_ListCache.js + 6 modules
var _ListCache = __webpack_require__(35);

// EXTERNAL MODULE: ../node_modules/lodash-es/_Map.js
var _Map = __webpack_require__(55);

// CONCATENATED MODULE: ../node_modules/lodash-es/_mapCacheClear.js




/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new _Hash,
    'map': new (_Map["a" /* default */] || _ListCache["a" /* default */]),
    'string': new _Hash
  };
}

/* harmony default export */ var _mapCacheClear = (mapCacheClear);

// CONCATENATED MODULE: ../node_modules/lodash-es/_isKeyable.js
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/* harmony default export */ var _isKeyable = (isKeyable);

// CONCATENATED MODULE: ../node_modules/lodash-es/_getMapData.js


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return _isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/* harmony default export */ var _getMapData = (getMapData);

// CONCATENATED MODULE: ../node_modules/lodash-es/_mapCacheDelete.js


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = _getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/* harmony default export */ var _mapCacheDelete = (mapCacheDelete);

// CONCATENATED MODULE: ../node_modules/lodash-es/_mapCacheGet.js


/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return _getMapData(this, key).get(key);
}

/* harmony default export */ var _mapCacheGet = (mapCacheGet);

// CONCATENATED MODULE: ../node_modules/lodash-es/_mapCacheHas.js


/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return _getMapData(this, key).has(key);
}

/* harmony default export */ var _mapCacheHas = (mapCacheHas);

// CONCATENATED MODULE: ../node_modules/lodash-es/_mapCacheSet.js


/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = _getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

/* harmony default export */ var _mapCacheSet = (mapCacheSet);

// CONCATENATED MODULE: ../node_modules/lodash-es/_MapCache.js






/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = _mapCacheClear;
MapCache.prototype['delete'] = _mapCacheDelete;
MapCache.prototype.get = _mapCacheGet;
MapCache.prototype.has = _mapCacheHas;
MapCache.prototype.set = _mapCacheSet;

/* harmony default export */ var _MapCache = __webpack_exports__["a"] = (MapCache);


/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArray_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isSymbol_js__ = __webpack_require__(42);



/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__isArray_js__["a" /* default */])(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || Object(__WEBPACK_IMPORTED_MODULE_1__isSymbol_js__["a" /* default */])(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/* harmony default export */ __webpack_exports__["a"] = (isKey);


/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ../node_modules/redux/es/index.js + 6 modules
var es = __webpack_require__(104);

// EXTERNAL MODULE: ../node_modules/redux-thunk/es/index.js
var redux_thunk_es = __webpack_require__(346);

// EXTERNAL MODULE: ../node_modules/redux-saga/es/internal/utils.js
var utils = __webpack_require__(7);

// EXTERNAL MODULE: ../node_modules/redux-saga/es/internal/channel.js
var internal_channel = __webpack_require__(17);

// EXTERNAL MODULE: ../node_modules/redux-saga/es/internal/scheduler.js
var scheduler = __webpack_require__(98);

// EXTERNAL MODULE: ../node_modules/redux-saga/es/internal/io.js
var io = __webpack_require__(11);

// EXTERNAL MODULE: ../node_modules/redux-saga/es/internal/buffers.js
var buffers = __webpack_require__(36);

// CONCATENATED MODULE: ../node_modules/redux-saga/es/internal/proc.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defineEnumerableProperties(obj, descs) { for (var key in descs) { var desc = descs[key]; desc.configurable = desc.enumerable = true; if ("value" in desc) desc.writable = true; Object.defineProperty(obj, key, desc); } return obj; }







var NOT_ITERATOR_ERROR = 'proc first argument (Saga function result) must be an iterator';

var CHANNEL_END = {
  toString: function toString() {
    return '@@redux-saga/CHANNEL_END';
  }
};
var TASK_CANCEL = {
  toString: function toString() {
    return '@@redux-saga/TASK_CANCEL';
  }
};

var matchers = {
  wildcard: function wildcard() {
    return utils["o" /* kTrue */];
  },
  default: function _default(pattern) {
    return (typeof pattern === 'undefined' ? 'undefined' : _typeof(pattern)) === 'symbol' ? function (input) {
      return input.type === pattern;
    } : function (input) {
      return input.type === String(pattern);
    };
  },
  array: function array(patterns) {
    return function (input) {
      return patterns.some(function (p) {
        return matcher(p)(input);
      });
    };
  },
  predicate: function predicate(_predicate) {
    return function (input) {
      return _predicate(input);
    };
  }
};

function matcher(pattern) {
  // prettier-ignore
  return (pattern === '*' ? matchers.wildcard : utils["n" /* is */].array(pattern) ? matchers.array : utils["n" /* is */].stringableFunc(pattern) ? matchers.default : utils["n" /* is */].func(pattern) ? matchers.predicate : matchers.default)(pattern);
}

/**
  Used to track a parent task and its forks
  In the new fork model, forked tasks are attached by default to their parent
  We model this using the concept of Parent task && main Task
  main task is the main flow of the current Generator, the parent tasks is the
  aggregation of the main tasks + all its forked tasks.
  Thus the whole model represents an execution tree with multiple branches (vs the
  linear execution tree in sequential (non parallel) programming)

  A parent tasks has the following semantics
  - It completes if all its forks either complete or all cancelled
  - If it's cancelled, all forks are cancelled as well
  - It aborts if any uncaught error bubbles up from forks
  - If it completes, the return value is the one returned by the main task
**/
function forkQueue(name, mainTask, cb) {
  var tasks = [],
      result = void 0,
      completed = false;
  addTask(mainTask);

  function abort(err) {
    cancelAll();
    cb(err, true);
  }

  function addTask(task) {
    tasks.push(task);
    task.cont = function (res, isErr) {
      if (completed) {
        return;
      }

      Object(utils["t" /* remove */])(tasks, task);
      task.cont = utils["r" /* noop */];
      if (isErr) {
        abort(res);
      } else {
        if (task === mainTask) {
          result = res;
        }
        if (!tasks.length) {
          completed = true;
          cb(result);
        }
      }
    };
    // task.cont.cancel = task.cancel
  }

  function cancelAll() {
    if (completed) {
      return;
    }
    completed = true;
    tasks.forEach(function (t) {
      t.cont = utils["r" /* noop */];
      t.cancel();
    });
    tasks = [];
  }

  return {
    addTask: addTask,
    cancelAll: cancelAll,
    abort: abort,
    getTasks: function getTasks() {
      return tasks;
    },
    taskNames: function taskNames() {
      return tasks.map(function (t) {
        return t.name;
      });
    }
  };
}

function createTaskIterator(_ref) {
  var context = _ref.context,
      fn = _ref.fn,
      args = _ref.args;

  if (utils["n" /* is */].iterator(fn)) {
    return fn;
  }

  // catch synchronous failures; see #152 and #441
  var result = void 0,
      error = void 0;
  try {
    result = fn.apply(context, args);
  } catch (err) {
    error = err;
  }

  // i.e. a generator function returns an iterator
  if (utils["n" /* is */].iterator(result)) {
    return result;
  }

  // do not bubble up synchronous failures for detached forks
  // instead create a failed task. See #152 and #441
  return error ? Object(utils["q" /* makeIterator */])(function () {
    throw error;
  }) : Object(utils["q" /* makeIterator */])(function () {
    var pc = void 0;
    var eff = { done: false, value: result };
    var ret = function ret(value) {
      return { done: true, value: value };
    };
    return function (arg) {
      if (!pc) {
        pc = true;
        return eff;
      } else {
        return ret(arg);
      }
    };
  }());
}

var wrapHelper = function wrapHelper(helper) {
  return { fn: helper };
};

function proc(iterator) {
  var subscribe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
    return utils["r" /* noop */];
  };
  var dispatch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : utils["r" /* noop */];
  var getState = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : utils["r" /* noop */];
  var parentContext = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
  var parentEffectId = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
  var name = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 'anonymous';
  var cont = arguments[8];

  Object(utils["g" /* check */])(iterator, utils["n" /* is */].iterator, NOT_ITERATOR_ERROR);

  var effectsString = '[...effects]';
  var runParallelEffect = Object(utils["k" /* deprecate */])(runAllEffect, Object(utils["w" /* updateIncentive */])(effectsString, 'all(' + effectsString + ')'));

  var sagaMonitor = options.sagaMonitor,
      logger = options.logger,
      onError = options.onError;

  var log = logger || utils["p" /* log */];
  var logError = function logError(err) {
    var message = err.sagaStack;

    if (!message && err.stack) {
      message = err.stack.split('\n')[0].indexOf(err.message) !== -1 ? err.stack : 'Error: ' + err.message + '\n' + err.stack;
    }

    log('error', 'uncaught at ' + name, message || err.message || err);
  };
  var stdChannel = Object(internal_channel["e" /* stdChannel */])(subscribe);
  var taskContext = Object.create(parentContext);
  /**
    Tracks the current effect cancellation
    Each time the generator progresses. calling runEffect will set a new value
    on it. It allows propagating cancellation to child effects
  **/
  next.cancel = utils["r" /* noop */];

  /**
    Creates a new task descriptor for this generator, We'll also create a main task
    to track the main flow (besides other forked tasks)
  **/
  var task = newTask(parentEffectId, name, iterator, cont);
  var mainTask = { name: name, cancel: cancelMain, isRunning: true };
  var taskQueue = forkQueue(name, mainTask, end);

  /**
    cancellation of the main task. We'll simply resume the Generator with a Cancel
  **/
  function cancelMain() {
    if (mainTask.isRunning && !mainTask.isCancelled) {
      mainTask.isCancelled = true;
      next(TASK_CANCEL);
    }
  }

  /**
    This may be called by a parent generator to trigger/propagate cancellation
    cancel all pending tasks (including the main task), then end the current task.
     Cancellation propagates down to the whole execution tree holded by this Parent task
    It's also propagated to all joiners of this task and their execution tree/joiners
     Cancellation is noop for terminated/Cancelled tasks tasks
  **/
  function cancel() {
    /**
      We need to check both Running and Cancelled status
      Tasks can be Cancelled but still Running
    **/
    if (iterator._isRunning && !iterator._isCancelled) {
      iterator._isCancelled = true;
      taskQueue.cancelAll();
      /**
        Ending with a Never result will propagate the Cancellation to all joiners
      **/
      end(TASK_CANCEL);
    }
  }
  /**
    attaches cancellation logic to this task's continuation
    this will permit cancellation to propagate down the call chain
  **/
  cont && (cont.cancel = cancel);

  // tracks the running status
  iterator._isRunning = true;

  // kicks up the generator
  next();

  // then return the task descriptor to the caller
  return task;

  /**
    This is the generator driver
    It's a recursive async/continuation function which calls itself
    until the generator terminates or throws
  **/
  function next(arg, isErr) {
    // Preventive measure. If we end up here, then there is really something wrong
    if (!mainTask.isRunning) {
      throw new Error('Trying to resume an already finished generator');
    }

    try {
      var result = void 0;
      if (isErr) {
        result = iterator.throw(arg);
      } else if (arg === TASK_CANCEL) {
        /**
          getting TASK_CANCEL automatically cancels the main task
          We can get this value here
           - By cancelling the parent task manually
          - By joining a Cancelled task
        **/
        mainTask.isCancelled = true;
        /**
          Cancels the current effect; this will propagate the cancellation down to any called tasks
        **/
        next.cancel();
        /**
          If this Generator has a `return` method then invokes it
          This will jump to the finally block
        **/
        result = utils["n" /* is */].func(iterator.return) ? iterator.return(TASK_CANCEL) : { done: true, value: TASK_CANCEL };
      } else if (arg === CHANNEL_END) {
        // We get CHANNEL_END by taking from a channel that ended using `take` (and not `takem` used to trap End of channels)
        result = utils["n" /* is */].func(iterator.return) ? iterator.return() : { done: true };
      } else {
        result = iterator.next(arg);
      }

      if (!result.done) {
        runEffect(result.value, parentEffectId, '', next);
      } else {
        /**
          This Generator has ended, terminate the main task and notify the fork queue
        **/
        mainTask.isMainRunning = false;
        mainTask.cont && mainTask.cont(result.value);
      }
    } catch (error) {
      if (mainTask.isCancelled) {
        logError(error);
      }
      mainTask.isMainRunning = false;
      mainTask.cont(error, true);
    }
  }

  function end(result, isErr) {
    iterator._isRunning = false;
    stdChannel.close();
    if (!isErr) {
      iterator._result = result;
      iterator._deferredEnd && iterator._deferredEnd.resolve(result);
    } else {
      if (result instanceof Error) {
        Object.defineProperty(result, 'sagaStack', {
          value: 'at ' + name + ' \n ' + (result.sagaStack || result.stack),
          configurable: true
        });
      }
      if (!task.cont) {
        if (result instanceof Error && onError) {
          onError(result);
        } else {
          logError(result);
        }
      }
      iterator._error = result;
      iterator._isAborted = true;
      iterator._deferredEnd && iterator._deferredEnd.reject(result);
    }
    task.cont && task.cont(result, isErr);
    task.joiners.forEach(function (j) {
      return j.cb(result, isErr);
    });
    task.joiners = null;
  }

  function runEffect(effect, parentEffectId) {
    var label = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var cb = arguments[3];

    var effectId = Object(utils["v" /* uid */])();
    sagaMonitor && sagaMonitor.effectTriggered({ effectId: effectId, parentEffectId: parentEffectId, label: label, effect: effect });

    /**
      completion callback and cancel callback are mutually exclusive
      We can't cancel an already completed effect
      And We can't complete an already cancelled effectId
    **/
    var effectSettled = void 0;

    // Completion callback passed to the appropriate effect runner
    function currCb(res, isErr) {
      if (effectSettled) {
        return;
      }

      effectSettled = true;
      cb.cancel = utils["r" /* noop */]; // defensive measure
      if (sagaMonitor) {
        isErr ? sagaMonitor.effectRejected(effectId, res) : sagaMonitor.effectResolved(effectId, res);
      }
      cb(res, isErr);
    }
    // tracks down the current cancel
    currCb.cancel = utils["r" /* noop */];

    // setup cancellation logic on the parent cb
    cb.cancel = function () {
      // prevents cancelling an already completed effect
      if (effectSettled) {
        return;
      }

      effectSettled = true;
      /**
        propagates cancel downward
        catch uncaught cancellations errors; since we can no longer call the completion
        callback, log errors raised during cancellations into the console
      **/
      try {
        currCb.cancel();
      } catch (err) {
        logError(err);
      }
      currCb.cancel = utils["r" /* noop */]; // defensive measure

      sagaMonitor && sagaMonitor.effectCancelled(effectId);
    };

    /**
      each effect runner must attach its own logic of cancellation to the provided callback
      it allows this generator to propagate cancellation downward.
       ATTENTION! effect runners must setup the cancel logic by setting cb.cancel = [cancelMethod]
      And the setup must occur before calling the callback
       This is a sort of inversion of control: called async functions are responsible
      for completing the flow by calling the provided continuation; while caller functions
      are responsible for aborting the current flow by calling the attached cancel function
       Library users can attach their own cancellation logic to promises by defining a
      promise[CANCEL] method in their returned promises
      ATTENTION! calling cancel must have no effect on an already completed or cancelled effect
    **/
    var data = void 0;
    // prettier-ignore
    return (
      // Non declarative effect
      utils["n" /* is */].promise(effect) ? resolvePromise(effect, currCb) : utils["n" /* is */].helper(effect) ? runForkEffect(wrapHelper(effect), effectId, currCb) : utils["n" /* is */].iterator(effect) ? resolveIterator(effect, effectId, name, currCb)

      // declarative effects
      : utils["n" /* is */].array(effect) ? runParallelEffect(effect, effectId, currCb) : (data = io["b" /* asEffect */].take(effect)) ? runTakeEffect(data, currCb) : (data = io["b" /* asEffect */].put(effect)) ? runPutEffect(data, currCb) : (data = io["b" /* asEffect */].all(effect)) ? runAllEffect(data, effectId, currCb) : (data = io["b" /* asEffect */].race(effect)) ? runRaceEffect(data, effectId, currCb) : (data = io["b" /* asEffect */].call(effect)) ? runCallEffect(data, effectId, currCb) : (data = io["b" /* asEffect */].cps(effect)) ? runCPSEffect(data, currCb) : (data = io["b" /* asEffect */].fork(effect)) ? runForkEffect(data, effectId, currCb) : (data = io["b" /* asEffect */].join(effect)) ? runJoinEffect(data, currCb) : (data = io["b" /* asEffect */].cancel(effect)) ? runCancelEffect(data, currCb) : (data = io["b" /* asEffect */].select(effect)) ? runSelectEffect(data, currCb) : (data = io["b" /* asEffect */].actionChannel(effect)) ? runChannelEffect(data, currCb) : (data = io["b" /* asEffect */].flush(effect)) ? runFlushEffect(data, currCb) : (data = io["b" /* asEffect */].cancelled(effect)) ? runCancelledEffect(data, currCb) : (data = io["b" /* asEffect */].getContext(effect)) ? runGetContextEffect(data, currCb) : (data = io["b" /* asEffect */].setContext(effect)) ? runSetContextEffect(data, currCb) : /* anything else returned as is */currCb(effect)
    );
  }

  function resolvePromise(promise, cb) {
    var cancelPromise = promise[utils["a" /* CANCEL */]];
    if (utils["n" /* is */].func(cancelPromise)) {
      cb.cancel = cancelPromise;
    } else if (utils["n" /* is */].func(promise.abort)) {
      cb.cancel = function () {
        return promise.abort();
      };
      // TODO: add support for the fetch API, whenever they get around to
      // adding cancel support
    }
    promise.then(cb, function (error) {
      return cb(error, true);
    });
  }

  function resolveIterator(iterator, effectId, name, cb) {
    proc(iterator, subscribe, dispatch, getState, taskContext, options, effectId, name, cb);
  }

  function runTakeEffect(_ref2, cb) {
    var channel = _ref2.channel,
        pattern = _ref2.pattern,
        maybe = _ref2.maybe;

    channel = channel || stdChannel;
    var takeCb = function takeCb(inp) {
      return inp instanceof Error ? cb(inp, true) : Object(internal_channel["d" /* isEnd */])(inp) && !maybe ? cb(CHANNEL_END) : cb(inp);
    };
    try {
      channel.take(takeCb, matcher(pattern));
    } catch (err) {
      return cb(err, true);
    }
    cb.cancel = takeCb.cancel;
  }

  function runPutEffect(_ref3, cb) {
    var channel = _ref3.channel,
        action = _ref3.action,
        resolve = _ref3.resolve;

    /**
      Schedule the put in case another saga is holding a lock.
      The put will be executed atomically. ie nested puts will execute after
      this put has terminated.
    **/
    Object(scheduler["a" /* asap */])(function () {
      var result = void 0;
      try {
        result = (channel ? channel.put : dispatch)(action);
      } catch (error) {
        // If we have a channel or `put.resolve` was used then bubble up the error.
        if (channel || resolve) return cb(error, true);
        logError(error);
      }

      if (resolve && utils["n" /* is */].promise(result)) {
        resolvePromise(result, cb);
      } else {
        return cb(result);
      }
    });
    // Put effects are non cancellables
  }

  function runCallEffect(_ref4, effectId, cb) {
    var context = _ref4.context,
        fn = _ref4.fn,
        args = _ref4.args;

    var result = void 0;
    // catch synchronous failures; see #152
    try {
      result = fn.apply(context, args);
    } catch (error) {
      return cb(error, true);
    }
    return utils["n" /* is */].promise(result) ? resolvePromise(result, cb) : utils["n" /* is */].iterator(result) ? resolveIterator(result, effectId, fn.name, cb) : cb(result);
  }

  function runCPSEffect(_ref5, cb) {
    var context = _ref5.context,
        fn = _ref5.fn,
        args = _ref5.args;

    // CPS (ie node style functions) can define their own cancellation logic
    // by setting cancel field on the cb

    // catch synchronous failures; see #152
    try {
      var cpsCb = function cpsCb(err, res) {
        return utils["n" /* is */].undef(err) ? cb(res) : cb(err, true);
      };
      fn.apply(context, args.concat(cpsCb));
      if (cpsCb.cancel) {
        cb.cancel = function () {
          return cpsCb.cancel();
        };
      }
    } catch (error) {
      return cb(error, true);
    }
  }

  function runForkEffect(_ref6, effectId, cb) {
    var context = _ref6.context,
        fn = _ref6.fn,
        args = _ref6.args,
        detached = _ref6.detached;

    var taskIterator = createTaskIterator({ context: context, fn: fn, args: args });

    try {
      Object(scheduler["c" /* suspend */])();
      var _task = proc(taskIterator, subscribe, dispatch, getState, taskContext, options, effectId, fn.name, detached ? null : utils["r" /* noop */]);

      if (detached) {
        cb(_task);
      } else {
        if (taskIterator._isRunning) {
          taskQueue.addTask(_task);
          cb(_task);
        } else if (taskIterator._error) {
          taskQueue.abort(taskIterator._error);
        } else {
          cb(_task);
        }
      }
    } finally {
      Object(scheduler["b" /* flush */])();
    }
    // Fork effects are non cancellables
  }

  function runJoinEffect(t, cb) {
    if (t.isRunning()) {
      var joiner = { task: task, cb: cb };
      cb.cancel = function () {
        return Object(utils["t" /* remove */])(t.joiners, joiner);
      };
      t.joiners.push(joiner);
    } else {
      t.isAborted() ? cb(t.error(), true) : cb(t.result());
    }
  }

  function runCancelEffect(taskToCancel, cb) {
    if (taskToCancel === utils["d" /* SELF_CANCELLATION */]) {
      taskToCancel = task;
    }
    if (taskToCancel.isRunning()) {
      taskToCancel.cancel();
    }
    cb();
    // cancel effects are non cancellables
  }

  function runAllEffect(effects, effectId, cb) {
    var keys = Object.keys(effects);

    if (!keys.length) {
      return cb(utils["n" /* is */].array(effects) ? [] : {});
    }

    var completedCount = 0;
    var completed = void 0;
    var results = {};
    var childCbs = {};

    function checkEffectEnd() {
      if (completedCount === keys.length) {
        completed = true;
        cb(utils["n" /* is */].array(effects) ? utils["f" /* array */].from(_extends({}, results, { length: keys.length })) : results);
      }
    }

    keys.forEach(function (key) {
      var chCbAtKey = function chCbAtKey(res, isErr) {
        if (completed) {
          return;
        }
        if (isErr || Object(internal_channel["d" /* isEnd */])(res) || res === CHANNEL_END || res === TASK_CANCEL) {
          cb.cancel();
          cb(res, isErr);
        } else {
          results[key] = res;
          completedCount++;
          checkEffectEnd();
        }
      };
      chCbAtKey.cancel = utils["r" /* noop */];
      childCbs[key] = chCbAtKey;
    });

    cb.cancel = function () {
      if (!completed) {
        completed = true;
        keys.forEach(function (key) {
          return childCbs[key].cancel();
        });
      }
    };

    keys.forEach(function (key) {
      return runEffect(effects[key], effectId, key, childCbs[key]);
    });
  }

  function runRaceEffect(effects, effectId, cb) {
    var completed = void 0;
    var keys = Object.keys(effects);
    var childCbs = {};

    keys.forEach(function (key) {
      var chCbAtKey = function chCbAtKey(res, isErr) {
        if (completed) {
          return;
        }

        if (isErr) {
          // Race Auto cancellation
          cb.cancel();
          cb(res, true);
        } else if (!Object(internal_channel["d" /* isEnd */])(res) && res !== CHANNEL_END && res !== TASK_CANCEL) {
          var _response;

          cb.cancel();
          completed = true;
          var response = (_response = {}, _response[key] = res, _response);
          cb(utils["n" /* is */].array(effects) ? [].slice.call(_extends({}, response, { length: keys.length })) : response);
        }
      };
      chCbAtKey.cancel = utils["r" /* noop */];
      childCbs[key] = chCbAtKey;
    });

    cb.cancel = function () {
      // prevents unnecessary cancellation
      if (!completed) {
        completed = true;
        keys.forEach(function (key) {
          return childCbs[key].cancel();
        });
      }
    };
    keys.forEach(function (key) {
      if (completed) {
        return;
      }
      runEffect(effects[key], effectId, key, childCbs[key]);
    });
  }

  function runSelectEffect(_ref7, cb) {
    var selector = _ref7.selector,
        args = _ref7.args;

    try {
      var state = selector.apply(undefined, [getState()].concat(args));
      cb(state);
    } catch (error) {
      cb(error, true);
    }
  }

  function runChannelEffect(_ref8, cb) {
    var pattern = _ref8.pattern,
        buffer = _ref8.buffer;

    var match = matcher(pattern);
    match.pattern = pattern;
    cb(Object(internal_channel["c" /* eventChannel */])(subscribe, buffer || buffers["a" /* buffers */].fixed(), match));
  }

  function runCancelledEffect(data, cb) {
    cb(!!mainTask.isCancelled);
  }

  function runFlushEffect(channel, cb) {
    channel.flush(cb);
  }

  function runGetContextEffect(prop, cb) {
    cb(taskContext[prop]);
  }

  function runSetContextEffect(props, cb) {
    utils["s" /* object */].assign(taskContext, props);
    cb();
  }

  function newTask(id, name, iterator, cont) {
    var _done, _ref9, _mutatorMap;

    iterator._deferredEnd = null;
    return _ref9 = {}, _ref9[utils["e" /* TASK */]] = true, _ref9.id = id, _ref9.name = name, _done = 'done', _mutatorMap = {}, _mutatorMap[_done] = _mutatorMap[_done] || {}, _mutatorMap[_done].get = function () {
      if (iterator._deferredEnd) {
        return iterator._deferredEnd.promise;
      } else {
        var def = Object(utils["i" /* deferred */])();
        iterator._deferredEnd = def;
        if (!iterator._isRunning) {
          iterator._error ? def.reject(iterator._error) : def.resolve(iterator._result);
        }
        return def.promise;
      }
    }, _ref9.cont = cont, _ref9.joiners = [], _ref9.cancel = cancel, _ref9.isRunning = function isRunning() {
      return iterator._isRunning;
    }, _ref9.isCancelled = function isCancelled() {
      return iterator._isCancelled;
    }, _ref9.isAborted = function isAborted() {
      return iterator._isAborted;
    }, _ref9.result = function result() {
      return iterator._result;
    }, _ref9.error = function error() {
      return iterator._error;
    }, _ref9.setContext = function setContext(props) {
      Object(utils["g" /* check */])(props, utils["n" /* is */].object, Object(utils["h" /* createSetContextWarning */])('task', props));
      utils["s" /* object */].assign(taskContext, props);
    }, _defineEnumerableProperties(_ref9, _mutatorMap), _ref9;
  }
}
// CONCATENATED MODULE: ../node_modules/redux-saga/es/internal/runSaga.js



var RUN_SAGA_SIGNATURE = 'runSaga(storeInterface, saga, ...args)';
var NON_GENERATOR_ERR = RUN_SAGA_SIGNATURE + ': saga argument must be a Generator function!';

function runSaga(storeInterface, saga) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var iterator = void 0;

  if (utils["n" /* is */].iterator(storeInterface)) {
    if (false) {
      log('warn', 'runSaga(iterator, storeInterface) has been deprecated in favor of ' + RUN_SAGA_SIGNATURE);
    }
    iterator = storeInterface;
    storeInterface = saga;
  } else {
    Object(utils["g" /* check */])(saga, utils["n" /* is */].func, NON_GENERATOR_ERR);
    iterator = saga.apply(undefined, args);
    Object(utils["g" /* check */])(iterator, utils["n" /* is */].iterator, NON_GENERATOR_ERR);
  }

  var _storeInterface = storeInterface,
      subscribe = _storeInterface.subscribe,
      dispatch = _storeInterface.dispatch,
      getState = _storeInterface.getState,
      context = _storeInterface.context,
      sagaMonitor = _storeInterface.sagaMonitor,
      logger = _storeInterface.logger,
      onError = _storeInterface.onError;


  var effectId = Object(utils["v" /* uid */])();

  if (sagaMonitor) {
    // monitors are expected to have a certain interface, let's fill-in any missing ones
    sagaMonitor.effectTriggered = sagaMonitor.effectTriggered || utils["r" /* noop */];
    sagaMonitor.effectResolved = sagaMonitor.effectResolved || utils["r" /* noop */];
    sagaMonitor.effectRejected = sagaMonitor.effectRejected || utils["r" /* noop */];
    sagaMonitor.effectCancelled = sagaMonitor.effectCancelled || utils["r" /* noop */];
    sagaMonitor.actionDispatched = sagaMonitor.actionDispatched || utils["r" /* noop */];

    sagaMonitor.effectTriggered({ effectId: effectId, root: true, parentEffectId: 0, effect: { root: true, saga: saga, args: args } });
  }

  var task = proc(iterator, subscribe, Object(utils["x" /* wrapSagaDispatch */])(dispatch), getState, context, { sagaMonitor: sagaMonitor, logger: logger, onError: onError }, effectId, saga.name);

  if (sagaMonitor) {
    sagaMonitor.effectResolved(effectId, task);
  }

  return task;
}
// CONCATENATED MODULE: ../node_modules/redux-saga/es/internal/middleware.js
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






function sagaMiddlewareFactory() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _ref$context = _ref.context,
      context = _ref$context === undefined ? {} : _ref$context,
      options = _objectWithoutProperties(_ref, ['context']);

  var sagaMonitor = options.sagaMonitor,
      logger = options.logger,
      onError = options.onError;


  if (utils["n" /* is */].func(options)) {
    if (true) {
      throw new Error('Saga middleware no longer accept Generator functions. Use sagaMiddleware.run instead');
    } else {
      throw new Error('You passed a function to the Saga middleware. You are likely trying to start a        Saga by directly passing it to the middleware. This is no longer possible starting from 0.10.0.        To run a Saga, you must do it dynamically AFTER mounting the middleware into the store.\n        Example:\n          import createSagaMiddleware from \'redux-saga\'\n          ... other imports\n\n          const sagaMiddleware = createSagaMiddleware()\n          const store = createStore(reducer, applyMiddleware(sagaMiddleware))\n          sagaMiddleware.run(saga, ...args)\n      ');
    }
  }

  if (logger && !utils["n" /* is */].func(logger)) {
    throw new Error('`options.logger` passed to the Saga middleware is not a function!');
  }

  if (false) {
    throw new Error('`options.onerror` was removed. Use `options.onError` instead.');
  }

  if (onError && !utils["n" /* is */].func(onError)) {
    throw new Error('`options.onError` passed to the Saga middleware is not a function!');
  }

  if (options.emitter && !utils["n" /* is */].func(options.emitter)) {
    throw new Error('`options.emitter` passed to the Saga middleware is not a function!');
  }

  function sagaMiddleware(_ref2) {
    var getState = _ref2.getState,
        dispatch = _ref2.dispatch;

    var sagaEmitter = Object(internal_channel["b" /* emitter */])();
    sagaEmitter.emit = (options.emitter || utils["l" /* ident */])(sagaEmitter.emit);

    sagaMiddleware.run = runSaga.bind(null, {
      context: context,
      subscribe: sagaEmitter.subscribe,
      dispatch: dispatch,
      getState: getState,
      sagaMonitor: sagaMonitor,
      logger: logger,
      onError: onError
    });

    return function (next) {
      return function (action) {
        if (sagaMonitor && sagaMonitor.actionDispatched) {
          sagaMonitor.actionDispatched(action);
        }
        var result = next(action); // hit reducers
        sagaEmitter.emit(action);
        return result;
      };
    };
  }

  sagaMiddleware.run = function () {
    throw new Error('Before running a Saga, you must mount the Saga middleware on the Store using applyMiddleware');
  };

  sagaMiddleware.setContext = function (props) {
    Object(utils["g" /* check */])(props, utils["n" /* is */].object, Object(utils["h" /* createSetContextWarning */])('sagaMiddleware', props));
    utils["s" /* object */].assign(context, props);
  };

  return sagaMiddleware;
}
// EXTERNAL MODULE: ../node_modules/redux-saga/es/internal/sagaHelpers/index.js + 4 modules
var sagaHelpers = __webpack_require__(99);

// EXTERNAL MODULE: ../node_modules/redux-saga/es/effects.js + 1 modules
var es_effects = __webpack_require__(142);

// CONCATENATED MODULE: ../node_modules/redux-saga/es/utils.js



// CONCATENATED MODULE: ../node_modules/redux-saga/es/index.js

/* harmony default export */ var redux_saga_es = (sagaMiddlewareFactory);












// EXTERNAL MODULE: ../node_modules/react-broadcast/esm/react-broadcast.js
var react_broadcast = __webpack_require__(76);

// EXTERNAL MODULE: ../node_modules/redux-devtools-extension/index.js
var redux_devtools_extension = __webpack_require__(199);
var redux_devtools_extension_default = /*#__PURE__*/__webpack_require__.n(redux_devtools_extension);

// EXTERNAL MODULE: ../node_modules/@lingui/react/index.js
var _lingui_react = __webpack_require__(3);
var _lingui_react_default = /*#__PURE__*/__webpack_require__.n(_lingui_react);

// EXTERNAL MODULE: ../react-lib/src/lib/lifted-components/redux/index.jsx + 1 modules
var redux = __webpack_require__(139);

// CONCATENATED MODULE: ../react-lib/src/components/utils/Redux/Provider.jsx
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BROADCAST_CHANNEL; });
/* unused harmony export InitialStateContext */
/* unused harmony export createStore */
function Provider__extends() { Provider__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Provider__extends.apply(this, arguments); }

function Provider__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Provider__typeof = function _typeof(obj) { return typeof obj; }; } else { Provider__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Provider__typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (Provider__typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








// cyclic dependency: https://roverdotcom.atlassian.net/browse/DEV-49358
// eslint-disable-next-line import/no-cycle

var DEFAULT_MIDDLEWARE = [redux_thunk_es["default"].withExtraArgument({})];
var BROADCAST_CHANNEL = 'redux-provider';
var InitialStateContext = react_default.a.createContext();
var Provider_createStore = function createStore(reducers) {
  var initialState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.__ROVER_INITIAL_DATA__;
  var middleware = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_MIDDLEWARE;
  var name = arguments.length > 3 ? arguments[3] : undefined;
  return Object(es["createStore"])(Object(es["combineReducers"])(_objectSpread({}, reducers, {
    lifted: redux["b" /* reducer */]
  })), initialState, Object(redux_devtools_extension["composeWithDevTools"])({
    name: name
  })(es["applyMiddleware"].apply(void 0, _toConsumableArray(middleware))));
};

var Provider_InnerProvider =
/*#__PURE__*/
function (_Component) {
  _inherits(InnerProvider, _Component);

  function InnerProvider(props) {
    var _this;

    _classCallCheck(this, InnerProvider);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(InnerProvider).call(this, props));
    _this.reducers = void 0;
    _this.reduxStore = void 0;
    _this.sagaMiddleWare = void 0;

    if (props.store) {
      _this.reduxStore = props.store;
    } else {
      _this.reducers = props.reducers;
      _this.sagaMiddleWare = redux_saga_es();
      _this.reduxStore = Provider_createStore(props.reducers, props.initialState, [redux_thunk_es["default"].withExtraArgument({
        routerProps: props.routerProps,
        i18n: props.i18n,
        query: props.query,
        history: props.history,
        expressParams: (props.routeContext || {}).expressParams
      }), _this.sagaMiddleWare], props.name);

      _this.registerSagas();
    }

    return _this;
  }

  _createClass(InnerProvider, [{
    key: "registerSagas",
    value: function registerSagas() {
      var _this2 = this;

      if (this.sagaMiddleWare) {
        this.props.sagas.forEach(function (saga) {
          return _this2.sagaMiddleWare.run(saga, _this2.props.routerProps);
        });
      }
    }
  }, {
    key: "getContext",
    value: function getContext() {
      return {
        reduxStore: this.reduxStore
      };
    }
  }, {
    key: "render",
    value: function render() {
      return react_default.a.createElement(react_broadcast["a" /* Broadcast */], {
        channel: BROADCAST_CHANNEL,
        value: this.getContext()
      }, react["Children"].only(this.props.children));
    }
  }]);

  return InnerProvider;
}(react["Component"]);

var Provider_Provider = function Provider(props) {
  return react_default.a.createElement(_lingui_react["I18n"], null, function (_ref) {
    var i18n = _ref.i18n;
    return react_default.a.createElement(InitialStateContext.Consumer, null, function (initialState) {
      return react_default.a.createElement(Provider_InnerProvider, Provider__extends({}, props, {
        i18n: i18n,
        initialState: initialState
      }));
    });
  });
};

Provider_Provider.defaultProps = {
  initialState: undefined,
  name: '',
  sagas: [],
  routerProps: undefined,
  store: undefined,
  query: undefined,
  history: undefined,
  routeContext: undefined
};
/* harmony default export */ var Redux_Provider = __webpack_exports__["b"] = (Provider_Provider);

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/* harmony default export */ __webpack_exports__["a"] = (isLength);


/***/ }),
/* 60 */,
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/lodash-es/_Stack.js + 5 modules
var _Stack = __webpack_require__(50);

// EXTERNAL MODULE: ../node_modules/lodash-es/_baseIsEqual.js + 6 modules
var _baseIsEqual = __webpack_require__(89);

// CONCATENATED MODULE: ../node_modules/lodash-es/_baseIsMatch.js



/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new _Stack["a" /* default */];
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? Object(_baseIsEqual["a" /* default */])(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

/* harmony default export */ var _baseIsMatch = (baseIsMatch);

// EXTERNAL MODULE: ../node_modules/lodash-es/isObject.js
var isObject = __webpack_require__(8);

// CONCATENATED MODULE: ../node_modules/lodash-es/_isStrictComparable.js


/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !Object(isObject["a" /* default */])(value);
}

/* harmony default export */ var _isStrictComparable = (isStrictComparable);

// EXTERNAL MODULE: ../node_modules/lodash-es/keys.js
var keys = __webpack_require__(26);

// CONCATENATED MODULE: ../node_modules/lodash-es/_getMatchData.js



/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = Object(keys["a" /* default */])(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, _isStrictComparable(value)];
  }
  return result;
}

/* harmony default export */ var _getMatchData = (getMatchData);

// CONCATENATED MODULE: ../node_modules/lodash-es/_matchesStrictComparable.js
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

/* harmony default export */ var _matchesStrictComparable = (matchesStrictComparable);

// CONCATENATED MODULE: ../node_modules/lodash-es/_baseMatches.js




/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = _getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return _matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || _baseIsMatch(object, source, matchData);
  };
}

/* harmony default export */ var _baseMatches = (baseMatches);

// EXTERNAL MODULE: ../node_modules/lodash-es/get.js
var get = __webpack_require__(82);

// EXTERNAL MODULE: ../node_modules/lodash-es/hasIn.js + 2 modules
var hasIn = __webpack_require__(167);

// EXTERNAL MODULE: ../node_modules/lodash-es/_isKey.js
var _isKey = __webpack_require__(57);

// EXTERNAL MODULE: ../node_modules/lodash-es/_toKey.js
var _toKey = __webpack_require__(28);

// CONCATENATED MODULE: ../node_modules/lodash-es/_baseMatchesProperty.js








/** Used to compose bitmasks for value comparisons. */
var _baseMatchesProperty_COMPARE_PARTIAL_FLAG = 1,
    _baseMatchesProperty_COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (Object(_isKey["a" /* default */])(path) && _isStrictComparable(srcValue)) {
    return _matchesStrictComparable(Object(_toKey["a" /* default */])(path), srcValue);
  }
  return function(object) {
    var objValue = Object(get["a" /* default */])(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? Object(hasIn["a" /* default */])(object, path)
      : Object(_baseIsEqual["a" /* default */])(srcValue, objValue, _baseMatchesProperty_COMPARE_PARTIAL_FLAG | _baseMatchesProperty_COMPARE_UNORDERED_FLAG);
  };
}

/* harmony default export */ var _baseMatchesProperty = (baseMatchesProperty);

// EXTERNAL MODULE: ../node_modules/lodash-es/identity.js
var identity = __webpack_require__(54);

// EXTERNAL MODULE: ../node_modules/lodash-es/isArray.js
var isArray = __webpack_require__(5);

// CONCATENATED MODULE: ../node_modules/lodash-es/_baseProperty.js
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/* harmony default export */ var _baseProperty = (baseProperty);

// EXTERNAL MODULE: ../node_modules/lodash-es/_baseGet.js
var _baseGet = __webpack_require__(91);

// CONCATENATED MODULE: ../node_modules/lodash-es/_basePropertyDeep.js


/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return Object(_baseGet["a" /* default */])(object, path);
  };
}

/* harmony default export */ var _basePropertyDeep = (basePropertyDeep);

// CONCATENATED MODULE: ../node_modules/lodash-es/property.js





/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return Object(_isKey["a" /* default */])(path) ? _baseProperty(Object(_toKey["a" /* default */])(path)) : _basePropertyDeep(path);
}

/* harmony default export */ var lodash_es_property = (property);

// CONCATENATED MODULE: ../node_modules/lodash-es/_baseIteratee.js






/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity["a" /* default */];
  }
  if (typeof value == 'object') {
    return Object(isArray["a" /* default */])(value)
      ? _baseMatchesProperty(value[0], value[1])
      : _baseMatches(value);
  }
  return lodash_es_property(value);
}

/* harmony default export */ var _baseIteratee = __webpack_exports__["a"] = (baseIteratee);


/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FONT_FAMILY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FontSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FontWeight; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types_Enum__ = __webpack_require__(6);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }


var FONT_FAMILY = "'Averta-Regular', 'Avenir', 'Helvetica Neue', 'Calibri', 'Helvetica', 'Roboto', sans-serif";
var FontSize =
/*#__PURE__*/
function (_Enum) {
  _inherits(FontSize, _Enum);

  function FontSize() {
    _classCallCheck(this, FontSize);

    return _possibleConstructorReturn(this, _getPrototypeOf(FontSize).apply(this, arguments));
  }

  _createClass(FontSize, [{
    key: "toString",
    value: function toString() {
      return "".concat(parseInt(this.value, 10), "px");
    }
  }, {
    key: "toNumber",
    value: function toNumber() {
      return this.value;
    }
  }]);

  return FontSize;
}(__WEBPACK_IMPORTED_MODULE_0__types_Enum__["a" /* default */]);
FontSize.S = new FontSize(12);
FontSize.M = new FontSize(14);
FontSize.L = new FontSize(16);
FontSize.XL = new FontSize(32);
FontSize.XXL = new FontSize(40);
FontSize.XXXL = new FontSize(48);
var FontWeight =
/*#__PURE__*/
function (_Enum2) {
  _inherits(FontWeight, _Enum2);

  function FontWeight() {
    _classCallCheck(this, FontWeight);

    return _possibleConstructorReturn(this, _getPrototypeOf(FontWeight).apply(this, arguments));
  }

  return FontWeight;
}(__WEBPACK_IMPORTED_MODULE_0__types_Enum__["a" /* default */]);
FontWeight.NORMAL = new FontWeight('normal');
FontWeight.HEAVY = new FontWeight('500');
FontWeight.BOLD = new FontWeight('600');
FontWeight.BOLDEST = new FontWeight('800');
/* harmony default export */ __webpack_exports__["d"] = ({
  FontSize: FontSize,
  FontWeight: FontWeight,
  FONT_FAMILY: FONT_FAMILY
});

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/lodash-es/_getNative.js + 4 modules
var _getNative = __webpack_require__(15);

// EXTERNAL MODULE: ../node_modules/lodash-es/_root.js
var _root = __webpack_require__(10);

// CONCATENATED MODULE: ../node_modules/lodash-es/_DataView.js



/* Built-in method references that are verified to be native. */
var DataView = Object(_getNative["a" /* default */])(_root["a" /* default */], 'DataView');

/* harmony default export */ var _DataView = (DataView);

// EXTERNAL MODULE: ../node_modules/lodash-es/_Map.js
var _Map = __webpack_require__(55);

// CONCATENATED MODULE: ../node_modules/lodash-es/_Promise.js



/* Built-in method references that are verified to be native. */
var Promise = Object(_getNative["a" /* default */])(_root["a" /* default */], 'Promise');

/* harmony default export */ var _Promise = (Promise);

// EXTERNAL MODULE: ../node_modules/lodash-es/_Set.js
var _Set = __webpack_require__(162);

// EXTERNAL MODULE: ../node_modules/lodash-es/_WeakMap.js
var _WeakMap = __webpack_require__(166);

// EXTERNAL MODULE: ../node_modules/lodash-es/_baseGetTag.js + 2 modules
var _baseGetTag = __webpack_require__(20);

// EXTERNAL MODULE: ../node_modules/lodash-es/_toSource.js
var _toSource = __webpack_require__(92);

// CONCATENATED MODULE: ../node_modules/lodash-es/_getTag.js








/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = Object(_toSource["a" /* default */])(_DataView),
    mapCtorString = Object(_toSource["a" /* default */])(_Map["a" /* default */]),
    promiseCtorString = Object(_toSource["a" /* default */])(_Promise),
    setCtorString = Object(_toSource["a" /* default */])(_Set["a" /* default */]),
    weakMapCtorString = Object(_toSource["a" /* default */])(_WeakMap["a" /* default */]);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = _baseGetTag["a" /* default */];

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((_DataView && getTag(new _DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (_Map["a" /* default */] && getTag(new _Map["a" /* default */]) != mapTag) ||
    (_Promise && getTag(_Promise.resolve()) != promiseTag) ||
    (_Set["a" /* default */] && getTag(new _Set["a" /* default */]) != setTag) ||
    (_WeakMap["a" /* default */] && getTag(new _WeakMap["a" /* default */]) != weakMapTag)) {
  getTag = function(value) {
    var result = Object(_baseGetTag["a" /* default */])(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? Object(_toSource["a" /* default */])(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/* harmony default export */ var _getTag = __webpack_exports__["a"] = (getTag);


/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayMap);


/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Icon__ = __webpack_require__(218);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return __WEBPACK_IMPORTED_MODULE_0__Icon__["a"]; });


/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assignValue_js__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseAssignValue_js__ = __webpack_require__(52);



/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      Object(__WEBPACK_IMPORTED_MODULE_1__baseAssignValue_js__["a" /* default */])(object, key, newValue);
    } else {
      Object(__WEBPACK_IMPORTED_MODULE_0__assignValue_js__["a" /* default */])(object, key, newValue);
    }
  }
  return object;
}

/* harmony default export */ __webpack_exports__["a"] = (copyObject);


/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Provider__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Connect__ = __webpack_require__(29);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__Provider__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__Connect__["a"]; });




/* unused harmony default export */ var _unused_webpack_default_export = ({
  Provider: __WEBPACK_IMPORTED_MODULE_0__Provider__["b" /* default */],
  Connect: __WEBPACK_IMPORTED_MODULE_1__Connect__["a" /* default */]
});

/***/ }),
/* 68 */,
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/lodash-es/isArray.js
var isArray = __webpack_require__(5);

// EXTERNAL MODULE: ../node_modules/lodash-es/_isKey.js
var _isKey = __webpack_require__(57);

// EXTERNAL MODULE: ../node_modules/lodash-es/memoize.js
var memoize = __webpack_require__(150);

// CONCATENATED MODULE: ../node_modules/lodash-es/_memoizeCapped.js


/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = Object(memoize["a" /* default */])(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

/* harmony default export */ var _memoizeCapped = (memoizeCapped);

// CONCATENATED MODULE: ../node_modules/lodash-es/_stringToPath.js


/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = _memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/* harmony default export */ var _stringToPath = (stringToPath);

// EXTERNAL MODULE: ../node_modules/lodash-es/toString.js + 1 modules
var lodash_es_toString = __webpack_require__(132);

// CONCATENATED MODULE: ../node_modules/lodash-es/_castPath.js





/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (Object(isArray["a" /* default */])(value)) {
    return value;
  }
  return Object(_isKey["a" /* default */])(value, object) ? [value] : _stringToPath(Object(lodash_es_toString["a" /* default */])(value));
}

/* harmony default export */ var _castPath = __webpack_exports__["a"] = (castPath);


/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Form__ = __webpack_require__(240);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Form__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__Form__["b"]; });


/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (baseUnary);


/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseFor_js__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keys_js__ = __webpack_require__(26);



/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && Object(__WEBPACK_IMPORTED_MODULE_0__baseFor_js__["a" /* default */])(object, iteratee, __WEBPACK_IMPORTED_MODULE_1__keys_js__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = (baseForOwn);


/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayPush);


/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(347);


/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */].process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

/* harmony default export */ __webpack_exports__["a"] = (nodeUtil);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(106)(module)))

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/* harmony default export */ __webpack_exports__["a"] = (isPrototype);


/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Broadcast; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Subscriber; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

var emptyFunction_1 = emptyFunction;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

var invariant_1 = invariant;

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction_1;

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

var warning_1 = warning;

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/

/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

var ReactPropTypesSecret_1 = ReactPropTypesSecret;

if (false) {
  var invariant$1 = invariant_1;
  var warning$1 = warning_1;
  var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (false) {
    for (var typeSpecName in typeSpecs) {
      if (typeSpecs.hasOwnProperty(typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          invariant$1(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'the `prop-types` package, but received `%s`.', componentName || 'React class', location, typeSpecName, typeof typeSpecs[typeSpecName]);
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$1);
        } catch (ex) {
          error = ex;
        }
        warning$1(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          warning$1(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
        }
      }
    }
  }
}

var checkPropTypes_1 = checkPropTypes;

var factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (false) {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret_1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          invariant_1(
            false,
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
        } else if (false) {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            warning_1(
              false,
              'You are manually calling a React.PropTypes validation ' +
              'function for the `%s` prop on `%s`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
              propFullName,
              componentName
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunction_1.thatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
       false ? warning_1(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
      return emptyFunction_1.thatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues);
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (propValue.hasOwnProperty(key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
       false ? warning_1(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunction_1.thatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        warning_1(
          false,
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received %s at index %s.',
          getPostfixForTypeWarning(checker),
          i
        );
        return emptyFunction_1.thatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from
      // props.
      var allKeys = objectAssign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes_1;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

var factoryWithThrowingShims = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret_1) {
      // It is still safe when called from React.
      return;
    }
    invariant_1(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  }
  shim.isRequired = shim;
  function getShim() {
    return shim;
  }
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction_1;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

var propTypes = createCommonjsModule(function (module) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = factoryWithTypeCheckers(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = factoryWithThrowingShims();
}
});

/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var NODE_ENV = "production";

var invariant$3 = function(condition, format, a, b, c, d, e, f) {
  if (NODE_ENV !== 'production') {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

var invariant_1$2 = invariant$3;

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};









var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

function createBroadcast(initialValue) {
  var currentValue = initialValue;
  var subscribers = [];

  var getValue = function getValue() {
    return currentValue;
  };

  var publish = function publish(state) {
    currentValue = state;
    subscribers.forEach(function (s) {
      return s(currentValue);
    });
  };

  var subscribe = function subscribe(subscriber) {
    subscribers.push(subscriber);

    return function () {
      subscribers = subscribers.filter(function (s) {
        return s !== subscriber;
      });
    };
  };

  return {
    getValue: getValue,
    publish: publish,
    subscribe: subscribe
  };
}

/**
 * A <Broadcast> provides a generic way for descendants to "subscribe"
 * to some value that changes over time, bypassing any intermediate
 * shouldComponentUpdate's in the hierarchy. It puts all subscription
 * functions on context.broadcasts, keyed by "channel".
 *
 * To use it, a subscriber must opt-in to context.broadcasts. See the
 * <Subscriber> component for a reference implementation.
 */

var Broadcast = function (_React$Component) {
  inherits(Broadcast, _React$Component);

  function Broadcast() {
    var _temp, _this, _ret;

    classCallCheck(this, Broadcast);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.broadcast = createBroadcast(_this.props.value), _temp), possibleConstructorReturn(_this, _ret);
  }

  Broadcast.prototype.getChildContext = function getChildContext() {
    var _babelHelpers$extends;

    return {
      broadcasts: _extends({}, this.context.broadcasts, (_babelHelpers$extends = {}, _babelHelpers$extends[this.props.channel] = this.broadcast, _babelHelpers$extends))
    };
  };

  Broadcast.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    invariant_1$2(this.props.channel === nextProps.channel, "You cannot change <Broadcast channel>");

    if (!this.props.compareValues(this.props.value, nextProps.value)) {
      this.broadcast.publish(nextProps.value);
    }
  };

  Broadcast.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.only(this.props.children);
  };

  return Broadcast;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Broadcast.propTypes = {
  channel: propTypes.string.isRequired,
  children: propTypes.node.isRequired,
  compareValues: propTypes.func,
  value: propTypes.any
};
Broadcast.defaultProps = {
  compareValues: function compareValues(prevValue, nextValue) {
    return prevValue === nextValue;
  }
};
Broadcast.contextTypes = {
  broadcasts: propTypes.object
};
Broadcast.childContextTypes = {
  broadcasts: propTypes.object.isRequired
};

/**
 * A <Subscriber> pulls the value for a channel off of context.broadcasts
 * and passes it to its children function.
 */

var Subscriber = function (_React$Component) {
  inherits(Subscriber, _React$Component);

  function Subscriber() {
    var _temp, _this, _ret;

    classCallCheck(this, Subscriber);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      value: undefined
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  Subscriber.prototype.getBroadcast = function getBroadcast() {
    var broadcasts = this.context.broadcasts || {};
    var broadcast = broadcasts[this.props.channel];

    invariant_1$2(this.props.quiet || broadcast, '<Subscriber channel="%s"> must be rendered in the context of a <Broadcast channel="%s">', this.props.channel, this.props.channel);

    return broadcast;
  };

  Subscriber.prototype.componentWillMount = function componentWillMount() {
    var broadcast = this.getBroadcast();

    if (broadcast) {
      this.setState({
        value: broadcast.getValue()
      });
    }
  };

  Subscriber.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    var broadcast = this.getBroadcast();

    if (broadcast) {
      this.unsubscribe = broadcast.subscribe(function (value) {
        _this2.setState({ value: value });
      });
    }
  };

  Subscriber.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.unsubscribe) this.unsubscribe();
  };

  Subscriber.prototype.render = function render() {
    var children = this.props.children;

    return children ? children(this.state.value) : null;
  };

  return Subscriber;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Subscriber.propTypes = {
  channel: propTypes.string.isRequired,
  children: propTypes.func,
  quiet: propTypes.bool
};
Subscriber.defaultProps = {
  quiet: false
};
Subscriber.contextTypes = {
  broadcasts: propTypes.object
};




/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(1);

// EXTERNAL MODULE: ../node_modules/classnames/index.js
var classnames = __webpack_require__(24);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ../react-lib/src/styles/index.js + 3 modules
var styles = __webpack_require__(2);

// EXTERNAL MODULE: ../react-lib/src/components/formFields/FormGroup/index.js
var FormGroup = __webpack_require__(129);

// EXTERNAL MODULE: ../react-lib/src/components/formFields/FormValidationError/index.js
var FormValidationError = __webpack_require__(130);

// EXTERNAL MODULE: ../react-lib/src/utils/elementIdCreator.js
var elementIdCreator = __webpack_require__(117);

// EXTERNAL MODULE: ../react-lib/src/components/callouts/Popover/index.js + 3 modules
var Popover = __webpack_require__(108);

// CONCATENATED MODULE: ../react-lib/src/components/utils/LabelAndErrorFormGroup/LabelAndErrorFormGroup.jsx
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }









var Label = styled_components_browser_esm["default"].label.withConfig({
  displayName: "LabelAndErrorFormGroup__Label",
  componentId: "b54duc-0"
})(["font-weight:700;color:", ";margin-bottom:", ";"], styles["d" /* DSToken */].TEXT_COLOR_SECONDARY, styles["k" /* Spacing */].XS);
var SubLabel = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LabelAndErrorFormGroup__SubLabel",
  componentId: "b54duc-1"
})(["line-height:1.6;color:", ";margin-bottom:6px;"], styles["d" /* DSToken */].TEXT_COLOR_TERTIARY);

var LabelAndErrorFormGroup_LabelAndErrorFormGroup =
/*#__PURE__*/
function (_Component) {
  _inherits(LabelAndErrorFormGroup, _Component);

  function LabelAndErrorFormGroup() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, LabelAndErrorFormGroup);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(LabelAndErrorFormGroup)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.id = Object(elementIdCreator["a" /* getNextId */])();
    return _this;
  }

  _createClass(LabelAndErrorFormGroup, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          id = _this$props.id,
          InputComponent = _this$props.InputComponent,
          className = _this$props.className,
          children = _this$props.children,
          style = _this$props.style,
          label = _this$props.label,
          name = _this$props.name,
          subLabel = _this$props.subLabel,
          inputRef = _this$props.inputRef,
          usingAriaLabelledby = _this$props.usingAriaLabelledby,
          placeholder = _this$props.placeholder,
          validationError = _this$props.validationError,
          validationErrorPlacement = _this$props.validationErrorPlacement,
          other = _objectWithoutProperties(_this$props, ["id", "InputComponent", "className", "children", "style", "label", "name", "subLabel", "inputRef", "usingAriaLabelledby", "placeholder", "validationError", "validationErrorPlacement"]);

      var labelComponent = null;
      var childrenComponent = null;

      if (label) {
        var labelProps = {
          className: 'control-label',
          htmlFor: usingAriaLabelledby ? undefined : id || "".concat(name || '', "-").concat(this.id),
          id: usingAriaLabelledby ? id || "".concat(name || '', "-").concat(this.id) : undefined,
          children: label
        }; // eslint-disable-next-line jsx-a11y/label-has-for

        labelComponent = react_default.a.createElement(Label, labelProps);
      }

      var inputComponentProps = _objectSpread({}, other, {
        ref: inputRef,
        name: name,
        id: id || "".concat(name || '', "-").concat(this.id),
        placeholder: placeholder || (typeof label === 'string' ? label : '')
      });

      if (InputComponent) {
        childrenComponent = react_default.a.createElement(InputComponent, inputComponentProps);
      } else if (children) {
        // support function as child
        childrenComponent = children(inputComponentProps);
      }

      return react_default.a.createElement(FormGroup["b" /* default */], {
        className: classnames_default()({
          'has-error': validationError
        }, className),
        style: style
      }, labelComponent, subLabel && react_default.a.createElement(SubLabel, null, subLabel), react_default.a.createElement(FormValidationError["a" /* default */], {
        message: validationError,
        placement: validationErrorPlacement
      }, childrenComponent));
    }
  }]);

  return LabelAndErrorFormGroup;
}(react["Component"]);


// CONCATENATED MODULE: ../react-lib/src/components/utils/LabelAndErrorFormGroup/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return LabelAndErrorFormGroup_LabelAndErrorFormGroup; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return Label; });
/* unused concated harmony import SubLabel */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return SubLabel; });


/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ZIndex; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types_Enum__ = __webpack_require__(6);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }



var ZIndex =
/*#__PURE__*/
function (_Enum) {
  _inherits(ZIndex, _Enum);

  function ZIndex() {
    _classCallCheck(this, ZIndex);

    return _possibleConstructorReturn(this, _getPrototypeOf(ZIndex).apply(this, arguments));
  }

  return ZIndex;
}(__WEBPACK_IMPORTED_MODULE_0__types_Enum__["a" /* default */]);

ZIndex.ZERO = new ZIndex(0);
ZIndex.ONE = new ZIndex(1);
ZIndex.NAVBAR = new ZIndex(1000);
ZIndex.NAVBAR_FIXED = new ZIndex(1030);
ZIndex.POPOVER = new ZIndex(1060);
ZIndex.TOOLTIP = new ZIndex(1070);
ZIndex.DROPDOWN = new ZIndex(1075);
ZIndex.DIALOG = new ZIndex(1077);
ZIndex.MODAL_BACKGROUND = new ZIndex(1079);
ZIndex.MODAL = new ZIndex(1080);
ZIndex.MODAL_OVERLAY = new ZIndex(1200);
ZIndex.isLocked = true;


/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return APIError; });
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _construct(Parent, args, Class) { if (isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var APIError =
/*#__PURE__*/
function (_Error) {
  _inherits(APIError, _Error);

  function APIError(message, status) {
    var _this;

    _classCallCheck(this, APIError);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(APIError).call(this, message.id || message));
    _this.status = void 0;
    _this.status = status;
    return _this;
  }

  return APIError;
}(_wrapNativeSuper(Error));



/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/lodash-es/_arrayLikeKeys.js + 1 modules
var _arrayLikeKeys = __webpack_require__(110);

// EXTERNAL MODULE: ../node_modules/lodash-es/isObject.js
var isObject = __webpack_require__(8);

// EXTERNAL MODULE: ../node_modules/lodash-es/_isPrototype.js
var _isPrototype = __webpack_require__(75);

// CONCATENATED MODULE: ../node_modules/lodash-es/_nativeKeysIn.js
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ var _nativeKeysIn = (nativeKeysIn);

// CONCATENATED MODULE: ../node_modules/lodash-es/_baseKeysIn.js




/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _baseKeysIn_hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!Object(isObject["a" /* default */])(object)) {
    return _nativeKeysIn(object);
  }
  var isProto = Object(_isPrototype["a" /* default */])(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !_baseKeysIn_hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ var _baseKeysIn = (baseKeysIn);

// EXTERNAL MODULE: ../node_modules/lodash-es/isArrayLike.js
var isArrayLike = __webpack_require__(23);

// CONCATENATED MODULE: ../node_modules/lodash-es/keysIn.js




/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return Object(isArrayLike["a" /* default */])(object) ? Object(_arrayLikeKeys["a" /* default */])(object, true) : _baseKeysIn(object);
}

/* harmony default export */ var lodash_es_keysIn = __webpack_exports__["a"] = (keysIn);


/***/ }),
/* 81 */,
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGet_js__ = __webpack_require__(91);


/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : Object(__WEBPACK_IMPORTED_MODULE_0__baseGet_js__["a" /* default */])(object, path);
  return result === undefined ? defaultValue : result;
}

/* harmony default export */ __webpack_exports__["a"] = (get);


/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ../node_modules/lodash-es/_arrayFilter.js
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

/* harmony default export */ var _arrayFilter = (arrayFilter);

// EXTERNAL MODULE: ../node_modules/lodash-es/stubArray.js
var stubArray = __webpack_require__(122);

// CONCATENATED MODULE: ../node_modules/lodash-es/_getSymbols.js



/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray["a" /* default */] : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return _arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

/* harmony default export */ var _getSymbols = __webpack_exports__["a"] = (getSymbols);


/***/ }),
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/lodash-es/_Stack.js + 5 modules
var _Stack = __webpack_require__(50);

// EXTERNAL MODULE: ../node_modules/lodash-es/_SetCache.js + 2 modules
var _SetCache = __webpack_require__(160);

// CONCATENATED MODULE: ../node_modules/lodash-es/_arraySome.js
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/* harmony default export */ var _arraySome = (arraySome);

// EXTERNAL MODULE: ../node_modules/lodash-es/_cacheHas.js
var _cacheHas = __webpack_require__(161);

// CONCATENATED MODULE: ../node_modules/lodash-es/_equalArrays.js




/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new _SetCache["a" /* default */] : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!_arraySome(other, function(othValue, othIndex) {
            if (!Object(_cacheHas["a" /* default */])(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

/* harmony default export */ var _equalArrays = (equalArrays);

// EXTERNAL MODULE: ../node_modules/lodash-es/_Symbol.js
var _Symbol = __webpack_require__(68);

// EXTERNAL MODULE: ../node_modules/lodash-es/_Uint8Array.js
var _Uint8Array = __webpack_require__(111);

// EXTERNAL MODULE: ../node_modules/lodash-es/eq.js
var eq = __webpack_require__(33);

// CONCATENATED MODULE: ../node_modules/lodash-es/_mapToArray.js
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/* harmony default export */ var _mapToArray = (mapToArray);

// EXTERNAL MODULE: ../node_modules/lodash-es/_setToArray.js
var _setToArray = __webpack_require__(158);

// CONCATENATED MODULE: ../node_modules/lodash-es/_equalByTag.js







/** Used to compose bitmasks for value comparisons. */
var _equalByTag_COMPARE_PARTIAL_FLAG = 1,
    _equalByTag_COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = _Symbol["a" /* default */] ? _Symbol["a" /* default */].prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new _Uint8Array["a" /* default */](object), new _Uint8Array["a" /* default */](other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return Object(eq["a" /* default */])(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = _mapToArray;

    case setTag:
      var isPartial = bitmask & _equalByTag_COMPARE_PARTIAL_FLAG;
      convert || (convert = _setToArray["a" /* default */]);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= _equalByTag_COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = _equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

/* harmony default export */ var _equalByTag = (equalByTag);

// EXTERNAL MODULE: ../node_modules/lodash-es/_getAllKeys.js
var _getAllKeys = __webpack_require__(120);

// CONCATENATED MODULE: ../node_modules/lodash-es/_equalObjects.js


/** Used to compose bitmasks for value comparisons. */
var _equalObjects_COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _equalObjects_hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & _equalObjects_COMPARE_PARTIAL_FLAG,
      objProps = Object(_getAllKeys["a" /* default */])(object),
      objLength = objProps.length,
      othProps = Object(_getAllKeys["a" /* default */])(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : _equalObjects_hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

/* harmony default export */ var _equalObjects = (equalObjects);

// EXTERNAL MODULE: ../node_modules/lodash-es/_getTag.js + 2 modules
var _getTag = __webpack_require__(63);

// EXTERNAL MODULE: ../node_modules/lodash-es/isArray.js
var isArray = __webpack_require__(5);

// EXTERNAL MODULE: ../node_modules/lodash-es/isBuffer.js
var isBuffer = __webpack_require__(38);

// EXTERNAL MODULE: ../node_modules/lodash-es/isTypedArray.js + 1 modules
var isTypedArray = __webpack_require__(48);

// CONCATENATED MODULE: ../node_modules/lodash-es/_baseIsEqualDeep.js









/** Used to compose bitmasks for value comparisons. */
var _baseIsEqualDeep_COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var _baseIsEqualDeep_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _baseIsEqualDeep_hasOwnProperty = _baseIsEqualDeep_objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = Object(isArray["a" /* default */])(object),
      othIsArr = Object(isArray["a" /* default */])(other),
      objTag = objIsArr ? arrayTag : Object(_getTag["a" /* default */])(object),
      othTag = othIsArr ? arrayTag : Object(_getTag["a" /* default */])(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && Object(isBuffer["a" /* default */])(object)) {
    if (!Object(isBuffer["a" /* default */])(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new _Stack["a" /* default */]);
    return (objIsArr || Object(isTypedArray["a" /* default */])(object))
      ? _equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : _equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & _baseIsEqualDeep_COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && _baseIsEqualDeep_hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && _baseIsEqualDeep_hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new _Stack["a" /* default */]);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new _Stack["a" /* default */]);
  return _equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

/* harmony default export */ var _baseIsEqualDeep = (baseIsEqualDeep);

// EXTERNAL MODULE: ../node_modules/lodash-es/isObjectLike.js
var isObjectLike = __webpack_require__(12);

// CONCATENATED MODULE: ../node_modules/lodash-es/_baseIsEqual.js



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!Object(isObjectLike["a" /* default */])(value) && !Object(isObjectLike["a" /* default */])(other))) {
    return value !== value && other !== other;
  }
  return _baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

/* harmony default export */ var _baseIsEqual = __webpack_exports__["a"] = (baseIsEqual);


/***/ }),
/* 90 */,
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__castPath_js__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toKey_js__ = __webpack_require__(28);



/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = Object(__WEBPACK_IMPORTED_MODULE_0__castPath_js__["a" /* default */])(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[Object(__WEBPACK_IMPORTED_MODULE_1__toKey_js__["a" /* default */])(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = (baseGet);


/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/* harmony default export */ __webpack_exports__["a"] = (toSource);


/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BACKGROUND_COLOR_CONTRAST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return BACKGROUND_COLOR_OVERLAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return BACKGROUND_COLOR_OVERLAY_ACCENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return BACKGROUND_COLOR_TERTIARY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return BACKGROUND_COLOR_SECONDARY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return BACKGROUND_COLOR_PRIMARY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return BACKGROUND_COLOR_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BACKGROUND_COLOR_ACCENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return BORDER_COLOR_PRIMARY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return BORDER_COLOR_SECONDARY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return BORDER_COLOR_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return BORDER_COLOR_INPUT_FOCUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return INTERACTIVE_TEXT_COLOR_PRIMARY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return INTERACTIVE_TEXT_COLOR_PRIMARY_ACTIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return INTERACTIVE_TEXT_COLOR_DISABLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return INTERACTIVE_TEXT_COLOR_LINK_PRIMARY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return INTERACTIVE_TEXT_COLOR_LINK_PRIMARY_PRESSED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return INTERACTIVE_TEXT_COLOR_LINK_PRIMARY_INVERSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return INTERACTIVE_TEXT_COLOR_LINK_SECONDARY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return INTERACTIVE_TEXT_COLOR_LINK_SECONDARY_PRESSED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return INTERACTIVE_TEXT_COLOR_LINK_SECONDARY_INVERSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return INTERACTIVE_BORDER_COLOR_PRIMARY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return INTERACTIVE_BORDER_COLOR_PRIMARY_PRESSED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return INTERACTIVE_BORDER_COLOR_PRIMARY_ACTIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return INTERACTIVE_BORDER_COLOR_DISABLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return INTERACTIVE_BACKGROUND_COLOR_PRIMARY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return INTERACTIVE_BACKGROUND_COLOR_PRIMARY_PRESSED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return INTERACTIVE_BACKGROUND_COLOR_PRIMARY_ACTIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return INTERACTIVE_BACKGROUND_COLOR_PRIMARY_ACTIVE_PRESSED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return INTERACTIVE_BACKGROUND_COLOR_DISABLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return SEPARATOR_COLOR_PRIMARY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_43", function() { return TEMPORARY_COLOR_BUTTON_TERTIARY_BACKGROUND_PRESSED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_41", function() { return TEMPORARY_COLOR_BUTTON_DESTRUCTIVE_BACKGROUND_PRESSED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_42", function() { return TEMPORARY_COLOR_BUTTON_PRIMARY_DISABLED_BACKGROUND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_57", function() { return TEXT_COLOR_PRIMARY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_58", function() { return TEXT_COLOR_PRIMARY_INVERSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_59", function() { return TEXT_COLOR_SECONDARY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_60", function() { return TEXT_COLOR_SECONDARY_INVERSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_61", function() { return TEXT_COLOR_TERTIARY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_62", function() { return TEXT_COLOR_TERTIARY_INVERSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_53", function() { return TEXT_COLOR_DISABLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_55", function() { return TEXT_COLOR_PLACEHOLDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_54", function() { return TEXT_COLOR_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_56", function() { return TEXT_COLOR_PRICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return GRADIENT_BASE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return GRADIENT_PRIMARY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return GRADIENT_PRIMARY_PRESSED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return GRADIENT_DESTRUCTIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return GRADIENT_DESTRUCTIVE_PRESSED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return BORDER_RADIUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return SPACE_0X; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return SPACE_1X; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return SPACE_2X; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_36", function() { return SPACE_3X; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_37", function() { return SPACE_4X; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_38", function() { return SPACE_5X; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_39", function() { return SPACE_6X; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_40", function() { return SPACE_8X; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return SPACE_12X; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return SPACE_16X; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return SPACE_24X; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return HEADING_100_FONT_FAMILY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return HEADING_100_FONT_SIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return HEADING_100_FONT_WEIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return HEADING_100_LINE_HEIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return HEADING_100_MARGIN_BOTTOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return HEADING_200_FONT_FAMILY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return HEADING_200_FONT_SIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return HEADING_200_FONT_WEIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return HEADING_200_LINE_HEIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return HEADING_200_MARGIN_BOTTOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return HEADING_300_FONT_FAMILY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return HEADING_300_FONT_SIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return HEADING_300_FONT_WEIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return HEADING_300_LINE_HEIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return HEADING_300_MARGIN_BOTTOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return HEADING_400_FONT_FAMILY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return HEADING_400_FONT_SIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return HEADING_400_FONT_WEIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return HEADING_400_LINE_HEIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return HEADING_400_MARGIN_BOTTOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return HEADING_500_FONT_FAMILY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return HEADING_500_FONT_SIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return HEADING_500_FONT_WEIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return HEADING_500_LINE_HEIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return HEADING_500_MARGIN_BOTTOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return HEADING_600_FONT_FAMILY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return HEADING_600_FONT_SIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return HEADING_600_FONT_WEIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return HEADING_600_LINE_HEIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return HEADING_600_MARGIN_BOTTOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return HEADING_RESPONSIVE_400_FONT_SIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return HEADING_RESPONSIVE_500_FONT_SIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return HEADING_RESPONSIVE_600_FONT_SIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return PARAGRAPH_100_FONT_SIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return PARAGRAPH_100_FONT_WEIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return PARAGRAPH_100_LINE_HEIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return PARAGRAPH_100_MARGIN_BOTTOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return PARAGRAPH_200_FONT_SIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return PARAGRAPH_200_FONT_WEIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return PARAGRAPH_200_LINE_HEIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return PARAGRAPH_200_MARGIN_BOTTOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return PARAGRAPH_300_FONT_SIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return PARAGRAPH_300_FONT_WEIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return PARAGRAPH_300_LINE_HEIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return PARAGRAPH_300_MARGIN_BOTTOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_44", function() { return TEXT_100_FONT_SIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_45", function() { return TEXT_100_FONT_WEIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_46", function() { return TEXT_100_LINE_HEIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_47", function() { return TEXT_200_FONT_SIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_48", function() { return TEXT_200_FONT_WEIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_49", function() { return TEXT_200_LINE_HEIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_50", function() { return TEXT_300_FONT_SIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_51", function() { return TEXT_300_FONT_WEIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_52", function() { return TEXT_300_LINE_HEIGHT; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Color__ = __webpack_require__(101);
/**
 * Do not edit directly
 * Generated on Thu, 20 Feb 2020 17:25:54 GMT
 */

var BACKGROUND_COLOR_CONTRAST = __WEBPACK_IMPORTED_MODULE_0__Color__["a" /* default */].NEUTRAL_28;
var BACKGROUND_COLOR_OVERLAY = __WEBPACK_IMPORTED_MODULE_0__Color__["a" /* default */].NEUTRAL_12.withOpacity(0.48);
var BACKGROUND_COLOR_OVERLAY_ACCENT = __WEBPACK_IMPORTED_MODULE_0__Color__["a" /* default */].GREEN_BASE.withOpacity(0.24);
var BACKGROUND_COLOR_TERTIARY = __WEBPACK_IMPORTED_MODULE_0__Color__["a" /* default */].NEUTRAL_92;
var BACKGROUND_COLOR_SECONDARY = __WEBPACK_IMPORTED_MODULE_0__Color__["a" /* default */].NEUTRAL_96;
var BACKGROUND_COLOR_PRIMARY = __WEBPACK_IMPORTED_MODULE_0__Color__["a" /* default */].NEUTRAL_100;
var BACKGROUND_COLOR_ERROR = __WEBPACK_IMPORTED_MODULE_0__Color__["a" /* default */].RED_96;
var BACKGROUND_COLOR_ACCENT = __WEBPACK_IMPORTED_MODULE_0__Color__["a" /* default */].BRAND_ROVER;
var BORDER_COLOR_PRIMARY = __WEBPACK_IMPORTED_MODULE_0__Color__["a" /* default */].NEUTRAL_84;
var BORDER_COLOR_SECONDARY = __WEBPACK_IMPORTED_MODULE_0__Color__["a" /* default */].NEUTRAL_88;
var BORDER_COLOR_ERROR = __WEBPACK_IMPORTED_MODULE_0__Color__["a" /* default */].RED_BASE;
var BORDER_COLOR_INPUT_FOCUS = __WEBPACK_IMPORTED_MODULE_0__Color__["a" /* default */].BLUE_BASE;
var INTERACTIVE_TEXT_COLOR_PRIMARY = __WEBPACK_IMPORTED_MODULE_0__Color__["a" /* default */].NEUTRAL_28;
var INTERACTIVE_TEXT_COLOR_PRIMARY_ACTIVE = __WEBPACK_IMPORTED_MODULE_0__Color__["a" /* default */].GREEN_24;
var INTERACTIVE_TEXT_COLOR_DISABLED = __WEBPACK_IMPORTED_MODULE_0__Color__["a" /* default */].NEUTRAL_56;
var INTERACTIVE_TEXT_COLOR_LINK_PRIMARY = __WEBPACK_IMPORTED_MODULE_0__Color__["a" /* default */].BLUE_32;
var INTERACTIVE_TEXT_COLOR_LINK_PRIMARY_PRESSED = __WEBPACK_IMPORTED_MODULE_0__Color__["a" /* default */].BLUE_28;
var INTERACTIVE_TEXT_COLOR_LINK_PRIMARY_INVERSE = __WEBPACK_IMPORTED_MODULE_0__Color__["a" /* default */].NEUTRAL_100;
var INTERACTIVE_TEXT_COLOR_LINK_SECONDARY = __WEBPACK_IMPORTED_MODULE_0__Color__["a" /* default */].NEUTRAL_44;
var INTERACTIVE_TEXT_COLOR_LINK_SECONDARY_PRESSED = __WEBPACK_IMPORTED_MODULE_0__Color__["a" /* default */].NEUTRAL_28;
var INTERACTIVE_TEXT_COLOR_LINK_SECONDARY_INVERSE = __WEBPACK_IMPORTED_MODULE_0__Color__["a" /* default */].NEUTRAL_96;
var INTERACTIVE_BORDER_COLOR_PRIMARY = __WEBPACK_IMPORTED_MODULE_0__Color__["a" /* default */].NEUTRAL_84;
var INTERACTIVE_BORDER_COLOR_PRIMARY_PRESSED = __WEBPACK_IMPORTED_MODULE_0__Color__["a" /* default */].NEUTRAL_56;
var INTERACTIVE_BORDER_COLOR_PRIMARY_ACTIVE = __WEBPACK_IMPORTED_MODULE_0__Color__["a" /* default */].GREEN_BASE;
var INTERACTIVE_BORDER_COLOR_DISABLED = __WEBPACK_IMPORTED_MODULE_0__Color__["a" /* default */].NEUTRAL_92;
var INTERACTIVE_BACKGROUND_COLOR_PRIMARY = __WEBPACK_IMPORTED_MODULE_0__Color__["a" /* default */].NEUTRAL_100;
var INTERACTIVE_BACKGROUND_COLOR_PRIMARY_PRESSED = __WEBPACK_IMPORTED_MODULE_0__Color__["a" /* default */].NEUTRAL_96;
var INTERACTIVE_BACKGROUND_COLOR_PRIMARY_ACTIVE = __WEBPACK_IMPORTED_MODULE_0__Color__["a" /* default */].GREEN_96;
var INTERACTIVE_BACKGROUND_COLOR_PRIMARY_ACTIVE_PRESSED = __WEBPACK_IMPORTED_MODULE_0__Color__["a" /* default */].GREEN_70.withOpacity(0.32);
var INTERACTIVE_BACKGROUND_COLOR_DISABLED = __WEBPACK_IMPORTED_MODULE_0__Color__["a" /* default */].NEUTRAL_96;
var SEPARATOR_COLOR_PRIMARY = __WEBPACK_IMPORTED_MODULE_0__Color__["a" /* default */].NEUTRAL_84;
var TEMPORARY_COLOR_BUTTON_TERTIARY_BACKGROUND_PRESSED = __WEBPACK_IMPORTED_MODULE_0__Color__["a" /* default */].PURPLE_70.withOpacity(0.24);
var TEMPORARY_COLOR_BUTTON_DESTRUCTIVE_BACKGROUND_PRESSED = __WEBPACK_IMPORTED_MODULE_0__Color__["a" /* default */].RED_70.withOpacity(0.24);
var TEMPORARY_COLOR_BUTTON_PRIMARY_DISABLED_BACKGROUND = __WEBPACK_IMPORTED_MODULE_0__Color__["a" /* default */].GREEN_BASE.withOpacity(0.24);
var TEXT_COLOR_PRIMARY = __WEBPACK_IMPORTED_MODULE_0__Color__["a" /* default */].NEUTRAL_12;
var TEXT_COLOR_PRIMARY_INVERSE = __WEBPACK_IMPORTED_MODULE_0__Color__["a" /* default */].NEUTRAL_100;
var TEXT_COLOR_SECONDARY = __WEBPACK_IMPORTED_MODULE_0__Color__["a" /* default */].NEUTRAL_28;
var TEXT_COLOR_SECONDARY_INVERSE = __WEBPACK_IMPORTED_MODULE_0__Color__["a" /* default */].NEUTRAL_96;
var TEXT_COLOR_TERTIARY = __WEBPACK_IMPORTED_MODULE_0__Color__["a" /* default */].NEUTRAL_44;
var TEXT_COLOR_TERTIARY_INVERSE = __WEBPACK_IMPORTED_MODULE_0__Color__["a" /* default */].NEUTRAL_92;
var TEXT_COLOR_DISABLED = __WEBPACK_IMPORTED_MODULE_0__Color__["a" /* default */].NEUTRAL_56;
var TEXT_COLOR_PLACEHOLDER = __WEBPACK_IMPORTED_MODULE_0__Color__["a" /* default */].NEUTRAL_44;
var TEXT_COLOR_ERROR = __WEBPACK_IMPORTED_MODULE_0__Color__["a" /* default */].RED_BASE;
var TEXT_COLOR_PRICE = __WEBPACK_IMPORTED_MODULE_0__Color__["a" /* default */].ORANGE_40;
var GRADIENT_BASE = 'linear-gradient(45deg, #00CD7A 0%, #14A96D 50%, #00CD7A 100%)';
var GRADIENT_PRIMARY = 'linear-gradient(180deg, #00BD70 0%, #00CD7A 100%)';
var GRADIENT_PRIMARY_PRESSED = 'linear-gradient(180deg, #00A362 0%, #00BD71 98.81%)';
var GRADIENT_DESTRUCTIVE = 'linear-gradient(180deg, #FD3225 0%, #FF645A 100%)';
var GRADIENT_DESTRUCTIVE_PRESSED = 'linear-gradient(180deg, #BA1C11 0%, #DB291D 98.44%);';
var BORDER_RADIUS = '4px';
var SPACE_0X = '0px';
var SPACE_1X = '4px';
var SPACE_2X = '8px';
var SPACE_3X = '12px';
var SPACE_4X = '16px';
var SPACE_5X = '20px';
var SPACE_6X = '24px';
var SPACE_8X = '32px';
var SPACE_12X = '48px';
var SPACE_16X = '64px';
var SPACE_24X = '96px';
var HEADING_100_FONT_FAMILY = 'Averta-Semibold';
var HEADING_100_FONT_SIZE = '13px';
var HEADING_100_FONT_WEIGHT = 600;
var HEADING_100_LINE_HEIGHT = 1.25;
var HEADING_100_MARGIN_BOTTOM = '8px';
var HEADING_200_FONT_FAMILY = 'Averta-Semibold';
var HEADING_200_FONT_SIZE = '16px';
var HEADING_200_FONT_WEIGHT = 600;
var HEADING_200_LINE_HEIGHT = 1.25;
var HEADING_200_MARGIN_BOTTOM = '12px';
var HEADING_300_FONT_FAMILY = 'Averta-Semibold';
var HEADING_300_FONT_SIZE = '20px';
var HEADING_300_FONT_WEIGHT = 600;
var HEADING_300_LINE_HEIGHT = 1.25;
var HEADING_300_MARGIN_BOTTOM = '16px';
var HEADING_400_FONT_FAMILY = 'Averta-Extrabold';
var HEADING_400_FONT_SIZE = '26px';
var HEADING_400_FONT_WEIGHT = 800;
var HEADING_400_LINE_HEIGHT = 1.25;
var HEADING_400_MARGIN_BOTTOM = '20px';
var HEADING_500_FONT_FAMILY = 'Averta-Extrabold';
var HEADING_500_FONT_SIZE = '32px';
var HEADING_500_FONT_WEIGHT = 800;
var HEADING_500_LINE_HEIGHT = 1.25;
var HEADING_500_MARGIN_BOTTOM = '24px';
var HEADING_600_FONT_FAMILY = 'Averta-Extrabold';
var HEADING_600_FONT_SIZE = '38px';
var HEADING_600_FONT_WEIGHT = 800;
var HEADING_600_LINE_HEIGHT = 1.25;
var HEADING_600_MARGIN_BOTTOM = '32px';
var HEADING_RESPONSIVE_400_FONT_SIZE = '32px';
var HEADING_RESPONSIVE_500_FONT_SIZE = '40px';
var HEADING_RESPONSIVE_600_FONT_SIZE = '48px';
var PARAGRAPH_100_FONT_SIZE = '13px';
var PARAGRAPH_100_FONT_WEIGHT = 400;
var PARAGRAPH_100_LINE_HEIGHT = 1.5;
var PARAGRAPH_100_MARGIN_BOTTOM = '12px';
var PARAGRAPH_200_FONT_SIZE = '16px';
var PARAGRAPH_200_FONT_WEIGHT = 400;
var PARAGRAPH_200_LINE_HEIGHT = 1.5;
var PARAGRAPH_200_MARGIN_BOTTOM = '16px';
var PARAGRAPH_300_FONT_SIZE = '20px';
var PARAGRAPH_300_FONT_WEIGHT = 400;
var PARAGRAPH_300_LINE_HEIGHT = 1.5;
var PARAGRAPH_300_MARGIN_BOTTOM = '24px';
var TEXT_100_FONT_SIZE = '13px';
var TEXT_100_FONT_WEIGHT = 400;
var TEXT_100_LINE_HEIGHT = 1.25;
var TEXT_200_FONT_SIZE = '16px';
var TEXT_200_FONT_WEIGHT = 400;
var TEXT_200_LINE_HEIGHT = 1.25;
var TEXT_300_FONT_SIZE = '20px';
var TEXT_300_FONT_WEIGHT = 400;
var TEXT_300_LINE_HEIGHT = 1.2;

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ButtonType; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types_Enum__ = __webpack_require__(6);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }


var ButtonType =
/*#__PURE__*/
function (_Enum) {
  _inherits(ButtonType, _Enum);

  function ButtonType() {
    _classCallCheck(this, ButtonType);

    return _possibleConstructorReturn(this, _getPrototypeOf(ButtonType).apply(this, arguments));
  }

  return ButtonType;
}(__WEBPACK_IMPORTED_MODULE_0__types_Enum__["a" /* default */]);
ButtonType.DEFAULT = new ButtonType('default');
ButtonType.PRIMARY = new ButtonType('primary');
ButtonType.PRIMARY_NEXT = new ButtonType('primary_next');
ButtonType.DARK = new ButtonType('dark');
ButtonType.DARK_TRANSPARENT = new ButtonType('dark-transparent');
ButtonType.TEXT = new ButtonType('text');
ButtonType.TEXT_LIGHT = new ButtonType('text-light');
ButtonType.DANGER = new ButtonType('danger');
ButtonType.TERTIARY = new ButtonType('tertiary');
ButtonType.isLocked = true;

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(185), __esModule: true };

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(97);
var ITERATOR = __webpack_require__(32)('iterator');
var Iterators = __webpack_require__(86);
module.exports = __webpack_require__(16).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(333);
var TAG = __webpack_require__(32)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = asap;
/* harmony export (immutable) */ __webpack_exports__["c"] = suspend;
/* harmony export (immutable) */ __webpack_exports__["b"] = flush;
var queue = [];
/**
  Variable to hold a counting semaphore
  - Incrementing adds a lock and puts the scheduler in a `suspended` state (if it's not
    already suspended)
  - Decrementing releases a lock. Zero locks puts the scheduler in a `released` state. This
    triggers flushing the queued tasks.
**/
var semaphore = 0;

/**
  Executes a task 'atomically'. Tasks scheduled during this execution will be queued
  and flushed after this task has finished (assuming the scheduler endup in a released
  state).
**/
function exec(task) {
  try {
    suspend();
    task();
  } finally {
    release();
  }
}

/**
  Executes or queues a task depending on the state of the scheduler (`suspended` or `released`)
**/
function asap(task) {
  queue.push(task);

  if (!semaphore) {
    suspend();
    flush();
  }
}

/**
  Puts the scheduler in a `suspended` state. Scheduled tasks will be queued until the
  scheduler is released.
**/
function suspend() {
  semaphore++;
}

/**
  Puts the scheduler in a `released` state.
**/
function release() {
  semaphore--;
}

/**
  Releases the current lock. Executes all queued tasks if the scheduler is in the released state.
**/
function flush() {
  release();

  var task = void 0;
  while (!semaphore && (task = queue.shift()) !== undefined) {
    exec(task);
  }
}

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/redux-saga/es/internal/utils.js
var utils = __webpack_require__(7);

// CONCATENATED MODULE: ../node_modules/redux-saga/es/internal/sagaHelpers/fsmIterator.js


var done = { done: true, value: undefined };
var qEnd = {};

function safeName(patternOrChannel) {
  if (utils["n" /* is */].channel(patternOrChannel)) {
    return 'channel';
  } else if (Array.isArray(patternOrChannel)) {
    return String(patternOrChannel.map(function (entry) {
      return String(entry);
    }));
  } else {
    return String(patternOrChannel);
  }
}

function fsmIterator(fsm, q0) {
  var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'iterator';

  var updateState = void 0,
      qNext = q0;

  function next(arg, error) {
    if (qNext === qEnd) {
      return done;
    }

    if (error) {
      qNext = qEnd;
      throw error;
    } else {
      updateState && updateState(arg);

      var _fsm$qNext = fsm[qNext](),
          q = _fsm$qNext[0],
          output = _fsm$qNext[1],
          _updateState = _fsm$qNext[2];

      qNext = q;
      updateState = _updateState;
      return qNext === qEnd ? done : output;
    }
  }

  return Object(utils["q" /* makeIterator */])(next, function (error) {
    return next(null, error);
  }, name, true);
}
// EXTERNAL MODULE: ../node_modules/redux-saga/es/internal/io.js
var io = __webpack_require__(11);

// EXTERNAL MODULE: ../node_modules/redux-saga/es/internal/channel.js
var internal_channel = __webpack_require__(17);

// CONCATENATED MODULE: ../node_modules/redux-saga/es/internal/sagaHelpers/takeEvery.js




function takeEvery(patternOrChannel, worker) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var yTake = { done: false, value: Object(io["g" /* take */])(patternOrChannel) };
  var yFork = function yFork(ac) {
    return { done: false, value: io["e" /* fork */].apply(undefined, [worker].concat(args, [ac])) };
  };

  var action = void 0,
      setAction = function setAction(ac) {
    return action = ac;
  };

  return fsmIterator({
    q1: function q1() {
      return ['q2', yTake, setAction];
    },
    q2: function q2() {
      return action === internal_channel["a" /* END */] ? [qEnd] : ['q1', yFork(action)];
    }
  }, 'q1', 'takeEvery(' + safeName(patternOrChannel) + ', ' + worker.name + ')');
}
// CONCATENATED MODULE: ../node_modules/redux-saga/es/internal/sagaHelpers/takeLatest.js




function takeLatest(patternOrChannel, worker) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var yTake = { done: false, value: Object(io["g" /* take */])(patternOrChannel) };
  var yFork = function yFork(ac) {
    return { done: false, value: io["e" /* fork */].apply(undefined, [worker].concat(args, [ac])) };
  };
  var yCancel = function yCancel(task) {
    return { done: false, value: Object(io["d" /* cancel */])(task) };
  };

  var task = void 0,
      action = void 0;
  var setTask = function setTask(t) {
    return task = t;
  };
  var setAction = function setAction(ac) {
    return action = ac;
  };

  return fsmIterator({
    q1: function q1() {
      return ['q2', yTake, setAction];
    },
    q2: function q2() {
      return action === internal_channel["a" /* END */] ? [qEnd] : task ? ['q3', yCancel(task)] : ['q1', yFork(action), setTask];
    },
    q3: function q3() {
      return ['q1', yFork(action), setTask];
    }
  }, 'q1', 'takeLatest(' + safeName(patternOrChannel) + ', ' + worker.name + ')');
}
// EXTERNAL MODULE: ../node_modules/redux-saga/es/internal/buffers.js
var buffers = __webpack_require__(36);

// CONCATENATED MODULE: ../node_modules/redux-saga/es/internal/sagaHelpers/throttle.js






function throttle(delayLength, pattern, worker) {
  for (var _len = arguments.length, args = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    args[_key - 3] = arguments[_key];
  }

  var action = void 0,
      channel = void 0;

  var yActionChannel = { done: false, value: Object(io["a" /* actionChannel */])(pattern, buffers["a" /* buffers */].sliding(1)) };
  var yTake = function yTake() {
    return { done: false, value: Object(io["g" /* take */])(channel) };
  };
  var yFork = function yFork(ac) {
    return { done: false, value: io["e" /* fork */].apply(undefined, [worker].concat(args, [ac])) };
  };
  var yDelay = { done: false, value: Object(io["c" /* call */])(utils["j" /* delay */], delayLength) };

  var setAction = function setAction(ac) {
    return action = ac;
  };
  var setChannel = function setChannel(ch) {
    return channel = ch;
  };

  return fsmIterator({
    q1: function q1() {
      return ['q2', yActionChannel, setChannel];
    },
    q2: function q2() {
      return ['q3', yTake(), setAction];
    },
    q3: function q3() {
      return action === internal_channel["a" /* END */] ? [qEnd] : ['q4', yFork(action)];
    },
    q4: function q4() {
      return ['q2', yDelay];
    }
  }, 'q1', 'throttle(' + safeName(pattern) + ', ' + worker.name + ')');
}
// CONCATENATED MODULE: ../node_modules/redux-saga/es/internal/sagaHelpers/index.js
/* unused harmony export takeEvery */
/* unused harmony export takeLatest */
/* unused harmony export throttle */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return takeEvery; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return takeLatest; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "c", function() { return throttle; });






var deprecationWarning = function deprecationWarning(helperName) {
  return 'import { ' + helperName + ' } from \'redux-saga\' has been deprecated in favor of import { ' + helperName + ' } from \'redux-saga/effects\'.\nThe latter will not work with yield*, as helper effects are wrapped automatically for you in fork effect.\nTherefore yield ' + helperName + ' will return task descriptor to your saga and execute next lines of code.';
};

var sagaHelpers_takeEvery = /*#__PURE__*/Object(utils["k" /* deprecate */])(takeEvery, /*#__PURE__*/deprecationWarning('takeEvery'));
var sagaHelpers_takeLatest = /*#__PURE__*/Object(utils["k" /* deprecate */])(takeLatest, /*#__PURE__*/deprecationWarning('takeLatest'));
var sagaHelpers_throttle = /*#__PURE__*/Object(utils["k" /* deprecate */])(throttle, /*#__PURE__*/deprecationWarning('throttle'));



/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../design-system/style-dictionary/build/es6/DSToken.js
var DSToken = __webpack_require__(93);

// CONCATENATED MODULE: ../design-system/style-dictionary/build/es6/DSTokenMap.js
/**
 * Do not edit directly
 * Generated on Thu, 20 Feb 2020 17:25:54 GMT
 */

/* harmony default export */ var DSTokenMap = ({
  BACKGROUND_COLOR_CONTRAST: DSToken["b" /* BACKGROUND_COLOR_CONTRAST */],
  BACKGROUND_COLOR_OVERLAY: DSToken["d" /* BACKGROUND_COLOR_OVERLAY */],
  BACKGROUND_COLOR_OVERLAY_ACCENT: DSToken["e" /* BACKGROUND_COLOR_OVERLAY_ACCENT */],
  BACKGROUND_COLOR_TERTIARY: DSToken["h" /* BACKGROUND_COLOR_TERTIARY */],
  BACKGROUND_COLOR_SECONDARY: DSToken["g" /* BACKGROUND_COLOR_SECONDARY */],
  BACKGROUND_COLOR_PRIMARY: DSToken["f" /* BACKGROUND_COLOR_PRIMARY */],
  BACKGROUND_COLOR_ERROR: DSToken["c" /* BACKGROUND_COLOR_ERROR */],
  BACKGROUND_COLOR_ACCENT: DSToken["a" /* BACKGROUND_COLOR_ACCENT */],
  BORDER_COLOR_PRIMARY: DSToken["k" /* BORDER_COLOR_PRIMARY */],
  BORDER_COLOR_SECONDARY: DSToken["l" /* BORDER_COLOR_SECONDARY */],
  BORDER_COLOR_ERROR: DSToken["i" /* BORDER_COLOR_ERROR */],
  BORDER_COLOR_INPUT_FOCUS: DSToken["j" /* BORDER_COLOR_INPUT_FOCUS */],
  INTERACTIVE_TEXT_COLOR_PRIMARY: DSToken["_15" /* INTERACTIVE_TEXT_COLOR_PRIMARY */],
  INTERACTIVE_TEXT_COLOR_PRIMARY_ACTIVE: DSToken["_16" /* INTERACTIVE_TEXT_COLOR_PRIMARY_ACTIVE */],
  INTERACTIVE_TEXT_COLOR_DISABLED: DSToken["_8" /* INTERACTIVE_TEXT_COLOR_DISABLED */],
  INTERACTIVE_TEXT_COLOR_LINK_PRIMARY: DSToken["_9" /* INTERACTIVE_TEXT_COLOR_LINK_PRIMARY */],
  INTERACTIVE_TEXT_COLOR_LINK_PRIMARY_PRESSED: DSToken["_11" /* INTERACTIVE_TEXT_COLOR_LINK_PRIMARY_PRESSED */],
  INTERACTIVE_TEXT_COLOR_LINK_PRIMARY_INVERSE: DSToken["_10" /* INTERACTIVE_TEXT_COLOR_LINK_PRIMARY_INVERSE */],
  INTERACTIVE_TEXT_COLOR_LINK_SECONDARY: DSToken["_12" /* INTERACTIVE_TEXT_COLOR_LINK_SECONDARY */],
  INTERACTIVE_TEXT_COLOR_LINK_SECONDARY_PRESSED: DSToken["_14" /* INTERACTIVE_TEXT_COLOR_LINK_SECONDARY_PRESSED */],
  INTERACTIVE_TEXT_COLOR_LINK_SECONDARY_INVERSE: DSToken["_13" /* INTERACTIVE_TEXT_COLOR_LINK_SECONDARY_INVERSE */],
  INTERACTIVE_BORDER_COLOR_PRIMARY: DSToken["_5" /* INTERACTIVE_BORDER_COLOR_PRIMARY */],
  INTERACTIVE_BORDER_COLOR_PRIMARY_PRESSED: DSToken["_7" /* INTERACTIVE_BORDER_COLOR_PRIMARY_PRESSED */],
  INTERACTIVE_BORDER_COLOR_PRIMARY_ACTIVE: DSToken["_6" /* INTERACTIVE_BORDER_COLOR_PRIMARY_ACTIVE */],
  INTERACTIVE_BORDER_COLOR_DISABLED: DSToken["_4" /* INTERACTIVE_BORDER_COLOR_DISABLED */],
  INTERACTIVE_BACKGROUND_COLOR_PRIMARY: DSToken["_0" /* INTERACTIVE_BACKGROUND_COLOR_PRIMARY */],
  INTERACTIVE_BACKGROUND_COLOR_PRIMARY_PRESSED: DSToken["_3" /* INTERACTIVE_BACKGROUND_COLOR_PRIMARY_PRESSED */],
  INTERACTIVE_BACKGROUND_COLOR_PRIMARY_ACTIVE: DSToken["_1" /* INTERACTIVE_BACKGROUND_COLOR_PRIMARY_ACTIVE */],
  INTERACTIVE_BACKGROUND_COLOR_PRIMARY_ACTIVE_PRESSED: DSToken["_2" /* INTERACTIVE_BACKGROUND_COLOR_PRIMARY_ACTIVE_PRESSED */],
  INTERACTIVE_BACKGROUND_COLOR_DISABLED: DSToken["Z" /* INTERACTIVE_BACKGROUND_COLOR_DISABLED */],
  SEPARATOR_COLOR_PRIMARY: DSToken["_29" /* SEPARATOR_COLOR_PRIMARY */],
  TEMPORARY_COLOR_BUTTON_TERTIARY_BACKGROUND_PRESSED: DSToken["_43" /* TEMPORARY_COLOR_BUTTON_TERTIARY_BACKGROUND_PRESSED */],
  TEMPORARY_COLOR_BUTTON_DESTRUCTIVE_BACKGROUND_PRESSED: DSToken["_41" /* TEMPORARY_COLOR_BUTTON_DESTRUCTIVE_BACKGROUND_PRESSED */],
  TEMPORARY_COLOR_BUTTON_PRIMARY_DISABLED_BACKGROUND: DSToken["_42" /* TEMPORARY_COLOR_BUTTON_PRIMARY_DISABLED_BACKGROUND */],
  TEXT_COLOR_PRIMARY: DSToken["_57" /* TEXT_COLOR_PRIMARY */],
  TEXT_COLOR_PRIMARY_INVERSE: DSToken["_58" /* TEXT_COLOR_PRIMARY_INVERSE */],
  TEXT_COLOR_SECONDARY: DSToken["_59" /* TEXT_COLOR_SECONDARY */],
  TEXT_COLOR_SECONDARY_INVERSE: DSToken["_60" /* TEXT_COLOR_SECONDARY_INVERSE */],
  TEXT_COLOR_TERTIARY: DSToken["_61" /* TEXT_COLOR_TERTIARY */],
  TEXT_COLOR_TERTIARY_INVERSE: DSToken["_62" /* TEXT_COLOR_TERTIARY_INVERSE */],
  TEXT_COLOR_DISABLED: DSToken["_53" /* TEXT_COLOR_DISABLED */],
  TEXT_COLOR_PLACEHOLDER: DSToken["_55" /* TEXT_COLOR_PLACEHOLDER */],
  TEXT_COLOR_ERROR: DSToken["_54" /* TEXT_COLOR_ERROR */],
  TEXT_COLOR_PRICE: DSToken["_56" /* TEXT_COLOR_PRICE */],
  GRADIENT_BASE: DSToken["n" /* GRADIENT_BASE */],
  GRADIENT_PRIMARY: DSToken["q" /* GRADIENT_PRIMARY */],
  GRADIENT_PRIMARY_PRESSED: DSToken["r" /* GRADIENT_PRIMARY_PRESSED */],
  GRADIENT_DESTRUCTIVE: DSToken["o" /* GRADIENT_DESTRUCTIVE */],
  GRADIENT_DESTRUCTIVE_PRESSED: DSToken["p" /* GRADIENT_DESTRUCTIVE_PRESSED */],
  BORDER_RADIUS: DSToken["m" /* BORDER_RADIUS */],
  SPACE_0X: DSToken["_30" /* SPACE_0X */],
  SPACE_1X: DSToken["_33" /* SPACE_1X */],
  SPACE_2X: DSToken["_35" /* SPACE_2X */],
  SPACE_3X: DSToken["_36" /* SPACE_3X */],
  SPACE_4X: DSToken["_37" /* SPACE_4X */],
  SPACE_5X: DSToken["_38" /* SPACE_5X */],
  SPACE_6X: DSToken["_39" /* SPACE_6X */],
  SPACE_8X: DSToken["_40" /* SPACE_8X */],
  SPACE_12X: DSToken["_31" /* SPACE_12X */],
  SPACE_16X: DSToken["_32" /* SPACE_16X */],
  SPACE_24X: DSToken["_34" /* SPACE_24X */],
  HEADING_100_FONT_FAMILY: DSToken["s" /* HEADING_100_FONT_FAMILY */],
  HEADING_100_FONT_SIZE: DSToken["t" /* HEADING_100_FONT_SIZE */],
  HEADING_100_FONT_WEIGHT: DSToken["u" /* HEADING_100_FONT_WEIGHT */],
  HEADING_100_LINE_HEIGHT: DSToken["v" /* HEADING_100_LINE_HEIGHT */],
  HEADING_100_MARGIN_BOTTOM: DSToken["w" /* HEADING_100_MARGIN_BOTTOM */],
  HEADING_200_FONT_FAMILY: DSToken["x" /* HEADING_200_FONT_FAMILY */],
  HEADING_200_FONT_SIZE: DSToken["y" /* HEADING_200_FONT_SIZE */],
  HEADING_200_FONT_WEIGHT: DSToken["z" /* HEADING_200_FONT_WEIGHT */],
  HEADING_200_LINE_HEIGHT: DSToken["A" /* HEADING_200_LINE_HEIGHT */],
  HEADING_200_MARGIN_BOTTOM: DSToken["B" /* HEADING_200_MARGIN_BOTTOM */],
  HEADING_300_FONT_FAMILY: DSToken["C" /* HEADING_300_FONT_FAMILY */],
  HEADING_300_FONT_SIZE: DSToken["D" /* HEADING_300_FONT_SIZE */],
  HEADING_300_FONT_WEIGHT: DSToken["E" /* HEADING_300_FONT_WEIGHT */],
  HEADING_300_LINE_HEIGHT: DSToken["F" /* HEADING_300_LINE_HEIGHT */],
  HEADING_300_MARGIN_BOTTOM: DSToken["G" /* HEADING_300_MARGIN_BOTTOM */],
  HEADING_400_FONT_FAMILY: DSToken["H" /* HEADING_400_FONT_FAMILY */],
  HEADING_400_FONT_SIZE: DSToken["I" /* HEADING_400_FONT_SIZE */],
  HEADING_400_FONT_WEIGHT: DSToken["J" /* HEADING_400_FONT_WEIGHT */],
  HEADING_400_LINE_HEIGHT: DSToken["K" /* HEADING_400_LINE_HEIGHT */],
  HEADING_400_MARGIN_BOTTOM: DSToken["L" /* HEADING_400_MARGIN_BOTTOM */],
  HEADING_500_FONT_FAMILY: DSToken["M" /* HEADING_500_FONT_FAMILY */],
  HEADING_500_FONT_SIZE: DSToken["N" /* HEADING_500_FONT_SIZE */],
  HEADING_500_FONT_WEIGHT: DSToken["O" /* HEADING_500_FONT_WEIGHT */],
  HEADING_500_LINE_HEIGHT: DSToken["P" /* HEADING_500_LINE_HEIGHT */],
  HEADING_500_MARGIN_BOTTOM: DSToken["Q" /* HEADING_500_MARGIN_BOTTOM */],
  HEADING_600_FONT_FAMILY: DSToken["R" /* HEADING_600_FONT_FAMILY */],
  HEADING_600_FONT_SIZE: DSToken["S" /* HEADING_600_FONT_SIZE */],
  HEADING_600_FONT_WEIGHT: DSToken["T" /* HEADING_600_FONT_WEIGHT */],
  HEADING_600_LINE_HEIGHT: DSToken["U" /* HEADING_600_LINE_HEIGHT */],
  HEADING_600_MARGIN_BOTTOM: DSToken["V" /* HEADING_600_MARGIN_BOTTOM */],
  HEADING_RESPONSIVE_400_FONT_SIZE: DSToken["W" /* HEADING_RESPONSIVE_400_FONT_SIZE */],
  HEADING_RESPONSIVE_500_FONT_SIZE: DSToken["X" /* HEADING_RESPONSIVE_500_FONT_SIZE */],
  HEADING_RESPONSIVE_600_FONT_SIZE: DSToken["Y" /* HEADING_RESPONSIVE_600_FONT_SIZE */],
  PARAGRAPH_100_FONT_SIZE: DSToken["_17" /* PARAGRAPH_100_FONT_SIZE */],
  PARAGRAPH_100_FONT_WEIGHT: DSToken["_18" /* PARAGRAPH_100_FONT_WEIGHT */],
  PARAGRAPH_100_LINE_HEIGHT: DSToken["_19" /* PARAGRAPH_100_LINE_HEIGHT */],
  PARAGRAPH_100_MARGIN_BOTTOM: DSToken["_20" /* PARAGRAPH_100_MARGIN_BOTTOM */],
  PARAGRAPH_200_FONT_SIZE: DSToken["_21" /* PARAGRAPH_200_FONT_SIZE */],
  PARAGRAPH_200_FONT_WEIGHT: DSToken["_22" /* PARAGRAPH_200_FONT_WEIGHT */],
  PARAGRAPH_200_LINE_HEIGHT: DSToken["_23" /* PARAGRAPH_200_LINE_HEIGHT */],
  PARAGRAPH_200_MARGIN_BOTTOM: DSToken["_24" /* PARAGRAPH_200_MARGIN_BOTTOM */],
  PARAGRAPH_300_FONT_SIZE: DSToken["_25" /* PARAGRAPH_300_FONT_SIZE */],
  PARAGRAPH_300_FONT_WEIGHT: DSToken["_26" /* PARAGRAPH_300_FONT_WEIGHT */],
  PARAGRAPH_300_LINE_HEIGHT: DSToken["_27" /* PARAGRAPH_300_LINE_HEIGHT */],
  PARAGRAPH_300_MARGIN_BOTTOM: DSToken["_28" /* PARAGRAPH_300_MARGIN_BOTTOM */],
  TEXT_100_FONT_SIZE: DSToken["_44" /* TEXT_100_FONT_SIZE */],
  TEXT_100_FONT_WEIGHT: DSToken["_45" /* TEXT_100_FONT_WEIGHT */],
  TEXT_100_LINE_HEIGHT: DSToken["_46" /* TEXT_100_LINE_HEIGHT */],
  TEXT_200_FONT_SIZE: DSToken["_47" /* TEXT_200_FONT_SIZE */],
  TEXT_200_FONT_WEIGHT: DSToken["_48" /* TEXT_200_FONT_WEIGHT */],
  TEXT_200_LINE_HEIGHT: DSToken["_49" /* TEXT_200_LINE_HEIGHT */],
  TEXT_300_FONT_SIZE: DSToken["_50" /* TEXT_300_FONT_SIZE */],
  TEXT_300_FONT_WEIGHT: DSToken["_51" /* TEXT_300_FONT_WEIGHT */],
  TEXT_300_LINE_HEIGHT: DSToken["_52" /* TEXT_300_LINE_HEIGHT */]
});
// EXTERNAL MODULE: ../design-system/style-dictionary/build/es6/Color.js
var Color = __webpack_require__(101);

// CONCATENATED MODULE: ../design-system/index.js
/* unused concated harmony import DSToken */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return DSToken; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return DSTokenMap; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return Color["a" /* default */]; });





/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Color; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__react_lib_src_types_Enum__ = __webpack_require__(6);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * Do not edit directly
 * Generated on Thu, 20 Feb 2020 17:25:54 GMT
 */


var Color =
/*#__PURE__*/
function (_Enum) {
  _inherits(Color, _Enum);

  function Color() {
    _classCallCheck(this, Color);

    return _possibleConstructorReturn(this, _getPrototypeOf(Color).apply(this, arguments));
  }

  _createClass(Color, [{
    key: "toString",
    value: function toString() {
      var _this$value$rgba = this.value.rgba,
          r = _this$value$rgba.r,
          g = _this$value$rgba.g,
          b = _this$value$rgba.b,
          a = _this$value$rgba.a;
      return "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(a, ")");
    }
  }, {
    key: "toTestString",
    value: function toTestString() {
      return this.toString().replace(/\s/g, '');
    }
  }, {
    key: "toHexString",
    value: function toHexString() {
      return this.value.hex;
    }
  }, {
    key: "withOpacity",
    value: function withOpacity(opacity) {
      var _this$value$rgba2 = this.value.rgba,
          r = _this$value$rgba2.r,
          g = _this$value$rgba2.g,
          b = _this$value$rgba2.b;
      return "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(opacity, ")");
    }
  }]);

  return Color;
}(__WEBPACK_IMPORTED_MODULE_0__react_lib_src_types_Enum__["a" /* default */]);

Color.NEUTRAL_12 = new Color({
  name: 'NEUTRAL_12',
  rgba: {
    r: 27,
    g: 31,
    b: 35,
    a: 1
  },
  hex: '#1B1F23',
  whiteTextContrastRating: 'AAA'
});
Color.NEUTRAL_28 = new Color({
  name: 'NEUTRAL_28',
  rgba: {
    r: 64,
    g: 72,
    b: 79,
    a: 1
  },
  hex: '#40484F',
  whiteTextContrastRating: 'AAA'
});
Color.NEUTRAL_44 = new Color({
  name: 'NEUTRAL_44',
  rgba: {
    r: 102,
    g: 114,
    b: 124,
    a: 1
  },
  hex: '#66727C',
  blackTextContrastRating: '•AA',
  whiteTextContrastRating: 'AA'
});
Color.NEUTRAL_56 = new Color({
  name: 'NEUTRAL_56',
  rgba: {
    r: 132,
    g: 144,
    b: 154,
    a: 1
  },
  hex: '#84909A',
  blackTextContrastRating: 'AA',
  whiteTextContrastRating: '•AA'
});
Color.NEUTRAL_84 = new Color({
  name: 'NEUTRAL_84',
  rgba: {
    r: 207,
    g: 215,
    b: 222,
    a: 1
  },
  hex: '#CFD7DE',
  blackTextContrastRating: 'AAA'
});
Color.NEUTRAL_88 = new Color({
  name: 'NEUTRAL_88',
  rgba: {
    r: 220,
    g: 225,
    b: 229,
    a: 1
  },
  hex: '#DCE1E5',
  blackTextContrastRating: 'AAA'
});
Color.NEUTRAL_92 = new Color({
  name: 'NEUTRAL_92',
  rgba: {
    r: 232,
    g: 235,
    b: 237,
    a: 1
  },
  hex: '#E8EBED',
  blackTextContrastRating: 'AAA'
});
Color.NEUTRAL_96 = new Color({
  name: 'NEUTRAL_96',
  rgba: {
    r: 244,
    g: 245,
    b: 246,
    a: 1
  },
  hex: '#F4F5F6',
  blackTextContrastRating: 'AAA'
});
Color.NEUTRAL_100 = new Color({
  name: 'NEUTRAL_100',
  rgba: {
    r: 255,
    g: 255,
    b: 255,
    a: 1
  },
  hex: '#FFFFFF',
  blackTextContrastRating: 'AAA'
});
Color.GREEN_24 = new Color({
  name: 'GREEN_24',
  rgba: {
    r: 0,
    g: 121,
    b: 72,
    a: 1
  },
  hex: '#007948',
  blackTextContrastRating: '•AA',
  whiteTextContrastRating: 'AA'
});
Color.GREEN_28 = new Color({
  name: 'GREEN_28',
  rgba: {
    r: 9,
    g: 136,
    b: 85,
    a: 1
  },
  hex: '#098855',
  blackTextContrastRating: '•AA',
  whiteTextContrastRating: '•AA'
});
Color.GREEN_70 = new Color({
  name: 'GREEN_70',
  rgba: {
    r: 113,
    g: 244,
    b: 191,
    a: 1
  },
  hex: '#71F4BF',
  blackTextContrastRating: 'AAA'
});
Color.GREEN_96 = new Color({
  name: 'GREEN_96',
  rgba: {
    r: 236,
    g: 254,
    b: 247,
    a: 1
  },
  hex: '#ECFEF7',
  blackTextContrastRating: 'AAA'
});
Color.GREEN_BASE = new Color({
  name: 'GREEN_BASE',
  rgba: {
    r: 20,
    g: 169,
    b: 109,
    a: 1
  },
  hex: '#14A96D',
  blackTextContrastRating: 'AA'
});
Color.BLUE_28 = new Color({
  name: 'BLUE_28',
  rgba: {
    r: 6,
    g: 116,
    b: 138,
    a: 1
  },
  hex: '#06748A',
  blackTextContrastRating: '•AA',
  whiteTextContrastRating: 'AA'
});
Color.BLUE_32 = new Color({
  name: 'BLUE_32',
  rgba: {
    r: 2,
    g: 129,
    b: 162,
    a: 1
  },
  hex: '#0281A2',
  blackTextContrastRating: '•AA',
  whiteTextContrastRating: 'AA'
});
Color.BLUE_70 = new Color({
  name: 'BLUE_70',
  rgba: {
    r: 125,
    g: 211,
    b: 232,
    a: 1
  },
  hex: '#7DD3E8',
  blackTextContrastRating: 'AAA'
});
Color.BLUE_96 = new Color({
  name: 'BLUE_96',
  rgba: {
    r: 236,
    g: 251,
    b: 254,
    a: 1
  },
  hex: '#ECFBFE',
  blackTextContrastRating: 'AAA'
});
Color.BLUE_BASE = new Color({
  name: 'BLUE_BASE',
  rgba: {
    r: 22,
    g: 162,
    b: 187,
    a: 1
  },
  hex: '#16A2BB',
  blackTextContrastRating: 'AA',
  whiteTextContrastRating: '•AA'
});
Color.PURPLE_40 = new Color({
  name: 'PURPLE_40',
  rgba: {
    r: 80,
    g: 75,
    b: 180,
    a: 1
  },
  hex: '#504BB4',
  whiteTextContrastRating: 'AA'
});
Color.PURPLE_70 = new Color({
  name: 'PURPLE_70',
  rgba: {
    r: 138,
    g: 133,
    b: 224,
    a: 1
  },
  hex: '#8A85E0',
  blackTextContrastRating: 'AA'
});
Color.PURPLE_96 = new Color({
  name: 'PURPLE_96',
  rgba: {
    r: 236,
    g: 236,
    b: 254,
    a: 1
  },
  hex: '#ECECFE',
  blackTextContrastRating: 'AAA'
});
Color.PURPLE_BASE = new Color({
  name: 'PURPLE_BASE',
  rgba: {
    r: 105,
    g: 100,
    b: 189,
    a: 1
  },
  hex: '#6964BD',
  blackTextContrastRating: '•AA',
  whiteTextContrastRating: 'AA'
});
Color.RED_40 = new Color({
  name: 'RED_40',
  rgba: {
    r: 194,
    g: 10,
    b: 47,
    a: 1
  },
  hex: '#C20A2F',
  whiteTextContrastRating: 'AA'
});
Color.RED_70 = new Color({
  name: 'RED_70',
  rgba: {
    r: 252,
    g: 105,
    b: 123,
    a: 1
  },
  hex: '#FC697B',
  blackTextContrastRating: 'AA'
});
Color.RED_96 = new Color({
  name: 'RED_96',
  rgba: {
    r: 254,
    g: 236,
    b: 238,
    a: 1
  },
  hex: '#FEECEE',
  blackTextContrastRating: 'AAA'
});
Color.RED_BASE = new Color({
  name: 'RED_BASE',
  rgba: {
    r: 229,
    g: 26,
    b: 66,
    a: 1
  },
  hex: '#E51A42',
  blackTextContrastRating: '•AA',
  whiteTextContrastRating: 'AA'
});
Color.ORANGE_40 = new Color({
  name: 'ORANGE_40',
  rgba: {
    r: 204,
    g: 78,
    b: 0,
    a: 1
  },
  hex: '#CC4E00',
  blackTextContrastRating: '•AA',
  whiteTextContrastRating: 'AA'
});
Color.ORANGE_70 = new Color({
  name: 'ORANGE_70',
  rgba: {
    r: 255,
    g: 161,
    b: 102,
    a: 1
  },
  hex: '#FFA166',
  blackTextContrastRating: 'AAA'
});
Color.ORANGE_96 = new Color({
  name: 'ORANGE_96',
  rgba: {
    r: 254,
    g: 243,
    b: 236,
    a: 1
  },
  hex: '#FEF3EC',
  blackTextContrastRating: 'AAA'
});
Color.ORANGE_BASE = new Color({
  name: 'ORANGE_BASE',
  rgba: {
    r: 255,
    g: 129,
    b: 51,
    a: 1
  },
  hex: '#FF8133',
  blackTextContrastRating: 'AA'
});
Color.YELLOW_28 = new Color({
  name: 'YELLOW_28',
  rgba: {
    r: 140,
    g: 108,
    b: 5,
    a: 1
  },
  hex: '#8C6C05',
  blackTextContrastRating: '•AA',
  whiteTextContrastRating: 'AA'
});
Color.YELLOW_70 = new Color({
  name: 'YELLOW_70',
  rgba: {
    r: 247,
    g: 217,
    b: 110,
    a: 1
  },
  hex: '#F7D96E',
  blackTextContrastRating: 'AAA'
});
Color.YELLOW_96 = new Color({
  name: 'YELLOW_96',
  rgba: {
    r: 254,
    g: 250,
    b: 236,
    a: 1
  },
  hex: '#FEFAEC',
  blackTextContrastRating: 'AAA'
});
Color.YELLOW_BASE = new Color({
  name: 'YELLOW_BASE',
  rgba: {
    r: 255,
    g: 207,
    b: 51,
    a: 1
  },
  hex: '#FFCF33',
  blackTextContrastRating: 'AAA'
});
Color.BRAND_ROVER = new Color({
  name: 'BRAND_ROVER',
  rgba: {
    r: 0,
    g: 189,
    b: 112,
    a: 1
  },
  hex: '#00BD70',
  blackTextContrastRating: 'AA'
});
Color.BRAND_DOGBUDDY = new Color({
  name: 'BRAND_DOGBUDDY',
  rgba: {
    r: 255,
    g: 90,
    b: 91,
    a: 1
  },
  hex: '#FF5A5B',
  blackTextContrastRating: 'AA',
  whiteTextContrastRating: '•AA'
});
Color.BRAND_FACEBOOK = new Color({
  name: 'BRAND_FACEBOOK',
  rgba: {
    r: 59,
    g: 89,
    b: 152,
    a: 1
  },
  hex: '#3B5998',
  whiteTextContrastRating: 'AA'
});
Color.BRAND_INSTAGRAM = new Color({
  name: 'BRAND_INSTAGRAM',
  rgba: {
    r: 138,
    g: 58,
    b: 185,
    a: 1
  },
  hex: '#8A3AB9',
  whiteTextContrastRating: 'AA'
});
Color.BRAND_TWITTER = new Color({
  name: 'BRAND_TWITTER',
  rgba: {
    r: 29,
    g: 161,
    b: 242,
    a: 1
  },
  hex: '#1DA1F2',
  blackTextContrastRating: 'AA'
});
Color.BRAND_PINTEREST = new Color({
  name: 'BRAND_PINTEREST',
  rgba: {
    r: 200,
    g: 35,
    b: 44,
    a: 1
  },
  hex: '#C8232C',
  whiteTextContrastRating: 'AA'
});
Color.BRAND_GOOGLE = new Color({
  name: 'BRAND_GOOGLE',
  rgba: {
    r: 221,
    g: 75,
    b: 57,
    a: 1
  },
  hex: '#DD4B39',
  blackTextContrastRating: '•AA',
  whiteTextContrastRating: '•AA'
});
Color.isLocked = true;


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
function _interopDefault(e){return e&&"object"==typeof e&&"default"in e?e.default:e}Object.defineProperty(exports,"__esModule",{value:!0});var React=_interopDefault(__webpack_require__(0));function AppContainer(e){return AppContainer.warnAboutHMRDisabled&&(AppContainer.warnAboutHMRDisabled=!0,console.error("React-Hot-Loader: misconfiguration detected, using production version in non-production environment."),console.error("React-Hot-Loader: Hot Module Replacement is not enabled.")),React.Children.only(e.children)}AppContainer.warnAboutHMRDisabled=!1;var hot=function e(){return e.shouldWrapWithAppContainer?function(e){return function(n){return React.createElement(AppContainer,null,React.createElement(e,n))}}:function(e){return e}};hot.shouldWrapWithAppContainer=!1;var areComponentsEqual=function(e,n){return e===n},setConfig=function(){},cold=function(e){return e},configureComponent=function(){};exports.AppContainer=AppContainer,exports.hot=hot,exports.areComponentsEqual=areComponentsEqual,exports.setConfig=setConfig,exports.cold=cold,exports.configureComponent=configureComponent;


/***/ }),
/* 104 */,
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(360);

// CONCATENATED MODULE: ../node_modules/resolve-pathname/index.js
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var toParts = to && to.split('/') || [];
  var fromParts = from && from.split('/') || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash = void 0;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) {
    fromParts.unshift('..');
  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ var resolve_pathname = (resolvePathname);
// CONCATENATED MODULE: ../node_modules/value-equal/index.js
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function valueEqual(a, b) {
  if (a === b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return valueEqual(item, b[index]);
    });
  }

  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (aType !== bType) return false;

  if (aType === 'object') {
    var aValue = a.valueOf();
    var bValue = b.valueOf();

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);

    if (aKeys.length !== bKeys.length) return false;

    return aKeys.every(function (key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ var value_equal = (valueEqual);
// CONCATENATED MODULE: ../node_modules/tiny-warning/dist/tiny-warning.esm.js
var isProduction = "production" === 'production';
function tiny_warning_esm_warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

/* harmony default export */ var tiny_warning_esm = (tiny_warning_esm_warning);

// CONCATENATED MODULE: ../node_modules/tiny-invariant/dist/tiny-invariant.esm.js
var tiny_invariant_esm_isProduction = "production" === 'production';
var prefix = 'Invariant failed';
function tiny_invariant_esm_invariant(condition, message) {
  if (condition) {
    return;
  }

  if (tiny_invariant_esm_isProduction) {
    throw new Error(prefix);
  } else {
    throw new Error(prefix + ": " + (message || ''));
  }
}

/* harmony default export */ var tiny_invariant_esm = (tiny_invariant_esm_invariant);

// CONCATENATED MODULE: ../node_modules/history/esm/history.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createBrowserHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createHashHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createMemoryHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return locationsAreEqual; });
/* unused harmony export parsePath */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createPath; });






function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
}
function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
}
function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
}
function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';
  var hashIndex = pathname.indexOf('#');

  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');

  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
}
function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;
  var path = pathname || '/';
  if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
  return path;
}

function createLocation(path, state, key, currentLocation) {
  var location;

  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = parsePath(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = Object(esm_extends["a" /* default */])({}, path);
    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = resolve_pathname(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
}
function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && value_equal(a.state, b.state);
}

function createTransitionManager() {
  var prompt = null;

  function setPrompt(nextPrompt) {
     false ? warning(prompt == null, 'A history supports only one prompt at a time') : void 0;
    prompt = nextPrompt;
    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  }

  function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
           false ? warning(false, 'A history needs a getUserConfirmation function in order to use a prompt message') : void 0;
          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  }

  var listeners = [];

  function appendListener(fn) {
    var isActive = true;

    function listener() {
      if (isActive) fn.apply(void 0, arguments);
    }

    listeners.push(listener);
    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  }

  function notifyListeners() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(void 0, args);
    });
  }

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function getConfirmation(message, callback) {
  callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */

function supportsHistory() {
  var ua = window.navigator.userAgent;
  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
  return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */

function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */

function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */

function isExtraneousPopstateEvent(event) {
  event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */


function createBrowserHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Browser history needs a DOM') : tiny_invariant_esm(false) : void 0;
  var globalHistory = window.history;
  var canUseHistory = supportsHistory();
  var needsHashChangeListener = !supportsPopStateOnHashChange();
  var _props = props,
      _props$forceRefresh = _props.forceRefresh,
      forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';

  function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;
    var path = pathname + search + hash;
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path, state, key);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(esm_extends["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (isExtraneousPopstateEvent(event)) return;
    handlePop(getDOMLocation(event.state));
  }

  function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  }

  var forceNextPop = false;

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allKeys.indexOf(fromLocation.key);
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  }

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key]; // Public interface

  function createHref(location) {
    return basename + createPath(location);
  }

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.pushState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
          nextKeys.push(location.key);
          allKeys = nextKeys;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history') : void 0;
        window.location.href = href;
      }
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.replaceState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history') : void 0;
        window.location.replace(href);
      }
    });
  }

  function go(n) {
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.addEventListener(HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.removeEventListener(HashChangeEvent, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

var HashChangeEvent$1 = 'hashchange';
var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + stripLeadingSlash(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: stripLeadingSlash,
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}

function pushHashPath(path) {
  window.location.hash = path;
}

function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');
  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
}

function createHashHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Hash history needs a DOM') : tiny_invariant_esm(false) : void 0;
  var globalHistory = window.history;
  var canGoWithoutReload = supportsGoWithoutReloadUsingHash();
  var _props = props,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$hashType = _props.hashType,
      hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;

  function getDOMLocation() {
    var path = decodePath(getHashPath());
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(esm_extends["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  var forceNextPop = false;
  var ignorePath = null;

  function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;
      if (!forceNextPop && locationsAreEqual(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;
      handlePop(location);
    }
  }

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(createPath(toLocation));
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  } // Ensure the hash is encoded properly before doing anything else.


  var path = getHashPath();
  var encodedPath = encodePath(path);
  if (path !== encodedPath) replaceHashPath(encodedPath);
  var initialLocation = getDOMLocation();
  var allPaths = [createPath(initialLocation)]; // Public interface

  function createHref(location) {
    return '#' + encodePath(basename + createPath(location));
  }

  function push(path, state) {
     false ? warning(state === undefined, 'Hash history cannot push state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);
        var prevIndex = allPaths.lastIndexOf(createPath(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
        nextPaths.push(path);
        allPaths = nextPaths;
        setState({
          action: action,
          location: location
        });
      } else {
         false ? warning(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack') : void 0;
        setState();
      }
    });
  }

  function replace(path, state) {
     false ? warning(state === undefined, 'Hash history cannot replace state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(createPath(history.location));
      if (prevIndex !== -1) allPaths[prevIndex] = path;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
     false ? warning(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(HashChangeEvent$1, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(HashChangeEvent$1, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */


function createMemoryHistory(props) {
  if (props === void 0) {
    props = {};
  }

  var _props = props,
      getUserConfirmation = _props.getUserConfirmation,
      _props$initialEntries = _props.initialEntries,
      initialEntries = _props$initialEntries === void 0 ? ['/'] : _props$initialEntries,
      _props$initialIndex = _props.initialIndex,
      initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(esm_extends["a" /* default */])(history, nextState);

    history.length = history.entries.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? createLocation(entry, undefined, createKey()) : createLocation(entry, undefined, entry.key || createKey());
  }); // Public interface

  var createHref = createPath;

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;
      var nextEntries = history.entries.slice(0);

      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      history.entries[history.index] = location;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
    var action = 'POP';
    var location = history.entries[nextIndex];
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  }

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    return transitionManager.setPrompt(prompt);
  }

  function listen(listener) {
    return transitionManager.appendListener(listener);
  }

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };
  return history;
}




/***/ }),
/* 106 */,
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FORM_ERROR_CLASSNAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ALERT_CLASSNAME; });
var FORM_ERROR_CLASSNAME = 'error-field'; // for scroll on error

var ALERT_CLASSNAME = 'alert'; // for scroll on error

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(1);

// EXTERNAL MODULE: ../node_modules/prop-types/index.js
var prop_types = __webpack_require__(4);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// EXTERNAL MODULE: ../node_modules/react-popper/lib/react-popper.js
var react_popper = __webpack_require__(230);
var react_popper_default = /*#__PURE__*/__webpack_require__.n(react_popper);

// EXTERNAL MODULE: ../node_modules/react-transition-group/Transition.js
var Transition = __webpack_require__(236);
var Transition_default = /*#__PURE__*/__webpack_require__.n(Transition);

// EXTERNAL MODULE: ../utilities/userAgent.js
var userAgent = __webpack_require__(60);

// EXTERNAL MODULE: ../react-lib/src/styles/index.js + 3 modules
var styles = __webpack_require__(2);

// EXTERNAL MODULE: ../react-lib/src/components/callouts/Popover/popover.constants.js
var popover_constants = __webpack_require__(131);

// EXTERNAL MODULE: ../react-lib/src/styles/ZIndex.js
var ZIndex = __webpack_require__(78);

// CONCATENATED MODULE: ../react-lib/src/components/callouts/Popover/StyledPopover.jsx



var TRANSITION_DURATION = 150;
var StyledPopover = styled_components_browser_esm["default"].div.withConfig({
  displayName: "StyledPopover",
  componentId: "sc-1q65y5p-0"
})(["transition:opacity ", "ms linear;opacity:", ";background-color:", ";text-align:left;border:1px solid ", ";border-radius:4px;box-shadow:0 5px 10px rgba(0,0,0,0.2);padding:8px;z-index:", ";max-width:450px;visibility:", ";", ";"], TRANSITION_DURATION, function (props) {
  return props.transitionState === 'entered' ? 1 : 0;
}, function (props) {
  return props.backgroundColor ? props.backgroundColor.toString() : '';
}, function (props) {
  return props.borderColor ? props.borderColor.toString() : '';
}, ZIndex["a" /* default */].POPOVER, function (_ref) {
  var isOutOfBoundaries = _ref.isOutOfBoundaries;
  return isOutOfBoundaries ? 'hidden' : 'inherit';
}, function (_ref2) {
  var showArrow = _ref2.showArrow,
      arrowStyle = _ref2.arrowStyle,
      borderColor = _ref2.borderColor,
      backgroundColor = _ref2.backgroundColor;
  return !showArrow ? '' : Object(styled_components_browser_esm["css"])(["&:before,&:after{border:1px solid ", ";border:solid transparent;content:' ';height:0;width:0;position:absolute;pointer-events:none;}&:after{border-color:rgba(255,255,255,0);border-width:8px;}&:before{border-color:rgba(204,204,204,0);border-width:9px;}&[data-placement='bottom']{margin-top:8px;&:before,&:after{bottom:100%;left:", "px;}&:after{border-bottom-color:", ";margin-left:-8px;}&:before{border-bottom-color:", ";margin-left:-9px;}}&[data-placement='top']{margin-bottom:8px;&:before,&:after{top:100%;left:", "px;}&:after{border-top-color:", ";margin-left:-8px;}&:before{border-top-color:", ";margin-left:-9px;}}&[data-placement='right']{margin-left:8px;&:before,&:after{right:100%;top:", "px;}&:after{border-right-color:", ";margin-bottom:-8px;}&:before{border-right-color:", ";margin-bottom:-9px;}}&[data-placement='left']{margin-right:8px;&:before,&:after{left:100%;top:", "px;}&:after{border-left-color:", ";margin-top:-8px;}&:before{border-left-color:", ";margin-top:-9px;}}"], borderColor ? borderColor.toString() : '', arrowStyle.left, backgroundColor ? backgroundColor.toString() : '', borderColor ? borderColor.toString() : '', arrowStyle.left, backgroundColor ? backgroundColor.toString() : '', borderColor ? borderColor.toString() : '', arrowStyle.top, backgroundColor ? backgroundColor.toString() : '', borderColor ? borderColor.toString() : '', arrowStyle.top, backgroundColor ? backgroundColor.toString() : '', borderColor ? borderColor.toString() : '');
});
/* harmony default export */ var Popover_StyledPopover = (StyledPopover);
// CONCATENATED MODULE: ../react-lib/src/components/callouts/Popover/TargetWrapper.jsx
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }




var StyledTargetWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "TargetWrapper__StyledTargetWrapper",
  componentId: "sc-1unqb61-0"
})(["width:100%;display:", ";cursor:", ";"], function (props) {
  return props.display;
}, function (props) {
  return props.event === popover_constants["a" /* PopoverEvent */].CLICK ? 'pointer' : 'default';
});

var TargetWrapper_TargetWrapper = function TargetWrapper(_ref) {
  var innerRef = _ref.innerRef,
      other = _objectWithoutProperties(_ref, ["innerRef"]);

  return react_default.a.createElement(StyledTargetWrapper, _extends({}, other, {
    ref: innerRef
  }));
};

/* harmony default export */ var Popover_TargetWrapper = (TargetWrapper_TargetWrapper);
// CONCATENATED MODULE: ../react-lib/src/components/callouts/Popover/Popover.jsx
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function Popover__extends() { Popover__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Popover__extends.apply(this, arguments); }

function Popover__objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = Popover__objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function Popover__objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }











var MOUSE_LEAVE_DELAY = 100;

var Popover_PopoverArrowContext = function PopoverArrowContext(_ref, _ref2) {
  var innerRef = _ref.innerRef,
      other = Popover__objectWithoutProperties(_ref, ["innerRef"]);

  var popper = _ref2.popper;
  return react_default.a.createElement(Popover_StyledPopover, Popover__extends({
    arrowStyle: popper.getArrowStyle()
  }, other, {
    ref: innerRef
  }));
};

Popover_PopoverArrowContext.contextTypes = {
  popper: prop_types_default.a.object.isRequired
};
var ContentWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Popover__ContentWrapper",
  componentId: "fs0mjx-0"
})(["background:rgba(0,0,0,0);-webkit-font-smoothing:antialiased;max-width:calc(100vw - 60px);"]);
var StyledArrow = Object(styled_components_browser_esm["default"])(react_popper["Arrow"]).withConfig({
  displayName: "Popover__StyledArrow",
  componentId: "fs0mjx-1"
})(["position:absolute;"]);

var Popover_Popover =
/*#__PURE__*/
function (_Component) {
  _inherits(Popover, _Component);

  function Popover() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Popover);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Popover)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.removeListener = void 0;
    _this.clearTimeout = void 0;
    _this.timeout = void 0;
    _this.popover = void 0;
    _this.state = {
      open: false
    };

    _this.handleOpen = function () {
      var _this$props = _this.props,
          event = _this$props.event,
          onChange = _this$props.onChange;

      if (event !== popover_constants["a" /* PopoverEvent */].NONE) {
        if (onChange) onChange(true);

        _this.setState(function () {
          return {
            open: true
          };
        });
      }
    };

    _this.handleClose = function () {
      var _this$props2 = _this.props,
          event = _this$props2.event,
          onChange = _this$props2.onChange;

      if (event !== popover_constants["a" /* PopoverEvent */].NONE) {
        if (onChange) onChange(false);

        _this.setState(function () {
          return {
            open: false
          };
        });
      }
    };

    _this.handleToggle = function () {
      var _this$props3 = _this.props,
          event = _this$props3.event,
          onChange = _this$props3.onChange;

      if (event !== popover_constants["a" /* PopoverEvent */].NONE) {
        _this.setState(function (state) {
          if (onChange) onChange(!state.open);
          return {
            open: !state.open
          };
        });
      }
    };

    _this.isOpen = function () {
      return _this.props.event === popover_constants["a" /* PopoverEvent */].NONE ? _this.props.open : _this.state.open;
    };

    _this.clearTimeout = function () {
      if (_this.timeout) {
        clearTimeout(_this.timeout);
        _this.timeout = undefined;
      }
    };

    _this.handleOutsideClick = function (event) {
      if (_this.popover && !_this.popover.contains(event.target)) {
        _this.handleClose();
      }
    };

    _this.handleClick = function () {
      var event = _this.props.event;

      if (event === popover_constants["a" /* PopoverEvent */].CLICK || !Object(userAgent["c" /* isHoverable */])()) {
        _this.handleToggle();

        if (!_this.isOpen()) {
          setTimeout(function () {
            document.addEventListener('click', _this.handleOutsideClick, false);
          }, 0);

          _this.removeListener = function () {
            return document.removeEventListener('click', _this.handleOutsideClick, false);
          };
        }
      }
    };

    _this.handleMouseEnter = function () {
      var event = _this.props.event;

      if (event === popover_constants["a" /* PopoverEvent */].HOVER && Object(userAgent["c" /* isHoverable */])()) {
        _this.clearTimeout();

        _this.handleOpen();
      }
    };

    _this.handleMouseLeave = function () {
      var event = _this.props.event;

      if (event === popover_constants["a" /* PopoverEvent */].HOVER && Object(userAgent["c" /* isHoverable */])()) {
        _this.clearTimeout();

        _this.timeout = setTimeout(function () {
          _this.handleClose();

          _this.timeout = undefined;
        }, MOUSE_LEAVE_DELAY);
      }
    };

    _this.renderContent = function () {
      var content = _this.props.content;

      if (typeof content === 'function') {
        return content({
          onClose: _this.handleClose
        });
      }

      return content;
    };

    return _this;
  }

  _createClass(Popover, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (!this.isOpen() && this.removeListener) {
        this.removeListener();
        this.removeListener = undefined;
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.clearTimeout();

      if (this.removeListener) {
        this.removeListener();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props4 = this.props,
          children = _this$props4.children,
          content = _this$props4.content,
          placement = _this$props4.placement,
          event = _this$props4.event,
          open = _this$props4.open,
          display = _this$props4.display,
          other = Popover__objectWithoutProperties(_this$props4, ["children", "content", "placement", "event", "open", "display"]);

      return react_default.a.createElement(react_popper["Manager"], {
        tag: display === 'inline' ? 'span' : 'div'
      }, react_default.a.createElement(react_popper["Target"], {
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseLeave,
        onClick: this.handleClick,
        component: Popover_TargetWrapper,
        event: event,
        display: display
      }, children), react_default.a.createElement(Transition_default.a, {
        "in": this.isOpen(),
        timeout: TRANSITION_DURATION,
        unmountOnExit: true
      }, function (state) {
        return react_default.a.createElement(react_popper["Popper"], {
          placement: placement.toString(),
          modifiers: {
            offset: {
              offset: -10
            },
            computeStyle: {
              gpuAcceleration: false
            }
          }
        }, function (_ref3) {
          var _ref3$popperProps = _ref3.popperProps,
              ref = _ref3$popperProps.ref,
              dataXOutOfBoundaries = _ref3$popperProps['data-x-out-of-boundaries'],
              rest = Popover__objectWithoutProperties(_ref3$popperProps, ["ref", "data-x-out-of-boundaries"]);

          var isOutOfBoundaries = typeof dataXOutOfBoundaries !== 'undefined';
          return react_default.a.createElement(Popover_PopoverArrowContext, Popover__extends({
            onMouseEnter: _this2.handleMouseEnter,
            onMouseLeave: _this2.handleMouseLeave,
            placement: placement.toString(),
            transitionState: state,
            innerRef: function innerRef(p) {
              _this2.popover = p;
              ref(p);
            },
            isOutOfBoundaries: isOutOfBoundaries
          }, rest, other), react_default.a.createElement(ContentWrapper, null, _this2.renderContent()), react_default.a.createElement(StyledArrow, null));
        });
      }));
    }
  }]);

  return Popover;
}(react["Component"]); // If we export this directly on top when we instantiate the variable, styleguide would endup using
// this component's name as displayname in the styleguide example.
// see warning section for more info: https://react-styleguidist.js.org/docs/components.html#default-vs-named-exports


Popover_Popover.defaultProps = {
  display: 'inline',
  className: '',
  event: popover_constants["a" /* PopoverEvent */].HOVER,
  placement: popover_constants["b" /* PopoverPlacement */].BOTTOM,
  backgroundColor: styles["d" /* DSToken */].BACKGROUND_COLOR_PRIMARY,
  borderColor: styles["d" /* DSToken */].BORDER_COLOR_PRIMARY,
  showArrow: true
};
Popover_Popover.Placement = popover_constants["b" /* PopoverPlacement */];
Popover_Popover.Event = popover_constants["a" /* PopoverEvent */];


// CONCATENATED MODULE: ../react-lib/src/components/callouts/Popover/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return Popover_Popover; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return StyledTargetWrapper; });



/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HorizontalLayout__ = __webpack_require__(275);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__HorizontalLayout__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__HorizontalLayout__["a"]; });


/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ../node_modules/lodash-es/_baseTimes.js
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/* harmony default export */ var _baseTimes = (baseTimes);

// EXTERNAL MODULE: ../node_modules/lodash-es/isArguments.js + 1 modules
var isArguments = __webpack_require__(40);

// EXTERNAL MODULE: ../node_modules/lodash-es/isArray.js
var isArray = __webpack_require__(5);

// EXTERNAL MODULE: ../node_modules/lodash-es/isBuffer.js
var isBuffer = __webpack_require__(38);

// EXTERNAL MODULE: ../node_modules/lodash-es/_isIndex.js
var _isIndex = __webpack_require__(47);

// EXTERNAL MODULE: ../node_modules/lodash-es/isTypedArray.js + 1 modules
var isTypedArray = __webpack_require__(48);

// CONCATENATED MODULE: ../node_modules/lodash-es/_arrayLikeKeys.js







/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _arrayLikeKeys_hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = Object(isArray["a" /* default */])(value),
      isArg = !isArr && Object(isArguments["a" /* default */])(value),
      isBuff = !isArr && !isArg && Object(isBuffer["a" /* default */])(value),
      isType = !isArr && !isArg && !isBuff && Object(isTypedArray["a" /* default */])(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? _baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || _arrayLikeKeys_hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           Object(_isIndex["a" /* default */])(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ var _arrayLikeKeys = __webpack_exports__["a"] = (arrayLikeKeys);


/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(10);


/** Built-in value references. */
var Uint8Array = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Uint8Array;

/* harmony default export */ __webpack_exports__["a"] = (Uint8Array);


/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/lodash-es/_baseForOwn.js
var _baseForOwn = __webpack_require__(72);

// EXTERNAL MODULE: ../node_modules/lodash-es/isArrayLike.js
var isArrayLike = __webpack_require__(23);

// CONCATENATED MODULE: ../node_modules/lodash-es/_createBaseEach.js


/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!Object(isArrayLike["a" /* default */])(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

/* harmony default export */ var _createBaseEach = (createBaseEach);

// CONCATENATED MODULE: ../node_modules/lodash-es/_baseEach.js



/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = _createBaseEach(_baseForOwn["a" /* default */]);

/* harmony default export */ var _baseEach = __webpack_exports__["a"] = (baseEach);


/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__eq_js__ = __webpack_require__(33);



/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && Object(__WEBPACK_IMPORTED_MODULE_1__eq_js__["a" /* default */])(objValue, value)) ||
      (value === undefined && !(key in object))) {
    Object(__WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__["a" /* default */])(object, key, value);
  }
}

/* harmony default export */ __webpack_exports__["a"] = (assignValue);


/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Uint8Array_js__ = __webpack_require__(111);


/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new __WEBPACK_IMPORTED_MODULE_0__Uint8Array_js__["a" /* default */](result).set(new __WEBPACK_IMPORTED_MODULE_0__Uint8Array_js__["a" /* default */](arrayBuffer));
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (cloneArrayBuffer);


/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayEach);


/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseForOwn_js__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseIteratee_js__ = __webpack_require__(61);




/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */
function mapValues(object, iteratee) {
  var result = {};
  iteratee = Object(__WEBPACK_IMPORTED_MODULE_2__baseIteratee_js__["a" /* default */])(iteratee, 3);

  Object(__WEBPACK_IMPORTED_MODULE_1__baseForOwn_js__["a" /* default */])(object, function(value, key, object) {
    Object(__WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__["a" /* default */])(result, key, iteratee(value, key, object));
  });
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (mapValues);


/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export resetId */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getNextId; });
var count = 0;
var resetId = function resetId() {
  count = 0;
};
var getNextId = function getNextId() {
  var id = "element-id-".concat(count);
  count += 1;
  return id;
};

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(15);


var defineProperty = (function() {
  try {
    var func = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

/* harmony default export */ __webpack_exports__["a"] = (defineProperty);


/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ../node_modules/lodash-es/_createBaseFor.js
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

/* harmony default export */ var _createBaseFor = (createBaseFor);

// CONCATENATED MODULE: ../node_modules/lodash-es/_baseFor.js


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = _createBaseFor();

/* harmony default export */ var _baseFor = __webpack_exports__["a"] = (baseFor);


/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetAllKeys_js__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getSymbols_js__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__keys_js__ = __webpack_require__(26);




/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseGetAllKeys_js__["a" /* default */])(object, __WEBPACK_IMPORTED_MODULE_2__keys_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__getSymbols_js__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = (getAllKeys);


/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayPush_js__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArray_js__ = __webpack_require__(5);



/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return Object(__WEBPACK_IMPORTED_MODULE_1__isArray_js__["a" /* default */])(object) ? result : Object(__WEBPACK_IMPORTED_MODULE_0__arrayPush_js__["a" /* default */])(result, symbolsFunc(object));
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetAllKeys);


/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/* harmony default export */ __webpack_exports__["a"] = (stubArray);


/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../design-system/style-dictionary/build/es6/theme.js
var theme = __webpack_require__(44);

// EXTERNAL MODULE: ../node_modules/object-assign/index.js
var object_assign = __webpack_require__(326);
var object_assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// CONCATENATED MODULE: ../node_modules/@styled-system/core/dist/index.esm.js

var index_esm_merge = function merge(a, b) {
  var result = object_assign_default()({}, a, b);

  for (var key in a) {
    var _assign;

    if (!a[key] || typeof b[key] !== 'object') continue;
    object_assign_default()(result, (_assign = {}, _assign[key] = object_assign_default()(a[key], b[key]), _assign));
  }

  return result;
}; // sort object-value responsive styles

var sort = function sort(obj) {
  var next = {};
  Object.keys(obj).sort(function (a, b) {
    return a.localeCompare(b, undefined, {
      numeric: true,
      sensitivity: 'base'
    });
  }).forEach(function (key) {
    next[key] = obj[key];
  });
  return next;
};

var defaults = {
  breakpoints: [40, 52, 64].map(function (n) {
    return n + 'em';
  })
};

var createMediaQuery = function createMediaQuery(n) {
  return "@media screen and (min-width: " + n + ")";
};

var getValue = function getValue(n, scale) {
  return get(scale, n, n);
};

var get = function get(obj, key, def, p, undef) {
  key = key && key.split ? key.split('.') : [key];

  for (p = 0; p < key.length; p++) {
    obj = obj ? obj[key[p]] : undef;
  }

  return obj === undef ? def : obj;
};
var index_esm_createParser = function createParser(config) {
  var cache = {};

  var parse = function parse(props) {
    var styles = {};
    var shouldSort = false;
    var isCacheDisabled = props.theme && props.theme.disableStyledSystemCache;

    for (var key in props) {
      if (!config[key]) continue;
      var sx = config[key];
      var raw = props[key];
      var scale = get(props.theme, sx.scale, sx.defaults);

      if (typeof raw === 'object') {
        cache.breakpoints = !isCacheDisabled && cache.breakpoints || get(props.theme, 'breakpoints', defaults.breakpoints);

        if (Array.isArray(raw)) {
          cache.media = !isCacheDisabled && cache.media || [null].concat(cache.breakpoints.map(createMediaQuery));
          styles = index_esm_merge(styles, index_esm_parseResponsiveStyle(cache.media, sx, scale, raw, props));
          continue;
        }

        if (raw !== null) {
          styles = index_esm_merge(styles, index_esm_parseResponsiveObject(cache.breakpoints, sx, scale, raw, props));
          shouldSort = true;
        }

        continue;
      }

      object_assign_default()(styles, sx(raw, scale, props));
    } // sort object-based responsive styles


    if (shouldSort) {
      styles = sort(styles);
    }

    return styles;
  };

  parse.config = config;
  parse.propNames = Object.keys(config);
  parse.cache = cache;
  var keys = Object.keys(config).filter(function (k) {
    return k !== 'config';
  });

  if (keys.length > 1) {
    keys.forEach(function (key) {
      var _createParser;

      parse[key] = createParser((_createParser = {}, _createParser[key] = config[key], _createParser));
    });
  }

  return parse;
};

var index_esm_parseResponsiveStyle = function parseResponsiveStyle(mediaQueries, sx, scale, raw, _props) {
  var styles = {};
  raw.slice(0, mediaQueries.length).forEach(function (value, i) {
    var media = mediaQueries[i];
    var style = sx(value, scale, _props);

    if (!media) {
      object_assign_default()(styles, style);
    } else {
      var _assign2;

      object_assign_default()(styles, (_assign2 = {}, _assign2[media] = object_assign_default()({}, styles[media], style), _assign2));
    }
  });
  return styles;
};

var index_esm_parseResponsiveObject = function parseResponsiveObject(breakpoints, sx, scale, raw, _props) {
  var styles = {};

  for (var key in raw) {
    var breakpoint = breakpoints[key];
    var value = raw[key];
    var style = sx(value, scale, _props);

    if (!breakpoint) {
      object_assign_default()(styles, style);
    } else {
      var _assign3;

      var media = createMediaQuery(breakpoint);
      object_assign_default()(styles, (_assign3 = {}, _assign3[media] = object_assign_default()({}, styles[media], style), _assign3));
    }
  }

  return styles;
};

var createStyleFunction = function createStyleFunction(_ref) {
  var properties = _ref.properties,
      property = _ref.property,
      scale = _ref.scale,
      _ref$transform = _ref.transform,
      transform = _ref$transform === void 0 ? getValue : _ref$transform,
      defaultScale = _ref.defaultScale;
  properties = properties || [property];

  var sx = function sx(value, scale, _props) {
    var result = {};
    var n = transform(value, scale, _props);
    if (n === null) return;
    properties.forEach(function (prop) {
      result[prop] = n;
    });
    return result;
  };

  sx.scale = scale;
  sx.defaults = defaultScale;
  return sx;
}; // new v5 API

var system = function system(args) {
  if (args === void 0) {
    args = {};
  }

  var config = {};
  Object.keys(args).forEach(function (key) {
    var conf = args[key];

    if (conf === true) {
      // shortcut definition
      config[key] = createStyleFunction({
        property: key,
        scale: key
      });
      return;
    }

    if (typeof conf === 'function') {
      config[key] = conf;
      return;
    }

    config[key] = createStyleFunction(conf);
  });
  var parser = index_esm_createParser(config);
  return parser;
};
var index_esm_compose = function compose() {
  var config = {};

  for (var _len = arguments.length, parsers = new Array(_len), _key = 0; _key < _len; _key++) {
    parsers[_key] = arguments[_key];
  }

  parsers.forEach(function (parser) {
    if (!parser || !parser.config) return;
    object_assign_default()(config, parser.config);
  });
  var parser = index_esm_createParser(config);
  return parser;
};

// CONCATENATED MODULE: ../node_modules/@styled-system/layout/dist/index.esm.js


var isNumber = function isNumber(n) {
  return typeof n === 'number' && !isNaN(n);
};

var index_esm_getWidth = function getWidth(n, scale) {
  return get(scale, n, !isNumber(n) || n > 1 ? n : n * 100 + '%');
};

var index_esm_config = {
  width: {
    property: 'width',
    scale: 'sizes',
    transform: index_esm_getWidth
  },
  height: {
    property: 'height',
    scale: 'sizes'
  },
  minWidth: {
    property: 'minWidth',
    scale: 'sizes'
  },
  minHeight: {
    property: 'minHeight',
    scale: 'sizes'
  },
  maxWidth: {
    property: 'maxWidth',
    scale: 'sizes'
  },
  maxHeight: {
    property: 'maxHeight',
    scale: 'sizes'
  },
  size: {
    properties: ['width', 'height'],
    scale: 'sizes'
  },
  overflow: true,
  overflowX: true,
  overflowY: true,
  display: true,
  verticalAlign: true
};
var layout = system(index_esm_config);
/* harmony default export */ var index_esm = (layout);

// CONCATENATED MODULE: ../node_modules/@styled-system/color/dist/index.esm.js

var dist_index_esm_config = {
  color: {
    property: 'color',
    scale: 'colors'
  },
  backgroundColor: {
    property: 'backgroundColor',
    scale: 'colors'
  },
  opacity: true
};
dist_index_esm_config.bg = dist_index_esm_config.backgroundColor;
var color = system(dist_index_esm_config);
/* harmony default export */ var dist_index_esm = (color);

// CONCATENATED MODULE: ../node_modules/@styled-system/typography/dist/index.esm.js

var index_esm_defaults = {
  fontSizes: [12, 14, 16, 20, 24, 32, 48, 64, 72]
};
var typography_dist_index_esm_config = {
  fontFamily: {
    property: 'fontFamily',
    scale: 'fonts'
  },
  fontSize: {
    property: 'fontSize',
    scale: 'fontSizes',
    defaultScale: index_esm_defaults.fontSizes
  },
  fontWeight: {
    property: 'fontWeight',
    scale: 'fontWeights'
  },
  lineHeight: {
    property: 'lineHeight',
    scale: 'lineHeights'
  },
  letterSpacing: {
    property: 'letterSpacing',
    scale: 'letterSpacings'
  },
  textAlign: true,
  fontStyle: true
};
var typography = system(typography_dist_index_esm_config);
/* harmony default export */ var typography_dist_index_esm = (typography);

// CONCATENATED MODULE: ../node_modules/@styled-system/flexbox/dist/index.esm.js

var flexbox_dist_index_esm_config = {
  alignItems: true,
  alignContent: true,
  justifyItems: true,
  justifyContent: true,
  flexWrap: true,
  flexDirection: true,
  // item
  flex: true,
  flexGrow: true,
  flexShrink: true,
  flexBasis: true,
  justifySelf: true,
  alignSelf: true,
  order: true
};
var flexbox = system(flexbox_dist_index_esm_config);
/* harmony default export */ var flexbox_dist_index_esm = (flexbox);

// CONCATENATED MODULE: ../node_modules/@styled-system/grid/dist/index.esm.js

var dist_index_esm_defaults = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512]
};
var grid_dist_index_esm_config = {
  gridGap: {
    property: 'gridGap',
    scale: 'space',
    defaultScale: dist_index_esm_defaults.space
  },
  gridColumnGap: {
    property: 'gridColumnGap',
    scale: 'space',
    defaultScale: dist_index_esm_defaults.space
  },
  gridRowGap: {
    property: 'gridRowGap',
    scale: 'space',
    defaultScale: dist_index_esm_defaults.space
  },
  gridColumn: true,
  gridRow: true,
  gridAutoFlow: true,
  gridAutoColumns: true,
  gridAutoRows: true,
  gridTemplateColumns: true,
  gridTemplateRows: true,
  gridTemplateAreas: true,
  gridArea: true
};
var grid = system(grid_dist_index_esm_config);
/* harmony default export */ var grid_dist_index_esm = (grid);

// CONCATENATED MODULE: ../node_modules/@styled-system/border/dist/index.esm.js
var index_esm__config;


var border_dist_index_esm_config = (index_esm__config = {
  border: {
    property: 'border',
    scale: 'borders'
  },
  borderWidth: {
    property: 'borderWidth',
    scale: 'borderWidths'
  },
  borderStyle: {
    property: 'borderStyle',
    scale: 'borderStyles'
  },
  borderColor: {
    property: 'borderColor',
    scale: 'colors'
  },
  borderRadius: {
    property: 'borderRadius',
    scale: 'radii'
  },
  borderTop: {
    property: 'borderTop',
    scale: 'borders'
  },
  borderTopLeftRadius: {
    property: 'borderTopLeftRadius',
    scale: 'radii'
  },
  borderTopRightRadius: {
    property: 'borderTopRightRadius',
    scale: 'radii'
  },
  borderRight: {
    property: 'borderRight',
    scale: 'borders'
  },
  borderBottom: {
    property: 'borderBottom',
    scale: 'borders'
  },
  borderBottomLeftRadius: {
    property: 'borderBottomLeftRadius',
    scale: 'radii'
  },
  borderBottomRightRadius: {
    property: 'borderBottomRightRadius',
    scale: 'radii'
  },
  borderLeft: {
    property: 'borderLeft',
    scale: 'borders'
  },
  borderX: {
    properties: ['borderLeft', 'borderRight'],
    scale: 'borders'
  },
  borderY: {
    properties: ['borderTop', 'borderBottom'],
    scale: 'borders'
  },
  borderTopWidth: {
    property: 'borderTopWidth',
    scale: 'borderWidths'
  },
  borderTopColor: {
    property: 'borderTopColor',
    scale: 'colors'
  },
  borderTopStyle: {
    property: 'borderTopStyle',
    scale: 'borderStyles'
  }
}, index_esm__config["borderTopLeftRadius"] = {
  property: 'borderTopLeftRadius',
  scale: 'radii'
}, index_esm__config["borderTopRightRadius"] = {
  property: 'borderTopRightRadius',
  scale: 'radii'
}, index_esm__config.borderBottomWidth = {
  property: 'borderBottomWidth',
  scale: 'borderWidths'
}, index_esm__config.borderBottomColor = {
  property: 'borderBottomColor',
  scale: 'colors'
}, index_esm__config.borderBottomStyle = {
  property: 'borderBottomStyle',
  scale: 'borderStyles'
}, index_esm__config["borderBottomLeftRadius"] = {
  property: 'borderBottomLeftRadius',
  scale: 'radii'
}, index_esm__config["borderBottomRightRadius"] = {
  property: 'borderBottomRightRadius',
  scale: 'radii'
}, index_esm__config.borderLeftWidth = {
  property: 'borderLeftWidth',
  scale: 'borderWidths'
}, index_esm__config.borderLeftColor = {
  property: 'borderLeftColor',
  scale: 'colors'
}, index_esm__config.borderLeftStyle = {
  property: 'borderLeftStyle',
  scale: 'borderStyles'
}, index_esm__config.borderRightWidth = {
  property: 'borderRightWidth',
  scale: 'borderWidths'
}, index_esm__config.borderRightColor = {
  property: 'borderRightColor',
  scale: 'colors'
}, index_esm__config.borderRightStyle = {
  property: 'borderRightStyle',
  scale: 'borderStyles'
}, index_esm__config);
var border = system(border_dist_index_esm_config);
/* harmony default export */ var border_dist_index_esm = (border);

// CONCATENATED MODULE: ../node_modules/@styled-system/background/dist/index.esm.js

var background_dist_index_esm_config = {
  background: true,
  backgroundImage: true,
  backgroundSize: true,
  backgroundPosition: true,
  backgroundRepeat: true
};
background_dist_index_esm_config.bgImage = background_dist_index_esm_config.backgroundImage;
background_dist_index_esm_config.bgSize = background_dist_index_esm_config.backgroundSize;
background_dist_index_esm_config.bgPosition = background_dist_index_esm_config.backgroundPosition;
background_dist_index_esm_config.bgRepeat = background_dist_index_esm_config.backgroundRepeat;
var background = system(background_dist_index_esm_config);
/* harmony default export */ var background_dist_index_esm = (background);

// CONCATENATED MODULE: ../node_modules/@styled-system/position/dist/index.esm.js

var position_dist_index_esm_defaults = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512]
};
var position_dist_index_esm_config = {
  position: true,
  zIndex: {
    property: 'zIndex',
    scale: 'zIndices'
  },
  top: {
    property: 'top',
    scale: 'space',
    defaultScale: position_dist_index_esm_defaults.space
  },
  right: {
    property: 'right',
    scale: 'space',
    defaultScale: position_dist_index_esm_defaults.space
  },
  bottom: {
    property: 'bottom',
    scale: 'space',
    defaultScale: position_dist_index_esm_defaults.space
  },
  left: {
    property: 'left',
    scale: 'space',
    defaultScale: position_dist_index_esm_defaults.space
  }
};
var position = system(position_dist_index_esm_config);
/* harmony default export */ var position_dist_index_esm = (position);

// CONCATENATED MODULE: ../node_modules/@styled-system/space/dist/index.esm.js

var space_dist_index_esm_defaults = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512]
};

var index_esm_isNumber = function isNumber(n) {
  return typeof n === 'number' && !isNaN(n);
};

var index_esm_getMargin = function getMargin(n, scale) {
  if (!index_esm_isNumber(n)) {
    return get(scale, n, n);
  }

  var isNegative = n < 0;
  var absolute = Math.abs(n);
  var value = get(scale, absolute, absolute);

  if (!index_esm_isNumber(value)) {
    return isNegative ? '-' + value : value;
  }

  return value * (isNegative ? -1 : 1);
};

var configs = {};
configs.margin = {
  margin: {
    property: 'margin',
    scale: 'space',
    transform: index_esm_getMargin,
    defaultScale: space_dist_index_esm_defaults.space
  },
  marginTop: {
    property: 'marginTop',
    scale: 'space',
    transform: index_esm_getMargin,
    defaultScale: space_dist_index_esm_defaults.space
  },
  marginRight: {
    property: 'marginRight',
    scale: 'space',
    transform: index_esm_getMargin,
    defaultScale: space_dist_index_esm_defaults.space
  },
  marginBottom: {
    property: 'marginBottom',
    scale: 'space',
    transform: index_esm_getMargin,
    defaultScale: space_dist_index_esm_defaults.space
  },
  marginLeft: {
    property: 'marginLeft',
    scale: 'space',
    transform: index_esm_getMargin,
    defaultScale: space_dist_index_esm_defaults.space
  },
  marginX: {
    properties: ['marginLeft', 'marginRight'],
    scale: 'space',
    transform: index_esm_getMargin,
    defaultScale: space_dist_index_esm_defaults.space
  },
  marginY: {
    properties: ['marginTop', 'marginBottom'],
    scale: 'space',
    transform: index_esm_getMargin,
    defaultScale: space_dist_index_esm_defaults.space
  }
};
configs.margin.m = configs.margin.margin;
configs.margin.mt = configs.margin.marginTop;
configs.margin.mr = configs.margin.marginRight;
configs.margin.mb = configs.margin.marginBottom;
configs.margin.ml = configs.margin.marginLeft;
configs.margin.mx = configs.margin.marginX;
configs.margin.my = configs.margin.marginY;
configs.padding = {
  padding: {
    property: 'padding',
    scale: 'space',
    defaultScale: space_dist_index_esm_defaults.space
  },
  paddingTop: {
    property: 'paddingTop',
    scale: 'space',
    defaultScale: space_dist_index_esm_defaults.space
  },
  paddingRight: {
    property: 'paddingRight',
    scale: 'space',
    defaultScale: space_dist_index_esm_defaults.space
  },
  paddingBottom: {
    property: 'paddingBottom',
    scale: 'space',
    defaultScale: space_dist_index_esm_defaults.space
  },
  paddingLeft: {
    property: 'paddingLeft',
    scale: 'space',
    defaultScale: space_dist_index_esm_defaults.space
  },
  paddingX: {
    properties: ['paddingLeft', 'paddingRight'],
    scale: 'space',
    defaultScale: space_dist_index_esm_defaults.space
  },
  paddingY: {
    properties: ['paddingTop', 'paddingBottom'],
    scale: 'space',
    defaultScale: space_dist_index_esm_defaults.space
  }
};
configs.padding.p = configs.padding.padding;
configs.padding.pt = configs.padding.paddingTop;
configs.padding.pr = configs.padding.paddingRight;
configs.padding.pb = configs.padding.paddingBottom;
configs.padding.pl = configs.padding.paddingLeft;
configs.padding.px = configs.padding.paddingX;
configs.padding.py = configs.padding.paddingY;
var margin = system(configs.margin);
var padding = system(configs.padding);
var space = index_esm_compose(margin, padding);
/* harmony default export */ var space_dist_index_esm = (space);

// CONCATENATED MODULE: ../node_modules/@styled-system/shadow/dist/index.esm.js

var shadow = system({
  boxShadow: {
    property: 'boxShadow',
    scale: 'shadows'
  },
  textShadow: {
    property: 'textShadow',
    scale: 'shadows'
  }
});
/* harmony default export */ var shadow_dist_index_esm = (shadow);

// CONCATENATED MODULE: ../node_modules/@styled-system/css/dist/index.esm.js
var _scales;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

// based on https://github.com/developit/dlv
var index_esm_get = function get(obj, key, def, p, undef) {
  key = key && key.split ? key.split('.') : [key];

  for (p = 0; p < key.length; p++) {
    obj = obj ? obj[key[p]] : undef;
  }

  return obj === undef ? def : obj;
};
var defaultBreakpoints = [40, 52, 64].map(function (n) {
  return n + 'em';
});
var defaultTheme = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
  fontSizes: [12, 14, 16, 20, 24, 32, 48, 64, 72]
};
var aliases = {
  bg: 'backgroundColor',
  m: 'margin',
  mt: 'marginTop',
  mr: 'marginRight',
  mb: 'marginBottom',
  ml: 'marginLeft',
  mx: 'marginX',
  my: 'marginY',
  p: 'padding',
  pt: 'paddingTop',
  pr: 'paddingRight',
  pb: 'paddingBottom',
  pl: 'paddingLeft',
  px: 'paddingX',
  py: 'paddingY'
};
var multiples = {
  marginX: ['marginLeft', 'marginRight'],
  marginY: ['marginTop', 'marginBottom'],
  paddingX: ['paddingLeft', 'paddingRight'],
  paddingY: ['paddingTop', 'paddingBottom'],
  size: ['width', 'height']
};
var scales = (_scales = {
  color: 'colors',
  backgroundColor: 'colors',
  borderColor: 'colors',
  margin: 'space',
  marginTop: 'space',
  marginRight: 'space',
  marginBottom: 'space',
  marginLeft: 'space',
  marginX: 'space',
  marginY: 'space',
  padding: 'space',
  paddingTop: 'space',
  paddingRight: 'space',
  paddingBottom: 'space',
  paddingLeft: 'space',
  paddingX: 'space',
  paddingY: 'space',
  top: 'space',
  right: 'space',
  bottom: 'space',
  left: 'space',
  gridGap: 'space',
  gridColumnGap: 'space',
  gridRowGap: 'space',
  gap: 'space',
  columnGap: 'space',
  rowGap: 'space',
  fontFamily: 'fonts',
  fontSize: 'fontSizes',
  fontWeight: 'fontWeights',
  lineHeight: 'lineHeights',
  letterSpacing: 'letterSpacings',
  border: 'borders',
  borderTop: 'borders',
  borderRight: 'borders',
  borderBottom: 'borders',
  borderLeft: 'borders',
  borderWidth: 'borderWidths',
  borderStyle: 'borderStyles',
  borderRadius: 'radii',
  borderTopRightRadius: 'radii',
  borderTopLeftRadius: 'radii',
  borderBottomRightRadius: 'radii',
  borderBottomLeftRadius: 'radii',
  borderTopWidth: 'borderWidths',
  borderTopColor: 'colors',
  borderTopStyle: 'borderStyles'
}, _scales["borderTopLeftRadius"] = 'radii', _scales["borderTopRightRadius"] = 'radii', _scales.borderBottomWidth = 'borderWidths', _scales.borderBottomColor = 'colors', _scales.borderBottomStyle = 'borderStyles', _scales["borderBottomLeftRadius"] = 'radii', _scales["borderBottomRightRadius"] = 'radii', _scales.borderLeftWidth = 'borderWidths', _scales.borderLeftColor = 'colors', _scales.borderLeftStyle = 'borderStyles', _scales.borderRightWidth = 'borderWidths', _scales.borderRightColor = 'colors', _scales.borderRightStyle = 'borderStyles', _scales.boxShadow = 'shadows', _scales.textShadow = 'shadows', _scales.zIndex = 'zIndices', _scales.width = 'sizes', _scales.minWidth = 'sizes', _scales.maxWidth = 'sizes', _scales.height = 'sizes', _scales.minHeight = 'sizes', _scales.maxHeight = 'sizes', _scales.flexBasis = 'sizes', _scales.size = 'sizes', _scales.fill = 'colors', _scales.stroke = 'colors', _scales);

var positiveOrNegative = function positiveOrNegative(scale, value) {
  if (typeof value !== 'number' || value >= 0) {
    return index_esm_get(scale, value, value);
  }

  var absolute = Math.abs(value);
  var n = index_esm_get(scale, absolute, absolute);
  if (typeof n === 'string') return '-' + n;
  return n * -1;
};

var transforms = ['margin', 'marginTop', 'marginRight', 'marginBottom', 'marginLeft', 'marginX', 'marginY', 'top', 'bottom', 'left', 'right'].reduce(function (acc, curr) {
  var _extends2;

  return _extends({}, acc, (_extends2 = {}, _extends2[curr] = positiveOrNegative, _extends2));
}, {});
var responsive = function responsive(styles) {
  return function (theme) {
    var next = {};
    var breakpoints = index_esm_get(theme, 'breakpoints', defaultBreakpoints);
    var mediaQueries = [null].concat(breakpoints.map(function (n) {
      return "@media screen and (min-width: " + n + ")";
    }));

    for (var key in styles) {
      var value = typeof styles[key] === 'function' ? styles[key](theme) : styles[key];
      if (value == null) continue;

      if (!Array.isArray(value)) {
        next[key] = value;
        continue;
      }

      for (var i = 0; i < value.slice(0, mediaQueries.length).length; i++) {
        var media = mediaQueries[i];
        if (value[i] == null) continue;

        if (!media) {
          next[key] = value[i];
          continue;
        }

        next[media] = next[media] || {};
        next[media][key] = value[i];
      }
    }

    return next;
  };
};
var css = function css(args) {
  return function (props) {
    if (props === void 0) {
      props = {};
    }

    var theme = _extends({}, defaultTheme, {}, props.theme || props);

    var result = {};
    var obj = typeof args === 'function' ? args(theme) : args;
    var styles = responsive(obj)(theme);

    for (var key in styles) {
      var x = styles[key];
      var val = typeof x === 'function' ? x(theme) : x;

      if (key === 'variant') {
        var variant = css(index_esm_get(theme, val))(theme);
        result = _extends({}, result, {}, variant);
        continue;
      }

      if (val && typeof val === 'object') {
        result[key] = css(val)(theme);
        continue;
      }

      var prop = index_esm_get(aliases, key, key);
      var scaleName = index_esm_get(scales, prop);
      var scale = index_esm_get(theme, scaleName, index_esm_get(theme, prop, {}));
      var transform = index_esm_get(transforms, prop, index_esm_get);
      var value = transform(scale, val, val);

      if (multiples[prop]) {
        var dirs = multiples[prop];

        for (var i = 0; i < dirs.length; i++) {
          result[dirs[i]] = value;
        }
      } else {
        result[prop] = value;
      }
    }

    return result;
  };
};
/* harmony default export */ var css_dist_index_esm = (css);

// CONCATENATED MODULE: ../node_modules/@styled-system/variant/dist/index.esm.js


var index_esm_variant = function variant(_ref) {
  var _config;

  var scale = _ref.scale,
      _ref$prop = _ref.prop,
      prop = _ref$prop === void 0 ? 'variant' : _ref$prop,
      _ref$variants = _ref.variants,
      variants = _ref$variants === void 0 ? {} : _ref$variants,
      key = _ref.key;
  var sx;

  if (Object.keys(variants).length) {
    sx = function sx(value, scale, props) {
      return css_dist_index_esm(get(scale, value, null))(props.theme);
    };
  } else {
    sx = function sx(value, scale) {
      return get(scale, value, null);
    };
  }

  sx.scale = scale || key;
  sx.defaults = variants;
  var config = (_config = {}, _config[prop] = sx, _config);
  var parser = index_esm_createParser(config);
  return parser;
};
/* harmony default export */ var variant_dist_index_esm = (index_esm_variant);
var buttonStyle = index_esm_variant({
  key: 'buttons'
});
var textStyle = index_esm_variant({
  key: 'textStyles',
  prop: 'textStyle'
});
var colorStyle = index_esm_variant({
  key: 'colorStyles',
  prop: 'colors'
});

// CONCATENATED MODULE: ../node_modules/styled-system/dist/index.esm.js
 // v4 api shims






















var width = index_esm.width,
    height = index_esm.height,
    minWidth = index_esm.minWidth,
    minHeight = index_esm.minHeight,
    maxWidth = index_esm.maxWidth,
    maxHeight = index_esm.maxHeight,
    size = index_esm.size,
    verticalAlign = index_esm.verticalAlign,
    display = index_esm.display,
    overflow = index_esm.overflow,
    overflowX = index_esm.overflowX,
    overflowY = index_esm.overflowY;
var opacity = dist_index_esm.opacity;
var fontSize = typography_dist_index_esm.fontSize,
    index_esm_fontFamily = typography_dist_index_esm.fontFamily,
    fontWeight = typography_dist_index_esm.fontWeight,
    lineHeight = typography_dist_index_esm.lineHeight,
    textAlign = typography_dist_index_esm.textAlign,
    fontStyle = typography_dist_index_esm.fontStyle,
    letterSpacing = typography_dist_index_esm.letterSpacing;
var alignItems = flexbox_dist_index_esm.alignItems,
    alignContent = flexbox_dist_index_esm.alignContent,
    justifyItems = flexbox_dist_index_esm.justifyItems,
    justifyContent = flexbox_dist_index_esm.justifyContent,
    flexWrap = flexbox_dist_index_esm.flexWrap,
    flexDirection = flexbox_dist_index_esm.flexDirection,
    flex = flexbox_dist_index_esm.flex,
    flexGrow = flexbox_dist_index_esm.flexGrow,
    flexShrink = flexbox_dist_index_esm.flexShrink,
    flexBasis = flexbox_dist_index_esm.flexBasis,
    justifySelf = flexbox_dist_index_esm.justifySelf,
    alignSelf = flexbox_dist_index_esm.alignSelf,
    order = flexbox_dist_index_esm.order;
var gridGap = grid_dist_index_esm.gridGap,
    gridColumnGap = grid_dist_index_esm.gridColumnGap,
    gridRowGap = grid_dist_index_esm.gridRowGap,
    gridColumn = grid_dist_index_esm.gridColumn,
    gridRow = grid_dist_index_esm.gridRow,
    gridAutoFlow = grid_dist_index_esm.gridAutoFlow,
    gridAutoColumns = grid_dist_index_esm.gridAutoColumns,
    gridAutoRows = grid_dist_index_esm.gridAutoRows,
    gridTemplateColumns = grid_dist_index_esm.gridTemplateColumns,
    gridTemplateRows = grid_dist_index_esm.gridTemplateRows,
    gridTemplateAreas = grid_dist_index_esm.gridTemplateAreas,
    gridArea = grid_dist_index_esm.gridArea;
var borderWidth = border_dist_index_esm.borderWidth,
    borderStyle = border_dist_index_esm.borderStyle,
    borderColor = border_dist_index_esm.borderColor,
    borderTop = border_dist_index_esm.borderTop,
    borderRight = border_dist_index_esm.borderRight,
    borderBottom = border_dist_index_esm.borderBottom,
    borderLeft = border_dist_index_esm.borderLeft,
    borderRadius = border_dist_index_esm.borderRadius;
var backgroundImage = background_dist_index_esm.backgroundImage,
    backgroundSize = background_dist_index_esm.backgroundSize,
    backgroundPosition = background_dist_index_esm.backgroundPosition,
    backgroundRepeat = background_dist_index_esm.backgroundRepeat;
var zIndex = position_dist_index_esm.zIndex,
    index_esm_top = position_dist_index_esm.top,
    right = position_dist_index_esm.right,
    bottom = position_dist_index_esm.bottom,
    left = position_dist_index_esm.left;

 // v4 style API shim

var index_esm_style = function style(_ref) {
  var prop = _ref.prop,
      cssProperty = _ref.cssProperty,
      alias = _ref.alias,
      key = _ref.key,
      transformValue = _ref.transformValue,
      scale = _ref.scale,
      properties = _ref.properties;
  var config = {};
  config[prop] = createStyleFunction({
    properties: properties,
    property: cssProperty || prop,
    scale: key,
    defaultScale: scale,
    transform: transformValue
  });
  if (alias) config[alias] = config[prop];
  var parse = index_esm_createParser(config);
  return parse;
};

// EXTERNAL MODULE: ../utilities/userAgent.js
var userAgent = __webpack_require__(60);

// CONCATENATED MODULE: ../react-lib/src/styles/styled-system/transforms.js

var createTransformWithDefault = function createTransformWithDefault(defaultValue) {
  return function (propValue, scale) {
    if (!scale) {
      return defaultValue;
    }

    return scale[propValue] || defaultValue;
  };
};
var transforms_reactNativeSafeTransform = function reactNativeSafeTransform(value) {
  // for RxN we need to remove the 'px'/etc units...
  var rxnSafeValue = Object(userAgent["g" /* isReactNative */])() ? parseInt(value, 10) : value; // but unitless values need to be turned back into string form else React will cleverly put the 'px' back on numerics.

  return rxnSafeValue.toString();
};
// CONCATENATED MODULE: ../react-lib/src/styles/styled-system/margin.js


var noMarginDefaultingTransform = createTransformWithDefault('0');

var margin_transform = function transform(spacing, scale) {
  var value = noMarginDefaultingTransform(spacing, scale);
  return transforms_reactNativeSafeTransform(value);
};

var margin_config = {
  margin: {
    property: 'margin',
    scale: 'space',
    transform: margin_transform
  },
  marginTop: {
    property: 'marginTop',
    scale: 'space',
    transform: margin_transform
  },
  marginRight: {
    property: 'marginRight',
    scale: 'space',
    transform: margin_transform
  },
  marginBottom: {
    property: 'marginBottom',
    scale: 'space',
    transform: margin_transform
  },
  marginLeft: {
    property: 'marginLeft',
    scale: 'space',
    transform: margin_transform
  },
  marginX: {
    properties: ['marginLeft', 'marginRight'],
    scale: 'space',
    transform: margin_transform
  },
  marginY: {
    properties: ['marginTop', 'marginBottom'],
    scale: 'space',
    transform: margin_transform
  }
};
/* harmony default export */ var styled_system_margin = (system(margin_config));
// CONCATENATED MODULE: ../react-lib/src/styles/styled-system/textAlign.js


var textAlign_config = {
  textAlign: {
    property: 'textAlign',
    scale: 'textAlign',
    transform: createTransformWithDefault('left')
  }
};
/* harmony default export */ var styled_system_textAlign = (system(textAlign_config));
// CONCATENATED MODULE: ../react-lib/src/styles/styled-system/textColor.js


var textColor_config = {
  textColor: {
    property: 'color',
    scale: 'textColor',
    transform: createTransformWithDefault(undefined)
  }
};
/* harmony default export */ var textColor = (system(textColor_config));
// CONCATENATED MODULE: ../react-lib/src/styles/styled-system/fontWeight.js



var getFontFamilyForWeight = function getFontFamilyForWeight(weight) {
  switch (weight) {
    case 'extrabold':
      return 'Averta-Extrabold';

    case 'semibold':
      return 'Averta-Semibold';

    case 'regular':
    default:
      return 'Averta-Regular';
  }
};

var fontWeight_config = {
  fontWeight: {
    property: 'fontFamily',
    scale: 'fontWeight',
    transform: function transform(propValue) {
      var fontFamily = getFontFamilyForWeight(propValue); // if not on react native, append fallback fonts

      if (true) {
        return "".concat(fontFamily, ", ").concat(theme["a" /* WEB_FALLBACK_FONT_FAMILIES */]);
      }

      return fontFamily;
    }
  }
};
/* harmony default export */ var styled_system_fontWeight = (system(fontWeight_config));
// CONCATENATED MODULE: ../react-lib/src/styles/styled-system/textTransform.js


var textTransform_config = {
  textTransform: {
    property: 'textTransform',
    scale: 'textTransform',
    transform: createTransformWithDefault('none')
  }
};
/* harmony default export */ var textTransform = (system(textTransform_config));
// CONCATENATED MODULE: ../react-lib/src/styles/styled-system/textDecoration.js


var textDecoration_config = {
  textDecoration: {
    property: 'textDecoration',
    scale: 'textDecoration',
    transform: createTransformWithDefault('none')
  }
};
/* harmony default export */ var textDecoration = (system(textDecoration_config));
// CONCATENATED MODULE: ../react-lib/src/styles/styled-system/index.js
/* unused concated harmony import theme */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return theme["b" /* default */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return styled_system_margin; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "c", function() { return styled_system_textAlign; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "d", function() { return textColor; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return styled_system_fontWeight; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "f", function() { return textTransform; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "e", function() { return textDecoration; });








/***/ }),
/* 124 */,
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var DEFAULT_VALID_NUMBER_OF_YEARS_IN_THE_FUTURE = 19;

function verification(isValid, isPotentiallyValid, isCurrentYear) {
  return {
    isValid: isValid,
    isPotentiallyValid: isPotentiallyValid,
    isCurrentYear: isCurrentYear || false
  };
}

function expirationYear(value, maxElapsedYear) {
  var currentFirstTwo, currentYear, firstTwo, len, twoDigitYear, valid, isCurrentYear;

  maxElapsedYear = maxElapsedYear || DEFAULT_VALID_NUMBER_OF_YEARS_IN_THE_FUTURE;

  if (typeof value !== 'string') {
    return verification(false, false);
  }
  if (value.replace(/\s/g, '') === '') {
    return verification(false, true);
  }
  if (!/^\d*$/.test(value)) {
    return verification(false, false);
  }

  len = value.length;

  if (len < 2) {
    return verification(false, true);
  }

  currentYear = new Date().getFullYear();

  if (len === 3) {
    // 20x === 20x
    firstTwo = value.slice(0, 2);
    currentFirstTwo = String(currentYear).slice(0, 2);
    return verification(false, firstTwo === currentFirstTwo);
  }

  if (len > 4) {
    return verification(false, false);
  }

  value = parseInt(value, 10);
  twoDigitYear = Number(String(currentYear).substr(2, 2));

  if (len === 2) {
    isCurrentYear = twoDigitYear === value;
    valid = value >= twoDigitYear && value <= twoDigitYear + maxElapsedYear;
  } else if (len === 4) {
    isCurrentYear = currentYear === value;
    valid = value >= currentYear && value <= currentYear + maxElapsedYear;
  }

  return verification(valid, valid, isCurrentYear);
}

module.exports = expirationYear;


/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArray_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(12);




/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!Object(__WEBPACK_IMPORTED_MODULE_1__isArray_js__["a" /* default */])(value) && Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) && Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) == stringTag);
}

/* harmony default export */ __webpack_exports__["a"] = (isString);


/***/ }),
/* 127 */,
/* 128 */,
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FormGroup__ = __webpack_require__(244);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__FormGroup__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__FormGroup__["a"]; });


/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FormValidationError__ = __webpack_require__(242);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__FormValidationError__["a"]; });


/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PopoverPlacement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PopoverEvent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types_Enum__ = __webpack_require__(6);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }


var PopoverPlacement =
/*#__PURE__*/
function (_Enum) {
  _inherits(PopoverPlacement, _Enum);

  function PopoverPlacement() {
    _classCallCheck(this, PopoverPlacement);

    return _possibleConstructorReturn(this, _getPrototypeOf(PopoverPlacement).apply(this, arguments));
  }

  return PopoverPlacement;
}(__WEBPACK_IMPORTED_MODULE_0__types_Enum__["a" /* default */]);
PopoverPlacement.TOP = new PopoverPlacement('top');
PopoverPlacement.BOTTOM = new PopoverPlacement('bottom');
PopoverPlacement.LEFT = new PopoverPlacement('left');
PopoverPlacement.RIGHT = new PopoverPlacement('right');
PopoverPlacement.isLocked = true;
var PopoverEvent =
/*#__PURE__*/
function (_Enum2) {
  _inherits(PopoverEvent, _Enum2);

  function PopoverEvent() {
    _classCallCheck(this, PopoverEvent);

    return _possibleConstructorReturn(this, _getPrototypeOf(PopoverEvent).apply(this, arguments));
  }

  return PopoverEvent;
}(__WEBPACK_IMPORTED_MODULE_0__types_Enum__["a" /* default */]);
PopoverEvent.HOVER = new PopoverEvent('hover');
PopoverEvent.CLICK = new PopoverEvent('click');
PopoverEvent.NONE = new PopoverEvent('none');
PopoverEvent.isLocked = true;

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/lodash-es/_Symbol.js
var _Symbol = __webpack_require__(68);

// EXTERNAL MODULE: ../node_modules/lodash-es/_arrayMap.js
var _arrayMap = __webpack_require__(64);

// EXTERNAL MODULE: ../node_modules/lodash-es/isArray.js
var isArray = __webpack_require__(5);

// EXTERNAL MODULE: ../node_modules/lodash-es/isSymbol.js
var isSymbol = __webpack_require__(42);

// CONCATENATED MODULE: ../node_modules/lodash-es/_baseToString.js





/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = _Symbol["a" /* default */] ? _Symbol["a" /* default */].prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (Object(isArray["a" /* default */])(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return Object(_arrayMap["a" /* default */])(value, baseToString) + '';
  }
  if (Object(isSymbol["a" /* default */])(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/* harmony default export */ var _baseToString = (baseToString);

// CONCATENATED MODULE: ../node_modules/lodash-es/toString.js


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString_toString(value) {
  return value == null ? '' : _baseToString(value);
}

/* harmony default export */ var lodash_es_toString = __webpack_exports__["a"] = (toString_toString);


/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(1);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["border:0;clip:rect(0 0 0 0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px;"]));

/***/ }),
/* 134 */,
/* 135 */,
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "polyfill", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rover_design_system__ = __webpack_require__(100);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__rover_design_system__["a"]; });


/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/lodash-es/_arrayPush.js
var _arrayPush = __webpack_require__(73);

// EXTERNAL MODULE: ../node_modules/lodash-es/_Symbol.js
var _Symbol = __webpack_require__(68);

// EXTERNAL MODULE: ../node_modules/lodash-es/isArguments.js + 1 modules
var isArguments = __webpack_require__(40);

// EXTERNAL MODULE: ../node_modules/lodash-es/isArray.js
var isArray = __webpack_require__(5);

// CONCATENATED MODULE: ../node_modules/lodash-es/_isFlattenable.js




/** Built-in value references. */
var spreadableSymbol = _Symbol["a" /* default */] ? _Symbol["a" /* default */].isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return Object(isArray["a" /* default */])(value) || Object(isArguments["a" /* default */])(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

/* harmony default export */ var _isFlattenable = (isFlattenable);

// CONCATENATED MODULE: ../node_modules/lodash-es/_baseFlatten.js



/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = _isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        Object(_arrayPush["a" /* default */])(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

/* harmony default export */ var _baseFlatten = __webpack_exports__["a"] = (baseFlatten);


/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ../react-lib/src/components/utils/Redux/Connect.jsx + 1 modules
var Connect = __webpack_require__(29);

// CONCATENATED MODULE: ../react-lib/src/lib/lifted-components/core/index.js
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/* eslint-disable no-underscore-dangle */
var core_lifted = function lifted(WrappedComponent) {
  var _class, _temp;

  return _temp = _class =
  /*#__PURE__*/
  function (_WrappedComponent) {
    _inherits(LiftedComponent, _WrappedComponent);

    function LiftedComponent() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck(this, LiftedComponent);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(LiftedComponent)).call.apply(_getPrototypeOf2, [this].concat(args)));
      _this.state = void 0;
      _this.props = void 0;
      _this.initialized = false;
      return _this;
    }

    _createClass(LiftedComponent, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        if (_get(_getPrototypeOf(LiftedComponent.prototype), "componentDidMount", this)) _get(_getPrototypeOf(LiftedComponent.prototype), "componentDidMount", this).call(this);

        if (this.props.state) {
          this.props.onLiftedChange(this.props.state);
        }
      }
    }, {
      key: "setState",
      value: function setState(reducer, callback) {
        if (typeof reducer === 'function' && this.props.onLiftedChange) {
          this.props.onLiftedChange(reducer(this.state, this.props));
        } else if (this.props.onLiftedChange) {
          this.props.onLiftedChange(reducer);
        }

        if (callback) callback();
      }
    }, {
      key: "state",
      get: function get() {
        return this.props && this.props.state || LiftedComponent.initialState;
      },
      set: function set(value) {
        if (!this.initialized && value) {
          this.initialized = true;
          LiftedComponent.initialState = value;
          this.props.onLiftedChange(value);
        }
      }
    }]);

    return LiftedComponent;
  }(WrappedComponent), _class.initialState = void 0, _class.displayName = "Lifted".concat(WrappedComponent.displayName || WrappedComponent.name || ''), _temp;
};
// CONCATENATED MODULE: ../react-lib/src/lib/lifted-components/redux/index.jsx
/* unused harmony export MOUNT_LIFTED_COMPONENT */
/* unused harmony export UNMOUNT_LIFTED_COMPONENT */
/* unused harmony export UPDATE_LIFTED_COMPONENT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return reducer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return redux_lifted; });
function redux__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { redux__typeof = function _typeof(obj) { return typeof obj; }; } else { redux__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return redux__typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function redux__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function redux__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function redux__createClass(Constructor, protoProps, staticProps) { if (protoProps) redux__defineProperties(Constructor.prototype, protoProps); if (staticProps) redux__defineProperties(Constructor, staticProps); return Constructor; }

function redux__possibleConstructorReturn(self, call) { if (call && (redux__typeof(call) === "object" || typeof call === "function")) { return call; } return redux__assertThisInitialized(self); }

function redux__assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function redux__getPrototypeOf(o) { redux__getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return redux__getPrototypeOf(o); }

function redux__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) redux__setPrototypeOf(subClass, superClass); }

function redux__setPrototypeOf(o, p) { redux__setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return redux__setPrototypeOf(o, p); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return redux__typeof(key) === "symbol" ? key : String(key); }

function _toPrimitive(input, hint) { if (redux__typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (redux__typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }

/* eslint-disable no-plusplus, no-underscore-dangle */



var MOUNT_LIFTED_COMPONENT = '@lifted-components/MOUNT_LIFTED_COMPONENT';
var UNMOUNT_LIFTED_COMPONENT = '@lifted-components/UNMOUNT_LIFTED_COMPONENT';
var UPDATE_LIFTED_COMPONENT = '@lifted-components/UPDATE_LIFTED_COMPONENT';

var mountComponent = function mountComponent(id, name) {
  return {
    type: MOUNT_LIFTED_COMPONENT,
    id: id,
    name: name
  };
};

var unmountComponent = function unmountComponent(id) {
  return {
    type: UNMOUNT_LIFTED_COMPONENT,
    id: id
  };
};

var updateComponent = function updateComponent(id, updates) {
  return {
    type: UPDATE_LIFTED_COMPONENT,
    id: id,
    updates: updates
  };
};

var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case MOUNT_LIFTED_COMPONENT:
      if (state[action.id]) {
        throw new Error("[LiftedComponents] Error mounting lifted component ".concat(action.name ? action.name : '', ": An instance of this component is already mounted."));
      }

      return state;

    case UNMOUNT_LIFTED_COMPONENT:
      {
        var _action$id = action.id,
            removedState = state[_action$id],
            rest = _objectWithoutProperties(state, [_action$id].map(_toPropertyKey));

        return rest;
      }

    case UPDATE_LIFTED_COMPONENT:
      return _objectSpread({}, state, _defineProperty({}, action.id, _objectSpread({}, state[action.id] || {}, {}, action.updates)));

    default:
      return state;
  }
};
var id = 0;
var redux_lifted = function lifted(WrappedComponent) {
  var _class, _temp;

  var LiftedComponent = core_lifted(WrappedComponent);
  var liftedId = "lifted_".concat(id++);

  var select = function select(state) {
    return state.lifted[liftedId] || LiftedComponent.initialState;
  };

  var update = function update(updates) {
    return updateComponent(liftedId, updates);
  };

  var matchAction = function matchAction(action) {
    return action.type === UPDATE_LIFTED_COMPONENT && action.id === liftedId;
  };

  var selector = function selector(state) {
    return {
      _componentState: select(state)
    };
  };

  var actions = {
    // $FlowFixMe This needs to be refactored to use ducks
    _onUpdate: update
  };
  return _temp = _class =
  /*#__PURE__*/
  function (_Component) {
    redux__inherits(ReduxLifted, _Component);

    function ReduxLifted() {
      redux__classCallCheck(this, ReduxLifted);

      return redux__possibleConstructorReturn(this, redux__getPrototypeOf(ReduxLifted).apply(this, arguments));
    }

    redux__createClass(ReduxLifted, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            innerRef = _this$props.innerRef,
            other = _objectWithoutProperties(_this$props, ["innerRef"]);

        return (// $FlowFixMe This needs to be refactored to use ducks
          react_default.a.createElement(Connect["a" /* default */], {
            selector: selector // $FlowFixMe This needs to be refactored to use ducks
            ,
            actions: actions,
            onMount: function onMount() {
              return mountComponent(liftedId, ReduxLifted.displayName);
            },
            onUnmount: function onUnmount() {
              return unmountComponent(liftedId);
            }
          }, function (_ref) {
            var _componentState = _ref._componentState,
                _onUpdate = _ref._onUpdate;
            return react_default.a.createElement(LiftedComponent, _extends({}, other, {
              ref: innerRef,
              state: _componentState,
              onLiftedChange: _onUpdate
            }));
          })
        );
      }
    }]);

    return ReduxLifted;
  }(react["Component"]), _class.displayName = "ReduxLifted".concat(WrappedComponent.displayName || WrappedComponent.name || ''), _class.select = function (state) {
    return select(state) || {};
  }, _class.update = update, _class.matchAction = matchAction, _temp;
};

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _objectSpread({
    opk: '',
    apiUrl: '',
    email: '',
    emailSha: '',
    firstName: '',
    lastName: '',
    phone: '',
    isStaff: false,
    performanceMetricsEnabled: false,
    postalCode: '',
    hasDogs: false,
    isActiveServiceProvider: false,
    listsAllServices: false,
    shouldPromptForPets: false,
    slug: '',
    smallPhotoUrl: '',
    timeZone: '',
    unreadMessageCount: 0,
    showAdminToolbar: false
  }, opts);
});

/***/ }),
/* 141 */,
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/redux-saga/es/internal/io.js
var io = __webpack_require__(11);

// EXTERNAL MODULE: ../node_modules/redux-saga/es/internal/sagaHelpers/index.js + 4 modules
var sagaHelpers = __webpack_require__(99);

// CONCATENATED MODULE: ../node_modules/redux-saga/es/internal/io-helpers.js



function takeEvery(patternOrChannel, worker) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  return io["e" /* fork */].apply(undefined, [sagaHelpers["a" /* takeEveryHelper */], patternOrChannel, worker].concat(args));
}

function takeLatest(patternOrChannel, worker) {
  for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
    args[_key2 - 2] = arguments[_key2];
  }

  return io["e" /* fork */].apply(undefined, [sagaHelpers["b" /* takeLatestHelper */], patternOrChannel, worker].concat(args));
}

function throttle(ms, pattern, worker) {
  for (var _len3 = arguments.length, args = Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
    args[_key3 - 3] = arguments[_key3];
  }

  return io["e" /* fork */].apply(undefined, [sagaHelpers["c" /* throttleHelper */], ms, pattern, worker].concat(args));
}
// CONCATENATED MODULE: ../node_modules/redux-saga/es/effects.js
/* unused concated harmony import take */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return io["g" /* take */]; });
/* unused concated harmony import takem */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import put */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import all */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import race */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return io["c" /* call */]; });
/* unused concated harmony import apply */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import cps */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import fork */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return io["e" /* fork */]; });
/* unused concated harmony import spawn */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import join */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import cancel */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return io["d" /* cancel */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return io["f" /* select */]; });
/* unused concated harmony import actionChannel */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return io["a" /* actionChannel */]; });
/* unused concated harmony import cancelled */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import flush */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import getContext */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import setContext */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import takeEvery */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return takeEvery; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "c", function() { return takeLatest; });
/* unused concated harmony import throttle */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return throttle; });




/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Input__ = __webpack_require__(313);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Input__["b"]; });


/***/ }),
/* 144 */,
/* 145 */,
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isObject_js__ = __webpack_require__(8);


/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

/* harmony default export */ __webpack_exports__["a"] = (baseCreate);


/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export generateActionTests */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(104);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-env jest */

var ERROR_MESSAGE_FIXTURE = 'Error Message';

var generateActions = function generateActions(action) {
  var _ref;

  return _ref = {}, _defineProperty(_ref, "".concat(action, "Pending"), function Pending() {
    return function (state) {
      return _objectSpread({}, state, {
        loading: true,
        errorMessage: ''
      });
    };
  }), _defineProperty(_ref, "".concat(action, "Success"), function Success(response) {
    return function (state) {
      var _objectSpread2;

      return _objectSpread({}, state, (_objectSpread2 = {}, _defineProperty(_objectSpread2, "".concat(action, "Response"), response), _defineProperty(_objectSpread2, "loading", false), _defineProperty(_objectSpread2, "errorMessage", ''), _objectSpread2));
    };
  }), _defineProperty(_ref, "".concat(action, "Failure"), function Failure(errorMessage) {
    return function (state) {
      return _objectSpread({}, state, {
        errorMessage: errorMessage,
        loading: false
      });
    };
  }), _ref;
};

var generateActionTests = function generateActionTests(action, responseFixture, actions, options, reducer) {
  describe(action, function () {
    var dispatch;
    var getState;
    beforeEach(function () {
      var _createStore = Object(__WEBPACK_IMPORTED_MODULE_0_redux__["createStore"])(Object(__WEBPACK_IMPORTED_MODULE_0_redux__["combineReducers"])({
        test: reducer
      }));

      dispatch = _createStore.dispatch;
      getState = _createStore.getState;
    });
    it("sets ".concat(action, "Pending state"), function () {
      expect(getState().test.loading).toBe(options.initialState.loading);
      dispatch(actions["".concat(action, "Pending")]());
      expect(getState().test.loading).toBe(true);
    });
    it("sets ".concat(action, "Failure state"), function () {
      expect(getState().test.errorMessage).toBe(options.initialState.errorMessage);
      dispatch(actions["".concat(action, "Failure")](ERROR_MESSAGE_FIXTURE));
      expect(getState().test.errorMessage).toBe(ERROR_MESSAGE_FIXTURE);
    });
    it("sets ".concat(action, "Success state"), function () {
      expect(getState().test["".concat(action, "Response")]).toEqual(options.initialState["".concat(action, "Response")]);
      dispatch(actions["".concat(action, "Success")](responseFixture));
      expect(getState().test["".concat(action, "Response")]).toEqual(responseFixture);
    });
  });
};
/* harmony default export */ __webpack_exports__["a"] = (generateActions);

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../react-lib/src/factories/fetchCurrentUserResponseFactory.js
var fetchCurrentUserResponseFactory = __webpack_require__(239);

// EXTERNAL MODULE: ../react-lib/src/lib/redux-duck/index.js + 2 modules
var redux_duck = __webpack_require__(21);

// EXTERNAL MODULE: ../utilities/apiUrl.js
var apiUrl = __webpack_require__(51);

// EXTERNAL MODULE: ../utilities/object-utilities.js
var object_utilities = __webpack_require__(22);

// EXTERNAL MODULE: ../utilities/axiosUtils/index.client.js
var index_client = __webpack_require__(45);

// EXTERNAL MODULE: ../react-lib/src/factories/userFactory.js
var userFactory = __webpack_require__(140);

// EXTERNAL MODULE: ../utilities/utm.js
var utm = __webpack_require__(388);

// EXTERNAL MODULE: ../react-lib/src/apis/DefaultAPIErrorHandler.js
var DefaultAPIErrorHandler = __webpack_require__(30);

// CONCATENATED MODULE: ../react-lib/src/apis/currentUser.api.js
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }







var CURRENT_USER_URL = Object(apiUrl["b" /* fullApiUrl */])('frontend/current-user/');
var get =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(expressParams) {
    var ai, _ref2, data, camelData;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            ai = Object(index_client["a" /* getAxiosInstance */])(expressParams);
            _context.prev = 1;
            _context.next = 4;
            return ai.get(CURRENT_USER_URL);

          case 4:
            _ref2 = _context.sent;
            data = _ref2.data;
            camelData = Object(object_utilities["a" /* camelize */])(data, true, utm["a" /* UTM_PARAMS */]);
            camelData.currentUser = camelData.currentUser || Object(userFactory["a" /* default */])();
            camelData.realUser = camelData.realUser || Object(userFactory["a" /* default */])();
            return _context.abrupt("return", camelData);

          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](1);
            return _context.abrupt("return", Object(DefaultAPIErrorHandler["a" /* default */])(_context.t0, 'There was an error while fetching the current user.'));

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 12]]);
  }));

  return function get(_x) {
    return _ref.apply(this, arguments);
  };
}();
/* harmony default export */ var currentUser_api = ({
  get: get
});
// EXTERNAL MODULE: ../utilities/sentry.client.js
var sentry_client = __webpack_require__(373);

// EXTERNAL MODULE: ../utilities/reportError.js
var reportError = __webpack_require__(34);

// EXTERNAL MODULE: ../utilities/retry.client.js
var retry_client = __webpack_require__(261);

// EXTERNAL MODULE: ../react-lib/src/redux/ducks/generateActions.js
var generateActions = __webpack_require__(147);

// CONCATENATED MODULE: ../react-lib/src/redux/ducks/currentUser.duck.js
/* unused harmony export options */
/* unused harmony export actions */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return currentUser_duck_selectors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return currentUser_duck_effects; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return reducer; });
function currentUser_duck_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function currentUser_duck__asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { currentUser_duck_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { currentUser_duck_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








var options = {
  name: 'currentUser',
  initialState: {
    errorMessage: '',
    loading: true,
    logoutPending: false,
    fetchCurrentUserResponse: Object(fetchCurrentUserResponseFactory["a" /* default */])()
  },
  // $FlowFixMe
  actions: _objectSpread({}, Object(generateActions["a" /* default */])('fetchCurrentUser'), {}, Object(generateActions["a" /* default */])('logoutCurrentUser')),
  effects: {
    fetchCurrentUser: function fetchCurrentUser() {
      return (
        /*#__PURE__*/
        function () {
          var _ref4 = currentUser_duck__asyncToGenerator(
          /*#__PURE__*/
          regeneratorRuntime.mark(function _callee(dispatch, getState, _ref, _ref2, selectors, _ref3) {
            var fetchCurrentUserPending, fetchCurrentUserSuccess, fetchCurrentUserFailure, initSentryUser, expressParams, fetchCurrentUserResponse;
            return regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    fetchCurrentUserPending = _ref.fetchCurrentUserPending, fetchCurrentUserSuccess = _ref.fetchCurrentUserSuccess, fetchCurrentUserFailure = _ref.fetchCurrentUserFailure;
                    initSentryUser = _ref2.initSentryUser;
                    expressParams = _ref3.expressParams;
                    dispatch(fetchCurrentUserPending());
                    _context.prev = 4;
                    _context.next = 7;
                    return get(expressParams);

                  case 7:
                    fetchCurrentUserResponse = _context.sent;
                    dispatch(fetchCurrentUserSuccess(fetchCurrentUserResponse));
                    dispatch(initSentryUser());
                    _context.next = 15;
                    break;

                  case 12:
                    _context.prev = 12;
                    _context.t0 = _context["catch"](4);

                    if (_context.t0.status === 404) {
                      dispatch(fetchCurrentUserSuccess(Object(fetchCurrentUserResponseFactory["a" /* default */])()));
                    } else {
                      dispatch(fetchCurrentUserFailure(_context.t0.message));
                      Object(reportError["a" /* default */])(_context.t0);
                    }

                  case 15:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee, null, [[4, 12]]);
          }));

          return function (_x, _x2, _x3, _x4, _x5, _x6) {
            return _ref4.apply(this, arguments);
          };
        }()
      );
    },
    logoutCurrentUser: function logoutCurrentUser(_ref5) {
      var nextLocation = _ref5.nextLocation,
          ref = _ref5.ref;
      return (
        /*#__PURE__*/
        function () {
          var _ref7 = currentUser_duck__asyncToGenerator(
          /*#__PURE__*/
          regeneratorRuntime.mark(function _callee2( // Only call this on the client, never the server
          dispatch, getState, _ref6) {
            var logoutCurrentUserPending, logoutCurrentUserSuccess, logoutCurrentUserFailure, localStorage, sessionStorage, encodedLocation;
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    logoutCurrentUserPending = _ref6.logoutCurrentUserPending, logoutCurrentUserSuccess = _ref6.logoutCurrentUserSuccess, logoutCurrentUserFailure = _ref6.logoutCurrentUserFailure;
                    dispatch(logoutCurrentUserPending());
                    _context2.prev = 2;
                    _context2.next = 5;
                    return Object(retry_client["a" /* default */])(function () {
                      return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 2301));
                    });

                  case 5:
                    localStorage = _context2.sent;
                    _context2.next = 8;
                    return Object(retry_client["a" /* default */])(function () {
                      return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 2302));
                    });

                  case 8:
                    sessionStorage = _context2.sent;
                    localStorage.clear();
                    sessionStorage.clear();
                    dispatch(logoutCurrentUserSuccess(Object(fetchCurrentUserResponseFactory["a" /* default */])()));
                    encodedLocation = encodeURIComponent(nextLocation);
                    window.location.href = "/logout/?next=".concat(encodedLocation).concat(ref ? "&".concat(ref) : ''); // This is the actual logout

                    _context2.next = 20;
                    break;

                  case 16:
                    _context2.prev = 16;
                    _context2.t0 = _context2["catch"](2);
                    dispatch(logoutCurrentUserFailure(_context2.t0.message));
                    Object(reportError["a" /* default */])(_context2.t0);

                  case 20:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2, null, [[2, 16]]);
          }));

          return function (_x7, _x8, _x9) {
            return _ref7.apply(this, arguments);
          };
        }()
      );
    },
    initSentryUser: function initSentryUser() {
      return (
        /*#__PURE__*/
        function () {
          var _ref9 = currentUser_duck__asyncToGenerator(
          /*#__PURE__*/
          regeneratorRuntime.mark(function _callee3(dispatch, getState, actions, effects, _ref8) {
            var getOpk;
            return regeneratorRuntime.wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    getOpk = _ref8.getOpk;
                    Object(sentry_client["c" /* configureScope */])(function (scope) {
                      return scope.setUser({
                        id: getOpk(getState())
                      });
                    });

                  case 2:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee3);
          }));

          return function (_x10, _x11, _x12, _x13, _x14) {
            return _ref9.apply(this, arguments);
          };
        }()
      );
    }
  },
  selectors: {
    getCurrentUser: function getCurrentUser(getState, createSelector) {
      return createSelector([getState], function (x) {
        return x.fetchCurrentUserResponse.currentUser;
      });
    },
    getRealUser: function getRealUser(getState, createSelector) {
      return createSelector([getState], function (x) {
        return x.fetchCurrentUserResponse.realUser;
      });
    },
    isLoading: function isLoading(getState, createSelector) {
      return createSelector([getState], function (x) {
        return x.loading;
      });
    },
    getErrorMessage: function getErrorMessage(getState, createSelector) {
      return createSelector([getState], function (x) {
        return x.errorMessage;
      });
    },
    getApiUrl: function getApiUrl(getState, createSelector, _ref10) {
      var getCurrentUser = _ref10.getCurrentUser;
      return createSelector([getCurrentUser], function (x) {
        return x.apiUrl;
      });
    },
    getOpk: function getOpk(getState, createSelector, _ref11) {
      var getCurrentUser = _ref11.getCurrentUser;
      return createSelector([getCurrentUser], function (x) {
        return x.opk;
      });
    },
    isAuthenticated: function isAuthenticated(getState, createSelector) {
      return createSelector([getState], function (x) {
        return x.fetchCurrentUserResponse.authenticated;
      });
    },
    isImpersonating: function isImpersonating(getState, createSelector, _ref12) {
      var getRealUser = _ref12.getRealUser;
      return createSelector([getRealUser], function (x) {
        return !!x.opk.length;
      });
    },
    getPeopleUrl: function getPeopleUrl(getState, createSelector, _ref13) {
      var getCurrentUser = _ref13.getCurrentUser;
      return createSelector([getCurrentUser], function (x) {
        return "/admin/people/person/?slug=".concat(x.slug);
      });
    },
    isNewCustomer: function isNewCustomer(getState, createSelector, _ref14) {
      var getCurrentUser = _ref14.getCurrentUser;
      return createSelector([getCurrentUser], function (x) {
        return x.isNewCustomer;
      });
    },
    getPostalCode: function getPostalCode(getState, createSelector, _ref15) {
      var getCurrentUser = _ref15.getCurrentUser;
      return createSelector([getCurrentUser], function (x) {
        return x.postalCode;
      });
    },
    getUtmParams: function getUtmParams(getState, createSelector, _ref16) {
      var getCurrentUser = _ref16.getCurrentUser;
      return createSelector([getCurrentUser], function (x) {
        return x.session && x.session.utmParameters;
      });
    },
    getFirstHttpReferrer: function getFirstHttpReferrer(getState, createSelector, _ref17) {
      var getCurrentUser = _ref17.getCurrentUser;
      return createSelector([getCurrentUser], function (x) {
        return x.session && x.session.firstHttpReferrer;
      });
    }
  }
};

var _ref18 = Object(redux_duck["a" /* createDuck */])(options),
    currentUser_duck_actions = _ref18.actions,
    currentUser_duck_selectors = _ref18.selectors,
    currentUser_duck_effects = _ref18.effects,
    reducer = _ref18.reducer;



/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/lodash-es/_baseClone.js + 13 modules
var _baseClone = __webpack_require__(299);

// CONCATENATED MODULE: ../node_modules/lodash-es/cloneDeep.js


/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return Object(_baseClone["a" /* default */])(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}

/* harmony default export */ var lodash_es_cloneDeep = (cloneDeep);

// EXTERNAL MODULE: ../node_modules/lodash-es/_baseSet.js
var _baseSet = __webpack_require__(301);

// CONCATENATED MODULE: ../node_modules/lodash-es/set.js


/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */
function set(object, path, value) {
  return object == null ? object : Object(_baseSet["a" /* default */])(object, path, value);
}

/* harmony default export */ var lodash_es_set = (set);

// EXTERNAL MODULE: ../react-lib/src/lib/redux-duck/index.js + 2 modules
var redux_duck = __webpack_require__(21);

// EXTERNAL MODULE: ../react-lib/src/factories/fetchFrontendConfigurationResponseFactory.js
var fetchFrontendConfigurationResponseFactory = __webpack_require__(263);

// EXTERNAL MODULE: ../utilities/apiUrl.js
var apiUrl = __webpack_require__(51);

// EXTERNAL MODULE: ../utilities/object-utilities.js
var object_utilities = __webpack_require__(22);

// EXTERNAL MODULE: ../utilities/axiosUtils/index.client.js
var index_client = __webpack_require__(45);

// EXTERNAL MODULE: ../react-lib/src/apis/DefaultAPIErrorHandler.js
var DefaultAPIErrorHandler = __webpack_require__(30);

// CONCATENATED MODULE: ../react-lib/src/apis/frontendConfiguration.api.js
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }





var CONFIGURATION_URL = Object(apiUrl["b" /* fullApiUrl */])('frontend/configuration/'); // Note - this is a form action url, not an api url.  To be cleaned up in DEV-42041

var SET_LANGUAGE_URL = '/set-language/';
var get =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(expressParams) {
    var ai, _ref2, data, camelData;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            ai = Object(index_client["a" /* getAxiosInstance */])(expressParams);
            _context.prev = 1;
            _context.next = 4;
            return ai.get(CONFIGURATION_URL);

          case 4:
            _ref2 = _context.sent;
            data = _ref2.data;
            camelData = Object(object_utilities["a" /* camelize */])(data, true);
            return _context.abrupt("return", camelData);

          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](1);
            return _context.abrupt("return", Object(DefaultAPIErrorHandler["a" /* default */])(_context.t0, 'There was an error while fetching the frontend configuration.'));

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 10]]);
  }));

  return function get(_x) {
    return _ref.apply(this, arguments);
  };
}();
var frontendConfiguration_api_setLanguage =
/*#__PURE__*/
function () {
  var _ref4 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee2(_ref3) {
    var language, ai, formData;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            language = _ref3.language;
            ai = Object(index_client["a" /* getAxiosInstance */])();
            formData = new FormData();
            formData.append('language', language);
            _context2.prev = 4;
            _context2.next = 7;
            return ai({
              method: 'post',
              url: SET_LANGUAGE_URL,
              data: formData,
              config: {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded'
                }
              }
            });

          case 7:
            return _context2.abrupt("return", Promise.resolve());

          case 10:
            _context2.prev = 10;
            _context2.t0 = _context2["catch"](4);
            throw Object(DefaultAPIErrorHandler["a" /* default */])(_context2.t0, 'There was an error setting your current language');

          case 13:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[4, 10]]);
  }));

  return function setLanguage(_x2) {
    return _ref4.apply(this, arguments);
  };
}();
/* harmony default export */ var frontendConfiguration_api = ({
  get: get,
  setLanguage: frontendConfiguration_api_setLanguage
});
// EXTERNAL MODULE: ../utilities/reportError.js
var reportError = __webpack_require__(34);

// EXTERNAL MODULE: ../shared/js/constants/i18n/datetime/index.js + 1 modules
var datetime = __webpack_require__(219);

// EXTERNAL MODULE: ../shared/js/constants/i18n/language.js
var i18n_language = __webpack_require__(124);

// EXTERNAL MODULE: ../react-lib/src/redux/ducks/generateActions.js
var generateActions = __webpack_require__(147);

// CONCATENATED MODULE: ../react-lib/src/redux/ducks/frontendConfiguration.duck.js
/* unused harmony export options */
/* unused harmony export actions */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return frontendConfiguration_duck_selectors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return frontendConfiguration_duck_effects; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return reducer; });
function frontendConfiguration_duck_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function frontendConfiguration_duck__asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { frontendConfiguration_duck_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { frontendConfiguration_duck_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }










var DEFAULT_CC_TLD = 'US';
var options = {
  name: 'frontendConfiguration',
  initialState: {
    isLoading: false,
    errorMessage: '',
    fetchFrontendConfigurationResponse: Object(fetchFrontendConfigurationResponseFactory["a" /* default */])()
  },
  // $FlowFixMe
  actions: _objectSpread({}, Object(generateActions["a" /* default */])('fetchFrontendConfiguration'), {
    setLanguage: function setLanguage(_ref) {
      var language = _ref.language;
      return function (state) {
        return lodash_es_set(lodash_es_cloneDeep(state), 'fetchFrontendConfigurationResponse.settings.language', language);
      };
    }
  }),
  effects: {
    fetchFrontendConfiguration: function fetchFrontendConfiguration() {
      return (
        /*#__PURE__*/
        function () {
          var _ref4 = frontendConfiguration_duck__asyncToGenerator(
          /*#__PURE__*/
          regeneratorRuntime.mark(function _callee(dispatch, getState, _ref2, effects, selectors, _ref3) {
            var fetchFrontendConfigurationPending, fetchFrontendConfigurationSuccess, fetchFrontendConfigurationFailure, expressParams, fetchFrontendConfigurationResponse;
            return regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    fetchFrontendConfigurationPending = _ref2.fetchFrontendConfigurationPending, fetchFrontendConfigurationSuccess = _ref2.fetchFrontendConfigurationSuccess, fetchFrontendConfigurationFailure = _ref2.fetchFrontendConfigurationFailure;
                    expressParams = _ref3.expressParams;
                    dispatch(fetchFrontendConfigurationPending());
                    _context.prev = 3;
                    _context.next = 6;
                    return get(expressParams);

                  case 6:
                    fetchFrontendConfigurationResponse = _context.sent;
                    dispatch(fetchFrontendConfigurationSuccess(fetchFrontendConfigurationResponse));
                    _context.next = 14;
                    break;

                  case 10:
                    _context.prev = 10;
                    _context.t0 = _context["catch"](3);
                    dispatch(fetchFrontendConfigurationFailure(_context.t0.message));
                    Object(reportError["a" /* default */])(_context.t0);

                  case 14:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee, null, [[3, 10]]);
          }));

          return function (_x, _x2, _x3, _x4, _x5, _x6) {
            return _ref4.apply(this, arguments);
          };
        }()
      );
    },
    setLanguage: function setLanguage(_ref5) {
      var language = _ref5.language;
      return (
        /*#__PURE__*/
        function () {
          var _ref6 = frontendConfiguration_duck__asyncToGenerator(
          /*#__PURE__*/
          regeneratorRuntime.mark(function _callee2(dispatch, getState, duckActions) {
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    dispatch(duckActions.setLanguage({
                      language: language
                    }));
                    _context2.next = 3;
                    return frontendConfiguration_api_setLanguage({
                      language: language
                    });

                  case 3:
                    // Note - we need to refresh the page here in order to make sure everything
                    // gets rerendered in the selected language
                    // eslint-disable-next-line rover/no-platform-specific-globals-or-imports
                    if (window && window.location) {
                      // eslint-disable-next-line rover/no-platform-specific-globals-or-imports
                      window.location.reload();
                    }

                  case 4:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2);
          }));

          return function (_x7, _x8, _x9) {
            return _ref6.apply(this, arguments);
          };
        }()
      );
    }
  },
  selectors: {
    getFrontendConfiguration: function getFrontendConfiguration(getState, createSelector) {
      return createSelector([getState], function (x) {
        return x.fetchFrontendConfigurationResponse;
      });
    },
    getFlags: function getFlags(getState, createSelector, _ref7) {
      var getFrontendConfiguration = _ref7.getFrontendConfiguration;
      return createSelector([getFrontendConfiguration], function (x) {
        return x.flags;
      });
    },
    getSettings: function getSettings(getState, createSelector, _ref8) {
      var getFrontendConfiguration = _ref8.getFrontendConfiguration;
      return createSelector([getFrontendConfiguration], function (x) {
        return x.settings;
      });
    },
    isFlagActive: function isFlagActive(getState, createSelector, _ref9) {
      var getFlags = _ref9.getFlags;
      return createSelector([getFlags], function (flags) {
        return function (flagToCheck) {
          return !!flags[flagToCheck];
        };
      });
    },
    getLanguage: function getLanguage(getState, createSelector, _ref10) {
      var getSettings = _ref10.getSettings;
      return createSelector([getSettings], function (settings) {
        return settings.language || i18n_language["a" /* DEFAULT_LANG */];
      });
    },
    getDateTimeFormatMap: function getDateTimeFormatMap(getState, createSelector, _ref11) {
      var getLanguage = _ref11.getLanguage;
      return createSelector([getLanguage], function (language) {
        return Object(datetime["a" /* default */])(language);
      });
    },
    getCcTld: function getCcTld(getState, createSelector, _ref12) {
      var getSettings = _ref12.getSettings;
      return createSelector([getSettings], function (settings) {
        return settings.ccTld || DEFAULT_CC_TLD;
      });
    },
    getIsBeforeHoliday: function getIsBeforeHoliday(getState, createSelector, _ref13) {
      var getSettings = _ref13.getSettings;
      return createSelector([getSettings], function (settings) {
        return settings.isBeforeHoliday;
      });
    },
    getCsrfCookieName: function getCsrfCookieName(getState, createSelector, _ref14) {
      var getSettings = _ref14.getSettings;
      return createSelector([getSettings], function (settings) {
        return settings.getCsrfCookieName;
      });
    }
  }
};

var _ref15 = Object(redux_duck["a" /* createDuck */])(options),
    actions = _ref15.actions,
    frontendConfiguration_duck_selectors = _ref15.selectors,
    frontendConfiguration_duck_effects = _ref15.effects,
    reducer = _ref15.reducer;



/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MapCache_js__ = __webpack_require__(56);


/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || __WEBPACK_IMPORTED_MODULE_0__MapCache_js__["a" /* default */]);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = __WEBPACK_IMPORTED_MODULE_0__MapCache_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (memoize);


/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (elevation) {
  var y = elevation;
  var blur = Math.pow(2, 1 + elevation); // 4, 8, 16, 32....

  var alpha = 22 - 2 * elevation;
  return "box-shadow: 0 ".concat(y, "px ").concat(blur, "px rgba(0, 0, 0, 0.").concat(alpha, ");");
});

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseEach_js__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__ = __webpack_require__(23);



/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = Object(__WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__["a" /* default */])(collection) ? Array(collection.length) : [];

  Object(__WEBPACK_IMPORTED_MODULE_0__baseEach_js__["a" /* default */])(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseMap);


/***/ }),
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (setToArray);


/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/lodash-es/_isPrototype.js
var _isPrototype = __webpack_require__(75);

// EXTERNAL MODULE: ../node_modules/lodash-es/_overArg.js
var _overArg = __webpack_require__(348);

// CONCATENATED MODULE: ../node_modules/lodash-es/_nativeKeys.js


/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = Object(_overArg["a" /* default */])(Object.keys, Object);

/* harmony default export */ var _nativeKeys = (nativeKeys);

// CONCATENATED MODULE: ../node_modules/lodash-es/_baseKeys.js



/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _baseKeys_hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!Object(_isPrototype["a" /* default */])(object)) {
    return _nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (_baseKeys_hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ var _baseKeys = __webpack_exports__["a"] = (baseKeys);


/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/lodash-es/_MapCache.js + 14 modules
var _MapCache = __webpack_require__(56);

// CONCATENATED MODULE: ../node_modules/lodash-es/_setCacheAdd.js
/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/* harmony default export */ var _setCacheAdd = (setCacheAdd);

// CONCATENATED MODULE: ../node_modules/lodash-es/_setCacheHas.js
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

/* harmony default export */ var _setCacheHas = (setCacheHas);

// CONCATENATED MODULE: ../node_modules/lodash-es/_SetCache.js




/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new _MapCache["a" /* default */];
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = _setCacheAdd;
SetCache.prototype.has = _setCacheHas;

/* harmony default export */ var _SetCache = __webpack_exports__["a"] = (SetCache);


/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

/* harmony default export */ __webpack_exports__["a"] = (cacheHas);


/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(10);



/* Built-in method references that are verified to be native. */
var Set = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'Set');

/* harmony default export */ __webpack_exports__["a"] = (Set);


/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Color; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types_Enum__ = __webpack_require__(6);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }



var Color =
/*#__PURE__*/
function (_Enum) {
  _inherits(Color, _Enum);

  function Color() {
    _classCallCheck(this, Color);

    return _possibleConstructorReturn(this, _getPrototypeOf(Color).apply(this, arguments));
  }

  _createClass(Color, [{
    key: "toString",
    // #fff
    // #DDD
    // #333
    // #f2f2f2
    // #00BD70
    // #00BD
    // #FFF
    // #00a461
    // #000
    // transparent
    // #FFF
    // #000
    // transparent
    // #14a4be
    // #0d6879
    // transparent
    // #fff
    // #e8fcf7
    // #e4f7f2
    // #dff2ed
    // #11a864
    value: function toString() {
      return "rgba(".concat(this.value.r, ", ").concat(this.value.g, ", ").concat(this.value.b, ", ").concat(this.value.a, ")");
    }
  }]);

  return Color;
}(__WEBPACK_IMPORTED_MODULE_0__types_Enum__["a" /* default */]);

Color.BUTTON_DEFAULT_BACKGROUND = new Color({
  r: 255,
  g: 255,
  b: 255,
  a: 1
});
Color.BUTTON_DEFAULT_BORDER = new Color({
  r: 221,
  g: 221,
  b: 221,
  a: 1
});
Color.BUTTON_DEFAULT_COLOR = new Color({
  r: 51,
  g: 51,
  b: 51,
  a: 1
});
Color.BUTTON_DEFAULT_HOVER = new Color({
  r: 242,
  g: 242,
  b: 242,
  a: 1
});
Color.BUTTON_PRIMARY_BACKGROUND = new Color({
  r: 0,
  g: 189,
  b: 112,
  a: 1
});
Color.BUTTON_PRIMARY_BORDER = new Color({
  r: 0,
  g: 189,
  b: 112,
  a: 1
});
Color.BUTTON_PRIMARY_COLOR = new Color({
  r: 255,
  g: 255,
  b: 255,
  a: 1
});
Color.BUTTON_PRIMARY_HOVER = new Color({
  r: 0,
  g: 164,
  b: 97,
  a: 1
});
Color.BUTTON_DARK_BACKGROUND = new Color({
  r: 0,
  g: 0,
  b: 0,
  a: 0.25
});
Color.BUTTON_DARK_BORDER = new Color({
  r: 0,
  g: 0,
  b: 0,
  a: 0
});
Color.BUTTON_DARK_COLOR = new Color({
  r: 255,
  g: 255,
  b: 255,
  a: 1
});
Color.BUTTON_DARK_HOVER = new Color({
  r: 0,
  g: 0,
  b: 0,
  a: 0.35
});
Color.BUTTON_TEXT_BACKGROUND = new Color({
  r: 0,
  g: 0,
  b: 0,
  a: 0
});
Color.BUTTON_TEXT_COLOR = new Color({
  r: 20,
  g: 164,
  b: 190,
  a: 1
});
Color.BUTTON_TEXT_HOVER = new Color({
  r: 13,
  g: 104,
  b: 121,
  a: 1
});
Color.BUTTON_TEXT_LIGHT_BACKGROUND = new Color({
  r: 0,
  g: 0,
  b: 0,
  a: 0
});
Color.BUTTON_TEXT_LIGHT_COLOR = new Color({
  r: 255,
  g: 255,
  b: 255,
  a: 1
});
Color.BUTTON_TERTIARY_BACKGROUND = new Color({
  r: 232,
  g: 252,
  b: 247,
  a: 1
});
Color.BUTTON_TERTIARY_BACKGROUND_HOVER = new Color({
  r: 228,
  g: 247,
  b: 242,
  a: 1
});
Color.BUTTON_TERTIARY_BACKGROUND_PRESSED = new Color({
  r: 223,
  g: 242,
  b: 237,
  a: 1
});
Color.BUTTON_TERTIARY_COLOR = new Color({
  r: 17,
  g: 168,
  b: 100,
  a: 1
});
Color.isLocked = true;


/***/ }),
/* 164 */,
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/* harmony default export */ __webpack_exports__["a"] = (copyArray);


/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(10);



/* Built-in method references that are verified to be native. */
var WeakMap = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'WeakMap');

/* harmony default export */ __webpack_exports__["a"] = (WeakMap);


/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ../node_modules/lodash-es/_baseHasIn.js
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

/* harmony default export */ var _baseHasIn = (baseHasIn);

// EXTERNAL MODULE: ../node_modules/lodash-es/_castPath.js + 2 modules
var _castPath = __webpack_require__(69);

// EXTERNAL MODULE: ../node_modules/lodash-es/isArguments.js + 1 modules
var isArguments = __webpack_require__(40);

// EXTERNAL MODULE: ../node_modules/lodash-es/isArray.js
var isArray = __webpack_require__(5);

// EXTERNAL MODULE: ../node_modules/lodash-es/_isIndex.js
var _isIndex = __webpack_require__(47);

// EXTERNAL MODULE: ../node_modules/lodash-es/isLength.js
var isLength = __webpack_require__(59);

// EXTERNAL MODULE: ../node_modules/lodash-es/_toKey.js
var _toKey = __webpack_require__(28);

// CONCATENATED MODULE: ../node_modules/lodash-es/_hasPath.js







/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = Object(_castPath["a" /* default */])(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = Object(_toKey["a" /* default */])(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && Object(isLength["a" /* default */])(length) && Object(_isIndex["a" /* default */])(key, length) &&
    (Object(isArray["a" /* default */])(object) || Object(isArguments["a" /* default */])(object));
}

/* harmony default export */ var _hasPath = (hasPath);

// CONCATENATED MODULE: ../node_modules/lodash-es/hasIn.js



/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && _hasPath(object, path, _baseHasIn);
}

/* harmony default export */ var lodash_es_hasIn = __webpack_exports__["a"] = (hasIn);


/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(10);


/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (cloneBuffer);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(106)(module)))

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cloneArrayBuffer_js__ = __webpack_require__(114);


/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? Object(__WEBPACK_IMPORTED_MODULE_0__cloneArrayBuffer_js__["a" /* default */])(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/* harmony default export */ __webpack_exports__["a"] = (cloneTypedArray);


/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseCreate_js__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isPrototype_js__ = __webpack_require__(75);




/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !Object(__WEBPACK_IMPORTED_MODULE_2__isPrototype_js__["a" /* default */])(object))
    ? Object(__WEBPACK_IMPORTED_MODULE_0__baseCreate_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(object))
    : {};
}

/* harmony default export */ __webpack_exports__["a"] = (initCloneObject);


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:!0});function g(c){return c&&"object"===typeof c&&"default"in c?c["default"]:c}
var k=g(__webpack_require__(172)),m=g(__webpack_require__(338)),p=g(__webpack_require__(339)),q=g(__webpack_require__(175)),r=g(__webpack_require__(176)),t=__webpack_require__(0),v=g(__webpack_require__(4)),x=g(__webpack_require__(184)),z=__webpack_require__(327),A=g(__webpack_require__(343)),B=g(__webpack_require__(345)),C=g(__webpack_require__(95)),
D=g(__webpack_require__(187)),F=g(__webpack_require__(344)),G=g(__webpack_require__(191)),H=g(__webpack_require__(342));
function K(c){var b=[];return{i18n:c,i18nHash:null,getSubscribers:function(){return b},subscribe:function(a){b.push(a)},unsubscribe:function(a){b=b.filter(function(b){return b!==a})},update:function(){var a=0<arguments.length&&void 0!==arguments[0]?arguments[0]:{};if(a){var e=a.catalogs,d=a.language;a=a.locales;if(e||d||a)e&&c.load(e),d&&c.activate(d,a),this.i18nHash=x([c.language,c.messages]),b.forEach(function(a){return a()})}}}}
var L=function(c){function b(a){m(this,b);var e=q(this,(b.__proto__||k(b)).call(this,a)),d=a.language,c=a.locales,h=a.catalogs;a=a.i18n||z.setupI18n({language:d,locales:c,catalogs:h});e.linguiPublisher=K(a);e.linguiPublisher.i18n._missing=e.props.missing;return e}r(b,c);p(b,[{key:"componentDidUpdate",value:function(a){var b=this.props,d=b.language,c=b.locales;b=b.catalogs;d===a.language&&c===a.locales&&b===a.catalogs||this.linguiPublisher.update({language:d,catalogs:b,locales:c});this.linguiPublisher.i18n._missing=
this.props.missing}},{key:"getChildContext",value:function(){return{linguiPublisher:this.linguiPublisher,linguiDefaultRender:this.props.defaultRender}}},{key:"render",value:function(){return this.props.children||null}}]);return b}(t.Component);L.defaultProps={defaultRender:null};L.childContextTypes={linguiPublisher:v.object.isRequired,linguiDefaultRender:v.any};
var M=function(c){function b(){var a,c,d,f;m(this,b);for(var h=arguments.length,l=Array(h),u=0;u<h;u++)l[u]=arguments[u];return f=(c=(d=q(this,(a=b.__proto__||k(b)).call.apply(a,[this].concat(l))),d),d.checkUpdate=function(){d.forceUpdate()},c),q(d,f)}r(b,c);p(b,[{key:"componentDidMount",value:function(){var a=this.getI18n().subscribe;this.props.update&&a&&a(this.checkUpdate)}},{key:"componentWillUnmount",value:function(){var a=this.getI18n().unsubscribe;this.props.update&&a&&a(this.checkUpdate)}},
{key:"getI18n",value:function(){return this.context.linguiPublisher||{}}},{key:"render",value:function(){var a=this.props,b=a.children;a=a.withHash;var c=this.getI18n(),f=c.i18nHash;a=A({i18n:c.i18n},a?{i18nHash:f}:{});return"function"===typeof b?b(a):t.isValidElement(b)?t.cloneElement(b,a):t.createElement(b,a)}}]);return b}(t.Component);M.defaultProps={update:!0,withHash:!0};M.contextTypes={linguiPublisher:v.object};
function N(){var c=0<arguments.length&&void 0!==arguments[0]?arguments[0]:{};return function(b){var a=c.update,e=void 0===a?!0:a;a=c.withHash;var d=void 0===a?!0:a;a=c.withRef;var f=void 0===a?!1:a;a=function(a){function c(){var a,b,d,e;m(this,c);for(var l=arguments.length,h=Array(l),w=0;w<l;w++)h[w]=arguments[w];return e=(b=(d=q(this,(a=c.__proto__||k(c)).call.apply(a,[this].concat(h))),d),d.wrappedInstance=null,d.setWrappedInstance=function(a){f&&(d.wrappedInstance=a)},d.getWrappedInstance=function(){if(!f)throw Error("To access the wrapped instance, you need to specify { withRef: true } in the options argument of the withI18n() call.");
return d.wrappedInstance},b),q(d,e)}r(c,a);p(c,[{key:"render",value:function(){var a=A({},this.props,f?{ref:this.setWrappedInstance}:{});return t.createElement(M,{update:e,withHash:d},function(c){return t.createElement(b,A({},a,{i18n:c.i18n,i18nHash:c.i18nHash}))})}}]);return c}(t.Component);a.contextTypes={linguiPublisher:v.object};return B(a,b)}}var O=/<(\d+)>(.*)<\/\1>|<(\d+)\/>/,P=/(?:\r\n|\r|\n)/g;
function Q(c){var b=1<arguments.length&&void 0!==arguments[1]?arguments[1]:[],a=c.replace(P,"").split(O);if(1===a.length)return c;var e=[],d=a.shift();d&&e.push(d);d=!0;var f=!1,h=void 0;try{for(var l=C(R(a)),u;!(d=(u=l.next()).done);d=!0){var E=D(u.value,3),I=E[0],J=E[1],y=E[2],n=b[I];e.push(t.cloneElement(n,{key:I},J?Q(J,b):n.props.children));y&&e.push(y)}}catch(w){f=!0,h=w}finally{try{!d&&l.return&&l.return()}finally{if(f)throw h;}}return e}
function R(c){if(!c.length)return[];var b=c.slice(0,4);b=D(b,4);var a=b[1],e=b[2],d=b[3];return[[parseInt(b[0]||e),a||"",d]].concat(R(c.slice(4,c.length)))}
var S=function(c){function b(){m(this,b);return q(this,(b.__proto__||k(b)).apply(this,arguments))}r(b,c);p(b,[{key:"render",value:function(){var a=this.props,b=a.className;a=a.value;var c=this.props.render||this.context.linguiDefaultRender;return null===c||void 0===c?a||null:"string"===typeof c?t.createElement(c,{className:b},a):t.isValidElement(c)?t.cloneElement(c,{},a):t.createElement(c,{translation:a})}}]);return b}(t.Component);S.contextTypes={linguiDefaultRender:v.any};
var T=function(c){function b(){m(this,b);return q(this,(b.__proto__||k(b)).apply(this,arguments))}r(b,c);p(b,[{key:"componentDidMount",value:function(){}},{key:"getTranslation",value:function(){var a=this.props,b=a.id;b=void 0===b?"":b;var c=a.defaults,f=a.i18n;a=a.formats;var h=A({},this.props.values),l=this.props.components?[].concat(G(this.props.components)):[];h&&F(h).forEach(function(a){var b=h[a];t.isValidElement(b)&&(b=l.push(b)-1,h[a]="\x3c"+b+"/\x3e")});return(a=f&&"function"===typeof f._?
f._(b,h,{defaults:c,formats:a}):b)?Q(a,l):null}},{key:"render",value:function(){return t.createElement(S,{render:this.props.render,className:this.props.className,value:this.getTranslation()})}}]);return b}(t.Component),U=N()(T),V=N()(function(c){function b(){m(this,b);return q(this,(b.__proto__||k(b)).apply(this,arguments))}r(b,c);p(b,[{key:"render",value:function(){var a=this.props,b=a.className,c=a.render,f=a.i18n;a=H(a,["className","render","i18n"]);return t.createElement(S,{className:b,render:c,
value:f.select(a)})}}]);return b}(t.Component));
function W(){var c,b,a=0<arguments.length&&void 0!==arguments[0]?arguments[0]:!1,e=a?"SelectOrdinal":"Plural",d=a?"selectOrdinal":"plural";return b=c=function(a){function b(){var a,c,d,f;m(this,b);for(var h=arguments.length,y=Array(h),n=0;n<h;n++)y[n]=arguments[n];return f=(c=(d=q(this,(a=b.__proto__||k(b)).call.apply(a,[this].concat(y))),d),d.displayName=e,c),q(d,f)}r(b,a);p(b,[{key:"render",value:function(){var a=this.props,b=a.className,c=a.render,e=a.i18n,f=a.value,h=a.offset,n=H(a,["className",
"render","i18n","value","offset"]);a=F(n).reduce(function(a,b){var c=b.replace("_","");a[c]=n[b];return a},{value:Number(f),offset:Number(h)});return t.createElement(S,{className:b,render:c,value:e[d](a)})}}]);return b}(t.Component),c.defaultProps={offset:0},b}var X=N()(W(!1)),Y=N()(W(!0));function Z(c){return function(b){var a=b.value,e=b.i18n,d=b.className,f=b.render;b=c(e.locales||e.language,b.format);return t.createElement(S,{className:d,render:f,value:b(a)})}}var aa=N()(Z(z.date)),ba=N()(Z(z.number));
exports.i18nMark=function(c){return c};exports.withI18n=N;exports.I18nProvider=L;exports.I18n=M;exports.Trans=U;exports.Plural=X;exports.Select=V;exports.SelectOrdinal=Y;exports.DateFormat=aa;exports.NumberFormat=ba;


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(173), __esModule: true };

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(174);
module.exports = __webpack_require__(16).Object.getPrototypeOf;


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(145);
var $getPrototypeOf = __webpack_require__(336);

__webpack_require__(337)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(154);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(177);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(181);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(154);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(178), __esModule: true };

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(179);
module.exports = __webpack_require__(16).Object.setPrototypeOf;


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(84);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(180).set });


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(316);
var anObject = __webpack_require__(85);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(153)(Function.call, __webpack_require__(341).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(182), __esModule: true };

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(183);
var $Object = __webpack_require__(16).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(84);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(332) });


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function pad (hash, len) {
  while (hash.length < len) {
    hash = '0' + hash;
  }
  return hash;
}

function fold (hash, text) {
  var i;
  var chr;
  var len;
  if (text.length === 0) {
    return hash;
  }
  for (i = 0, len = text.length; i < len; i++) {
    chr = text.charCodeAt(i);
    hash = ((hash << 5) - hash) + chr;
    hash |= 0;
  }
  return hash < 0 ? hash * -2 : hash;
}

function foldObject (hash, o, seen) {
  return Object.keys(o).sort().reduce(foldKey, hash);
  function foldKey (hash, key) {
    return foldValue(hash, o[key], key, seen);
  }
}

function foldValue (input, value, key, seen) {
  var hash = fold(fold(fold(input, key), toString(value)), typeof value);
  if (value === null) {
    return fold(hash, 'null');
  }
  if (value === undefined) {
    return fold(hash, 'undefined');
  }
  if (typeof value === 'object') {
    if (seen.indexOf(value) !== -1) {
      return fold(hash, '[Circular]' + key);
    }
    seen.push(value);
    return foldObject(hash, value, seen);
  }
  return fold(hash, value.toString());
}

function toString (o) {
  return Object.prototype.toString.call(o);
}

function sum (o) {
  return pad(foldValue(0, o, '', []).toString(16), 8);
}

module.exports = sum;


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(155);
__webpack_require__(90);
module.exports = __webpack_require__(186);


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(85);
var get = __webpack_require__(96);
module.exports = __webpack_require__(16).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(188);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(95);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(189), __esModule: true };

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(155);
__webpack_require__(90);
module.exports = __webpack_require__(190);


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(97);
var ITERATOR = __webpack_require__(32)('iterator');
var Iterators = __webpack_require__(86);
module.exports = __webpack_require__(16).isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(192);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(193), __esModule: true };

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(90);
__webpack_require__(194);
module.exports = __webpack_require__(16).Array.from;


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(153);
var $export = __webpack_require__(84);
var toObject = __webpack_require__(145);
var call = __webpack_require__(195);
var isArrayIter = __webpack_require__(196);
var toLength = __webpack_require__(340);
var createProperty = __webpack_require__(197);
var getIterFn = __webpack_require__(96);

$export($export.S + $export.F * !__webpack_require__(198)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(85);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(86);
var ITERATOR = __webpack_require__(32)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(298);
var createDesc = __webpack_require__(321);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(32)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var compose = __webpack_require__(104).compose;

exports.__esModule = true;
exports.composeWithDevTools = (
  typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ :
    function() {
      if (arguments.length === 0) return undefined;
      if (typeof arguments[0] === 'object') return compose;
      return compose.apply(null, arguments);
    }
);

exports.devToolsEnhancer = (
  typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__ ?
    window.__REDUX_DEVTOOLS_EXTENSION__ :
    function() { return function(noop) { return noop; } }
);


/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (stubFalse);


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.defaultMemoize = defaultMemoize;
exports.createSelectorCreator = createSelectorCreator;
exports.createStructuredSelector = createStructuredSelector;
function defaultEqualityCheck(a, b) {
  return a === b;
}

function areArgumentsShallowlyEqual(equalityCheck, prev, next) {
  if (prev === null || next === null || prev.length !== next.length) {
    return false;
  }

  // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
  var length = prev.length;
  for (var i = 0; i < length; i++) {
    if (!equalityCheck(prev[i], next[i])) {
      return false;
    }
  }

  return true;
}

function defaultMemoize(func) {
  var equalityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultEqualityCheck;

  var lastArgs = null;
  var lastResult = null;
  // we reference arguments instead of spreading them for performance reasons
  return function () {
    if (!areArgumentsShallowlyEqual(equalityCheck, lastArgs, arguments)) {
      // apply arguments instead of spreading for performance.
      lastResult = func.apply(null, arguments);
    }

    lastArgs = arguments;
    return lastResult;
  };
}

function getDependencies(funcs) {
  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;

  if (!dependencies.every(function (dep) {
    return typeof dep === 'function';
  })) {
    var dependencyTypes = dependencies.map(function (dep) {
      return typeof dep;
    }).join(', ');
    throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
  }

  return dependencies;
}

function createSelectorCreator(memoize) {
  for (var _len = arguments.length, memoizeOptions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    memoizeOptions[_key - 1] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      funcs[_key2] = arguments[_key2];
    }

    var recomputations = 0;
    var resultFunc = funcs.pop();
    var dependencies = getDependencies(funcs);

    var memoizedResultFunc = memoize.apply(undefined, [function () {
      recomputations++;
      // apply arguments instead of spreading for performance.
      return resultFunc.apply(null, arguments);
    }].concat(memoizeOptions));

    // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
    var selector = defaultMemoize(function () {
      var params = [];
      var length = dependencies.length;

      for (var i = 0; i < length; i++) {
        // apply arguments instead of spreading and mutate a local list of params for performance.
        params.push(dependencies[i].apply(null, arguments));
      }

      // apply arguments instead of spreading for performance.
      return memoizedResultFunc.apply(null, params);
    });

    selector.resultFunc = resultFunc;
    selector.recomputations = function () {
      return recomputations;
    };
    selector.resetRecomputations = function () {
      return recomputations = 0;
    };
    return selector;
  };
}

var createSelector = exports.createSelector = createSelectorCreator(defaultMemoize);

function createStructuredSelector(selectors) {
  var selectorCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : createSelector;

  if (typeof selectors !== 'object') {
    throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
  }
  var objectKeys = Object.keys(selectors);
  return selectorCreator(objectKeys.map(function (key) {
    return selectors[key];
  }), function () {
    for (var _len3 = arguments.length, values = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      values[_key3] = arguments[_key3];
    }

    return values.reduce(function (composition, value, index) {
      composition[objectKeys[index]] = value;
      return composition;
    }, {});
  });
}

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../react-lib/src/lib/redux-duck/index.js + 2 modules
var redux_duck = __webpack_require__(21);

// EXTERNAL MODULE: ../utilities/axiosUtils/index.client.js
var index_client = __webpack_require__(45);

// EXTERNAL MODULE: ../utilities/apiUrl.js
var apiUrl = __webpack_require__(51);

// EXTERNAL MODULE: ../utilities/object-utilities.js
var object_utilities = __webpack_require__(22);

// EXTERNAL MODULE: ../react-lib/src/apis/DefaultAPIErrorHandler.js
var DefaultAPIErrorHandler = __webpack_require__(30);

// CONCATENATED MODULE: ../react-lib/src/apis/countryConfiguration.api.js
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }





var countryConfigurationsUrl = Object(apiUrl["b" /* fullApiUrl */])('country-configuration/');
var currentCountryConfigurationUrl = Object(apiUrl["b" /* fullApiUrl */])('country-configuration/current/');
var navigationCountryConfigurationUrl = Object(apiUrl["b" /* fullApiUrl */])('country-configuration/navigation/');
var getAll =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(expressParams) {
    var ai, response;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            ai = Object(index_client["a" /* getAxiosInstance */])(expressParams);
            _context.prev = 1;
            _context.next = 4;
            return ai.get(countryConfigurationsUrl);

          case 4:
            response = _context.sent;
            return _context.abrupt("return", Object(object_utilities["a" /* camelize */])(response.data.results, true));

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](1);
            throw Object(DefaultAPIErrorHandler["a" /* default */])(_context.t0, 'There was an error getting your country configuration.');

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 8]]);
  }));

  return function getAll(_x) {
    return _ref.apply(this, arguments);
  };
}(); // Figure out if the /navigation API call can replace /current API call. The /current API does not
// take into account directly visiting country-specific pages such as /uk, /es, etc. This means that
// certain UI elements, like the Language dropdown, do not end up appearing on the country-specific
// pages if the user is currently in the US.
// See DEV-41929

var getCurrent =
/*#__PURE__*/
function () {
  var _ref2 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee2(expressParams) {
    var ai, response;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            ai = Object(index_client["a" /* getAxiosInstance */])(expressParams);
            _context2.prev = 1;
            _context2.next = 4;
            return ai.get(currentCountryConfigurationUrl);

          case 4:
            response = _context2.sent;
            return _context2.abrupt("return", Object(object_utilities["a" /* camelize */])(response.data, true));

          case 8:
            _context2.prev = 8;
            _context2.t0 = _context2["catch"](1);
            throw Object(DefaultAPIErrorHandler["a" /* default */])(_context2.t0, 'There was an error getting your current country configuration.');

          case 11:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[1, 8]]);
  }));

  return function getCurrent(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
var getNavigation =
/*#__PURE__*/
function () {
  var _ref3 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee3(expressParams) {
    var ai, response;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            ai = Object(index_client["a" /* getAxiosInstance */])(expressParams);
            _context3.prev = 1;
            _context3.next = 4;
            return ai.get(navigationCountryConfigurationUrl);

          case 4:
            response = _context3.sent;
            return _context3.abrupt("return", Object(object_utilities["a" /* camelize */])(response.data, true));

          case 8:
            _context3.prev = 8;
            _context3.t0 = _context3["catch"](1);
            throw Object(DefaultAPIErrorHandler["a" /* default */])(_context3.t0, 'There was an error getting your navigation country configuration.');

          case 11:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[1, 8]]);
  }));

  return function getNavigation(_x3) {
    return _ref3.apply(this, arguments);
  };
}();
// CONCATENATED MODULE: ../utilities/partialRegExp.js
/**
 * This function allows you determine whether a string matches
 * a RegExp partially. In other words, could this string
 * eventually match a given RegExp. This is useful for determining
 * if user input is valid as they are typing.
 *
 * This solution is an adapted version of the StackOverflow answer
 * here: https://stackoverflow.com/questions/22483214/regex-check-if-input-still-has-chances-to-become-matching/41580048#41580048
 */
/* harmony default export */ var partialRegExp = (function (re) {
  var i = 0;
  var source = re.source;

  var process = function process() {
    var result = '';
    var tmp;

    var appendRaw = function appendRaw(nbChars) {
      result += source.substr(i, nbChars);
      i += nbChars;
    };

    var appendOptional = function appendOptional(nbChars) {
      result += "(?:".concat(source.substr(i, nbChars), "|$)");
      i += nbChars;
    };

    while (i < source.length) {
      switch (source[i]) {
        case '\\':
          switch (source[i + 1]) {
            case 'c':
              appendOptional(3);
              break;

            case 'x':
              appendOptional(4);
              break;

            case 'u':
              if (re.unicode) {
                if (source[i + 2] === '{') {
                  appendOptional(source.indexOf('}', i) - i + 1);
                } else {
                  appendOptional(6);
                }
              } else {
                appendOptional(2);
              }

              break;

            default:
              appendOptional(2);
              break;
          }

          break;

        case '[':
          tmp = /\[(?:\\.|.)*?\]/g;
          tmp.lastIndex = i;
          tmp = tmp.exec(source);

          if (tmp) {
            appendOptional(tmp[0].length);
          }

          break;

        case '|':
        case '^':
        case '$':
        case '*':
        case '+':
        case '?':
          appendRaw(1);
          break;

        case '{':
          tmp = /\{\d+,?\d*\}/g;
          tmp.lastIndex = i;
          tmp = tmp.exec(source);

          if (tmp) {
            appendRaw(tmp[0].length);
          } else {
            appendOptional(1);
          }

          break;

        case '(':
          if (source[i + 1] === '?') {
            switch (source[i + 2]) {
              case ':':
                result += '(?:';
                i += 3;
                result += "".concat(process(), "|$)");
                break;

              case '=':
                result += '(?=';
                i += 3;
                result += "".concat(process(), ")");
                break;

              case '!':
                tmp = i;
                i += 3;
                process();
                result += source.substr(tmp, i - tmp);
                break;

              default:
                break;
            }
          } else {
            appendRaw(1);
            result += "".concat(process(), "|$)");
          }

          break;

        case ')':
          i += 1;
          return result;

        default:
          appendOptional(1);
          break;
      }
    }

    return result;
  };

  return new RegExp(process(), re.flags);
});
// EXTERNAL MODULE: ../utilities/reportError.js
var reportError = __webpack_require__(34);

// CONCATENATED MODULE: ../react-lib/src/redux/ducks/countryConfiguration.duck.js
/* unused harmony export options */
/* unused harmony export actions */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return selectors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return effects; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return reducer; });
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function countryConfiguration_duck_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function countryConfiguration_duck__asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { countryConfiguration_duck_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { countryConfiguration_duck_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var formatRegex = function formatRegex(inputRegex) {
  /**
   * Some postal code regexes come from the backend
   * without the needed leading carrot (^). This ensures
   * that the regex starts with a carrot.
   */
  var regEx = inputRegex[0] === '^' ? inputRegex : "^".concat(inputRegex);
  return new RegExp(regEx);
};

var options = {
  name: 'countryConfiguration',
  initialState: {
    isLoading: false,
    errorMessage: '',
    currentCountryConfiguration: null,
    countryConfigurations: [],
    navigationCountryConfiguration: null
  },
  actions: {
    fetchConfigurationPending: function fetchConfigurationPending() {
      return function (state) {
        return _objectSpread({}, state, {
          errorMessage: '',
          isLoading: true
        });
      };
    },
    fetchConfigurationFailure: function fetchConfigurationFailure(_ref) {
      var message = _ref.message;
      return function (state) {
        return _objectSpread({}, state, {
          errorMessage: message,
          isLoading: false
        });
      };
    },
    fetchConfigurationSuccess: function fetchConfigurationSuccess(_ref2) {
      var currentCountryConfiguration = _ref2.currentCountryConfiguration,
          countryConfigurations = _ref2.countryConfigurations,
          navigationCountryConfiguration = _ref2.navigationCountryConfiguration;
      return function (state) {
        return _objectSpread({}, state, {
          currentCountryConfiguration: currentCountryConfiguration,
          countryConfigurations: countryConfigurations,
          navigationCountryConfiguration: navigationCountryConfiguration,
          errorMessage: '',
          isLoading: false
        });
      };
    }
  },
  effects: {
    fetchConfiguration: function fetchConfiguration() {
      return (
        /*#__PURE__*/
        function () {
          var _ref5 = countryConfiguration_duck__asyncToGenerator(
          /*#__PURE__*/
          regeneratorRuntime.mark(function _callee(dispatch, getState, _ref3, duckEffects, duckSelectors, _ref4) {
            var fetchConfigurationPending, fetchConfigurationSuccess, fetchConfigurationFailure, expressParams, _ref6, _ref7, currentCountryConfiguration, countryConfigurations, navigationCountryConfiguration;

            return regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    fetchConfigurationPending = _ref3.fetchConfigurationPending, fetchConfigurationSuccess = _ref3.fetchConfigurationSuccess, fetchConfigurationFailure = _ref3.fetchConfigurationFailure;
                    expressParams = _ref4.expressParams;
                    dispatch(fetchConfigurationPending());
                    _context.prev = 3;
                    _context.next = 6;
                    return Promise.all([getCurrent(expressParams), getAll(expressParams), getNavigation(expressParams)]);

                  case 6:
                    _ref6 = _context.sent;
                    _ref7 = _slicedToArray(_ref6, 3);
                    currentCountryConfiguration = _ref7[0];
                    countryConfigurations = _ref7[1];
                    navigationCountryConfiguration = _ref7[2];
                    dispatch(fetchConfigurationSuccess({
                      currentCountryConfiguration: currentCountryConfiguration,
                      countryConfigurations: countryConfigurations,
                      navigationCountryConfiguration: navigationCountryConfiguration
                    }));
                    _context.next = 18;
                    break;

                  case 14:
                    _context.prev = 14;
                    _context.t0 = _context["catch"](3);
                    dispatch(fetchConfigurationFailure(_context.t0));
                    Object(reportError["a" /* default */])(_context.t0);

                  case 18:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee, null, [[3, 14]]);
          }));

          return function (_x, _x2, _x3, _x4, _x5, _x6) {
            return _ref5.apply(this, arguments);
          };
        }()
      );
    }
  },
  selectors: {
    getIsLoading: function getIsLoading(getDuckState, createSelector) {
      return createSelector([getDuckState], function (state) {
        return state.isLoading;
      });
    },
    getCurrentCountryConfiguration: function getCurrentCountryConfiguration(getDuckState, createSelector) {
      return createSelector([getDuckState], function (state) {
        return state.currentCountryConfiguration;
      });
    },
    getAvailableLanguages: function getAvailableLanguages(getDuckState, createSelector, _ref8) {
      var getCurrentCountryConfiguration = _ref8.getCurrentCountryConfiguration;
      return createSelector([getCurrentCountryConfiguration], function (countryConfiguration) {
        if (!countryConfiguration) return null;
        return countryConfiguration.availableLanguages;
      });
    },
    getCurrentPostalCodeRegex: function getCurrentPostalCodeRegex(getDuckState, createSelector, _ref9) {
      var getCurrentCountryConfiguration = _ref9.getCurrentCountryConfiguration;
      return createSelector([getCurrentCountryConfiguration], function (countryConfiguration) {
        if (!countryConfiguration) return null;
        return formatRegex(countryConfiguration.postalCodeRegex);
      });
    },
    getCurrentPartialPostalCodeRegex: function getCurrentPartialPostalCodeRegex(getDuckState, createSelector, _ref10) {
      var getCurrentPostalCodeRegex = _ref10.getCurrentPostalCodeRegex;
      return createSelector([getCurrentPostalCodeRegex], function (regex) {
        return regex && partialRegExp(regex);
      });
    },
    getCurrentIsStateRequired: function getCurrentIsStateRequired(getDuckState, createSelector, _ref11) {
      var getCurrentCountryConfiguration = _ref11.getCurrentCountryConfiguration;
      return createSelector([getCurrentCountryConfiguration], function (countryConfiguration) {
        return countryConfiguration && countryConfiguration.isStateRequired;
      });
    },
    getCurrentCustomerSupportPhoneFormatted: function getCurrentCustomerSupportPhoneFormatted(getDuckState, createSelector, _ref12) {
      var getCurrentCountryConfiguration = _ref12.getCurrentCountryConfiguration;
      return createSelector([getCurrentCountryConfiguration], function (countryConfiguration) {
        return countryConfiguration && countryConfiguration.phoneNumbers.customerSupportPhoneFormatted;
      });
    },
    getCurrentEmergencyHotlinePhoneFormatted: function getCurrentEmergencyHotlinePhoneFormatted(getDuckState, createSelector, _ref13) {
      var getCurrentCountryConfiguration = _ref13.getCurrentCountryConfiguration;
      return createSelector([getCurrentCountryConfiguration], function (countryConfiguration) {
        return countryConfiguration && countryConfiguration.phoneNumbers.emergencyHotlinePhoneFormatted;
      });
    },
    getAllCountryConfigurations: function getAllCountryConfigurations(getDuckState, createSelector) {
      return createSelector([getDuckState], function (state) {
        return state.countryConfigurations;
      });
    },
    getAllFormattedRegexes: function getAllFormattedRegexes(getDuckState, createSelector, _ref14) {
      var getAllCountryConfigurations = _ref14.getAllCountryConfigurations;
      return createSelector([getAllCountryConfigurations], function (countryConfigurations) {
        return countryConfigurations.map(function (config) {
          return formatRegex(config.postalCodeRegex);
        });
      });
    },
    getCombinedRegex: function getCombinedRegex(getDuckState, createSelector, _ref15) {
      var getAllFormattedRegexes = _ref15.getAllFormattedRegexes;
      return createSelector([getAllFormattedRegexes], function (regexes) {
        return new RegExp(regexes.map(function (r) {
          return r.source;
        }).join('|'));
      });
    },
    getCombinedPartialRegex: function getCombinedPartialRegex(getDuckState, createSelector, _ref16) {
      var getCombinedRegex = _ref16.getCombinedRegex;
      return createSelector([getCombinedRegex], function (regex) {
        return regex && partialRegExp(regex);
      });
    },
    getCountryConfigurationByPostalCode: function getCountryConfigurationByPostalCode(getDuckState, createSelector, _ref17) {
      var getAllCountryConfigurations = _ref17.getAllCountryConfigurations,
          getCurrentCountryConfiguration = _ref17.getCurrentCountryConfiguration,
          getCurrentPartialPostalCodeRegex = _ref17.getCurrentPartialPostalCodeRegex;
      return createSelector([getAllCountryConfigurations, getCurrentCountryConfiguration, getCurrentPartialPostalCodeRegex], function (countryConfigurations, currentCountryConfiguration, partial) {
        return function (postalCode) {
          if (!postalCode || partial && partial.test(postalCode)) {
            return currentCountryConfiguration;
          }

          return countryConfigurations.find(function (config) {
            return partialRegExp(formatRegex(config.postalCodeRegex)).test(postalCode);
          }) || currentCountryConfiguration;
        };
      });
    },
    getIsStateRequiredByPostalCode: function getIsStateRequiredByPostalCode(getDuckState, createSelector, _ref18) {
      var getCountryConfigurationByPostalCode = _ref18.getCountryConfigurationByPostalCode;
      return createSelector([getCountryConfigurationByPostalCode], function (countryConfigurationByPostalCode) {
        return function (postalCode) {
          var config = countryConfigurationByPostalCode(postalCode);
          return config ? config.isStateRequired : true;
        };
      });
    },
    getCurrentContinentIsEurope: function getCurrentContinentIsEurope(getDuckState, createSelector, _ref19) {
      var getCurrentCountryConfiguration = _ref19.getCurrentCountryConfiguration;
      return createSelector([getCurrentCountryConfiguration], function (countryConfiguration) {
        if (!countryConfiguration) return false;
        return countryConfiguration.continentCode === 'EU';
      });
    },
    getCurrentCountryCode: function getCurrentCountryCode(getDuckState, createSelector, _ref20) {
      var getCurrentCountryConfiguration = _ref20.getCurrentCountryConfiguration;
      return createSelector([getCurrentCountryConfiguration], function (countryConfiguration) {
        return countryConfiguration ? countryConfiguration.countryCode : 'US';
      });
    },
    getCurrentCurrencyCode: function getCurrentCurrencyCode(getDuckState, createSelector, _ref21) {
      var getCurrentCountryConfiguration = _ref21.getCurrentCountryConfiguration;
      return createSelector([getCurrentCountryConfiguration], function (countryConfiguration) {
        return countryConfiguration ? countryConfiguration.currencyCode : 'USD';
      });
    },
    getCurrentCountryUrls: function getCurrentCountryUrls(getDuckState, createSelector, _ref22) {
      var getCurrentCountryConfiguration = _ref22.getCurrentCountryConfiguration;
      return createSelector([getCurrentCountryConfiguration], function (currentCountryConfiguration) {
        if (!currentCountryConfiguration) return {};
        return currentCountryConfiguration.urls;
      });
    },
    getCurrentCountryMinimumAddOnPrices: function getCurrentCountryMinimumAddOnPrices(getDuckState, createSelector, _ref23) {
      var getCurrentCountryConfiguration = _ref23.getCurrentCountryConfiguration;
      return createSelector([getCurrentCountryConfiguration], function (currentCountryConfiguration) {
        if (!currentCountryConfiguration) return {};
        return currentCountryConfiguration.minimumServiceAddOnPrices;
      });
    },
    getCurrentCountryIndexUrl: function getCurrentCountryIndexUrl(getDuckState, createSelector, _ref24) {
      var getCurrentCountryUrls = _ref24.getCurrentCountryUrls;
      return createSelector([getCurrentCountryUrls], function (currentCountryUrls) {
        if (currentCountryUrls === {}) return 'http://www.rover.com/';
        return currentCountryUrls.indexUrl;
      });
    },
    getCountryCodes: function getCountryCodes(getDuckState, createSelector, _ref25) {
      var getAllCountryConfigurations = _ref25.getAllCountryConfigurations;
      return createSelector([getAllCountryConfigurations], function (allCountryConfigurations) {
        return allCountryConfigurations.map(function (countryConfiguration) {
          return countryConfiguration.countryCode;
        });
      });
    },
    getStateFieldNameByPostalCode: function getStateFieldNameByPostalCode(getDuckState, createSelector, _ref26) {
      var getCountryConfigurationByPostalCode = _ref26.getCountryConfigurationByPostalCode;
      return createSelector([getCountryConfigurationByPostalCode], function (countryConfigurationByPostalCode) {
        return function (postalCode) {
          var config = countryConfigurationByPostalCode(postalCode);
          return config && config.countryCode === 'CA' ? 'Province' : 'State';
        };
      });
    },
    getWeightLabel: function getWeightLabel(getDuckState, createSelector, _ref27) {
      var getCurrentCountryConfiguration = _ref27.getCurrentCountryConfiguration;
      return createSelector([getCurrentCountryConfiguration], function (countryConfiguration) {
        var weightLabel = countryConfiguration ? countryConfiguration.weightUnit : 'lbs';
        return weightLabel;
      });
    },
    getExtenuatingCircumstancesArticleURL: function getExtenuatingCircumstancesArticleURL(getDuckState, createSelector, _ref28) {
      var getCurrentCountryConfiguration = _ref28.getCurrentCountryConfiguration;
      return createSelector([getCurrentCountryConfiguration], function (countryConfiguration) {
        var articleURL = countryConfiguration ? countryConfiguration.urls.extenuatingCircumstancesHelpdeskUrl : 'https://support.rover.com/hc/en-us/articles/360031574231';
        return articleURL;
      });
    },
    // If you navigate to a new country-specific page, this still returns the previous country
    // value. It may be a cookie issue.
    // See DEV-41869
    getNavigationCountryConfiguration: function getNavigationCountryConfiguration(getDuckState, createSelector) {
      return createSelector([getDuckState], function (state) {
        return state.navigationCountryConfiguration;
      });
    },
    getNavigationAvailableLanguages: function getNavigationAvailableLanguages(getDuckState, createSelector, _ref29) {
      var getNavigationCountryConfiguration = _ref29.getNavigationCountryConfiguration;
      return createSelector([getNavigationCountryConfiguration], function (navigationConfiguration) {
        if (!navigationConfiguration) return null;
        return navigationConfiguration.availableLanguages;
      });
    },
    getNavigationCurrentContinentIsEurope: function getNavigationCurrentContinentIsEurope(getDuckState, createSelector, _ref30) {
      var getNavigationCountryConfiguration = _ref30.getNavigationCountryConfiguration;
      return createSelector([getNavigationCountryConfiguration], function (navigationConfiguration) {
        if (!navigationConfiguration) return false;
        return navigationConfiguration.continentCode === 'EU';
      });
    },
    getNavigationCurrencyCode: function getNavigationCurrencyCode(getDuckState, createSelector, _ref31) {
      var getNavigationCountryConfiguration = _ref31.getNavigationCountryConfiguration;
      return createSelector([getNavigationCountryConfiguration], function (countryConfiguration) {
        return countryConfiguration ? countryConfiguration.currencyCode : 'EUR';
      });
    }
  }
};

var _ref32 = Object(redux_duck["a" /* createDuck */])(options),
    actions = _ref32.actions,
    selectors = _ref32.selectors,
    effects = _ref32.effects,
    reducer = _ref32.reducer;



/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ../node_modules/react-hot-loader/index.js
var react_hot_loader = __webpack_require__(204);
var react_hot_loader_default = /*#__PURE__*/__webpack_require__.n(react_hot_loader);

// EXTERNAL MODULE: ../node_modules/react-hot-loader/patch.js
var patch = __webpack_require__(205);
var patch_default = /*#__PURE__*/__webpack_require__.n(patch);

// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ../node_modules/react-dom/index.js
var react_dom = __webpack_require__(81);
var react_dom_default = /*#__PURE__*/__webpack_require__.n(react_dom);

// EXTERNAL MODULE: ../node_modules/@lingui/react/index.js
var _lingui_react = __webpack_require__(3);
var _lingui_react_default = /*#__PURE__*/__webpack_require__.n(_lingui_react);

// EXTERNAL MODULE: ../utilities/translation.js
var translation = __webpack_require__(37);

// EXTERNAL MODULE: ../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(1);

// EXTERNAL MODULE: ../design-system/style-dictionary/build/es6/theme.js
var es6_theme = __webpack_require__(44);

// CONCATENATED MODULE: ../react-lib/src/components/utils/ThemeProvider/ThemeProvider.jsx




var ThemeProvider_ThemeProvider = function ThemeProvider(_ref) {
  var theme = _ref.theme,
      children = _ref.children;
  return react_default.a.createElement(styled_components_browser_esm["ThemeProvider"], {
    theme: theme
  }, react_default.a.createElement(react["Fragment"], null, children));
};

ThemeProvider_ThemeProvider.defaultProps = {
  theme: es6_theme["b" /* default */]
};
/* harmony default export */ var utils_ThemeProvider_ThemeProvider = (ThemeProvider_ThemeProvider);
// CONCATENATED MODULE: ../react-lib/src/components/utils/ThemeProvider/index.js

// CONCATENATED MODULE: ../react-lib/src/utils/renderRootElement.jsx







/* harmony default export */ var renderRootElement = __webpack_exports__["default"] = (function (Component, elementSelector, props) {
  var rootElement = document.querySelector(elementSelector);
  var container = react_default.a.createElement(react_hot_loader["AppContainer"], null, react_default.a.createElement(_lingui_react["I18nProvider"], translation["i18nConfig"], react_default.a.createElement(utils_ThemeProvider_ThemeProvider, null, react_default.a.createElement(Component, props))));

  if (!rootElement) {
    throw new Error('rootElement not found.');
  }

  react_dom_default.a.render(container, rootElement);
});

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(103);
} else if (process.env.NODE_ENV === 'test') {
  module.exports = require('./dist/react-hot-loader.production.min.js');
} else if (typeof window === 'undefined') {
  // this is just server environment
  module.exports = require('./dist/react-hot-loader.production.min.js');
} else if (!module.hot) {
  module.exports = require('./dist/react-hot-loader.production.min.js');
  module.exports.AppContainer.warnAboutHMRDisabled = true;
  module.exports.hot.shouldWrapWithAppContainer = true;
} else {
  var evalAllowed = false;
  try {
    eval('evalAllowed = true');
  } catch (e) {
    // eval not allowed due to CSP
  }

  // RHL needs setPrototypeOf to operate Component inheritance, and eval to patch methods
  var jsFeaturesPresent = !!Object.setPrototypeOf;

  if (!jsFeaturesPresent || !evalAllowed) {
    // we are not in prod mode, but RHL could not be activated
    console.warn('React-Hot-Loader is not supported in this environment.');
    module.exports = require('./dist/react-hot-loader.production.min.js');
  } else {
    module.exports = window.reactHotLoaderGlobal = require('./dist/react-hot-loader.development.js');
  }
}


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(103);
} else {
  module.exports = require('./dist/react-hot-loader.development.js');
}


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var testOrder;
var types = {};
var customCards = {};
var VISA = 'visa';
var MASTERCARD = 'master-card'; // TODO: rename to mastercard in major version bunmp
var AMERICAN_EXPRESS = 'american-express';
var DINERS_CLUB = 'diners-club';
var DISCOVER = 'discover';
var JCB = 'jcb';
var UNIONPAY = 'unionpay';
var MAESTRO = 'maestro';
var MIR = 'mir';
var CVV = 'CVV';
var CID = 'CID';
var CVC = 'CVC';
var CVN = 'CVN';
var CVP2 = 'CVP2';
var ORIGINAL_TEST_ORDER = [
  VISA,
  MASTERCARD,
  AMERICAN_EXPRESS,
  DINERS_CLUB,
  DISCOVER,
  JCB,
  UNIONPAY,
  MAESTRO,
  MIR
];

function clone(originalObject) {
  var dupe;

  if (!originalObject) { return null; }

  dupe = JSON.parse(JSON.stringify(originalObject));
  delete dupe.prefixPattern;
  delete dupe.exactPattern;

  return dupe;
}

testOrder = clone(ORIGINAL_TEST_ORDER);

types[VISA] = {
  niceType: 'Visa',
  type: VISA,
  prefixPattern: /^4$/,
  exactPattern: /^4\d*$/,
  gaps: [4, 8, 12],
  lengths: [16, 18, 19],
  code: {
    name: CVV,
    size: 3
  }
};

types[MASTERCARD] = {
  niceType: 'Mastercard',
  type: MASTERCARD,
  prefixPattern: /^(5|5[1-5]|2|22|222|222[1-9]|2[3-6]|27|27[0-2]|2720)$/,
  exactPattern: /^(5[1-5]|222[1-9]|22[3-9]|2[3-6]|27[0-1]|2720)\d*$/,
  gaps: [4, 8, 12],
  lengths: [16],
  code: {
    name: CVC,
    size: 3
  }
};

types[AMERICAN_EXPRESS] = {
  niceType: 'American Express',
  type: AMERICAN_EXPRESS,
  prefixPattern: /^(3|34|37)$/,
  exactPattern: /^3[47]\d*$/,
  isAmex: true,
  gaps: [4, 10],
  lengths: [15],
  code: {
    name: CID,
    size: 4
  }
};

types[DINERS_CLUB] = {
  niceType: 'Diners Club',
  type: DINERS_CLUB,
  prefixPattern: /^(3|3[0689]|30[0-5])$/,
  exactPattern: /^3(0[0-5]|[689])\d*$/,
  gaps: [4, 10],
  lengths: [14, 16, 19],
  code: {
    name: CVV,
    size: 3
  }
};

types[DISCOVER] = {
  niceType: 'Discover',
  type: DISCOVER,
  prefixPattern: /^(6|60|601|6011|65|64|64[4-9])$/,
  exactPattern: /^(6011|65|64[4-9])\d*$/,
  gaps: [4, 8, 12],
  lengths: [16, 19],
  code: {
    name: CID,
    size: 3
  }
};

types[JCB] = {
  niceType: 'JCB',
  type: JCB,
  prefixPattern: /^(2|21|213|2131|1|18|180|1800|3|35)$/,
  exactPattern: /^(2131|1800|35)\d*$/,
  gaps: [4, 8, 12],
  lengths: [16, 17, 18, 19],
  code: {
    name: CVV,
    size: 3
  }
};

types[UNIONPAY] = {
  niceType: 'UnionPay',
  type: UNIONPAY,
  prefixPattern: /^((6|62|62\d|(621(?!83|88|98|99))|622(?!06)|627[02,06,07]|628(?!0|1)|629[1,2])|622018)$/,
  exactPattern: /^(((620|(621(?!83|88|98|99))|622(?!06|018)|62[3-6]|627[02,06,07]|628(?!0|1)|629[1,2]))\d*|622018\d{12})$/,
  gaps: [4, 8, 12],
  lengths: [16, 17, 18, 19],
  code: {
    name: CVN,
    size: 3
  }
};

types[MAESTRO] = {
  niceType: 'Maestro',
  type: MAESTRO,
  prefixPattern: /^(5|5[06-9]|6\d*)$/,
  exactPattern: /^(5[06-9]|6[37])\d*$/,
  gaps: [4, 8, 12],
  lengths: [12, 13, 14, 15, 16, 17, 18, 19],
  code: {
    name: CVC,
    size: 3
  }
};

types[MIR] = {
  niceType: 'Mir',
  type: MIR,
  prefixPattern: /^(2|22|220|220[0-4])$/,
  exactPattern: /^(220[0-4])\d*$/,
  gaps: [4, 8, 12],
  lengths: [16, 17, 18, 19],
  code: {
    name: CVP2,
    size: 3
  }
};

function findType(type) {
  return customCards[type] || types[type];
}

function creditCardType(cardNumber) {
  var type, value, i;
  var prefixResults = [];
  var exactResults = [];

  if (!(typeof cardNumber === 'string' || cardNumber instanceof String)) {
    return [];
  }

  for (i = 0; i < testOrder.length; i++) {
    type = testOrder[i];
    value = findType(type);

    if (cardNumber.length === 0) {
      prefixResults.push(clone(value));
      continue;
    }

    if (value.exactPattern.test(cardNumber)) {
      exactResults.push(clone(value));
    } else if (value.prefixPattern.test(cardNumber)) {
      prefixResults.push(clone(value));
    }
  }

  return exactResults.length ? exactResults : prefixResults;
}

creditCardType.getTypeInfo = function (type) {
  return clone(findType(type));
};

function getCardPosition(name, ignoreErrorForNotExisting) {
  var position = testOrder.indexOf(name);

  if (!ignoreErrorForNotExisting && position === -1) {
    throw new Error('"' + name + '" is not a supported card type.');
  }

  return position;
}

creditCardType.removeCard = function (name) {
  var position = getCardPosition(name);

  testOrder.splice(position, 1);
};

creditCardType.addCard = function (config) {
  var existingCardPosition = getCardPosition(config.type, true);

  customCards[config.type] = config;

  if (existingCardPosition === -1) {
    testOrder.push(config.type);
  }
};

creditCardType.changeOrder = function (name, position) {
  var currentPosition = getCardPosition(name);

  testOrder.splice(currentPosition, 1);
  testOrder.splice(position, 0, name);
};

creditCardType.resetModifications = function () {
  testOrder = clone(ORIGINAL_TEST_ORDER);
  customCards = {};
};

creditCardType.types = {
  VISA: VISA,
  MASTERCARD: MASTERCARD,
  AMERICAN_EXPRESS: AMERICAN_EXPRESS,
  DINERS_CLUB: DINERS_CLUB,
  DISCOVER: DISCOVER,
  JCB: JCB,
  UNIONPAY: UNIONPAY,
  MAESTRO: MAESTRO,
  MIR: MIR
};

module.exports = creditCardType;


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function verification(isValid, isPotentiallyValid, isValidForThisYear) {
  return {
    isValid: isValid,
    isPotentiallyValid: isPotentiallyValid,
    isValidForThisYear: isValidForThisYear || false
  };
}

function expirationMonth(value) {
  var month, result;
  var currentMonth = new Date().getMonth() + 1;

  if (typeof value !== 'string') {
    return verification(false, false);
  }
  if (value.replace(/\s/g, '') === '' || value === '0') {
    return verification(false, true);
  }
  if (!/^\d*$/.test(value)) {
    return verification(false, false);
  }

  month = parseInt(value, 10);

  if (isNaN(value)) {
    return verification(false, false);
  }

  result = month > 0 && month < 13;

  return verification(result, result, result && month >= currentMonth);
}

module.exports = expirationMonth;


/***/ }),
/* 208 */,
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayPush_js__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getSymbols_js__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stubArray_js__ = __webpack_require__(122);





/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? __WEBPACK_IMPORTED_MODULE_3__stubArray_js__["a" /* default */] : function(object) {
  var result = [];
  while (object) {
    Object(__WEBPACK_IMPORTED_MODULE_0__arrayPush_js__["a" /* default */])(result, Object(__WEBPACK_IMPORTED_MODULE_2__getSymbols_js__["a" /* default */])(object));
    object = Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(object);
  }
  return result;
};

/* harmony default export */ __webpack_exports__["a"] = (getSymbolsIn);


/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__classNames_constants__ = __webpack_require__(107);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__classNames_constants__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__classNames_constants__["b"]; });


/***/ }),
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ../react-lib/src/components/formFields/Input/index.js
var Input = __webpack_require__(143);

// CONCATENATED MODULE: ../react-lib/src/components/formFields/TextInput/TextInput.jsx
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



/* harmony default export */ var TextInput = (function (props) {
  return react_default.a.createElement(Input["a" /* default */], _extends({
    type: "text"
  }, props));
});
// CONCATENATED MODULE: ../react-lib/src/components/formFields/TextInput/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return TextInput; });


/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return BrainTreeCreditCardConstants; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return ContactInfoConstants; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CollapsingCheckboxCollectionConstants; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return ContactSitterPageConstants; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return MessageFormConstants; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return PhoneInfoFormConstants; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return PhotosFormConstants; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return SdvCalloutConstants; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return TosFormConstants; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return UnavailableModalConstants; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return EmergencyFormConstants; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return VetInfoConstants; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CareInstructionsConstants; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return ContactDateAndTimeConstants; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return ContiguousTimesConstants; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return EnhancedAddOnsConstants; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return FrequencyToggleConstants; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return NonContiguousTimesConstants; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return LastUpdatedTimestampsConstants; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AddPetFormConstants; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AddPetFormRowConstants; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ConfirmedAvailabilityConstants; });
/* unused harmony export ConfirmedAvailabilityCalendarButtonConstants */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CheckboxCategoryConstants; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return multiDatePickerConstants; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return petTypeButtonsConstants; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return TimepickerConstants; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return TimepickerDayConstants; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__ = __webpack_require__(37);
/* eslint-disable filenames/match-regex */

var BrainTreeCreditCardConstants = {
  creditCardNumberPlaceholder: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('Credit Card Number'),
  isInvalidCreditCardString: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('Enter a valid credit card number.'),
  isInvalidExpirationDateString: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('Enter a valid expiration date.'),
  isInvalidCVVString: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('Enter a valid CVV'),
  braintreeErrorMessage: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('There was an error processing your credit card, please try again later.')
};
var ContactInfoConstants = {
  emergencyContactInfo: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('Emergency contact info'),
  incomplete: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('INCOMPLETE'),
  contactName: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('Contact name'),
  phoneNumber: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('Phone number'),
  phoneNumberInvalid: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('Phone numbers must be valid'),
  complete: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('COMPLETE'),
  updateEmergencyContactInfo: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('Update emergency contact info'),
  save: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('Save')
};
var CollapsingCheckboxCollectionConstants = {
  filters: function filters(totalSelected) {
    return __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._(
    /*i18n*/
    {
      id: "Filters ({totalSelected})",
      values: {
        totalSelected: totalSelected
      }
    });
  },
  resetAll: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('Reset all')
};
var ContactSitterPageConstants = {
  message: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('Message'),
  youCanMessageProvider: function youCanMessageProvider(providerName) {
    return __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._(
    /*i18n*/
    {
      id: "You can chat with {providerName} right after you finish sending this request.",
      values: {
        providerName: providerName
      }
    });
  },
  bookingAndPayingOnRoverIsRequired: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._(
  /*i18n*/
  {
    id: "<strong>Booking and paying on Rover is required</strong> per Rover's Terms of Service."
  }),
  atLeastOneDayIsRequired: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('Please select at least one day'),
  fromPlaceholder: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('From'),
  toPlaceholder: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('To'),
  startBetweenTitle: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('Start Between'),
  endBetweenTitle: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('End Between')
};
var MessageFormConstants = {
  shareAlittleInfoAboutYourPet: function shareAlittleInfoAboutYourPet(providerName) {
    return __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._(
    /*i18n*/
    {
      id: "Share a little info about your pet and why they'd have a great time with {providerName}",
      values: {
        providerName: providerName
      }
    });
  }
};
var PhoneInfoFormConstants = {
  whatIsYourPhoneNumber: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('What is your phone number?'),
  forYourSafetyAndSecurity: function forYourSafetyAndSecurity(providerName, notifyPhoneNumber) {
    return __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._(
    /*i18n*/
    {
      id: "For your safety & security, Rover will not expose your phone number until you've booked your stay. Messages from {providerName} will come from <strong>{notifyPhoneNumber}</strong>, a number owned by Rover.",
      values: {
        providerName: providerName,
        notifyPhoneNumber: notifyPhoneNumber
      }
    });
  },
  textMeWhenReplies: function textMeWhenReplies(providerName) {
    return __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._(
    /*i18n*/
    {
      id: "Text me when {providerName} replies.",
      values: {
        providerName: providerName
      }
    });
  }
};
var PhotosFormConstants = {
  iWouldLikeToReceivePhotos: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._("I'd like to receive photos of my pet(s) during this stay.")
};
var SdvCalloutConstants = {
  withRoverCards: function withRoverCards(providerName, service) {
    return __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._(
    /*i18n*/
    {
      id: "With Rover Cards, you'll know when {providerName} starts the service ({service}). Afterward, you'll receive a summary including walk info (if one happened), photos, and any pet events that occurred.",
      values: {
        providerName: providerName,
        service: service
      }
    });
  }
};
var TosFormConstants = {
  iAgreeToRoverdotcom: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('I agree to the Rover.com'),
  termsOfService: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('Terms of Service')
};
var UnavailableModalConstants = {
  title: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._("Let's find some great dog walkers"),
  buttonTextClose: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('Back'),
  buttonText: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('Search for local dog walkers'),
  notAvailableMessage: function notAvailableMessage(zipCode) {
    return __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._(
    /*i18n*/
    {
      id: "Rover Now is not available in {zipCode} yet but you can still find someone great in your neighborhood within the nation's largest network of dog walkers.",
      values: {
        zipCode: zipCode
      }
    });
  }
};
var EmergencyFormConstants = {
  petsSafetyInfo: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._("Your pet's safety info"),
  missedPetsSafetyInfo: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._("We're missing some safety info"),
  filtersSitter: function filtersSitter(petList) {
    return __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._(
    /*i18n*/
    {
      id: "Make sure all the information for {petList} is up-to-date for your sitter",
      values: {
        petList: petList
      }
    });
  },
  returnButton: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('Return to Conversation')
};
var VetInfoConstants = {
  title: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('Veterinary Info'),
  incomplete: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('INCOMPLETE'),
  complete: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('COMPLETE'),
  updateButton: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('Update veterinary info'),
  save: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('Save'),
  contactInfo: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('Add your veterinarian’s name & contact info')
};
var CareInstructionsConstants = {
  title: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('Care instructions'),
  incomplete: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('INCOMPLETE'),
  complete: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('COMPLETE'),
  instructionsReminder: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._("Be sure to include your dog's typical meal and potty schedule, how much you feed them, and any medication instructions"),
  updateButton: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('Update care instructions'),
  save: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('Save')
};
var ContactDateAndTimeConstants = {
  errorMessage: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('Please select a date'),
  shouldThisBookingRepeat: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('Should this booking repeat every week?'),
  repeatOptions: {
    yes: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('Yes'),
    no: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('No')
  }
};
var ContiguousTimesConstants = {
  placeholder: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('Select a date'),
  defaultPlaceholder: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('Select a Date'),
  dropOff: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('Drop-off'),
  pickUp: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('Pick-up'),
  start: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('Start'),
  end: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('End'),
  dropOffMessage: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('When would you like to drop off?'),
  pickUpMessage: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('When would you like to pick up?'),
  startMessage: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('When would you like to start?'),
  endMessage: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('When would you like to end?'),
  requestedPickUpAndDropOffFrom: function requestedPickUpAndDropOffFrom(requesterName, addressLine1, addressLine2, city, state, zip) {
    return __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._(
    /*i18n*/
    {
      id: "{requesterName} requested pick-up and drop-off from:\n{addressLine1} {addressLine2}\n{city}, {state} {zip}",
      values: {
        requesterName: requesterName,
        addressLine1: addressLine1,
        addressLine2: addressLine2,
        city: city,
        state: state,
        zip: zip
      }
    });
  },
  requestedPickUpAndDropOffForTheStay: function requestedPickUpAndDropOffForTheStay(requesterName) {
    return __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._(
    /*i18n*/
    {
      id: "{requesterName} requested pick-up and drop-off for this stay. Please confirm their address before booking this stay.",
      values: {
        requesterName: requesterName
      }
    });
  },
  pickUpBetweenTimesOnADate: function pickUpBetweenTimesOnADate(earliest, latest, date) {
    return __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._(
    /*i18n*/
    {
      id: "Pick-up: between {earliest} and {latest} on {date}",
      values: {
        earliest: earliest,
        latest: latest,
        date: date
      }
    });
  },
  dropOffBetweenTimesOnADate: function dropOffBetweenTimesOnADate(earliest, latest, date) {
    return __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._(
    /*i18n*/
    {
      id: "Drop-off: between {earliest} and {latest} on {date}",
      values: {
        earliest: earliest,
        latest: latest,
        date: date
      }
    });
  },
  startBetweenTimesOnADate: function startBetweenTimesOnADate(earliest, latest, date) {
    return __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._(
    /*i18n*/
    {
      id: "Start: between {earliest} and {latest} on {date}",
      values: {
        earliest: earliest,
        latest: latest,
        date: date
      }
    });
  },
  endBetweenTimesOnADate: function endBetweenTimesOnADate(earliest, latest, date) {
    return __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._(
    /*i18n*/
    {
      id: "End: between {earliest} and {latest} on {date}",
      values: {
        earliest: earliest,
        latest: latest,
        date: date
      }
    });
  },
  pickUpOnADate: function pickUpOnADate(date) {
    return __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._(
    /*i18n*/
    {
      id: "Pick-up on {date}",
      values: {
        date: date
      }
    });
  },
  dropOffOnADate: function dropOffOnADate(date) {
    return __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._(
    /*i18n*/
    {
      id: "Drop-off on {date}",
      values: {
        date: date
      }
    });
  },
  startOnADate: function startOnADate(date) {
    return __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._(
    /*i18n*/
    {
      id: "Start on {date}",
      values: {
        date: date
      }
    });
  },
  endOnADate: function endOnADate(date) {
    return __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._(
    /*i18n*/
    {
      id: "End on {date}",
      values: {
        date: date
      }
    });
  }
};
var EnhancedAddOnsConstants = {
  extrasAndUpgrades: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('Extras and upgrades'),
  treatYourself: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('Treat yourself (and your dog!) by upgrading your booking.'),
  noteYourAddress: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('Note: Your address will be shared with the sitter.')
};
var FrequencyToggleConstants = {
  howOftenDoYouNeed: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('How often do you need #[span.service service_name]?'),
  howOften: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('How often?'),
  oneTime: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('One Time'),
  repeatWeekly: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('Repeat Weekly')
};
var NonContiguousTimesConstants = {
  whatDaysWouldYouLike: function whatDaysWouldYouLike(serviceSlug) {
    return serviceSlug === 'dog-walking' ? __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('What days would you like walks?') : __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('What days would you like day care?');
  },
  providerMayArrive: function providerMayArrive(providerName) {
    return __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._(
    /*i18n*/
    {
      id: "{providerName} may arrive an hour earlier or later than the time you select.",
      values: {
        providerName: providerName
      }
    });
  },
  whichDates: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('Which dates?'),
  addAndSelectPeferredTimes: function addAndSelectPeferredTimes(serviceSlug) {
    return serviceSlug === 'dog-walking' ? __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('Add and select preferred times for walks below') : __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('Add and select preferred times for your visits below');
  },
  selectYourPreferredPickUpDropOff: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('Select your preferred pick-up and drop-off times'),
  selectYourPreferredDropOffPickUp: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('Select your preferred drop-off and pick-up times'),
  selectYourPreferredStartEnd: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('Select your preferred start and end times'),
  whenWouldYouLikeToStart: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('When would you like to start?'),
  pickUpBetween: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('Pick-up Between'),
  dropOffBetween: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('Drop-off Between'),
  serviceRequestRecurring: function serviceRequestRecurring(serviceName, startDate) {
    return __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._(
    /*i18n*/
    {
      id: "{0} Request - Repeat Service starting on {startDate}",
      values: {
        0: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._(serviceName),
        startDate: startDate
      }
    });
  },
  serviceRequestOneTime: function serviceRequestOneTime(serviceName) {
    return __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._(
    /*i18n*/
    {
      id: "{0} Request - One Time:",
      values: {
        0: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._(serviceName)
      }
    });
  },
  pickUpBetweenWithDates: function pickUpBetweenWithDates(earliest, latest) {
    return __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._(
    /*i18n*/
    {
      id: "Pick-up Between: {earliest} and {latest}",
      values: {
        earliest: earliest,
        latest: latest
      }
    });
  },
  dropOffBetweenWithDates: function dropOffBetweenWithDates(earliest, latest) {
    return __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._(
    /*i18n*/
    {
      id: "Drop-off Between: {earliest} and {latest}",
      values: {
        earliest: earliest,
        latest: latest
      }
    });
  },
  startBetweenWithDates: function startBetweenWithDates(earliest, latest) {
    return __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._(
    /*i18n*/
    {
      id: "Start Between: {earliest} and {latest}",
      values: {
        earliest: earliest,
        latest: latest
      }
    });
  },
  endBetweenWithDates: function endBetweenWithDates(earliest, latest) {
    return __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._(
    /*i18n*/
    {
      id: "End Between: {earliest} and {latest}",
      values: {
        earliest: earliest,
        latest: latest
      }
    });
  },
  pudoMessageWithAddress: function pudoMessageWithAddress(requesterName, addressLine1, addressLine2, city, state, zip) {
    return __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._(
    /*i18n*/
    {
      id: "{requesterName} requested pick-up and drop-off from:\n{addressLine1} {addressLine2}\n{city}, {state} {zip}",
      values: {
        requesterName: requesterName,
        addressLine1: addressLine1,
        addressLine2: addressLine2,
        city: city,
        state: state,
        zip: zip
      }
    });
  },
  pudoMessageWithoutAddress: function pudoMessageWithoutAddress(requesterName) {
    return __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._(
    /*i18n*/
    {
      id: "{requesterName} requested pick-up and drop-off for this stay. Please confirm their address before booking this stay.",
      values: {
        requesterName: requesterName
      }
    });
  },
  recurringFrequencyText: function recurringFrequencyText(date) {
    return __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._(
    /* i18n:
    {date} is formatted date e.g. Jun 02, 2018 or 02 juin 2018
    */
    {
      id: "Repeat Service starting on {date}",
      values: {
        date: date
      }
    });
  },
  oneTimeFrequencyText: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('One Time:'),
  recurringNumUnitMessage: function recurringNumUnitMessage(count, unitText, weekday, times) {
    return __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._(
    /* i18n: 2 walks on Sunday at 10:00 AM */
    {
      id: "{count} {unitText} on {weekday} at {times}",
      values: {
        count: count,
        unitText: unitText,
        weekday: weekday,
        times: times
      }
    });
  },
  nonRecurringNumUnitMessage: function nonRecurringNumUnitMessage(count, unitText, date, times) {
    return __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._(
    /* i18n: 2 walks on Sat, Jun 02 at 10:00 AM */
    {
      id: "{count} {unitText} on {date} at {times}",
      values: {
        count: count,
        unitText: unitText,
        date: date,
        times: times
      }
    });
  }
};
var LastUpdatedTimestampsConstants = {
  neverUpdated: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('Never updated'),
  updatedToday: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('Last updated today'),
  updatedAgo: function updatedAgo(humanizedTimeSinceUpdated) {
    return __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._(
    /*i18n*/
    {
      id: "Last updated {humanizedTimeSinceUpdated} ago",
      values: {
        humanizedTimeSinceUpdated: humanizedTimeSinceUpdated
      }
    });
  },
  saveButtonText: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('Save')
};
var AddPetFormConstants = {
  errorMessage: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('Please select at least one pet'),
  addAdditionalPet: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('Add additional pet')
};
var AddPetFormRowConstants = {
  enterInformationForPet: function enterInformationForPet(petName) {
    return __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._(
    /*i18n*/
    {
      id: "Enter information for {petName}",
      values: {
        petName: petName
      }
    });
  },
  updateInformationForPet: function updateInformationForPet(petName) {
    return __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._(
    /*i18n*/
    {
      id: "Update information for {petName}",
      values: {
        petName: petName
      }
    });
  },
  labelDog: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('Dog'),
  labelCat: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('Cat'),
  labelName: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('Name'),
  nameRequired: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('Name Required'),
  labelWeightWithUnit: function labelWeightWithUnit(weightUnit) {
    return __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._(
    /* i18n: e.g 'Weight (lbs)' */
    {
      id: "Weight ({weightUnit})",
      values: {
        weightUnit: weightUnit
      }
    });
  },
  labelWeight: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('Weight'),
  labelBreeds: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('Breed(s)'),
  placeholderBreeds: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('Breeds'),
  enterBreedsMessage: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('Enter all breeds that apply'),
  enterBreedsMessageDog: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('If your dog is a mixed breed, add ‘Mixed’ as well.'),
  enterBreedsMessageCat: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._(
  /* i18n: e.g 'Enter all breeds that apply (optional).' */
  '(optional).'),
  labelAgeYears: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('Age (years)'),
  labelAgeMonths: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('Age (months)'),
  labelSex: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('Sex'),
  labelSexM: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('Male'),
  labelSexF: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('Female'),
  confirmPetRemoval: function confirmPetRemoval(petName) {
    return __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._(
    /* i18n: {0} will be either pet's name or 'this pet' */
    {
      id: "Are you sure you want to remove {0}?",
      values: {
        0: petName || 'this pet'
      }
    });
  }
};
var ConfirmedAvailabilityConstants = {
  headerTitle: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('Your availability for the next 2 weeks'),
  editCalendar: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('Edit my full calendar'),
  instructions: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('Want more requests that are right for you?<br/>Confirm your availability to highlight your profile in search results. Deselect any days you’re <span class="semibold-text">not</span> available.'),
  confirmButtonText: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('Confirm Availability'),
  popoverNew: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('NEW'),
  popoverHeaderText: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('Highlight your profile in search'),
  popoverParagrafText: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._("Let potential clients know that you're available for new requests. Confirm your schedule over the next two weeks to highlight your profile in search."),
  popoverLearnMoreLink: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('Learn more'),
  popoverDismissLink: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('Dismiss')
};
var ConfirmedAvailabilityCalendarButtonConstants = {
  popupText: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('Confirm your availability to highlight your profile in the search results'),
  cancelButtonText: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('Cancel'),
  modalTitle: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('Is your calendar up-to-date for the next 2 weeks?')
};
var CheckboxCategoryConstants = {
  less: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('Less'),
  more: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('More')
};
var multiDatePickerConstants = {
  errorMessage: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('Please select at least one date')
};
var petTypeButtonsConstants = {
  whatTypeOfPet: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('What type of pet?'),
  cat: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('Cat'),
  dog: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('Dog')
};
var TimepickerConstants = {
  errorMessage: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('Please select a time'),
  placeholder: __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._('Select a time'),
  ariaLabel: function ariaLabel(label) {
    return __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._(
    /* i18n: {label} is a service label e.g. "Visits", "Stay", "Walks" */
    {
      id: "Time of {label}",
      values: {
        label: label
      }
    });
  }
};
var TimepickerDayConstants = {
  addService: function addService(service) {
    return __WEBPACK_IMPORTED_MODULE_0__rover_utilities_translation__["default"]._(
    /* i18n: {service} is a service label e.g. "Visit", "Walk" */
    {
      id: "Add a {service}",
      values: {
        service: service
      }
    });
  }
};

/***/ }),
/* 216 */,
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SENSITIVE_DATA_CLASS; });
var SENSITIVE_DATA_CLASS = 'fs-hide';
/* unused harmony default export */ var _unused_webpack_default_export = ({
  SENSITIVE_DATA_CLASS: SENSITIVE_DATA_CLASS
});

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rover_shared_css_rover_icons_rover_icons_css__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rover_shared_css_rover_icons_rover_icons_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__rover_shared_css_rover_icons_rover_icons_css__);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }





var Icon = function Icon(_ref) {
  var icon = _ref.icon,
      className = _ref.className,
      other = _objectWithoutProperties(_ref, ["icon", "className"]);

  var props = _objectSpread({}, other, {
    className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()({
      'rover-icon': typeof icon === 'string' && icon.includes('rover'),
      fa: typeof icon === 'string' && icon.indexOf('fa') !== -1
    }, icon, className)
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", props);
};

Icon.defaultProps = {
  className: ''
};
/* harmony default export */ __webpack_exports__["a"] = (Icon);

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../shared/js/constants/i18n/language.js
var i18n_language = __webpack_require__(124);

// EXTERNAL MODULE: ../design-system/style-dictionary/build/es6/i18nFormatMap.constants.js
var i18nFormatMap_constants = __webpack_require__(247);

// EXTERNAL MODULE: ../shared/js/constants/i18n/datetime/generateExternalFormatMap.js
var generateExternalFormatMap = __webpack_require__(387);

// EXTERNAL MODULE: ../shared/js/constants/i18n/datetime/generateFormatMap.js
var generateFormatMap = __webpack_require__(392);

// EXTERNAL MODULE: ../shared/js/constants/i18n/datetime/getLocalizedFormatContextless.js
var getLocalizedFormatContextless = __webpack_require__(393);

// CONCATENATED MODULE: ../shared/js/constants/i18n/datetime/datetimeContextless.js





var datetimeContextless_getExternalFormatMap = function getExternalFormatMap(language) {
  return Object(generateExternalFormatMap["a" /* default */])(getLocalizedFormatContextless["a" /* default */], language);
};

var datetimeContextless_getDateTimeFormatMapForLang = function getDateTimeFormatMapForLang(language) {
  return Object(generateFormatMap["a" /* default */])(getLocalizedFormatContextless["a" /* default */], language);
};


// CONCATENATED MODULE: ../shared/js/constants/i18n/datetime/index.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return defaultDateTimeFormatMap; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return datetimeContextless_getDateTimeFormatMapForLang; });
/* unused concated harmony import getExternalFormatMap */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return datetimeContextless_getExternalFormatMap; });
/* unused concated harmony import I18N_FORMAT_MAP */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return i18nFormatMap_constants["a" /* default */]; });


var defaultDateTimeFormatMap = datetimeContextless_getDateTimeFormatMapForLang(i18n_language["a" /* DEFAULT_LANG */]);


/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BookingAddOn__ = __webpack_require__(250);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PriceObjDefaults", function() { return __WEBPACK_IMPORTED_MODULE_0__BookingAddOn__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apiResponses__ = __webpack_require__(265);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__interfaces__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__interfaces___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__interfaces__);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Enum__ = __webpack_require__(6);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Enum", function() { return __WEBPACK_IMPORTED_MODULE_3__Enum__["a"]; });





/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// CONCATENATED MODULE: ../react-lib/src/components/utils/ScrollToError/ScrollToError.js
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }



var ScrollToError =
/*#__PURE__*/
function (_Component) {
  _inherits(ScrollToError, _Component);

  function ScrollToError() {
    _classCallCheck(this, ScrollToError);

    return _possibleConstructorReturn(this, _getPrototypeOf(ScrollToError).apply(this, arguments));
  }

  _createClass(ScrollToError, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return this.props.shouldScroll !== nextProps.shouldScroll || this.props.errorClass !== nextProps.errorClass;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this$props = this.props,
          shouldScroll = _this$props.shouldScroll,
          errorClass = _this$props.errorClass;
      var errorElement = document.getElementsByClassName(errorClass)[0];

      if (shouldScroll && errorElement) {
        // $FlowFixMe
        errorElement.scrollIntoView({
          block: 'nearest'
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return ScrollToError;
}(react["Component"]);


// CONCATENATED MODULE: ../react-lib/src/components/utils/ScrollToError/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return ScrollToError; });


/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, "A <Router> may have only one child element");

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, "You cannot change <Router history>");
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var parent = arguments[2];

  if (typeof options === "string") options = { path: options };

  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;


  if (path == null) return parent;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === "/" && url === "" ? "/" : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_constants__ = __webpack_require__(41);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }




var VerticalWrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div.withConfig({
  displayName: "VerticalLayout__VerticalWrapper",
  componentId: "sc-12qhy07-0"
})(["width:100%;display:flex;flex-direction:column;justify-content:", ";align-items:", ";"], function (props) {
  return props.vAlign.toString();
}, function (props) {
  return props.hAlign.toString();
});
var VerticalLayout = __WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(function (props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(VerticalWrapper, _extends({
    ref: ref
  }, props), props.children);
}); // $FlowFixMe

VerticalLayout.defaultProps = {
  style: {},
  vAlign: __WEBPACK_IMPORTED_MODULE_2__layout_constants__["a" /* ALIGNMENT */].START,
  hAlign: __WEBPACK_IMPORTED_MODULE_2__layout_constants__["a" /* ALIGNMENT */].START
};
/* harmony default export */ __webpack_exports__["a"] = (VerticalLayout);

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/axios/index.js
var axios = __webpack_require__(87);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// EXTERNAL MODULE: ../utilities/userAgent.js
var utilities_userAgent = __webpack_require__(60);

// EXTERNAL MODULE: ../utilities/cookie/index.client.js + 4 modules
var index_client = __webpack_require__(328);

// EXTERNAL MODULE: ../utilities/reportError.js
var reportError = __webpack_require__(34);

// CONCATENATED MODULE: ../utilities/axiosUtils/getStatsdTagForUrl.js
/* Allowing every URL to be sent as a tag in StatsD would give us an unbounded number of URLs. Instead we match URLs with regexes, then give them a static tag. */
// MORE SPECIFIC REGEXES MUST GO FIRST, FIRST MATCH WINS
var urlTagMapArray = [{
  regex: /https:\/\/api\.lever\.co\/v0\/postings\/rover\?group=team&mode=json/,
  tag: 'https://api.lever.co/v0/postings/rover?group=team&mode=json'
}, {
  regex: /\/frontend\/current-user\//,
  tag: '/frontend/current-user/'
}, {
  regex: /\/frontend\/experiments\//,
  tag: '/frontend/experiments/'
}, {
  regex: /\/search-optimized\//,
  tag: '/search-optimized/'
}, {
  regex: /\/people\/[a-zA-Z0-9]+\/home\//,
  tag: '/people/:personOpk/home/'
}, {
  regex: /\/cities-and-neighborhoods\//,
  tag: '/cities-and-neighborhoods/'
}, {
  regex: /\/country-configuration\/current\//,
  tag: '/country-configuration/current/'
}, {
  regex: /\/country-configuration\//,
  tag: '/country-configuration/'
}, {
  regex: /\/frontend\/country-footer-links\//,
  tag: '/country-footer-links/'
}, {
  regex: /\/frontend\/country-region-links\//,
  tag: '/frontend/country-region-links/'
}, {
  regex: /\/frontend\/events\//,
  tag: '/frontend/events/'
}, {
  regex: /\/frontend\/configuration\//,
  tag: '/frontend/configuration/'
}, {
  regex: /\/announcements\/global\//,
  tag: '/announcements/global/'
}, {
  regex: /\/frontend\/href-langs\//,
  tag: '/frontend/href-langs/'
}, {
  regex: /\/utilities\/location-autocomplete\//,
  tag: '/utilities/location-autocomplete/'
}, {
  regex: /\/utilities\/location-geocode\//,
  tag: '/utilities/location-geocode/'
}, {
  regex: /\/frontend\/location-service\//,
  tag: '/frontend/location-service/'
}, {
  regex: /\/announcements\/notifications\//,
  tag: '/announcements/notifications/'
}, {
  regex: /\/payment-intents\//,
  tag: '/payment-intents/'
}, {
  regex: /\/me\//,
  tag: '/me/'
}, {
  regex: /\/pets\//,
  tag: '/pets/'
}, {
  regex: /\/seo-location\//,
  tag: '/seo-location/'
}, {
  regex: /\/service-types\//,
  tag: '/service-types/'
}, {
  regex: /\/frontend\/top-cities\//,
  tag: '/frontend/top-cities/'
}, {
  regex: /\/frontend\/footer\//,
  tag: '/frontend/footer/'
}, {
  regex: /\/homepage\/configuration\//,
  tag: '/homepage/configuration/'
}];
/* harmony default export */ var getStatsdTagForUrl = (function (url, fallback) {
  var urlTagMap = urlTagMapArray.find(function (_ref) {
    var regex = _ref.regex;
    return regex.test(url);
  });
  if (!urlTagMap) return fallback || 'unknown';
  return urlTagMap.tag;
});
// CONCATENATED MODULE: ../utilities/axiosUtils/axiosErrorHandler.js


var axiosErrorHandler_axiosErrorHandler = function axiosErrorHandler(e, PROFILER, PROFILER_KEYS) {
  var error;

  if (e && e.config && e.config.method) {
    var isTimeout = e.code === 'ECONNABORTED';
    var apiUrl = getStatsdTagForUrl(e.config.url, 'No Match Found');
    var apiMethod = e.config.method.toUpperCase();

    if (isTimeout && PROFILER && PROFILER_KEYS) {
      PROFILER.increment({
        key: PROFILER_KEYS.API_CALL_TIMEOUT,
        tags: {
          apiMethod: apiMethod,
          apiUrl: apiUrl
        }
      });
    }

    var errorUrl = getStatsdTagForUrl(e.config.url);
    error = new Error("axiosUtils ".concat(isTimeout ? 'timed out' : 'errored', " while requesting \"").concat(apiMethod, " ").concat(errorUrl, "\": ").concat(e.message));
  } else {
    error = new Error(e);
  }

  if (!e.status) throw error;
  throw e;
};

/* harmony default export */ var axiosUtils_axiosErrorHandler = (axiosErrorHandler_axiosErrorHandler);
// CONCATENATED MODULE: ../utilities/axiosUtils/axiosUtils.client.js
/* unused harmony export DEFAULT_CSRF_COOKIE_NAME */
/* unused harmony export CSRF_META_TAG_NAME */
/* unused harmony export getCsrfCookieName */
/* unused harmony export getSourceDescription */
/* unused harmony export getSourceHeader */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return axiosUtils_client_getCsrfToken; });
/* unused harmony export isRoverUrl */
/* unused harmony export addRoverHeaders */
/* unused harmony export createRequestInterceptor */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return axiosUtils_client_getAxiosInstance; });
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var DEFAULT_CSRF_COOKIE_NAME = 'csrftoken';
var CSRF_META_TAG_NAME = 'csrf-cookie-name';
var getCsrfCookieName = function getCsrfCookieName() {
  var meta = document.querySelector("meta[name=".concat(CSRF_META_TAG_NAME, "]"));
  var metaCookieName = meta && meta.getAttribute('content');
  return metaCookieName || DEFAULT_CSRF_COOKIE_NAME;
};
var axiosUtils_client_getSourceDescription = function getSourceDescription() {
  var _navigator = navigator,
      userAgent = _navigator.userAgent;
  if (!userAgent || !userAgent.length || !Object(utilities_userAgent["e" /* isMobileBrowser */])(userAgent)) return 'web'; // If the user agent string doesn't exist, assume this is a web request

  if (!Object(utilities_userAgent["f" /* isMobileEmbedded */])()) return 'mobile_web';
  return Object(utilities_userAgent["h" /* isiOS */])(userAgent) ? 'ios' : 'android';
};
var getSourceHeader = function getSourceHeader() {
  var source = axiosUtils_client_getSourceDescription();
  return {
    'X-Rover-Source': source
  };
};
var axiosUtils_client_getCsrfToken = function getCsrfToken() {
  return Object(index_client["b" /* getCookie */])(getCsrfCookieName());
};
var isRoverUrl = function isRoverUrl(url) {
  return url.includes(window.location.hostname) || url.startsWith('/') || url.startsWith('./') || url.startsWith('../');
};
var addRoverHeaders = function addRoverHeaders(config) {
  var roverConfig = _objectSpread({}, config);

  var token = axiosUtils_client_getCsrfToken();
  roverConfig.headers.common = _objectSpread({}, config.headers.common, {}, getSourceHeader(), {}, token && {
    'X-CSRFToken': token
  });
  return roverConfig;
};
var createRequestInterceptor = function createRequestInterceptor() {
  return function (defaultConfig) {
    var isRover = isRoverUrl(defaultConfig.url);
    if (!isRover) return defaultConfig; // non-rover urls get NOTHING, to avoid CORS issues

    var configWithHeaders = addRoverHeaders(defaultConfig);
    return configWithHeaders;
  };
};
var axiosUtils_client_getAxiosInstance = function getAxiosInstance(expressParams) {
  if (expressParams) Object(reportError["a" /* default */])('Error in axiosUtils.client.js: expressParams was found');
  var ai = axios_default.a.create();
  ai.interceptors.request.use(createRequestInterceptor(), axiosUtils_axiosErrorHandler);
  return ai;
};
var axiosUtils = {
  getAxiosInstance: axiosUtils_client_getAxiosInstance
};
/* harmony default export */ var axiosUtils_client = (axiosUtils);

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(1);

// EXTERNAL MODULE: ../node_modules/classnames/index.js
var classnames = __webpack_require__(24);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ../react-lib/src/styles/index.js + 3 modules
var styles = __webpack_require__(2);

// EXTERNAL MODULE: ../react-lib/src/constants/sensitiveData.constants.js
var sensitiveData_constants = __webpack_require__(217);

// CONCATENATED MODULE: ../react-lib/src/components/utils/AsInput/AsInput.jsx
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }






var Wrapper = Object(styled_components_browser_esm["default"])(function (_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ["children"]);

  return react_default.a.cloneElement(children, props);
}).withConfig({
  displayName: "AsInput__Wrapper",
  componentId: "f2icci-0"
})(["height:40px;width:100%;background-color:", ";border-radius:", ";border:1px solid ", ";color:", ";display:block;padding:", ";transition:border-color ease-in-out 0.15s;&:focus{border:1px solid ", ";outline:none;}&:disabled{background-color:", ";border:1px solid ", ";cursor:not-allowed;opacity:1;}"], styles["d" /* DSToken */].BACKGROUND_COLOR_PRIMARY, styles["d" /* DSToken */].BORDER_RADIUS, styles["d" /* DSToken */].BORDER_COLOR_PRIMARY, styles["d" /* DSToken */].TEXT_COLOR_PRIMARY, styles["k" /* Spacing */].S, styles["d" /* DSToken */].BORDER_COLOR_INPUT_FOCUS, styles["d" /* DSToken */].INTERACTIVE_BACKGROUND_COLOR_DISABLED, styles["d" /* DSToken */].INTERACTIVE_BORDER_COLOR_DISABLED);

var AsInput_getClassNames = function getClassNames(sensitive, className) {
  return classnames_default()(className, _defineProperty({}, sensitiveData_constants["a" /* SENSITIVE_DATA_CLASS */], sensitive));
};

var AsInput_AsInput = function AsInput(props) {
  var children = props.children,
      className = props.className,
      inputRef = props.inputRef,
      _onChange = props.onChange,
      sensitive = props.sensitive;
  var inputProps = {
    className: AsInput_getClassNames(sensitive, className),
    onChange: function onChange(event) {
      return _onChange(event.target.value);
    }
  };

  if (inputRef) {
    inputProps.ref = inputRef;
  }

  return react_default.a.createElement(Wrapper, {
    className: AsInput_getClassNames(sensitive, className)
  }, children(inputProps));
};

AsInput_AsInput.defaultProps = {
  className: '',
  inputRef: undefined,
  onChange: function onChange() {},
  sensitive: false
};
/* harmony default export */ var utils_AsInput_AsInput = (AsInput_AsInput);
// CONCATENATED MODULE: ../react-lib/src/components/utils/AsInput/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return utils_AsInput_AsInput; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return Wrapper; });


/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VerticalLayout__ = __webpack_require__(224);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__VerticalLayout__["a"]; });


/***/ }),
/* 228 */,
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LoadingButton__ = __webpack_require__(302);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__LoadingButton__["a"]; });


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Arrow = exports.Popper = exports.Target = exports.Manager = undefined;

var _Manager2 = __webpack_require__(231);

var _Manager3 = _interopRequireDefault(_Manager2);

var _Target2 = __webpack_require__(232);

var _Target3 = _interopRequireDefault(_Target2);

var _Popper2 = __webpack_require__(233);

var _Popper3 = _interopRequireDefault(_Popper2);

var _Arrow2 = __webpack_require__(235);

var _Arrow3 = _interopRequireDefault(_Arrow2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Manager = _Manager3.default;
exports.Target = _Target3.default;
exports.Popper = _Popper3.default;
exports.Arrow = _Arrow3.default;

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Manager = function (_Component) {
  _inherits(Manager, _Component);

  function Manager() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Manager);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Manager.__proto__ || Object.getPrototypeOf(Manager)).call.apply(_ref, [this].concat(args))), _this), _this._setTargetNode = function (node) {
      _this._targetNode = node;
    }, _this._getTargetNode = function () {
      return _this._targetNode;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Manager, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        popperManager: {
          setTargetNode: this._setTargetNode,
          getTargetNode: this._getTargetNode
        }
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          tag = _props.tag,
          children = _props.children,
          restProps = _objectWithoutProperties(_props, ['tag', 'children']);

      if (tag !== false) {
        return (0, _react.createElement)(tag, restProps, children);
      } else {
        return children;
      }
    }
  }]);

  return Manager;
}(_react.Component);

Manager.childContextTypes = {
  popperManager: _propTypes2.default.object.isRequired
};
Manager.propTypes = {
  tag: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool])
};
Manager.defaultProps = {
  tag: 'div'
};
exports.default = Manager;

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Target = function Target(props, context) {
  var _props$component = props.component,
      component = _props$component === undefined ? 'div' : _props$component,
      innerRef = props.innerRef,
      children = props.children,
      restProps = _objectWithoutProperties(props, ['component', 'innerRef', 'children']);

  var popperManager = context.popperManager;

  var targetRef = function targetRef(node) {
    popperManager.setTargetNode(node);
    if (typeof innerRef === 'function') {
      innerRef(node);
    }
  };

  if (typeof children === 'function') {
    var targetProps = { ref: targetRef };
    return children({ targetProps: targetProps, restProps: restProps });
  }

  var componentProps = _extends({}, restProps);

  if (typeof component === 'string') {
    componentProps.ref = targetRef;
  } else {
    componentProps.innerRef = targetRef;
  }

  return (0, _react.createElement)(component, componentProps, children);
};

Target.contextTypes = {
  popperManager: _propTypes2.default.object.isRequired
};

Target.propTypes = {
  component: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]),
  innerRef: _propTypes2.default.func,
  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func])
};

exports.default = Target;

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _popper = __webpack_require__(234);

var _popper2 = _interopRequireDefault(_popper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Popper = function (_Component) {
  _inherits(Popper, _Component);

  function Popper() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Popper);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Popper.__proto__ || Object.getPrototypeOf(Popper)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this._setArrowNode = function (node) {
      _this._arrowNode = node;
    }, _this._getTargetNode = function () {
      return _this.context.popperManager.getTargetNode();
    }, _this._getOffsets = function (data) {
      return Object.keys(data.offsets).map(function (key) {
        return data.offsets[key];
      });
    }, _this._isDataDirty = function (data) {
      if (_this.state.data) {
        return JSON.stringify(_this._getOffsets(_this.state.data)) !== JSON.stringify(_this._getOffsets(data));
      } else {
        return true;
      }
    }, _this._updateStateModifier = {
      enabled: true,
      order: 900,
      fn: function fn(data) {
        if (_this._isDataDirty(data)) {
          _this.setState({ data: data });
        }
        return data;
      }
    }, _this._getPopperStyle = function () {
      var data = _this.state.data;

      // If Popper isn't instantiated, hide the popperElement
      // to avoid flash of unstyled content

      if (!data) {
        return {
          position: 'absolute',
          pointerEvents: 'none',
          opacity: 0
        };
      }

      var _data$offsets$popper = data.offsets.popper,
          top = _data$offsets$popper.top,
          left = _data$offsets$popper.left,
          position = _data$offsets$popper.position;


      return _extends({
        position: position
      }, data.styles);
    }, _this._getPopperPlacement = function () {
      return _this.state.data ? _this.state.data.placement : undefined;
    }, _this._getPopperHide = function () {
      return !!_this.state.data && _this.state.data.hide ? '' : undefined;
    }, _this._getArrowStyle = function () {
      if (!_this.state.data || !_this.state.data.offsets.arrow) {
        return {};
      } else {
        var _this$state$data$offs = _this.state.data.offsets.arrow,
            top = _this$state$data$offs.top,
            left = _this$state$data$offs.left;

        return { top: top, left: left };
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Popper, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        popper: {
          setArrowNode: this._setArrowNode,
          getArrowStyle: this._getArrowStyle
        }
      };
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(lastProps) {
      if (lastProps.placement !== this.props.placement || lastProps.eventsEnabled !== this.props.eventsEnabled) {
        this._destroyPopper();
        this._createPopper();
      }

      if (lastProps.children !== this.props.children) {
        this._popper.scheduleUpdate();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._destroyPopper();
    }
  }, {
    key: '_createPopper',
    value: function _createPopper() {
      var _props = this.props,
          placement = _props.placement,
          eventsEnabled = _props.eventsEnabled;

      var modifiers = _extends({}, this.props.modifiers, {
        applyStyle: { enabled: false },
        updateState: this._updateStateModifier
      });

      if (this._arrowNode) {
        modifiers.arrow = {
          element: this._arrowNode
        };
      }

      this._popper = new _popper2.default(this._getTargetNode(), this._node, {
        placement: placement,
        eventsEnabled: eventsEnabled,
        modifiers: modifiers
      });

      // schedule an update to make sure everything gets positioned correctly
      // after being instantiated
      this._popper.scheduleUpdate();
    }
  }, {
    key: '_destroyPopper',
    value: function _destroyPopper() {
      if (this._popper) {
        this._popper.destroy();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          component = _props2.component,
          innerRef = _props2.innerRef,
          placement = _props2.placement,
          eventsEnabled = _props2.eventsEnabled,
          modifiers = _props2.modifiers,
          children = _props2.children,
          restProps = _objectWithoutProperties(_props2, ['component', 'innerRef', 'placement', 'eventsEnabled', 'modifiers', 'children']);

      var popperRef = function popperRef(node) {
        _this2._node = node;
        if (node) {
          _this2._createPopper();
        } else {
          _this2._destroyPopper();
        }
        if (typeof innerRef === 'function') {
          innerRef(node);
        }
      };
      var popperStyle = this._getPopperStyle();
      var popperPlacement = this._getPopperPlacement();
      var popperHide = this._getPopperHide();

      if (typeof children === 'function') {
        var _popperProps;

        var popperProps = (_popperProps = {
          ref: popperRef,
          style: popperStyle
        }, _defineProperty(_popperProps, 'data-placement', popperPlacement), _defineProperty(_popperProps, 'data-x-out-of-boundaries', popperHide), _popperProps);

        return children({
          popperProps: popperProps,
          restProps: restProps,
          scheduleUpdate: function scheduleUpdate() {
            // _createPopper will scheduleUpdate,
            // so calling this before this._popper exists
            // can be a noop.
            _this2._popper && _this2._popper.scheduleUpdate();
          }
        });
      }

      var componentProps = _extends({}, restProps, {
        style: _extends({}, restProps.style, popperStyle),
        'data-placement': popperPlacement,
        'data-x-out-of-boundaries': popperHide
      });

      if (typeof component === 'string') {
        componentProps.ref = popperRef;
      } else {
        componentProps.innerRef = popperRef;
      }

      return (0, _react.createElement)(component, componentProps, children);
    }
  }]);

  return Popper;
}(_react.Component);

Popper.contextTypes = {
  popperManager: _propTypes2.default.object.isRequired
};
Popper.childContextTypes = {
  popper: _propTypes2.default.object.isRequired
};
Popper.propTypes = {
  component: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]),
  innerRef: _propTypes2.default.func,
  placement: _propTypes2.default.oneOf(_popper2.default.placements),
  eventsEnabled: _propTypes2.default.bool,
  modifiers: _propTypes2.default.object,
  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func])
};
Popper.defaultProps = {
  component: 'div',
  placement: 'bottom',
  eventsEnabled: true,
  modifiers: {}
};
exports.default = Popper;

/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.15.0
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';

var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
var timeoutDuration = 0;
for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
  if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
    timeoutDuration = 1;
    break;
  }
}

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var window = element.ownerDocument.defaultView;
  var css = window.getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);

/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent || null;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TH, TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width'], 10) + parseFloat(styles['border' + sideB + 'Width'], 10);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}

function getWindowSizes(document) {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.right - result.left;
  var height = sizes.height || element.clientHeight || result.bottom - result.top;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth, 10);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth, 10);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop, 10);
    var marginLeft = parseFloat(styles.marginLeft, 10);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  var parentNode = getParentNode(element);
  if (!parentNode) {
    return false;
  }
  return isFixed(parentNode);
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  padding = padding || 0;
  var isPaddingNumber = typeof padding === 'number';
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var window = element.ownerDocument.defaultView;
  var styles = window.getComputedStyle(element);
  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);

  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicity asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */
function getRoundedOffsets(data, shouldRound) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
  var round = Math.round,
      floor = Math.floor;

  var noRound = function noRound(v) {
    return v;
  };

  var referenceWidth = round(reference.width);
  var popperWidth = round(popper.width);

  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
  var isVariation = data.placement.indexOf('-') !== -1;
  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;

  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
  var verticalToInteger = !shouldRound ? noRound : round;

  return {
    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
    top: verticalToInteger(popper.top),
    bottom: verticalToInteger(popper.bottom),
    right: horizontalToInteger(popper.right)
  };
}

var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
    // and not the bottom of the html element
    if (offsetParent.nodeName === 'HTML') {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    if (offsetParent.nodeName === 'HTML') {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjunction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized], 10);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width'], 10);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;

    // flips variation if reference element overflows boundaries
    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    // flips variation if popper content overflows boundaries
    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);

    var flippedVariation = flippedVariationByRef || flippedVariationByContent;

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself
  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification
  var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];

  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

  // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;

  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: 'viewport',
    /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariations: false,
    /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariationsByContent: false
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */


    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

/* harmony default export */ __webpack_exports__["default"] = (Popper);
//# sourceMappingURL=popper.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(49)))

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Arrow = function Arrow(props, context) {
  var _props$component = props.component,
      component = _props$component === undefined ? 'span' : _props$component,
      innerRef = props.innerRef,
      children = props.children,
      restProps = _objectWithoutProperties(props, ['component', 'innerRef', 'children']);

  var popper = context.popper;

  var arrowRef = function arrowRef(node) {
    popper.setArrowNode(node);
    if (typeof innerRef === 'function') {
      innerRef(node);
    }
  };
  var arrowStyle = popper.getArrowStyle();

  if (typeof children === 'function') {
    var arrowProps = {
      ref: arrowRef,
      style: arrowStyle
    };
    return children({ arrowProps: arrowProps, restProps: restProps });
  }

  var componentProps = _extends({}, restProps, {
    style: _extends({}, arrowStyle, restProps.style)
  });

  if (typeof component === 'string') {
    componentProps.ref = arrowRef;
  } else {
    componentProps.innerRef = arrowRef;
  }

  return (0, _react.createElement)(component, componentProps, children);
};

Arrow.contextTypes = {
  popper: _propTypes2.default.object.isRequired
};

Arrow.propTypes = {
  component: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]),
  innerRef: _propTypes2.default.func,
  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func])
};

exports.default = Arrow;

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;

var PropTypes = _interopRequireWildcard(__webpack_require__(4));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(81));

var _reactLifecyclesCompat = __webpack_require__(136);

var _PropTypes = __webpack_require__(237);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var UNMOUNTED = 'unmounted';
exports.UNMOUNTED = UNMOUNTED;
var EXITED = 'exited';
exports.EXITED = EXITED;
var ENTERING = 'entering';
exports.ENTERING = ENTERING;
var ENTERED = 'entered';
exports.ENTERED = ENTERED;
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

exports.EXITING = EXITING;

var Transition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  var _proto = Transition.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: null // allows for nested Transitions

    };
  };

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  }; // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }


  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      var node = _reactDom.default.findDOMNode(this);

      if (nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(node, appearing);

      _this2.onTransitionEnd(node, enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  _proto.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED

    if (!exit) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(node);
      });
      return;
    }

    this.props.onExit(node);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      this.props.addEndListener(node, this.nextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      return children(status, childProps);
    }

    var child = _react.default.Children.only(children);

    return _react.default.cloneElement(child, childProps);
  };

  return Transition;
}(_react.default.Component);

Transition.contextTypes = {
  transitionGroup: PropTypes.object
};
Transition.childContextTypes = {
  transitionGroup: function transitionGroup() {}
};
Transition.propTypes =  false ? {
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`, `'unmounted'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
   * If you want to transition on the first mount set `appear` to `true`, and the
   * component will transition in as soon as the `<Transition>` mounts.
   *
   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function timeout(props) {
    var pt = _PropTypes.timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. **Note:** Timeouts are still used as a fallback if provided.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func // Name the function so it is clearer in the documentation

} : {};

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;

var _default = (0, _reactLifecyclesCompat.polyfill)(Transition);

exports.default = _default;

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.classNamesShape = exports.timeoutsShape = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(4));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var timeoutsShape =  false ? _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
  enter: _propTypes.default.number,
  exit: _propTypes.default.number,
  appear: _propTypes.default.number
}).isRequired]) : null;
exports.timeoutsShape = timeoutsShape;
var classNamesShape =  false ? _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
  enter: _propTypes.default.string,
  exit: _propTypes.default.string,
  active: _propTypes.default.string
}), _propTypes.default.shape({
  enter: _propTypes.default.string,
  enterDone: _propTypes.default.string,
  enterActive: _propTypes.default.string,
  exit: _propTypes.default.string,
  exitDone: _propTypes.default.string,
  exitActive: _propTypes.default.string
})]) : null;
exports.classNamesShape = classNamesShape;

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(1);

// EXTERNAL MODULE: ../react-lib/src/styles/index.js + 3 modules
var styles = __webpack_require__(2);

// CONCATENATED MODULE: ../react-lib/src/components/typography/LoadingSpinner/LoadingSpinner.jsx
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }




var Spinner = styled_components_browser_esm["default"].i.withConfig({
  displayName: "LoadingSpinner__Spinner",
  componentId: "p4ysho-0"
})(["font-size:14px;position:relative;color:", ";@keyframes spin{0%{transform:rotate(0deg);}100%{transform:rotate(359deg);}}animation:spin 2s infinite linear;"], styles["d" /* DSToken */].TEXT_COLOR_TERTIARY);

var LoadingSpinner_LoadingSpinner = function LoadingSpinner(_ref) {
  var className = _ref.className,
      other = _objectWithoutProperties(_ref, ["className"]);

  return react_default.a.createElement(Spinner, _extends({}, other, {
    className: "rover-icon rover-icon-in-spinner ".concat(className)
  }));
};

LoadingSpinner_LoadingSpinner.defaultProps = {
  className: ''
};
/* harmony default export */ var typography_LoadingSpinner_LoadingSpinner = (LoadingSpinner_LoadingSpinner);
// CONCATENATED MODULE: ../react-lib/src/components/typography/LoadingSpinner/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return typography_LoadingSpinner_LoadingSpinner; });


/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__factories_userFactory__ = __webpack_require__(140);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


/* harmony default export */ __webpack_exports__["a"] = (function () {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _objectSpread({
    authenticated: false,
    currentUser: Object(__WEBPACK_IMPORTED_MODULE_0__factories_userFactory__["a" /* default */])(),
    realUser: Object(__WEBPACK_IMPORTED_MODULE_0__factories_userFactory__["a" /* default */])()
  }, opts);
});

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ../node_modules/lodash-es/_baseMerge.js + 5 modules
var _baseMerge = __webpack_require__(259);

// EXTERNAL MODULE: ../node_modules/lodash-es/_createAssigner.js
var _createAssigner = __webpack_require__(260);

// CONCATENATED MODULE: ../node_modules/lodash-es/mergeWith.js



/**
 * This method is like `_.merge` except that it accepts `customizer` which
 * is invoked to produce the merged values of the destination and source
 * properties. If `customizer` returns `undefined`, merging is handled by the
 * method instead. The `customizer` is invoked with six arguments:
 * (objValue, srcValue, key, object, source, stack).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   if (_.isArray(objValue)) {
 *     return objValue.concat(srcValue);
 *   }
 * }
 *
 * var object = { 'a': [1], 'b': [2] };
 * var other = { 'a': [3], 'b': [4] };
 *
 * _.mergeWith(object, other, customizer);
 * // => { 'a': [1, 3], 'b': [2, 4] }
 */
var mergeWith = Object(_createAssigner["a" /* default */])(function(object, source, srcIndex, customizer) {
  Object(_baseMerge["a" /* default */])(object, source, srcIndex, customizer);
});

/* harmony default export */ var lodash_es_mergeWith = (mergeWith);

// EXTERNAL MODULE: ../node_modules/lodash-es/isFunction.js
var isFunction = __webpack_require__(25);

// EXTERNAL MODULE: ../node_modules/lodash-es/isPlainObject.js
var isPlainObject = __webpack_require__(243);

// EXTERNAL MODULE: ../node_modules/lodash-es/mapValues.js
var mapValues = __webpack_require__(116);

// EXTERNAL MODULE: ../node_modules/lodash-es/forEach.js + 1 modules
var forEach = __webpack_require__(255);

// EXTERNAL MODULE: ../node_modules/lodash-es/_arrayEach.js
var _arrayEach = __webpack_require__(115);

// EXTERNAL MODULE: ../node_modules/lodash-es/_baseCreate.js
var _baseCreate = __webpack_require__(146);

// EXTERNAL MODULE: ../node_modules/lodash-es/_baseForOwn.js
var _baseForOwn = __webpack_require__(72);

// EXTERNAL MODULE: ../node_modules/lodash-es/_baseIteratee.js + 9 modules
var _baseIteratee = __webpack_require__(61);

// EXTERNAL MODULE: ../node_modules/lodash-es/_getPrototype.js
var _getPrototype = __webpack_require__(156);

// EXTERNAL MODULE: ../node_modules/lodash-es/isArray.js
var isArray = __webpack_require__(5);

// EXTERNAL MODULE: ../node_modules/lodash-es/isBuffer.js
var isBuffer = __webpack_require__(38);

// EXTERNAL MODULE: ../node_modules/lodash-es/isObject.js
var isObject = __webpack_require__(8);

// EXTERNAL MODULE: ../node_modules/lodash-es/isTypedArray.js + 1 modules
var isTypedArray = __webpack_require__(48);

// CONCATENATED MODULE: ../node_modules/lodash-es/transform.js











/**
 * An alternative to `_.reduce`; this method transforms `object` to a new
 * `accumulator` object which is the result of running each of its own
 * enumerable string keyed properties thru `iteratee`, with each invocation
 * potentially mutating the `accumulator` object. If `accumulator` is not
 * provided, a new object with the same `[[Prototype]]` will be used. The
 * iteratee is invoked with four arguments: (accumulator, value, key, object).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 1.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The custom accumulator value.
 * @returns {*} Returns the accumulated value.
 * @example
 *
 * _.transform([2, 3, 4], function(result, n) {
 *   result.push(n *= n);
 *   return n % 2 == 0;
 * }, []);
 * // => [4, 9]
 *
 * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] }
 */
function transform(object, iteratee, accumulator) {
  var isArr = Object(isArray["a" /* default */])(object),
      isArrLike = isArr || Object(isBuffer["a" /* default */])(object) || Object(isTypedArray["a" /* default */])(object);

  iteratee = Object(_baseIteratee["a" /* default */])(iteratee, 4);
  if (accumulator == null) {
    var Ctor = object && object.constructor;
    if (isArrLike) {
      accumulator = isArr ? new Ctor : [];
    }
    else if (Object(isObject["a" /* default */])(object)) {
      accumulator = Object(isFunction["a" /* default */])(Ctor) ? Object(_baseCreate["a" /* default */])(Object(_getPrototype["a" /* default */])(object)) : {};
    }
    else {
      accumulator = {};
    }
  }
  (isArrLike ? _arrayEach["a" /* default */] : _baseForOwn["a" /* default */])(object, function(value, index, object) {
    return iteratee(accumulator, value, index, object);
  });
  return accumulator;
}

/* harmony default export */ var lodash_es_transform = (transform);

// CONCATENATED MODULE: ../react-lib/src/components/utils/Form/validation/index.js
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







/**
 * This function creates an initial validationErrors
 * object with the appropriate shape. The result will
 * be in "valid" state meaning all leaf values are null.
 *
 * input:
 * {
 *   name: {
 *      first: Form.validators.required,
 *      last: Form.validators.required,
 *   },
 *   email: [Form.validators.required, Form.validators.minLength(3)],
 * }
 *
 * output:
 * {
 *   name: {
 *      first: null,
 *      last: null,
 *   },
 *   email: null,
 * }
 * @param {object} validators
 */

var validation_initializeValidation = function initializeValidation(intialData, validators) {
  var resolvedValidators = Object(isFunction["a" /* default */])(validators) ? // $FlowFixMe(Ryan) flow doesn't understand type refinement from isFunction
  validators(intialData) : validators;
  return lodash_es_mergeWith({}, resolvedValidators, resolvedValidators, function (a, b) {
    if (!Object(isPlainObject["default"])(b)) {
      return null;
    }

    return undefined;
  });
};
/**
 * Validators can be optionally configured. If they
 * haven't been configured in any way, this function
 * will resolve them with default params.
 *
 * @param {function} validator
 */

var validation_resolveValidator = function resolveValidator(validator) {
  var testValue = validator();
  return Object(isFunction["a" /* default */])(testValue) ? testValue : validator;
};
/**
 * This function takes two objects of the same shape:
 * the first contains user input, the other the validator
 * functions. It returns an object of the same shape with
 * error messages (or null) as values.
 *
 * input:
 * {
 *   name: {
 *      first: 'John',
 *      last: '',
 *   },
 *   email: 'jo',
 * },
 * {
 *   name: {
 *      first: Form.validators.required,
 *      last: Form.validators.required,
 *   },
 *   email: [Form.validators.required, Form.validators.minLength(3)],
 * }
 *
 * output:
 * {
 *   name: {
 *      first: null,
 *      last: 'This field is required.',
 *   },
 *   email: 'This field must be at least 3 characters.',
 * }
 * @param {object} data
 * @param {object} validators
 */

var validation_getErrors = function getErrors(data, validators) {
  return Object(mapValues["a" /* default */])(validators, function (value, key) {
    // Recurse into nested objects
    if (Object(isPlainObject["default"])(value)) {
      return getErrors(data[key], value);
    } // Assure validators are in an array


    var validatorList = Array.isArray(value) ? value : [value]; // Run validators serially on data value,
    // terminating early if error is found

    var error = null;
    Object(forEach["a" /* default */])(validatorList, function (validator) {
      error = validation_resolveValidator(validator)(data[key]);
      return error === null;
    });
    return error;
  });
};
/**
 * This function checks to see if there are any non-null
 * values (representing errors) in the object.
 *
 * @param {object} errors
 */

var validation_isValid = function isValid(errors) {
  return lodash_es_transform(errors, function (result, value) {
    if (value !== null && Object(isPlainObject["default"])(value)) {
      result.valid = isValid(value).valid; // eslint-disable-line no-param-reassign
    } else {
      result.valid = value === null; // eslint-disable-line no-param-reassign
    }

    return result.valid;
  }, {
    valid: true
  });
};
var validation_validate = function validate(data, validators) {
  var resolvedValidators = Object(isFunction["a" /* default */])(validators) ? // $FlowFixMe(Ryan) flow doesn't understand type refinement from isFunction
  validators(data) : validators;
  var errors = validation_getErrors(data, resolvedValidators);
  return _objectSpread({}, validation_isValid(errors), {
    errors: errors
  });
};
// EXTERNAL MODULE: ../react-lib/src/components/utils/Form/validation/validators.js
var validation_validators = __webpack_require__(248);

// EXTERNAL MODULE: ../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(1);

// EXTERNAL MODULE: ../react-lib/src/constants/classNames.constants.js
var classNames_constants = __webpack_require__(107);

// EXTERNAL MODULE: ../react-lib/src/components/utils/ScrollToError/index.js + 1 modules
var ScrollToError = __webpack_require__(221);

// EXTERNAL MODULE: ../react-lib/src/utils/hasFormError.js
var hasFormError = __webpack_require__(274);

// CONCATENATED MODULE: ../react-lib/src/components/utils/Form/InnerForm/InnerForm.common.js
var defaultProps = {
  nested: false
};
// CONCATENATED MODULE: ../react-lib/src/components/utils/Form/InnerForm/InnerForm.jsx
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }







var StyledForm = styled_components_browser_esm["default"].form.withConfig({
  displayName: "InnerForm__StyledForm",
  componentId: "sc-1mmi3sv-0"
})(["width:100%;"]); // $FlowFixMe - our flow-typed types for styled-components are out of date and there are none in OSS for this

var NestedForm = StyledForm.withComponent('div');

var InnerForm_InnerForm = function InnerForm(_ref) {
  var nested = _ref.nested,
      children = _ref.children,
      submitted = _ref.submitted,
      handleSubmit = _ref.handleSubmit,
      handleKeyPress = _ref.handleKeyPress,
      validationErrors = _ref.validationErrors,
      initialValidationErrors = _ref.initialValidationErrors,
      loading = _ref.loading,
      onDelete = _ref.onDelete,
      onPreSubmit = _ref.onPreSubmit,
      onLiftedChange = _ref.onLiftedChange,
      other = _objectWithoutProperties(_ref, ["nested", "children", "submitted", "handleSubmit", "handleKeyPress", "validationErrors", "initialValidationErrors", "loading", "onDelete", "onPreSubmit", "onLiftedChange"]);

  var Wrapper = nested ? NestedForm : StyledForm;
  return react_default.a.createElement(Wrapper, _extends({}, other, {
    onSubmit: handleSubmit,
    onKeyPress: handleKeyPress
  }), children, react_default.a.createElement(ScrollToError["a" /* default */], {
    shouldScroll: submitted ? submitted && Object(hasFormError["a" /* default */])(validationErrors || initialValidationErrors) : false,
    errorClass: classNames_constants["b" /* FORM_ERROR_CLASSNAME */]
  }));
};

InnerForm_InnerForm.defaultProps = defaultProps;
/* harmony default export */ var Form_InnerForm_InnerForm = (InnerForm_InnerForm);
// CONCATENATED MODULE: ../react-lib/src/components/utils/Form/Form.jsx
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Form_mergeFormData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Form_Form; });
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function Form__extends() { Form__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Form__extends.apply(this, arguments); }

function Form__objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = Form__objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function Form__objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function Form_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function Form__objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Form_ownKeys(source, true).forEach(function (key) { Form__defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Form_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function Form__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }




 // $FlowFixMe


var Form_mergeFormData = function mergeFormData() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return lodash_es_mergeWith.apply(void 0, [{}].concat(args, [function (a, b) {
    if (Array.isArray(b)) {
      return b;
    }

    return undefined;
  }]));
};
/**
 * Recursively walk through the data shape.
 * Each leaf in the data tree can either be a validator function,
 * or array of validator functions
 */

var Form_Form =
/*#__PURE__*/
function (_Component) {
  _inherits(Form, _Component);

  function Form() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Form);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Form)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      initialValidationErrors: validation_initializeValidation(_this.props.initialData, _this.props.validators),
      data: undefined,
      submitted: false,
      validationErrors: undefined,
      valid: true
    };

    _this.handleChange = function (updates) {
      var _this$props = _this.props,
          formValidators = _this$props.validators,
          initialData = _this$props.initialData,
          validateOnChange = _this$props.validateOnChange,
          onChange = _this$props.onChange;
      var _this$state = _this.state,
          valid = _this$state.valid,
          data = _this$state.data,
          validationErrors = _this$state.validationErrors;
      var nextDirtyData = Form_mergeFormData(data, updates);
      var mergedData = Form_mergeFormData(initialData, nextDirtyData);
      var nextValid = valid;
      var nextErrors = validationErrors;
      var nextState = {}; // Do validation

      if (validateOnChange || !valid) {
        var validationResults = validation_validate(mergedData, formValidators);
        nextValid = validationResults.valid;
        nextErrors = validationResults.errors;
        nextState = {
          valid: nextValid,
          validationErrors: nextErrors
        };
      }

      nextState = Form__objectSpread({}, nextState, {
        data: nextDirtyData,
        submitted: false
      });

      _this.setState(nextState);

      if (onChange) {
        onChange({
          data: mergedData,
          validationErrors: nextErrors,
          valid: nextValid
        });
      }
    };

    _this.handleSubmit = function (e) {
      var _this$props2 = _this.props,
          initialData = _this$props2.initialData,
          onSubmit = _this$props2.onSubmit,
          onPreSubmit = _this$props2.onPreSubmit;
      var data = _this.state.data;
      var mergedFormData = Form_mergeFormData(initialData, data);

      var _validationUtils$vali = validation_validate(mergedFormData, _this.props.validators),
          valid = _validationUtils$vali.valid,
          errors = _validationUtils$vali.errors;

      if (e && e.preventDefault) {
        e.preventDefault();
      } // validate needs to fire to set the flags correctly no matter it is valid or not


      _this.setState(function () {
        return {
          valid: valid,
          validationErrors: errors,
          submitted: true
        };
      });

      if (onPreSubmit) {
        onPreSubmit(valid, errors);
      }

      if (valid && onSubmit) {
        return onSubmit(mergedFormData);
      }

      return valid;
    };

    _this.handleKeyPress = function (e) {
      if (e.key === 'Enter') {
        e.stopPropagation();
        e.preventDefault();

        _this.handleSubmit();
      }
    };

    _this.handleClearData = function () {
      _this.setState(function () {
        return {
          data: undefined,
          submitted: false,
          validationErrors: undefined,
          valid: true
        };
      });
    };

    return _this;
  }

  _createClass(Form, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var initialData = nextProps.initialData,
          formValidators = nextProps.validators;
      var _this$state2 = this.state,
          data = _this$state2.data,
          valid = _this$state2.valid;

      if (!data && !valid) {
        var _validationUtils$vali2 = validation_validate(initialData, formValidators),
            nextValid = _validationUtils$vali2.valid,
            errors = _validationUtils$vali2.errors;

        this.setState(function () {
          return {
            valid: nextValid,
            validationErrors: errors
          };
        });
      }
    }
  }, {
    key: "submit",
    value: function submit() {
      return this.handleSubmit();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          v = _this$props3.validators,
          initialData = _this$props3.initialData,
          children = _this$props3.children,
          onSubmit = _this$props3.onSubmit,
          nested = _this$props3.nested,
          onChange = _this$props3.onChange,
          other = Form__objectWithoutProperties(_this$props3, ["validators", "initialData", "children", "onSubmit", "nested", "onChange"]);

      var _this$state3 = this.state,
          initialValidationErrors = _this$state3.initialValidationErrors,
          data = _this$state3.data,
          submitted = _this$state3.submitted,
          valid = _this$state3.valid,
          validationErrors = _this$state3.validationErrors;
      var handleSubmit = this.handleSubmit,
          handleKeyPress = this.handleKeyPress;
      return react_default.a.createElement(Form_InnerForm_InnerForm, Form__extends({
        nested: nested,
        submitted: submitted,
        handleSubmit: handleSubmit,
        handleKeyPress: handleKeyPress,
        validationErrors: validationErrors,
        initialValidationErrors: initialValidationErrors
      }, other), children({
        submitted: submitted,
        valid: valid,
        data: Form_mergeFormData(initialData, data),
        validationErrors: validationErrors || initialValidationErrors,
        onChange: this.handleChange,
        onSubmit: this.handleSubmit,
        clearData: this.handleClearData
      }));
    }
  }]);

  return Form;
}(react["Component"]);

Form_Form.defaultProps = {
  validators: {},
  onSubmit: function onSubmit() {},
  nested: false,
  validateOnChange: false,
  onChange: function onChange() {},
  onPreSubmit: function onPreSubmit() {}
};
Form_Form.validators = validation_validators;


/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__eq_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isIndex_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isObject_js__ = __webpack_require__(8);





/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_3__isObject_js__["a" /* default */])(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (Object(__WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__["a" /* default */])(object) && Object(__WEBPACK_IMPORTED_MODULE_2__isIndex_js__["a" /* default */])(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__eq_js__["a" /* default */])(object[index], value);
  }
  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (isIterateeCall);


/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ErrorWrapper */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FormValidationError; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lingui_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lingui_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__lingui_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__callouts_Popover__ = __webpack_require__(108);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








var ErrorWrapper = __WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].div.withConfig({
  displayName: "FormValidationError__ErrorWrapper",
  componentId: "sc-1tys4gl-0"
})(["color:", ";"], __WEBPACK_IMPORTED_MODULE_5__styles__["d" /* DSToken */].TEXT_COLOR_ERROR);

var getClassNames = function getClassNames(message, className) {
  return __WEBPACK_IMPORTED_MODULE_1_classnames___default()(className, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_4__constants__["b" /* FORM_ERROR_CLASSNAME */], message));
};

var FormValidationError =
/*#__PURE__*/
function (_Component) {
  _inherits(FormValidationError, _Component);

  function FormValidationError() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, FormValidationError);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(FormValidationError)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      lastMessage: ''
    };
    return _this;
  }

  _createClass(FormValidationError, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(newProps) {
      var _this2 = this;

      if (this.props.message !== newProps.message) {
        this.setState(function () {
          return {
            lastMessage: _this2.props.message || ''
          };
        });
      }
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      var message = this.props.message;
      var lastMessage = this.state.lastMessage;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ErrorWrapper, null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__lingui_react__["Trans"], {
        id: message || lastMessage
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          placement = _this$props.placement,
          children = _this$props.children,
          message = _this$props.message,
          className = _this$props.className,
          other = _objectWithoutProperties(_this$props, ["placement", "children", "message", "className"]);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__callouts_Popover__["b" /* default */], _extends({
        event: __WEBPACK_IMPORTED_MODULE_6__callouts_Popover__["b" /* default */].Event.NONE,
        placement: placement,
        content: this.renderContent(),
        open: !!message,
        display: "block",
        className: getClassNames(message, className)
      }, other), children);
    }
  }]);

  return FormValidationError;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

FormValidationError.defaultProps = {
  placement: __WEBPACK_IMPORTED_MODULE_6__callouts_Popover__["b" /* default */].Placement.TOP,
  message: ''
};


/***/ }),
/* 243 */,
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Wrapper; });
/* unused harmony export FormGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }




var Wrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div.withConfig({
  displayName: "FormGroup__Wrapper",
  componentId: "sc-1orn1bs-0"
})(["position:relative;"]);
var FormGroup = function FormGroup(_ref) {
  var className = _ref.className,
      children = _ref.children,
      other = _objectWithoutProperties(_ref, ["className", "children"]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Wrapper, _extends({
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'form-group')
  }, other), children);
};
FormGroup.defaultProps = {
  className: '',
  validationError: '',
  errorDirection: 'top'
};
/* harmony default export */ __webpack_exports__["b"] = (FormGroup);

/***/ }),
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "required", function() { return required; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "truthy", function() { return truthy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "notVisible", function() { return notVisible; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "minValue", function() { return minValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "maxValue", function() { return maxValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "minLength", function() { return minLength; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "maxLength", function() { return maxLength; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withinInclusiveRange", function() { return withinInclusiveRange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "minWordCount", function() { return minWordCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "zipcode", function() { return zipcode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "notEmptyArray", function() { return notEmptyArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "date", function() { return date; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cardHolderName", function() { return cardHolderName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "creditCardNumber", function() { return creditCardNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "creditCardExpiration", function() { return creditCardExpiration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "creditCardCVV", function() { return creditCardCVV; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "noUndefinedTimes", function() { return noUndefinedTimes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "maxNumberOfTimesPerDay", function() { return maxNumberOfTimesPerDay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "requiredFuzzyTime", function() { return requiredFuzzyTime; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_card_validator__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_card_validator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_card_validator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rover_utilities_wordCount__ = __webpack_require__(273);



var required = function required() {
  var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] :
  /*i18n*/
  {
    id: "This field is required."
  };
  return function (prop) {
    if (prop === 0 || prop === false) return null;
    if (typeof prop === 'string' && !prop.trim()) return message;
    return prop ? null : message;
  };
};
var truthy = function truthy() {
  var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] :
  /*i18n*/
  {
    id: "This field must be truthy."
  };
  return function (prop) {
    return prop ? null : message;
  };
};
var notVisible = function notVisible() {
  var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] :
  /*i18n*/
  {
    id: "Submit or cancel this form."
  };
  return function (prop) {
    return prop === false ? null : message;
  };
};
var minValue = function minValue(value) {
  var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] :
  /*i18n*/
  {
    id: "This field must be at least {value}.",
    values: {
      value: value
    }
  };
  return function (prop) {
    if (!prop && prop !== 0) return message;
    return Number(prop) >= value ? null : message;
  };
};
var maxValue = function maxValue(value) {
  var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] :
  /*i18n*/
  {
    id: "This field must be no more than {value}.",
    values: {
      value: value
    }
  };
  return function (prop) {
    if (!prop && prop !== 0) return message;
    return Number(prop) <= value ? null : message;
  };
};
var minLength = function minLength() {
  var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
  var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] :
  /*i18n*/
  {
    id: "This field must be at least {length} characters long.",
    values: {
      length: length
    }
  };
  return function (prop) {
    if (!prop) return message;
    return prop.length >= length ? null : message;
  };
};
var maxLength = function maxLength(length) {
  var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] :
  /*i18n*/
  {
    id: "This field must be at most {length} characters long.",
    values: {
      length: length
    }
  };
  return function (prop) {
    if (typeof prop !== 'string') return message;
    return prop.length <= length ? null : message;
  };
};
var withinInclusiveRange = function withinInclusiveRange(min, max) {
  var message = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] :
  /*i18n*/
  {
    id: "This field must be between {min} and {max}.",
    values: {
      min: min,
      max: max
    }
  };
  return function (prop) {
    if (typeof prop !== 'number') return message;
    var meetsMin = min <= prop;
    var meetsMax = max >= prop;
    return meetsMin && meetsMax ? null : message;
  };
};
var minWordCount = function minWordCount(length) {
  var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] :
  /*i18n*/
  {
    id: "Please write at least {length} words.",
    values: {
      length: length
    }
  };
  return function (prop) {
    if (typeof prop !== 'string') return message;
    var wordCount = Object(__WEBPACK_IMPORTED_MODULE_2__rover_utilities_wordCount__["a" /* getWordCount */])(prop);
    var meetsWordCount = typeof wordCount === 'number' && wordCount >= length;
    return meetsWordCount ? null : message;
  };
};
var zipcode = function zipcode(regex) {
  var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] :
  /*i18n*/
  {
    id: "Enter a valid zipcode."
  };
  return function (prop) {
    if (!prop) return message;
    var zipcodeRegex = regex || /(^\d{5}(-\d{4})?$)|(^[ABCEGHJKLMNPRSTVXY]{1}\d{1}[A-Z]{1} *\d{1}[A-Z]{1}\d{1}$)/;
    return zipcodeRegex.test(prop.trim()) ? null : message;
  };
};
var notEmptyArray = function notEmptyArray() {
  var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] :
  /*i18n*/
  {
    id: "This field is required."
  };
  return function (prop) {
    return Array.isArray(prop) && prop.length > 0 ? null : message;
  };
};
var date = function date(pattern) {
  var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "Enter a valid date".concat(pattern ? " (".concat(pattern, ")") : '');
  return function (prop) {
    if (!prop) {
      return message;
    }

    if (pattern) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(prop, pattern, true).isValid() ? null : message;
    }

    return __WEBPACK_IMPORTED_MODULE_1_moment___default()(prop).isValid() ? null : message;
  };
};
var cardHolderName = function cardHolderName() {
  var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] :
  /*i18n*/
  {
    id: "We cannot store names with only numbers in our system."
  };
  return function (prop) {
    return /^[\d\s-]+$/.test(prop) ? message : null;
  };
};
var creditCardNumber = function creditCardNumber() {
  var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Enter a valid credit card number.';
  return function (prop) {
    return __WEBPACK_IMPORTED_MODULE_0_card_validator___default.a.number(prop).isValid ? null : message;
  };
};
var creditCardExpiration = function creditCardExpiration() {
  var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Enter a valid expiration date.';
  return function (prop) {
    return __WEBPACK_IMPORTED_MODULE_0_card_validator___default.a.expirationDate(prop).isValid ? null : message;
  };
};
var creditCardCVV = function creditCardCVV(number) {
  var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Enter a valid CVV.';
  return function (prop) {
    if (number) {
      var card = __WEBPACK_IMPORTED_MODULE_0_card_validator___default.a.number(number);
      var cvvLength = card.card && card.card.code && card.card.code.size;
      return __WEBPACK_IMPORTED_MODULE_0_card_validator___default.a.cvv(prop, cvvLength).isValid ? null : message;
    }

    return __WEBPACK_IMPORTED_MODULE_0_card_validator___default.a.cvv(prop).isValid ? null : message;
  };
};
var noUndefinedTimes = function noUndefinedTimes() {
  var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] :
  /*i18n*/
  {
    id: "Please select a time."
  };
  return function (days) {
    var errors = [];
    var isError = false;
    days.forEach(function (day) {
      var dayErrors = [];
      day.times.forEach(function (time) {
        if (!time.value) {
          isError = true;
          dayErrors.push(message);
        } else {
          dayErrors.push('');
        }
      });
      errors.push(dayErrors);
    });
    return isError ? errors : null;
  };
};
var maxNumberOfTimesPerDay = function maxNumberOfTimesPerDay(value) {
  var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] :
  /*i18n*/
  {
    id: "You can only schedule up to {value} times per day.",
    values: {
      value: value
    }
  };
  return function (days) {
    var errors = [];
    var isError = false;
    days.forEach(function (day) {
      var dayErrors = [];

      if (Array.isArray(day.times) && day.times.length > value) {
        isError = true;
        dayErrors.push(message);
      } else {
        dayErrors.push('');
      }

      errors.push(dayErrors);
    });
    return isError ? errors : null;
  };
};
var requiredFuzzyTime = function requiredFuzzyTime() {
  var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] :
  /*i18n*/
  {
    id: "Please select a start and end time."
  };
  return function (fuzzyTime) {
    return fuzzyTime && fuzzyTime.earliest && fuzzyTime.earliest.value && fuzzyTime.latest && fuzzyTime.latest.value ? null : message;
  };
};

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/lodash-es/_arrayMap.js
var _arrayMap = __webpack_require__(64);

// CONCATENATED MODULE: ../node_modules/lodash-es/_baseValues.js


/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return Object(_arrayMap["a" /* default */])(props, function(key) {
    return object[key];
  });
}

/* harmony default export */ var _baseValues = (baseValues);

// EXTERNAL MODULE: ../node_modules/lodash-es/keys.js
var keys = __webpack_require__(26);

// CONCATENATED MODULE: ../node_modules/lodash-es/values.js



/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */
function values(object) {
  return object == null ? [] : _baseValues(object, Object(keys["a" /* default */])(object));
}

/* harmony default export */ var lodash_es_values = __webpack_exports__["a"] = (values);


/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PriceObjDefaults; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BookingAddOnDefaults; });
var PriceObjDefaults = {
  amount: '',
  currencyIso: 'USD'
};
var BookingAddOnDefaults = {
  name: '',
  slug: '',
  pricePerUnit: '',
  pricePerUnitObj: PriceObjDefaults,
  totalPrice: '',
  active: false,
  frequency: '',
  unit: '',
  unitLabel: '',
  unitAsSentence: '',
  numUnits: 0,
  isAlternativeRate: false,
  isEditable: false,
  isFutureService: false,
  pet: ''
};

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getIntlNumberFormat */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formatCurrency; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return formatCurrencyFromPriceObj; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getCurrencyAndLocaleConfig; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rover_shared_js_constants_i18n_language__ = __webpack_require__(124);

var getIntlNumberFormat = function getIntlNumberFormat(currencyIso) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : __WEBPACK_IMPORTED_MODULE_0__rover_shared_js_constants_i18n_language__["a" /* DEFAULT_LANG */];
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currencyIso
  });
};
var formatCurrency = function formatCurrency(amount, currencyIso) {
  var locale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __WEBPACK_IMPORTED_MODULE_0__rover_shared_js_constants_i18n_language__["a" /* DEFAULT_LANG */];

  var _ref = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
      _ref$includeDecimal = _ref.includeDecimal,
      includeDecimal = _ref$includeDecimal === void 0 ? true : _ref$includeDecimal,
      formatSymbol = _ref.formatSymbol,
      formatAmount = _ref.formatAmount;

  var parts = getIntlNumberFormat(currencyIso, locale).formatToParts(amount);
  var formattedCurrency = '';
  var formattedAmount = '';
  var currencyIndex = 0;
  parts.forEach(function (part, index) {
    var type = part.type,
        value = part.value;

    if (type === 'currency') {
      currencyIndex = index;
      formattedCurrency = value;
    } else if (includeDecimal || !['decimal', 'fraction'].includes(type)) {
      formattedAmount += value;
    }
  });

  if (typeof formatSymbol === 'function') {
    formattedCurrency = formatSymbol(formattedCurrency);
  }

  if (typeof formatAmount === 'function') {
    formattedAmount = formatAmount(formattedAmount);
  }

  if (currencyIndex > 0) {
    return formattedAmount + formattedCurrency;
  }

  return formattedCurrency + formattedAmount;
};
var formatCurrencyFromPriceObj = function formatCurrencyFromPriceObj(priceObj, locale) {
  return formatCurrency(priceObj.amount, priceObj.currency_iso, locale);
};
var getCurrencyAndLocaleConfig = function getCurrencyAndLocaleConfig(currencyIso) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : __WEBPACK_IMPORTED_MODULE_0__rover_shared_js_constants_i18n_language__["a" /* DEFAULT_LANG */];
  var formatter = getIntlNumberFormat(currencyIso, locale);
  var config = {};
  formatter.formatToParts(1000.0).forEach(function (_ref2, index) {
    var type = _ref2.type,
        value = _ref2.value;

    if (type === 'currency') {
      config.symbol = value;
      config.symbolOnLeft = index === 0;
    }

    if (type === 'group') {
      config.thousandsSeparator = value;
    }

    if (type === 'decimal') {
      config.decimalSeparator = value;
    }

    if (type === 'fraction') {
      config.decimalDigits = value.length;
    }
  });
  return {
    currencyConfig: {
      symbol: config.symbol,
      decimalDigits: config.decimalDigits
    },
    localeConfig: {
      locale: locale,
      symbolOnLeft: config.symbolOnLeft,
      thousandsSeparator: config.thousandsSeparator,
      decimalSeparator: config.decimalSeparator
    }
  };
};

/***/ }),
/* 252 */,
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var defaults = {
  addressLine1: '',
  addressLine2: '',
  city: '',
  state: '',
  zip: '',
  countryCode: '',
  accessToHome: ''
};
/* harmony default export */ __webpack_exports__["a"] = (function (address) {
  return _objectSpread({}, defaults, {}, address);
});

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Alert__ = __webpack_require__(264);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Alert__["a"]; });
/* unused harmony reexport DismissIconWrapper */


/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/lodash-es/_arrayEach.js
var _arrayEach = __webpack_require__(115);

// EXTERNAL MODULE: ../node_modules/lodash-es/_baseEach.js + 1 modules
var _baseEach = __webpack_require__(112);

// EXTERNAL MODULE: ../node_modules/lodash-es/identity.js
var identity = __webpack_require__(54);

// CONCATENATED MODULE: ../node_modules/lodash-es/_castFunction.js


/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity["a" /* default */];
}

/* harmony default export */ var _castFunction = (castFunction);

// EXTERNAL MODULE: ../node_modules/lodash-es/isArray.js
var isArray = __webpack_require__(5);

// CONCATENATED MODULE: ../node_modules/lodash-es/forEach.js





/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = Object(isArray["a" /* default */])(collection) ? _arrayEach["a" /* default */] : _baseEach["a" /* default */];
  return func(collection, _castFunction(iteratee));
}

/* harmony default export */ var lodash_es_forEach = __webpack_exports__["a"] = (forEach);


/***/ }),
/* 256 */,
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ../node_modules/@lingui/react/index.js
var _lingui_react = __webpack_require__(3);
var _lingui_react_default = /*#__PURE__*/__webpack_require__.n(_lingui_react);

// EXTERNAL MODULE: ../react-lib/src/constants/index.js
var constants = __webpack_require__(210);

// EXTERNAL MODULE: ../utilities/i18n.js
var i18n = __webpack_require__(135);

// EXTERNAL MODULE: ../react-lib/src/components/notifications/Alert/index.js
var Alert = __webpack_require__(254);

// CONCATENATED MODULE: ../react-lib/src/components/notifications/SuccessOrErrorAlert/SuccessOrErrorAlert.common.js
var defaultProps = {
  error: '',
  success: ''
};
// CONCATENATED MODULE: ../react-lib/src/components/notifications/SuccessOrErrorAlert/SuccessOrErrorAlert.jsx
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }








var SuccessOrErrorAlert_SuccessOrErrorAlert = function SuccessOrErrorAlert(_ref) {
  var error = _ref.error,
      success = _ref.success,
      other = _objectWithoutProperties(_ref, ["error", "success"]);

  var message = error || success;
  var severity = error ? Alert["a" /* default */].Severity.DANGER : Alert["a" /* default */].Severity.SUCCESS;
  return react_default.a.createElement(Alert["a" /* default */], _extends({
    severity: severity,
    className: error ? constants["b" /* FORM_ERROR_CLASSNAME */] : ''
  }, other), Object(i18n["a" /* isTranslatable */])(message) ? react_default.a.createElement(_lingui_react["Trans"], {
    id: message
  }) : message);
};

SuccessOrErrorAlert_SuccessOrErrorAlert.defaultProps = defaultProps;

/* harmony default export */ var notifications_SuccessOrErrorAlert_SuccessOrErrorAlert = (SuccessOrErrorAlert_SuccessOrErrorAlert);
// CONCATENATED MODULE: ../react-lib/src/components/notifications/SuccessOrErrorAlert/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return notifications_SuccessOrErrorAlert_SuccessOrErrorAlert; });


/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__identity_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__overRest_js__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__setToString_js__ = __webpack_require__(277);




/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__setToString_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__overRest_js__["a" /* default */])(func, start, __WEBPACK_IMPORTED_MODULE_0__identity_js__["a" /* default */]), func + '');
}

/* harmony default export */ __webpack_exports__["a"] = (baseRest);


/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/lodash-es/_Stack.js + 5 modules
var _Stack = __webpack_require__(50);

// EXTERNAL MODULE: ../node_modules/lodash-es/_baseAssignValue.js
var _baseAssignValue = __webpack_require__(52);

// EXTERNAL MODULE: ../node_modules/lodash-es/eq.js
var eq = __webpack_require__(33);

// CONCATENATED MODULE: ../node_modules/lodash-es/_assignMergeValue.js



/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !Object(eq["a" /* default */])(object[key], value)) ||
      (value === undefined && !(key in object))) {
    Object(_baseAssignValue["a" /* default */])(object, key, value);
  }
}

/* harmony default export */ var _assignMergeValue = (assignMergeValue);

// EXTERNAL MODULE: ../node_modules/lodash-es/_baseFor.js + 1 modules
var _baseFor = __webpack_require__(119);

// EXTERNAL MODULE: ../node_modules/lodash-es/_cloneBuffer.js
var _cloneBuffer = __webpack_require__(168);

// EXTERNAL MODULE: ../node_modules/lodash-es/_cloneTypedArray.js
var _cloneTypedArray = __webpack_require__(169);

// EXTERNAL MODULE: ../node_modules/lodash-es/_copyArray.js
var _copyArray = __webpack_require__(165);

// EXTERNAL MODULE: ../node_modules/lodash-es/_initCloneObject.js
var _initCloneObject = __webpack_require__(170);

// EXTERNAL MODULE: ../node_modules/lodash-es/isArguments.js + 1 modules
var isArguments = __webpack_require__(40);

// EXTERNAL MODULE: ../node_modules/lodash-es/isArray.js
var isArray = __webpack_require__(5);

// EXTERNAL MODULE: ../node_modules/lodash-es/isArrayLike.js
var isArrayLike = __webpack_require__(23);

// EXTERNAL MODULE: ../node_modules/lodash-es/isObjectLike.js
var isObjectLike = __webpack_require__(12);

// CONCATENATED MODULE: ../node_modules/lodash-es/isArrayLikeObject.js



/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return Object(isObjectLike["a" /* default */])(value) && Object(isArrayLike["a" /* default */])(value);
}

/* harmony default export */ var lodash_es_isArrayLikeObject = (isArrayLikeObject);

// EXTERNAL MODULE: ../node_modules/lodash-es/isBuffer.js
var isBuffer = __webpack_require__(38);

// EXTERNAL MODULE: ../node_modules/lodash-es/isFunction.js
var isFunction = __webpack_require__(25);

// EXTERNAL MODULE: ../node_modules/lodash-es/isObject.js
var isObject = __webpack_require__(8);

// EXTERNAL MODULE: ../node_modules/lodash-es/isPlainObject.js
var isPlainObject = __webpack_require__(243);

// EXTERNAL MODULE: ../node_modules/lodash-es/isTypedArray.js + 1 modules
var isTypedArray = __webpack_require__(48);

// CONCATENATED MODULE: ../node_modules/lodash-es/_safeGet.js
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

/* harmony default export */ var _safeGet = (safeGet);

// EXTERNAL MODULE: ../node_modules/lodash-es/_copyObject.js
var _copyObject = __webpack_require__(66);

// EXTERNAL MODULE: ../node_modules/lodash-es/keysIn.js + 2 modules
var keysIn = __webpack_require__(80);

// CONCATENATED MODULE: ../node_modules/lodash-es/toPlainObject.js



/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return Object(_copyObject["a" /* default */])(value, Object(keysIn["a" /* default */])(value));
}

/* harmony default export */ var lodash_es_toPlainObject = (toPlainObject);

// CONCATENATED MODULE: ../node_modules/lodash-es/_baseMergeDeep.js
















/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = _safeGet(object, key),
      srcValue = _safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    _assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = Object(isArray["a" /* default */])(srcValue),
        isBuff = !isArr && Object(isBuffer["a" /* default */])(srcValue),
        isTyped = !isArr && !isBuff && Object(isTypedArray["a" /* default */])(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (Object(isArray["a" /* default */])(objValue)) {
        newValue = objValue;
      }
      else if (lodash_es_isArrayLikeObject(objValue)) {
        newValue = Object(_copyArray["a" /* default */])(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = Object(_cloneBuffer["a" /* default */])(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = Object(_cloneTypedArray["a" /* default */])(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (Object(isPlainObject["default"])(srcValue) || Object(isArguments["a" /* default */])(srcValue)) {
      newValue = objValue;
      if (Object(isArguments["a" /* default */])(objValue)) {
        newValue = lodash_es_toPlainObject(objValue);
      }
      else if (!Object(isObject["a" /* default */])(objValue) || Object(isFunction["a" /* default */])(objValue)) {
        newValue = Object(_initCloneObject["a" /* default */])(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  _assignMergeValue(object, key, newValue);
}

/* harmony default export */ var _baseMergeDeep = (baseMergeDeep);

// CONCATENATED MODULE: ../node_modules/lodash-es/_baseMerge.js








/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  Object(_baseFor["a" /* default */])(source, function(srcValue, key) {
    stack || (stack = new _Stack["a" /* default */]);
    if (Object(isObject["a" /* default */])(srcValue)) {
      _baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(_safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      _assignMergeValue(object, key, newValue);
    }
  }, keysIn["a" /* default */]);
}

/* harmony default export */ var _baseMerge = __webpack_exports__["a"] = (baseMerge);


/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseRest_js__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isIterateeCall_js__ = __webpack_require__(241);



/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseRest_js__["a" /* default */])(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && Object(__WEBPACK_IMPORTED_MODULE_1__isIterateeCall_js__["a" /* default */])(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/* harmony default export */ __webpack_exports__["a"] = (createAssigner);


/***/ }),
/* 261 */,
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IdealBankElement = exports.IbanElement = exports.PaymentRequestButtonElement = exports.PostalCodeElement = exports.CardCVCElement = exports.CardExpiryElement = exports.CardNumberElement = exports.CardElement = exports.Elements = exports.injectStripe = exports.StripeProvider = undefined;

var _Provider = __webpack_require__(381);

var _Provider2 = _interopRequireDefault(_Provider);

var _inject = __webpack_require__(492);

var _inject2 = _interopRequireDefault(_inject);

var _Elements = __webpack_require__(352);

var _Elements2 = _interopRequireDefault(_Elements);

var _Element = __webpack_require__(493);

var _Element2 = _interopRequireDefault(_Element);

var _PaymentRequestButtonElement = __webpack_require__(495);

var _PaymentRequestButtonElement2 = _interopRequireDefault(_PaymentRequestButtonElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Define Elements, and register their implied token / source types for
// automatic token / source creation.

// Card
var CardElement = (0, _Element2.default)('card', {
  impliedTokenType: 'card',
  impliedSourceType: 'card'
});

// Split Fields
// Note: we only register the CardNumberElement for split fields so that we have
// a unique Element to infer when calling `wrappedCreateToken` or `wrappedCreateSource`.

var CardNumberElement = (0, _Element2.default)('cardNumber', {
  impliedTokenType: 'card',
  impliedSourceType: 'card'
});
var CardExpiryElement = (0, _Element2.default)('cardExpiry');
var CardCVCElement = (0, _Element2.default)('cardCvc');
var PostalCodeElement = (0, _Element2.default)('postalCode');

// IBAN
var IbanElement = (0, _Element2.default)('iban', {
  impliedTokenType: 'bank_account',
  impliedSourceType: 'sepa_debit'
});

// iDEAL Bank
var IdealBankElement = (0, _Element2.default)('idealBank', { impliedSourceType: 'ideal' });

exports.StripeProvider = _Provider2.default;
exports.injectStripe = _inject2.default;
exports.Elements = _Elements2.default;
exports.CardElement = CardElement;
exports.CardNumberElement = CardNumberElement;
exports.CardExpiryElement = CardExpiryElement;
exports.CardCVCElement = CardCVCElement;
exports.PostalCodeElement = PostalCodeElement;
exports.PaymentRequestButtonElement = _PaymentRequestButtonElement2.default;
exports.IbanElement = IbanElement;
exports.IdealBankElement = IdealBankElement;

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _objectSpread({
    flags: {},
    settings: {
      branchKey: '',
      ccTld: '',
      countryCode: '',
      csrfCookieName: '',
      dogSizeBuckets: {
        small: '',
        medium: '',
        large: '',
        giant: ''
      },
      googleMapsClientId: '',
      gtmContainerId: '',
      imageUploadMaxSize: 0,
      isBeforeHoliday: false,
      language: '',
      personReferralCampaign: '',
      staticSvgPresent: '',
      supportsMobileApp: false,
      supportsReferral: false,
      weightUnit: '',
      roverNowEnabled: false,
      groomingEnabled: false
    }
  }, opts);
});

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(1);

// EXTERNAL MODULE: ../react-lib/src/styles/index.js + 3 modules
var styles = __webpack_require__(2);

// EXTERNAL MODULE: ../react-lib/src/constants/classNames.constants.js
var classNames_constants = __webpack_require__(107);

// EXTERNAL MODULE: ../node_modules/@lingui/react/index.js
var _lingui_react = __webpack_require__(3);
var _lingui_react_default = /*#__PURE__*/__webpack_require__.n(_lingui_react);

// EXTERNAL MODULE: ../utilities/i18n.js
var utilities_i18n = __webpack_require__(135);

// EXTERNAL MODULE: ../react-lib/src/components/buttons/Button/index.js + 1 modules
var Button = __webpack_require__(13);

// EXTERNAL MODULE: ../icons/index.js + 99 modules
var icons = __webpack_require__(39);

// EXTERNAL MODULE: ../react-lib/src/types/index.js
var types = __webpack_require__(220);

// CONCATENATED MODULE: ../react-lib/src/components/notifications/Alert/Alert.common.js
var _ALERT_SEVERITY_BACKG, _ALERT_SEVERITY_BORDE;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }



var AlertSeverity =
/*#__PURE__*/
function (_Enum) {
  _inherits(AlertSeverity, _Enum);

  function AlertSeverity() {
    _classCallCheck(this, AlertSeverity);

    return _possibleConstructorReturn(this, _getPrototypeOf(AlertSeverity).apply(this, arguments));
  }

  return AlertSeverity;
}(types["Enum"]);
AlertSeverity.INFO = new AlertSeverity('info');
AlertSeverity.SUCCESS = new AlertSeverity('success');
AlertSeverity.WARNING = new AlertSeverity('warning');
AlertSeverity.DANGER = new AlertSeverity('danger');
AlertSeverity.isLocked = true;
var ALERT_SEVERITY_BACKGROUNDS = (_ALERT_SEVERITY_BACKG = {}, _defineProperty(_ALERT_SEVERITY_BACKG, AlertSeverity.DANGER, styles["c" /* Color */].RED_96), _defineProperty(_ALERT_SEVERITY_BACKG, AlertSeverity.WARNING, styles["c" /* Color */].YELLOW_96), _defineProperty(_ALERT_SEVERITY_BACKG, AlertSeverity.SUCCESS, styles["c" /* Color */].GREEN_96), _defineProperty(_ALERT_SEVERITY_BACKG, AlertSeverity.INFO, styles["c" /* Color */].BLUE_96), _ALERT_SEVERITY_BACKG);
var ALERT_SEVERITY_BORDERS = (_ALERT_SEVERITY_BORDE = {}, _defineProperty(_ALERT_SEVERITY_BORDE, AlertSeverity.DANGER, styles["d" /* DSToken */].BORDER_COLOR_ERROR), _defineProperty(_ALERT_SEVERITY_BORDE, AlertSeverity.WARNING, styles["c" /* Color */].YELLOW_BASE), _defineProperty(_ALERT_SEVERITY_BORDE, AlertSeverity.SUCCESS, styles["c" /* Color */].GREEN_BASE), _defineProperty(_ALERT_SEVERITY_BORDE, AlertSeverity.INFO, styles["c" /* Color */].BLUE_BASE), _ALERT_SEVERITY_BORDE);
var getBackgroundColorForSeverity = function getBackgroundColorForSeverity(_ref) {
  var severity = _ref.severity;
  var severityBackground = ALERT_SEVERITY_BACKGROUNDS[severity];
  if (severityBackground) return severityBackground;
  return ALERT_SEVERITY_BACKGROUNDS[AlertSeverity.INFO];
};
var getBorderColorForSeverity = function getBorderColorForSeverity(_ref2) {
  var severity = _ref2.severity;
  var severityBorder = ALERT_SEVERITY_BORDERS[severity];
  if (severityBorder) return severityBorder;
  return ALERT_SEVERITY_BORDERS[AlertSeverity.INFO];
};
var defaultProps = {
  severity: AlertSeverity.INFO,
  onDismiss: undefined
};
// CONCATENATED MODULE: ../react-lib/src/components/notifications/Alert/Alert.jsx
/* unused harmony export DismissIconWrapper */
/* unused concated harmony import AlertSeverity */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return AlertSeverity; });
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Alert__defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function Alert__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }










var Wrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Alert__Wrapper",
  componentId: "czdlqb-0"
})(["display:flex;padding:", ";margin-bottom:", ";background-color:", ";border-width:2px !important;border-style:solid !important;border-color:", " !important;border-radius:4px;"], styles["k" /* Spacing */].M, styles["k" /* Spacing */].L, getBackgroundColorForSeverity, getBorderColorForSeverity);
var ChildWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Alert__ChildWrapper",
  componentId: "czdlqb-1"
})(["display:flex;flex:1;color:", ";"], styles["d" /* DSToken */].TEXT_COLOR_PRIMARY);
var DismissIconWrapper = Object(styled_components_browser_esm["default"])(Button["b" /* default */]).withConfig({
  displayName: "Alert__DismissIconWrapper",
  componentId: "czdlqb-2"
})(["display:flex;height:16px;padding:0;width:16px;"]);
var DismissIcon = Object(styled_components_browser_esm["default"])(icons["Close"]).withConfig({
  displayName: "Alert__DismissIcon",
  componentId: "czdlqb-3"
})(["cursor:pointer;fill:", ";height:16px;width:16px;&:hover{fill:", ";}"], styles["d" /* DSToken */].TEXT_COLOR_TERTIARY, styles["d" /* DSToken */].TEXT_COLOR_SECONDARY);

var Alert_renderDismissIcon = function renderDismissIcon(_ref) {
  var onDismiss = _ref.onDismiss;
  if (!onDismiss) return null;
  return react_default.a.createElement(_lingui_react["I18n"], null, function (_ref2) {
    var i18n = _ref2.i18n;
    return react_default.a.createElement(DismissIconWrapper, {
      tabIndex: 0,
      role: "button",
      "aria-label": i18n._('Close Alert'),
      buttonType: Button["a" /* ButtonType */].TEXT,
      onClick: onDismiss
    }, react_default.a.createElement(DismissIcon, null));
  });
};

var Alert_Alert = function Alert(_ref3) {
  var children = _ref3.children,
      onDismiss = _ref3.onDismiss,
      severity = _ref3.severity,
      className = _ref3.className,
      other = _objectWithoutProperties(_ref3, ["children", "onDismiss", "severity", "className"]);

  if (!children) return null;
  return react_default.a.createElement(Wrapper, _extends({
    severity: severity,
    className: "".concat(classNames_constants["a" /* ALERT_CLASSNAME */], " ").concat(className)
  }, other), react_default.a.createElement(ChildWrapper, null, Object(utilities_i18n["a" /* isTranslatable */])(children) ? react_default.a.createElement(_lingui_react["Trans"], {
    id: children
  }) : children), Alert_renderDismissIcon({
    onDismiss: onDismiss
  }));
}; // attach AlertSeverity to default export for convenience


Alert_Alert.Severity = AlertSeverity;
Alert_Alert.defaultProps = _objectSpread({}, defaultProps, {
  className: ''
});

/* harmony default export */ var notifications_Alert_Alert = __webpack_exports__["a"] = (Alert_Alert);

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PaymentIntentResponse__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PaymentIntentResponse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__PaymentIntentResponse__);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FetchFooterResponse__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FetchFooterResponse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__FetchFooterResponse__);
/* unused harmony namespace reexport */



/***/ }),
/* 266 */
/***/ (function(module, exports) {



/***/ }),
/* 267 */
/***/ (function(module, exports) {



/***/ }),
/* 268 */
/***/ (function(module, exports) {



/***/ }),
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(1);

// EXTERNAL MODULE: ../react-lib/src/styles/index.js + 3 modules
var styles = __webpack_require__(2);

// CONCATENATED MODULE: ../react-lib/src/components/typography/AnimatedSpinner/AnimatedSpinner.jsx
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }




var Wrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "AnimatedSpinner__Wrapper",
  componentId: "sc-17ojt0z-0"
})(["height:100%;display:flex;align-items:center;justify-content:center;"]);
// Adapted from https://github.com/tobiasahlin/SpinKit/blob/master/examples/8-circle.html
var OuterCircle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "AnimatedSpinner__OuterCircle",
  componentId: "sc-17ojt0z-1"
})(["position:relative;height:", "px;width:", "px;"], function (props) {
  return props.diameter;
}, function (props) {
  return props.diameter;
});
var dotAnimation = Object(styled_components_browser_esm["keyframes"])(["0%,80%,100%{transform:scale(0);}40%{transform:scale(1);}"]);
var Dot = styled_components_browser_esm["default"].div.withConfig({
  displayName: "AnimatedSpinner__Dot",
  componentId: "sc-17ojt0z-2"
})(["width:100%;height:100%;position:absolute;left:0;top:0;transform:rotate(", "deg);&:before{content:'';display:block;margin:0 auto;width:15%;height:15%;background-color:", ";border-radius:100%;animation:", " 1.2s infinite ease-in-out both;animation-delay:", "s;}"], function (props) {
  return 30 * props.number;
}, function (props) {
  return props.color.toString();
}, dotAnimation, function (props) {
  return 0.1 * props.number;
});

var AnimatedSpinner_AnimatedSpinner = function AnimatedSpinner(_ref) {
  var diameter = _ref.diameter,
      color = _ref.color,
      other = _objectWithoutProperties(_ref, ["diameter", "color"]);

  return react_default.a.createElement(Wrapper, other, react_default.a.createElement(OuterCircle, {
    diameter: diameter
  }, react_default.a.createElement(Dot, {
    number: 0,
    color: color
  }), react_default.a.createElement(Dot, {
    number: 1,
    color: color
  }), react_default.a.createElement(Dot, {
    number: 2,
    color: color
  }), react_default.a.createElement(Dot, {
    number: 3,
    color: color
  }), react_default.a.createElement(Dot, {
    number: 4,
    color: color
  }), react_default.a.createElement(Dot, {
    number: 5,
    color: color
  }), react_default.a.createElement(Dot, {
    number: 6,
    color: color
  }), react_default.a.createElement(Dot, {
    number: 7,
    color: color
  }), react_default.a.createElement(Dot, {
    number: 8,
    color: color
  }), react_default.a.createElement(Dot, {
    number: 9,
    color: color
  }), react_default.a.createElement(Dot, {
    number: 10,
    color: color
  }), react_default.a.createElement(Dot, {
    number: 11,
    color: color
  })));
};

AnimatedSpinner_AnimatedSpinner.defaultProps = {
  diameter: 40,
  color: styles["d" /* DSToken */].TEXT_COLOR_TERTIARY
};
/* harmony default export */ var typography_AnimatedSpinner_AnimatedSpinner = (AnimatedSpinner_AnimatedSpinner);
// CONCATENATED MODULE: ../react-lib/src/components/typography/AnimatedSpinner/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return typography_AnimatedSpinner_AnimatedSpinner; });


/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getWordCount; });
var getWordCount = function getWordCount(text) {
  var words = text.match(/\w+/g);
  return words && words.length;
};

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = hasFormError;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_values__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isString__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_flat__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_flat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_flat__);



function hasFormError(error) {
  // NOTE(JC): form error can be a nested object:
  // {
  //   address: {
  //     address_1: 'some error',
  //     address_2: null,
  //   },
  //   location: null
  // }
  // Fields with error will have an error message under that key. And correct
  // fields will have null value.
  // To figure out whether this nested error object actually has error, there are 3
  // steps:
  // 1) flatten the error object so it is no longer nested:
  // {
  //   address.address_1: 'some error',
  //   address.address_2: null,
  //   location: null,
  // }
  // 2) transform the error object to an array:
  // ['some error', null, null];
  // 3) filter the array to only keep the strings
  // if we have 1 or more items in the array, we have an error.
  return Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_values__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2_flat___default()(error)).filter(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isString__["a" /* default */]).length > 0;
}

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HorizontalWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_constants__ = __webpack_require__(41);



var HorizontalWrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div.withConfig({
  displayName: "HorizontalLayout__HorizontalWrapper",
  componentId: "djq4p9-0"
})(["width:100%;display:flex;flex-direction:row;justify-content:", ";align-items:", ";flex-wrap:", ";flex-shrink:0;"], function (props) {
  return props.hAlign.toString();
}, function (props) {
  return props.vAlign.toString();
}, function (props) {
  return props.noWrap ? 'nowrap' : 'wrap';
});

var HorizontalLayout = function HorizontalLayout(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HorizontalWrapper, props, props.children);
};

HorizontalLayout.defaultProps = {
  style: {},
  vAlign: __WEBPACK_IMPORTED_MODULE_2__layout_constants__["a" /* ALIGNMENT */].START,
  hAlign: __WEBPACK_IMPORTED_MODULE_2__layout_constants__["a" /* ALIGNMENT */].START,
  noWrap: false
};
/* harmony default export */ __webpack_exports__["b"] = (HorizontalLayout);

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/* harmony default export */ __webpack_exports__["a"] = (apply);


/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ../node_modules/lodash-es/constant.js
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

/* harmony default export */ var lodash_es_constant = (constant);

// EXTERNAL MODULE: ../node_modules/lodash-es/_defineProperty.js
var _defineProperty = __webpack_require__(118);

// EXTERNAL MODULE: ../node_modules/lodash-es/identity.js
var identity = __webpack_require__(54);

// CONCATENATED MODULE: ../node_modules/lodash-es/_baseSetToString.js




/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !_defineProperty["a" /* default */] ? identity["a" /* default */] : function(func, string) {
  return Object(_defineProperty["a" /* default */])(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': lodash_es_constant(string),
    'writable': true
  });
};

/* harmony default export */ var _baseSetToString = (baseSetToString);

// EXTERNAL MODULE: ../node_modules/lodash-es/_shortOut.js
var _shortOut = __webpack_require__(279);

// CONCATENATED MODULE: ../node_modules/lodash-es/_setToString.js



/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = Object(_shortOut["a" /* default */])(_baseSetToString);

/* harmony default export */ var _setToString = __webpack_exports__["a"] = (setToString);


/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__apply_js__ = __webpack_require__(276);


/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return Object(__WEBPACK_IMPORTED_MODULE_0__apply_js__["a" /* default */])(func, this, otherArgs);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overRest);


/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (shortOut);


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  number: __webpack_require__(281),
  expirationDate: __webpack_require__(283),
  expirationMonth: __webpack_require__(207),
  expirationYear: __webpack_require__(125),
  cvv: __webpack_require__(286),
  postalCode: __webpack_require__(287),
  creditCardType: __webpack_require__(206)
};


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var luhn10 = __webpack_require__(282);
var getCardTypes = __webpack_require__(206);

function verification(card, isPotentiallyValid, isValid) {
  return {card: card, isPotentiallyValid: isPotentiallyValid, isValid: isValid};
}

function cardNumber(value) {
  var potentialTypes, cardType, isPotentiallyValid, isValid, i, maxLength;

  if (typeof value === 'number') {
    value = String(value);
  }

  if (typeof value !== 'string') { return verification(null, false, false); }

  value = value.replace(/\-|\s/g, '');

  if (!/^\d*$/.test(value)) { return verification(null, false, false); }

  potentialTypes = getCardTypes(value);

  if (potentialTypes.length === 0) {
    return verification(null, false, false);
  } else if (potentialTypes.length !== 1) {
    return verification(null, true, false);
  }

  cardType = potentialTypes[0];

  if (cardType.type === 'unionpay') {  // UnionPay is not Luhn 10 compliant
    isValid = true;
  } else {
    isValid = luhn10(value);
  }

  maxLength = Math.max.apply(null, cardType.lengths);

  for (i = 0; i < cardType.lengths.length; i++) {
    if (cardType.lengths[i] === value.length) {
      isPotentiallyValid = value.length !== maxLength || isValid;
      return verification(cardType, isPotentiallyValid, isValid);
    }
  }

  return verification(cardType, value.length < maxLength, false);
}

module.exports = cardNumber;


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Luhn algorithm implementation in JavaScript
 * Copyright (c) 2009 Nicholas C. Zakas
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */


function luhn10(identifier) {
  var sum = 0;
  var alt = false;
  var i = identifier.length - 1;
  var num;

  while (i >= 0) {
    num = parseInt(identifier.charAt(i), 10);

    if (alt) {
      num *= 2;
      if (num > 9) {
        num = (num % 10) + 1; // eslint-disable-line no-extra-parens
      }
    }

    alt = !alt;

    sum += num;

    i--;
  }

  return sum % 10 === 0;
}

module.exports = luhn10;


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var parseDate = __webpack_require__(284);
var expirationMonth = __webpack_require__(207);
var expirationYear = __webpack_require__(125);

function verification(isValid, isPotentiallyValid, month, year) {
  return {
    isValid: isValid,
    isPotentiallyValid: isPotentiallyValid,
    month: month,
    year: year
  };
}

function expirationDate(value, maxElapsedYear) {
  var date, monthValid, yearValid, isValidForThisYear;

  if (typeof value === 'string') {
    value = value.replace(/^(\d\d) (\d\d(\d\d)?)$/, '$1/$2');
    date = parseDate(value);
  } else if (value !== null && typeof value === 'object') {
    date = {
      month: String(value.month),
      year: String(value.year)
    };
  } else {
    return verification(false, false, null, null);
  }

  monthValid = expirationMonth(date.month);
  yearValid = expirationYear(date.year, maxElapsedYear);

  if (monthValid.isValid) {
    if (yearValid.isCurrentYear) {
      isValidForThisYear = monthValid.isValidForThisYear;
      return verification(isValidForThisYear, isValidForThisYear, date.month, date.year);
    }

    if (yearValid.isValid) {
      return verification(true, true, date.month, date.year);
    }
  }

  if (monthValid.isPotentiallyValid && yearValid.isPotentiallyValid) {
    return verification(false, true, null, null);
  }

  return verification(false, false, null, null);
}

module.exports = expirationDate;


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var expirationYear = __webpack_require__(125);
var isArray = __webpack_require__(285);

function parseDate(value) {
  var month, len, year, yearValid;

  if (/\//.test(value)) {
    value = value.split(/\s*\/\s*/g);
  } else if (/\s/.test(value)) {
    value = value.split(/ +/g);
  }

  if (isArray(value)) {
    return {
      month: value[0],
      year: value.slice(1).join()
    };
  }

  len = value[0] === '0' || value.length > 5 ? 2 : 1;

  if (value[0] === '1') {
    year = value.substr(1);
    yearValid = expirationYear(year);
    if (!yearValid.isPotentiallyValid) {
      len = 2;
    }
  }

  month = value.substr(0, len);

  return {
    month: month,
    year: value.substr(month.length)
  };
}

module.exports = parseDate;


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Polyfill taken from <https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/isArray#Polyfill>.

module.exports = Array.isArray || function (arg) {
  return Object.prototype.toString.call(arg) === '[object Array]';
};


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var DEFAULT_LENGTH = 3;

function includes(array, thing) {
  var i = 0;

  for (; i < array.length; i++) {
    if (thing === array[i]) { return true; }
  }

  return false;
}

function max(array) {
  var maximum = DEFAULT_LENGTH;
  var i = 0;

  for (; i < array.length; i++) {
    maximum = array[i] > maximum ? array[i] : maximum;
  }

  return maximum;
}

function verification(isValid, isPotentiallyValid) {
  return {isValid: isValid, isPotentiallyValid: isPotentiallyValid};
}

function cvv(value, maxLength) {
  maxLength = maxLength || DEFAULT_LENGTH;
  maxLength = maxLength instanceof Array ? maxLength : [maxLength];

  if (typeof value !== 'string') { return verification(false, false); }
  if (!/^\d*$/.test(value)) { return verification(false, false); }
  if (includes(maxLength, value.length)) { return verification(true, true); }
  if (value.length < Math.min.apply(null, maxLength)) { return verification(false, true); }
  if (value.length > max(maxLength)) { return verification(false, false); }

  return verification(true, true);
}

module.exports = cvv;


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var DEFAULT_MIN_POSTAL_CODE_LENGTH = 3;

function verification(isValid, isPotentiallyValid) {
  return {isValid: isValid, isPotentiallyValid: isPotentiallyValid};
}

function postalCode(value, options) {
  var minLength;

  options = options || {};

  minLength = options.minLength || DEFAULT_MIN_POSTAL_CODE_LENGTH;

  if (typeof value !== 'string') {
    return verification(false, false);
  } else if (value.length < minLength) {
    return verification(false, true);
  }

  return verification(true, true);
}

module.exports = postalCode;


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

var isBuffer = __webpack_require__(289)

module.exports = flatten
flatten.flatten = flatten
flatten.unflatten = unflatten

function flatten (target, opts) {
  opts = opts || {}

  var delimiter = opts.delimiter || '.'
  var maxDepth = opts.maxDepth
  var output = {}

  function step (object, prev, currentDepth) {
    currentDepth = currentDepth || 1
    Object.keys(object).forEach(function (key) {
      var value = object[key]
      var isarray = opts.safe && Array.isArray(value)
      var type = Object.prototype.toString.call(value)
      var isbuffer = isBuffer(value)
      var isobject = (
        type === '[object Object]' ||
        type === '[object Array]'
      )

      var newKey = prev
        ? prev + delimiter + key
        : key

      if (!isarray && !isbuffer && isobject && Object.keys(value).length &&
        (!opts.maxDepth || currentDepth < maxDepth)) {
        return step(value, newKey, currentDepth + 1)
      }

      output[newKey] = value
    })
  }

  step(target)

  return output
}

function unflatten (target, opts) {
  opts = opts || {}

  var delimiter = opts.delimiter || '.'
  var overwrite = opts.overwrite || false
  var result = {}

  var isbuffer = isBuffer(target)
  if (isbuffer || Object.prototype.toString.call(target) !== '[object Object]') {
    return target
  }

  // safely ensure that the key is
  // an integer.
  function getkey (key) {
    var parsedKey = Number(key)

    return (
      isNaN(parsedKey) ||
      key.indexOf('.') !== -1 ||
      opts.object
    ) ? key
      : parsedKey
  }

  var sortedKeys = Object.keys(target).sort(function (keyA, keyB) {
    return keyA.length - keyB.length
  })

  sortedKeys.forEach(function (key) {
    var split = key.split(delimiter)
    var key1 = getkey(split.shift())
    var key2 = getkey(split[0])
    var recipient = result

    while (key2 !== undefined) {
      var type = Object.prototype.toString.call(recipient[key1])
      var isobject = (
        type === '[object Object]' ||
        type === '[object Array]'
      )

      // do not write over falsey, non-undefined values if overwrite is false
      if (!overwrite && !isobject && typeof recipient[key1] !== 'undefined') {
        return
      }

      if ((overwrite && !isobject) || (!overwrite && recipient[key1] == null)) {
        recipient[key1] = (
          typeof key2 === 'number' &&
          !opts.object ? [] : {}
        )
      }

      recipient = recipient[key1]
      if (split.length > 0) {
        key1 = getkey(split.shift())
        key2 = getkey(split[0])
      }
    }

    // unflatten again for 'messy objects'
    recipient[key1] = unflatten(target[key], opts)
  })

  return result
}


/***/ }),
/* 289 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

module.exports = function isBuffer (obj) {
  return obj != null && obj.constructor != null &&
    typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}


/***/ }),
/* 290 */,
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(1);

// EXTERNAL MODULE: ../react-lib/src/styles/ZIndex.js
var ZIndex = __webpack_require__(78);

// CONCATENATED MODULE: ../react-lib/src/components/utils/RoverLoading/roverLoaderUrl.js
/* harmony default export */ var roverLoaderUrl = ('data:image/gif;base64,R0lGODlhUABQAMQfAAO+cpnlxhTCe9b16Pv+/WPXpyXHhfT8+YPfuszy4uv69HXbsr7u2kfPmLLr1DfLj6Pny4zhvz/Nk1PTn+T48F3VpN737cTw3gnAdazq0BzEgCzJiU3Rm////wC9cP///yH/C05FVFNDQVBFMi4wAwEAAAAh+QQFAAAfACwAAAAAUABQAAAF/+AnjmRpniJBOUghGQLmeZhgSAXiUATq/8DgSZEpGACzpHI5AxgKGYVwSvUdHBMBc8tNCiaOQ3UsVEQM3bTaEJGS36QDQquupwUIMXxMgGjsgGoaED17QgMNgYpqDQOGPwQBdIuUWwIBhY9xBUiVnkwABXqaHxQPn6hbDxSkA2ipsEoGjoYJf7G4MxoJewO3ubkatGMUr8DABqxVB6fHzg+jQQQFztUeBZlAAZ3WwAABh5PdwALDKASJ49UN2SYQ6t0QVr/wxxrRJAj13QhD4vvk3JCIALBbhBIHjBU8ZiCag4XdHJCYANHahBEK/lXEJcBNho3WMoigBtJZgQ8EFPmWxGVABbeVuACsgOmMBc1jLW4Cc6Ez14ueLDUCrRRjKCwZRpPCRKq0Uo2mnmxArXRjKiUcVhflyKpIB9dAO15+5SIz5dg1PUie5XLyw8e1XER+yAiXSccRFOsquTjiod4kEkck/OuhYQmCfw+WoFv3rgl9dfudOEDv6z0f79bK84HuLDsgA4QqLSdkW9ZvU6ZlxUaF2VRoxFQCTfbGV1Jhe2wN3fXIVc9ZpEzdXEVKxAFOJUPh0xRJNLxL7Yp/QASxkfRzfvYNin49zpxxeJZ3H3LGGRuB44VcyQLrS5j0cIgYEavGCRT08PeoYOECBtIaN+SwA3ePhAAAIfkEBQAAHwAsJgAsAAoACQAABSbg9wnPJogo8Ejsg6EGK0unOrcYdsuasLO9nyQ362leo83jhPqEAAAh+QQFAAAfACwiACcAEwATAAAFZeAnipqBjWg6GguCFM+pokLruoskq8B0/4jFA6AyAI+T3QdQOR4LO43TWSF+GlPnQ2TL/goAgdcpMI6BhscZrV7jBBu3a/IRuyuygrNgEGg2GxpWHxpdc4MzhBUtCw2IiUt+SokhACH5BAUAAB8ALB4AIwAcABsAAAWs4CeO3xMgk4GRbNs+DiMzQaEBbi5q2ew7iA1ORwJEfEhZZEMcNZJQx2KlE/SgUAgzV8B6HZwhyeotT8SiSXndIGEC67JDM9rE15Fh915+fABwfF4LHwIxglgQGHaIWA4CT41RGmqSSXMVlkmKlZozCB8Snj5MBqMyEyIYV2sOGRmHMgESJHtfNhgYAhsPDyosGhBftE0kG6w/fsUsAgixNAbLLgAGEwsFD2jLIQAh+QQFAAAfACwaAB4AJQAlAAAF/+AnjuT2aBiprmwrckp3JFEjuLgrxV3fEZZAI5UrGiy+ZI+QKNyKLYxDSe1ZFkQoaUGoei2FLHTD81YJjAcACsiY3x0Ftijpws2EzLMFYNzvCQYuDXZ/bwMbLABThncDGisbB41/DGIfCJSGCCQYA5p/B4kiD4WgbxAjmad3CpB9rH8FHwIUsXepkrdwCR8Tu3ADGAvAbxYYq8VVwhHKXgyYzlWcxNJJBw8fFdZJGWul3B0WgrS21gmjH22gFAwOFxaFTAt7IhOmwRNPABgaGxInLonA4OePg3paRGxAAudgQhYPPnkhEADhwxEaAkxSIkfgRRIGEFxQoCABAnIfcwfww7AmpYoQACH5BAUAAB8ALBEAHgAuACUAAAX/oCeOZGmeaKqqT8EZ2CrPpER1hJIgUkz/ps2tQyQSdgYAEChIFJ/FA+ShXK4AAajWmHlYVY3DdnwIaK6bh6Z6ao7fHUuFbcJI7mfUggB/lwUpBneAJxoWfX0XeScYPicLiIgDG1YCQ5FwAwZLBZiRF4QzABeekRF0KhtipX0HEjSQrIgMNAyyiASUKxoKt4gIMhK+iBeoJrHDbwrGJVnJfqEnAA7P0Cqj1WSO0k7ZWgPMI9jeUAFX1ORFBF4rzukdEDOd7wzRKaqyBHxafzQA3ZEIMCjw4AGHBQEyOICwIAmQAvv6UJgQ7osHDBkQUWBnMYUAW28scOzoEcEqKAw2GJGUAWBDAAtiDiQosG2lDAwGNqyxybNjCAAh+QQFAAAfACwPAB8ALwAjAAAF/6AnjmRpnmiqruIWIJMGsHTtbVanH9di2ECTYKAr7hiTGRBjkLEAGaNUZykIaoYFArF4KFEFwnRcxawAha06iTJQxvAO46ECaNXbzQkAiccPC2YoE3hbDScPB35+DlcnGBWFPyUADouLA5MmAA8FC12IYpd+mXVfJX2jiwmOQBqKqosQpzQFsZcEE0EMt5cJgjQaCr2XujUTosRxGTYRyosWwCu8z3EErSoYRNVxeiwCb9xw3ivC4mMEGsGw50bRwcPtRhA1AjnyOgR0NAAX+DoRaKkIgI9AAGksOCTDlSCDgwHsDjDgIHCFPVUZNigBgEHDBgMYKtKosBAdApFBNiZFKGmEwAKUKTctYGfkQAGYMU9sgMCOgANyOYMIkFAhBs6gSG2EAAAh+QQFAAAfACwOACIADAAKAAAFNuAHPAtSPMCnqgvjulCTfs9rM4jwIbcdAZGe7VEQvgoYiJFR+WgCQodBJVg4bpOVSjMpLTaqEAAh+QQFAAAfACwMACAAEAAOAAAFV+AnfpimYWM6CtGgKAPEoaqWdHhOJBMwApmcMJcRiB6HoTKh+SyUUAcGAVUSGhNCdYgQ3La5yOdBAeMKIkl5qzCMNgytFZ3CVC7JnKLgU4k0HAUFHEYiIQAh+QQFAAAfACwMABgAEgAWAAAFceAnjiRpbFipjpgkPcCqAo8ryCq2GTHu/8CgUOUpeoAASYBxgRQ0xxUAcSgpItCSp0KQUQo9ESbhI0TCm265EE0DB6mPgAI8bEQeBJDwYDl+ChokAhlqKwFhYgsKKwk3RBoLF2oKAQJRMh4YGhoAmCIhACH5BAUAAB8ALAwAFgAUABgAAAWC4CeO5ChIj1CupLEgyGKwbAHDi0qT9o1MO1LDF8MERYLXbWE8fly3htPUmGwA06x2W/JgJrDCxnP0bAYkwmWCpQksNIaB3EUEFRL6yJM4UjRdcEcReh8eEE4JhR8PB0eKXQUEQQGLhhWOLAdjLGYOk2kVliQAGwgOCRcBD6OdHq80IQAh+QQFAAAfACwWABQADAAMAAAFPuD3AdpmAGL6CYjDMMGmYsFrO1LK2bwjfwseL4D5VIS8xmeDtCEAgFozgHq4kE/RpPlQSSA3jkqEaRQmmlQIACH5BAUAAB8ALBQAEgAPABAAAAVg4CeKmACMqAhImaIMiJZ+WHR0OE5N6ULkwEPh9BFQgMhDQyT5IYEDGcf5zEU+Bmq1o9BgBltg4YMI5wIfzdGM/hS0zzEtAs9ZBCMM4oZULFEADQxOBAwSMyQbBQUPGCMhACH5BAUAAB8ALBQAEgAZABAAAAVy4CeKXjmeaPp52BRk0QOo9LolJ5FptWhIPINFlTB4aBiJ5OEJ1C4CpHKDGdYCsxTA8MBgFL2DpPcB4HqMLM0TIRN4vceB3CADMuQxeUOpKaJkHg1gKghHZCsPAyg6GIgjHgILCQcHCQWOjycsGhoYh2QhACH5BAUAAB8ALBQAEgAbABAAAAWG4CeOZGkK1TIJpIc1lQR4JokVSL4AIrAoI0uFV/tsckjDBxCoRYimCTK3+TQIxWcNNzV4mkXChFaSIhcYT6YosrBKhunj40GwRQsyyVApzEUNdx8XUHcYA3cUGIIiHgV3FouMS2tFEHqMGAw1ClWTIxgRByQUDZifHnEODgsCp5+NHrKwHyEAIfkEBQAAHwAsJgAQAAsADAAABTrg9wEPEiESIIoT47qL+hnO+zbiYr/Ih2U7FwRgCAoxDyMjQFIuPhrlYxQJImSCgC0gWPkmCESlKwoBACH5BAUAAB8ALCQADgAOABAAAAVU4Cd+wBQ4QYWNo+B0MGw1LPbGsSKNBYHjjBUm8cMdDB+JrxjjfBBMXOGTicYKgIsVNhluD4/sdrAKbBEiySFq0YgAkaVxUkOscxUAS2RYQCAISCMhACH5BAUAAB8ALCQADgAXABAAAAVyoCeKmDRJ2KiuKlBRXXwgAmt7BRHvnZPeIwOMFyMsgKMIkXcBIAWW5U5RAz500g7BgCxkixsk4ts5aJDKr+V3G38DSE8DuzxI4phLFuJcAQwPVQ9DTGcsGhISXCIbDlgEEIYsG4mSHgAaDRwGfTYCD5whACH5BAUAAB8ALCUADgAYABIAAAWBoCeOZGmaQkB1FLSdsKcNXV0fU1wCju0rBt2oQfD5EEIRxOhzJDErZm0AEBqK0g5VKMnWElVdw9sJJB/kXAnTqDQwHmh2ACdhCoj8orqQEjgmHHmDQQABRgQLKAuDeUEeABMMFBQMgCYbjXl1IxgYYZiaakmdjHkFnKQiAhwFbyIhACH5BAUAAB8ALDMAFgAMAAwAAAVB4Cd+ArcUGzCKBsS8zIKNWgbDhQhEN5zNjx7MIfgghK8fxoaMAAQOJIPzWSIhs09B6NiMMIsb5LH6AB6LxaQ4CgEAIfkEBQAAHwAsMgAUAA8AEAAABVrgJ4pYsywNNq6flHRwZ1UAOylxTCC1KOG52OEhEryCuYBoQUDmGADMwJlzfBpNKkwZ0cYKH4e3czCEx5kawqsgfjZAJGHRAzDlvBWgQMlZJj0sGBMIERMqLCEAIfkEBQAAHwAsMgAUAA8AEAAABVqgJ46YpmFjKmKI1XUWIqiexrx4l2ypcOc4BsoDiABzBIloczjmFqKAM1fwCBRT3MTTIGQ7B4On8O1cAOMvobL0ToUigGNq4Y0MiePgQRNEsGARMzQrGw9DKiEAIfkEBQAAHwAsMgAUAA4AEAAABVKgJ44eQJ7iFlxMtKHAcnR0dyzmuBB1TRQjyaxXG2A8mASxRzB4JkumxuOI1hQCjMJKSwA0XBrCI+BZFVOA0roYTcxESK60Y0aOJ1ViAHmg/ighACH5BAUAAB8ALAAAAAABAAEAAAUD4BcCACH5BAUAAB8ALAAAAAABAAEAAAUD4BcCACH5BAUAAB8ALAAAAAABAAEAAAUD4BcCACH5BAUAAB8ALAAAAAABAAEAAAUD4BcCACH5BAUAAB8ALAAAAAABAAEAAAUD4BcCACH5BAUAAB8ALAAAAAABAAEAAAUD4BcCACH5BAUAAB8ALAAAAAABAAEAAAUD4BcCACH5BAUAAB8ALBoAHwAkACMAAAX/4CeO5FNwBkaubOtKVEcoCSKpbu5u8djJNQNAR/wIEp3W7wB5DIssQCCpk2Ue0FXjQCV2DgFN1ogcfzqWypO4IJhF34CAqLF0352LOLe4v88DGy4CPX8kHQMGLQV+hmcXcyQAF42OHRFrHxsHjkoHEiR9nUoMJAyVowSCHxoKqJ0dCCISr7AXQ6KjSgpDU7ouBwIADrWdwZPFhl8YAGW/K4gAyM/QAR/DyXgEWB++1HAQI4zfPwyRmlxjPwQEPz5x59fORQQMBQ8PHAsBGQ4QC0JYFGjnhcKETFkwZHDnogMFboYEnKqEBqIjAQi4dCmn6BeADQEscDmQoACObxgMBmzQgPBPCAAh+QQFAAAfACwaAB8AJAAjAAAF+OAnjqRnmmSqrqxnIIUknGxdu06iX0Gl0bagR5DRGXcBCQAVXHkAkaNU55hgPE2VZzLtJhycZVbk0TC83sCGGQQg0OhLQWzzbC5weGRmg+bzGT8td3+AglpvhXkQfCUCZ4p5CHRkXJF/ElgjHgGXfxkYJI+emJoeEqR/CKYLqXkOVx+crnl8GEW0aD9DkLldBiajvl0zZb3DRrDBx8gJq7IYOc07ayIAENM6CwCbrdMLsWSolxARERl4SEqaZNGKEQZLTxgCBhoY8lochXPsY7IevHmRw+1fiicVmOlgEMagExcIjsHz57CECQwPOEjQQKliixMUK4YAACH5BAUAAB8ALBsAIAAiACEAAAW7IOI4i+CdaKqmE9G9cAetdI0CiwsTEWb/tE0gMYA8gMjkD9DgbEzKJKASqEYWD1/UJql6rRPoNqWJfM+RiXaMO7sDkQdg/HjbC2skAGG3l5R1fX55NW2Cd3M/GoeCEkANjH09NoaRb0c1GGaWbxU2i5xvCzZCoW6jNYGmX6g0qqtVE6SwXxqftFWeNhh8q2mJNlSCBRsaBg9NEmKKm25xYysbzV4RG9A0Ggusttc1Ag8SBsDd5OXm5+jQIQAh+QQFAAAfACwMACEALAAcAAAF4KDnAVLAXFChiWzrvrAILETXjchh70q0xsCgZxNIeCq1nZJSAAifMExCSe0QIk6odpis7giFrXbT9doGGPFTQDErDxv1E+H+PoSChyYNxTjqHQo/MQIVBQUVEhpZQQIZZVQBjC8AE4eXBRwCTxgLCl4Jm0AbmKUPkzEaCxdJCgGiMRiGpZgcfJwai0+ktKUcqHIulb20d8GExLQVt8ctvMmYg80sD9ClcdMtDdaYBtna3Jew39XhEt8tGsQNEhwTHBvA0wAcpRWw8ugY24cT4+hAAAjYYCAfwIMIEypcKCQEACH5BAUAAB8ALAwAIQAoABgAAAWRoCdiUlFMmqiubOuqgGhkSZ1cgRS/fO8JDpswEUj5jqvCcMjYIJ+QJVPwPNKkwkXVh8AKIdve5uKtgcM8TjmhRacZ2IvB3TNElhcO3QcwFCIQAQtzTwACGHtbGg8PG1SJPhiMkwY7kC6Lk4xGly0bmowblp0iAJ+fk6KkLKianKsimQYYtLAtAgKjtru8vb49IQAh+QQFAAAfACwNACEAIwAUAAAFUaAnjmRpnqgIaJsGpDAsLEGNcFisjwBd/4jNTqf5GQMRwxBmOBoXyxQm4vy9oqdHNYC4Yk0P6rHxTWkq4sjEWz5hNBpBe06v2+/4vH7P7/tFIQAh+QQFAAAfACwOABMAFQAZAAAFi6AnjiM2BVn0AGRLbkknd0Smua1hzXxi4KMAb3gRADG7IS/AcmEUSt5BggPEojNGsxXBzgg31+PglTWqmXKHittQvAojsAGNIoCjx2BYw+BHAgsJBwcJBX5/JBgaGoiJjyQAW5AeABIFFRJykBsFnp4/kJefmI5/GqSem4kGpByTiRgbEg+mlLe4LSEAIfkEBQAAHwAsEAATABMAFwAABWagJ44i9nAbQK4jUDFJ7DQqKwJLrMdLzT674MLmyQV3ElvkuHNgWAXmrvKT6iC+UsaaYDxXHK6TBVhKEURMgMkwED2YxaX5eI80hUikIrD7/4CBgiwaBn2BABsPD1+AAhsbjYOTgiEAIfkEBQAAHwAsEQATABIAFQAABUmgJ45kaZ7oKVRL8QCpaERBHRRYCiC2XcCqXu+BEtCEAUTOBFggawbU4xkgngCFpyaFcfYqQBSggYggGuEYAJOOud/wuHxOr9tDACH5BAUAAB8ALBYADgAcABIAAAWMoCeOZEli0iRhZusCFdXNByK4uFgQc985rJzJIPPNCAuhKWL0XQDKkcDS7CluUc+DV+0QDFlPoXvckATYFoLcOWhEgEah0AiWmGRLcDOfc9RsASMPfXNgJQ1cTQcSIxqFdCYYF10QUCNyfY0mD0VObyeZFWklGw5cBBCgJQACGnYtABoNHAaXYbi5OSEAIfkEBQAAHwAsGAAOABoAEAAABWygJ45kaZ6oKSxMwiBGmgpZYttXI5tAdP8MzY70+BkLwxHC+IskPRgH85YBJDWXqa2aLGoTEOvQq0WMBBqxafNNSESAzSN2imozmJHh8VCXKlMXbyMAGgIpAAtMFU8kABIBDgwBg40lGBh+HiEAIfkEBQAAHwAsGQAPABkADwAABUigJ45kaZ5oCWiGBqQwVgT0IsDoTNcvTmq7oMFHmgR3EuJocaQ1lB4AohlIKqVUDdSjCy56Sk0kGBluPZtpALE5j1YajHvuDgEAIfkEBQAAHwAsJgAQABoAFAAABYygJ45kaZ5oqgLGo6mw9xT0E6MYTVdAimkajMmgowlNGISl07EgBKRNsXIkaRjMbCexGRF1DZMAq80yjgDODkoCRMpagmTE2lRHmwNcu7gF9loFMQIKgFkTMQ0Ehh0HBjEFjB0XPTCRhgQVNxuLgGc3AA6AFl03HgYJcAM2piICEYWNEWytIxgbD3ciIQAh+QQFAAAfACwoABIAGAASAAAFZKAnjmRpnmhaCgamqsD2GKqxBMFCj/GjoYDKJUFMXAqAkUCTPFWK0ATnJXoMo8SMS4WBYKE/leQLfkXIRIaAy0AnIE2Uxp0ovARu9QvgJVeoHg1kCHEwQlELhVQ2EBkIG4CRIiEAIfkEBQAAHwAsKQAUABcADwAABUWgJ45kaZ5oqpqYgK2ohERRIcAkF+w78uIbnlCCAyyEvAnOgORxcJPmboOrSH04iZSIwyCQFQBOJChEAgiJeDwSaH5sWAgAIfkEBQAAHwAsNAAWAAoADAAABSagJ45kaY6CIZhP4W6k5roVMHKza3tYXnCjXs5A2sweJsFmdWo2QwAh+QQFAAAfACw1ABgACAAIAAAFFKAnjmRJChpwPo9AaixGYoZr3mUIACH5BAUAAB8ALDcAGgAEAAQAAAUGoCeOZOmFACH5BAUAAB8ALAAAAAABAAEAAAUD4BcCACH5BAUAAB8ALAAAAAABAAEAAAUD4BcCADs=');
// CONCATENATED MODULE: ../react-lib/src/components/utils/RoverLoading/RoverLoading.jsx



var SIZE = 40;
var RoverLoading = styled_components_browser_esm["default"].div.withConfig({
  displayName: "RoverLoading",
  componentId: "sc-98ge69-0"
})(["", ""], function (_ref) {
  var isLoading = _ref.isLoading;
  return !isLoading ? '' : Object(styled_components_browser_esm["css"])(["position:relative;&:before,&:after{position:absolute;display:block;content:' ';}&:before{top:0;bottom:0;left:0;right:0;background-color:white;background-color:rgba(255,255,255,0.9);z-index:", ";}&:after{display:inline-block;background-image:url(", ");background-size:", "px ", "px;width:", "px;height:", "px;top:50%;left:50%;z-index:", ";margin-top:", "px;margin-left:", "px;}"], ZIndex["a" /* default */].NAVBAR_FIXED - 2, roverLoaderUrl, SIZE, SIZE, SIZE, SIZE, ZIndex["a" /* default */].NAVBAR_FIXED - 1, SIZE / 2 * -1, SIZE / 2 * -1);
});
/* harmony default export */ var RoverLoading_RoverLoading = __webpack_exports__["a"] = (RoverLoading);

/***/ }),
/* 292 */,
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(223);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(router, "You should not use <Route> or withRouter() outside a <Router>");

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }, route.match);
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    if (component) return match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : null;

    if (render) return match ? render(props) : null;

    if (typeof children === "function") return children(props);

    if (children && !isEmptyChildren(children)) return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children);

    return null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  sensitive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(382)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compileGenerator = function compileGenerator(pattern) {
  var cacheKey = pattern;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var compiledGenerator = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default.a.compile(pattern);

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledGenerator;
    cacheCount++;
  }

  return compiledGenerator;
};

/**
 * Public API for generating a URL pathname from a pattern and parameters.
 */
var generatePath = function generatePath() {
  var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (pattern === "/") {
    return pattern;
  }
  var generator = compileGenerator(pattern);
  return generator(params, { pretty: true });
};

/* harmony default export */ __webpack_exports__["a"] = (generatePath);

/***/ }),
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/lodash-es/_Stack.js + 5 modules
var _Stack = __webpack_require__(50);

// EXTERNAL MODULE: ../node_modules/lodash-es/_arrayEach.js
var _arrayEach = __webpack_require__(115);

// EXTERNAL MODULE: ../node_modules/lodash-es/_assignValue.js
var _assignValue = __webpack_require__(113);

// EXTERNAL MODULE: ../node_modules/lodash-es/_copyObject.js
var _copyObject = __webpack_require__(66);

// EXTERNAL MODULE: ../node_modules/lodash-es/keys.js
var keys = __webpack_require__(26);

// CONCATENATED MODULE: ../node_modules/lodash-es/_baseAssign.js



/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && Object(_copyObject["a" /* default */])(source, Object(keys["a" /* default */])(source), object);
}

/* harmony default export */ var _baseAssign = (baseAssign);

// EXTERNAL MODULE: ../node_modules/lodash-es/keysIn.js + 2 modules
var lodash_es_keysIn = __webpack_require__(80);

// CONCATENATED MODULE: ../node_modules/lodash-es/_baseAssignIn.js



/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && Object(_copyObject["a" /* default */])(source, Object(lodash_es_keysIn["a" /* default */])(source), object);
}

/* harmony default export */ var _baseAssignIn = (baseAssignIn);

// EXTERNAL MODULE: ../node_modules/lodash-es/_cloneBuffer.js
var _cloneBuffer = __webpack_require__(168);

// EXTERNAL MODULE: ../node_modules/lodash-es/_copyArray.js
var _copyArray = __webpack_require__(165);

// EXTERNAL MODULE: ../node_modules/lodash-es/_getSymbols.js + 1 modules
var _getSymbols = __webpack_require__(83);

// CONCATENATED MODULE: ../node_modules/lodash-es/_copySymbols.js



/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return Object(_copyObject["a" /* default */])(source, Object(_getSymbols["a" /* default */])(source), object);
}

/* harmony default export */ var _copySymbols = (copySymbols);

// EXTERNAL MODULE: ../node_modules/lodash-es/_getSymbolsIn.js
var _getSymbolsIn = __webpack_require__(209);

// CONCATENATED MODULE: ../node_modules/lodash-es/_copySymbolsIn.js



/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return Object(_copyObject["a" /* default */])(source, Object(_getSymbolsIn["a" /* default */])(source), object);
}

/* harmony default export */ var _copySymbolsIn = (copySymbolsIn);

// EXTERNAL MODULE: ../node_modules/lodash-es/_getAllKeys.js
var _getAllKeys = __webpack_require__(120);

// EXTERNAL MODULE: ../node_modules/lodash-es/_getAllKeysIn.js
var _getAllKeysIn = __webpack_require__(300);

// EXTERNAL MODULE: ../node_modules/lodash-es/_getTag.js + 2 modules
var _getTag = __webpack_require__(63);

// CONCATENATED MODULE: ../node_modules/lodash-es/_initCloneArray.js
/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _initCloneArray_hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && _initCloneArray_hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

/* harmony default export */ var _initCloneArray = (initCloneArray);

// EXTERNAL MODULE: ../node_modules/lodash-es/_cloneArrayBuffer.js
var _cloneArrayBuffer = __webpack_require__(114);

// CONCATENATED MODULE: ../node_modules/lodash-es/_cloneDataView.js


/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? Object(_cloneArrayBuffer["a" /* default */])(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

/* harmony default export */ var _cloneDataView = (cloneDataView);

// CONCATENATED MODULE: ../node_modules/lodash-es/_cloneRegExp.js
/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

/* harmony default export */ var _cloneRegExp = (cloneRegExp);

// EXTERNAL MODULE: ../node_modules/lodash-es/_Symbol.js
var _Symbol = __webpack_require__(68);

// CONCATENATED MODULE: ../node_modules/lodash-es/_cloneSymbol.js


/** Used to convert symbols to primitives and strings. */
var symbolProto = _Symbol["a" /* default */] ? _Symbol["a" /* default */].prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

/* harmony default export */ var _cloneSymbol = (cloneSymbol);

// EXTERNAL MODULE: ../node_modules/lodash-es/_cloneTypedArray.js
var _cloneTypedArray = __webpack_require__(169);

// CONCATENATED MODULE: ../node_modules/lodash-es/_initCloneByTag.js






/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return Object(_cloneArrayBuffer["a" /* default */])(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return _cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return Object(_cloneTypedArray["a" /* default */])(object, isDeep);

    case mapTag:
      return new Ctor;

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return _cloneRegExp(object);

    case setTag:
      return new Ctor;

    case symbolTag:
      return _cloneSymbol(object);
  }
}

/* harmony default export */ var _initCloneByTag = (initCloneByTag);

// EXTERNAL MODULE: ../node_modules/lodash-es/_initCloneObject.js
var _initCloneObject = __webpack_require__(170);

// EXTERNAL MODULE: ../node_modules/lodash-es/isArray.js
var isArray = __webpack_require__(5);

// EXTERNAL MODULE: ../node_modules/lodash-es/isBuffer.js
var isBuffer = __webpack_require__(38);

// EXTERNAL MODULE: ../node_modules/lodash-es/isObjectLike.js
var isObjectLike = __webpack_require__(12);

// CONCATENATED MODULE: ../node_modules/lodash-es/_baseIsMap.js



/** `Object#toString` result references. */
var _baseIsMap_mapTag = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return Object(isObjectLike["a" /* default */])(value) && Object(_getTag["a" /* default */])(value) == _baseIsMap_mapTag;
}

/* harmony default export */ var _baseIsMap = (baseIsMap);

// EXTERNAL MODULE: ../node_modules/lodash-es/_baseUnary.js
var _baseUnary = __webpack_require__(71);

// EXTERNAL MODULE: ../node_modules/lodash-es/_nodeUtil.js
var _nodeUtil = __webpack_require__(74);

// CONCATENATED MODULE: ../node_modules/lodash-es/isMap.js




/* Node.js helper references. */
var nodeIsMap = _nodeUtil["a" /* default */] && _nodeUtil["a" /* default */].isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? Object(_baseUnary["a" /* default */])(nodeIsMap) : _baseIsMap;

/* harmony default export */ var lodash_es_isMap = (isMap);

// EXTERNAL MODULE: ../node_modules/lodash-es/isObject.js
var isObject = __webpack_require__(8);

// CONCATENATED MODULE: ../node_modules/lodash-es/_baseIsSet.js



/** `Object#toString` result references. */
var _baseIsSet_setTag = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return Object(isObjectLike["a" /* default */])(value) && Object(_getTag["a" /* default */])(value) == _baseIsSet_setTag;
}

/* harmony default export */ var _baseIsSet = (baseIsSet);

// CONCATENATED MODULE: ../node_modules/lodash-es/isSet.js




/* Node.js helper references. */
var nodeIsSet = _nodeUtil["a" /* default */] && _nodeUtil["a" /* default */].isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? Object(_baseUnary["a" /* default */])(nodeIsSet) : _baseIsSet;

/* harmony default export */ var lodash_es_isSet = (isSet);

// CONCATENATED MODULE: ../node_modules/lodash-es/_baseClone.js






















/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    _baseClone_boolTag = '[object Boolean]',
    _baseClone_dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    _baseClone_mapTag = '[object Map]',
    _baseClone_numberTag = '[object Number]',
    objectTag = '[object Object]',
    _baseClone_regexpTag = '[object RegExp]',
    _baseClone_setTag = '[object Set]',
    _baseClone_stringTag = '[object String]',
    _baseClone_symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var _baseClone_arrayBufferTag = '[object ArrayBuffer]',
    _baseClone_dataViewTag = '[object DataView]',
    _baseClone_float32Tag = '[object Float32Array]',
    _baseClone_float64Tag = '[object Float64Array]',
    _baseClone_int8Tag = '[object Int8Array]',
    _baseClone_int16Tag = '[object Int16Array]',
    _baseClone_int32Tag = '[object Int32Array]',
    _baseClone_uint8Tag = '[object Uint8Array]',
    _baseClone_uint8ClampedTag = '[object Uint8ClampedArray]',
    _baseClone_uint16Tag = '[object Uint16Array]',
    _baseClone_uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[_baseClone_arrayBufferTag] = cloneableTags[_baseClone_dataViewTag] =
cloneableTags[_baseClone_boolTag] = cloneableTags[_baseClone_dateTag] =
cloneableTags[_baseClone_float32Tag] = cloneableTags[_baseClone_float64Tag] =
cloneableTags[_baseClone_int8Tag] = cloneableTags[_baseClone_int16Tag] =
cloneableTags[_baseClone_int32Tag] = cloneableTags[_baseClone_mapTag] =
cloneableTags[_baseClone_numberTag] = cloneableTags[objectTag] =
cloneableTags[_baseClone_regexpTag] = cloneableTags[_baseClone_setTag] =
cloneableTags[_baseClone_stringTag] = cloneableTags[_baseClone_symbolTag] =
cloneableTags[_baseClone_uint8Tag] = cloneableTags[_baseClone_uint8ClampedTag] =
cloneableTags[_baseClone_uint16Tag] = cloneableTags[_baseClone_uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!Object(isObject["a" /* default */])(value)) {
    return value;
  }
  var isArr = Object(isArray["a" /* default */])(value);
  if (isArr) {
    result = _initCloneArray(value);
    if (!isDeep) {
      return Object(_copyArray["a" /* default */])(value, result);
    }
  } else {
    var tag = Object(_getTag["a" /* default */])(value),
        isFunc = tag == funcTag || tag == genTag;

    if (Object(isBuffer["a" /* default */])(value)) {
      return Object(_cloneBuffer["a" /* default */])(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : Object(_initCloneObject["a" /* default */])(value);
      if (!isDeep) {
        return isFlat
          ? _copySymbolsIn(value, _baseAssignIn(result, value))
          : _copySymbols(value, _baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = _initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new _Stack["a" /* default */]);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (lodash_es_isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (lodash_es_isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? _getAllKeysIn["a" /* default */] : _getAllKeys["a" /* default */])
    : (isFlat ? keysIn : keys["a" /* default */]);

  var props = isArr ? undefined : keysFunc(value);
  Object(_arrayEach["a" /* default */])(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    Object(_assignValue["a" /* default */])(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

/* harmony default export */ var _baseClone = __webpack_exports__["a"] = (baseClone);


/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetAllKeys_js__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getSymbolsIn_js__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__keysIn_js__ = __webpack_require__(80);




/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseGetAllKeys_js__["a" /* default */])(object, __WEBPACK_IMPORTED_MODULE_2__keysIn_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__getSymbolsIn_js__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = (getAllKeysIn);


/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assignValue_js__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__castPath_js__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isIndex_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isObject_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__toKey_js__ = __webpack_require__(28);






/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_3__isObject_js__["a" /* default */])(object)) {
    return object;
  }
  path = Object(__WEBPACK_IMPORTED_MODULE_1__castPath_js__["a" /* default */])(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = Object(__WEBPACK_IMPORTED_MODULE_4__toKey_js__["a" /* default */])(path[index]),
        newValue = value;

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = Object(__WEBPACK_IMPORTED_MODULE_3__isObject_js__["a" /* default */])(objValue)
          ? objValue
          : (Object(__WEBPACK_IMPORTED_MODULE_2__isIndex_js__["a" /* default */])(path[index + 1]) ? [] : {});
      }
    }
    Object(__WEBPACK_IMPORTED_MODULE_0__assignValue_js__["a" /* default */])(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

/* harmony default export */ __webpack_exports__["a"] = (baseSet);


/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__typography_LoadingSpinner__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Button__ = __webpack_require__(13);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }





var Spinner = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_2__typography_LoadingSpinner__["a" /* default */]).withConfig({
  displayName: "LoadingButton__Spinner",
  componentId: "g7a4fb-0"
})(["margin-left:5px;transform-origin:53% 51%;top:1px;color:inherit;"]);

var LoadingButton = function LoadingButton(_ref) {
  var loading = _ref.loading,
      children = _ref.children,
      other = _objectWithoutProperties(_ref, ["loading", "children"]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Button__["b" /* default */], _extends({
    disabled: loading
  }, other), children, loading && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Spinner, null));
};

LoadingButton.defaultProps = {
  loading: false
};
/* harmony default export */ __webpack_exports__["a"] = (LoadingButton);

/***/ }),
/* 303 */,
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RoverLoading__ = __webpack_require__(291);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__RoverLoading__["a"]; });


/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Input; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_LabelAndErrorFormGroup__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_utils_AsInput__ = __webpack_require__(226);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }





var Input = function Input(_ref) {
  var inputRef = _ref.inputRef,
      onChange = _ref.onChange,
      sensitive = _ref.sensitive,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["inputRef", "onChange", "sensitive", "className"]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_utils_AsInput__["b" /* default */], {
    inputRef: inputRef,
    onChange: onChange,
    sensitive: sensitive,
    className: className
  }, function (inputProps) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", _extends({}, props, inputProps));
  });
};

/* harmony default export */ __webpack_exports__["b"] = (function (props) {
  return (// $FlowFixMe - could not easily decipher how to address the Flow types here as part of FE-3869
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__utils_LabelAndErrorFormGroup__["b" /* default */], props, function (_ref2) {
      var ref = _ref2.ref,
          rest = _objectWithoutProperties(_ref2, ["ref"]);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Input, _extends({}, rest, {
        inputRef: ref
      }));
    })
  );
});


/***/ }),
/* 314 */,
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(1);

// EXTERNAL MODULE: ../design-system/style-dictionary/build/es6/theme.js
var theme = __webpack_require__(44);

// EXTERNAL MODULE: ../react-lib/src/styles/styled-system/index.js + 21 modules
var styled_system = __webpack_require__(123);

// EXTERNAL MODULE: ../react-lib/src/styles/index.js + 3 modules
var styles = __webpack_require__(2);

// CONCATENATED MODULE: ../react-lib/src/components/typography/Heading/Heading.jsx
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }






var DEFAULT_TAGS_FOR_SIZES = {
  '100': 'h5',
  '200': 'h4',
  '300': 'h3',
  '400': 'h2',
  '500': 'h1',
  '600': 'div'
};
var getTag = function getTag(size, as) {
  if (as) {
    return as;
  }

  return DEFAULT_TAGS_FOR_SIZES[size];
};
var StyledHeading = styled_components_browser_esm["default"].p.withConfig({
  displayName: "Heading__StyledHeading",
  componentId: "sc-1p7htrv-0"
})(["padding:0;margin:0;border:0 none;", " ", " ", " ", " ", ""], function (_ref) {
  var size = _ref.size;
  return theme["c" /* headingStyles */][size];
}, function (_ref2) {
  var responsive = _ref2.responsive,
      size = _ref2.size;

  // $FlowFixMe Flow was unable to refine `props.size` based on `props.responsive`
  if (responsive && theme["e" /* responsiveHeadingStyles */][size]) {
    return Object(styled_components_browser_esm["css"])(["", "{", "}"], styles["i" /* MQ */].NOT_XS, theme["e" /* responsiveHeadingStyles */][size]);
  }

  return '';
}, styled_system["b" /* margin */], styled_system["c" /* textAlign */], styled_system["d" /* textColor */]);

var Heading_Heading = function Heading(props) {
  return react_default.a.createElement(StyledHeading, _extends({}, props, {
    as: getTag(props.size, props.as)
  }));
};

Heading_Heading.defaultProps = {
  size: '200',
  responsive: true
};
/* harmony default export */ var typography_Heading_Heading = (Heading_Heading);
// CONCATENATED MODULE: ../react-lib/src/components/typography/Heading/index.js

// CONCATENATED MODULE: ../react-lib/src/components/typography/Paragraph/Paragraph.jsx




var StyledParagraph = styled_components_browser_esm["default"].p.withConfig({
  displayName: "Paragraph__StyledParagraph",
  componentId: "sc-11f9odm-0"
})(["padding:0;margin:0;border:0 none;", " max-width:", ";", " ", " ", " ", ""], function (_ref) {
  var size = _ref.size;
  return theme["d" /* paragraphStyles */][size];
}, function (props) {
  return props.maxWidth;
}, styled_system["b" /* margin */], styled_system["c" /* textAlign */], styled_system["d" /* textColor */], styled_system["a" /* fontWeight */]);

var Paragraph_Paragraph = function Paragraph(props) {
  return react_default.a.createElement(StyledParagraph, props);
};

Paragraph_Paragraph.defaultProps = {
  size: '200',
  maxWidth: '640px' // reasoning behind this default is at https://www.rover.com/design-system/components/paragraph/guidelines/#content-guidelines

};
/* harmony default export */ var typography_Paragraph_Paragraph = (Paragraph_Paragraph);
// CONCATENATED MODULE: ../react-lib/src/components/typography/Paragraph/index.js

// CONCATENATED MODULE: ../react-lib/src/components/typography/Text/Text.jsx




var StyledText = styled_components_browser_esm["default"].span.withConfig({
  displayName: "Text__StyledText",
  componentId: "yejfl5-0"
})(["padding:0;margin:0;border:0;", " ", " ", " ", " ", " ", " ", ""], function (_ref) {
  var size = _ref.size;
  return theme["f" /* textStyles */][size];
}, styled_system["b" /* margin */], styled_system["c" /* textAlign */], styled_system["d" /* textColor */], styled_system["a" /* fontWeight */], styled_system["f" /* textTransform */], styled_system["e" /* textDecoration */]);

var Text_Text = function Text(props) {
  return react_default.a.createElement(StyledText, props);
};

Text_Text.defaultProps = {
  as: 'span',
  size: '200'
};
/* harmony default export */ var typography_Text_Text = (Text_Text);
// CONCATENATED MODULE: ../react-lib/src/components/typography/Text/index.js

// CONCATENATED MODULE: ../react-lib/src/components/typography/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return typography_Heading_Heading; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return typography_Paragraph_Paragraph; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "c", function() { return typography_Text_Text; });




/***/ }),
/* 316 */,
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../react-lib/src/factories/addressFactory.js
var addressFactory = __webpack_require__(253);

// EXTERNAL MODULE: ../react-lib/src/lib/redux-duck/index.js + 2 modules
var redux_duck = __webpack_require__(21);

// EXTERNAL MODULE: ../utilities/object-utilities.js
var object_utilities = __webpack_require__(22);

// EXTERNAL MODULE: ../utilities/parseApiErrors.js
var parseApiErrors = __webpack_require__(157);

// EXTERNAL MODULE: ../utilities/axiosUtils/index.client.js
var index_client = __webpack_require__(45);

// EXTERNAL MODULE: ../utilities/apiUrl.js
var apiUrl = __webpack_require__(51);

// EXTERNAL MODULE: ../utilities/reportError.js
var reportError = __webpack_require__(34);

// EXTERNAL MODULE: ../react-lib/src/apis/APIError.js
var APIError = __webpack_require__(79);

// CONCATENATED MODULE: ../react-lib/src/apis/address.api.js
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }









var address_api_buildAddressApiUrl = function buildAddressApiUrl(personOpk) {
  return Object(apiUrl["b" /* fullApiUrl */])("people/".concat(personOpk, "/home/"));
};

var get =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(personOpk, expressParams) {
    var ai, response, _response, errors, message, apiError;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            ai = Object(index_client["a" /* getAxiosInstance */])(expressParams);
            _context.prev = 1;
            _context.next = 4;
            return ai.get(address_api_buildAddressApiUrl(personOpk));

          case 4:
            response = _context.sent;
            return _context.abrupt("return", Object(object_utilities["a" /* camelize */])(response.data));

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](1);
            _response = _context.t0.response;

            if (!(_response && _response.status === 404)) {
              _context.next = 13;
              break;
            }

            return _context.abrupt("return", Object(addressFactory["a" /* default */])());

          case 13:
            errors = Object(parseApiErrors["a" /* default */])(_response);
            message = errors.length ? errors.pop() :
            /*i18n*/
            {
              id: "There was an error fetching address."
            };
            apiError = new APIError["a" /* default */](message, _response.status);
            Object(reportError["a" /* default */])(apiError);
            throw apiError;

          case 18:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 8]]);
  }));

  return function get(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var post =
/*#__PURE__*/
function () {
  var _ref2 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee2(personOpk, address, expressParams) {
    var ai, data, response, errors, message, apiError;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            ai = Object(index_client["a" /* getAxiosInstance */])(expressParams);
            _context2.prev = 1;
            data = Object(object_utilities["d" /* snakeify */])(address);
            _context2.next = 5;
            return ai.post(address_api_buildAddressApiUrl(personOpk), data);

          case 5:
            _context2.next = 15;
            break;

          case 7:
            _context2.prev = 7;
            _context2.t0 = _context2["catch"](1);
            response = _context2.t0.response;
            errors = Object(parseApiErrors["a" /* default */])(response);
            message = errors.length ? errors.pop() :
            /*i18n*/
            {
              id: "There was an error saving address."
            };
            apiError = new APIError["a" /* default */](message, response.status);
            Object(reportError["a" /* default */])(apiError);
            throw apiError;

          case 15:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[1, 7]]);
  }));

  return function post(_x3, _x4, _x5) {
    return _ref2.apply(this, arguments);
  };
}();
// CONCATENATED MODULE: ../react-lib/src/redux/ducks/address.duck.js
/* unused harmony export options */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return selectors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return effects; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return reducer; });
function address_duck_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function address_duck__asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { address_duck_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { address_duck_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var options = {
  name: 'address',
  initialState: {
    address: Object(addressFactory["a" /* default */])(),
    errorMessage: '',
    successMessage: '',
    loading: false,
    submitting: false
  },
  actions: {
    fetchAddressPending: function fetchAddressPending() {
      return function (state) {
        return _objectSpread({}, state, {
          loading: true
        });
      };
    },
    fetchAddressSuccess: function fetchAddressSuccess(_ref) {
      var address = _ref.address;
      return function (state) {
        return _objectSpread({}, state, {
          loading: false,
          address: address,
          errorMessage: ''
        });
      };
    },
    fetchAddressFailure: function fetchAddressFailure(_ref2) {
      var message = _ref2.message;
      return function (state) {
        return _objectSpread({}, state, {
          loading: false,
          errorMessage: message
        });
      };
    },
    saveAddressPending: function saveAddressPending() {
      return function (state) {
        return _objectSpread({}, state, {
          submitting: true
        });
      };
    },
    saveAddressSuccess: function saveAddressSuccess(_ref3) {
      var address = _ref3.address;
      return function (state) {
        return _objectSpread({}, state, {
          submitting: false,
          address: address,
          errorMessage: ''
        });
      };
    },
    saveAddressFailure: function saveAddressFailure(_ref4) {
      var message = _ref4.message;
      return function (state) {
        return _objectSpread({}, state, {
          submitting: false,
          errorMessage: message
        });
      };
    },
    resetAddress: function resetAddress(opts) {
      return function (state) {
        return _objectSpread({}, state, {
          address: Object(addressFactory["a" /* default */])(opts)
        });
      };
    }
  },
  effects: {
    fetchAddress: function fetchAddress(personOpk) {
      return (
        /*#__PURE__*/
        function () {
          var _ref6 = address_duck__asyncToGenerator(
          /*#__PURE__*/
          regeneratorRuntime.mark(function _callee(dispatch, getState, duckActions, duckEffects, duckSelectors, _ref5) {
            var expressParams, address;
            return regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    expressParams = _ref5.expressParams;
                    dispatch(duckActions.fetchAddressPending());
                    _context.prev = 2;
                    _context.next = 5;
                    return get(personOpk, expressParams);

                  case 5:
                    address = _context.sent;
                    dispatch(duckActions.fetchAddressSuccess({
                      address: address
                    }));
                    _context.next = 12;
                    break;

                  case 9:
                    _context.prev = 9;
                    _context.t0 = _context["catch"](2);
                    dispatch(duckActions.fetchAddressFailure(_context.t0));

                  case 12:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee, null, [[2, 9]]);
          }));

          return function (_x, _x2, _x3, _x4, _x5, _x6) {
            return _ref6.apply(this, arguments);
          };
        }()
      );
    },
    saveAddress: function saveAddress(_ref7) {
      var personOpk = _ref7.personOpk,
          address = _ref7.address;
      return (
        /*#__PURE__*/
        function () {
          var _ref9 = address_duck__asyncToGenerator(
          /*#__PURE__*/
          regeneratorRuntime.mark(function _callee2(dispatch, getState, duckActions, duckEffects, duckSelectors, _ref8) {
            var expressParams;
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    expressParams = _ref8.expressParams;
                    dispatch(duckActions.saveAddressPending());
                    _context2.prev = 2;
                    _context2.next = 5;
                    return post(personOpk, address, expressParams);

                  case 5:
                    dispatch(duckActions.saveAddressSuccess({
                      address: address
                    }));
                    _context2.next = 12;
                    break;

                  case 8:
                    _context2.prev = 8;
                    _context2.t0 = _context2["catch"](2);
                    dispatch(duckActions.saveAddressFailure(_context2.t0));
                    return _context2.abrupt("return", false);

                  case 12:
                    return _context2.abrupt("return", true);

                  case 13:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2, null, [[2, 8]]);
          }));

          return function (_x7, _x8, _x9, _x10, _x11, _x12) {
            return _ref9.apply(this, arguments);
          };
        }()
      );
    }
  },
  selectors: {
    getAddress: function getAddress(getState, createSelector) {
      return createSelector([getState], function (s) {
        return s.address;
      });
    },
    getAccessToHome: function getAccessToHome(getState, createSelector, duckSelectors) {
      return createSelector([duckSelectors.getAddress], function (address) {
        return address.accessToHome;
      });
    },
    getZip: function getZip(getState, createSelector, duckSelectors) {
      return createSelector([duckSelectors.getAddress], function (address) {
        return address.zip;
      });
    },
    isAddressSubmitting: function isAddressSubmitting(getState, createSelector) {
      return createSelector([getState], function (s) {
        return s.submitting;
      });
    },
    getErrorMessage: function getErrorMessage(getState, createSelector) {
      return createSelector([getState], function (s) {
        return s.errorMessage;
      });
    },
    getLoading: function getLoading(getState, createSelector) {
      return createSelector([getState], function (s) {
        return s.loading;
      });
    }
  }
};

var _ref10 = Object(redux_duck["a" /* createDuck */])(options),
    actions = _ref10.actions,
    selectors = _ref10.selectors,
    effects = _ref10.effects,
    reducer = _ref10.reducer;



/***/ }),
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/react-router-dom/node_modules/warning/warning.js
var warning = __webpack_require__(304);
var warning_default = /*#__PURE__*/__webpack_require__.n(warning);

// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ../node_modules/prop-types/index.js
var prop_types = __webpack_require__(4);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// EXTERNAL MODULE: ../node_modules/history/esm/history.js + 4 modules
var esm_history = __webpack_require__(105);

// EXTERNAL MODULE: ../node_modules/react-router/es/Router.js
var Router = __webpack_require__(222);

// CONCATENATED MODULE: ../node_modules/react-router-dom/es/Router.js
// Written in this round about way for babel-transform-imports


/* harmony default export */ var es_Router = (Router["a" /* default */]);
// CONCATENATED MODULE: ../node_modules/react-router-dom/es/BrowserRouter.js
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter_BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(esm_history["a" /* createBrowserHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    warning_default()(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.");
  };

  BrowserRouter.prototype.render = function render() {
    return react_default.a.createElement(es_Router, { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(react_default.a.Component);

BrowserRouter_BrowserRouter.propTypes = {
  basename: prop_types_default.a.string,
  forceRefresh: prop_types_default.a.bool,
  getUserConfirmation: prop_types_default.a.func,
  keyLength: prop_types_default.a.number,
  children: prop_types_default.a.node
};


/* harmony default export */ var es_BrowserRouter = (BrowserRouter_BrowserRouter);
// CONCATENATED MODULE: ../node_modules/react-router-dom/es/HashRouter.js
function HashRouter__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function HashRouter__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function HashRouter__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter_HashRouter = function (_React$Component) {
  HashRouter__inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    HashRouter__classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = HashRouter__possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(esm_history["b" /* createHashHistory */])(_this.props), _temp), HashRouter__possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    warning_default()(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.");
  };

  HashRouter.prototype.render = function render() {
    return react_default.a.createElement(es_Router, { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(react_default.a.Component);

HashRouter_HashRouter.propTypes = {
  basename: prop_types_default.a.string,
  getUserConfirmation: prop_types_default.a.func,
  hashType: prop_types_default.a.oneOf(["hashbang", "noslash", "slash"]),
  children: prop_types_default.a.node
};


/* harmony default export */ var es_HashRouter = (HashRouter_HashRouter);
// EXTERNAL MODULE: ../node_modules/invariant/browser.js
var browser = __webpack_require__(88);
var browser_default = /*#__PURE__*/__webpack_require__.n(browser);

// CONCATENATED MODULE: ../node_modules/react-router-dom/es/Link.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function Link__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Link__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Link__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link_Link = function (_React$Component) {
  Link__inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    Link__classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = Link__possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore everything but left clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), Link__possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ["replace", "to", "innerRef"]); // eslint-disable-line no-unused-vars

    browser_default()(this.context.router, "You should not use <Link> outside a <Router>");

    browser_default()(to !== undefined, 'You must specify the "to" property');

    var history = this.context.router.history;

    var location = typeof to === "string" ? Object(esm_history["c" /* createLocation */])(to, null, null, history.location) : to;

    var href = history.createHref(location);
    return react_default.a.createElement("a", _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(react_default.a.Component);

Link_Link.propTypes = {
  onClick: prop_types_default.a.func,
  target: prop_types_default.a.string,
  replace: prop_types_default.a.bool,
  to: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.object]).isRequired,
  innerRef: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.func])
};
Link_Link.defaultProps = {
  replace: false
};
Link_Link.contextTypes = {
  router: prop_types_default.a.shape({
    history: prop_types_default.a.shape({
      push: prop_types_default.a.func.isRequired,
      replace: prop_types_default.a.func.isRequired,
      createHref: prop_types_default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ var es_Link = (Link_Link);
// EXTERNAL MODULE: ../node_modules/react-router/es/MemoryRouter.js
var MemoryRouter = __webpack_require__(374);

// CONCATENATED MODULE: ../node_modules/react-router-dom/es/MemoryRouter.js
// Written in this round about way for babel-transform-imports


/* harmony default export */ var es_MemoryRouter = (MemoryRouter["a" /* default */]);
// EXTERNAL MODULE: ../node_modules/react-router/es/Route.js
var Route = __webpack_require__(293);

// CONCATENATED MODULE: ../node_modules/react-router-dom/es/Route.js
// Written in this round about way for babel-transform-imports


/* harmony default export */ var es_Route = (Route["a" /* default */]);
// CONCATENATED MODULE: ../node_modules/react-router-dom/es/NavLink.js
var NavLink__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function NavLink__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink_NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref["aria-current"],
      rest = NavLink__objectWithoutProperties(_ref, ["to", "exact", "strict", "location", "activeClassName", "className", "activeStyle", "style", "isActive", "aria-current"]);

  var path = (typeof to === "undefined" ? "undefined" : _typeof(to)) === "object" ? to.pathname : to;

  // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
  var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");

  return react_default.a.createElement(es_Route, {
    path: escapedPath,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return react_default.a.createElement(es_Link, NavLink__extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(" ") : className,
        style: isActive ? NavLink__extends({}, style, activeStyle) : style,
        "aria-current": isActive && ariaCurrent || null
      }, rest));
    }
  });
};

NavLink_NavLink.propTypes = {
  to: es_Link.propTypes.to,
  exact: prop_types_default.a.bool,
  strict: prop_types_default.a.bool,
  location: prop_types_default.a.object,
  activeClassName: prop_types_default.a.string,
  className: prop_types_default.a.string,
  activeStyle: prop_types_default.a.object,
  style: prop_types_default.a.object,
  isActive: prop_types_default.a.func,
  "aria-current": prop_types_default.a.oneOf(["page", "step", "location", "date", "time", "true"])
};

NavLink_NavLink.defaultProps = {
  activeClassName: "active",
  "aria-current": "page"
};

/* harmony default export */ var es_NavLink = (NavLink_NavLink);
// EXTERNAL MODULE: ../node_modules/react-router/es/Prompt.js
var Prompt = __webpack_require__(375);

// CONCATENATED MODULE: ../node_modules/react-router-dom/es/Prompt.js
// Written in this round about way for babel-transform-imports


/* harmony default export */ var es_Prompt = (Prompt["a" /* default */]);
// EXTERNAL MODULE: ../node_modules/react-router/es/Redirect.js
var Redirect = __webpack_require__(376);

// CONCATENATED MODULE: ../node_modules/react-router-dom/es/Redirect.js
// Written in this round about way for babel-transform-imports


/* harmony default export */ var es_Redirect = (Redirect["a" /* default */]);
// EXTERNAL MODULE: ../node_modules/react-router/es/StaticRouter.js
var StaticRouter = __webpack_require__(377);

// CONCATENATED MODULE: ../node_modules/react-router-dom/es/StaticRouter.js
// Written in this round about way for babel-transform-imports


/* harmony default export */ var es_StaticRouter = (StaticRouter["a" /* default */]);
// EXTERNAL MODULE: ../node_modules/react-router/es/Switch.js
var Switch = __webpack_require__(378);

// CONCATENATED MODULE: ../node_modules/react-router-dom/es/Switch.js
// Written in this round about way for babel-transform-imports


/* harmony default export */ var es_Switch = (Switch["a" /* default */]);
// EXTERNAL MODULE: ../node_modules/react-router/es/generatePath.js
var generatePath = __webpack_require__(295);

// CONCATENATED MODULE: ../node_modules/react-router-dom/es/generatePath.js
// Written in this round about way for babel-transform-imports


/* harmony default export */ var es_generatePath = (generatePath["a" /* default */]);
// EXTERNAL MODULE: ../node_modules/react-router/es/matchPath.js
var matchPath = __webpack_require__(223);

// CONCATENATED MODULE: ../node_modules/react-router-dom/es/matchPath.js
// Written in this round about way for babel-transform-imports


/* harmony default export */ var es_matchPath = (matchPath["a" /* default */]);
// EXTERNAL MODULE: ../node_modules/react-router/es/withRouter.js
var withRouter = __webpack_require__(379);

// CONCATENATED MODULE: ../node_modules/react-router-dom/es/withRouter.js
// Written in this round about way for babel-transform-imports


/* harmony default export */ var es_withRouter = (withRouter["a" /* default */]);
// CONCATENATED MODULE: ../node_modules/react-router-dom/es/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return es_BrowserRouter; });
/* unused concated harmony import HashRouter */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return es_HashRouter; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return es_Link; });
/* unused concated harmony import MemoryRouter */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return es_MemoryRouter; });
/* unused concated harmony import NavLink */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return es_NavLink; });
/* unused concated harmony import Prompt */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return es_Prompt; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "c", function() { return es_Redirect; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "d", function() { return es_Route; });
/* unused concated harmony import Router */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return es_Router; });
/* unused concated harmony import StaticRouter */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return es_StaticRouter; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "e", function() { return es_Switch; });
/* unused concated harmony import generatePath */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return es_generatePath; });
/* unused concated harmony import matchPath */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return es_matchPath; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "f", function() { return es_withRouter; });





























/***/ }),
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export StyledSelect */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Select; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lingui_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lingui_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__lingui_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_sensitiveData_constants__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_LabelAndErrorFormGroup__ = __webpack_require__(77);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }








var PLACEHOLDER_VALUE = 'placeholder';

var renderPlaceholder = function renderPlaceholder(placeholder) {
  if (placeholder) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option", {
      disabled: true,
      value: PLACEHOLDER_VALUE
    }, placeholder);
  }

  return null;
};

var StyledSelect = __WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].select.withConfig({
  displayName: "Select__StyledSelect",
  componentId: "sc-4fop9h-0"
})(["background-color:", ";background-image:none;border-radius:", ";border:1px solid ", ";color:", ";display:block;font-family:", ";font-size:", ";height:40px;line-height:1.6;padding:", " ", " ", " ", ";transition:border-color 0.15s ease-in-out,box-shadow 0.15s ease-in-out;width:100%;box-shadow:none;&:disabled{border:1px solid ", ";background-color:", ";color:", ";cursor:not-allowed;opacity:1;}"], __WEBPACK_IMPORTED_MODULE_4__styles__["d" /* DSToken */].BACKGROUND_COLOR_PRIMARY, __WEBPACK_IMPORTED_MODULE_4__styles__["d" /* DSToken */].BORDER_RADIUS, __WEBPACK_IMPORTED_MODULE_4__styles__["d" /* DSToken */].BORDER_COLOR_PRIMARY, __WEBPACK_IMPORTED_MODULE_4__styles__["d" /* DSToken */].TEXT_COLOR_SECONDARY, __WEBPACK_IMPORTED_MODULE_4__styles__["e" /* FONT_FAMILY */], __WEBPACK_IMPORTED_MODULE_4__styles__["g" /* FontSize */].M, __WEBPACK_IMPORTED_MODULE_4__styles__["k" /* Spacing */].S, __WEBPACK_IMPORTED_MODULE_4__styles__["k" /* Spacing */].M, __WEBPACK_IMPORTED_MODULE_4__styles__["k" /* Spacing */].S, __WEBPACK_IMPORTED_MODULE_4__styles__["k" /* Spacing */].XS, __WEBPACK_IMPORTED_MODULE_4__styles__["d" /* DSToken */].INTERACTIVE_BORDER_COLOR_DISABLED, __WEBPACK_IMPORTED_MODULE_4__styles__["d" /* DSToken */].INTERACTIVE_BACKGROUND_COLOR_DISABLED, __WEBPACK_IMPORTED_MODULE_4__styles__["d" /* DSToken */].TEXT_COLOR_TERTIARY);

var Select = function Select(_ref) {
  var value = _ref.value,
      options = _ref.options,
      placeholder = _ref.placeholder,
      _onChange = _ref.onChange,
      className = _ref.className,
      sensitive = _ref.sensitive,
      other = _objectWithoutProperties(_ref, ["value", "options", "placeholder", "onChange", "className", "sensitive"]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__lingui_react__["I18n"], null, function (_ref2) {
    var i18n = _ref2.i18n;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StyledSelect, _extends({
      className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(className, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_5__constants_sensitiveData_constants__["a" /* SENSITIVE_DATA_CLASS */], sensitive)),
      value: value || PLACEHOLDER_VALUE,
      onChange: function onChange(e) {
        return _onChange(e.target.value);
      }
    }, other), renderPlaceholder(placeholder), options.map(function (option) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option", {
        value: option.value,
        key: option.value,
        disabled: typeof option.disabled === 'boolean' ? option.disabled : false
      }, i18n._(option.title));
    }));
  });
};

Select.defaultProps = {
  value: '',
  placeholder: '',
  className: '',
  sensitive: false
};

/* harmony default export */ __webpack_exports__["b"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__utils_LabelAndErrorFormGroup__["b" /* default */], _extends({}, props, {
    InputComponent: Select
  }));
});

/***/ }),
/* 350 */,
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PET_DEFAULTS */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_uuid__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_uuid__);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var PET_DEFAULTS = {
  pk: '',
  url: '',
  name: '',
  weight: '',
  breeds: [],
  ageYears: '',
  ageMonths: '',
  gender: '',
  isPuppy: false,
  defaultImage: {
    bigThumb: 'https://www.rover.com/static/images/profilable/defaults/big_thumb.png'
  },
  petType: 'dog',
  weightObj: [],
  owner: '',
  webUrl: '',
  urls: {
    images: ''
  },
  active: true,
  dogSize: '',
  careInstructions: '',
  veterinaryInformation: '',
  emergencyContactInformation: '',
  birthday: '',
  birthdayDisplay: '',
  implant: null,
  spayedNeutered: null,
  description: null,
  specialRequirements: null,
  houseTrained: null,
  houseTrainedDesc: null,
  playsChildren: null,
  playsChildrenDesc: null,
  playsDogs: null,
  playsDogsDesc: null,
  playsCats: null,
  playsCatsDesc: null,
  notes: null,
  petDetails: []
};
/* harmony default export */ __webpack_exports__["a"] = (function () {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _objectSpread({}, PET_DEFAULTS, {
    id: __WEBPACK_IMPORTED_MODULE_0_uuid___default.a.v4()
  }, opts);
});

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.elementContextTypes = exports.injectContextTypes = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Provider = __webpack_require__(381);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var injectContextTypes = exports.injectContextTypes = {
  getRegisteredElements: _propTypes2.default.func.isRequired
};

var elementContextTypes = exports.elementContextTypes = {
  addElementsLoadListener: _propTypes2.default.func.isRequired,
  registerElement: _propTypes2.default.func.isRequired,
  unregisterElement: _propTypes2.default.func.isRequired
};

var Elements = function (_React$Component) {
  _inherits(Elements, _React$Component);

  function Elements(props, context) {
    _classCallCheck(this, Elements);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.handleRegisterElement = function (element, impliedTokenType, impliedSourceType) {
      _this.setState(function (prevState) {
        return {
          registeredElements: [].concat(_toConsumableArray(prevState.registeredElements), [_extends({
            element: element
          }, impliedTokenType ? { impliedTokenType: impliedTokenType } : {}, impliedSourceType ? { impliedSourceType: impliedSourceType } : {})])
        };
      });
    };

    _this.handleUnregisterElement = function (el) {
      _this.setState(function (prevState) {
        return {
          registeredElements: prevState.registeredElements.filter(function (_ref) {
            var element = _ref.element;
            return element !== el;
          })
        };
      });
    };

    _this.state = {
      registeredElements: []
    };
    return _this;
  }

  Elements.prototype.getChildContext = function getChildContext() {
    var _this2 = this;

    return {
      addElementsLoadListener: function addElementsLoadListener(fn) {
        // Return the existing elements instance if we already have one.
        if (_this2._elements) {
          fn(_this2._elements);
          return;
        }

        var _props = _this2.props,
            children = _props.children,
            options = _objectWithoutProperties(_props, ['children']);

        if (_this2.context.tag === 'sync') {
          _this2._elements = _this2.context.stripe.elements(options);
          fn(_this2._elements);
        } else {
          _this2.context.addStripeLoadListener(function (stripe) {
            if (_this2._elements) {
              fn(_this2._elements);
            } else {
              _this2._elements = stripe.elements(options);
              fn(_this2._elements);
            }
          });
        }
      },
      registerElement: this.handleRegisterElement,
      unregisterElement: this.handleUnregisterElement,
      getRegisteredElements: function getRegisteredElements() {
        return _this2.state.registeredElements;
      }
    };
  };

  Elements.prototype.render = function render() {
    return _react2.default.Children.only(this.props.children);
  };

  return Elements;
}(_react2.default.Component);

Elements.childContextTypes = _extends({}, injectContextTypes, elementContextTypes);
Elements.contextTypes = _Provider.providerContextTypes;
Elements.defaultProps = {
  children: null
};
exports.default = Elements;

/***/ }),
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCityZipAddressLine; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isStateRequired; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isValidAddress; });
var getCityZipAddressLine = function getCityZipAddressLine(address) {
  return "".concat(address.city, ", ").concat(address.state, " ").concat(address.zip, ", ").concat(address.countryCode);
};
var isStateRequired = function isStateRequired(countryCode) {
  return countryCode === 'US' || countryCode === 'CA';
};
var isValidAddress = function isValidAddress(address) {
  return !!(address && address.city && (isStateRequired(address.countryCode) && address.state || !isStateRequired(address.countryCode)) && address.addressLine1 && address.zip);
};

/***/ }),
/* 359 */,
/* 360 */,
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(571);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BILLING_ADDRESS_FIELDS; });
/* unused harmony export PAGE_NAMES */
/* unused harmony export PAGE_CHANGE_SIGNALS */
/* unused harmony export ERROR_MESSAGES */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CARD_TYPES; });
var BILLING_ADDRESS_FIELDS = ['address_line1', 'address_line2', 'city', 'state', 'zip'];
var PAGE_NAMES = {
  ADD_CARD: 'addCardPage',
  ADD_ADDRESS: 'addAddressPage',
  SELECT_CARD: 'selectCardPage'
};
var PAGE_CHANGE_SIGNALS = {
  CARD_FORM_SUBMITTED: 'cardFormSubmitted',
  ADDRESS_FORM_SUBMITTED: 'addressFormSubmitted',
  SHOW_ADD_CARD_SCREEN: 'showAddCardScreen',
  CANCEL_ADD_CARD: 'cancelAddCard',
  CARD_SUBMISSION_ERROR: 'cardSubmissionError'
};
var ERROR_MESSAGES = {
  DEFAULT_PAYMENT_METHOD: 'You cannot remove your default payment method.',
  LAST_PAYMENT_METHOD: 'You cannot remove your last payment method.'
};
var amex = {
  id: 'amex',
  display: 'AmEx',
  "long": 'American Express'
};
var visa = {
  id: 'visa',
  display: 'Visa',
  "long": 'Visa'
};
var mastercard = {
  id: 'mastercard',
  display: 'MasterCard',
  "long": 'MasterCard'
};
var discover = {
  id: 'discover',
  display: 'Discover',
  "long": 'Discover'
};
var CARD_TYPES = {
  visa: visa,
  mastercard: mastercard,
  'master-card': mastercard,
  discover: discover,
  amex: amex,
  'american express': amex,
  'american-express': amex
};
/* unused harmony default export */ var _unused_webpack_default_export = ({
  BILLING_ADDRESS_FIELDS: BILLING_ADDRESS_FIELDS,
  PAGE_NAMES: PAGE_NAMES,
  PAGE_CHANGE_SIGNALS: PAGE_CHANGE_SIGNALS,
  ERROR_MESSAGES: ERROR_MESSAGES,
  CARD_TYPES: CARD_TYPES
});

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Select__ = __webpack_require__(349);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Select__["b"]; });


/***/ }),
/* 364 */,
/* 365 */,
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../react-lib/src/lib/redux-duck/index.js + 2 modules
var redux_duck = __webpack_require__(21);

// EXTERNAL MODULE: ../node_modules/axios/index.js
var axios = __webpack_require__(87);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// EXTERNAL MODULE: ../utilities/injector.js
var injector = __webpack_require__(43);

// EXTERNAL MODULE: ../utilities/object-utilities.js
var object_utilities = __webpack_require__(22);

// EXTERNAL MODULE: ../react-lib/src/constants/creditCard.constants.js
var creditCard_constants = __webpack_require__(362);

// EXTERNAL MODULE: ../react-lib/src/apis/DefaultAPIErrorHandler.js
var DefaultAPIErrorHandler = __webpack_require__(30);

// CONCATENATED MODULE: ../react-lib/src/apis/creditCards.api.js
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }






var creditCards_api_formatBilling = function formatBilling(data) {
  var snakeData = Object(object_utilities["d" /* snakeify */])(data, true);
  var fields = {
    billing_address: {},
    postal_code: snakeData.zip,
    country_code: snakeData.country_code
  };
  Object.keys(snakeData).forEach(function (key) {
    if (!creditCard_constants["a" /* BILLING_ADDRESS_FIELDS */].includes(key)) {
      fields[key] = snakeData[key];
    }
  });
  creditCard_constants["a" /* BILLING_ADDRESS_FIELDS */].forEach(function (f) {
    fields.billing_address[f] = snakeData[f] || '';
  });
  return fields;
};
var getCards =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee() {
    var paymentMethods, response;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            paymentMethods = Object(injector["a" /* default */])('Rover.urls.paymentMethods');
            _context.next = 4;
            return axios_default.a.get(paymentMethods);

          case 4:
            response = _context.sent;
            return _context.abrupt("return", Object(object_utilities["a" /* camelize */])(response.data, true).filter(function (i) {
              return i.type === 'creditcard';
            }));

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](0);
            throw Object(DefaultAPIErrorHandler["a" /* default */])(_context.t0,
            /*i18n*/
            {
              id: "There was an error fetching credit cards."
            });

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 8]]);
  }));

  return function getCards() {
    return _ref.apply(this, arguments);
  };
}();
var getCard =
/*#__PURE__*/
function () {
  var _ref2 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee2(cardUrl) {
    var response;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return axios_default.a.get(cardUrl);

          case 3:
            response = _context2.sent;
            return _context2.abrupt("return", Object(object_utilities["a" /* camelize */])(response.data, true));

          case 7:
            _context2.prev = 7;
            _context2.t0 = _context2["catch"](0);
            throw Object(DefaultAPIErrorHandler["a" /* default */])(_context2.t0, 'There was an error fetching a credit card.');

          case 10:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 7]]);
  }));

  return function getCard(_x) {
    return _ref2.apply(this, arguments);
  };
}();
var setDefaultCard =
/*#__PURE__*/
function () {
  var _ref3 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee3(cardUrl) {
    var defaultPaymentUrl, response;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            defaultPaymentUrl = Object(injector["a" /* default */])('Rover.urls.defaultPaymentUrl');
            _context3.next = 4;
            return axios_default.a.put(defaultPaymentUrl, {
              url: cardUrl
            });

          case 4:
            response = _context3.sent;
            return _context3.abrupt("return", Object(object_utilities["a" /* camelize */])(response.data, true));

          case 8:
            _context3.prev = 8;
            _context3.t0 = _context3["catch"](0);
            throw Object(DefaultAPIErrorHandler["a" /* default */])(_context3.t0,
            /*i18n*/
            {
              id: "There was an error setting the default credit card."
            });

          case 11:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[0, 8]]);
  }));

  return function setDefaultCard(_x2) {
    return _ref3.apply(this, arguments);
  };
}();
var removeCard =
/*#__PURE__*/
function () {
  var _ref4 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee4(cardUrl) {
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            _context4.next = 3;
            return axios_default.a["delete"](cardUrl);

          case 3:
            _context4.next = 8;
            break;

          case 5:
            _context4.prev = 5;
            _context4.t0 = _context4["catch"](0);
            throw Object(DefaultAPIErrorHandler["a" /* default */])(_context4.t0,
            /*i18n*/
            {
              id: "There was an error removing a credit card."
            });

          case 8:
            return _context4.abrupt("return", true);

          case 9:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[0, 5]]);
  }));

  return function removeCard(_x3) {
    return _ref4.apply(this, arguments);
  };
}();
var saveCard =
/*#__PURE__*/
function () {
  var _ref5 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee5(body) {
    var addCreditCardMethod, creditCard, address, other, flattenedData, formattedData, response, _response$data, isSuccess, errorMessage, url;

    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            if (body.formVersion === 'braintree' || body.formVersion === 'stripe') {
              _context5.next = 2;
              break;
            }

            throw Object(DefaultAPIErrorHandler["a" /* default */])({
              response: {
                status: 400,
                response: {
                  some_error: ''
                }
              }
            },
            /*i18n*/
            {
              id: "There was an error saving a credit card."
            });

          case 2:
            _context5.prev = 2;
            addCreditCardMethod = Object(injector["a" /* default */])('Rover.urls.addCreditCardMethod');
            creditCard = body.creditCard, address = body.address, other = _objectWithoutProperties(body, ["creditCard", "address"]);
            flattenedData = _objectSpread({}, creditCard, {}, address, {}, other);
            formattedData = creditCards_api_formatBilling(flattenedData); // the API will throw error if nonce and postal_code both exist in the same payload

            delete formattedData.postal_code;
            _context5.next = 10;
            return axios_default.a.post(addCreditCardMethod, formattedData);

          case 10:
            response = _context5.sent;
            _response$data = response.data, isSuccess = _response$data.is_success, errorMessage = _response$data.error_status, url = _response$data.url;

            if (isSuccess) {
              _context5.next = 14;
              break;
            }

            throw Error(errorMessage);

          case 14:
            return _context5.abrupt("return", url);

          case 17:
            _context5.prev = 17;
            _context5.t0 = _context5["catch"](2);

            if (!_context5.t0.response) {
              _context5.next = 23;
              break;
            }

            throw Object(DefaultAPIErrorHandler["a" /* default */])(_context5.t0,
            /*i18n*/
            {
              id: "There was an error saving a credit card."
            });

          case 23:
            throw _context5.t0;

          case 24:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[2, 17]]);
  }));

  return function saveCard(_x4) {
    return _ref5.apply(this, arguments);
  };
}();
// CONCATENATED MODULE: ../react-lib/src/redux/ducks/creditCards.duck.js
/* unused harmony export options */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return selectors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return effects; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return reducer; });
function creditCards_duck_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function creditCards_duck__asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { creditCards_duck_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { creditCards_duck_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function creditCards_duck_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function creditCards_duck__objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { creditCards_duck_ownKeys(source, true).forEach(function (key) { creditCards_duck__defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { creditCards_duck_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function creditCards_duck__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var options = {
  name: 'creditCards',
  initialState: {
    cards: [],
    errorMessage: '',
    loading: false
  },
  actions: {
    creditCardsPending: function creditCardsPending() {
      return function (state) {
        return creditCards_duck__objectSpread({}, state, {
          loading: true,
          errorMessage: ''
        });
      };
    },
    creditCardsFailure: function creditCardsFailure(_ref) {
      var errorMessage = _ref.errorMessage;
      return function (state) {
        return creditCards_duck__objectSpread({}, state, {
          loading: false,
          errorMessage: errorMessage
        });
      };
    },
    fetchCreditCardsSuccess: function fetchCreditCardsSuccess(_ref2) {
      var cards = _ref2.cards;
      return function (state) {
        return creditCards_duck__objectSpread({}, state, {
          cards: cards,
          errorMessage: '',
          loading: false
        });
      };
    },
    fetchCreditCardSuccess: function fetchCreditCardSuccess(_ref3) {
      var creditCard = _ref3.creditCard;
      return function (state) {
        return creditCards_duck__objectSpread({}, state, {
          cards: [].concat(_toConsumableArray(state.cards.filter(function (c) {
            return c.url !== creditCard.url;
          })), [creditCard]),
          errorMessage: '',
          loading: false
        });
      };
    },
    setDefaultCreditCardSuccess: function setDefaultCreditCardSuccess(_ref4) {
      var creditCard = _ref4.creditCard;
      return function (state) {
        return creditCards_duck__objectSpread({}, state, {
          cards: _toConsumableArray(state.cards.map(function (c) {
            return creditCards_duck__objectSpread({}, c, {
              defaultPayment: c.url === creditCard.url
            });
          })),
          errorMessage: '',
          loading: false
        });
      };
    },
    removeCreditCardSuccess: function removeCreditCardSuccess(_ref5) {
      var cardUrl = _ref5.cardUrl;
      return function (state) {
        return creditCards_duck__objectSpread({}, state, {
          cards: state.cards.filter(function (card) {
            return card.url !== cardUrl;
          }),
          errorMessage: '',
          loading: false
        });
      };
    },
    saveCreditCardSuccess: function saveCreditCardSuccess() {
      return function (state) {
        return creditCards_duck__objectSpread({}, state, {
          errorMessage: '',
          loading: false
        });
      };
    }
  },
  effects: {
    fetchCreditCards: function fetchCreditCards() {
      return (
        /*#__PURE__*/
        function () {
          var _ref7 = creditCards_duck__asyncToGenerator(
          /*#__PURE__*/
          regeneratorRuntime.mark(function _callee(dispatch, getState, _ref6) {
            var creditCardsPending, creditCardsFailure, fetchCreditCardsSuccess, cards;
            return regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    creditCardsPending = _ref6.creditCardsPending, creditCardsFailure = _ref6.creditCardsFailure, fetchCreditCardsSuccess = _ref6.fetchCreditCardsSuccess;
                    dispatch(creditCardsPending());
                    _context.prev = 2;
                    _context.next = 5;
                    return getCards();

                  case 5:
                    cards = _context.sent;
                    dispatch(fetchCreditCardsSuccess({
                      cards: cards
                    }));
                    _context.next = 13;
                    break;

                  case 9:
                    _context.prev = 9;
                    _context.t0 = _context["catch"](2);
                    dispatch(creditCardsFailure({
                      errorMessage: _context.t0.message
                    }));
                    return _context.abrupt("return", false);

                  case 13:
                    return _context.abrupt("return", true);

                  case 14:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee, null, [[2, 9]]);
          }));

          return function (_x, _x2, _x3) {
            return _ref7.apply(this, arguments);
          };
        }()
      );
    },
    fetchCreditCard: function fetchCreditCard(cardUrl) {
      return (
        /*#__PURE__*/
        function () {
          var _ref9 = creditCards_duck__asyncToGenerator(
          /*#__PURE__*/
          regeneratorRuntime.mark(function _callee2(dispatch, getState, _ref8) {
            var creditCardsPending, creditCardsFailure, fetchCreditCardSuccess, creditCard;
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    creditCardsPending = _ref8.creditCardsPending, creditCardsFailure = _ref8.creditCardsFailure, fetchCreditCardSuccess = _ref8.fetchCreditCardSuccess;
                    dispatch(creditCardsPending());
                    _context2.prev = 2;
                    _context2.next = 5;
                    return getCard(cardUrl);

                  case 5:
                    creditCard = _context2.sent;
                    dispatch(fetchCreditCardSuccess({
                      creditCard: creditCard
                    }));
                    _context2.next = 13;
                    break;

                  case 9:
                    _context2.prev = 9;
                    _context2.t0 = _context2["catch"](2);
                    dispatch(creditCardsFailure({
                      errorMessage: _context2.t0.message
                    }));
                    return _context2.abrupt("return", false);

                  case 13:
                    return _context2.abrupt("return", true);

                  case 14:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2, null, [[2, 9]]);
          }));

          return function (_x4, _x5, _x6) {
            return _ref9.apply(this, arguments);
          };
        }()
      );
    },
    setDefaultCreditCard: function setDefaultCreditCard(cardUrl) {
      return (
        /*#__PURE__*/
        function () {
          var _ref11 = creditCards_duck__asyncToGenerator(
          /*#__PURE__*/
          regeneratorRuntime.mark(function _callee3(dispatch, getState, _ref10) {
            var creditCardsPending, creditCardsFailure, setDefaultCreditCardSuccess, creditCard;
            return regeneratorRuntime.wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    creditCardsPending = _ref10.creditCardsPending, creditCardsFailure = _ref10.creditCardsFailure, setDefaultCreditCardSuccess = _ref10.setDefaultCreditCardSuccess;
                    dispatch(creditCardsPending());
                    _context3.prev = 2;
                    _context3.next = 5;
                    return setDefaultCard(cardUrl);

                  case 5:
                    creditCard = _context3.sent;
                    dispatch(setDefaultCreditCardSuccess({
                      creditCard: creditCard
                    }));
                    _context3.next = 13;
                    break;

                  case 9:
                    _context3.prev = 9;
                    _context3.t0 = _context3["catch"](2);
                    dispatch(creditCardsFailure({
                      errorMessage: _context3.t0.message
                    }));
                    return _context3.abrupt("return", false);

                  case 13:
                    return _context3.abrupt("return", true);

                  case 14:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee3, null, [[2, 9]]);
          }));

          return function (_x7, _x8, _x9) {
            return _ref11.apply(this, arguments);
          };
        }()
      );
    },
    removeCreditCard: function removeCreditCard(cardUrl) {
      return (
        /*#__PURE__*/
        function () {
          var _ref14 = creditCards_duck__asyncToGenerator(
          /*#__PURE__*/
          regeneratorRuntime.mark(function _callee4(dispatch, getState, _ref12, _ref13) {
            var creditCardsPending, creditCardsFailure, removeCreditCardSuccess, fetchCreditCards;
            return regeneratorRuntime.wrap(function _callee4$(_context4) {
              while (1) {
                switch (_context4.prev = _context4.next) {
                  case 0:
                    creditCardsPending = _ref12.creditCardsPending, creditCardsFailure = _ref12.creditCardsFailure, removeCreditCardSuccess = _ref12.removeCreditCardSuccess;
                    fetchCreditCards = _ref13.fetchCreditCards;
                    dispatch(creditCardsPending());
                    _context4.prev = 3;
                    _context4.next = 6;
                    return removeCard(cardUrl);

                  case 6:
                    dispatch(removeCreditCardSuccess({
                      cardUrl: cardUrl
                    }));
                    dispatch(fetchCreditCards());
                    _context4.next = 13;
                    break;

                  case 10:
                    _context4.prev = 10;
                    _context4.t0 = _context4["catch"](3);
                    dispatch(creditCardsFailure({
                      errorMessage: _context4.t0.message
                    }));

                  case 13:
                  case "end":
                    return _context4.stop();
                }
              }
            }, _callee4, null, [[3, 10]]);
          }));

          return function (_x10, _x11, _x12, _x13) {
            return _ref14.apply(this, arguments);
          };
        }()
      );
    },
    saveCreditCard: function saveCreditCard(data) {
      return (
        /*#__PURE__*/
        function () {
          var _ref18 = creditCards_duck__asyncToGenerator(
          /*#__PURE__*/
          regeneratorRuntime.mark(function _callee5(dispatch, getState, _ref15, _ref16, _ref17) {
            var creditCardsPending, creditCardsFailure, saveCreditCardSuccess, fetchCreditCards, getLoading;
            return regeneratorRuntime.wrap(function _callee5$(_context5) {
              while (1) {
                switch (_context5.prev = _context5.next) {
                  case 0:
                    creditCardsPending = _ref15.creditCardsPending, creditCardsFailure = _ref15.creditCardsFailure, saveCreditCardSuccess = _ref15.saveCreditCardSuccess;
                    fetchCreditCards = _ref16.fetchCreditCards;
                    getLoading = _ref17.getLoading;

                    if (!getLoading(getState())) {
                      _context5.next = 5;
                      break;
                    }

                    return _context5.abrupt("return", false);

                  case 5:
                    dispatch(creditCardsPending());
                    _context5.prev = 6;
                    _context5.next = 9;
                    return saveCard(data);

                  case 9:
                    _context5.next = 11;
                    return dispatch(fetchCreditCards());

                  case 11:
                    dispatch(saveCreditCardSuccess());
                    _context5.next = 18;
                    break;

                  case 14:
                    _context5.prev = 14;
                    _context5.t0 = _context5["catch"](6);
                    dispatch(creditCardsFailure({
                      errorMessage: _context5.t0.message
                    }));
                    return _context5.abrupt("return", false);

                  case 18:
                    return _context5.abrupt("return", true);

                  case 19:
                  case "end":
                    return _context5.stop();
                }
              }
            }, _callee5, null, [[6, 14]]);
          }));

          return function (_x14, _x15, _x16, _x17, _x18) {
            return _ref18.apply(this, arguments);
          };
        }()
      );
    }
  },
  selectors: {
    getCreditCards: function getCreditCards(getState, createSelector) {
      return createSelector([getState], function (s) {
        var NOW = new Date();
        var curMonth = NOW.getMonth() + 1;
        var curYear = NOW.getFullYear();
        return s.cards.filter(function (card) {
          var cardYear = parseInt(card.expirationYear, 10);
          var cardMonth = parseInt(card.expirationMonth, 10);

          if (cardYear < curYear) {
            return false;
          }

          if (cardYear === curYear && cardMonth < curMonth) {
            return false;
          }

          return true;
        });
      });
    },
    getDefaultCreditCard: function getDefaultCreditCard(getState, createSelector, _ref19) {
      var getCreditCards = _ref19.getCreditCards;
      return createSelector([getCreditCards], function (cards) {
        return cards.find(function (c) {
          return c.defaultPayment;
        }) || cards[0];
      });
    },
    getDefaultCreditCardId: function getDefaultCreditCardId(getState, createSelector, _ref20) {
      var getDefaultCreditCard = _ref20.getDefaultCreditCard;
      return createSelector([getDefaultCreditCard], function (defaultCard) {
        return defaultCard ? defaultCard.url : '';
      });
    },
    getErrorMessage: function getErrorMessage(getState, createSelector) {
      return createSelector([getState], function (s) {
        return s.errorMessage;
      });
    },
    getLoading: function getLoading(getState, createSelector) {
      return createSelector([getState], function (s) {
        return s.loading;
      });
    }
  }
};

var _ref21 = Object(redux_duck["a" /* createDuck */])(options),
    actions = _ref21.actions,
    selectors = _ref21.selectors,
    effects = _ref21.effects,
    reducer = _ref21.reducer;



/***/ }),
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export options */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return selectors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return effects; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_get__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_redux_duck__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__factories_petFactory__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rover_utilities_object_utilities__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_pets__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__countryConfiguration_duck__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__personSummary_duck__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__apis_pet_api__ = __webpack_require__(523);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }










var convertWeight = function convertWeight(weightUnit) {
  return function (pet) {
    var weight = pet.weight;
    var unit = 'lbs';
    var weightObj = pet.weightObj.find(function (item) {
      return item.unit === weightUnit;
    });
    weight = weightObj ? parseInt(weightObj.value, 10) : pet.weight;
    unit = weightObj ? weightObj.unit : 'lbs';
    return _objectSpread({}, pet, {
      weight: weight,
      unit: unit
    });
  };
};

var createInitialState = function createInitialState() {
  return {
    pets: [],
    petInformation: Object(__WEBPACK_IMPORTED_MODULE_2__factories_petFactory__["a" /* default */])(),
    petImages: {
      count: 0,
      images: [],
      next: null
    },
    isLoading: false,
    isSaving: false,
    isDeletingImages: false,
    isLoadingImages: false,
    submittingCount: 0,
    errorMessage: '',
    savePetErrorMessage: '',
    petDetailsOptions: [],
    isLoadingOptions: false
  };
};

var options = {
  name: 'pets',
  initialState: createInitialState(),
  actions: {
    fetchPetsPending: function fetchPetsPending() {
      return function (state) {
        return _objectSpread({}, state, {
          isLoading: true
        });
      };
    },
    fetchPetsSuccess: function fetchPetsSuccess(pets) {
      return function (state) {
        return _objectSpread({}, state, {
          pets: pets,
          isLoading: false,
          errorMessage: ''
        });
      };
    },
    fetchPetsFailure: function fetchPetsFailure(errorMessage) {
      return function (state) {
        return _objectSpread({}, state, {
          isLoading: false,
          errorMessage: errorMessage
        });
      };
    },
    savePetPending: function savePetPending() {
      return function (state) {
        return _objectSpread({}, state, {
          submittingCount: state.submittingCount + 1,
          isSaving: true
        });
      };
    },
    savePetSuccess: function savePetSuccess(savedPet) {
      return function (state) {
        var existingPet = state.pets.find(function (pet) {
          return pet.url === savedPet.url;
        });
        var updatedPets = existingPet ? state.pets.map(function (pet) {
          return pet.url === savedPet.url ? savedPet : pet;
        }) : [].concat(_toConsumableArray(state.pets), [savedPet]);
        return _objectSpread({}, state, {
          submittingCount: state.submittingCount - 1,
          pets: updatedPets,
          savePetErrorMessage: '',
          isSaving: false
        });
      };
    },
    savePetFailure: function savePetFailure(message) {
      return function (state) {
        return _objectSpread({}, state, {
          submittingCount: state.submittingCount - 1,
          savePetErrorMessage: message,
          isSaving: false
        });
      };
    },
    fetchPetInformationPending: function fetchPetInformationPending() {
      return function (state) {
        return _objectSpread({}, state, {
          isLoading: true
        });
      };
    },
    fetchPetInformationSuccess: function fetchPetInformationSuccess(petInformation) {
      return function (state) {
        return _objectSpread({}, state, {
          petInformation: petInformation,
          isLoading: false,
          errorMessage: ''
        });
      };
    },
    fetchPetInformationFailure: function fetchPetInformationFailure(errorMessage) {
      return function (state) {
        return _objectSpread({}, state, {
          isLoading: false,
          errorMessage: errorMessage
        });
      };
    },
    fetchPetImagesPending: function fetchPetImagesPending() {
      return function (state) {
        return _objectSpread({}, state, {
          isLoadingImages: true
        });
      };
    },
    fetchPetImagesSuccess: function fetchPetImagesSuccess(_ref) {
      var results = _ref.results,
          previous = _ref.previous,
          count = _ref.count,
          next = _ref.next;
      return function (state) {
        return _objectSpread({}, state, {
          petImages: {
            count: count,
            // previous and next are urls that we can use to get the previous/next page of images.
            // when previous is null, it means that we are on the first page.
            // And we should clean up the existing images to avoid duplicating. Else if previous is defined,
            // we will append to existing images.
            images: previous ? [].concat(_toConsumableArray(state.petImages.images), _toConsumableArray(results)) : results,
            next: next
          },
          isLoadingImages: false,
          errorMessage: ''
        });
      };
    },
    fetchPetImagesFailure: function fetchPetImagesFailure(errorMessage) {
      return function (state) {
        return _objectSpread({}, state, {
          isLoadingImages: false,
          errorMessage: errorMessage
        });
      };
    },
    fetchPetDetailsOptionsPending: function fetchPetDetailsOptionsPending() {
      return function (state) {
        return _objectSpread({}, state, {
          isLoadingOptions: true
        });
      };
    },
    fetchPetDetailsOptionsSuccess: function fetchPetDetailsOptionsSuccess(petDetailsOptions) {
      return function (state) {
        return _objectSpread({}, state, {
          petDetailsOptions: petDetailsOptions,
          isLoadingOptions: false,
          errorMessage: ''
        });
      };
    },
    fetchPetDetailsOptionsFailure: function fetchPetDetailsOptionsFailure(errorMessage) {
      return function (state) {
        return _objectSpread({}, state, {
          isLoadingOptions: false,
          errorMessage: errorMessage
        });
      };
    },
    deletePetImagePending: function deletePetImagePending() {
      return function (state) {
        return _objectSpread({}, state, {
          isDeletingImages: true
        });
      };
    },
    deletePetImageSuccess: function deletePetImageSuccess(imageUrl) {
      return function (state) {
        return _objectSpread({}, state, {
          petInformation: state.petInformation.defaultImage.url !== imageUrl ? state.petInformation : _objectSpread({}, state.petInformation, {
            defaultImage: state.petImages.images[1] || Object(__WEBPACK_IMPORTED_MODULE_2__factories_petFactory__["a" /* default */])().defaultImage
          }),
          petImages: {
            count: state.petImages.count - 1,
            images: state.petImages.images.filter(function (image) {
              return image.url !== imageUrl;
            }),
            next: state.petImages.next
          },
          isDeletingImages: false,
          errorMessage: ''
        });
      };
    },
    deletePetImageFailure: function deletePetImageFailure(errorMessage) {
      return function (state) {
        return _objectSpread({}, state, {
          isDeletingImages: false,
          errorMessage: errorMessage
        });
      };
    },
    clearPets: function clearPets() {
      return function (state) {
        var emptyState = createInitialState();
        return _objectSpread({}, state, {
          pets: emptyState.pets,
          petInformation: emptyState.petInformation,
          petImages: emptyState.petImages
        });
      };
    },
    setPetInformation: function setPetInformation(petInformation) {
      return function (state) {
        return _objectSpread({}, state, {
          petInformation: petInformation
        });
      };
    }
  },
  effects: {
    fetchPets: function fetchPets() {
      return (
        /*#__PURE__*/
        function () {
          var _ref4 = _asyncToGenerator(
          /*#__PURE__*/
          regeneratorRuntime.mark(function _callee(dispatch, getState, _ref2, duckEffects, duckSelectors, _ref3) {
            var fetchPetsPending, fetchPetsSuccess, fetchPetsFailure, expressParams, fetchPetsResponse;
            return regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    fetchPetsPending = _ref2.fetchPetsPending, fetchPetsSuccess = _ref2.fetchPetsSuccess, fetchPetsFailure = _ref2.fetchPetsFailure;
                    expressParams = _ref3.expressParams;
                    dispatch(fetchPetsPending());
                    _context.prev = 3;
                    _context.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_7__apis_pet_api__["b" /* get */])(expressParams);

                  case 6:
                    fetchPetsResponse = _context.sent;
                    dispatch(fetchPetsSuccess(fetchPetsResponse));
                    _context.next = 13;
                    break;

                  case 10:
                    _context.prev = 10;
                    _context.t0 = _context["catch"](3);
                    dispatch(fetchPetsFailure(_context.t0.message));

                  case 13:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee, null, [[3, 10]]);
          }));

          return function (_x, _x2, _x3, _x4, _x5, _x6) {
            return _ref4.apply(this, arguments);
          };
        }()
      );
    },
    fetchPetInformation: function fetchPetInformation(petUrl) {
      return (
        /*#__PURE__*/
        function () {
          var _ref7 = _asyncToGenerator(
          /*#__PURE__*/
          regeneratorRuntime.mark(function _callee2(dispatch, getState, _ref5, duckEffects, duckSelectors, _ref6) {
            var fetchPetInformationPending, fetchPetInformationSuccess, fetchPetInformationFailure, expressParams;
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    fetchPetInformationPending = _ref5.fetchPetInformationPending, fetchPetInformationSuccess = _ref5.fetchPetInformationSuccess, fetchPetInformationFailure = _ref5.fetchPetInformationFailure;
                    expressParams = _ref6.expressParams;
                    dispatch(fetchPetInformationPending());
                    _context2.prev = 3;
                    _context2.t0 = dispatch;
                    _context2.t1 = fetchPetInformationSuccess;
                    _context2.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_7__apis_pet_api__["c" /* getDetail */])(petUrl, expressParams);

                  case 8:
                    _context2.t2 = _context2.sent;
                    _context2.t3 = (0, _context2.t1)(_context2.t2);
                    (0, _context2.t0)(_context2.t3);
                    _context2.next = 16;
                    break;

                  case 13:
                    _context2.prev = 13;
                    _context2.t4 = _context2["catch"](3);
                    dispatch(fetchPetInformationFailure(_context2.t4.message));

                  case 16:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2, null, [[3, 13]]);
          }));

          return function (_x7, _x8, _x9, _x10, _x11, _x12) {
            return _ref7.apply(this, arguments);
          };
        }()
      );
    },
    fetchPetImages: function fetchPetImages(_ref8) {
      var imageListUrl = _ref8.imageListUrl,
          page = _ref8.page;
      return (
        /*#__PURE__*/
        function () {
          var _ref11 = _asyncToGenerator(
          /*#__PURE__*/
          regeneratorRuntime.mark(function _callee3(dispatch, getState, _ref9, duckEffects, duckSelectors, _ref10) {
            var fetchPetImagesPending, fetchPetImagesSuccess, fetchPetImagesFailure, expressParams;
            return regeneratorRuntime.wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    fetchPetImagesPending = _ref9.fetchPetImagesPending, fetchPetImagesSuccess = _ref9.fetchPetImagesSuccess, fetchPetImagesFailure = _ref9.fetchPetImagesFailure;
                    expressParams = _ref10.expressParams;
                    dispatch(fetchPetImagesPending());
                    _context3.prev = 3;
                    _context3.t0 = dispatch;
                    _context3.t1 = fetchPetImagesSuccess;
                    _context3.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_7__apis_pet_api__["d" /* getImages */])(imageListUrl, page, expressParams);

                  case 8:
                    _context3.t2 = _context3.sent;
                    _context3.t3 = (0, _context3.t1)(_context3.t2);
                    (0, _context3.t0)(_context3.t3);
                    _context3.next = 16;
                    break;

                  case 13:
                    _context3.prev = 13;
                    _context3.t4 = _context3["catch"](3);
                    dispatch(fetchPetImagesFailure(_context3.t4.message));

                  case 16:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee3, null, [[3, 13]]);
          }));

          return function (_x13, _x14, _x15, _x16, _x17, _x18) {
            return _ref11.apply(this, arguments);
          };
        }()
      );
    },
    fetchPetDetailsOptions: function fetchPetDetailsOptions() {
      return (
        /*#__PURE__*/
        function () {
          var _ref14 = _asyncToGenerator(
          /*#__PURE__*/
          regeneratorRuntime.mark(function _callee4(dispatch, getState, _ref12, duckEffects, duckSelectors, _ref13) {
            var fetchPetDetailsOptionsPending, fetchPetDetailsOptionsSuccess, fetchPetDetailsOptionsFailure, expressParams;
            return regeneratorRuntime.wrap(function _callee4$(_context4) {
              while (1) {
                switch (_context4.prev = _context4.next) {
                  case 0:
                    fetchPetDetailsOptionsPending = _ref12.fetchPetDetailsOptionsPending, fetchPetDetailsOptionsSuccess = _ref12.fetchPetDetailsOptionsSuccess, fetchPetDetailsOptionsFailure = _ref12.fetchPetDetailsOptionsFailure;
                    expressParams = _ref13.expressParams;
                    dispatch(fetchPetDetailsOptionsPending());
                    _context4.prev = 3;
                    _context4.t0 = dispatch;
                    _context4.t1 = fetchPetDetailsOptionsSuccess;
                    _context4.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_7__apis_pet_api__["e" /* getPetDetailsOptions */])(expressParams);

                  case 8:
                    _context4.t2 = _context4.sent;
                    _context4.t3 = (0, _context4.t1)(_context4.t2);
                    (0, _context4.t0)(_context4.t3);
                    _context4.next = 16;
                    break;

                  case 13:
                    _context4.prev = 13;
                    _context4.t4 = _context4["catch"](3);
                    dispatch(fetchPetDetailsOptionsFailure(_context4.t4.message));

                  case 16:
                  case "end":
                    return _context4.stop();
                }
              }
            }, _callee4, null, [[3, 13]]);
          }));

          return function (_x19, _x20, _x21, _x22, _x23, _x24) {
            return _ref14.apply(this, arguments);
          };
        }()
      );
    },
    deleteImage: function deleteImage(imageUrl) {
      return (
        /*#__PURE__*/
        function () {
          var _ref17 = _asyncToGenerator(
          /*#__PURE__*/
          regeneratorRuntime.mark(function _callee5(dispatch, getState, _ref15, duckEffects, duckSelectors, _ref16) {
            var deletePetImagePending, deletePetImageSuccess, deletePetImageFailure, expressParams;
            return regeneratorRuntime.wrap(function _callee5$(_context5) {
              while (1) {
                switch (_context5.prev = _context5.next) {
                  case 0:
                    deletePetImagePending = _ref15.deletePetImagePending, deletePetImageSuccess = _ref15.deletePetImageSuccess, deletePetImageFailure = _ref15.deletePetImageFailure;
                    expressParams = _ref16.expressParams;
                    dispatch(deletePetImagePending());
                    _context5.prev = 3;
                    _context5.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_7__apis_pet_api__["a" /* deleteImage */])(imageUrl, expressParams);

                  case 6:
                    dispatch(deletePetImageSuccess(imageUrl));
                    _context5.next = 12;
                    break;

                  case 9:
                    _context5.prev = 9;
                    _context5.t0 = _context5["catch"](3);
                    dispatch(deletePetImageFailure(_context5.t0.message));

                  case 12:
                  case "end":
                    return _context5.stop();
                }
              }
            }, _callee5, null, [[3, 9]]);
          }));

          return function (_x25, _x26, _x27, _x28, _x29, _x30) {
            return _ref17.apply(this, arguments);
          };
        }()
      );
    },
    savePet: function savePet(pet) {
      return (
        /*#__PURE__*/
        function () {
          var _ref20 = _asyncToGenerator(
          /*#__PURE__*/
          regeneratorRuntime.mark(function _callee6(dispatch, getState, _ref18, duckEffects, duckSelectors, _ref19) {
            var savePetPending, savePetSuccess, savePetFailure, expressParams, savedPet;
            return regeneratorRuntime.wrap(function _callee6$(_context6) {
              while (1) {
                switch (_context6.prev = _context6.next) {
                  case 0:
                    savePetPending = _ref18.savePetPending, savePetSuccess = _ref18.savePetSuccess, savePetFailure = _ref18.savePetFailure;
                    expressParams = _ref19.expressParams;
                    dispatch(savePetPending());
                    _context6.prev = 3;
                    _context6.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_7__apis_pet_api__["f" /* postOrPut */])(pet, expressParams);

                  case 6:
                    savedPet = _context6.sent;
                    dispatch(savePetSuccess(savedPet));
                    return _context6.abrupt("return", savedPet);

                  case 11:
                    _context6.prev = 11;
                    _context6.t0 = _context6["catch"](3);
                    dispatch(savePetFailure(_context6.t0.message));

                  case 14:
                    return _context6.abrupt("return", null);

                  case 15:
                  case "end":
                    return _context6.stop();
                }
              }
            }, _callee6, null, [[3, 11]]);
          }));

          return function (_x31, _x32, _x33, _x34, _x35, _x36) {
            return _ref20.apply(this, arguments);
          };
        }()
      );
    }
  },
  selectors: {
    getPets: function getPets(getState, createSelector) {
      return createSelector([getState, __WEBPACK_IMPORTED_MODULE_5__countryConfiguration_duck__["c" /* selectors */].getWeightLabel], function (state, weightUnit) {
        return state.pets.map(convertWeight(weightUnit));
      });
    },
    getPetInformation: function getPetInformation(getState, createSelector) {
      return createSelector([getState, __WEBPACK_IMPORTED_MODULE_5__countryConfiguration_duck__["c" /* selectors */].getWeightLabel], function (state, weightUnit) {
        return convertWeight(weightUnit)(state.petInformation);
      });
    },
    getPetOpk: function getPetOpk(getState, createSelector, _ref21) {
      var getPetInformation = _ref21.getPetInformation;
      return createSelector([getState, getPetInformation], function (state, pet) {
        var petOpk = pet.url.match(/pets\/([a-zA-z0-9]+)\/$/);
        return petOpk ? petOpk[1] : '';
      });
    },
    getPetImagesUrl: function getPetImagesUrl(getState, createSelector, _ref22) {
      var getPetInformation = _ref22.getPetInformation;
      return createSelector([getPetInformation], function (pet) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_get__["a" /* default */])(pet, 'urls.images');
      });
    },
    getPetImages: function getPetImages(getState, createSelector) {
      return createSelector([getState], function (state) {
        return state.petImages;
      });
    },
    getIsOwnPet: function getIsOwnPet(getState, createSelector, _ref23) {
      var getPetInformation = _ref23.getPetInformation;
      return createSelector([getPetInformation, __WEBPACK_IMPORTED_MODULE_6__personSummary_duck__["c" /* selectors */].getPersonUrl], function (pet, personUrl) {
        return pet.owner === personUrl;
      });
    },
    getPetDetails: function getPetDetails(getState, createSelector, _ref24) {
      var getPetInformation = _ref24.getPetInformation;
      return createSelector([getState, getPetInformation], function (state, pet) {
        var petDetails = pet.petDetails;
        var derivedPetDetails = Object(__WEBPACK_IMPORTED_MODULE_4__utils_pets__["a" /* getPetDetailsFromPetInformation */])(pet);
        return [].concat(_toConsumableArray(derivedPetDetails), _toConsumableArray(petDetails || []));
      });
    },
    getPetInformationBooleans: function getPetInformationBooleans(getState, createSelector, _ref25) {
      var getPetInformation = _ref25.getPetInformation,
          getPetDetails = _ref25.getPetDetails;
      return createSelector([getState, getPetInformation, getPetDetails], function (state, pet, petDetails) {
        var petInfoKeys = Object(__WEBPACK_IMPORTED_MODULE_4__utils_pets__["b" /* getPetInformationKeys */])(pet);
        return petDetails.filter(function (pd) {
          return petInfoKeys.some(function (infoKey) {
            return Object(__WEBPACK_IMPORTED_MODULE_3__rover_utilities_object_utilities__["c" /* kebabifyString */])(infoKey.key) === pd.slug;
          });
        });
      });
    },
    isPetInfoSubmitting: function isPetInfoSubmitting(getState, createSelector) {
      return createSelector([getState], function (s) {
        return s.submittingCount > 0;
      });
    },
    isPetInfoSaving: function isPetInfoSaving(getState, createSelector) {
      return createSelector([getState], function (s) {
        return s.isSaving;
      });
    },
    getPetsError: function getPetsError(getState, createSelector) {
      return createSelector([getState], function (s) {
        return s.errorMessage;
      });
    },
    getSavePetErrorMessage: function getSavePetErrorMessage(getState, createSelector) {
      return createSelector([getState], function (s) {
        return s.savePetErrorMessage;
      });
    },
    getIsLoading: function getIsLoading(getState, createSelector) {
      return createSelector([getState], function (s) {
        return s.isLoading;
      });
    },
    getPetDetailsOptions: function getPetDetailsOptions(getState, createSelector) {
      return createSelector([getState], function (s) {
        return s.petDetailsOptions;
      });
    },
    getPetDetailsOptionsLoading: function getPetDetailsOptionsLoading(getState, createSelector) {
      return createSelector([getState], function (s) {
        return s.isLoadingOptions;
      });
    }
  }
};

var _ref26 = Object(__WEBPACK_IMPORTED_MODULE_1__lib_redux_duck__["a" /* createDuck */])(options),
    actions = _ref26.actions,
    selectors = _ref26.selectors,
    effects = _ref26.effects,
    reducer = _ref26.reducer;



/***/ }),
/* 373 */,
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(222);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["d" /* createMemoryHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.");
  };

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (MemoryRouter);

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Prompt> outside a <Router>");

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Prompt);

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__generatePath__ = __webpack_require__(295);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Redirect> outside a <Router>");

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(prevProps.to);
    var nextTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(this.props.to);

    if (Object(__WEBPACK_IMPORTED_MODULE_4_history__["f" /* locationsAreEqual */])(prevTo, nextTo)) {
      __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, "You tried to redirect to the same route you're currently on: " + ("\"" + nextTo.pathname + nextTo.search + "\""));
      return;
    }

    this.perform();
  };

  Redirect.prototype.computeTo = function computeTo(_ref) {
    var computedMatch = _ref.computedMatch,
        to = _ref.to;

    if (computedMatch) {
      if (typeof to === "string") {
        return Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to, computedMatch.params);
      } else {
        return _extends({}, to, {
          pathname: Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to.pathname, computedMatch.params)
        });
      }
    }

    return to;
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var push = this.props.push;

    var to = this.computeTo(this.props);

    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, // private, from <Switch>
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Router__ = __webpack_require__(222);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = addLeadingSlash(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createURL = function createURL(location) {
  return typeof location === "string" ? location : Object(__WEBPACK_IMPORTED_MODULE_4_history__["e" /* createPath */])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false, "You cannot %s with <StaticRouter>", methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return addLeadingSlash(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = "PUSH";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = "REPLACE";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.");
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ["basename", "context", "location"]);

    var history = {
      createHref: this.createHref,
      action: "POP",
      location: stripBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: "",
  location: "/"
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (StaticRouter);

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(223);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Switch> outside a <Router>");
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (match == null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) {
        var _element$props = element.props,
            pathProp = _element$props.path,
            exact = _element$props.exact,
            strict = _element$props.strict,
            sensitive = _element$props.sensitive,
            from = _element$props.from;

        var path = pathProp || from;

        child = element;
        match = Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }, route.match);
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(293);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ["wrappedComponentRef"]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], {
      children: function children(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, {
          ref: wrappedComponentRef
        }));
      }
    });
  };

  C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),
/* 380 */,
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.providerContextTypes = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// TODO(jez) 'sync' and 'async' are bad tag names.
// TODO(jez) What if redux also uses this.context.tag?
var providerContextTypes = exports.providerContextTypes = {
  tag: _propTypes2.default.string.isRequired,
  stripe: _propTypes2.default.object,
  addStripeLoadListener: _propTypes2.default.func
};

var getOrCreateStripe = function getOrCreateStripe(apiKey, options) {
  /**
   * Note that this is not meant to be a generic memoization solution.
   * This is specifically a solution for `StripeProvider`s being initialized
   * and destroyed regularly (with the same set of props) when users only
   * use `StripeProvider` for the subtree that contains their checkout form.
   */
  window.Stripe.__cachedInstances = window.Stripe.__cachedInstances || {};
  var cacheKey = 'key=' + apiKey + ' options=' + JSON.stringify(options);

  var stripe = window.Stripe.__cachedInstances[cacheKey] || window.Stripe(apiKey, options);
  window.Stripe.__cachedInstances[cacheKey] = stripe;

  return stripe;
};

var ensureStripeShape = function ensureStripeShape(stripe) {
  if (stripe && stripe.elements && stripe.createSource && stripe.createToken) {
    return stripe;
  } else {
    throw new Error("Please pass a valid Stripe object to StripeProvider. You can obtain a Stripe object by calling 'Stripe(...)' with your publishable key.");
  }
};

var Provider = function (_React$Component) {
  _inherits(Provider, _React$Component);

  // on the other hand: childContextTypes is *required* to use context.
  function Provider(props) {
    _classCallCheck(this, Provider);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    if (_this.props.apiKey && _this.props.stripe) {
      throw new Error("Please pass either 'apiKey' or 'stripe' to StripeProvider, not both.");
    } else if (_this.props.apiKey) {
      if (!window.Stripe) {
        throw new Error("Please load Stripe.js (https://js.stripe.com/v3/) on this page to use react-stripe-elements. If Stripe.js isn't available yet (it's loading asynchronously, or you're using server-side rendering), see https://github.com/stripe/react-stripe-elements#advanced-integrations");
      } else {
        var _this$props = _this.props,
            _apiKey = _this$props.apiKey,
            _children = _this$props.children,
            _stripe = _this$props.stripe,
            options = _objectWithoutProperties(_this$props, ['apiKey', 'children', 'stripe']);

        _this._meta = {
          tag: 'sync',
          stripe: getOrCreateStripe(_apiKey, options)
        };
      }
    } else if (_this.props.stripe) {
      // If we already have a stripe instance (in the constructor), we can behave synchronously.
      _this._meta = {
        tag: 'sync',
        stripe: ensureStripeShape(_this.props.stripe)
      };
    } else if (_this.props.stripe === null) {
      _this._meta = {
        tag: 'async',
        stripe: null
      };
    } else {
      throw new Error("Please pass either 'apiKey' or 'stripe' to StripeProvider. If you're using 'stripe' but don't have a Stripe instance yet, pass 'null' explicitly.");
    }

    _this._didWarn = false;
    _this._didWakeUpListeners = false;
    _this._listeners = [];
    return _this;
  }
  // Even though we're using flow, also use PropTypes so we can take advantage of developer warnings.


  Provider.prototype.getChildContext = function getChildContext() {
    var _this2 = this;

    // getChildContext is run after the constructor, so we WILL have access to
    // the initial state.
    //
    // However, context doesn't update in respnse to state changes like you
    // might expect: context is pulled by the child, not pushed by the parent.
    if (this._meta.tag === 'sync') {
      return {
        tag: 'sync',
        stripe: this._meta.stripe
      };
    } else {
      return {
        tag: 'async',
        addStripeLoadListener: function addStripeLoadListener(fn) {
          if (_this2._meta.stripe) {
            fn(_this2._meta.stripe);
          } else {
            _this2._listeners.push(fn);
          }
        }
      };
    }
  };

  Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var apiKeyChanged = this.props.apiKey && nextProps.apiKey && this.props.apiKey !== nextProps.apiKey;

    var stripeInstanceChanged = this.props.stripe && nextProps.stripe && this.props.stripe !== nextProps.stripe;
    if (!this._didWarn && (apiKeyChanged || stripeInstanceChanged) && window.console && window.console.error) {
      this._didWarn = true;
      // eslint-disable-next-line no-console
      console.error('StripeProvider does not support changing the apiKey parameter.');
      return;
    }

    if (!this._didWakeUpListeners && nextProps.stripe) {
      // Wake up the listeners if we've finally been given a StripeShape
      this._didWakeUpListeners = true;
      var _stripe2 = ensureStripeShape(nextProps.stripe);
      this._meta.stripe = _stripe2;
      this._listeners.forEach(function (fn) {
        fn(_stripe2);
      });
    }
  };

  Provider.prototype.render = function render() {
    return _react2.default.Children.only(this.props.children);
  };

  return Provider;
}(_react2.default.Component);

Provider.propTypes = {
  apiKey: _propTypes2.default.string,
  // PropTypes.object is the only way we can accept a Stripe instance
  // eslint-disable-next-line react/forbid-prop-types
  stripe: _propTypes2.default.object,
  children: _propTypes2.default.node
};
Provider.childContextTypes = providerContextTypes;
Provider.defaultProps = {
  apiKey: undefined,
  stripe: undefined,
  children: null
};
exports.default = Provider;

/***/ }),
/* 382 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 384 */,
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StyledButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Button__ = __webpack_require__(13);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }





var StyledButton = Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_3__Button__["b" /* default */]).withConfig({
  displayName: "LinkButton__StyledButton",
  componentId: "vf887h-0"
})(["text-decoration:none !important;"]);
var StyledAnchor = __WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].a.withConfig({
  displayName: "LinkButton__StyledAnchor",
  componentId: "vf887h-1"
})(["text-decoration:none;"]);
var StyledLink = Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */]).withConfig({
  displayName: "LinkButton__StyledLink",
  componentId: "vf887h-2"
})(["text-decoration:none;"]);

var LinkButton = function LinkButton(_ref) {
  var children = _ref.children,
      href = _ref.href,
      text = _ref.text,
      linkPath = _ref.linkPath,
      buttonType = _ref.buttonType,
      buttonProps = _ref.buttonProps,
      other = _objectWithoutProperties(_ref, ["children", "href", "text", "linkPath", "buttonType", "buttonProps"]);

  var linkProps = _objectSpread({}, other, {
    href: href
  });

  var LinkComponent = StyledAnchor;

  if (linkPath) {
    linkProps = _objectSpread({}, other, {
      to: linkPath
    });
    LinkComponent = StyledLink;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LinkComponent, linkProps, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StyledButton, _extends({
    buttonType: buttonType
  }, buttonProps), text || children));
};

LinkButton.defaultProps = {
  text: '',
  href: '',
  buttonType: __WEBPACK_IMPORTED_MODULE_3__Button__["a" /* ButtonType */].DEFAULT,
  linkPath: '',
  buttonProps: {},
  children: null
};
LinkButton.Button = StyledButton;
/* harmony default export */ __webpack_exports__["b"] = (LinkButton);

/***/ }),
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return petNameListify; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getPetInformationKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getPetDetailsFromPetInformation; });
/* unused harmony export createPetDetailFromOption */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rover_utilities_object_utilities__ = __webpack_require__(22);
 // Returns the pet names in a comma separated list

var petNameListify = function petNameListify(petNames) {
  return petNames.length > 0 ? petNames.join(', ') : '';
};

var getSpayedOrNeutered = function getSpayedOrNeutered(pet) {
  return pet.gender === 'm' ? 'Neutered' : 'Spayed';
}; // Returns keys and display text for the pet details that are stored on the Pet object


var getPetInformationKeys = function getPetInformationKeys(pet) {
  return [{
    key: 'houseTrained',
    display: 'House Trained'
  }, {
    key: 'spayedNeutered',
    display: getSpayedOrNeutered(pet)
  }, {
    key: 'playsChildren',
    display: 'Gets along with children'
  }, {
    key: 'playsDogs',
    display: 'Gets along with dogs'
  }, {
    key: 'playsCats',
    display: 'Gets along with cats'
  }, {
    key: 'implant',
    display: 'Microchipped'
  }];
}; // Returns a list of PetDetail objects for each property currently stored on the Pet object
// but not yet stored as a PetDetail

var getPetDetailsFromPetInformation = function getPetDetailsFromPetInformation(pet) {
  var petDetails = pet.petDetails;

  if (!petDetails) {
    return [];
  }

  var newKeys = getPetInformationKeys(pet) // Only return properties where a corresponding PetDetail doesn't exist
  .filter(function (detail) {
    return !petDetails.some(function (pd) {
      return pd.slug === Object(__WEBPACK_IMPORTED_MODULE_0__rover_utilities_object_utilities__["c" /* kebabifyString */])(detail.key);
    });
  }) // Only return properties where the value is not null
  .filter(function (detail) {
    return Object.prototype.hasOwnProperty.call(pet, detail.key) && pet[detail.key] !== null;
  });
  return newKeys.map(function (detail) {
    var value = pet[detail.key] ? 'yes' : 'no';
    return {
      slug: Object(__WEBPACK_IMPORTED_MODULE_0__rover_utilities_object_utilities__["c" /* kebabifyString */])(detail.key),
      value: value,
      displayName: detail.display,
      valueDisplayName: "".concat(value[0].toUpperCase()).concat(value.slice(1).toLowerCase()),
      additionalInformation: pet["".concat(detail.key, "Desc")] || ''
    };
  });
};
var createPetDetailFromOption = function createPetDetailFromOption(value) {
  var additionalInformation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var petDetailOption = arguments.length > 2 ? arguments[2] : undefined;
  var slug = petDetailOption.slug,
      displayName = petDetailOption.displayName,
      serviceTypes = petDetailOption.serviceTypes,
      multiselect = petDetailOption.multiselect;

  var _ref = petDetailOption.options.find(function (o) {
    return o.value === value;
  }) || {},
      valueDisplayName = _ref.displayName;

  return {
    slug: slug,
    value: value,
    additionalInformation: additionalInformation,
    displayName: displayName,
    serviceTypes: serviceTypes,
    multiselect: multiselect,
    valueDisplayName: valueDisplayName || ''
  };
};
/* unused harmony default export */ var _unused_webpack_default_export = ({
  petNameListify: petNameListify,
  getPetInformationKeys: getPetInformationKeys,
  getPetDetailsFromPetInformation: getPetDetailsFromPetInformation,
  createPetDetailFromOption: createPetDetailFromOption
});

/***/ }),
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 410 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PERSON_SUMMARY_URL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return get; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return save; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rover_utilities_object_utilities__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rover_utilities_apiUrl__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rover_utilities_axiosUtils__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DefaultAPIErrorHandler__ = __webpack_require__(30);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }






var buildPersonSummaryUrl = function buildPersonSummaryUrl(personUrl) {
  return "".concat(personUrl, "summary/");
};

var PERSON_SUMMARY_URL = Object(__WEBPACK_IMPORTED_MODULE_1__rover_utilities_apiUrl__["b" /* fullApiUrl */])('me/');
var get =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(personUrl, expressParams) {
    var ai, _ref2, data, response;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            ai = Object(__WEBPACK_IMPORTED_MODULE_2__rover_utilities_axiosUtils__["a" /* getAxiosInstance */])(expressParams);
            _context.prev = 1;
            _context.next = 4;
            return ai.get(personUrl ? buildPersonSummaryUrl(personUrl) : PERSON_SUMMARY_URL);

          case 4:
            _ref2 = _context.sent;
            data = _ref2.data;
            return _context.abrupt("return", Object(__WEBPACK_IMPORTED_MODULE_0__rover_utilities_object_utilities__["a" /* camelize */])(data, true));

          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](1);
            response = _context.t0.response;

            if (!(response && response.status === 404)) {
              _context.next = 14;
              break;
            }

            return _context.abrupt("return", []);

          case 14:
            return _context.abrupt("return", Object(__WEBPACK_IMPORTED_MODULE_3__DefaultAPIErrorHandler__["a" /* default */])(_context.t0, "There was an error fetching person's summary."));

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 9]]);
  }));

  return function get(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var save =
/*#__PURE__*/
function () {
  var _ref3 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee2(personData, personUrl, expressParams) {
    var ai, _ref4, data, response;

    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            ai = Object(__WEBPACK_IMPORTED_MODULE_2__rover_utilities_axiosUtils__["a" /* getAxiosInstance */])(expressParams);
            _context2.prev = 1;
            _context2.next = 4;
            return ai.patch(personUrl || personData.url, Object(__WEBPACK_IMPORTED_MODULE_0__rover_utilities_object_utilities__["d" /* snakeify */])(personData, true));

          case 4:
            _ref4 = _context2.sent;
            data = _ref4.data;
            return _context2.abrupt("return", Object(__WEBPACK_IMPORTED_MODULE_0__rover_utilities_object_utilities__["a" /* camelize */])(data, true));

          case 9:
            _context2.prev = 9;
            _context2.t0 = _context2["catch"](1);
            response = _context2.t0.response;

            if (!(response && response.status === 404)) {
              _context2.next = 14;
              break;
            }

            return _context2.abrupt("return", []);

          case 14:
            return _context2.abrupt("return", Object(__WEBPACK_IMPORTED_MODULE_3__DefaultAPIErrorHandler__["a" /* default */])(_context2.t0, "There was an error saving person's summary."));

          case 15:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[1, 9]]);
  }));

  return function save(_x3, _x4, _x5) {
    return _ref3.apply(this, arguments);
  };
}();

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(649),
    getValue = __webpack_require__(652);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// CONCATENATED MODULE: ../react-lib/src/components/formFields/Checkbox/Checkbox.jsx
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }



var Checkbox_Checkbox = function Checkbox(_ref) {
  var _onChange = _ref.onChange,
      value = _ref.value,
      other = _objectWithoutProperties(_ref, ["onChange", "value"]);

  return react_default.a.createElement("input", _extends({}, other, {
    type: "checkbox",
    onChange: function onChange(e) {
      if (typeof value !== 'undefined') {
        _onChange(e.target.checked, value);
      } else {
        _onChange(e.target.checked);
      }
    }
  }));
};

Checkbox_Checkbox.defaultProps = {
  checked: false,
  disabled: false,
  id: undefined,
  value: undefined
};
/* harmony default export */ var formFields_Checkbox_Checkbox = (Checkbox_Checkbox);
// CONCATENATED MODULE: ../react-lib/src/components/formFields/Checkbox/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return formFields_Checkbox_Checkbox; });


/***/ }),
/* 421 */,
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(454),
    getRawTag = __webpack_require__(644),
    objectToString = __webpack_require__(645);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AddressForm__ = __webpack_require__(475);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__AddressForm__["a"]; });


/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ../node_modules/@lingui/react/index.js
var _lingui_react = __webpack_require__(3);
var _lingui_react_default = /*#__PURE__*/__webpack_require__.n(_lingui_react);

// EXTERNAL MODULE: ../react-lib/src/components/formFields/Input/index.js
var Input = __webpack_require__(143);

// CONCATENATED MODULE: ../react-lib/src/components/formFields/ZipcodeInput/ZipcodeInput.jsx
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }





var handleChange = function handleChange(value, onChange, postalRegExp) {
  if (!onChange) return;
  var cleanedValue = value.toUpperCase();

  if (postalRegExp) {
    if (postalRegExp.test(cleanedValue)) {
      onChange(cleanedValue);
    }
  } else {
    onChange(cleanedValue);
  }
};

var ZipcodeInput_ZipcodeInput = function ZipcodeInput(_ref) {
  var _onChange = _ref.onChange,
      postalRegExp = _ref.postalRegExp,
      other = _objectWithoutProperties(_ref, ["onChange", "postalRegExp"]);

  return react_default.a.createElement(_lingui_react["I18n"], null, function (_ref2) {
    var i18n = _ref2.i18n;
    return react_default.a.createElement(Input["a" /* default */], _extends({
      name: "zipcode",
      type: "text",
      placeholder: i18n._('Postal Code'),
      autoComplete: "postal-code",
      onChange: function onChange(value) {
        return handleChange(value, _onChange, postalRegExp);
      }
    }, other));
  });
};

/* harmony default export */ var formFields_ZipcodeInput_ZipcodeInput = (ZipcodeInput_ZipcodeInput);
// CONCATENATED MODULE: ../react-lib/src/components/formFields/ZipcodeInput/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return formFields_ZipcodeInput_ZipcodeInput; });


/***/ }),
/* 429 */,
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(416);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(469);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(663);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(537);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ }),
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export options */
/* unused harmony export actions */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return selectors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return effects; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_redux_duck__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apis_personSummary_api__ = __webpack_require__(415);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var options = {
  name: 'personSummary',
  initialState: {
    summary: {
      pets: []
    },
    errorMessage: '',
    successMessage: '',
    loading: false
  },
  actions: {
    fetchPersonSummaryPending: function fetchPersonSummaryPending() {
      return function (state) {
        return _objectSpread({}, state, {
          loading: true
        });
      };
    },
    fetchPersonSummarySuccess: function fetchPersonSummarySuccess(summary) {
      return function (state) {
        return _objectSpread({}, state, {
          loading: false,
          summary: summary,
          errorMessage: ''
        });
      };
    },
    fetchPersonSummaryFailure: function fetchPersonSummaryFailure(_ref) {
      var message = _ref.message;
      return function (state) {
        return _objectSpread({}, state, {
          loading: false,
          errorMessage: message
        });
      };
    },
    savePersonSummaryPrivatePending: function savePersonSummaryPrivatePending() {
      return function (state) {
        return _objectSpread({}, state, {
          loading: true
        });
      };
    },
    savePersonSummaryPrivateSuccess: function savePersonSummaryPrivateSuccess(summaryPrivate) {
      return function (state) {
        return _objectSpread({}, state, {
          loading: false,
          summary: _objectSpread({}, state.summary, {
            "private": summaryPrivate
          }),
          errorMessage: ''
        });
      };
    },
    savePersonSummaryPrivateFailure: function savePersonSummaryPrivateFailure(_ref2) {
      var message = _ref2.message;
      return function (state) {
        return _objectSpread({}, state, {
          loading: false,
          errorMessage: message
        });
      };
    }
  },
  effects: {
    fetchPersonSummary: function fetchPersonSummary(personUrl) {
      return (
        /*#__PURE__*/
        function () {
          var _ref3 = _asyncToGenerator(
          /*#__PURE__*/
          regeneratorRuntime.mark(function _callee(dispatch, getState, duckActions) {
            return regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    dispatch(duckActions.fetchPersonSummaryPending());
                    _context.prev = 1;
                    _context.t0 = dispatch;
                    _context.t1 = duckActions;
                    _context.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_1__apis_personSummary_api__["a" /* get */])(personUrl);

                  case 6:
                    _context.t2 = _context.sent;
                    _context.t3 = _context.t1.fetchPersonSummarySuccess.call(_context.t1, _context.t2);
                    (0, _context.t0)(_context.t3);
                    _context.next = 14;
                    break;

                  case 11:
                    _context.prev = 11;
                    _context.t4 = _context["catch"](1);
                    dispatch(duckActions.fetchPersonSummaryFailure(_context.t4));

                  case 14:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee, null, [[1, 11]]);
          }));

          return function (_x, _x2, _x3) {
            return _ref3.apply(this, arguments);
          };
        }()
      );
    },
    savePersonSummaryPrivate: function savePersonSummaryPrivate(_ref4) {
      var personData = _ref4.personData,
          personUrl = _ref4.personUrl;
      return (
        /*#__PURE__*/
        function () {
          var _ref5 = _asyncToGenerator(
          /*#__PURE__*/
          regeneratorRuntime.mark(function _callee2(dispatch, getState, duckActions) {
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    dispatch(duckActions.savePersonSummaryPrivatePending());
                    _context2.prev = 1;
                    _context2.t0 = dispatch;
                    _context2.t1 = duckActions;
                    _context2.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_1__apis_personSummary_api__["b" /* save */])(personData, personUrl);

                  case 6:
                    _context2.t2 = _context2.sent;
                    _context2.t3 = _context2.t1.savePersonSummaryPrivateSuccess.call(_context2.t1, _context2.t2);
                    (0, _context2.t0)(_context2.t3);
                    _context2.next = 14;
                    break;

                  case 11:
                    _context2.prev = 11;
                    _context2.t4 = _context2["catch"](1);
                    dispatch(duckActions.savePersonSummaryPrivateFailure(_context2.t4));

                  case 14:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2, null, [[1, 11]]);
          }));

          return function (_x4, _x5, _x6) {
            return _ref5.apply(this, arguments);
          };
        }()
      );
    }
  },
  selectors: {
    getPersonSummary: function getPersonSummary(getState, createSelector) {
      return createSelector([getState], function (s) {
        return s.summary;
      });
    },
    getPersonUrl: function getPersonUrl(getState, createSelector) {
      return createSelector([getState], function (s) {
        return s.summary.url;
      });
    },
    getErrorMessage: function getErrorMessage(getState, createSelector) {
      return createSelector([getState], function (s) {
        return s.errorMessage;
      });
    },
    getIsLoading: function getIsLoading(getState, createSelector) {
      return createSelector([getState], function (s) {
        return s.loading;
      });
    },
    getIsSuccessful: function getIsSuccessful(getState, createSelector) {
      return createSelector([getState], function (s) {
        return !s.loading && !s.errorMessage;
      });
    },
    getAvailablePets: function getAvailablePets(getState, createSelector) {
      return createSelector([getState], function (s) {
        return s.summary.pets;
      });
    },
    getAddress: function getAddress(getState, createSelector, _ref6) {
      var getPersonSummary = _ref6.getPersonSummary;
      return createSelector([getPersonSummary], function (personSummary) {
        return personSummary && personSummary["private"] && personSummary["private"].home;
      });
    },
    getOpk: function getOpk(getState, createSelector, _ref7) {
      var getPersonSummary = _ref7.getPersonSummary;
      return createSelector([getPersonSummary], function (personSummary) {
        return personSummary && personSummary.url && personSummary.url.substr(0, personSummary.url.length - 1).split('/').pop();
      });
    },
    getEmergencyContactName: function getEmergencyContactName(getState, createSelector, _ref8) {
      var getPersonSummary = _ref8.getPersonSummary;
      return createSelector([getPersonSummary], function (personSummary) {
        return personSummary && personSummary["private"] && personSummary["private"].emergency_contact_name;
      });
    },
    getEmergencyContactPhoneNumber: function getEmergencyContactPhoneNumber(getState, createSelector, _ref9) {
      var getPersonSummary = _ref9.getPersonSummary;
      return createSelector([getPersonSummary], function (personSummary) {
        return personSummary && personSummary["private"] && personSummary["private"].emergency_contact_phone_number;
      });
    }
  }
};

var _ref10 = Object(__WEBPACK_IMPORTED_MODULE_0__lib_redux_duck__["a" /* createDuck */])(options),
    actions = _ref10.actions,
    selectors = _ref10.selectors,
    effects = _ref10.effects,
    reducer = _ref10.reducer;



/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(361);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/axios/index.js
var axios = __webpack_require__(87);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// EXTERNAL MODULE: ../utilities/apiUrl.js
var apiUrl = __webpack_require__(51);

// EXTERNAL MODULE: ../utilities/parseApiErrors.js
var parseApiErrors = __webpack_require__(157);

// EXTERNAL MODULE: ../utilities/object-utilities.js
var object_utilities = __webpack_require__(22);

// EXTERNAL MODULE: ../react-lib/src/apis/APIError.js
var APIError = __webpack_require__(79);

// CONCATENATED MODULE: ../react-lib/src/apis/paymentIntent.api.js
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }






var PaymentIntentCreationError =
/*#__PURE__*/
function (_APIError) {
  _inherits(PaymentIntentCreationError, _APIError);

  function PaymentIntentCreationError(message, status, errorType) {
    var _this;

    _classCallCheck(this, PaymentIntentCreationError);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PaymentIntentCreationError).call(this, message, status));
    _this.type = 'PaymentIntentCreationError';
    _this.errorType = null;
    _this.errorType = errorType;
    return _this;
  }

  return PaymentIntentCreationError;
}(APIError["a" /* default */]);
var PAYMENT_INTENT_URL = Object(apiUrl["b" /* fullApiUrl */])('payment-intents/');
var post =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(conversationOpk, ccmUrl, amount, currency) {
    var response, data, _response, errors, message;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return axios_default.a.post(PAYMENT_INTENT_URL, {
              amount: amount,
              currency: currency,
              credit_card_method: ccmUrl,
              conversation: conversationOpk
            });

          case 3:
            response = _context.sent;
            data = response.data;
            return _context.abrupt("return", Object(object_utilities["a" /* camelize */])(data, true));

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](0);
            _response = _context.t0.response;
            errors = Object(parseApiErrors["a" /* default */])(_response); // placeholder error for now until we decide more granular error for FE payment intent

            message = errors.length ? errors.pop() : 'There was an error creating payment intent.'; // placeholder error for now until we decide more granular
            // error for FE payment intent
            // limit Payment Intent errors to the payment_intent_creation to avoid
            // accidently displaying untranslated strings

            throw new PaymentIntentCreationError(message, _response.status, _response.data && _response.data.error_type);

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 8]]);
  }));

  return function post(_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();
// EXTERNAL MODULE: ../utilities/injector.js
var injector = __webpack_require__(43);

// CONCATENATED MODULE: ../utilities/script.js
var loadScript = function loadScript(url, scriptId) {
  return new Promise(function (resolve) {
    var script = document.getElementById(scriptId);

    if (!script) {
      script = document.createElement('script');
      script.id = scriptId;
      script.src = url;
      script.async = true;

      if (!document.body) {
        throw Error('document.body does not exist');
      }

      document.body.appendChild(script);
    }

    script.addEventListener('load', function () {
      return resolve(script);
    });
  });
};
// CONCATENATED MODULE: ../utilities/stripe.client.js
/* unused harmony export STRIPE_JS_TAG_ID */
/* unused harmony export STRIPE_JS_URL */
/* unused harmony export WEBKIT_SUCCESS_CALLBACK */
/* unused harmony export WEBKIT_FAILURE_CALLBACK */
/* unused harmony export PaymentIntentAuthenticationError */
/* unused harmony export loadStripe */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getStripeClient; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return authenticatePaymentIntent; });
/* unused concated harmony import PaymentIntentCreationError */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return PaymentIntentCreationError; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return post; });
function stripe_client__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { stripe_client__typeof = function _typeof(obj) { return typeof obj; }; } else { stripe_client__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return stripe_client__typeof(obj); }

function stripe_client_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function stripe_client__asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { stripe_client_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { stripe_client_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function stripe_client__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function stripe_client__possibleConstructorReturn(self, call) { if (call && (stripe_client__typeof(call) === "object" || typeof call === "function")) { return call; } return stripe_client__assertThisInitialized(self); }

function stripe_client__assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function stripe_client__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) stripe_client__setPrototypeOf(subClass, superClass); }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, stripe_client__getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return stripe_client__setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _construct(Parent, args, Class) { if (isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) stripe_client__setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function stripe_client__setPrototypeOf(o, p) { stripe_client__setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return stripe_client__setPrototypeOf(o, p); }

function stripe_client__getPrototypeOf(o) { stripe_client__getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return stripe_client__getPrototypeOf(o); }

/* eslint-disable no-console */



var STRIPE_JS_TAG_ID = 'stripe-js';
var STRIPE_JS_URL = 'https://js.stripe.com/v3/';
var WEBKIT_SUCCESS_CALLBACK = 'webkitAuthenticatePaymentIntentSuccessful';
var WEBKIT_FAILURE_CALLBACK = 'webkitAuthenticatePaymentIntentFailure';
var PaymentIntentAuthenticationError =
/*#__PURE__*/
function (_Error) {
  stripe_client__inherits(PaymentIntentAuthenticationError, _Error);

  function PaymentIntentAuthenticationError() {
    var _getPrototypeOf2;

    var _this;

    stripe_client__classCallCheck(this, PaymentIntentAuthenticationError);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = stripe_client__possibleConstructorReturn(this, (_getPrototypeOf2 = stripe_client__getPrototypeOf(PaymentIntentAuthenticationError)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.type = 'PaymentIntentAuthenticationError';
    return _this;
  }

  return PaymentIntentAuthenticationError;
}(_wrapNativeSuper(Error)); // Put the inject in a function so STRIPE_PUBLIC_KEY does not need to be a dependency of this module at load time

var stripe_client_getStripeApiKey = function getStripeApiKey() {
  return Object(injector["a" /* default */])('Rover.context.STRIPE_PUBLIC_KEY');
}; // Use module because we cannot mock individual function otherwise due to the way module is being loaded


var stripe_client_module = {};

stripe_client_module.shouldAuthenticateWithIOSSDK = function () {
  return Object(injector["a" /* default */])('Rover.context.useStripeNativeIosSdk', false);
};

stripe_client_module.getWebkitMessageHandler = function () {
  return window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.rover;
};

stripe_client_module.loadStripe =
/*#__PURE__*/
stripe_client__asyncToGenerator(
/*#__PURE__*/
regeneratorRuntime.mark(function _callee() {
  return regeneratorRuntime.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (!(window && window.Stripe)) {
            _context.next = 2;
            break;
          }

          return _context.abrupt("return", window.Stripe);

        case 2:
          _context.next = 4;
          return loadScript(STRIPE_JS_URL, STRIPE_JS_TAG_ID);

        case 4:
          return _context.abrupt("return", window.Stripe);

        case 5:
        case "end":
          return _context.stop();
      }
    }
  }, _callee);
}));

stripe_client_module.getStripeClient =
/*#__PURE__*/
function () {
  var _ref2 = stripe_client__asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee2(apiKey) {
    var publicKey, Stripe;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            publicKey = stripe_client_getStripeApiKey();
            _context2.next = 3;
            return stripe_client_module.loadStripe();

          case 3:
            Stripe = _context2.sent;
            return _context2.abrupt("return", Stripe(apiKey || publicKey));

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function (_x) {
    return _ref2.apply(this, arguments);
  };
}();

stripe_client_module.authenticatePaymentIntent =
/*#__PURE__*/
function () {
  var _ref3 = stripe_client__asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee3(clientSecret, requiresAction, opk) {
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (!requiresAction) {
              _context3.next = 6;
              break;
            }

            if (!(stripe_client_module.shouldAuthenticateWithIOSSDK() && stripe_client_module.getWebkitMessageHandler())) {
              _context3.next = 4;
              break;
            }

            console.debug('Authenticate payment intent with webkit');
            return _context3.abrupt("return", stripe_client_module.authenticatePaymentIntentIOS(clientSecret, opk));

          case 4:
            console.debug('Authenticate payment intent with stripejs');
            return _context3.abrupt("return", stripe_client_module.authenticatePaymentIntentStripeJS(clientSecret, opk));

          case 6:
            return _context3.abrupt("return", opk);

          case 7:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function (_x2, _x3, _x4) {
    return _ref3.apply(this, arguments);
  };
}();

stripe_client_module.authenticatePaymentIntentStripeJS =
/*#__PURE__*/
function () {
  var _ref4 = stripe_client__asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee4(clientSecret, opk) {
    var stripeClient, result;
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return stripe_client_module.getStripeClient();

          case 2:
            stripeClient = _context4.sent;
            result = {};
            _context4.prev = 4;
            _context4.next = 7;
            return stripeClient.handleCardAction(clientSecret);

          case 7:
            result = _context4.sent;
            _context4.next = 13;
            break;

          case 10:
            _context4.prev = 10;
            _context4.t0 = _context4["catch"](4);
            throw new PaymentIntentAuthenticationError();

          case 13:
            if (!result.error) {
              _context4.next = 15;
              break;
            }

            throw new PaymentIntentAuthenticationError(result.error.message);

          case 15:
            return _context4.abrupt("return", opk);

          case 16:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[4, 10]]);
  }));

  return function (_x5, _x6) {
    return _ref4.apply(this, arguments);
  };
}();
/** This function delegates payment intent authentication to iOS native SDK
 * and exposes global callbacks that allows iOS to communicate authentication status back to the embedded web
 */


stripe_client_module.authenticatePaymentIntentIOS =
/*#__PURE__*/
function () {
  var _ref5 = stripe_client__asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee5(clientSecret, opk) {
    var resultPromise, result;
    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            resultPromise = new Promise(function (resolve, reject) {
              window[WEBKIT_SUCCESS_CALLBACK] = function () {
                return resolve(opk);
              };

              window[WEBKIT_FAILURE_CALLBACK] = function () {
                return reject();
              };
            });
            stripe_client_module.getWebkitMessageHandler().postMessage({
              action: 'stripe-challenge',
              clientSecret: clientSecret,
              stripeApiKey: stripe_client_getStripeApiKey(),
              successJSCallback: "window.".concat(WEBKIT_SUCCESS_CALLBACK),
              errorJSCallback: "window.".concat(WEBKIT_FAILURE_CALLBACK),
              closeJSCallback: "window.".concat(WEBKIT_FAILURE_CALLBACK)
            });
            _context5.prev = 2;
            _context5.next = 5;
            return resultPromise;

          case 5:
            result = _context5.sent;
            _context5.next = 11;
            break;

          case 8:
            _context5.prev = 8;
            _context5.t0 = _context5["catch"](2);
            throw new PaymentIntentAuthenticationError();

          case 11:
            window.webkitAuthenticatePaymentIntentSuccessful = undefined;
            window.webkitAuthenticatePaymentIntentFailure = undefined;
            return _context5.abrupt("return", result);

          case 14:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[2, 8]]);
  }));

  return function (_x7, _x8) {
    return _ref5.apply(this, arguments);
  };
}();

/* harmony default export */ var stripe_client = (stripe_client_module);
var loadStripe = stripe_client_module.loadStripe,
    getStripeClient = stripe_client_module.getStripeClient,
    authenticatePaymentIntent = stripe_client_module.authenticatePaymentIntent;



/***/ }),
/* 461 */,
/* 462 */,
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(360);

// EXTERNAL MODULE: ../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(468);

// EXTERNAL MODULE: ../node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
var inheritsLoose = __webpack_require__(522);

// EXTERNAL MODULE: ../node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__(467);

// EXTERNAL MODULE: ../node_modules/prop-types/index.js
var prop_types = __webpack_require__(4);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// CONCATENATED MODULE: ../node_modules/react-textarea-autosize/dist/react-textarea-autosize.esm.browser.js







var isIE = !!document.documentElement.currentStyle;
var HIDDEN_TEXTAREA_STYLE = {
  'min-height': '0',
  'max-height': 'none',
  height: '0',
  visibility: 'hidden',
  overflow: 'hidden',
  position: 'absolute',
  'z-index': '-1000',
  top: '0',
  right: '0'
};
var SIZING_STYLE = ['letter-spacing', 'line-height', 'font-family', 'font-weight', 'font-size', 'font-style', 'tab-size', 'text-rendering', 'text-transform', 'width', 'text-indent', 'padding-top', 'padding-right', 'padding-bottom', 'padding-left', 'border-top-width', 'border-right-width', 'border-bottom-width', 'border-left-width', 'box-sizing'];
var computedStyleCache = {};
var hiddenTextarea = document.createElement('textarea');

var forceHiddenStyles = function forceHiddenStyles(node) {
  Object.keys(HIDDEN_TEXTAREA_STYLE).forEach(function (key) {
    node.style.setProperty(key, HIDDEN_TEXTAREA_STYLE[key], 'important');
  });
};

{
  forceHiddenStyles(hiddenTextarea);
}

function calculateNodeHeight(uiTextNode, uid, useCache, minRows, maxRows) {
  if (useCache === void 0) {
    useCache = false;
  }

  if (minRows === void 0) {
    minRows = null;
  }

  if (maxRows === void 0) {
    maxRows = null;
  }

  if (hiddenTextarea.parentNode === null) {
    document.body.appendChild(hiddenTextarea);
  } // Copy all CSS properties that have an impact on the height of the content in
  // the textbox


  var nodeStyling = calculateNodeStyling(uiTextNode, uid, useCache);

  if (nodeStyling === null) {
    return null;
  }

  var paddingSize = nodeStyling.paddingSize,
      borderSize = nodeStyling.borderSize,
      boxSizing = nodeStyling.boxSizing,
      sizingStyle = nodeStyling.sizingStyle; // Need to have the overflow attribute to hide the scrollbar otherwise
  // text-lines will not calculated properly as the shadow will technically be
  // narrower for content

  Object.keys(sizingStyle).forEach(function (key) {
    hiddenTextarea.style[key] = sizingStyle[key];
  });
  forceHiddenStyles(hiddenTextarea);
  hiddenTextarea.value = uiTextNode.value || uiTextNode.placeholder || 'x';
  var minHeight = -Infinity;
  var maxHeight = Infinity;
  var height = hiddenTextarea.scrollHeight;

  if (boxSizing === 'border-box') {
    // border-box: add border, since height = content + padding + border
    height = height + borderSize;
  } else if (boxSizing === 'content-box') {
    // remove padding, since height = content
    height = height - paddingSize;
  } // measure height of a textarea with a single row


  hiddenTextarea.value = 'x';
  var singleRowHeight = hiddenTextarea.scrollHeight - paddingSize; // Stores the value's rows count rendered in `hiddenTextarea`,
  // regardless if `maxRows` or `minRows` props are passed

  var valueRowCount = Math.floor(height / singleRowHeight);

  if (minRows !== null) {
    minHeight = singleRowHeight * minRows;

    if (boxSizing === 'border-box') {
      minHeight = minHeight + paddingSize + borderSize;
    }

    height = Math.max(minHeight, height);
  }

  if (maxRows !== null) {
    maxHeight = singleRowHeight * maxRows;

    if (boxSizing === 'border-box') {
      maxHeight = maxHeight + paddingSize + borderSize;
    }

    height = Math.min(maxHeight, height);
  }

  var rowCount = Math.floor(height / singleRowHeight);
  return {
    height: height,
    minHeight: minHeight,
    maxHeight: maxHeight,
    rowCount: rowCount,
    valueRowCount: valueRowCount
  };
}

function calculateNodeStyling(node, uid, useCache) {
  if (useCache === void 0) {
    useCache = false;
  }

  if (useCache && computedStyleCache[uid]) {
    return computedStyleCache[uid];
  }

  var style = window.getComputedStyle(node);

  if (style === null) {
    return null;
  }

  var sizingStyle = SIZING_STYLE.reduce(function (obj, name) {
    obj[name] = style.getPropertyValue(name);
    return obj;
  }, {});
  var boxSizing = sizingStyle['box-sizing']; // probably node is detached from DOM, can't read computed dimensions

  if (boxSizing === '') {
    return null;
  } // IE (Edge has already correct behaviour) returns content width as computed width
  // so we need to add manually padding and border widths


  if (isIE && boxSizing === 'border-box') {
    sizingStyle.width = parseFloat(sizingStyle.width) + parseFloat(style['border-right-width']) + parseFloat(style['border-left-width']) + parseFloat(style['padding-right']) + parseFloat(style['padding-left']) + 'px';
  }

  var paddingSize = parseFloat(sizingStyle['padding-bottom']) + parseFloat(sizingStyle['padding-top']);
  var borderSize = parseFloat(sizingStyle['border-bottom-width']) + parseFloat(sizingStyle['border-top-width']);
  var nodeInfo = {
    sizingStyle: sizingStyle,
    paddingSize: paddingSize,
    borderSize: borderSize,
    boxSizing: boxSizing
  };

  if (useCache) {
    computedStyleCache[uid] = nodeInfo;
  }

  return nodeInfo;
}

var purgeCache = function purgeCache(uid) {
  delete computedStyleCache[uid];
};

var noop = function noop() {};

var uid = 0;

var react_textarea_autosize_esm_browser_TextareaAutosize =
/*#__PURE__*/
function (_React$Component) {
  Object(inheritsLoose["a" /* default */])(TextareaAutosize, _React$Component);

  function TextareaAutosize(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _this._onRef = function (node) {
      _this._ref = node;
      var inputRef = _this.props.inputRef;

      if (typeof inputRef === 'function') {
        inputRef(node);
        return;
      }

      inputRef.current = node;
    };

    _this._onChange = function (event) {
      if (!_this._controlled) {
        _this._resizeComponent();
      }

      _this.props.onChange(event, Object(assertThisInitialized["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this)));
    };

    _this._resizeComponent = function (callback) {
      if (callback === void 0) {
        callback = noop;
      }

      var nodeHeight = calculateNodeHeight(_this._ref, _this._uid, _this.props.useCacheForDOMMeasurements, _this.props.minRows, _this.props.maxRows);

      if (nodeHeight === null) {
        callback();
        return;
      }

      var height = nodeHeight.height,
          minHeight = nodeHeight.minHeight,
          maxHeight = nodeHeight.maxHeight,
          rowCount = nodeHeight.rowCount,
          valueRowCount = nodeHeight.valueRowCount;
      _this.rowCount = rowCount;
      _this.valueRowCount = valueRowCount;

      if (_this.state.height !== height || _this.state.minHeight !== minHeight || _this.state.maxHeight !== maxHeight) {
        _this.setState({
          height: height,
          minHeight: minHeight,
          maxHeight: maxHeight
        }, callback);

        return;
      }

      callback();
    };

    _this.state = {
      height: props.style && props.style.height || 0,
      minHeight: -Infinity,
      maxHeight: Infinity
    };
    _this._uid = uid++;
    _this._controlled = props.value !== undefined;
    _this._resizeLock = false;
    return _this;
  }

  var _proto = TextareaAutosize.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        _inputRef = _this$props.inputRef,
        _maxRows = _this$props.maxRows,
        _minRows = _this$props.minRows,
        _onHeightChange = _this$props.onHeightChange,
        _useCacheForDOMMeasurements = _this$props.useCacheForDOMMeasurements,
        props = Object(objectWithoutPropertiesLoose["a" /* default */])(_this$props, ["inputRef", "maxRows", "minRows", "onHeightChange", "useCacheForDOMMeasurements"]);

    props.style = Object(esm_extends["a" /* default */])({}, props.style, {
      height: this.state.height
    });
    var maxHeight = Math.max(props.style.maxHeight || Infinity, this.state.maxHeight);

    if (maxHeight < this.state.height) {
      props.style.overflow = 'hidden';
    }

    return react_default.a.createElement("textarea", Object(esm_extends["a" /* default */])({}, props, {
      onChange: this._onChange,
      ref: this._onRef
    }));
  };

  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;

    this._resizeComponent(); // Working around Firefox bug which runs resize listeners even when other JS is running at the same moment
    // causing competing rerenders (due to setState in the listener) in React.
    // More can be found here - facebook/react#6324


    this._resizeListener = function () {
      if (_this2._resizeLock) {
        return;
      }

      _this2._resizeLock = true;

      _this2._resizeComponent(function () {
        _this2._resizeLock = false;
      });
    };

    window.addEventListener('resize', this._resizeListener);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    if (prevProps !== this.props) {
      this._resizeComponent();
    }

    if (this.state.height !== prevState.height) {
      this.props.onHeightChange(this.state.height, this);
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('resize', this._resizeListener);
    purgeCache(this._uid);
  };

  return TextareaAutosize;
}(react_default.a.Component);

react_textarea_autosize_esm_browser_TextareaAutosize.defaultProps = {
  inputRef: noop,
  onChange: noop,
  onHeightChange: noop,
  useCacheForDOMMeasurements: false
};
 false ? react_textarea_autosize_esm_browser_TextareaAutosize.propTypes = {
  inputRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.any
  })]),
  maxRows: PropTypes.number,
  minRows: PropTypes.number,
  onChange: PropTypes.func,
  onHeightChange: PropTypes.func,
  style: PropTypes.object,
  useCacheForDOMMeasurements: PropTypes.bool,
  value: PropTypes.string
} : void 0;

/* harmony default export */ var react_textarea_autosize_esm_browser = (react_textarea_autosize_esm_browser_TextareaAutosize);

// EXTERNAL MODULE: ../react-lib/src/components/utils/LabelAndErrorFormGroup/index.js + 1 modules
var LabelAndErrorFormGroup = __webpack_require__(77);

// EXTERNAL MODULE: ../react-lib/src/components/utils/AsInput/index.js + 1 modules
var AsInput = __webpack_require__(226);

// CONCATENATED MODULE: ../react-lib/src/components/formFields/Textarea/Textarea.jsx
/* unused harmony export UnwrappedTextarea */
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }






var handleKeyPress = function handleKeyPress(e, onKeyPress) {
  if (e.key === 'Enter') {
    e.stopPropagation();
  }

  if (onKeyPress) {
    onKeyPress(e);
  }
};

var Textarea_Textarea = function Textarea(_ref) {
  var inputRef = _ref.inputRef,
      onChange = _ref.onChange,
      sensitive = _ref.sensitive,
      className = _ref.className,
      _onKeyPress = _ref.onKeyPress,
      autoExpand = _ref.autoExpand,
      props = _objectWithoutProperties(_ref, ["inputRef", "onChange", "sensitive", "className", "onKeyPress", "autoExpand"]);

  return react_default.a.createElement(AsInput["b" /* default */], {
    inputRef: inputRef,
    onChange: onChange,
    sensitive: sensitive,
    className: className
  }, function (inputProps) {
    var allProps = _objectSpread({}, props, {}, inputProps, {
      onKeyPress: function onKeyPress(e) {
        return handleKeyPress(e, _onKeyPress);
      }
    });

    return autoExpand ? react_default.a.createElement(react_textarea_autosize_esm_browser, allProps) : react_default.a.createElement("textarea", allProps);
  });
};

/* harmony default export */ var formFields_Textarea_Textarea = __webpack_exports__["a"] = (function (props) {
  return react_default.a.createElement(LabelAndErrorFormGroup["b" /* default */], props, function (_ref2) {
    var ref = _ref2.ref,
        rest = _objectWithoutProperties(_ref2, ["ref"]);

    return react_default.a.createElement(Textarea_Textarea, _extends({}, rest, {
      inputRef: ref
    }));
  });
});


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(657),
    listCacheDelete = __webpack_require__(658),
    listCacheGet = __webpack_require__(659),
    listCacheHas = __webpack_require__(660),
    listCacheSet = __webpack_require__(661);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ../node_modules/@lingui/react/index.js
var _lingui_react = __webpack_require__(3);
var _lingui_react_default = /*#__PURE__*/__webpack_require__.n(_lingui_react);

// EXTERNAL MODULE: ../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(1);

// EXTERNAL MODULE: ../react-lib/src/factories/addressFactory.js
var addressFactory = __webpack_require__(253);

// EXTERNAL MODULE: ../react-lib/src/components/utils/Form/validation/validators.js
var validators = __webpack_require__(248);

// EXTERNAL MODULE: ../react-lib/src/utils/address.js
var utils_address = __webpack_require__(358);

// EXTERNAL MODULE: ../react-lib/src/components/notifications/SuccessOrErrorAlert/index.js + 2 modules
var SuccessOrErrorAlert = __webpack_require__(257);

// EXTERNAL MODULE: ../react-lib/src/constants/countries.constants.json
var countries_constants = __webpack_require__(534);
var countries_constants_default = /*#__PURE__*/__webpack_require__.n(countries_constants);

// EXTERNAL MODULE: ../react-lib/src/styles/index.js + 3 modules
var styles = __webpack_require__(2);

// EXTERNAL MODULE: ../react-lib/src/components/formFields/Select/index.js
var Select = __webpack_require__(363);

// CONCATENATED MODULE: ../react-lib/src/components/forms/AddressForm/AddressFormCountryField.jsx
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }







var StyledSelectInput = Object(styled_components_browser_esm["default"])(Select["a" /* default */]).withConfig({
  displayName: "AddressFormCountryField__StyledSelectInput",
  componentId: "sc-1bzf94l-0"
})(["flex:2;", "{margin-right:0;}"], styles["i" /* MQ */].XS);

var mapCountriesToOptions = function mapCountriesToOptions(countries) {
  return countries.map(function (_ref) {
    var name = _ref.name,
        code = _ref.code;
    return {
      title: name,
      value: code
    };
  });
};

var AddressFormCountryField_getCountryOptions = function getCountryOptions(supportedCountryCodes) {
  if (!supportedCountryCodes || supportedCountryCodes.length === 0) {
    return mapCountriesToOptions(countries_constants_default.a);
  }

  var supportedCountryList = countries_constants_default.a.filter(function (country) {
    return supportedCountryCodes.includes(country.code);
  }) // Maintain the same country order as supportedCountryCodes
  .sort(function (a, b) {
    return supportedCountryCodes.indexOf(a.code) - supportedCountryCodes.indexOf(b.code);
  });
  var otherCountryList = countries_constants_default.a.filter(function (country) {
    return !supportedCountryCodes.includes(country.code);
  });
  return [].concat(_toConsumableArray(mapCountriesToOptions(supportedCountryList)), [{
    title: '------',
    value: '',
    disabled: true
  }], _toConsumableArray(mapCountriesToOptions(otherCountryList)));
};

var AddressFormCountryField_AddressFormCountryField = function AddressFormCountryField(_ref2) {
  var supportedCountryCodes = _ref2.supportedCountryCodes,
      _onChange = _ref2.onChange,
      other = _objectWithoutProperties(_ref2, ["supportedCountryCodes", "onChange"]);

  return react_default.a.createElement(_lingui_react["I18n"], null, function (_ref3) {
    var i18n = _ref3.i18n;
    return react_default.a.createElement(StyledSelectInput, _extends({
      label: i18n._('Country'),
      name: "country",
      "data-qa-id": "input-text-address-country",
      options: AddressFormCountryField_getCountryOptions(supportedCountryCodes),
      onChange: function onChange(value) {
        return _onChange(value.toString());
      }
    }, other));
  });
};

/* harmony default export */ var AddressForm_AddressFormCountryField = (AddressFormCountryField_AddressFormCountryField);
// EXTERNAL MODULE: ../react-lib/src/components/formFields/TextInput/index.js + 1 modules
var TextInput = __webpack_require__(214);

// CONCATENATED MODULE: ../react-lib/src/components/forms/AddressForm/AddressFormLine1Field.jsx
function AddressFormLine1Field__extends() { AddressFormLine1Field__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return AddressFormLine1Field__extends.apply(this, arguments); }






var StyledTextInput = Object(styled_components_browser_esm["default"])(TextInput["a" /* default */]).withConfig({
  displayName: "AddressFormLine1Field__StyledTextInput",
  componentId: "d4trl6-0"
})(["flex:2;", "{width:100%;flex:none;}"], styles["i" /* MQ */].XS);

var AddressFormLine1Field_AddresFormLine1Field = function AddresFormLine1Field(props) {
  return react_default.a.createElement(_lingui_react["I18n"], null, function (_ref) {
    var i18n = _ref.i18n;
    return react_default.a.createElement(StyledTextInput, AddressFormLine1Field__extends({
      sensitive: true,
      label: i18n._('Address Line 1'),
      name: "address-line1",
      placeholder: i18n._('Address Line 1'),
      autoComplete: "address-line1",
      "data-qa-id": "input-text-address-line-1"
    }, props));
  });
};

/* harmony default export */ var AddressFormLine1Field = (AddressFormLine1Field_AddresFormLine1Field);
// CONCATENATED MODULE: ../react-lib/src/components/forms/AddressForm/AddressFormLine2Field.jsx
function AddressFormLine2Field__extends() { AddressFormLine2Field__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return AddressFormLine2Field__extends.apply(this, arguments); }

function AddressFormLine2Field__objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = AddressFormLine2Field__objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function AddressFormLine2Field__objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }






var AddressFormLine2Field_StyledTextInput = Object(styled_components_browser_esm["default"])(TextInput["a" /* default */]).withConfig({
  displayName: "AddressFormLine2Field__StyledTextInput",
  componentId: "sc-36gpcb-0"
})(["flex:1;margin-left:", ";", "{width:100%;flex:none;margin-left:0;}"], styles["k" /* Spacing */].M, styles["i" /* MQ */].XS);

var AddressFormLine2Field_AddressFormLine2Field = function AddressFormLine2Field(_ref) {
  var isUS = _ref.isUS,
      other = AddressFormLine2Field__objectWithoutProperties(_ref, ["isUS"]);

  var label = isUS ?
  /*i18n*/
  {
    id: "Apt., Ste., Bldg. (Optional)"
  } :
  /*i18n*/
  {
    id: "Address Line 2"
  };
  return react_default.a.createElement(_lingui_react["I18n"], null, function (_ref2) {
    var i18n = _ref2.i18n;
    return react_default.a.createElement(AddressFormLine2Field_StyledTextInput, AddressFormLine2Field__extends({
      sensitive: true,
      label: i18n._(label),
      name: "address-line2",
      placeholder: i18n._(label),
      autoComplete: "address-line2",
      "data-qa-id": "input-text-address-line-2"
    }, other));
  });
};

/* harmony default export */ var AddressForm_AddressFormLine2Field = (AddressFormLine2Field_AddressFormLine2Field);
// EXTERNAL MODULE: ../react-lib/src/components/formFields/ZipcodeInput/index.js + 1 modules
var ZipcodeInput = __webpack_require__(428);

// CONCATENATED MODULE: ../react-lib/src/components/forms/AddressForm/AddressFormZipcodeField.jsx
function AddressFormZipcodeField__extends() { AddressFormZipcodeField__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return AddressFormZipcodeField__extends.apply(this, arguments); }

function AddressFormZipcodeField__objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = AddressFormZipcodeField__objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function AddressFormZipcodeField__objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }






var StyledZipcodeInput = Object(styled_components_browser_esm["default"])(ZipcodeInput["a" /* default */]).withConfig({
  displayName: "AddressFormZipcodeField__StyledZipcodeInput",
  componentId: "sc-1l8qx7m-0"
})(["flex:1;margin-left:", ";", "{width:100%;flex:none;margin-left:0;}"], styles["k" /* Spacing */].M, styles["i" /* MQ */].XS);

var AddressFormZipcodeField_AddresFormZipcodeField = function AddresFormZipcodeField(_ref) {
  var isUS = _ref.isUS,
      other = AddressFormZipcodeField__objectWithoutProperties(_ref, ["isUS"]);

  var label = isUS ?
  /*i18n*/
  {
    id: "Zip"
  } :
  /*i18n*/
  {
    id: "Zip/Postal Code"
  };
  return react_default.a.createElement(_lingui_react["I18n"], null, function (_ref2) {
    var i18n = _ref2.i18n;
    return react_default.a.createElement(StyledZipcodeInput, AddressFormZipcodeField__extends({
      label: i18n._(label),
      name: "zip",
      "data-qa-id": "input-text-address-zip-code"
    }, other));
  });
};

/* harmony default export */ var AddressFormZipcodeField = (AddressFormZipcodeField_AddresFormZipcodeField);
// CONCATENATED MODULE: ../react-lib/src/components/formFields/CityInput/CityInput.jsx
function CityInput__extends() { CityInput__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return CityInput__extends.apply(this, arguments); }




/* harmony default export */ var CityInput = (function (props) {
  return react_default.a.createElement(_lingui_react["I18n"], null, function (_ref) {
    var i18n = _ref.i18n;
    return react_default.a.createElement(TextInput["a" /* default */], CityInput__extends({
      name: "city",
      placeholder: i18n._('City'),
      autoComplete: "address-level2"
    }, props));
  });
});
// CONCATENATED MODULE: ../react-lib/src/components/formFields/CityInput/index.js

// CONCATENATED MODULE: ../react-lib/src/components/forms/AddressForm/AddressFormCityField.jsx
function AddressFormCityField__extends() { AddressFormCityField__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return AddressFormCityField__extends.apply(this, arguments); }

function AddressFormCityField__objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = AddressFormCityField__objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function AddressFormCityField__objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }






var StyledCityInput = Object(styled_components_browser_esm["default"])(CityInput).withConfig({
  displayName: "AddressFormCityField__StyledCityInput",
  componentId: "sc-9o8z4k-0"
})(["flex:2;", "{margin-right:0;}"], styles["i" /* MQ */].XS);

var AddressFormCityField_AddressFormCityField = function AddressFormCityField(_ref) {
  var isUS = _ref.isUS,
      other = AddressFormCityField__objectWithoutProperties(_ref, ["isUS"]);

  return react_default.a.createElement(_lingui_react["I18n"], null, function (_ref2) {
    var i18n = _ref2.i18n;
    return react_default.a.createElement(StyledCityInput, AddressFormCityField__extends({
      label: isUS ? i18n._('City') : i18n._('City/Town/District'),
      name: "city",
      "data-qa-id": "input-text-address-city"
    }, other));
  });
};

/* harmony default export */ var AddressForm_AddressFormCityField = (AddressFormCityField_AddressFormCityField);
// CONCATENATED MODULE: ../react-lib/src/constants/unitedStates.constants.js
/* harmony default export */ var unitedStates_constants = ([{
  code: 'AL',
  name: 'Alabama',
  isTerritory: false
}, {
  code: 'AK',
  name: 'Alaska',
  isTerritory: false
}, {
  code: 'AS',
  name: 'American Samoa',
  isTerritory: true
}, {
  code: 'AZ',
  name: 'Arizona',
  isTerritory: false
}, {
  code: 'AR',
  name: 'Arkansas',
  isTerritory: false
}, {
  code: 'CA',
  name: 'California',
  isTerritory: false
}, {
  code: 'CO',
  name: 'Colorado',
  isTerritory: false
}, {
  code: 'CT',
  name: 'Connecticut',
  isTerritory: false
}, {
  code: 'DE',
  name: 'Delaware',
  isTerritory: false
}, {
  code: 'DC',
  name: 'District of Columbia',
  isTerritory: false
}, {
  code: 'FL',
  name: 'Florida',
  isTerritory: false
}, {
  code: 'GA',
  name: 'Georgia',
  isTerritory: false
}, {
  code: 'GU',
  name: 'Guam',
  isTerritory: true
}, {
  code: 'HI',
  name: 'Hawaii',
  isTerritory: false
}, {
  code: 'ID',
  name: 'Idaho',
  isTerritory: false
}, {
  code: 'IL',
  name: 'Illinois',
  isTerritory: false
}, {
  code: 'IN',
  name: 'Indiana',
  isTerritory: false
}, {
  code: 'IA',
  name: 'Iowa',
  isTerritory: false
}, {
  code: 'KS',
  name: 'Kansas',
  isTerritory: false
}, {
  code: 'KY',
  name: 'Kentucky',
  isTerritory: false
}, {
  code: 'LA',
  name: 'Louisiana',
  isTerritory: false
}, {
  code: 'ME',
  name: 'Maine',
  isTerritory: false
}, {
  code: 'MD',
  name: 'Maryland',
  isTerritory: false
}, {
  code: 'MA',
  name: 'Massachusetts',
  isTerritory: false
}, {
  code: 'MI',
  name: 'Michigan',
  isTerritory: false
}, {
  code: 'MN',
  name: 'Minnesota',
  isTerritory: false
}, {
  code: 'MS',
  name: 'Mississippi',
  isTerritory: false
}, {
  code: 'MO',
  name: 'Missouri',
  isTerritory: false
}, {
  code: 'MT',
  name: 'Montana',
  isTerritory: false
}, {
  code: 'NE',
  name: 'Nebraska',
  isTerritory: false
}, {
  code: 'NV',
  name: 'Nevada',
  isTerritory: false
}, {
  code: 'NH',
  name: 'New Hampshire',
  isTerritory: false
}, {
  code: 'NJ',
  name: 'New Jersey',
  isTerritory: false
}, {
  code: 'NM',
  name: 'New Mexico',
  isTerritory: false
}, {
  code: 'NY',
  name: 'New York',
  isTerritory: false
}, {
  code: 'NC',
  name: 'North Carolina',
  isTerritory: false
}, {
  code: 'ND',
  name: 'North Dakota',
  isTerritory: false
}, {
  code: 'MP',
  name: 'Northern Mariana Islands',
  isTerritory: true
}, {
  code: 'OH',
  name: 'Ohio',
  isTerritory: false
}, {
  code: 'OK',
  name: 'Oklahoma',
  isTerritory: false
}, {
  code: 'OR',
  name: 'Oregon',
  isTerritory: false
}, {
  code: 'PA',
  name: 'Pennsylvania',
  isTerritory: false
}, {
  code: 'PR',
  name: 'Puerto Rico',
  isTerritory: true
}, {
  code: 'RI',
  name: 'Rhode Island',
  isTerritory: false
}, {
  code: 'SC',
  name: 'South Carolina',
  isTerritory: false
}, {
  code: 'SD',
  name: 'South Dakota',
  isTerritory: false
}, {
  code: 'TN',
  name: 'Tennessee',
  isTerritory: false
}, {
  code: 'TX',
  name: 'Texas',
  isTerritory: false
}, {
  code: 'UT',
  name: 'Utah',
  isTerritory: false
}, {
  code: 'VT',
  name: 'Vermont',
  isTerritory: false
}, {
  code: 'VI',
  name: 'Virgin Islands',
  isTerritory: true
}, {
  code: 'VA',
  name: 'Virginia',
  isTerritory: false
}, {
  code: 'WA',
  name: 'Washington',
  isTerritory: false
}, {
  code: 'WV',
  name: 'West Virginia',
  isTerritory: false
}, {
  code: 'WI',
  name: 'Wisconsin',
  isTerritory: false
}, {
  code: 'WY',
  name: 'Wyoming',
  isTerritory: false
}]);
// CONCATENATED MODULE: ../react-lib/src/components/formFields/StateInput/StateInput.jsx
function StateInput__extends() { StateInput__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return StateInput__extends.apply(this, arguments); }





/* harmony default export */ var StateInput = (function (props) {
  return react_default.a.createElement(_lingui_react["I18n"], null, function (_ref) {
    var i18n = _ref.i18n;
    return react_default.a.createElement(Select["a" /* default */], StateInput__extends({
      name: "zipcode",
      placeholder: i18n._('State'),
      autoComplete: "address-level1",
      options: unitedStates_constants.map(function (s) {
        return {
          value: s.code,
          title: s.code
        };
      })
    }, props));
  });
});
// CONCATENATED MODULE: ../react-lib/src/components/formFields/StateInput/index.js

// CONCATENATED MODULE: ../react-lib/src/components/forms/AddressForm/AddressFormStateField.jsx
function AddressFormStateField__extends() { AddressFormStateField__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return AddressFormStateField__extends.apply(this, arguments); }

function AddressFormStateField__objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = AddressFormStateField__objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function AddressFormStateField__objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }







var stateFieldCSS = Object(styled_components_browser_esm["css"])(["flex:1;margin-left:", ";", "{width:100%;flex:none;margin-left:0;}"], styles["k" /* Spacing */].M, styles["i" /* MQ */].XS);
var StyledStateInput = Object(styled_components_browser_esm["default"])(StateInput).withConfig({
  displayName: "AddressFormStateField__StyledStateInput",
  componentId: "sc-4p4udk-0"
})(["", ";"], stateFieldCSS);
var AddressFormStateField_StyledTextInput = Object(styled_components_browser_esm["default"])(TextInput["a" /* default */]).withConfig({
  displayName: "AddressFormStateField__StyledTextInput",
  componentId: "sc-4p4udk-1"
})(["", ";"], stateFieldCSS);

var AddressFormStateField_AddressFormStateField = function AddressFormStateField(_ref) {
  var isUS = _ref.isUS,
      other = AddressFormStateField__objectWithoutProperties(_ref, ["isUS"]);

  return react_default.a.createElement(_lingui_react["I18n"], null, function (_ref2) {
    var i18n = _ref2.i18n;
    return isUS ? react_default.a.createElement(StyledStateInput, AddressFormStateField__extends({
      label: i18n._('State'),
      name: "state",
      "data-qa-id": "input-select-address-state"
    }, other)) : react_default.a.createElement(AddressFormStateField_StyledTextInput, AddressFormStateField__extends({
      label: i18n._('State/Province'),
      name: "state",
      "data-qa-id": "input-select-address-state-province"
    }, other));
  });
};

/* harmony default export */ var AddressForm_AddressFormStateField = (AddressFormStateField_AddressFormStateField);
// CONCATENATED MODULE: ../react-lib/src/components/forms/AddressForm/AddressForm.jsx
function AddressForm__objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = AddressForm__objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function AddressForm__objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }














var FlexRow = styled_components_browser_esm["default"].div.withConfig({
  displayName: "AddressForm__FlexRow",
  componentId: "sc-1jvg4ij-0"
})(["display:flex;flex-direction:row;justify-content:space-between;flex-wrap:wrap;align-items:flex-end;"]);

var AddressForm_AddressForm = function AddressForm(_ref) {
  var address = _ref.address,
      _onChange = _ref.onChange,
      onDismiss = _ref.onDismiss,
      errorMessage = _ref.errorMessage,
      successMessage = _ref.successMessage,
      validationErrors = _ref.validationErrors,
      postalRegExp = _ref.postalRegExp,
      supportedCountryCodes = _ref.supportedCountryCodes,
      other = AddressForm__objectWithoutProperties(_ref, ["address", "onChange", "onDismiss", "errorMessage", "successMessage", "validationErrors", "postalRegExp", "supportedCountryCodes"]);

  return react_default.a.createElement(_lingui_react["I18n"], null, function () {
    var isUS = address.countryCode === 'US';
    var showStateField = Object(utils_address["b" /* isStateRequired */])(address.countryCode);
    return react_default.a.createElement("div", other, react_default.a.createElement(SuccessOrErrorAlert["a" /* default */], {
      error: errorMessage,
      success: successMessage,
      onDismiss: onDismiss
    }), react_default.a.createElement(AddressForm_AddressFormCountryField, {
      value: address.countryCode,
      onChange: function onChange(countryCode) {
        return _onChange({
          countryCode: countryCode
        });
      },
      validationError: validationErrors.address.countryCode,
      supportedCountryCodes: supportedCountryCodes
    }), react_default.a.createElement(FlexRow, null, react_default.a.createElement(AddressFormLine1Field, {
      value: address.addressLine1,
      onChange: function onChange(addressLine1) {
        return _onChange({
          addressLine1: addressLine1
        });
      },
      validationError: validationErrors.address.addressLine1
    }), react_default.a.createElement(AddressForm_AddressFormLine2Field, {
      value: address.addressLine2,
      onChange: function onChange(addressLine2) {
        return _onChange({
          addressLine2: addressLine2
        });
      },
      validationError: validationErrors.address.addressLine2,
      isUS: isUS
    })), react_default.a.createElement(FlexRow, null, react_default.a.createElement(AddressForm_AddressFormCityField, {
      value: address.city,
      onChange: function onChange(city) {
        return _onChange({
          city: city
        });
      },
      validationError: validationErrors.address.city,
      isUS: isUS
    }), showStateField && react_default.a.createElement(AddressForm_AddressFormStateField, {
      value: address.state,
      onChange: function onChange(state) {
        return _onChange({
          state: state
        });
      },
      validationError: validationErrors.address.state,
      isUS: isUS
    }), react_default.a.createElement(AddressFormZipcodeField, {
      value: address.zip,
      onChange: function onChange(zip) {
        return _onChange({
          zip: zip
        });
      },
      validationError: validationErrors.address.zip,
      postalRegExp: postalRegExp,
      isUS: isUS
    })));
  });
};

AddressForm_AddressForm.getValidators = function (data) {
  return {
    address: {
      countryCode: validators["required"],
      addressLine1: validators["required"],
      zip: validators["required"],
      city: validators["required"],
      state: function state() {
        return data && Object(utils_address["b" /* isStateRequired */])(data.countryCode) ? Object(validators["required"])() : null;
      }
    }
  };
};

AddressForm_AddressForm.defaultProps = {
  address: Object(addressFactory["a" /* default */])(),
  errorMessage: '',
  successMessage: '',
  validationErrors: {
    address: {}
  },
  onDismiss: undefined,
  postalRegExp: null,
  supportedCountryCodes: []
};
/* harmony default export */ var forms_AddressForm_AddressForm = __webpack_exports__["a"] = (AddressForm_AddressForm);

/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ../node_modules/react-stripe-elements/es/index.js
var es = __webpack_require__(262);
var es_default = /*#__PURE__*/__webpack_require__.n(es);

// EXTERNAL MODULE: ../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(1);

// EXTERNAL MODULE: ../react-lib/src/components/typography/AnimatedSpinner/index.js + 1 modules
var AnimatedSpinner = __webpack_require__(272);

// EXTERNAL MODULE: ../utilities/stripe.client.js + 2 modules
var stripe_client = __webpack_require__(460);

// CONCATENATED MODULE: ../react-lib/src/components/utils/StripeProvider/StripeProvider.jsx
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }





 // NOTE(Ryan) the min-height here helps prevent the layout jumping too much while loading Stripe.js

var StyledSpinner = Object(styled_components_browser_esm["default"])(AnimatedSpinner["a" /* default */]).withConfig({
  displayName: "StripeProvider__StyledSpinner",
  componentId: "sc-69ihv1-0"
})(["min-height:350px;"]);

var StripeProvider_StripeProvider =
/*#__PURE__*/
function (_Component) {
  _inherits(StripeProvider, _Component);

  function StripeProvider() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, StripeProvider);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(StripeProvider)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      stripe: null
    };

    _this.initStripe = function (stripe) {
      _this.setState(function () {
        return {
          stripe: stripe
        };
      }, _this.props.onStripeLoaded);
    };

    return _this;
  }

  _createClass(StripeProvider, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var stripeClient;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return Object(stripe_client["c" /* getStripeClient */])(this.props.apiKey);

              case 2:
                stripeClient = _context.sent;
                this.initStripe(stripeClient);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          language = _this$props.language;
      var stripe = this.state.stripe;
      return react_default.a.createElement(es["StripeProvider"], {
        stripe: stripe
      }, stripe ? react_default.a.createElement(es["Elements"], {
        locale: language,
        key: language
      }, children) : react_default.a.createElement(StyledSpinner, null));
    }
  }]);

  return StripeProvider;
}(react["Component"]);

StripeProvider_StripeProvider.defaultProps = {
  apiKey: '',
  onStripeLoaded: function onStripeLoaded() {}
};

// CONCATENATED MODULE: ../react-lib/src/components/utils/StripeProvider/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return StripeProvider_StripeProvider; });


/***/ }),
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Textarea__ = __webpack_require__(463);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Textarea__["a"]; });


/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ../node_modules/@lingui/react/index.js
var _lingui_react = __webpack_require__(3);
var _lingui_react_default = /*#__PURE__*/__webpack_require__.n(_lingui_react);

// EXTERNAL MODULE: ../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(1);

// EXTERNAL MODULE: ../react-lib/src/components/formFields/Input/index.js
var Input = __webpack_require__(143);

// EXTERNAL MODULE: ../react-lib/src/styles/index.js + 3 modules
var styles = __webpack_require__(2);

// EXTERNAL MODULE: ../node_modules/intl-tel-input/index.js
var intl_tel_input = __webpack_require__(544);
var intl_tel_input_default = /*#__PURE__*/__webpack_require__.n(intl_tel_input);

// EXTERNAL MODULE: ../node_modules/intl-tel-input/build/css/intlTelInput.css
var intlTelInput = __webpack_require__(546);
var intlTelInput_default = /*#__PURE__*/__webpack_require__.n(intlTelInput);

// EXTERNAL MODULE: ../node_modules/cleave.js/dist/cleave-esm.js
var cleave_esm = __webpack_require__(547);

// EXTERNAL MODULE: ../utilities/retry.client.js
var retry_client = __webpack_require__(261);

// CONCATENATED MODULE: ../react-lib/src/components/formFields/IntlPhoneInput/IntlPhoneInputUtils.client.js
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }





/**
 * Most of this file was adapted from /frontend/app/js/components/intl_tel_input.js
 */

var DEFAULT_LOCALE = 'en-us';
var COUNTRIES_TO_USE_CLEAVE_FOR = ['us', 'ca'];
var DEFAULT_PREFERRED_COUNTRIES = ['us', 'ca', 'gb', 'de', 'es', 'fr', 'it', 'nl', 'no', 'se'];
var MISSING_MODULE_MESSAGE = 'Cannot find module';

var handleChange = function handleChange(intlTelInputInstance, onChange) {
  onChange(intlTelInputInstance.getNumber(), intlTelInputInstance.isValidNumber());
};

var IntlPhoneInputUtils_client_initCleave = function initCleave(inputRef) {
  return new cleave_esm["a" /* default */](inputRef, {
    blocks: [3, 3, 4],
    delimiter: '-',
    numericOnly: true
  });
};

var getLocalizedCountries =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee2(locale) {
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!(locale === DEFAULT_LOCALE)) {
              _context2.next = 2;
              break;
            }

            return _context2.abrupt("return", {});

          case 2:
            return _context2.abrupt("return", Object(retry_client["a" /* default */])(
            /*#__PURE__*/
            _asyncToGenerator(
            /*#__PURE__*/
            regeneratorRuntime.mark(function _callee() {
              var localeModule;
              return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      _context.prev = 0;
                      _context.next = 3;
                      return __webpack_require__(548)("./".concat(locale, "/countries.json"));

                    case 3:
                      localeModule = _context.sent;
                      return _context.abrupt("return", localeModule["default"]);

                    case 7:
                      _context.prev = 7;
                      _context.t0 = _context["catch"](0);

                      if (_context.t0.message.includes(MISSING_MODULE_MESSAGE)) {
                        _context.next = 11;
                        break;
                      }

                      throw _context.t0;

                    case 11:
                      return _context.abrupt("return", {});

                    case 12:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee, null, [[0, 7]]);
            }))));

          case 3:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getLocalizedCountries(_x) {
    return _ref.apply(this, arguments);
  };
}();

var initIntlPhoneInput =
/*#__PURE__*/
function () {
  var _ref3 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee3(inputRef, onChange) {
    var countryCode,
        locale,
        preferredCountries,
        localizedCountries,
        intlTelInputInstance,
        cleave,
        _args3 = arguments;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            countryCode = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : 'us';
            locale = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : DEFAULT_LOCALE;
            preferredCountries = _args3.length > 4 && _args3[4] !== undefined ? _args3[4] : DEFAULT_PREFERRED_COUNTRIES;
            _context3.next = 5;
            return getLocalizedCountries(locale);

          case 5:
            localizedCountries = _context3.sent;

            // extra insurance that we don't use an empty list of preferredCountries
            if (preferredCountries.length === 0) {
              preferredCountries = DEFAULT_PREFERRED_COUNTRIES; // eslint-disable-line no-param-reassign
            }

            intlTelInputInstance = intl_tel_input_default()(inputRef, {
              utilsScript: 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/16.0.4/js/utils.js',
              autoPlaceholder: 'off',
              preferredCountries: preferredCountries,
              localizedCountries: localizedCountries,
              initialCountry: countryCode
            });

            if (COUNTRIES_TO_USE_CLEAVE_FOR.includes(countryCode.toLowerCase())) {
              cleave = IntlPhoneInputUtils_client_initCleave(inputRef);
            }

            inputRef.addEventListener('countrychange', function () {
              var newCountryCode = intlTelInputInstance.getSelectedCountryData().iso2;

              if (COUNTRIES_TO_USE_CLEAVE_FOR.includes(newCountryCode)) {
                cleave = IntlPhoneInputUtils_client_initCleave(inputRef);
                handleChange(intlTelInputInstance, onChange);
              } else if (cleave) {
                cleave.destroy();
                handleChange(intlTelInputInstance, onChange);
              }
            });
            inputRef.addEventListener('input', function () {
              handleChange(intlTelInputInstance, onChange);
            });
            return _context3.abrupt("return", {
              cleanup: function cleanup() {
                if (cleave) {
                  cleave.destroy();
                }

                intlTelInputInstance.destroy();
              },
              pluginInstance: intlTelInputInstance
            });

          case 12:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function initIntlPhoneInput(_x2, _x3) {
    return _ref3.apply(this, arguments);
  };
}();
/* harmony default export */ var IntlPhoneInputUtils_client = ({
  initIntlPhoneInput: initIntlPhoneInput
});
// CONCATENATED MODULE: ../react-lib/src/components/formFields/IntlPhoneInput/IntlPhoneInput.jsx
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function IntlPhoneInput_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function IntlPhoneInput__asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { IntlPhoneInput_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { IntlPhoneInput_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }







var IntlPhoneInputStylingWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "IntlPhoneInput__IntlPhoneInputStylingWrapper",
  componentId: "sc-141r9l3-0"
})([".iti{width:100%;}input{border:1px solid ", ";}"], function (props) {
  return props.styleAsError ? styles["d" /* DSToken */].BORDER_COLOR_ERROR : styles["d" /* DSToken */].BORDER_COLOR_PRIMARY;
});

var IntlPhoneInput_IntlPhoneInput = function IntlPhoneInput(_ref) {
  var placeholder = _ref.placeholder,
      label = _ref.label,
      onChange = _ref.onChange,
      countryCode = _ref.countryCode,
      locale = _ref.locale,
      supportedCountryCodes = _ref.supportedCountryCodes,
      validationError = _ref.validationError,
      other = _objectWithoutProperties(_ref, ["placeholder", "label", "onChange", "countryCode", "locale", "supportedCountryCodes", "validationError"]);

  var _inputRef = Object(react["useRef"])();

  var intlPhonePluginRef = Object(react["useRef"])();
  Object(react["useEffect"])(function () {
    var init =
    /*#__PURE__*/
    function () {
      var _ref2 = IntlPhoneInput__asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_inputRef.current) {
                  _context.next = 6;
                  break;
                }

                _context.next = 3;
                return initIntlPhoneInput(_inputRef.current, onChange, countryCode, locale, supportedCountryCodes);

              case 3:
                intlPhonePluginRef.current = _context.sent;
                _context.next = 7;
                break;

              case 6:
                throw new Error('inputRef undefined during initIntlPhoneInput()');

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function init() {
        return _ref2.apply(this, arguments);
      };
    }();

    init();
    return function () {
      return intlPhonePluginRef.current && intlPhonePluginRef.current.cleanup();
    };
  }, []);
  Object(react["useEffect"])(function () {
    if (intlPhonePluginRef.current) {
      intlPhonePluginRef.current.pluginInstance.setCountry(countryCode);
    }
  }, [countryCode]);
  return react_default.a.createElement(_lingui_react["I18n"], null, function (_ref3) {
    var i18n = _ref3.i18n;
    return react_default.a.createElement(IntlPhoneInputStylingWrapper, {
      styleAsError: !!validationError
    }, react_default.a.createElement(Input["a" /* default */], _extends({}, other, {
      sensitive: true,
      type: "tel",
      label: i18n._(label),
      placeholder: i18n._(placeholder),
      inputRef: function inputRef(node) {
        _inputRef.current = node;
      },
      validationError: validationError
    })));
  });
};

IntlPhoneInput_IntlPhoneInput.defaultProps = {
  label:
  /*i18n*/
  {
    id: "Phone Number"
  },
  placeholder:
  /*i18n*/
  {
    id: "Phone Number"
  },
  countryCode: 'us',
  locale: 'en-us',
  supportedCountryCodes: ['us']
};
/* harmony default export */ var formFields_IntlPhoneInput_IntlPhoneInput = (IntlPhoneInput_IntlPhoneInput);
// CONCATENATED MODULE: ../react-lib/src/components/formFields/IntlPhoneInput/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return formFields_IntlPhoneInput_IntlPhoneInput; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return IntlPhoneInputStylingWrapper; });


/***/ }),
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Elements = __webpack_require__(352);

var _Provider = __webpack_require__(381);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// react-redux does a bunch of stuff with pure components / checking if it needs to re-render.
// not sure if we need to do the same.
var inject = function inject(WrappedComponent) {
  var _class, _temp;

  var componentOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _componentOptions$wit = componentOptions.withRef,
      withRef = _componentOptions$wit === undefined ? false : _componentOptions$wit;


  return _temp = _class = function (_React$Component) {
    _inherits(_class, _React$Component);

    function _class(props, context) {
      _classCallCheck(this, _class);

      if (!context || !context.getRegisteredElements) {
        throw new Error('It looks like you are trying to inject Stripe context outside of an Elements context.\nPlease be sure the component that calls createSource or createToken is within an <Elements> component.');
      }

      var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

      _this.findElement = function (filterBy, specifiedType) {
        var allElements = _this.context.getRegisteredElements();
        var filteredElements = allElements.filter(function (e) {
          return e[filterBy];
        });
        var matchingElements = specifiedType === 'auto' ? filteredElements : filteredElements.filter(function (e) {
          return e[filterBy] === specifiedType;
        });

        if (matchingElements.length === 1) {
          return matchingElements[0].element;
        } else if (matchingElements.length > 1) {
          throw new Error('You did not specify the type of Source or Token to create.\n        We could not infer which Element you want to use for this operation.');
        } else {
          return null;
        }
      };

      _this.requireElement = function (filterBy, specifiedType) {
        var element = _this.findElement(filterBy, specifiedType);
        if (element) {
          return element;
        } else {
          throw new Error('You did not specify the type of Source or Token to create.\n        We could not infer which Element you want to use for this operation.');
        }
      };

      _this.wrappedCreateToken = function (stripe) {
        return function () {
          var tokenTypeOrOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

          if (tokenTypeOrOptions && (typeof tokenTypeOrOptions === 'undefined' ? 'undefined' : _typeof(tokenTypeOrOptions)) === 'object') {
            // First argument is options; infer the Element and tokenize
            var opts = tokenTypeOrOptions;

            var tokenType = opts.type,
                rest = _objectWithoutProperties(opts, ['type']);

            var specifiedType = typeof tokenType === 'string' ? tokenType : 'auto';
            // Since only options were passed in, a corresponding Element must exist
            // for the tokenization to succeed -- thus we call requireElement.
            var element = _this.requireElement('impliedTokenType', specifiedType);
            return stripe.createToken(element, rest);
          } else if (typeof tokenTypeOrOptions === 'string') {
            // First argument is token type; tokenize with token type and options
            var _tokenType = tokenTypeOrOptions;
            return stripe.createToken(_tokenType, options);
          } else {
            // If a bad value was passed in for options, throw an error.
            throw new Error('Invalid options passed to createToken. Expected an object, got ' + (typeof tokenTypeOrOptions === 'undefined' ? 'undefined' : _typeof(tokenTypeOrOptions)) + '.');
          }
        };
      };

      _this.wrappedCreateSource = function (stripe) {
        return function () {
          var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

          if (options && (typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
            if (typeof options.type !== 'string') {
              throw new Error('Invalid Source type passed to createSource. Expected string, got ' + _typeof(options.type) + '.');
            }

            var element = _this.findElement('impliedSourceType', options.type);
            if (element) {
              // If an Element exists for the source type, use that to create the
              // corresponding source.
              //
              // NOTE: this prevents users from independently creating sources of
              // type `foo` if an Element that can create `foo` sources exists in
              // the current <Elements /> context.
              return stripe.createSource(element, options);
            } else {
              // If no Element exists for the source type, directly create a source.
              return stripe.createSource(options);
            }
          } else {
            // If a bad value was passed in for options, throw an error.
            throw new Error('Invalid options passed to createSource. Expected an object, got ' + (typeof options === 'undefined' ? 'undefined' : _typeof(options)) + '.');
          }
        };
      };

      if (_this.context.tag === 'sync') {
        _this.state = {
          stripe: _this.stripeProps(_this.context.stripe)
        };
      } else {
        _this.state = {
          stripe: null
        };
      }
      return _this;
    }

    _class.prototype.componentDidMount = function componentDidMount() {
      var _this2 = this;

      if (this.context.tag === 'async') {
        this.context.addStripeLoadListener(function (stripe) {
          _this2.setState({
            stripe: _this2.stripeProps(stripe)
          });
        });
      } else {
        // when 'sync', it's already set in the constructor.
      }
    };

    _class.prototype.getWrappedInstance = function getWrappedInstance() {
      if (!withRef) {
        throw new Error('To access the wrapped instance, the `{withRef: true}` option must be set when calling `injectStripe()`');
      }
      return this.wrappedInstance;
    };

    _class.prototype.stripeProps = function stripeProps(stripe) {
      return _extends({}, stripe, {
        // These are the only functions that take elements.
        createToken: this.wrappedCreateToken(stripe),
        createSource: this.wrappedCreateSource(stripe)
      });
    };

    // Finds an Element by the specified type, if one exists.
    // Throws if multiple Elements match.


    // Require that exactly one Element is found for the specified type.
    // Throws if no Element is found.


    // Wraps createToken in order to infer the Element that is being tokenized.


    // Wraps createSource in order to infer the Element that is being used for
    // source creation.


    _class.prototype.render = function render() {
      var _this3 = this;

      return _react2.default.createElement(WrappedComponent, _extends({}, this.props, {
        stripe: this.state.stripe,
        ref: withRef ? function (c) {
          _this3.wrappedInstance = c;
        } : null
      }));
    };

    return _class;
  }(_react2.default.Component), _class.contextTypes = _extends({}, _Provider.providerContextTypes, _Elements.injectContextTypes), _class.displayName = 'InjectStripe(' + (WrappedComponent.displayName || WrappedComponent.name || 'Component') + ')', _temp;
};

exports.default = inject;

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _isEqual = __webpack_require__(494);

var _isEqual2 = _interopRequireDefault(_isEqual);

var _Elements = __webpack_require__(352);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var noop = function noop() {};

var _extractOptions = function _extractOptions(props) {
  var id = props.id,
      className = props.className,
      onChange = props.onChange,
      onFocus = props.onFocus,
      onBlur = props.onBlur,
      onReady = props.onReady,
      options = _objectWithoutProperties(props, ['id', 'className', 'onChange', 'onFocus', 'onBlur', 'onReady']);

  return options;
};

var capitalized = function capitalized(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

var Element = function Element(type) {
  var _class, _temp;

  var hocOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return _temp = _class = function (_React$Component) {
    _inherits(_class, _React$Component);

    function _class(props, context) {
      _classCallCheck(this, _class);

      var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

      _this.handleRef = function (ref) {
        _this._ref = ref;
      };

      _this._element = null;

      var options = _extractOptions(_this.props);
      // We keep track of the extracted options on this._options to avoid re-rendering.
      // (We would unnecessarily re-render if we were tracking them with state.)
      _this._options = options;
      return _this;
    }

    _class.prototype.componentDidMount = function componentDidMount() {
      var _this2 = this;

      this.context.addElementsLoadListener(function (elements) {
        var element = elements.create(type, _this2._options);
        _this2._element = element;

        _this2._setupEventListeners(element);

        element.mount(_this2._ref);

        // Register Element for automatic token / source creation
        if (hocOptions.impliedTokenType || hocOptions.impliedSourceType) {
          _this2.context.registerElement(element, hocOptions.impliedTokenType, hocOptions.impliedSourceType);
        }
      });
    };

    _class.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var options = _extractOptions(nextProps);
      if (Object.keys(options).length !== 0 && !(0, _isEqual2.default)(options, this._options)) {
        this._options = options;
        if (this._element) {
          this._element.update(options);
        }
      }
    };

    _class.prototype.componentWillUnmount = function componentWillUnmount() {
      if (this._element) {
        var element = this._element;
        element.destroy();
        this.context.unregisterElement(element);
      }
    };

    _class.prototype._setupEventListeners = function _setupEventListeners(element) {
      var _this3 = this;

      element.on('ready', function () {
        _this3.props.onReady(_this3._element);
      });

      element.on('change', function (change) {
        _this3.props.onChange(change);
      });

      element.on('blur', function () {
        var _props;

        return (_props = _this3.props).onBlur.apply(_props, arguments);
      });
      element.on('focus', function () {
        var _props2;

        return (_props2 = _this3.props).onFocus.apply(_props2, arguments);
      });
    };

    _class.prototype.render = function render() {
      return _react2.default.createElement('div', {
        id: this.props.id,
        className: this.props.className,
        ref: this.handleRef
      });
    };

    return _class;
  }(_react2.default.Component), _class.propTypes = {
    id: _propTypes2.default.string,
    className: _propTypes2.default.string,
    onChange: _propTypes2.default.func,
    onBlur: _propTypes2.default.func,
    onFocus: _propTypes2.default.func,
    onReady: _propTypes2.default.func
  }, _class.defaultProps = {
    id: undefined,
    className: undefined,
    onChange: noop,
    onBlur: noop,
    onFocus: noop,
    onReady: noop
  }, _class.contextTypes = _Elements.elementContextTypes, _class.displayName = capitalized(type) + 'Element', _temp;
};

exports.default = Element;

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var PLAIN_OBJECT_STR = '[object Object]';

var isEqual = function isEqual(left, right) {
  if ((typeof left === 'undefined' ? 'undefined' : _typeof(left)) !== 'object' || (typeof right === 'undefined' ? 'undefined' : _typeof(right)) !== 'object') {
    return left === right;
  }

  if (left === null || right === null) return left === right;

  var leftArray = Array.isArray(left);
  var rightArray = Array.isArray(right);

  if (leftArray !== rightArray) return false;

  var leftPlainObject = Object.prototype.toString.call(left) === PLAIN_OBJECT_STR;
  var rightPlainObject = Object.prototype.toString.call(right) === PLAIN_OBJECT_STR;

  if (leftPlainObject !== rightPlainObject) return false;

  if (!leftPlainObject && !leftArray) return false;

  var leftKeys = Object.keys(left);
  var rightKeys = Object.keys(right);

  if (leftKeys.length !== rightKeys.length) return false;

  var keySet = {};
  for (var i = 0; i < leftKeys.length; i += 1) {
    keySet[leftKeys[i]] = true;
  }
  for (var _i = 0; _i < rightKeys.length; _i += 1) {
    keySet[rightKeys[_i]] = true;
  }
  var allKeys = Object.keys(keySet);
  if (allKeys.length !== leftKeys.length) {
    return false;
  }

  var l = left;
  var r = right;
  var pred = function pred(key) {
    return isEqual(l[key], r[key]);
  };

  return allKeys.every(pred);
};

exports.default = isEqual;

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _shallowEqual = __webpack_require__(496);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _Elements = __webpack_require__(352);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var noop = function noop() {};

var _extractOptions = function _extractOptions(props) {
  var id = props.id,
      className = props.className,
      onBlur = props.onBlur,
      onClick = props.onClick,
      onFocus = props.onFocus,
      onReady = props.onReady,
      paymentRequest = props.paymentRequest,
      options = _objectWithoutProperties(props, ['id', 'className', 'onBlur', 'onClick', 'onFocus', 'onReady', 'paymentRequest']);

  return options;
};

var PaymentRequestButtonElement = function (_React$Component) {
  _inherits(PaymentRequestButtonElement, _React$Component);

  function PaymentRequestButtonElement(props, context) {
    _classCallCheck(this, PaymentRequestButtonElement);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.handleRef = function (ref) {
      _this._ref = ref;
    };

    var options = _extractOptions(props);
    // We keep track of the extracted options on this._options to avoid re-rendering.
    // (We would unnecessarily re-render if we were tracking them with state.)
    _this._options = options;
    return _this;
  }

  PaymentRequestButtonElement.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    this.context.addElementsLoadListener(function (elements) {
      _this2._element = elements.create('paymentRequestButton', _extends({
        paymentRequest: _this2.props.paymentRequest
      }, _this2._options));
      _this2._element.on('ready', function () {
        _this2.props.onReady(_this2._element);
      });
      _this2._element.on('focus', function () {
        var _props;

        return (_props = _this2.props).onFocus.apply(_props, arguments);
      });
      _this2._element.on('click', function () {
        var _props2;

        return (_props2 = _this2.props).onClick.apply(_props2, arguments);
      });
      _this2._element.on('blur', function () {
        var _props3;

        return (_props3 = _this2.props).onBlur.apply(_props3, arguments);
      });
      _this2._element.mount(_this2._ref);
    });
  };

  PaymentRequestButtonElement.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this.props.paymentRequest !== nextProps.paymentRequest) {
      console.warn('Unsupported prop change: paymentRequest is not a customizable property.');
    }
    var options = _extractOptions(nextProps);
    if (Object.keys(options).length !== 0 && !(0, _shallowEqual2.default)(options, this._options)) {
      this._options = options;
      this._element.update(options);
    }
  };

  PaymentRequestButtonElement.prototype.componentWillUnmount = function componentWillUnmount() {
    this._element.destroy();
  };

  PaymentRequestButtonElement.prototype.render = function render() {
    return _react2.default.createElement('div', {
      id: this.props.id,
      className: this.props.className,
      ref: this.handleRef
    });
  };

  return PaymentRequestButtonElement;
}(_react2.default.Component);

PaymentRequestButtonElement.propTypes = {
  id: _propTypes2.default.string,
  className: _propTypes2.default.string,
  onBlur: _propTypes2.default.func,
  onClick: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  onReady: _propTypes2.default.func,
  paymentRequest: _propTypes2.default.shape({
    canMakePayment: _propTypes2.default.func.isRequired,
    on: _propTypes2.default.func.isRequired,
    show: _propTypes2.default.func.isRequired
  }).isRequired
};
PaymentRequestButtonElement.defaultProps = {
  id: undefined,
  className: undefined,
  onBlur: noop,
  onClick: noop,
  onFocus: noop,
  onReady: noop
};
PaymentRequestButtonElement.contextTypes = _Elements.elementContextTypes;
exports.default = PaymentRequestButtonElement;

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var shallowEqual = function shallowEqual(a, b) {
  var keysA = Object.keys(a);
  var keysB = Object.keys(b);

  return keysA.length === keysB.length && keysA.every(function (key) {
    return b.hasOwnProperty(key) && b[key] === a[key];
  });
};

exports.default = shallowEqual;

/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__formFields_Input__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__layouts_HorizontalLayout__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__layouts_layout_constants__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_Font__ = __webpack_require__(62);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }







var BigRadioWrapper = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_3__layouts_HorizontalLayout__["b" /* default */]).withConfig({
  displayName: "BigRadioButton__BigRadioWrapper",
  componentId: "zr86r9-0"
})(["cursor:pointer;& .form-group{margin:0 !important;}"]);
var BigRadio = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_2__formFields_Input__["a" /* default */]).withConfig({
  displayName: "BigRadioButton__BigRadio",
  componentId: "zr86r9-1"
})(["width:28px;& input{width:28px;height:18px;margin:0 !important;cursor:pointer;}"]);
var StyledLabel = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].label.withConfig({
  displayName: "BigRadioButton__StyledLabel",
  componentId: "zr86r9-2"
})(["font-weight:", ";cursor:pointer;display:block;> *{pointer-events:none;}"], __WEBPACK_IMPORTED_MODULE_5__styles_Font__["c" /* FontWeight */].NORMAL);

var BigRadioButton = function BigRadioButton(_ref) {
  var name = _ref.name,
      id = _ref.id,
      value = _ref.value,
      label = _ref.label,
      checked = _ref.checked,
      sensitive = _ref.sensitive,
      _onChange = _ref.onChange,
      other = _objectWithoutProperties(_ref, ["name", "id", "value", "label", "checked", "sensitive", "onChange"]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BigRadioWrapper, _extends({
    vAlign: __WEBPACK_IMPORTED_MODULE_4__layouts_layout_constants__["a" /* ALIGNMENT */].CENTER
  }, other), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BigRadio, {
    type: "radio",
    name: name,
    id: id || '',
    value: value,
    checked: checked,
    sensitive: sensitive,
    "data-qa-id": "components-buttons-big-radio-radio",
    onChange: function onChange() {
      return _onChange(value);
    }
  }), label && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StyledLabel, {
    htmlFor: id
  }, label));
};

BigRadioButton.defaultProps = {
  id: undefined,
  label: undefined,
  checked: false,
  sensitive: false
};
/* harmony default export */ __webpack_exports__["a"] = (BigRadioButton);

/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rover_globals_dataLayer__ = __webpack_require__(144);
var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(trackAction);




function trackAction(getData, action) {
  var data;
  return regeneratorRuntime.wrap(function trackAction$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* select */])(function (state) {
            return getData(state, action);
          });

        case 2:
          data = _context.sent;

          if (data) {
            _context.next = 5;
            break;
          }

          return _context.abrupt("return");

        case 5:
          if (Array.isArray(data)) {
            data.forEach(function (i) {
              console.debug('dataLayer', i);
              __WEBPACK_IMPORTED_MODULE_1__rover_globals_dataLayer__["a" /* default */].push(i);
            });
          } else {
            console.debug('dataLayer', data);
            __WEBPACK_IMPORTED_MODULE_1__rover_globals_dataLayer__["a" /* default */].push(data);
          }

        case 6:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}

var createAnalyticsSaga = function createAnalyticsSaga(actionTypes, getData) {
  return (
    /*#__PURE__*/
    regeneratorRuntime.mark(function analyticsSaga() {
      return regeneratorRuntime.wrap(function analyticsSaga$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* takeLatest */])(actionTypes, trackAction, getData);

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, analyticsSaga);
    })
  );
};

/* harmony default export */ __webpack_exports__["a"] = (createAnalyticsSaga);

/***/ }),
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return US_ROVER_SUPPORT_NUMBER; });
/* unused harmony export US_ROVER_EMERGENCY_HOTLINE_NUMBER */
var US_ROVER_SUPPORT_NUMBER = '888-453-7889';
var US_ROVER_EMERGENCY_HOTLINE_NUMBER = '888-727-1140';

/***/ }),
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PET_LIST_URL */
/* unused harmony export PERSON_SUMMARY_URL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return scrubAPetData; });
/* unused harmony export scrubRawData */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return get; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getPetDetailsOptions; });
/* unused harmony export deletePet */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getImages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return deleteImage; });
/* unused harmony export addImage */
/* unused harmony export setImageToFirst */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return postOrPut; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_get__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rover_utilities_apiUrl__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rover_utilities_axiosUtils__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__rover_utilities_object_utilities__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rover_shared_js_constants_i18n_language__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rover_design_system_style_dictionary_build_es6_i18nFormatMap_constants__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__factories_petFactory__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__personSummary_api__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__DefaultAPIErrorHandler__ = __webpack_require__(30);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }











var PET_LIST_URL = Object(__WEBPACK_IMPORTED_MODULE_2__rover_utilities_apiUrl__["b" /* fullApiUrl */])('pets/');
var PERSON_SUMMARY_URL = Object(__WEBPACK_IMPORTED_MODULE_2__rover_utilities_apiUrl__["b" /* fullApiUrl */])('me/');
var scrubAPetData = function scrubAPetData(rawPet) {
  var ageYears = __WEBPACK_IMPORTED_MODULE_0_moment___default()().diff(rawPet.birthday, 'years');
  var ageMonths = __WEBPACK_IMPORTED_MODULE_0_moment___default()().diff(rawPet.birthday, 'months') % 12;
  return Object(__WEBPACK_IMPORTED_MODULE_7__factories_petFactory__["a" /* default */])(_objectSpread({}, rawPet, {
    ageYears: ageYears,
    ageMonths: ageMonths
  }));
};
var scrubRawData = function scrubRawData(rawPetsData) {
  return rawPetsData.map(scrubAPetData);
};
var get =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(expressParams) {
    var data;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return Object(__WEBPACK_IMPORTED_MODULE_8__personSummary_api__["a" /* get */])(undefined, expressParams);

          case 3:
            data = _context.sent;
            return _context.abrupt("return", scrubRawData(data.pets));

          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", Object(__WEBPACK_IMPORTED_MODULE_9__DefaultAPIErrorHandler__["a" /* default */])(_context.t0,
            /*i18n*/
            {
              id: "There was an error while fetching pets."
            }));

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 7]]);
  }));

  return function get(_x) {
    return _ref.apply(this, arguments);
  };
}();
var getDetail =
/*#__PURE__*/
function () {
  var _ref2 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee2(petUrl, expressParams) {
    var ai, _ref3, data;

    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            ai = Object(__WEBPACK_IMPORTED_MODULE_3__rover_utilities_axiosUtils__["a" /* getAxiosInstance */])(expressParams);
            _context2.prev = 1;
            _context2.next = 4;
            return ai.get(petUrl);

          case 4:
            _ref3 = _context2.sent;
            data = _ref3.data;
            return _context2.abrupt("return", scrubAPetData(Object(__WEBPACK_IMPORTED_MODULE_4__rover_utilities_object_utilities__["a" /* camelize */])(data, true)));

          case 9:
            _context2.prev = 9;
            _context2.t0 = _context2["catch"](1);
            return _context2.abrupt("return", Object(__WEBPACK_IMPORTED_MODULE_9__DefaultAPIErrorHandler__["a" /* default */])(_context2.t0,
            /*i18n*/
            {
              id: "There was an error fetching pet details."
            }));

          case 12:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[1, 9]]);
  }));

  return function getDetail(_x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();
var getPetDetailsOptions =
/*#__PURE__*/
function () {
  var _ref4 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee3(expressParams) {
    var ai, petDetailsOptionsUrl, response, petDetailsOptions;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            ai = Object(__WEBPACK_IMPORTED_MODULE_3__rover_utilities_axiosUtils__["a" /* getAxiosInstance */])(expressParams);
            petDetailsOptionsUrl = Object(__WEBPACK_IMPORTED_MODULE_2__rover_utilities_apiUrl__["b" /* fullApiUrl */])('pets/');
            _context3.prev = 2;
            _context3.next = 5;
            return ai.request({
              url: petDetailsOptionsUrl,
              method: 'options'
            });

          case 5:
            response = _context3.sent;
            petDetailsOptions = Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_get__["a" /* default */])(response, 'data.actions.POST.pet_details.child.children');
            return _context3.abrupt("return", Object(__WEBPACK_IMPORTED_MODULE_4__rover_utilities_object_utilities__["a" /* camelize */])(petDetailsOptions, true));

          case 10:
            _context3.prev = 10;
            _context3.t0 = _context3["catch"](2);
            return _context3.abrupt("return", Object(__WEBPACK_IMPORTED_MODULE_9__DefaultAPIErrorHandler__["a" /* default */])(_context3.t0,
            /*i18n*/
            {
              id: "There was an error fetching pet details options."
            }));

          case 13:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[2, 10]]);
  }));

  return function getPetDetailsOptions(_x4) {
    return _ref4.apply(this, arguments);
  };
}();
var deletePet =
/*#__PURE__*/
function () {
  var _ref5 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee4(petUrl, expressParams) {
    var ai;
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            ai = Object(__WEBPACK_IMPORTED_MODULE_3__rover_utilities_axiosUtils__["a" /* getAxiosInstance */])(expressParams);
            _context4.prev = 1;
            _context4.next = 4;
            return ai["delete"](petUrl);

          case 4:
            return _context4.abrupt("return", true);

          case 7:
            _context4.prev = 7;
            _context4.t0 = _context4["catch"](1);
            return _context4.abrupt("return", Object(__WEBPACK_IMPORTED_MODULE_9__DefaultAPIErrorHandler__["a" /* default */])(_context4.t0,
            /*i18n*/
            {
              id: "There was an error deleting pet."
            }));

          case 10:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[1, 7]]);
  }));

  return function deletePet(_x5, _x6) {
    return _ref5.apply(this, arguments);
  };
}();
var getImages =
/*#__PURE__*/
function () {
  var _ref6 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee5(url, pageSize, expressParams) {
    var ai, _ref7, data;

    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            ai = Object(__WEBPACK_IMPORTED_MODULE_3__rover_utilities_axiosUtils__["a" /* getAxiosInstance */])(expressParams);
            _context5.prev = 1;
            _context5.next = 4;
            return ai.get(url, {
              params: {
                page_size: pageSize
              }
            });

          case 4:
            _ref7 = _context5.sent;
            data = _ref7.data;
            return _context5.abrupt("return", Object(__WEBPACK_IMPORTED_MODULE_4__rover_utilities_object_utilities__["a" /* camelize */])(data, true));

          case 9:
            _context5.prev = 9;
            _context5.t0 = _context5["catch"](1);
            return _context5.abrupt("return", Object(__WEBPACK_IMPORTED_MODULE_9__DefaultAPIErrorHandler__["a" /* default */])(_context5.t0,
            /*i18n*/
            {
              id: "There was an error fetching pet images."
            }));

          case 12:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[1, 9]]);
  }));

  return function getImages(_x7, _x8, _x9) {
    return _ref6.apply(this, arguments);
  };
}();
var deleteImage =
/*#__PURE__*/
function () {
  var _ref8 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee6(imageUrl, expressParams) {
    var ai;
    return regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            ai = Object(__WEBPACK_IMPORTED_MODULE_3__rover_utilities_axiosUtils__["a" /* getAxiosInstance */])(expressParams);
            _context6.prev = 1;
            _context6.next = 4;
            return ai["delete"](imageUrl);

          case 4:
            return _context6.abrupt("return", true);

          case 7:
            _context6.prev = 7;
            _context6.t0 = _context6["catch"](1);
            return _context6.abrupt("return", Object(__WEBPACK_IMPORTED_MODULE_9__DefaultAPIErrorHandler__["a" /* default */])(_context6.t0,
            /*i18n*/
            {
              id: "There was an error deleting pet image."
            }));

          case 10:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[1, 7]]);
  }));

  return function deleteImage(_x10, _x11) {
    return _ref8.apply(this, arguments);
  };
}();
var addImage =
/*#__PURE__*/
function () {
  var _ref9 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee7(petImagesUrl, imageUrl, expressParams) {
    var ai, response;
    return regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            ai = Object(__WEBPACK_IMPORTED_MODULE_3__rover_utilities_axiosUtils__["a" /* getAxiosInstance */])(expressParams);
            _context7.prev = 1;
            _context7.next = 4;
            return ai.post(petImagesUrl, {
              image_url: imageUrl
            });

          case 4:
            response = _context7.sent;
            return _context7.abrupt("return", Object(__WEBPACK_IMPORTED_MODULE_4__rover_utilities_object_utilities__["a" /* camelize */])(response.data, true));

          case 8:
            _context7.prev = 8;
            _context7.t0 = _context7["catch"](1);
            return _context7.abrupt("return", Object(__WEBPACK_IMPORTED_MODULE_9__DefaultAPIErrorHandler__["a" /* default */])(_context7.t0,
            /*i18n*/
            {
              id: "There was an error adding a pet image."
            }));

          case 11:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7, null, [[1, 8]]);
  }));

  return function addImage(_x12, _x13, _x14) {
    return _ref9.apply(this, arguments);
  };
}();
var setImageToFirst =
/*#__PURE__*/
function () {
  var _ref10 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee8(orderingUrl, expressParams) {
    var ai;
    return regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            ai = Object(__WEBPACK_IMPORTED_MODULE_3__rover_utilities_axiosUtils__["a" /* getAxiosInstance */])(expressParams);
            _context8.prev = 1;
            ai.put(orderingUrl, {
              previous: null
            });
            _context8.next = 8;
            break;

          case 5:
            _context8.prev = 5;
            _context8.t0 = _context8["catch"](1);
            throw Object(__WEBPACK_IMPORTED_MODULE_9__DefaultAPIErrorHandler__["a" /* default */])(_context8.t0,
            /*i18n*/
            {
              id: "There was an error updating the pet image."
            });

          case 8:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8, null, [[1, 5]]);
  }));

  return function setImageToFirst(_x15, _x16) {
    return _ref10.apply(this, arguments);
  };
}();
var postOrPut =
/*#__PURE__*/
function () {
  var _ref11 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee9(pet, expressParams) {
    var ai, birthday, rawData, snakeData, _ref12, data;

    return regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            ai = Object(__WEBPACK_IMPORTED_MODULE_3__rover_utilities_axiosUtils__["a" /* getAxiosInstance */])(expressParams);
            birthday = __WEBPACK_IMPORTED_MODULE_0_moment___default()().subtract(pet.ageYears, 'years').subtract(pet.ageMonths, 'months').format(__WEBPACK_IMPORTED_MODULE_6__rover_design_system_style_dictionary_build_es6_i18nFormatMap_constants__["a" /* default */][__WEBPACK_IMPORTED_MODULE_5__rover_shared_js_constants_i18n_language__["a" /* DEFAULT_LANG */]].DATE_ISO);
            rawData = _objectSpread({}, pet, {
              birthday: birthday
            });
            rawData = Object.keys(rawData).filter(function (k) {
              return rawData[k] !== null;
            }).reduce(function (obj, k) {
              obj[k] = rawData[k]; // eslint-disable-line no-param-reassign

              return obj;
            }, {});
            _context9.prev = 4;
            snakeData = Object(__WEBPACK_IMPORTED_MODULE_4__rover_utilities_object_utilities__["d" /* snakeify */])(rawData, true);
            _context9.next = 8;
            return ai({
              method: pet.url ? 'PUT' : 'POST',
              url: pet.url ? pet.url : PET_LIST_URL,
              data: _objectSpread({}, snakeData)
            });

          case 8:
            _ref12 = _context9.sent;
            data = _ref12.data;
            return _context9.abrupt("return", scrubAPetData(Object(__WEBPACK_IMPORTED_MODULE_4__rover_utilities_object_utilities__["a" /* camelize */])(data, true)));

          case 13:
            _context9.prev = 13;
            _context9.t0 = _context9["catch"](4);
            return _context9.abrupt("return", Object(__WEBPACK_IMPORTED_MODULE_9__DefaultAPIErrorHandler__["a" /* default */])(_context9.t0,
            /*i18n*/
            {
              id: "There was an error saving your pet information."
            }));

          case 16:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9, null, [[4, 13]]);
  }));

  return function postOrPut(_x17, _x18) {
    return _ref11.apply(this, arguments);
  };
}();

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(422),
    isObject = __webpack_require__(389);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(416),
    root = __webpack_require__(361);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ../react-lib/src/components/utils/Redux/Connect.jsx + 1 modules
var Connect = __webpack_require__(29);

// EXTERNAL MODULE: ../utilities/injector.js
var injector = __webpack_require__(43);

// EXTERNAL MODULE: ../react-lib/src/components/utils/Form/index.js
var Form = __webpack_require__(70);

// EXTERNAL MODULE: ../react-lib/src/components/formFields/FormGroup/index.js
var FormGroup = __webpack_require__(129);

// EXTERNAL MODULE: ../react-lib/src/components/formFields/FormValidationError/index.js
var FormValidationError = __webpack_require__(130);

// EXTERNAL MODULE: ../node_modules/@lingui/react/index.js
var _lingui_react = __webpack_require__(3);
var _lingui_react_default = /*#__PURE__*/__webpack_require__.n(_lingui_react);

// EXTERNAL MODULE: ../node_modules/react-stripe-elements/es/index.js
var es = __webpack_require__(262);
var es_default = /*#__PURE__*/__webpack_require__.n(es);

// EXTERNAL MODULE: ../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(1);

// EXTERNAL MODULE: ../utilities/object-utilities.js
var object_utilities = __webpack_require__(22);

// EXTERNAL MODULE: ../utilities/reportError.js
var reportError = __webpack_require__(34);

// EXTERNAL MODULE: ../react-lib/src/styles/index.js + 3 modules
var styles = __webpack_require__(2);

// EXTERNAL MODULE: ../react-lib/src/utils/address.js
var utils_address = __webpack_require__(358);

// EXTERNAL MODULE: ../react-lib/src/components/forms/AddressForm/index.js
var AddressForm = __webpack_require__(427);

// EXTERNAL MODULE: ../react-lib/src/factories/addressFactory.js
var addressFactory = __webpack_require__(253);

// EXTERNAL MODULE: ../react-lib/src/components/buttons/Button/index.js + 1 modules
var Button = __webpack_require__(13);

// EXTERNAL MODULE: ../react-lib/src/components/buttons/LoadingButton/index.js
var LoadingButton = __webpack_require__(229);

// EXTERNAL MODULE: ../react-lib/src/components/notifications/Alert/index.js
var Alert = __webpack_require__(254);

// EXTERNAL MODULE: ../react-lib/src/components/utils/StripeProvider/index.js + 1 modules
var StripeProvider = __webpack_require__(476);

// EXTERNAL MODULE: ../react-lib/src/components/formFields/FormGroup/FormGroup.jsx
var FormGroup_FormGroup = __webpack_require__(244);

// EXTERNAL MODULE: ../react-lib/src/components/typography/AnimatedSpinner/index.js + 1 modules
var AnimatedSpinner = __webpack_require__(272);

// EXTERNAL MODULE: ../react-lib/src/components/formFields/Checkbox/index.js + 1 modules
var Checkbox = __webpack_require__(420);

// CONCATENATED MODULE: ../react-lib/src/components/forms/CreditCardForm/BraintreeCreditCardForm/AddressCheckbox.jsx






var AddressCard = styled_components_browser_esm["default"].div.withConfig({
  displayName: "AddressCheckbox__AddressCard",
  componentId: "sc-1r02q07-0"
})(["background-color:", ";padding:", ";margin-bottom:", ";"], styles["d" /* DSToken */].BACKGROUND_COLOR_SECONDARY, styles["k" /* Spacing */].M, styles["k" /* Spacing */].M);
var CheckboxContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "AddressCheckbox__CheckboxContainer",
  componentId: "sc-1r02q07-1"
})(["display:flex;flex-direction:'row';"]);
var CheckboxLabel = styled_components_browser_esm["default"].label.withConfig({
  displayName: "AddressCheckbox__CheckboxLabel",
  componentId: "sc-1r02q07-2"
})(["margin:0;font-weight:", ";"], styles["h" /* FontWeight */].BOLD);
var AddressContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "AddressCheckbox__AddressContainer",
  componentId: "sc-1r02q07-3"
})(["margin-left:", ";"], styles["k" /* Spacing */].S);
var AddressLine = styled_components_browser_esm["default"].p.withConfig({
  displayName: "AddressCheckbox__AddressLine",
  componentId: "sc-1r02q07-4"
})(["margin:0;"]);
var checkBoxLabelString =
/*i18n*/
{
  id: "Use my primary address as the billing address"
};
var checkboxId = 'address-form-use-primary-checkbox';

var AddressCheckbox_AddressCheckbox = function AddressCheckbox(_ref) {
  var onChange = _ref.onChange,
      address = _ref.address,
      isChecked = _ref.isChecked;
  return react_default.a.createElement(AddressCard, null, react_default.a.createElement(CheckboxContainer, null, react_default.a.createElement(Checkbox["a" /* default */], {
    onChange: onChange,
    value: "address",
    checked: isChecked,
    id: checkboxId
  }), react_default.a.createElement(AddressContainer, null, react_default.a.createElement(CheckboxLabel, {
    htmlFor: checkboxId
  }, react_default.a.createElement(_lingui_react["Trans"], {
    id: checkBoxLabelString
  })), Object(utils_address["c" /* isValidAddress */])(address) && isChecked && react_default.a.createElement(react["Fragment"], null, react_default.a.createElement(AddressLine, null, address.addressLine1), react_default.a.createElement(AddressLine, null, address.addressLine2), react_default.a.createElement(AddressLine, null, Object(utils_address["a" /* getCityZipAddressLine */])(address))))));
};

/* harmony default export */ var BraintreeCreditCardForm_AddressCheckbox = (AddressCheckbox_AddressCheckbox);
// EXTERNAL MODULE: ../react-lib/src/components/utils/LabelAndErrorFormGroup/index.js + 1 modules
var LabelAndErrorFormGroup = __webpack_require__(77);

// EXTERNAL MODULE: ../react-lib/src/components/formFields/TextInput/index.js + 1 modules
var TextInput = __webpack_require__(214);

// CONCATENATED MODULE: ../react-lib/src/components/forms/StripeCreditCardForm/StripeCreditCardNameField.jsx
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }






var StripeCreditCardNameField_StripeCreditCardNameField = function StripeCreditCardNameField(_ref) {
  var other = _extends({}, _ref);

  return react_default.a.createElement(_lingui_react["I18n"], null, function (_ref2) {
    var i18n = _ref2.i18n;
    return react_default.a.createElement(LabelAndErrorFormGroup["b" /* default */], _extends({}, other, {
      label: i18n._('Name on Card'),
      name: "cc-name",
      autoComplete: "cc-name",
      "data-qa-id": "credit-card-inputs-name"
    }), function (inputProps) {
      return react_default.a.createElement(TextInput["a" /* default */], inputProps);
    });
  });
};

/* harmony default export */ var StripeCreditCardForm_StripeCreditCardNameField = (StripeCreditCardNameField_StripeCreditCardNameField);
// EXTERNAL MODULE: ../react-lib/src/images/credit-cards@2x.png
var credit_cards_2x = __webpack_require__(535);
var credit_cards_2x_default = /*#__PURE__*/__webpack_require__.n(credit_cards_2x);

// EXTERNAL MODULE: ../react-lib/src/constants/creditCard.constants.js
var creditCard_constants = __webpack_require__(362);

// CONCATENATED MODULE: ../react-lib/src/components/typography/CreditCardIcon/CreditCardIcon.jsx
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }





var CardIcon = styled_components_browser_esm["default"].span.withConfig({
  displayName: "CreditCardIcon__CardIcon",
  componentId: "sc-1rb277o-0"
})(["display:inline-block;width:32px;min-width:32px;height:22px;margin-right:8px;background-image:url(", ");background-repeat:no-repeat;background-size:cover;"], credit_cards_2x_default.a);
var VisaIcon = Object(styled_components_browser_esm["default"])(CardIcon).withConfig({
  displayName: "CreditCardIcon__VisaIcon",
  componentId: "sc-1rb277o-1"
})(["background-position:0 0;"]);
var AmexIcon = Object(styled_components_browser_esm["default"])(CardIcon).withConfig({
  displayName: "CreditCardIcon__AmexIcon",
  componentId: "sc-1rb277o-2"
})(["background-position:0 -44px;"]);
var MastercardIcon = Object(styled_components_browser_esm["default"])(CardIcon).withConfig({
  displayName: "CreditCardIcon__MastercardIcon",
  componentId: "sc-1rb277o-3"
})(["background-position:0 -88px;"]);
var DiscoverIcon = Object(styled_components_browser_esm["default"])(CardIcon).withConfig({
  displayName: "CreditCardIcon__DiscoverIcon",
  componentId: "sc-1rb277o-4"
})(["background-position:0 -132px;"]);

var CreditCardIcon_CreditCardIcon = function CreditCardIcon(_ref) {
  var type = _ref.type,
      other = _objectWithoutProperties(_ref, ["type"]);

  var cardType = creditCard_constants["b" /* CARD_TYPES */][type && type.toLowerCase()] || {};

  switch (cardType.id) {
    case creditCard_constants["b" /* CARD_TYPES */].visa.id:
      return react_default.a.createElement(VisaIcon, other);

    case creditCard_constants["b" /* CARD_TYPES */].amex.id:
      return react_default.a.createElement(AmexIcon, other);

    case creditCard_constants["b" /* CARD_TYPES */].mastercard.id:
      return react_default.a.createElement(MastercardIcon, other);

    case creditCard_constants["b" /* CARD_TYPES */].discover.id:
      return react_default.a.createElement(DiscoverIcon, other);

    default:
      return null;
  }
};

CreditCardIcon_CreditCardIcon.defaultProps = {
  type: undefined
};
/* harmony default export */ var typography_CreditCardIcon_CreditCardIcon = (CreditCardIcon_CreditCardIcon);
// CONCATENATED MODULE: ../react-lib/src/components/typography/CreditCardIcon/index.js

// CONCATENATED MODULE: ../react-lib/src/components/forms/StripeCreditCardForm/StripeFormGroup.jsx
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function StripeFormGroup__objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = StripeFormGroup__objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function StripeFormGroup__objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }






var StripeFormGroup_getBorderColor = function getBorderColor() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      isFocused = _ref.isFocused;

  if (isFocused) {
    return styles["d" /* DSToken */].BORDER_COLOR_INPUT_FOCUS.toString();
  }

  return styles["d" /* DSToken */].BORDER_COLOR_PRIMARY.toString();
};
var StripeFormGroup_createStyledStripeElement = function createStyledStripeElement(StripeElement) {
  return Object(styled_components_browser_esm["default"])(function (_ref2) {
    var isFocused = _ref2.isFocused,
        other = StripeFormGroup__objectWithoutProperties(_ref2, ["isFocused"]);

    return react_default.a.createElement(StripeElement, other);
  }).withConfig({
    displayName: "StripeFormGroup",
    componentId: "sc-1p8nhev-0"
  })(["position:relative;display:flex;align-items:center;height:40px;padding:", ";border:1px solid ", ";border-radius:4px;transition:border-color ease-in-out 0.15s;.__PrivateStripeElement{flex:1;}"], styles["k" /* Spacing */].S, function (props) {
    return StripeFormGroup_getBorderColor(props);
  });
};
var stripeElementStyles = {
  base: {
    fontSize: '14px',
    color: styles["d" /* DSToken */].TEXT_COLOR_SECONDARY.toString(),
    fontFamily: styles["e" /* FONT_FAMILY */],
    '::placeholder': {
      color: styles["d" /* DSToken */].TEXT_COLOR_TERTIARY.toString()
    }
  },
  invalid: {
    color: styles["d" /* DSToken */].TEXT_COLOR_SECONDARY.toString()
  }
};

var StripeFormGroup_StripeFormGroup =
/*#__PURE__*/
function (_Component) {
  _inherits(StripeFormGroup, _Component);

  function StripeFormGroup() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, StripeFormGroup);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(StripeFormGroup)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      isFocused: false
    };

    _this.handleBlur = function () {
      _this.setState(function () {
        return {
          isFocused: false
        };
      });
    };

    _this.handleFocus = function () {
      _this.setState(function () {
        return {
          isFocused: true
        };
      });
    };

    return _this;
  }

  _createClass(StripeFormGroup, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          other = StripeFormGroup__objectWithoutProperties(_this$props, ["children"]);

      return react_default.a.createElement(LabelAndErrorFormGroup["b" /* default */], other, function (_ref3) {
        var name = _ref3.name,
            cleanInputProps = StripeFormGroup__objectWithoutProperties(_ref3, ["name"]);

        var renderProps = _objectSpread({}, cleanInputProps, {}, _this2.state, {
          style: stripeElementStyles,
          onFocus: _this2.handleFocus,
          onBlur: _this2.handleBlur
        });

        return children(renderProps);
      });
    }
  }]);

  return StripeFormGroup;
}(react["Component"]);


// CONCATENATED MODULE: ../react-lib/src/components/forms/StripeCreditCardForm/StripeCreditCardNumberField.jsx
function StripeCreditCardNumberField__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { StripeCreditCardNumberField__typeof = function _typeof(obj) { return typeof obj; }; } else { StripeCreditCardNumberField__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return StripeCreditCardNumberField__typeof(obj); }

function StripeCreditCardNumberField__extends() { StripeCreditCardNumberField__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return StripeCreditCardNumberField__extends.apply(this, arguments); }

function StripeCreditCardNumberField__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function StripeCreditCardNumberField__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function StripeCreditCardNumberField__createClass(Constructor, protoProps, staticProps) { if (protoProps) StripeCreditCardNumberField__defineProperties(Constructor.prototype, protoProps); if (staticProps) StripeCreditCardNumberField__defineProperties(Constructor, staticProps); return Constructor; }

function StripeCreditCardNumberField__possibleConstructorReturn(self, call) { if (call && (StripeCreditCardNumberField__typeof(call) === "object" || typeof call === "function")) { return call; } return StripeCreditCardNumberField__assertThisInitialized(self); }

function StripeCreditCardNumberField__assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function StripeCreditCardNumberField__getPrototypeOf(o) { StripeCreditCardNumberField__getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return StripeCreditCardNumberField__getPrototypeOf(o); }

function StripeCreditCardNumberField__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) StripeCreditCardNumberField__setPrototypeOf(subClass, superClass); }

function StripeCreditCardNumberField__setPrototypeOf(o, p) { StripeCreditCardNumberField__setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return StripeCreditCardNumberField__setPrototypeOf(o, p); }









var StyledStripeFormGroup = Object(styled_components_browser_esm["default"])(StripeFormGroup_StripeFormGroup).withConfig({
  displayName: "StripeCreditCardNumberField__StyledStripeFormGroup",
  componentId: "sc-1lq3zbr-0"
})(["flex:1;flex-basis:100%;", "{flex-basis:200px;}"], styles["i" /* MQ */].NOT_XS);
var InnerWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "StripeCreditCardNumberField__InnerWrapper",
  componentId: "sc-1lq3zbr-1"
})(["position:relative;"]);
var StyledCardNumberElement = StripeFormGroup_createStyledStripeElement(es["CardNumberElement"]);
var StyledCreditCardIcon = Object(styled_components_browser_esm["default"])(typography_CreditCardIcon_CreditCardIcon).withConfig({
  displayName: "StripeCreditCardNumberField__StyledCreditCardIcon",
  componentId: "sc-1lq3zbr-2"
})(["position:absolute;right:0;top:50%;margin-top:-11px;"]);

var StripeCreditCardNumberField_StripeCreditCardNumberField =
/*#__PURE__*/
function (_Component) {
  StripeCreditCardNumberField__inherits(StripeCreditCardNumberField, _Component);

  function StripeCreditCardNumberField() {
    var _getPrototypeOf2;

    var _this;

    StripeCreditCardNumberField__classCallCheck(this, StripeCreditCardNumberField);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = StripeCreditCardNumberField__possibleConstructorReturn(this, (_getPrototypeOf2 = StripeCreditCardNumberField__getPrototypeOf(StripeCreditCardNumberField)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      cardType: null
    };

    _this.handleChange = function (e) {
      if (e.brand) {
        var cardType = creditCard_constants["b" /* CARD_TYPES */][e.brand] ? creditCard_constants["b" /* CARD_TYPES */][e.brand].id : null;

        _this.setState(function () {
          return {
            cardType: cardType
          };
        });
      }

      _this.props.onChange(e);
    };

    return _this;
  }

  StripeCreditCardNumberField__createClass(StripeCreditCardNumberField, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var cardType = this.state.cardType;
      return react_default.a.createElement(_lingui_react["I18n"], null, function (_ref) {
        var i18n = _ref.i18n;
        return react_default.a.createElement(StyledStripeFormGroup, StripeCreditCardNumberField__extends({}, _this2.props, {
          label: i18n._('Card Number')
        }), function (formGroupProps) {
          return react_default.a.createElement(InnerWrapper, null, react_default.a.createElement(StyledCardNumberElement, StripeCreditCardNumberField__extends({}, formGroupProps, {
            onChange: _this2.handleChange
          })), react_default.a.createElement(StyledCreditCardIcon, {
            type: cardType
          }));
        });
      });
    }
  }]);

  return StripeCreditCardNumberField;
}(react["Component"]);


// CONCATENATED MODULE: ../react-lib/src/components/forms/StripeCreditCardForm/StripeCreditCardExpiryField.jsx
function StripeCreditCardExpiryField__extends() { StripeCreditCardExpiryField__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return StripeCreditCardExpiryField__extends.apply(this, arguments); }





var StyledCardExpiryElement = StripeFormGroup_createStyledStripeElement(es["CardExpiryElement"]);

var StripeCreditCardExpiryField_StripeCreditCardExpiryField = function StripeCreditCardExpiryField(props) {
  return react_default.a.createElement(_lingui_react["I18n"], null, function (_ref) {
    var i18n = _ref.i18n;
    return react_default.a.createElement(StripeFormGroup_StripeFormGroup, StripeCreditCardExpiryField__extends({}, props, {
      label: i18n._('Expiration')
    }), function (formGroupProps) {
      return react_default.a.createElement(StyledCardExpiryElement, StripeCreditCardExpiryField__extends({}, formGroupProps, {
        placeholder: i18n._('MM/YY')
      }));
    });
  });
};

/* harmony default export */ var StripeCreditCardForm_StripeCreditCardExpiryField = (StripeCreditCardExpiryField_StripeCreditCardExpiryField);
// CONCATENATED MODULE: ../react-lib/src/components/forms/StripeCreditCardForm/StripeCreditCardCVCField.jsx
function StripeCreditCardCVCField__extends() { StripeCreditCardCVCField__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return StripeCreditCardCVCField__extends.apply(this, arguments); }




var StyledCardCVCElement = StripeFormGroup_createStyledStripeElement(es["CardCVCElement"]);

var StripeCreditCardCVCField_StripeCreditCardCVCField = function StripeCreditCardCVCField(props) {
  return react_default.a.createElement(StripeFormGroup_StripeFormGroup, StripeCreditCardCVCField__extends({}, props, {
    label: "CVC"
  }), function (formGroupProps) {
    return react_default.a.createElement(StyledCardCVCElement, formGroupProps);
  });
};

/* harmony default export */ var StripeCreditCardForm_StripeCreditCardCVCField = (StripeCreditCardCVCField_StripeCreditCardCVCField);
// CONCATENATED MODULE: ../react-lib/src/components/forms/StripeCreditCardForm/StripeCreditCardForm.jsx
function StripeCreditCardForm__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { StripeCreditCardForm__typeof = function _typeof(obj) { return typeof obj; }; } else { StripeCreditCardForm__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return StripeCreditCardForm__typeof(obj); }

function StripeCreditCardForm__objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = StripeCreditCardForm__objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function StripeCreditCardForm__objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function StripeCreditCardForm__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function StripeCreditCardForm__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function StripeCreditCardForm__createClass(Constructor, protoProps, staticProps) { if (protoProps) StripeCreditCardForm__defineProperties(Constructor.prototype, protoProps); if (staticProps) StripeCreditCardForm__defineProperties(Constructor, staticProps); return Constructor; }

function StripeCreditCardForm__possibleConstructorReturn(self, call) { if (call && (StripeCreditCardForm__typeof(call) === "object" || typeof call === "function")) { return call; } return StripeCreditCardForm__assertThisInitialized(self); }

function StripeCreditCardForm__getPrototypeOf(o) { StripeCreditCardForm__getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return StripeCreditCardForm__getPrototypeOf(o); }

function StripeCreditCardForm__assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function StripeCreditCardForm__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) StripeCreditCardForm__setPrototypeOf(subClass, superClass); }

function StripeCreditCardForm__setPrototypeOf(o, p) { StripeCreditCardForm__setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return StripeCreditCardForm__setPrototypeOf(o, p); }

function StripeCreditCardForm_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function StripeCreditCardForm__objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { StripeCreditCardForm_ownKeys(source, true).forEach(function (key) { StripeCreditCardForm__defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { StripeCreditCardForm_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function StripeCreditCardForm__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }























var StyledForm = Object(styled_components_browser_esm["default"])(Form["a" /* default */]).withConfig({
  displayName: "StripeCreditCardForm__StyledForm",
  componentId: "sc-19lp6el-0"
})(["position:relative;"]);
var CreditCardFormFlexWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "StripeCreditCardForm__CreditCardFormFlexWrapper",
  componentId: "sc-19lp6el-1"
})(["display:flex;flex-wrap:wrap;"]);
var CVCExpiryResponsiveRow = styled_components_browser_esm["default"].div.withConfig({
  displayName: "StripeCreditCardForm__CVCExpiryResponsiveRow",
  componentId: "sc-19lp6el-2"
})(["display:flex;flex:1 100%;", "{flex:1 100px;margin-left:", ";}", "{flex:1 1 50%;&:first-child{margin-right:", ";}&:last-child{margin-left:", ";}}"], styles["i" /* MQ */].NOT_XS, styles["k" /* Spacing */].M, FormGroup_FormGroup["a" /* Wrapper */], styles["k" /* Spacing */].S, styles["k" /* Spacing */].S);
var StyledAnimatedSpinner = Object(styled_components_browser_esm["default"])(AnimatedSpinner["a" /* default */]).withConfig({
  displayName: "StripeCreditCardForm__StyledAnimatedSpinner",
  componentId: "sc-19lp6el-3"
})(["position:absolute;background:", ";top:0;right:0;bottom:0;left:0;opacity:", ";"], styles["d" /* DSToken */].BACKGROUND_COLOR_PRIMARY, function (props) {
  return props.opaque ? 1 : 0.66;
});
var ButtonGroup = styled_components_browser_esm["default"].div.withConfig({
  displayName: "StripeCreditCardForm__ButtonGroup",
  componentId: "sc-19lp6el-4"
})(["display:flex;justify-content:flex-end;"]);

var StripeCreditCardForm_getValidators = function getValidators() {
  return function (_ref) {
    var address = _ref.address;
    return StripeCreditCardForm__objectSpread({
      name: Form["a" /* default */].validators.required
    }, AddressForm["a" /* default */].getValidators(address));
  };
};

/* eslint-enable react/no-unused-prop-types */
var StripeCreditCardForm_UnwrappedStripeCreditCardForm =
/*#__PURE__*/
function (_Component) {
  StripeCreditCardForm__inherits(UnwrappedStripeCreditCardForm, _Component);

  function UnwrappedStripeCreditCardForm(props) {
    var _this;

    StripeCreditCardForm__classCallCheck(this, UnwrappedStripeCreditCardForm);

    _this = StripeCreditCardForm__possibleConstructorReturn(this, StripeCreditCardForm__getPrototypeOf(UnwrappedStripeCreditCardForm).call(this, props)); // NOTE(Ryan) this .bind() is necessary, otherwise `this` is undefined in handleSubmit()
    //            /shrug babel weirdness?
    // $FlowFixMe: flow thinks this.handleSubmit isn't writable, it is wrong: https://github.com/facebook/flow/issues/5874

    _this.isCreatingDSToken = void 0;
    _this.state = {
      stripeValidationErrors: {
        cardNumber: null,
        cardExpiry: null,
        cardCvc: null
      },
      stripeFieldsToLoad: 3,
      stripeError: null,
      usePrimaryAddress: Object(utils_address["c" /* isValidAddress */])(_this.props.address)
    };
    _this.isCreatingDSToken = false;

    _this.handleStripeFieldChange = function (_ref2) {
      var elementType = _ref2.elementType,
          error = _ref2.error;

      if (error) {
        _this.setState(function (state) {
          return {
            stripeValidationErrors: StripeCreditCardForm__objectSpread({}, state.stripeValidationErrors, StripeCreditCardForm__defineProperty({}, elementType, error.message))
          };
        });
      } else {
        _this.setState(function (state) {
          return {
            stripeValidationErrors: StripeCreditCardForm__objectSpread({}, state.stripeValidationErrors, StripeCreditCardForm__defineProperty({}, elementType, null))
          };
        });
      }
    };

    _this.handleStripeFieldReady = function () {
      var onStripeFieldsReady = _this.props.onStripeFieldsReady;

      _this.setState(function (_ref3) {
        var stripeFieldsToLoad = _ref3.stripeFieldsToLoad;
        var newNumFieldsLoaded = stripeFieldsToLoad - 1;

        if (newNumFieldsLoaded === 0) {
          onStripeFieldsReady();
        }

        return {
          stripeFieldsToLoad: newNumFieldsLoaded
        };
      });
    };

    _this.handleAddressCheckboxChange = function () {
      return _this.setState(function (state) {
        return {
          usePrimaryAddress: !state.usePrimaryAddress
        };
      });
    };

    _this.handleSubmit = _this.handleSubmit.bind(StripeCreditCardForm__assertThisInitialized(_this));
    return _this;
  }

  StripeCreditCardForm__createClass(UnwrappedStripeCreditCardForm, [{
    key: "handleSubmit",
    value: function () {
      var _handleSubmit = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee(formData) {
        var name, address, tokenData, _this$props, stripe, onSubmit, _ref4, token, error, isSuccessful;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this.isCreatingDSToken) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                this.isCreatingDSToken = true;
                this.setState(function () {
                  return {
                    stripeError: null
                  };
                }); // https://stripe.com/docs/stripe-js/reference#stripe-create-token

                name = formData.name, address = formData.address;
                tokenData = Object(object_utilities["d" /* snakeify */])({
                  name: name,
                  addressLine1: address.addressLine1,
                  addressLine2: address.addressLine2,
                  addressCity: address.city,
                  addressState: address.state,
                  addressZip: address.zip,
                  addressCountry: address.countryCode
                });
                _this$props = this.props, stripe = _this$props.stripe, onSubmit = _this$props.onSubmit;
                _context.prev = 7;

                if (stripe) {
                  _context.next = 10;
                  break;
                }

                throw new Error('Stripe.js Not Found: Please refresh the page and try again.');

              case 10:
                _context.next = 12;
                return stripe.createToken(tokenData);

              case 12:
                _ref4 = _context.sent;
                token = _ref4.token;
                error = _ref4.error;
                this.isCreatingDSToken = false;

                if (!error) {
                  _context.next = 18;
                  break;
                }

                throw error;

              case 18:
                _context.next = 20;
                return onSubmit(StripeCreditCardForm__objectSpread({}, formData, {
                  nonce: token.id,
                  formVersion: 'stripe',
                  cardholderName: name
                }));

              case 20:
                isSuccessful = _context.sent;

                if (isSuccessful) {
                  this.props.onToggleForm();
                }

                _context.next = 28;
                break;

              case 24:
                _context.prev = 24;
                _context.t0 = _context["catch"](7);
                this.isCreatingDSToken = false;

                if (_context.t0.type !== 'validation_error') {
                  Object(reportError["a" /* default */])(_context.t0);
                  this.setState(function () {
                    return {
                      stripeError: _context.t0.message
                    };
                  });
                }

              case 28:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[7, 24]]);
      }));

      function handleSubmit(_x) {
        return _handleSubmit.apply(this, arguments);
      }

      return handleSubmit;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          stripeValidationErrors = _this$state.stripeValidationErrors,
          stripeFieldsToLoad = _this$state.stripeFieldsToLoad,
          stripeError = _this$state.stripeError,
          usePrimaryAddress = _this$state.usePrimaryAddress;
      var _this$props2 = this.props,
          propsAddress = _this$props2.address,
          hideCancelButton = _this$props2.hideCancelButton,
          onToggleForm = _this$props2.onToggleForm,
          isSubmitting = _this$props2.isSubmitting,
          nestedForm = _this$props2.nestedForm,
          supportedCountryCodes = _this$props2.supportedCountryCodes,
          centerButtons = _this$props2.centerButtons,
          saveButtonText = _this$props2.saveButtonText;
      var buttonGroupStyle = centerButtons ? {
        justifyContent: 'center'
      } : {};
      return react_default.a.createElement(StyledForm, {
        onSubmit: this.handleSubmit,
        validators: StripeCreditCardForm_getValidators(),
        initialData: {
          name: '',
          address: propsAddress
        },
        "data-qa-id": "credit-card-forms-add-card",
        nested: nestedForm
      }, function (form) {
        return react_default.a.createElement(react["Fragment"], null, stripeError && react_default.a.createElement(Alert["a" /* default */], {
          severity: Alert["a" /* default */].Severity.DANGER
        }, stripeError), react_default.a.createElement(StripeCreditCardForm_StripeCreditCardNameField, {
          value: form.data.name,
          onChange: function onChange(name) {
            return form.onChange({
              name: name
            });
          },
          validationError: form.validationErrors.name
        }), react_default.a.createElement(CreditCardFormFlexWrapper, null, react_default.a.createElement(StripeCreditCardNumberField_StripeCreditCardNumberField, {
          validationError: stripeValidationErrors.cardNumber,
          onChange: _this2.handleStripeFieldChange,
          onReady: _this2.handleStripeFieldReady
        }), react_default.a.createElement(CVCExpiryResponsiveRow, null, react_default.a.createElement(StripeCreditCardForm_StripeCreditCardExpiryField, {
          validationError: stripeValidationErrors.cardExpiry,
          onChange: _this2.handleStripeFieldChange,
          onReady: _this2.handleStripeFieldReady
        }), react_default.a.createElement(StripeCreditCardForm_StripeCreditCardCVCField, {
          validationError: stripeValidationErrors.cardCvc,
          onChange: _this2.handleStripeFieldChange,
          onReady: _this2.handleStripeFieldReady
        }))), Object(utils_address["c" /* isValidAddress */])(propsAddress) && react_default.a.createElement(BraintreeCreditCardForm_AddressCheckbox, {
          onChange: _this2.handleAddressCheckboxChange,
          address: propsAddress,
          isChecked: usePrimaryAddress
        }), !usePrimaryAddress && react_default.a.createElement(AddressForm["a" /* default */], {
          address: form.data.address,
          onChange: function onChange(address) {
            return form.onChange({
              address: address
            });
          },
          validationErrors: form.validationErrors,
          supportedCountryCodes: supportedCountryCodes
        }), stripeFieldsToLoad !== 0 || isSubmitting ? react_default.a.createElement(StyledAnimatedSpinner, {
          "data-qa-id": "credit-card-forms-spinner",
          opaque: !isSubmitting
        }) : null, react_default.a.createElement(ButtonGroup, {
          style: buttonGroupStyle
        }, !hideCancelButton && react_default.a.createElement(Button["b" /* default */], {
          buttonType: Button["a" /* ButtonType */].TEXT,
          onClick: onToggleForm
        }, react_default.a.createElement(_lingui_react["Trans"], {
          id: "Cancel"
        })), react_default.a.createElement(LoadingButton["a" /* default */], {
          disabled: isSubmitting || stripeFieldsToLoad !== 0,
          loading: isSubmitting,
          buttonType: Button["a" /* ButtonType */].PRIMARY,
          type: nestedForm ? 'button' : 'submit',
          onClick: form.onSubmit,
          "data-qa-id": "credit-card-buttons-save"
        }, saveButtonText || react_default.a.createElement(_lingui_react["Trans"], {
          id: "Save Card"
        }))));
      });
    }
  }]);

  return UnwrappedStripeCreditCardForm;
}(react["Component"]);
StripeCreditCardForm_UnwrappedStripeCreditCardForm.defaultProps = {
  onStripeFieldsReady: function onStripeFieldsReady() {},
  address: Object(addressFactory["a" /* default */])(),
  hideCancelButton: false,
  onToggleForm: function onToggleForm() {},
  isSubmitting: false,
  nestedForm: false,
  centerButtons: false
};
var StripeCreditCardForm = Object(es["injectStripe"])(StripeCreditCardForm_UnwrappedStripeCreditCardForm);
/* harmony default export */ var StripeCreditCardForm_StripeCreditCardForm = (function (_ref5) {
  var language = _ref5.language,
      onStripeLoaded = _ref5.onStripeLoaded,
      other = StripeCreditCardForm__objectWithoutProperties(_ref5, ["language", "onStripeLoaded"]);

  return react_default.a.createElement(StripeProvider["a" /* default */], {
    language: language,
    onStripeLoaded: onStripeLoaded
  }, react_default.a.createElement(StripeCreditCardForm, other));
});
// CONCATENATED MODULE: ../react-lib/src/components/forms/StripeCreditCardForm/index.js

// EXTERNAL MODULE: ../react-lib/src/components/buttons/BigRadioButton/BigRadioButton.jsx
var BigRadioButton = __webpack_require__(497);

// CONCATENATED MODULE: ../react-lib/src/components/buttons/BigRadioButton/index.js

// EXTERNAL MODULE: ../react-lib/src/components/typography/Icon/index.js
var Icon = __webpack_require__(65);

// CONCATENATED MODULE: ../react-lib/src/components/formFields/RadioRows/RadioRows.jsx
function RadioRows__extends() { RadioRows__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return RadioRows__extends.apply(this, arguments); }

function RadioRows__objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = RadioRows__objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function RadioRows__objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }






var V_CENTER = "\n  display: flex;\n  align-items: center;\n";
var Wrapper = styled_components_browser_esm["default"].label.withConfig({
  displayName: "RadioRows__Wrapper",
  componentId: "sc-12tu47l-0"
})(["margin-bottom:0;", " width:100%;flex-direction:row;border:1px solid ", ";padding:15px;cursor:pointer;font-weight:normal;&:first-child{border-top-left-radius:", ";border-top-right-radius:", ";}&:last-child{border-bottom-left-radius:", ";border-bottom-right-radius:", ";}&:not(:first-child){border-top:none;}", "{align-items:flex-start;}"], V_CENTER, styles["d" /* DSToken */].BORDER_COLOR_PRIMARY, styles["d" /* DSToken */].BORDER_RADIUS, styles["d" /* DSToken */].BORDER_RADIUS, styles["d" /* DSToken */].BORDER_RADIUS, styles["d" /* DSToken */].BORDER_RADIUS, styles["i" /* MQ */].XS);
var RadioButtonWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "RadioRows__RadioButtonWrapper",
  componentId: "sc-12tu47l-1"
})(["width:28px;margin-right:5px;", "{margin-top:3px;}"], styles["i" /* MQ */].XS);
var ContentWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "RadioRows__ContentWrapper",
  componentId: "sc-12tu47l-2"
})(["", " flex-direction:row;justify-content:space-between;width:100%;padding-right:30px;", "{flex-direction:column;align-items:flex-start;justify-content:flex-start;}"], V_CENTER, styles["i" /* MQ */].XS);
var DeleteButtonWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "RadioRows__DeleteButtonWrapper",
  componentId: "sc-12tu47l-3"
})(["height:14px;margin-right:15px;color:", ";", "{margin-right:0;}"], styles["d" /* DSToken */].TEXT_COLOR_TERTIARY, styles["i" /* MQ */].XS);
var DeleteIcon = Object(styled_components_browser_esm["default"])(Icon["default"]).withConfig({
  displayName: "RadioRows__DeleteIcon",
  componentId: "sc-12tu47l-4"
})(["position:relative;top:-3px;"]);

var handleDeleteClicked = function handleDeleteClicked(event, cb) {
  event.preventDefault();
  cb();
};

var RadioRows_renderDelete = function renderDelete(value, onDelete) {
  if (!onDelete) return null;
  return react_default.a.createElement(DeleteButtonWrapper, null, react_default.a.createElement(DeleteIcon, {
    icon: "rover-icon-generic-none",
    "data-qa-id": "components-ff-radio-rows-buttons-delete",
    onClick: function onClick(e) {
      return handleDeleteClicked(e, function () {
        return onDelete(value);
      });
    }
  }));
};

var RadioRows_RadioRows = function RadioRows(_ref) {
  var options = _ref.options,
      value = _ref.value,
      name = _ref.name,
      _onChange = _ref.onChange,
      onDelete = _ref.onDelete,
      radioProps = _ref.radioProps,
      other = RadioRows__objectWithoutProperties(_ref, ["options", "value", "name", "onChange", "onDelete", "radioProps"]);

  return react_default.a.createElement("div", null, options.map(function (option) {
    return react_default.a.createElement(Wrapper, RadioRows__extends({
      key: option.value
    }, other), react_default.a.createElement(RadioButtonWrapper, null, react_default.a.createElement(BigRadioButton["a" /* default */], RadioRows__extends({
      name: name,
      value: option.value,
      checked: option.value === value,
      onChange: function onChange() {
        return _onChange(option.value);
      }
    }, radioProps))), react_default.a.createElement(ContentWrapper, null, option.label || option.children), RadioRows_renderDelete(option.value, onDelete));
  }));
};

RadioRows_RadioRows.defaultProps = {
  value: '',
  onDelete: undefined,
  radioProps: {}
};
/* harmony default export */ var formFields_RadioRows_RadioRows = (RadioRows_RadioRows);
// CONCATENATED MODULE: ../react-lib/src/components/formFields/RadioRows/index.js

// CONCATENATED MODULE: ../react-lib/src/components/forms/CreditCardForm/CreditCardOptions/CreditCardOptions.jsx





var CreditCardOptions_V_CENTER = Object(styled_components_browser_esm["css"])(["display:flex;align-items:center;"]);
var MOBILE_FULL_WIDTH = Object(styled_components_browser_esm["css"])(["", "{width:100%;text-align:left;}"], styles["i" /* MQ */].XS);
var CardName = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CreditCardOptions__CardName",
  componentId: "sc-7pqfjn-0"
})(["", " width:40%;", ";", "{span{display:none;}}"], CreditCardOptions_V_CENTER, MOBILE_FULL_WIDTH, styles["i" /* MQ */].XS_DOWN);
var CardHolder = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CreditCardOptions__CardHolder",
  componentId: "sc-7pqfjn-1"
})(["width:45%;", ";"], MOBILE_FULL_WIDTH);
var CardExpiration = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CreditCardOptions__CardExpiration",
  componentId: "sc-7pqfjn-2"
})(["color:", ";width:15%;", ";"], styles["d" /* DSToken */].TEXT_COLOR_TERTIARY, MOBILE_FULL_WIDTH);

var CreditCardOptions_renderCard = function renderCard(card) {
  return [react_default.a.createElement(CardName, {
    key: "cc-name"
  }, react_default.a.createElement(typography_CreditCardIcon_CreditCardIcon, {
    type: card.cardType
  }), card.cardType, " - ", card.lastFour), react_default.a.createElement(CardHolder, {
    key: "cc-holder"
  }, card.cardholderName), react_default.a.createElement(CardExpiration, {
    key: "cc-exp"
  }, card.expirationMonth, " / ", card.expirationYear)];
};

var CreditCardOptions_CreditCardOptions = function CreditCardOptions(_ref) {
  var cards = _ref.cards,
      radioName = _ref.radioName,
      value = _ref.value,
      onChange = _ref.onChange,
      onDelete = _ref.onDelete;
  return react_default.a.createElement(formFields_RadioRows_RadioRows, {
    options: cards.map(function (card) {
      return {
        value: card.url,
        children: CreditCardOptions_renderCard(card)
      };
    }),
    value: value,
    name: radioName,
    onDelete: onDelete,
    onChange: onChange,
    radioProps: {
      sensitive: true
    },
    "data-qa-id": "credit-card-radios-card"
  });
};

CreditCardOptions_CreditCardOptions.defaultProps = {
  value: '',
  radioName: 'cc'
};
/* harmony default export */ var CreditCardForm_CreditCardOptions_CreditCardOptions = (CreditCardOptions_CreditCardOptions);
// CONCATENATED MODULE: ../react-lib/src/components/forms/CreditCardForm/CreditCardOptions/index.js

// CONCATENATED MODULE: ../react-lib/src/components/forms/CreditCardForm/SelectCreditCardForm/SelectCreditCardForm.jsx
function SelectCreditCardForm__objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = SelectCreditCardForm__objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function SelectCreditCardForm__objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }






var SelectCreditCardForm_Wrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "SelectCreditCardForm__Wrapper",
  componentId: "jfktl8-0"
})(["position:relative;text-align:right;opacity:", ";"], function (props) {
  return props.disabled ? 0.5 : 1;
});
var AddCardButton = Object(styled_components_browser_esm["default"])(Button["b" /* default */]).withConfig({
  displayName: "SelectCreditCardForm__AddCardButton",
  componentId: "jfktl8-1"
})(["margin-top:8px;"]);
var DisabledOverlay = styled_components_browser_esm["default"].div.withConfig({
  displayName: "SelectCreditCardForm__DisabledOverlay",
  componentId: "jfktl8-2"
})(["position:absolute;top:0;right:0;bottom:0;left:0;cursor:not-allowed;"]);

var SelectCreditCardForm_SelectCreditCardForm = function SelectCreditCardForm(_ref) {
  var onToggleForm = _ref.onToggleForm,
      className = _ref.className,
      disabled = _ref.disabled,
      other = SelectCreditCardForm__objectWithoutProperties(_ref, ["onToggleForm", "className", "disabled"]);

  return react_default.a.createElement(SelectCreditCardForm_Wrapper, {
    className: className,
    disabled: disabled,
    "data-qa-id": "credit-card-forms-select-card"
  }, react_default.a.createElement(CreditCardForm_CreditCardOptions_CreditCardOptions, other), disabled ? react_default.a.createElement(DisabledOverlay, null) : react_default.a.createElement(AddCardButton, {
    buttonType: Button["b" /* default */].types.TEXT,
    onClick: onToggleForm,
    "data-qa-id": "credit-card-buttons-add"
  }, react_default.a.createElement(_lingui_react["Trans"], {
    id: "Add Credit Card"
  })));
};

/* harmony default export */ var CreditCardForm_SelectCreditCardForm_SelectCreditCardForm = (SelectCreditCardForm_SelectCreditCardForm);
// CONCATENATED MODULE: ../react-lib/src/components/forms/CreditCardForm/SelectCreditCardForm/index.js

// EXTERNAL MODULE: ../node_modules/braintree-web/dist/browser/hosted-fields.js
var hosted_fields = __webpack_require__(536);
var hosted_fields_default = /*#__PURE__*/__webpack_require__.n(hosted_fields);

// EXTERNAL MODULE: ../node_modules/lodash-es/get.js
var get = __webpack_require__(82);

// EXTERNAL MODULE: ../node_modules/braintree-web/dist/browser/client.js
var client = __webpack_require__(538);
var client_default = /*#__PURE__*/__webpack_require__.n(client);

// CONCATENATED MODULE: ../utilities/braintree.js
function braintree_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function braintree__asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { braintree_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { braintree_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }




var braintree_braintreeInstance;
var BRAINTREE_TOKENIZATION_KEY = Object(injector["a" /* default */])('Rover.context.BRAINTREE_TOKENIZATION_KEY');
var braintreeInstancePromise = client_default.a.create({
  authorization: BRAINTREE_TOKENIZATION_KEY
});
var getInstance =
/*#__PURE__*/
function () {
  var _ref = braintree__asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee() {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (braintree_braintreeInstance) {
              _context.next = 4;
              break;
            }

            _context.next = 3;
            return braintreeInstancePromise;

          case 3:
            braintree_braintreeInstance = _context.sent;

          case 4:
            return _context.abrupt("return", braintree_braintreeInstance);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getInstance() {
    return _ref.apply(this, arguments);
  };
}();
var braintree_encrypt = function encrypt() {
  Object(reportError["a" /* default */])('The new Braintree SDK does not support encrypt.');
};
// EXTERNAL MODULE: ../react-lib/src/components/notifications/SuccessOrErrorAlert/index.js + 2 modules
var SuccessOrErrorAlert = __webpack_require__(257);

// EXTERNAL MODULE: ./js/constants/translationConstants.js
var translationConstants = __webpack_require__(215);

// EXTERNAL MODULE: ../react-lib/src/components/typography/LoadingSpinner/index.js + 1 modules
var LoadingSpinner = __webpack_require__(238);

// CONCATENATED MODULE: ../react-lib/src/components/forms/CreditCardForm/BraintreeCreditCardForm/LoadingOverlay.jsx




var Overlay = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LoadingOverlay__Overlay",
  componentId: "w60fmk-0"
})(["position:absolute;left:0;right:0;top:0;bottom:0;background-color:", ";display:flex;align-items:center;justify-content:center;"], styles["d" /* DSToken */].BACKGROUND_COLOR_PRIMARY);
var StyledSpinner = Object(styled_components_browser_esm["default"])(LoadingSpinner["a" /* default */]).withConfig({
  displayName: "LoadingOverlay__StyledSpinner",
  componentId: "w60fmk-1"
})(["font-size:24px;"]);

var LoadingOverlay_LoadingOverlay = function LoadingOverlay() {
  return react_default.a.createElement(Overlay, null, react_default.a.createElement(StyledSpinner, {
    "data-qa-id": "credit-card-forms-spinner"
  }));
};

/* harmony default export */ var BraintreeCreditCardForm_LoadingOverlay = (LoadingOverlay_LoadingOverlay);
// CONCATENATED MODULE: ../react-lib/src/components/forms/CreditCardForm/BraintreeCreditCardForm/CreditCardNameField.jsx
function CreditCardNameField__extends() { CreditCardNameField__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return CreditCardNameField__extends.apply(this, arguments); }





var CreditCardNameField_CreditCardNameField = function CreditCardNameField(props) {
  return react_default.a.createElement(_lingui_react["I18n"], null, function (_ref) {
    var i18n = _ref.i18n;
    return react_default.a.createElement(TextInput["a" /* default */], CreditCardNameField__extends({
      sensitive: true,
      label: i18n._('Name on Card'),
      name: "cardholder-name",
      placeholder: i18n._('Name on Card'),
      autoComplete: "cc-name",
      "data-qa-id": "credit-card-inputs-name"
    }, props));
  });
};

/* harmony default export */ var BraintreeCreditCardForm_CreditCardNameField = (CreditCardNameField_CreditCardNameField);
// CONCATENATED MODULE: ../react-lib/src/components/forms/CreditCardForm/BraintreeCreditCardForm/CreditCardForm.jsx







var CreditCardNumberInputContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CreditCardForm__CreditCardNumberInputContainer",
  componentId: "sc-57f1xv-0"
})(["flex-grow:1;", "{flex-basis:400px;}"], styles["i" /* MQ */].NOT_XS);
var ExpirationInputContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CreditCardForm__ExpirationInputContainer",
  componentId: "sc-57f1xv-1"
})(["flex-grow:1;", "{flex-basis:120px;}"], styles["i" /* MQ */].NOT_XS);
var CVVInputContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CreditCardForm__CVVInputContainer",
  componentId: "sc-57f1xv-2"
})(["flex-grow:1;", "{flex-basis:120px;}"], styles["i" /* MQ */].NOT_XS);
var InputWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CreditCardForm__InputWrapper",
  componentId: "sc-57f1xv-3"
})(["display:flex;", "{flex-direction:row;div + div{margin-left:15px;}}", "{flex-direction:column;}"], styles["i" /* MQ */].NOT_XS, styles["i" /* MQ */].XS_DOWN);

var CreditCardForm_getBorderColor = function getBorderColor(_ref) {
  var isFocus = _ref.isFocus;
  if (isFocus) return "1px solid ".concat(styles["d" /* DSToken */].BORDER_COLOR_INPUT_FOCUS);
  return "1px solid ".concat(styles["d" /* DSToken */].BORDER_COLOR_PRIMARY);
};

var InputPlaceHolder = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CreditCardForm__InputPlaceHolder",
  componentId: "sc-57f1xv-4"
})(["height:40px;padding:8px;box-shadow:none;border-radius:4px;display:flex;border:", ";"], CreditCardForm_getBorderColor);
var CardNumberPlaceHolder = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CreditCardForm__CardNumberPlaceHolder",
  componentId: "sc-57f1xv-5"
})(["flex-grow:1;height:25px;"]);
var ExpirationAndCvvContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CreditCardForm__ExpirationAndCvvContainer",
  componentId: "sc-57f1xv-6"
})(["flex-direction:row;display:flex;", "{flex-basis:260px;flex-grow:1;}", "{div + div{margin-left:15px;}}"], styles["i" /* MQ */].NOT_XS, styles["i" /* MQ */].XS_DOWN);

var CreditCardForm_CreditCardForm = function CreditCardForm(_ref2) {
  var form = _ref2.form,
      cardType = _ref2.cardType,
      currentFocus = _ref2.currentFocus;
  return react_default.a.createElement(_lingui_react["I18n"], null, function (_ref3) {
    var i18n = _ref3.i18n;
    return react_default.a.createElement(react["Fragment"], null, react_default.a.createElement(BraintreeCreditCardForm_CreditCardNameField, {
      value: form.data.creditCard.cardholderName,
      onChange: function onChange(cardholderName) {
        return form.onChange({
          creditCard: {
            cardholderName: cardholderName
          }
        });
      },
      validationError: form.validationErrors.creditCard.cardholderName,
      "data-qa-id": "input-text-credit-card-name-on-card"
    }), react_default.a.createElement(InputWrapper, null, react_default.a.createElement(CreditCardNumberInputContainer, null, react_default.a.createElement(LabelAndErrorFormGroup["b" /* default */], {
      label: i18n._('Card Number'),
      validationError: form.validationErrors.creditCard.creditCardNumber
    }, function () {
      return react_default.a.createElement(InputPlaceHolder, {
        isFocus: currentFocus === 'number'
      }, react_default.a.createElement(CardNumberPlaceHolder, {
        id: "card-number"
      }), react_default.a.createElement(typography_CreditCardIcon_CreditCardIcon, {
        type: cardType || null
      }));
    })), react_default.a.createElement(ExpirationAndCvvContainer, null, react_default.a.createElement(ExpirationInputContainer, null, react_default.a.createElement(LabelAndErrorFormGroup["b" /* default */], {
      label: i18n._('Expiration'),
      validationError: form.validationErrors.creditCard.expiration,
      InputComponent: InputPlaceHolder,
      id: "expiration",
      isFocus: currentFocus === 'expirationDate'
    })), react_default.a.createElement(CVVInputContainer, null, react_default.a.createElement(LabelAndErrorFormGroup["b" /* default */], {
      label: "CVV",
      validationError: form.validationErrors.creditCard.cvv,
      InputComponent: InputPlaceHolder,
      id: "cvv",
      isFocus: currentFocus === 'cvv'
    })))));
  });
};

/* harmony default export */ var BraintreeCreditCardForm_CreditCardForm = (CreditCardForm_CreditCardForm);
// CONCATENATED MODULE: ../react-lib/src/components/forms/CreditCardForm/BraintreeCreditCardForm/BraintreeCreditCardForm.jsx
function BraintreeCreditCardForm__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { BraintreeCreditCardForm__typeof = function _typeof(obj) { return typeof obj; }; } else { BraintreeCreditCardForm__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return BraintreeCreditCardForm__typeof(obj); }

function BraintreeCreditCardForm_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function BraintreeCreditCardForm__asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { BraintreeCreditCardForm_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { BraintreeCreditCardForm_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function BraintreeCreditCardForm__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function BraintreeCreditCardForm__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function BraintreeCreditCardForm__createClass(Constructor, protoProps, staticProps) { if (protoProps) BraintreeCreditCardForm__defineProperties(Constructor.prototype, protoProps); if (staticProps) BraintreeCreditCardForm__defineProperties(Constructor, staticProps); return Constructor; }

function BraintreeCreditCardForm__possibleConstructorReturn(self, call) { if (call && (BraintreeCreditCardForm__typeof(call) === "object" || typeof call === "function")) { return call; } return BraintreeCreditCardForm__assertThisInitialized(self); }

function BraintreeCreditCardForm__assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function BraintreeCreditCardForm__getPrototypeOf(o) { BraintreeCreditCardForm__getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return BraintreeCreditCardForm__getPrototypeOf(o); }

function BraintreeCreditCardForm__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) BraintreeCreditCardForm__setPrototypeOf(subClass, superClass); }

function BraintreeCreditCardForm__setPrototypeOf(o, p) { BraintreeCreditCardForm__setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return BraintreeCreditCardForm__setPrototypeOf(o, p); }

function BraintreeCreditCardForm_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function BraintreeCreditCardForm__objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { BraintreeCreditCardForm_ownKeys(source, true).forEach(function (key) { BraintreeCreditCardForm__defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { BraintreeCreditCardForm_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function BraintreeCreditCardForm__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





















var BraintreeCreditCardForm_getValidators = function getValidators() {
  return function (_ref) {
    var hostedFieldsInstance = _ref.creditCard.hostedFieldsInstance,
        address = _ref.address;
    var hostedFieldsInstanceState = hostedFieldsInstance && hostedFieldsInstance.getState();
    return BraintreeCreditCardForm__objectSpread({
      creditCard: {
        cardholderName: [Form["a" /* default */].validators.required, Form["a" /* default */].validators.cardHolderName],
        creditCardNumber: function creditCardNumber() {
          if (Object(get["a" /* default */])(hostedFieldsInstanceState, 'fields.number.isEmpty') || !Object(get["a" /* default */])(hostedFieldsInstanceState, 'fields.number.isValid')) {
            return translationConstants["c" /* BrainTreeCreditCardConstants */].isInvalidCreditCardString;
          }

          return null;
        },
        expiration: function expiration() {
          if (Object(get["a" /* default */])(hostedFieldsInstanceState, 'fields.expirationDate.isEmpty') || !Object(get["a" /* default */])(hostedFieldsInstanceState, 'fields.expirationDate.isValid')) {
            return translationConstants["c" /* BrainTreeCreditCardConstants */].isInvalidExpirationDateString;
          }

          return null;
        },
        cvv: function cvv() {
          if (Object(get["a" /* default */])(hostedFieldsInstanceState, 'fields.cvv.isEmpty') || !Object(get["a" /* default */])(hostedFieldsInstanceState, 'fields.cvv.isValid')) {
            return translationConstants["c" /* BrainTreeCreditCardConstants */].isInvalidCVVString;
          }

          return null;
        }
      }
    }, AddressForm["a" /* default */].getValidators(address));
  };
};

var CreditCardContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "BraintreeCreditCardForm__CreditCardContainer",
  componentId: "sc-1h5y5eq-0"
})(["position:relative;"]);
var BillingAddressTitle = styled_components_browser_esm["default"].h5.withConfig({
  displayName: "BraintreeCreditCardForm__BillingAddressTitle",
  componentId: "sc-1h5y5eq-1"
})(["margin:", " 0 ", " 0;font-weight:", ";"], styles["k" /* Spacing */].M, styles["k" /* Spacing */].S, styles["h" /* FontWeight */].BOLD);
var BraintreeCreditCardForm_ButtonGroup = styled_components_browser_esm["default"].div.withConfig({
  displayName: "BraintreeCreditCardForm__ButtonGroup",
  componentId: "sc-1h5y5eq-2"
})(["display:flex;justify-content:flex-end;"]); // TODO: move this to a type file when we clean up

var BraintreeCreditCardForm_BraintreeCreditCardForm =
/*#__PURE__*/
function (_React$Component) {
  BraintreeCreditCardForm__inherits(BraintreeCreditCardForm, _React$Component);

  function BraintreeCreditCardForm() {
    var _getPrototypeOf2;

    var _this;

    BraintreeCreditCardForm__classCallCheck(this, BraintreeCreditCardForm);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = BraintreeCreditCardForm__possibleConstructorReturn(this, (_getPrototypeOf2 = BraintreeCreditCardForm__getPrototypeOf(BraintreeCreditCardForm)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      hostedFieldsInstance: null,
      currentFocus: '',
      cardType: null,
      usePrimaryAddress: Object(utils_address["c" /* isValidAddress */])(_this.props.address),
      braintreeError: ''
    };

    _this.getHandleSubmit = function (onSubmit, onToggleForm) {
      return (
        /*#__PURE__*/
        function () {
          var _ref3 = BraintreeCreditCardForm__asyncToGenerator(
          /*#__PURE__*/
          regeneratorRuntime.mark(function _callee(_ref2) {
            var creditCard, address, _ref4, nonce, isSuccessful;

            return regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    creditCard = _ref2.creditCard, address = _ref2.address;

                    _this.setState(function () {
                      return {
                        braintreeError: ''
                      };
                    });

                    _context.prev = 2;
                    _context.next = 5;
                    return creditCard.hostedFieldsInstance.tokenize({
                      billingAddress: {
                        postalCode: address.zip
                      }
                    });

                  case 5:
                    _ref4 = _context.sent;
                    nonce = _ref4.nonce;
                    _context.next = 9;
                    return onSubmit({
                      creditCard: {
                        cardholderName: creditCard.cardholderName,
                        nonce: nonce
                      },
                      address: address,
                      formVersion: 'braintree'
                    });

                  case 9:
                    isSuccessful = _context.sent;

                    if (isSuccessful && onToggleForm) {
                      onToggleForm();
                    }

                    _context.next = 17;
                    break;

                  case 13:
                    _context.prev = 13;
                    _context.t0 = _context["catch"](2);

                    _this.setState(function () {
                      return {
                        braintreeError: translationConstants["c" /* BrainTreeCreditCardConstants */].braintreeErrorMessage
                      };
                    });

                    Object(reportError["a" /* default */])(_context.t0);

                  case 17:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee, null, [[2, 13]]);
          }));

          return function (_x) {
            return _ref3.apply(this, arguments);
          };
        }()
      );
    };

    return _this;
  }

  BraintreeCreditCardForm__createClass(BraintreeCreditCardForm, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = BraintreeCreditCardForm__asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2() {
        var _this2 = this;

        var braintreeInstance, hostedFieldsInstance;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return getInstance();

              case 2:
                braintreeInstance = _context2.sent;
                _context2.next = 5;
                return hosted_fields_default.a.create({
                  client: braintreeInstance,
                  styles: {
                    input: {
                      'font-size': "".concat(styles["g" /* FontSize */].M),
                      color: "".concat(styles["d" /* DSToken */].TEXT_COLOR_SECONDARY),
                      'font-family': styles["e" /* FONT_FAMILY */]
                    },
                    'input::placeholder': {
                      color: "".concat(styles["d" /* DSToken */].TEXT_COLOR_TERTIARY),
                      opacity: 1
                    }
                  },
                  fields: {
                    number: {
                      selector: '#card-number',
                      placeholder: translationConstants["c" /* BrainTreeCreditCardConstants */].creditCardNumberPlaceholder
                    },
                    cvv: {
                      selector: '#cvv',
                      placeholder: 'CVV'
                    },
                    expirationDate: {
                      selector: '#expiration',
                      placeholder: 'MM/YYYY'
                    }
                  }
                });

              case 5:
                hostedFieldsInstance = _context2.sent;
                // this approach is cleaner than putting it in a callback.
                // eslint-disable-next-line react/no-did-mount-set-state
                this.setState({
                  hostedFieldsInstance: hostedFieldsInstance
                });
                hostedFieldsInstance.on('focus', function (stateObj) {
                  _this2.setState({
                    currentFocus: stateObj.emittedBy
                  });
                });
                hostedFieldsInstance.on('blur', function () {
                  _this2.setState({
                    currentFocus: ''
                  });
                });
                hostedFieldsInstance.on('cardTypeChange', function (_ref5) {
                  var cards = _ref5.cards,
                      fields = _ref5.fields;

                  if (fields.number.isEmpty) {
                    _this2.setState({
                      cardType: null
                    });
                  } else {
                    var reconizedTypes = cards.map(function (_ref6) {
                      var type = _ref6.type;
                      return creditCard_constants["b" /* CARD_TYPES */][type];
                    }).filter(Boolean);

                    if (reconizedTypes.length) {
                      _this2.setState({
                        cardType: reconizedTypes[0].display
                      });
                    }
                  }
                });

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.hostedFieldsInstance) {
        this.state.hostedFieldsInstance.teardown(function (teardownErr) {
          if (teardownErr) {
            Object(reportError["a" /* default */])(new Error("Could not tear down Hosted Fields! ".concat(teardownErr)));
          }
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          address = _this$props.address,
          loading = _this$props.loading,
          onSubmit = _this$props.onSubmit,
          nestedForm = _this$props.nestedForm,
          onToggleForm = _this$props.onToggleForm,
          hideCancelButton = _this$props.hideCancelButton,
          supportedCountryCodes = _this$props.supportedCountryCodes,
          centerButtons = _this$props.centerButtons,
          saveButtonText = _this$props.saveButtonText;
      var _this$state = this.state,
          hostedFieldsInstance = _this$state.hostedFieldsInstance,
          cardType = _this$state.cardType,
          currentFocus = _this$state.currentFocus,
          usePrimaryAddress = _this$state.usePrimaryAddress,
          braintreeError = _this$state.braintreeError;
      var buttonGroupStyle = centerButtons ? {
        justifyContent: 'center'
      } : {};
      return react_default.a.createElement(Form["a" /* default */], {
        onSubmit: this.getHandleSubmit(onSubmit, onToggleForm),
        "data-qa-id": "credit-card-forms-add-card",
        nested: nestedForm,
        initialData: {
          creditCard: {
            hostedFieldsInstance: hostedFieldsInstance,
            cardholderName: ''
          },
          address: address
        } // validators will return more fields than the data since hostedFieldInstance is holding onto some of the data
        ,
        validators: BraintreeCreditCardForm_getValidators()
      }, function (form) {
        return react_default.a.createElement("div", null, react_default.a.createElement(SuccessOrErrorAlert["a" /* default */], {
          error: braintreeError
        }), react_default.a.createElement(CreditCardContainer, null, react_default.a.createElement(BraintreeCreditCardForm_CreditCardForm, {
          form: form,
          cardType: cardType,
          currentFocus: currentFocus
        }), !hostedFieldsInstance && react_default.a.createElement(BraintreeCreditCardForm_LoadingOverlay, null)), react_default.a.createElement(BillingAddressTitle, null, react_default.a.createElement(_lingui_react["Trans"], {
          id: "Billing Address"
        })), Object(utils_address["c" /* isValidAddress */])(address) && react_default.a.createElement(BraintreeCreditCardForm_AddressCheckbox, {
          onChange: function onChange() {
            _this3.setState({
              usePrimaryAddress: !usePrimaryAddress
            });
          },
          address: address,
          isChecked: usePrimaryAddress
        }), !usePrimaryAddress && react_default.a.createElement(AddressForm["a" /* default */], {
          address: form.data.address,
          onChange: function onChange(changes) {
            form.onChange({
              address: changes
            });
          },
          validationErrors: form.validationErrors,
          supportedCountryCodes: supportedCountryCodes
        }), react_default.a.createElement(BraintreeCreditCardForm_ButtonGroup, {
          style: buttonGroupStyle
        }, !hideCancelButton && react_default.a.createElement(Button["b" /* default */], {
          buttonType: Button["a" /* ButtonType */].TEXT,
          onClick: onToggleForm
        }, react_default.a.createElement(_lingui_react["Trans"], {
          id: "Cancel"
        })), react_default.a.createElement(LoadingButton["a" /* default */], {
          loading: loading,
          buttonType: Button["a" /* ButtonType */].PRIMARY,
          onClick: form.onSubmit,
          "data-qa-id": "credit-card-buttons-save"
        }, saveButtonText || react_default.a.createElement(_lingui_react["Trans"], {
          id: "Save Card"
        }))));
      });
    }
  }]);

  return BraintreeCreditCardForm;
}(react_default.a.Component);


// CONCATENATED MODULE: ../react-lib/src/components/forms/CreditCardForm/BraintreeCreditCardForm/index.js

// CONCATENATED MODULE: ../react-lib/src/components/forms/CreditCardForm/CreditCardForm.jsx
function CreditCardForm__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { CreditCardForm__typeof = function _typeof(obj) { return typeof obj; }; } else { CreditCardForm__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return CreditCardForm__typeof(obj); }

function CreditCardForm__objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = CreditCardForm__objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function CreditCardForm__objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function CreditCardForm__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function CreditCardForm__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function CreditCardForm__createClass(Constructor, protoProps, staticProps) { if (protoProps) CreditCardForm__defineProperties(Constructor.prototype, protoProps); if (staticProps) CreditCardForm__defineProperties(Constructor, staticProps); return Constructor; }

function CreditCardForm__possibleConstructorReturn(self, call) { if (call && (CreditCardForm__typeof(call) === "object" || typeof call === "function")) { return call; } return CreditCardForm__assertThisInitialized(self); }

function CreditCardForm__assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function CreditCardForm__getPrototypeOf(o) { CreditCardForm__getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return CreditCardForm__getPrototypeOf(o); }

function CreditCardForm__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) CreditCardForm__setPrototypeOf(subClass, superClass); }

function CreditCardForm__setPrototypeOf(o, p) { CreditCardForm__setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return CreditCardForm__setPrototypeOf(o, p); }










var useStripeContext = Object(injector["a" /* default */])('Rover.context.useStripe', false);

var CreditCardForm_CreditCardForm_CreditCardForm =
/*#__PURE__*/
function (_Component) {
  CreditCardForm__inherits(CreditCardForm, _Component);

  function CreditCardForm() {
    var _getPrototypeOf2;

    var _this;

    CreditCardForm__classCallCheck(this, CreditCardForm);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = CreditCardForm__possibleConstructorReturn(this, (_getPrototypeOf2 = CreditCardForm__getPrototypeOf(CreditCardForm)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      addingCard: false
    };

    _this.handleToggle = function (isAdding) {
      var onReportFormVisibility = _this.props.onReportFormVisibility;
      onReportFormVisibility(isAdding);

      _this.setState(function () {
        return {
          addingCard: isAdding
        };
      });
    };

    return _this;
  }

  CreditCardForm__createClass(CreditCardForm, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
          selectedCardId = _this$props.selectedCardId,
          onChange = _this$props.onChange;

      if (selectedCardId && !prevProps.selectedCardId) {
        onChange(selectedCardId);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          address = _this$props2.address,
          onAddCard = _this$props2.onAddCard,
          loading = _this$props2.loading,
          hideAddCardCancelButton = _this$props2.hideAddCardCancelButton,
          partialPostalRegExp = _this$props2.partialPostalRegExp,
          fullPostalRegExp = _this$props2.fullPostalRegExp,
          getStateFieldNameByPostalCode = _this$props2.getStateFieldNameByPostalCode,
          isStateFieldRequiredByPostalCode = _this$props2.isStateFieldRequiredByPostalCode,
          supportedCountryCodes = _this$props2.supportedCountryCodes,
          language = _this$props2.language,
          creditCards = _this$props2.creditCards,
          selectedCardId = _this$props2.selectedCardId,
          onDeleteCard = _this$props2.onDeleteCard,
          onChange = _this$props2.onChange,
          radioName = _this$props2.radioName,
          validationErrors = _this$props2.validationErrors,
          nestedForm = _this$props2.nestedForm,
          errorMessage = _this$props2.errorMessage,
          onReportFormVisibility = _this$props2.onReportFormVisibility,
          disabled = _this$props2.disabled,
          useStripe = _this$props2.useStripe,
          isSubmitting = _this$props2.isSubmitting,
          centerButtons = _this$props2.centerButtons,
          saveButtonText = _this$props2.saveButtonText,
          others = CreditCardForm__objectWithoutProperties(_this$props2, ["address", "onAddCard", "loading", "hideAddCardCancelButton", "partialPostalRegExp", "fullPostalRegExp", "getStateFieldNameByPostalCode", "isStateFieldRequiredByPostalCode", "supportedCountryCodes", "language", "creditCards", "selectedCardId", "onDeleteCard", "onChange", "radioName", "validationErrors", "nestedForm", "errorMessage", "onReportFormVisibility", "disabled", "useStripe", "isSubmitting", "centerButtons", "saveButtonText"]);

      var addingCard = this.state.addingCard;
      var creditCardElement;

      if (addingCard || !loading && creditCards.length === 0) {
        var formProps = {
          address: address,
          onSubmit: onAddCard,
          onToggleForm: function onToggleForm() {
            return _this2.handleToggle(false);
          },
          validationErrors: validationErrors,
          loading: loading,
          nestedForm: nestedForm,
          hideCancelButton: hideAddCardCancelButton,
          fullPostalRegExp: fullPostalRegExp,
          partialPostalRegExp: partialPostalRegExp,
          getStateFieldNameByPostalCode: getStateFieldNameByPostalCode,
          isStateFieldRequiredByPostalCode: isStateFieldRequiredByPostalCode,
          isSubmitting: isSubmitting,
          supportedCountryCodes: supportedCountryCodes,
          language: language,
          centerButtons: centerButtons,
          saveButtonText: saveButtonText
        };

        if (useStripe) {
          creditCardElement = react_default.a.createElement(StripeCreditCardForm_StripeCreditCardForm, formProps);
        } else {
          creditCardElement = react_default.a.createElement(BraintreeCreditCardForm_BraintreeCreditCardForm, formProps);
        }
      } else {
        creditCardElement = react_default.a.createElement(CreditCardForm_SelectCreditCardForm_SelectCreditCardForm, {
          cards: creditCards,
          value: selectedCardId,
          onChange: onChange,
          onDelete: onDeleteCard,
          onToggleForm: function onToggleForm() {
            return _this2.handleToggle(true);
          },
          radioName: radioName,
          disabled: disabled
        });
      }

      return react_default.a.createElement(FormGroup["b" /* default */], others, react_default.a.createElement(FormValidationError["a" /* default */], {
        message: validationErrors && (validationErrors.selectedCardId || validationErrors.formVisible)
      }, react_default.a.createElement(SuccessOrErrorAlert["a" /* default */], {
        error: errorMessage
      }), creditCardElement));
    }
  }]);

  return CreditCardForm;
}(react["Component"]);

CreditCardForm_CreditCardForm_CreditCardForm.defaultProps = {
  step: 0,
  loading: false,
  hideAddCardCancelButton: undefined,
  nestedForm: false,
  getStateFieldNameByPostalCode: function getStateFieldNameByPostalCode() {
    return '';
  },
  isStateFieldRequiredByPostalCode: function isStateFieldRequiredByPostalCode() {
    return true;
  },
  creditCards: [],
  selectedCardId: '',
  addingCard: false,
  validationErrors: undefined,
  onReportFormVisibility: function onReportFormVisibility() {},
  disabled: false,
  centerButtons: false,
  useStripe: useStripeContext
};
CreditCardForm_CreditCardForm_CreditCardForm.validators = {
  selectedCardId: Form["a" /* default */].validators.required(
  /*i18n*/
  {
    id: "Credit card is required"
  })
};

// CONCATENATED MODULE: ../react-lib/src/components/forms/CreditCardForm/index.js

// EXTERNAL MODULE: ../react-lib/src/redux/ducks/address.duck.js + 1 modules
var address_duck = __webpack_require__(317);

// EXTERNAL MODULE: ../react-lib/src/redux/ducks/creditCards.duck.js + 1 modules
var creditCards_duck = __webpack_require__(366);

// EXTERNAL MODULE: ../react-lib/src/redux/ducks/countryConfiguration.duck.js + 2 modules
var countryConfiguration_duck = __webpack_require__(202);

// EXTERNAL MODULE: ../react-lib/src/redux/ducks/frontendConfiguration.duck.js + 3 modules
var frontendConfiguration_duck = __webpack_require__(149);

// CONCATENATED MODULE: ../react-lib/src/containers/CreditCardFormContainer.jsx
function CreditCardFormContainer__extends() { CreditCardFormContainer__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return CreditCardFormContainer__extends.apply(this, arguments); }

function CreditCardFormContainer__objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = CreditCardFormContainer__objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function CreditCardFormContainer__objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function CreditCardFormContainer__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { CreditCardFormContainer__typeof = function _typeof(obj) { return typeof obj; }; } else { CreditCardFormContainer__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return CreditCardFormContainer__typeof(obj); }

function CreditCardFormContainer__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function CreditCardFormContainer__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function CreditCardFormContainer__createClass(Constructor, protoProps, staticProps) { if (protoProps) CreditCardFormContainer__defineProperties(Constructor.prototype, protoProps); if (staticProps) CreditCardFormContainer__defineProperties(Constructor, staticProps); return Constructor; }

function CreditCardFormContainer__possibleConstructorReturn(self, call) { if (call && (CreditCardFormContainer__typeof(call) === "object" || typeof call === "function")) { return call; } return CreditCardFormContainer__assertThisInitialized(self); }

function CreditCardFormContainer__assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function CreditCardFormContainer__getPrototypeOf(o) { CreditCardFormContainer__getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return CreditCardFormContainer__getPrototypeOf(o); }

function CreditCardFormContainer__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) CreditCardFormContainer__setPrototypeOf(subClass, superClass); }

function CreditCardFormContainer__setPrototypeOf(o, p) { CreditCardFormContainer__setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return CreditCardFormContainer__setPrototypeOf(o, p); }









var CreditCardFormContainer_selector = function selector(state) {
  return {
    address: address_duck["d" /* selectors */].getAddress(state),
    loading: creditCards_duck["d" /* selectors */].getLoading(state),
    creditCards: creditCards_duck["d" /* selectors */].getCreditCards(state),
    errorMessage: creditCards_duck["d" /* selectors */].getErrorMessage(state),
    defaultCardId: creditCards_duck["d" /* selectors */].getDefaultCreditCardId(state),
    getStateFieldNameByPostalCode: countryConfiguration_duck["c" /* selectors */].getStateFieldNameByPostalCode(state),
    isStateFieldRequiredByPostalCode: countryConfiguration_duck["c" /* selectors */].getIsStateRequiredByPostalCode(state),
    fullPostalRegExp: countryConfiguration_duck["c" /* selectors */].getCombinedRegex(state),
    partialPostalRegExp: countryConfiguration_duck["c" /* selectors */].getCombinedPartialRegex(state),
    supportedCountryCodes: countryConfiguration_duck["c" /* selectors */].getCountryCodes(state),
    isSubmitting: creditCards_duck["d" /* selectors */].getLoading(state),
    language: frontendConfiguration_duck["c" /* selectors */].getLanguage(state)
  };
};

var effects = {
  onAddCard: creditCards_duck["b" /* effects */].saveCreditCard,
  onSelectCard: creditCards_duck["b" /* effects */].setDefaultCreditCard,
  onDeleteCard: creditCards_duck["b" /* effects */].removeCreditCard
};

var FormResetter =
/*#__PURE__*/
function (_Component) {
  CreditCardFormContainer__inherits(FormResetter, _Component);

  function FormResetter() {
    CreditCardFormContainer__classCallCheck(this, FormResetter);

    return CreditCardFormContainer__possibleConstructorReturn(this, CreditCardFormContainer__getPrototypeOf(FormResetter).apply(this, arguments));
  }

  CreditCardFormContainer__createClass(FormResetter, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      // if the default card changes from the API, reset the
      // selected card to be that default
      if (prevProps.defaultCardId !== this.props.defaultCardId) {
        this.props.onChange(this.props.defaultCardId);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return FormResetter;
}(react["Component"]);

var CreditCardFormContainer_CreditCardFormContainer = function CreditCardFormContainer(_ref) {
  var _onChange = _ref.onChange,
      selectedCardId = _ref.selectedCardId,
      validationErrors = _ref.validationErrors,
      shouldSetDefaultCardOnChange = _ref.shouldSetDefaultCardOnChange,
      other = CreditCardFormContainer__objectWithoutProperties(_ref, ["onChange", "selectedCardId", "validationErrors", "shouldSetDefaultCardOnChange"]);

  return react_default.a.createElement(Connect["a" /* default */], {
    selector: CreditCardFormContainer_selector,
    effects: effects
  }, function (_ref2) {
    var onSelectCard = _ref2.onSelectCard,
        creditCards = _ref2.creditCards,
        defaultCardId = _ref2.defaultCardId,
        otherConnectedProps = CreditCardFormContainer__objectWithoutProperties(_ref2, ["onSelectCard", "creditCards", "defaultCardId"]);

    return react_default.a.createElement(react["Fragment"], null, react_default.a.createElement(CreditCardForm_CreditCardForm_CreditCardForm, CreditCardFormContainer__extends({
      creditCards: creditCards,
      selectedCardId: selectedCardId,
      onChange: function onChange(cardId) {
        _onChange(cardId);

        if (shouldSetDefaultCardOnChange) {
          onSelectCard(cardId);
        }
      },
      hideAddCardCancelButton: creditCards.length === 0
    }, otherConnectedProps, other)), react_default.a.createElement(FormResetter, {
      defaultCardId: defaultCardId,
      onChange: _onChange
    }));
  });
};

CreditCardFormContainer_CreditCardFormContainer.defaultProps = {
  shouldSetDefaultCardOnChange: true
};
/* harmony default export */ var containers_CreditCardFormContainer = __webpack_exports__["a"] = (CreditCardFormContainer_CreditCardFormContainer);

/***/ }),
/* 534 */
/***/ (function(module, exports) {

module.exports = [{"code":"AF","name":"Afghanistan"},{"code":"AX","name":"Åland Islands"},{"code":"AL","name":"Albania"},{"code":"DZ","name":"Algeria"},{"code":"AS","name":"American Samoa"},{"code":"AD","name":"Andorra"},{"code":"AO","name":"Angola"},{"code":"AI","name":"Anguilla"},{"code":"AQ","name":"Antarctica"},{"code":"AG","name":"Antigua and Barbuda"},{"code":"AR","name":"Argentina"},{"code":"AM","name":"Armenia"},{"code":"AW","name":"Aruba"},{"code":"AU","name":"Australia"},{"code":"AT","name":"Austria"},{"code":"AZ","name":"Azerbaijan"},{"code":"BS","name":"Bahamas"},{"code":"BH","name":"Bahrain"},{"code":"BD","name":"Bangladesh"},{"code":"BB","name":"Barbados"},{"code":"BY","name":"Belarus"},{"code":"BE","name":"Belgium"},{"code":"BZ","name":"Belize"},{"code":"BJ","name":"Benin"},{"code":"BM","name":"Bermuda"},{"code":"BT","name":"Bhutan"},{"code":"BO","name":"Bolivia, Plurinational State of"},{"code":"BQ","name":"Bonaire, Sint Eustatius and Saba"},{"code":"BA","name":"Bosnia and Herzegovina"},{"code":"BW","name":"Botswana"},{"code":"BV","name":"Bouvet Island"},{"code":"BR","name":"Brazil"},{"code":"IO","name":"British Indian Ocean Territory"},{"code":"BN","name":"Brunei Darussalam"},{"code":"BG","name":"Bulgaria"},{"code":"BF","name":"Burkina Faso"},{"code":"BI","name":"Burundi"},{"code":"CV","name":"Cabo Verde"},{"code":"KH","name":"Cambodia"},{"code":"CM","name":"Cameroon"},{"code":"CA","name":"Canada"},{"code":"KY","name":"Cayman Islands"},{"code":"CF","name":"Central African Republic"},{"code":"TD","name":"Chad"},{"code":"CL","name":"Chile"},{"code":"CN","name":"China"},{"code":"CX","name":"Christmas Island"},{"code":"CC","name":"Cocos (Keeling) Islands"},{"code":"CO","name":"Colombia"},{"code":"KM","name":"Comoros"},{"code":"CG","name":"Congo"},{"code":"CD","name":"Congo, the Democratic Republic of the"},{"code":"CK","name":"Cook Islands"},{"code":"CR","name":"Costa Rica"},{"code":"CI","name":"Côte d'Ivoire"},{"code":"HR","name":"Croatia"},{"code":"CU","name":"Cuba"},{"code":"CW","name":"Curaçao"},{"code":"CY","name":"Cyprus"},{"code":"CZ","name":"Czech Republic"},{"code":"DK","name":"Denmark"},{"code":"DJ","name":"Djibouti"},{"code":"DM","name":"Dominica"},{"code":"DO","name":"Dominican Republic"},{"code":"EC","name":"Ecuador"},{"code":"EG","name":"Egypt"},{"code":"SV","name":"El Salvador"},{"code":"GQ","name":"Equatorial Guinea"},{"code":"ER","name":"Eritrea"},{"code":"EE","name":"Estonia"},{"code":"SZ","name":"Eswatini"},{"code":"ET","name":"Ethiopia"},{"code":"FK","name":"Falkland Islands (Malvinas)"},{"code":"FO","name":"Faroe Islands"},{"code":"FJ","name":"Fiji"},{"code":"FI","name":"Finland"},{"code":"FR","name":"France"},{"code":"GF","name":"French Guiana"},{"code":"PF","name":"French Polynesia"},{"code":"TF","name":"French Southern Territories"},{"code":"GA","name":"Gabon"},{"code":"GM","name":"Gambia"},{"code":"GE","name":"Georgia"},{"code":"DE","name":"Germany"},{"code":"GH","name":"Ghana"},{"code":"GI","name":"Gibraltar"},{"code":"GR","name":"Greece"},{"code":"GL","name":"Greenland"},{"code":"GD","name":"Grenada"},{"code":"GP","name":"Guadeloupe"},{"code":"GU","name":"Guam"},{"code":"GT","name":"Guatemala"},{"code":"GG","name":"Guernsey"},{"code":"GN","name":"Guinea"},{"code":"GW","name":"Guinea-Bissau"},{"code":"GY","name":"Guyana"},{"code":"HT","name":"Haiti"},{"code":"HM","name":"Heard Island and McDonald Islands"},{"code":"VA","name":"Holy See"},{"code":"HN","name":"Honduras"},{"code":"HK","name":"Hong Kong"},{"code":"HU","name":"Hungary"},{"code":"IS","name":"Iceland"},{"code":"IN","name":"India"},{"code":"ID","name":"Indonesia"},{"code":"IR","name":"Iran, Islamic Republic of"},{"code":"IQ","name":"Iraq"},{"code":"IE","name":"Ireland"},{"code":"IM","name":"Isle of Man"},{"code":"IL","name":"Israel"},{"code":"IT","name":"Italy"},{"code":"JM","name":"Jamaica"},{"code":"JP","name":"Japan"},{"code":"JE","name":"Jersey"},{"code":"JO","name":"Jordan"},{"code":"KZ","name":"Kazakhstan"},{"code":"KE","name":"Kenya"},{"code":"KI","name":"Kiribati"},{"code":"KR","name":"Korea, the Republic of"},{"code":"KW","name":"Kuwait"},{"code":"KG","name":"Kyrgyzstan"},{"code":"LA","name":"Lao People's Democratic Republic"},{"code":"LV","name":"Latvia"},{"code":"LB","name":"Lebanon"},{"code":"LS","name":"Lesotho"},{"code":"LR","name":"Liberia"},{"code":"LY","name":"Libya"},{"code":"LI","name":"Liechtenstein"},{"code":"LT","name":"Lithuania"},{"code":"LU","name":"Luxembourg"},{"code":"MO","name":"Macao"},{"code":"MK","name":"Macedonia, the former Yugoslav Republic of"},{"code":"MG","name":"Madagascar"},{"code":"MW","name":"Malawi"},{"code":"MY","name":"Malaysia"},{"code":"MV","name":"Maldives"},{"code":"ML","name":"Mali"},{"code":"MT","name":"Malta"},{"code":"MH","name":"Marshall Islands"},{"code":"MQ","name":"Martinique"},{"code":"MR","name":"Mauritania"},{"code":"MU","name":"Mauritius"},{"code":"YT","name":"Mayotte"},{"code":"MX","name":"Mexico"},{"code":"FM","name":"Micronesia, Federated States of"},{"code":"MD","name":"Moldova, the Republic of"},{"code":"MC","name":"Monaco"},{"code":"MN","name":"Mongolia"},{"code":"ME","name":"Montenegro"},{"code":"MS","name":"Montserrat"},{"code":"MA","name":"Morocco"},{"code":"MZ","name":"Mozambique"},{"code":"MM","name":"Myanmar"},{"code":"NA","name":"Namibia"},{"code":"NR","name":"Nauru"},{"code":"NP","name":"Nepal"},{"code":"NL","name":"Netherlands"},{"code":"NC","name":"New Caledonia"},{"code":"NZ","name":"New Zealand"},{"code":"NI","name":"Nicaragua"},{"code":"NE","name":"Niger"},{"code":"NG","name":"Nigeria"},{"code":"NU","name":"Niue"},{"code":"NF","name":"Norfolk Island"},{"code":"MP","name":"Northern Mariana Islands"},{"code":"NO","name":"Norway"},{"code":"OM","name":"Oman"},{"code":"PK","name":"Pakistan"},{"code":"PW","name":"Palau"},{"code":"PS","name":"Palestine, State of"},{"code":"PA","name":"Panama"},{"code":"PG","name":"Papua New Guinea"},{"code":"PY","name":"Paraguay"},{"code":"PE","name":"Peru"},{"code":"PH","name":"Philippines"},{"code":"PN","name":"Pitcairn"},{"code":"PL","name":"Poland"},{"code":"PT","name":"Portugal"},{"code":"PR","name":"Puerto Rico"},{"code":"QA","name":"Qatar"},{"code":"RE","name":"Réunion"},{"code":"RO","name":"Romania"},{"code":"RU","name":"Russian Federation"},{"code":"RW","name":"Rwanda"},{"code":"BL","name":"Saint Barthélemy"},{"code":"SH","name":"Saint Helena, Ascension and Tristan da Cunha"},{"code":"KN","name":"Saint Kitts and Nevis"},{"code":"LC","name":"Saint Lucia"},{"code":"MF","name":"Saint Martin, French part"},{"code":"PM","name":"Saint Pierre and Miquelon"},{"code":"VC","name":"Saint Vincent and the Grenadines"},{"code":"WS","name":"Samoa"},{"code":"SM","name":"San Marino"},{"code":"ST","name":"Sao Tome and Principe"},{"code":"SA","name":"Saudi Arabia"},{"code":"SN","name":"Senegal"},{"code":"RS","name":"Serbia"},{"code":"SC","name":"Seychelles"},{"code":"SL","name":"Sierra Leone"},{"code":"SG","name":"Singapore"},{"code":"SX","name":"Sint Maarten, Dutch part"},{"code":"SK","name":"Slovakia"},{"code":"SI","name":"Slovenia"},{"code":"SB","name":"Solomon Islands"},{"code":"SO","name":"Somalia"},{"code":"ZA","name":"South Africa"},{"code":"GS","name":"South Georgia and the South Sandwich Islands"},{"code":"SS","name":"South Sudan"},{"code":"ES","name":"Spain"},{"code":"LK","name":"Sri Lanka"},{"code":"SD","name":"Sudan"},{"code":"SR","name":"Suriname"},{"code":"SJ","name":"Svalbard and Jan Mayen"},{"code":"SE","name":"Sweden"},{"code":"CH","name":"Switzerland"},{"code":"SY","name":"Syrian Arab Republic"},{"code":"TW","name":"Taiwan"},{"code":"TJ","name":"Tajikistan"},{"code":"TZ","name":"Tanzania, United Republic of"},{"code":"TH","name":"Thailand"},{"code":"TL","name":"Timor-Leste"},{"code":"TG","name":"Togo"},{"code":"TK","name":"Tokelau"},{"code":"TO","name":"Tonga"},{"code":"TT","name":"Trinidad and Tobago"},{"code":"TN","name":"Tunisia"},{"code":"TR","name":"Turkey"},{"code":"TM","name":"Turkmenistan"},{"code":"TC","name":"Turks and Caicos Islands"},{"code":"TV","name":"Tuvalu"},{"code":"UG","name":"Uganda"},{"code":"UA","name":"Ukraine"},{"code":"AE","name":"United Arab Emirates"},{"code":"GB","name":"United Kingdom"},{"code":"US","name":"United States"},{"code":"UM","name":"United States Minor Outlying Islands"},{"code":"UY","name":"Uruguay"},{"code":"UZ","name":"Uzbekistan"},{"code":"VU","name":"Vanuatu"},{"code":"VE","name":"Venezuela, Bolivarian Republic of"},{"code":"VN","name":"Vietnam"},{"code":"VG","name":"Virgin Islands, British"},{"code":"VI","name":"Virgin Islands, U.S."},{"code":"WF","name":"Wallis and Futuna"},{"code":"EH","name":"Western Sahara"},{"code":"YE","name":"Yemen"},{"code":"ZM","name":"Zambia"},{"code":"ZW","name":"Zimbabwe"}]

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "3896587bab0a5221e5f42a07898f092a.png";

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, setImmediate) {var require;var require;(function(f){if(true){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}(g.braintree || (g.braintree = {})).hostedFields = f()}})(function(){var define,module,exports;return (function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return require(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(_dereq_,module,exports){
(function (global){
'use strict';

module.exports = function isAndroid(ua) {
  ua = ua || global.navigator.userAgent;
  return /Android/.test(ua);
};

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],2:[function(_dereq_,module,exports){
'use strict';

var isEdge = _dereq_('./is-edge');
var isSamsung = _dereq_('./is-samsung');

module.exports = function isChrome(ua) {
  ua = ua || navigator.userAgent;
  return (ua.indexOf('Chrome') !== -1 || ua.indexOf('CriOS') !== -1) && !isEdge(ua) && !isSamsung(ua);
};

},{"./is-edge":3,"./is-samsung":9}],3:[function(_dereq_,module,exports){
'use strict';

module.exports = function isEdge(ua) {
  ua = ua || navigator.userAgent;
  return ua.indexOf('Edge/') !== -1;
};

},{}],4:[function(_dereq_,module,exports){
(function (global){
'use strict';

var isIE11 = _dereq_('./is-ie11');

module.exports = function isIE(ua) {
  ua = ua || global.navigator.userAgent;
  return ua.indexOf('MSIE') !== -1 || isIE11(ua);
};

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"./is-ie11":5}],5:[function(_dereq_,module,exports){
'use strict';

module.exports = function isIe11(ua) {
  ua = ua || navigator.userAgent;
  return ua.indexOf('Trident/7') !== -1;
};

},{}],6:[function(_dereq_,module,exports){
'use strict';

module.exports = function isIe9(ua) {
  ua = ua || navigator.userAgent;
  return ua.indexOf('MSIE 9') !== -1;
};

},{}],7:[function(_dereq_,module,exports){
(function (global){
'use strict';

var isIos = _dereq_('./is-ios');

// The Google Search iOS app is technically a webview and doesn't support popups.
function isGoogleSearchApp(ua) {
  return /\bGSA\b/.test(ua);
}

module.exports = function isIosWebview(ua) {
  ua = ua || global.navigator.userAgent;
  if (isIos(ua)) {
    if (isGoogleSearchApp(ua)) {
      return true;
    }
    return /.+AppleWebKit(?!.*Safari)/.test(ua);
  }
  return false;
};

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"./is-ios":8}],8:[function(_dereq_,module,exports){
(function (global){
'use strict';

module.exports = function isIos(ua) {
  ua = ua || global.navigator.userAgent;
  return /iPhone|iPod|iPad/i.test(ua);
};

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],9:[function(_dereq_,module,exports){
(function (global){
'use strict';

module.exports = function isSamsungBrowser(ua) {
  ua = ua || global.navigator.userAgent;
  return /SamsungBrowser/i.test(ua);
};

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],10:[function(_dereq_,module,exports){
'use strict';

var setAttributes = _dereq_('./lib/set-attributes');
var defaultAttributes = _dereq_('./lib/default-attributes');
var assign = _dereq_('./lib/assign');

module.exports = function createFrame(options) {
  var iframe = document.createElement('iframe');
  var config = assign({}, defaultAttributes, options);

  if (config.style && typeof config.style !== 'string') {
    assign(iframe.style, config.style);
    delete config.style;
  }

  setAttributes(iframe, config);

  if (!iframe.getAttribute('id')) {
    iframe.id = iframe.name;
  }

  return iframe;
};

},{"./lib/assign":11,"./lib/default-attributes":12,"./lib/set-attributes":13}],11:[function(_dereq_,module,exports){
'use strict';

module.exports = function assign(target) {
  var objs = Array.prototype.slice.call(arguments, 1);

  objs.forEach(function (obj) {
    if (typeof obj !== 'object') { return; }

    Object.keys(obj).forEach(function (key) {
      target[key] = obj[key];
    });
  });

  return target;
}

},{}],12:[function(_dereq_,module,exports){
'use strict';

module.exports = {
  src: 'about:blank',
  frameBorder: 0,
  allowtransparency: true,
  scrolling: 'no'
};

},{}],13:[function(_dereq_,module,exports){
'use strict';

module.exports = function setAttributes(element, attributes) {
  var value;

  for (var key in attributes) {
    if (attributes.hasOwnProperty(key)) {
      value = attributes[key];

      if (value == null) {
        element.removeAttribute(key);
      } else {
        element.setAttribute(key, value);
      }
    }
  }
};

},{}],14:[function(_dereq_,module,exports){
'use strict';

function deferred(fn) {
  return function () {
    // IE9 doesn't support passing arguments to setTimeout so we have to emulate it.
    var args = arguments;

    setTimeout(function () {
      fn.apply(null, args);
    }, 1);
  };
}

module.exports = deferred;

},{}],15:[function(_dereq_,module,exports){
'use strict';

function once(fn) {
  var called = false;

  return function () {
    if (!called) {
      called = true;
      fn.apply(null, arguments);
    }
  };
}

module.exports = once;

},{}],16:[function(_dereq_,module,exports){
'use strict';

function promiseOrCallback(promise, callback) { // eslint-disable-line consistent-return
  if (callback) {
    promise
      .then(function (data) {
        callback(null, data);
      })
      .catch(function (err) {
        callback(err);
      });
  } else {
    return promise;
  }
}

module.exports = promiseOrCallback;

},{}],17:[function(_dereq_,module,exports){
'use strict';

var deferred = _dereq_('./lib/deferred');
var once = _dereq_('./lib/once');
var promiseOrCallback = _dereq_('./lib/promise-or-callback');

function wrapPromise(fn) {
  return function () {
    var callback;
    var args = Array.prototype.slice.call(arguments);
    var lastArg = args[args.length - 1];

    if (typeof lastArg === 'function') {
      callback = args.pop();
      callback = once(deferred(callback));
    }
    return promiseOrCallback(fn.apply(this, args), callback); // eslint-disable-line no-invalid-this
  };
}

wrapPromise.wrapPrototype = function (target, options) {
  var methods, ignoreMethods, includePrivateMethods;

  options = options || {};
  ignoreMethods = options.ignoreMethods || [];
  includePrivateMethods = options.transformPrivateMethods === true;

  methods = Object.getOwnPropertyNames(target.prototype).filter(function (method) {
    var isNotPrivateMethod;
    var isNonConstructorFunction = method !== 'constructor' &&
      typeof target.prototype[method] === 'function';
    var isNotAnIgnoredMethod = ignoreMethods.indexOf(method) === -1;

    if (includePrivateMethods) {
      isNotPrivateMethod = true;
    } else {
      isNotPrivateMethod = method.charAt(0) !== '_';
    }

    return isNonConstructorFunction &&
      isNotPrivateMethod &&
      isNotAnIgnoredMethod;
  });

  methods.forEach(function (method) {
    var original = target.prototype[method];

    target.prototype[method] = wrapPromise(original);
  });

  return target;
};

module.exports = wrapPromise;

},{"./lib/deferred":14,"./lib/once":15,"./lib/promise-or-callback":16}],18:[function(_dereq_,module,exports){
'use strict';

var testOrder;
var types = {};
var customCards = {};
var VISA = 'visa';
var MASTERCARD = 'mastercard';
var AMERICAN_EXPRESS = 'american-express';
var DINERS_CLUB = 'diners-club';
var DISCOVER = 'discover';
var ELO = 'elo';
var JCB = 'jcb';
var UNIONPAY = 'unionpay';
var MAESTRO = 'maestro';
var MIR = 'mir';
var CVV = 'CVV';
var CID = 'CID';
var CVC = 'CVC';
var CVN = 'CVN';
var CVP2 = 'CVP2';
var CVE = 'CVE';
var ORIGINAL_TEST_ORDER = [
  VISA,
  MASTERCARD,
  AMERICAN_EXPRESS,
  DINERS_CLUB,
  DISCOVER,
  JCB,
  UNIONPAY,
  MAESTRO,
  ELO,
  MIR
];

function clone(originalObject) {
  var dupe;

  if (!originalObject) { return null; }

  dupe = JSON.parse(JSON.stringify(originalObject));

  return dupe;
}

testOrder = clone(ORIGINAL_TEST_ORDER);

types[VISA] = {
  niceType: 'Visa',
  type: VISA,
  patterns: [
    4
  ],
  gaps: [4, 8, 12],
  lengths: [16, 18, 19],
  code: {
    name: CVV,
    size: 3
  }
};

types[MASTERCARD] = {
  niceType: 'Mastercard',
  type: MASTERCARD,
  patterns: [
    [51, 55],
    [2221, 2229],
    [223, 229],
    [23, 26],
    [270, 271],
    2720
  ],
  gaps: [4, 8, 12],
  lengths: [16],
  code: {
    name: CVC,
    size: 3
  }
};

types[AMERICAN_EXPRESS] = {
  niceType: 'American Express',
  type: AMERICAN_EXPRESS,
  patterns: [
    34,
    37
  ],
  gaps: [4, 10],
  lengths: [15],
  code: {
    name: CID,
    size: 4
  }
};

types[DINERS_CLUB] = {
  niceType: 'Diners Club',
  type: DINERS_CLUB,
  patterns: [
    [300, 305],
    36,
    38,
    39
  ],
  gaps: [4, 10],
  lengths: [14, 16, 19],
  code: {
    name: CVV,
    size: 3
  }
};

types[DISCOVER] = {
  niceType: 'Discover',
  type: DISCOVER,
  patterns: [
    6011,
    [644, 649],
    65
  ],
  gaps: [4, 8, 12],
  lengths: [16, 19],
  code: {
    name: CID,
    size: 3
  }
};

types[JCB] = {
  niceType: 'JCB',
  type: JCB,
  patterns: [
    2131,
    1800,
    [3528, 3589]
  ],
  gaps: [4, 8, 12],
  lengths: [16, 17, 18, 19],
  code: {
    name: CVV,
    size: 3
  }
};

types[UNIONPAY] = {
  niceType: 'UnionPay',
  type: UNIONPAY,
  patterns: [
    620,
    [624, 626],
    [62100, 62182],
    [62184, 62187],
    [62185, 62197],
    [62200, 62205],
    [622010, 622999],
    622018,
    [622019, 622999],
    [62207, 62209],
    [622126, 622925],
    [623, 626],
    6270,
    6272,
    6276,
    [627700, 627779],
    [627781, 627799],
    [6282, 6289],
    6291,
    6292
  ],
  gaps: [4, 8, 12],
  lengths: [16, 17, 18, 19],
  code: {
    name: CVN,
    size: 3
  }
};

types[MAESTRO] = {
  niceType: 'Maestro',
  type: MAESTRO,
  patterns: [
    493698,
    [500000, 506698],
    [506779, 508999],
    [56, 59],
    63,
    67,
    6
  ],
  gaps: [4, 8, 12],
  lengths: [12, 13, 14, 15, 16, 17, 18, 19],
  code: {
    name: CVC,
    size: 3
  }
};

types[ELO] = {
  niceType: 'Elo',
  type: ELO,
  patterns: [
    401178,
    401179,
    438935,
    457631,
    457632,
    431274,
    451416,
    457393,
    504175,
    [506699, 506778],
    [509000, 509999],
    627780,
    636297,
    636368,
    [650031, 650033],
    [650035, 650051],
    [650405, 650439],
    [650485, 650538],
    [650541, 650598],
    [650700, 650718],
    [650720, 650727],
    [650901, 650978],
    [651652, 651679],
    [655000, 655019],
    [655021, 655058]
  ],
  gaps: [4, 8, 12],
  lengths: [16],
  code: {
    name: CVE,
    size: 3
  }
};

types[MIR] = {
  niceType: 'Mir',
  type: MIR,
  patterns: [
    [2200, 2204]
  ],
  gaps: [4, 8, 12],
  lengths: [16, 17, 18, 19],
  code: {
    name: CVP2,
    size: 3
  }
};

function findType(type) {
  return customCards[type] || types[type];
}

function isValidInputType(cardNumber) {
  return typeof cardNumber === 'string' || cardNumber instanceof String;
}

function hasEnoughResultsToDetermineBestMatch(results) {
  var numberOfResultsWithMaxStrengthProperty = results.filter(function (result) {
    return result.matchStrength;
  }).length;

  // if all possible results have a maxStrength property
  // that means the card number is sufficiently long
  // enough to determine conclusively what the type is
  return numberOfResultsWithMaxStrengthProperty > 0 &&
    numberOfResultsWithMaxStrengthProperty === results.length;
}

function findBestMatch(results) {
  if (!hasEnoughResultsToDetermineBestMatch(results)) {
    return;
  }

  return results.reduce(function (bestMatch, result) { // eslint-disable-line consistent-return
    if (!bestMatch) {
      return result;
    }

    // if the current best match pattern is less specific
    // than this result, set the result as the new best match
    if (bestMatch.matchStrength < result.matchStrength) {
      return result;
    }

    return bestMatch;
  });
}

function getAllCardTypes() {
  return testOrder.map(function (type) {
    return clone(findType(type));
  });
}

function creditCardType(cardNumber) {
  var bestMatch;
  var results = [];

  if (!isValidInputType(cardNumber)) {
    return [];
  }

  if (cardNumber.length === 0) {
    return getAllCardTypes();
  }

  testOrder.forEach(function (type) {
    var cardConfiguration = findType(type);

    loopOverCardPatterns(cardNumber, cardConfiguration, results);
  });

  bestMatch = findBestMatch(results);

  if (bestMatch) {
    return [bestMatch];
  }

  return results;
}

function loopOverCardPatterns(cardNumber, cardConfiguration, results) {
  var i, pattern, patternLength, clonedCardConfiguration;

  for (i = 0; i < cardConfiguration.patterns.length; i++) {
    pattern = cardConfiguration.patterns[i];

    if (!matches(cardNumber, pattern)) {
      continue;
    }

    clonedCardConfiguration = clone(cardConfiguration);

    if (Array.isArray(pattern)) {
      patternLength = String(pattern[0]).length;
    } else {
      patternLength = String(pattern).length;
    }

    if (cardNumber.length >= patternLength) {
      clonedCardConfiguration.matchStrength = patternLength;
    }

    results.push(clonedCardConfiguration);
    break;
  }
}

function matches(cardNumber, pattern) {
  if (Array.isArray(pattern)) {
    return matchesRange(cardNumber, pattern[0], pattern[1]);
  }

  return matchesPattern(cardNumber, pattern);
}

function matchesPattern(cardNumber, pattern) {
  pattern = String(pattern);

  return pattern.substring(0, cardNumber.length) === cardNumber.substring(0, pattern.length);
}

// Adapted from https://github.com/polvo-labs/card-type/blob/aaab11f80fa1939bccc8f24905a06ae3cd864356/src/cardType.js#L37-L42
function matchesRange(cardNumber, min, max) {
  var maxLengthToCheck = String(min).length;
  var substr = cardNumber.substr(0, maxLengthToCheck);
  var integerRepresentationOfCardNumber = parseInt(substr, 10);

  min = parseInt(String(min).substr(0, substr.length), 10);
  max = parseInt(String(max).substr(0, substr.length), 10);

  return integerRepresentationOfCardNumber >= min && integerRepresentationOfCardNumber <= max;
}

creditCardType.getTypeInfo = function (type) {
  return clone(findType(type));
};

function getCardPosition(name, ignoreErrorForNotExisting) {
  var position = testOrder.indexOf(name);

  if (!ignoreErrorForNotExisting && position === -1) {
    throw new Error('"' + name + '" is not a supported card type.');
  }

  return position;
}

creditCardType.removeCard = function (name) {
  var position = getCardPosition(name);

  testOrder.splice(position, 1);
};

creditCardType.addCard = function (config) {
  var existingCardPosition = getCardPosition(config.type, true);

  customCards[config.type] = config;

  if (existingCardPosition === -1) {
    testOrder.push(config.type);
  }
};

creditCardType.updateCard = function (cardType, updates) {
  var clonedCard;
  var originalObject = customCards[cardType] || types[cardType];

  if (!originalObject) {
    throw new Error('"' + cardType + '" is not a recognized type. Use `addCard` instead.');
  }

  if (updates.type && originalObject.type !== updates.type) {
    throw new Error('Cannot overwrite type parameter.');
  }

  clonedCard = clone(originalObject, true);

  Object.keys(clonedCard).forEach(function (key) {
    if (updates[key]) {
      clonedCard[key] = updates[key];
    }
  });

  customCards[clonedCard.type] = clonedCard;
};

creditCardType.changeOrder = function (name, position) {
  var currentPosition = getCardPosition(name);

  testOrder.splice(currentPosition, 1);
  testOrder.splice(position, 0, name);
};

creditCardType.resetModifications = function () {
  testOrder = clone(ORIGINAL_TEST_ORDER);
  customCards = {};
};

creditCardType.types = {
  VISA: VISA,
  MASTERCARD: MASTERCARD,
  AMERICAN_EXPRESS: AMERICAN_EXPRESS,
  DINERS_CLUB: DINERS_CLUB,
  DISCOVER: DISCOVER,
  JCB: JCB,
  UNIONPAY: UNIONPAY,
  MAESTRO: MAESTRO,
  ELO: ELO,
  MIR: MIR
};

module.exports = creditCardType;

},{}],19:[function(_dereq_,module,exports){
(function (global){
'use strict';

var win, framebus;
var popups = [];
var subscribers = {};
var prefix = '/*framebus*/';

function include(popup) {
  if (popup == null) { return false; }
  if (popup.Window == null) { return false; }
  if (popup.constructor !== popup.Window) { return false; }

  popups.push(popup);
  return true;
}

function target(origin) {
  var key;
  var targetedFramebus = {};

  for (key in framebus) {
    if (!framebus.hasOwnProperty(key)) { continue; }

    targetedFramebus[key] = framebus[key];
  }

  targetedFramebus._origin = origin || '*';

  return targetedFramebus;
}

function publish(event) {
  var payload, args;
  var origin = _getOrigin(this); // eslint-disable-line no-invalid-this

  if (_isntString(event)) { return false; }
  if (_isntString(origin)) { return false; }

  args = Array.prototype.slice.call(arguments, 1);

  payload = _packagePayload(event, args, origin);
  if (payload === false) { return false; }

  _broadcast(win.top || win.self, payload, origin);

  return true;
}

function subscribe(event, fn) {
  var origin = _getOrigin(this); // eslint-disable-line no-invalid-this

  if (_subscriptionArgsInvalid(event, fn, origin)) { return false; }

  subscribers[origin] = subscribers[origin] || {};
  subscribers[origin][event] = subscribers[origin][event] || [];
  subscribers[origin][event].push(fn);

  return true;
}

function unsubscribe(event, fn) {
  var i, subscriberList;
  var origin = _getOrigin(this); // eslint-disable-line no-invalid-this

  if (_subscriptionArgsInvalid(event, fn, origin)) { return false; }

  subscriberList = subscribers[origin] && subscribers[origin][event];
  if (!subscriberList) { return false; }

  for (i = 0; i < subscriberList.length; i++) {
    if (subscriberList[i] === fn) {
      subscriberList.splice(i, 1);
      return true;
    }
  }

  return false;
}

function _getOrigin(scope) {
  return scope && scope._origin || '*';
}

function _isntString(string) {
  return typeof string !== 'string';
}

function _packagePayload(event, args, origin) {
  var packaged = false;
  var payload = {
    event: event,
    origin: origin
  };
  var reply = args[args.length - 1];

  if (typeof reply === 'function') {
    payload.reply = _subscribeReplier(reply, origin);
    args = args.slice(0, -1);
  }

  payload.args = args;

  try {
    packaged = prefix + JSON.stringify(payload);
  } catch (e) {
    throw new Error('Could not stringify event: ' + e.message);
  }
  return packaged;
}

function _unpackPayload(e) {
  var payload, replyOrigin, replySource, replyEvent;

  if (e.data.slice(0, prefix.length) !== prefix) { return false; }

  try {
    payload = JSON.parse(e.data.slice(prefix.length));
  } catch (err) {
    return false;
  }

  if (payload.reply != null) {
    replyOrigin = e.origin;
    replySource = e.source;
    replyEvent = payload.reply;

    payload.reply = function reply(data) { // eslint-disable-line consistent-return
      var replyPayload = _packagePayload(replyEvent, [data], replyOrigin);

      if (replyPayload === false) { return false; }

      replySource.postMessage(replyPayload, replyOrigin);
    };

    payload.args.push(payload.reply);
  }

  return payload;
}

function _attach(w) {
  if (win) { return; }
  win = w || global;

  if (win.addEventListener) {
    win.addEventListener('message', _onmessage, false);
  } else if (win.attachEvent) {
    win.attachEvent('onmessage', _onmessage);
  } else if (win.onmessage === null) {
    win.onmessage = _onmessage;
  } else {
    win = null;
  }
}

// removeIf(production)
function _detach() {
  if (win == null) { return; }

  if (win.removeEventListener) {
    win.removeEventListener('message', _onmessage, false);
  } else if (win.detachEvent) {
    win.detachEvent('onmessage', _onmessage);
  } else if (win.onmessage === _onmessage) {
    win.onmessage = null;
  }

  win = null;
  popups = [];
  subscribers = {};
}
// endRemoveIf(production)

function _uuid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0;
    var v = c === 'x' ? r : r & 0x3 | 0x8;

    return v.toString(16);
  });
}

function _onmessage(e) {
  var payload;

  if (_isntString(e.data)) { return; }

  payload = _unpackPayload(e);
  if (!payload) { return; }

  _dispatch('*', payload.event, payload.args, e);
  _dispatch(e.origin, payload.event, payload.args, e);
  _broadcastPopups(e.data, payload.origin, e.source);
}

function _dispatch(origin, event, args, e) {
  var i;

  if (!subscribers[origin]) { return; }
  if (!subscribers[origin][event]) { return; }

  for (i = 0; i < subscribers[origin][event].length; i++) {
    subscribers[origin][event][i].apply(e, args);
  }
}

function _hasOpener(frame) {
  if (frame.top !== frame) { return false; }
  if (frame.opener == null) { return false; }
  if (frame.opener === frame) { return false; }
  if (frame.opener.closed === true) { return false; }

  return true;
}

function _broadcast(frame, payload, origin) {
  var i = 0;
  var frameToBroadcastTo;

  try {
    frame.postMessage(payload, origin);

    if (_hasOpener(frame)) {
      _broadcast(frame.opener.top, payload, origin);
    }

    // previously, our max value was frame.frames.length
    // but frames.length inherits from window.length
    // which can be overwritten if a developer does
    // `var length = value;` outside of a function
    // scope, it'll prevent us from looping through
    // all the frames. With this, we loop through
    // until there are no longer any frames
    while (frameToBroadcastTo = frame.frames[i]) { // eslint-disable-line no-cond-assign
      _broadcast(frameToBroadcastTo, payload, origin);
      i++;
    }
  } catch (_) { /* ignored */ }
}

function _broadcastPopups(payload, origin, source) {
  var i, popup;

  for (i = popups.length - 1; i >= 0; i--) {
    popup = popups[i];

    if (popup.closed === true) {
      popups = popups.slice(i, 1);
    } else if (source !== popup) {
      _broadcast(popup.top, payload, origin);
    }
  }
}

function _subscribeReplier(fn, origin) {
  var uuid = _uuid();

  function replier(d, o) {
    fn(d, o);
    framebus.target(origin).unsubscribe(uuid, replier);
  }

  framebus.target(origin).subscribe(uuid, replier);
  return uuid;
}

function _subscriptionArgsInvalid(event, fn, origin) {
  if (_isntString(event)) { return true; }
  if (typeof fn !== 'function') { return true; }
  if (_isntString(origin)) { return true; }

  return false;
}

_attach();

framebus = {
  target: target,
  // removeIf(production)
  _packagePayload: _packagePayload,
  _unpackPayload: _unpackPayload,
  _attach: _attach,
  _detach: _detach,
  _dispatch: _dispatch,
  _broadcast: _broadcast,
  _subscribeReplier: _subscribeReplier,
  _subscriptionArgsInvalid: _subscriptionArgsInvalid,
  _onmessage: _onmessage,
  _uuid: _uuid,
  _getSubscribers: function () { return subscribers; },
  _win: function () { return win; },
  // endRemoveIf(production)
  include: include,
  publish: publish,
  pub: publish,
  trigger: publish,
  emit: publish,
  subscribe: subscribe,
  sub: subscribe,
  on: subscribe,
  unsubscribe: unsubscribe,
  unsub: unsubscribe,
  off: unsubscribe
};

module.exports = framebus;

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],20:[function(_dereq_,module,exports){
'use strict';

var promiseFinally = function(callback) {
  var constructor = this.constructor;
  return this.then(
    function(value) {
      return constructor.resolve(callback()).then(function() {
        return value;
      });
    },
    function(reason) {
      return constructor.resolve(callback()).then(function() {
        return constructor.reject(reason);
      });
    }
  );
};

// Store setTimeout reference so promise-polyfill will be unaffected by
// other code modifying setTimeout (like sinon.useFakeTimers())
var setTimeoutFunc = setTimeout;

function noop() {}

// Polyfill for Function.prototype.bind
function bind(fn, thisArg) {
  return function() {
    fn.apply(thisArg, arguments);
  };
}

function Promise(fn) {
  if (!(this instanceof Promise))
    throw new TypeError('Promises must be constructed via new');
  if (typeof fn !== 'function') throw new TypeError('not a function');
  this._state = 0;
  this._handled = false;
  this._value = undefined;
  this._deferreds = [];

  doResolve(fn, this);
}

function handle(self, deferred) {
  while (self._state === 3) {
    self = self._value;
  }
  if (self._state === 0) {
    self._deferreds.push(deferred);
    return;
  }
  self._handled = true;
  Promise._immediateFn(function() {
    var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      (self._state === 1 ? resolve : reject)(deferred.promise, self._value);
      return;
    }
    var ret;
    try {
      ret = cb(self._value);
    } catch (e) {
      reject(deferred.promise, e);
      return;
    }
    resolve(deferred.promise, ret);
  });
}

function resolve(self, newValue) {
  try {
    // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
    if (newValue === self)
      throw new TypeError('A promise cannot be resolved with itself.');
    if (
      newValue &&
      (typeof newValue === 'object' || typeof newValue === 'function')
    ) {
      var then = newValue.then;
      if (newValue instanceof Promise) {
        self._state = 3;
        self._value = newValue;
        finale(self);
        return;
      } else if (typeof then === 'function') {
        doResolve(bind(then, newValue), self);
        return;
      }
    }
    self._state = 1;
    self._value = newValue;
    finale(self);
  } catch (e) {
    reject(self, e);
  }
}

function reject(self, newValue) {
  self._state = 2;
  self._value = newValue;
  finale(self);
}

function finale(self) {
  if (self._state === 2 && self._deferreds.length === 0) {
    Promise._immediateFn(function() {
      if (!self._handled) {
        Promise._unhandledRejectionFn(self._value);
      }
    });
  }

  for (var i = 0, len = self._deferreds.length; i < len; i++) {
    handle(self, self._deferreds[i]);
  }
  self._deferreds = null;
}

function Handler(onFulfilled, onRejected, promise) {
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, self) {
  var done = false;
  try {
    fn(
      function(value) {
        if (done) return;
        done = true;
        resolve(self, value);
      },
      function(reason) {
        if (done) return;
        done = true;
        reject(self, reason);
      }
    );
  } catch (ex) {
    if (done) return;
    done = true;
    reject(self, ex);
  }
}

Promise.prototype['catch'] = function(onRejected) {
  return this.then(null, onRejected);
};

Promise.prototype.then = function(onFulfilled, onRejected) {
  var prom = new this.constructor(noop);

  handle(this, new Handler(onFulfilled, onRejected, prom));
  return prom;
};

Promise.prototype['finally'] = promiseFinally;

Promise.all = function(arr) {
  return new Promise(function(resolve, reject) {
    if (!arr || typeof arr.length === 'undefined')
      throw new TypeError('Promise.all accepts an array');
    var args = Array.prototype.slice.call(arr);
    if (args.length === 0) return resolve([]);
    var remaining = args.length;

    function res(i, val) {
      try {
        if (val && (typeof val === 'object' || typeof val === 'function')) {
          var then = val.then;
          if (typeof then === 'function') {
            then.call(
              val,
              function(val) {
                res(i, val);
              },
              reject
            );
            return;
          }
        }
        args[i] = val;
        if (--remaining === 0) {
          resolve(args);
        }
      } catch (ex) {
        reject(ex);
      }
    }

    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.resolve = function(value) {
  if (value && typeof value === 'object' && value.constructor === Promise) {
    return value;
  }

  return new Promise(function(resolve) {
    resolve(value);
  });
};

Promise.reject = function(value) {
  return new Promise(function(resolve, reject) {
    reject(value);
  });
};

Promise.race = function(values) {
  return new Promise(function(resolve, reject) {
    for (var i = 0, len = values.length; i < len; i++) {
      values[i].then(resolve, reject);
    }
  });
};

// Use polyfill for setImmediate for performance gains
Promise._immediateFn =
  (typeof setImmediate === 'function' &&
    function(fn) {
      setImmediate(fn);
    }) ||
  function(fn) {
    setTimeoutFunc(fn, 0);
  };

Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
  if (typeof console !== 'undefined' && console) {
    console.warn('Possible Unhandled Promise Rejection:', err); // eslint-disable-line no-console
  }
};

module.exports = Promise;

},{}],21:[function(_dereq_,module,exports){
(function (global){
'use strict';

var UA = global.navigator && global.navigator.userAgent;

var isAndroid = _dereq_('@braintree/browser-detection/is-android');
var isChrome = _dereq_('@braintree/browser-detection/is-chrome');
var isIos = _dereq_('@braintree/browser-detection/is-ios');
var isIE9 = _dereq_('@braintree/browser-detection/is-ie9');

// Old Android Webviews used specific versions of Chrome with 0.0.0 as their version suffix
// https://developer.chrome.com/multidevice/user-agent#webview_user_agent
var KITKAT_WEBVIEW_REGEX = /Version\/\d\.\d* Chrome\/\d*\.0\.0\.0/;

function _isOldSamsungBrowserOrSamsungWebview(ua) {
  return !isChrome(ua) && ua.indexOf('Samsung') > -1;
}

function isKitKatWebview(uaArg) {
  var ua = uaArg || UA;

  return isAndroid(ua) && KITKAT_WEBVIEW_REGEX.test(ua);
}

function isAndroidChrome(uaArg) {
  var ua = uaArg || UA;

  return isAndroid(ua) && isChrome(ua);
}

function isSamsungBrowser(ua) {
  ua = ua || UA;
  return /SamsungBrowser/.test(ua) || _isOldSamsungBrowserOrSamsungWebview(ua);
}

module.exports = {
  isIE9: isIE9,
  isAndroidChrome: isAndroidChrome,
  isIos: isIos,
  isKitKatWebview: isKitKatWebview,
  isSamsungBrowser: isSamsungBrowser
};

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"@braintree/browser-detection/is-android":1,"@braintree/browser-detection/is-chrome":2,"@braintree/browser-detection/is-ie9":6,"@braintree/browser-detection/is-ios":8}],22:[function(_dereq_,module,exports){
'use strict';

var device = _dereq_('./lib/device');

module.exports = function () {
  // Digits get dropped in samsung browser
  return !device.isSamsungBrowser();
};

},{"./lib/device":21}],23:[function(_dereq_,module,exports){
'use strict';

var BraintreeError = _dereq_('../../lib/braintree-error');
var errors = _dereq_('../shared/errors');
var allowedAttributes = _dereq_('../shared/constants').allowedAttributes;

function attributeValidationError(attribute, value) {
  var err;

  if (!allowedAttributes.hasOwnProperty(attribute)) {
    err = new BraintreeError({
      type: errors.HOSTED_FIELDS_ATTRIBUTE_NOT_SUPPORTED.type,
      code: errors.HOSTED_FIELDS_ATTRIBUTE_NOT_SUPPORTED.code,
      message: 'The "' + attribute + '" attribute is not supported in Hosted Fields.'
    });
  } else if (value != null && !_isValid(attribute, value)) {
    err = new BraintreeError({
      type: errors.HOSTED_FIELDS_ATTRIBUTE_VALUE_NOT_ALLOWED.type,
      code: errors.HOSTED_FIELDS_ATTRIBUTE_VALUE_NOT_ALLOWED.code,
      message: 'Value "' + value + '" is not allowed for "' + attribute + '" attribute.'
    });
  }

  return err;
}

function _isValid(attribute, value) {
  if (allowedAttributes[attribute] === 'string') {
    return typeof value === 'string' || typeof value === 'number';
  } else if (allowedAttributes[attribute] === 'boolean') {
    return String(value) === 'true' || String(value) === 'false';
  }

  return false;
}

module.exports = attributeValidationError;

},{"../../lib/braintree-error":40,"../shared/constants":30,"../shared/errors":31}],24:[function(_dereq_,module,exports){
'use strict';

var constants = _dereq_('../shared/constants');
var useMin = _dereq_('../../lib/use-min');

module.exports = function composeUrl(assetsUrl, componentId, isDebug) {
  return assetsUrl +
    '/web/' +
    constants.VERSION +
    '/html/hosted-fields-frame' + useMin(isDebug) + '.html#' +
    componentId;
};

},{"../../lib/use-min":57,"../shared/constants":30}],25:[function(_dereq_,module,exports){
(function (global){
'use strict';

var allowedStyles = _dereq_('../shared/constants').allowedStyles;

module.exports = function getStylesFromClass(cssClass) {
  var element = document.createElement('input');
  var styles = {};
  var computedStyles;

  if (cssClass[0] === '.') {
    cssClass = cssClass.substring(1);
  }

  element.className = cssClass;
  element.style.display = 'none !important';
  element.style.position = 'fixed !important';
  element.style.left = '-99999px !important';
  element.style.top = '-99999px !important';
  global.document.body.appendChild(element);

  computedStyles = global.getComputedStyle(element);

  allowedStyles.forEach(function (style) {
    var value = computedStyles[style];

    if (value) {
      styles[style] = value;
    }
  });

  global.document.body.removeChild(element);

  return styles;
};

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"../shared/constants":30}],26:[function(_dereq_,module,exports){
(function (global){
'use strict';

var assign = _dereq_('../../lib/assign').assign;
var createAuthorizationData = _dereq_('../../lib/create-authorization-data');
var Destructor = _dereq_('../../lib/destructor');
var classlist = _dereq_('../../lib/classlist');
var iFramer = _dereq_('@braintree/iframer');
var Bus = _dereq_('../../lib/bus');
var assets = _dereq_('../../lib/assets');
var BraintreeError = _dereq_('../../lib/braintree-error');
var composeUrl = _dereq_('./compose-url');
var getStylesFromClass = _dereq_('./get-styles-from-class');
var constants = _dereq_('../shared/constants');
var errors = _dereq_('../shared/errors');
var VERSION = _dereq_('../../lib/constants').VERSION;
var INTEGRATION_TIMEOUT_MS = _dereq_('../../lib/constants').INTEGRATION_TIMEOUT_MS;
var ASSETS_URLS = _dereq_('../../lib/constants').ASSETS_URLS;
var uuid = _dereq_('../../lib/vendor/uuid');
var findParentTags = _dereq_('../shared/find-parent-tags');
var browserDetection = _dereq_('../shared/browser-detection');
var events = constants.events;
var EventEmitter = _dereq_('../../lib/event-emitter');
var injectFrame = _dereq_('./inject-frame');
var analytics = _dereq_('../../lib/analytics');
var allowedFields = constants.allowedFields;
var methods = _dereq_('../../lib/methods');
var convertMethodsToError = _dereq_('../../lib/convert-methods-to-error');
var sharedErrors = _dereq_('../../lib/errors');
var getCardTypes = _dereq_('../shared/get-card-types');
var attributeValidationError = _dereq_('./attribute-validation-error');
var Promise = _dereq_('../../lib/promise');
var wrapPromise = _dereq_('@braintree/wrap-promise');

/**
 * @typedef {object} HostedFields~tokenizePayload
 * @property {string} nonce The payment method nonce.
 * @property {object} details Additional account details.
 * @property {string} details.cardType Type of card, ex: Visa, MasterCard.
 * @property {string} details.lastFour Last four digits of card number.
 * @property {string} details.lastTwo Last two digits of card number.
 * @property {string} description A human-readable description.
 * @property {string} type The payment method type, always `CreditCard`.
 * @property {object} binData Information about the card based on the bin.
 * @property {string} binData.commercial Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.countryOfIssuance The country of issuance.
 * @property {string} binData.debit Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.durbinRegulated Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.healthcare Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.issuingBank The issuing bank.
 * @property {string} binData.payroll Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.prepaid Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.productId The product id.
 */

/**
 * @typedef {object} HostedFields~stateObject
 * @description The event payload sent from {@link HostedFields#on|on} or {@link HostedFields#getState|getState}.
 * @property {HostedFields~hostedFieldsCard[]} cards
 * This will return an array of potential {@link HostedFields~hostedFieldsCard|cards}. If the card type has been determined, the array will contain only one card.
 * Internally, Hosted Fields uses <a href="https://github.com/braintree/credit-card-type">credit-card-type</a>,
 * an open-source card detection library.
 * @property {string} emittedBy
 * The name of the field associated with an event. This will not be included if returned by {@link HostedFields#getState|getState}. It will be one of the following strings:<br>
 * - `"number"`
 * - `"cvv"`
 * - `"expirationDate"`
 * - `"expirationMonth"`
 * - `"expirationYear"`
 * - `"postalCode"`
 * @property {object} fields
 * @property {?HostedFields~hostedFieldsFieldData} fields.number {@link HostedFields~hostedFieldsFieldData|hostedFieldsFieldData} for the number field, if it is present.
 * @property {?HostedFields~hostedFieldsFieldData} fields.cvv {@link HostedFields~hostedFieldsFieldData|hostedFieldsFieldData} for the CVV field, if it is present.
 * @property {?HostedFields~hostedFieldsFieldData} fields.expirationDate {@link HostedFields~hostedFieldsFieldData|hostedFieldsFieldData} for the expiration date field, if it is present.
 * @property {?HostedFields~hostedFieldsFieldData} fields.expirationMonth {@link HostedFields~hostedFieldsFieldData|hostedFieldsFieldData} for the expiration month field, if it is present.
 * @property {?HostedFields~hostedFieldsFieldData} fields.expirationYear {@link HostedFields~hostedFieldsFieldData|hostedFieldsFieldData} for the expiration year field, if it is present.
 * @property {?HostedFields~hostedFieldsFieldData} fields.postalCode {@link HostedFields~hostedFieldsFieldData|hostedFieldsFieldData} for the postal code field, if it is present.
 */

/**
 * @typedef {object} HostedFields~hostedFieldsFieldData
 * @description Data about Hosted Fields fields, sent in {@link HostedFields~stateObject|stateObjects}.
 * @property {HTMLElement} container Reference to the container DOM element on your page associated with the current event.
 * @property {boolean} isFocused Whether or not the input is currently focused.
 * @property {boolean} isEmpty Whether or not the user has entered a value in the input.
 * @property {boolean} isPotentiallyValid
 * A determination based on the future validity of the input value.
 * This is helpful when a user is entering a card number and types <code>"41"</code>.
 * While that value is not valid for submission, it is still possible for
 * it to become a fully qualified entry. However, if the user enters <code>"4x"</code>
 * it is clear that the card number can never become valid and isPotentiallyValid will
 * return false.
 * @property {boolean} isValid Whether or not the value of the associated input is <i>fully</i> qualified for submission.
 */

/**
 * @typedef {object} HostedFields~hostedFieldsCard
 * @description Information about the card type, sent in {@link HostedFields~stateObject|stateObjects}.
 * @property {string} type The code-friendly representation of the card type. It will be one of the following strings:
 * - `american-express`
 * - `diners-club`
 * - `discover`
 * - `jcb`
 * - `maestro`
 * - `master-card`
 * - `unionpay`
 * - `visa`
 * @property {string} niceType The pretty-printed card type. It will be one of the following strings:
 * - `American Express`
 * - `Diners Club`
 * - `Discover`
 * - `JCB`
 * - `Maestro`
 * - `MasterCard`
 * - `UnionPay`
 * - `Visa`
 * @property {object} code
 * This object contains data relevant to the security code requirements of the card brand.
 * For example, on a Visa card there will be a <code>CVV</code> of 3 digits, whereas an
 * American Express card requires a 4-digit <code>CID</code>.
 * @property {string} code.name <code>"CVV"</code> <code>"CID"</code> <code>"CVC"</code>
 * @property {number} code.size The expected length of the security code. Typically, this is 3 or 4.
 */

/**
 * @name HostedFields#on
 * @function
 * @param {string} event The name of the event to which you are subscribing.
 * @param {function} handler A callback to handle the event.
 * @description Subscribes a handler function to a named event. `event` should be {@link HostedFields#event:blur|blur}, {@link HostedFields#event:focus|focus}, {@link HostedFields#event:empty|empty}, {@link HostedFields#event:notEmpty|notEmpty}, {@link HostedFields#event:cardTypeChange|cardTypeChange}, or {@link HostedFields#event:validityChange|validityChange}. Events will emit a {@link HostedFields~stateObject|stateObject}.
 * @example
 * <caption>Listening to a Hosted Field event, in this case 'focus'</caption>
 * hostedFields.create({ ... }, function (createErr, hostedFieldsInstance) {
 *   hostedFieldsInstance.on('focus', function (event) {
 *     console.log(event.emittedBy, 'has been focused');
 *   });
 * });
 * @returns {void}
 */

/**
 * This event is emitted when the user requests submission of an input field, such as by pressing the Enter or Return key on their keyboard, or mobile equivalent.
 * @event HostedFields#inputSubmitRequest
 * @type {HostedFields~stateObject}
 * @example
 * <caption>Clicking a submit button upon hitting Enter (or equivalent) within a Hosted Field</caption>
 * var hostedFields = require('braintree-web/hosted-fields');
 * var submitButton = document.querySelector('input[type="submit"]');
 *
 * hostedFields.create({ ... }, function (createErr, hostedFieldsInstance) {
 *   hostedFieldsInstance.on('inputSubmitRequest', function () {
 *     // User requested submission, e.g. by pressing Enter or equivalent
 *     submitButton.click();
 *   });
 * });
 */

/**
 * This event is emitted when a field transitions from having data to being empty.
 * @event HostedFields#empty
 * @type {HostedFields~stateObject}
 * @example
 * <caption>Listening to an empty event</caption>
 * hostedFields.create({ ... }, function (createErr, hostedFieldsInstance) {
 *   hostedFieldsInstance.on('empty', function (event) {
 *     console.log(event.emittedBy, 'is now empty');
 *   });
 * });
 */

/**
 * This event is emitted when a field transitions from being empty to having data.
 * @event HostedFields#notEmpty
 * @type {HostedFields~stateObject}
 * @example
 * <caption>Listening to an notEmpty event</caption>
 * hostedFields.create({ ... }, function (createErr, hostedFieldsInstance) {
 *   hostedFieldsInstance.on('notEmpty', function (event) {
 *     console.log(event.emittedBy, 'is now not empty');
 *   });
 * });
 */

/**
 * This event is emitted when a field loses focus.
 * @event HostedFields#blur
 * @type {HostedFields~stateObject}
 * @example
 * <caption>Listening to a blur event</caption>
 * hostedFields.create({ ... }, function (createErr, hostedFieldsInstance) {
 *   hostedFieldsInstance.on('blur', function (event) {
 *     console.log(event.emittedBy, 'lost focus');
 *   });
 * });
 */

/**
 * This event is emitted when a field gains focus.
 * @event HostedFields#focus
 * @type {HostedFields~stateObject}
 * @example
 * <caption>Listening to a focus event</caption>
 * hostedFields.create({ ... }, function (createErr, hostedFieldsInstance) {
 *   hostedFieldsInstance.on('focus', function (event) {
 *     console.log(event.emittedBy, 'gained focus');
 *   });
 * });
 */

/**
 * This event is emitted when activity within the number field has changed such that the possible card type has changed.
 * @event HostedFields#cardTypeChange
 * @type {HostedFields~stateObject}
 * @example
 * <caption>Listening to a cardTypeChange event</caption>
 * hostedFields.create({ ... }, function (createErr, hostedFieldsInstance) {
 *   hostedFieldsInstance.on('cardTypeChange', function (event) {
 *     if (event.cards.length === 1) {
 *       console.log(event.cards[0].type);
 *     } else {
 *       console.log('Type of card not yet known');
 *     }
 *   });
 * });
 */

/**
 * This event is emitted when the validity of a field has changed. Validity is represented in the {@link HostedFields~stateObject|stateObject} as two booleans: `isValid` and `isPotentiallyValid`.
 * @event HostedFields#validityChange
 * @type {HostedFields~stateObject}
 * @example
 * <caption>Listening to a validityChange event</caption>
 * hostedFields.create({ ... }, function (createErr, hostedFieldsInstance) {
 *   hostedFieldsInstance.on('validityChange', function (event) {
 *     var field = event.fields[event.emittedBy];
 *
 *     if (field.isValid) {
 *       console.log(event.emittedBy, 'is fully valid');
 *     } else if (field.isPotentiallyValid) {
 *       console.log(event.emittedBy, 'is potentially valid');
 *     } else {
 *       console.log(event.emittedBy, 'is not valid');
 *     }
 *   });
 * });
 */

function createInputEventHandler(fields) {
  return function (eventData) {
    var field;
    var merchantPayload = eventData.merchantPayload;
    var emittedBy = merchantPayload.emittedBy;
    var container = fields[emittedBy].containerElement;

    Object.keys(merchantPayload.fields).forEach(function (key) {
      merchantPayload.fields[key].container = fields[key].containerElement;
    });

    field = merchantPayload.fields[emittedBy];

    if (eventData.type === 'blur') {
      performBlurFixForIos(container);
    }

    classlist.toggle(container, constants.externalClasses.FOCUSED, field.isFocused);
    classlist.toggle(container, constants.externalClasses.VALID, field.isValid);
    classlist.toggle(container, constants.externalClasses.INVALID, !field.isPotentiallyValid);

    this._state = { // eslint-disable-line no-invalid-this
      cards: merchantPayload.cards,
      fields: merchantPayload.fields
    };

    this._emit(eventData.type, merchantPayload); // eslint-disable-line no-invalid-this
  };
}

// iOS Safari has a bug where inputs in iframes
// will not dismiss the keyboard when they lose
// focus. We create a hidden button input that we
// can focus on and blur to force the keyboard to
// dismiss. See #229
function performBlurFixForIos(container) {
  var hiddenInput;

  if (!browserDetection.isIos()) {
    return;
  }

  if (document.activeElement === document.body) {
    hiddenInput = container.querySelector('input');

    if (!hiddenInput) {
      hiddenInput = document.createElement('input');

      hiddenInput.type = 'button';
      hiddenInput.style.height = '0px';
      hiddenInput.style.width = '0px';
      hiddenInput.style.opacity = '0';
      hiddenInput.style.padding = '0';
      hiddenInput.style.position = 'absolute';
      hiddenInput.style.left = '-200%';
      hiddenInput.style.top = '0px';

      container.insertBefore(hiddenInput, container.firstChild);
    }

    hiddenInput.focus();
    hiddenInput.blur();
  }
}

/**
 * @class HostedFields
 * @param {object} options The Hosted Fields {@link module:braintree-web/hosted-fields.create create} options.
 * @description <strong>Do not use this constructor directly. Use {@link module:braintree-web/hosted-fields.create|braintree-web.hosted-fields.create} instead.</strong>
 * @classdesc This class represents a Hosted Fields component produced by {@link module:braintree-web/hosted-fields.create|braintree-web/hosted-fields.create}. Instances of this class have methods for interacting with the input fields within Hosted Fields' iframes.
 */
function HostedFields(options) {
  var failureTimeout, clientConfig, assetsUrl, isDebug, hostedFieldsUrl, authData;
  var self = this;
  var fields = {};
  var busOptions = assign({}, options);
  var frameReadyPromiseResolveFunctions = {};
  var frameReadyPromises = [];
  var componentId = uuid();

  if (options.client) {
    clientConfig = options.client.getConfiguration();
    assetsUrl = clientConfig.gatewayConfiguration.assetsUrl;
    isDebug = clientConfig.isDebug;
    this._clientInstanceOrPromise = options.client;
  } else {
    authData = createAuthorizationData(options.authorization);
    assetsUrl = ASSETS_URLS[authData.environment || 'production'];
    isDebug = Boolean(options.debug);

    if (!(global.braintree && global.braintree.client)) {
      this._clientInstanceOrPromise = assets.loadScript({
        src: assetsUrl + '/web/' + VERSION + '/js/client.min.js'
      });
    } else {
      this._clientInstanceOrPromise = Promise.resolve();
    }

    this._clientInstanceOrPromise = this._clientInstanceOrPromise.then(function () {
      return global.braintree.client.create({
        authorization: options.authorization,
        debug: isDebug
      });
    });
  }

  hostedFieldsUrl = composeUrl(assetsUrl, componentId, isDebug);

  if (!options.fields || Object.keys(options.fields).length === 0) {
    throw new BraintreeError({
      type: sharedErrors.INSTANTIATION_OPTION_REQUIRED.type,
      code: sharedErrors.INSTANTIATION_OPTION_REQUIRED.code,
      message: 'options.fields is required when instantiating Hosted Fields.'
    });
  }

  EventEmitter.call(this);

  this._injectedNodes = [];
  this._destructor = new Destructor();
  this._fields = fields;
  this._state = {
    fields: {},
    cards: getCardTypes('')
  };

  this._bus = new Bus({
    channel: componentId,
    merchantUrl: location.href
  });

  this._destructor.registerFunctionForTeardown(function () {
    self._bus.teardown();
  });

  analytics.sendEvent(this._clientInstanceOrPromise, 'custom.hosted-fields.initialized');

  Object.keys(options.fields).forEach(function (key) {
    var field, container, frame, frameReadyPromise;

    if (!constants.allowedFields.hasOwnProperty(key)) {
      throw new BraintreeError({
        type: errors.HOSTED_FIELDS_INVALID_FIELD_KEY.type,
        code: errors.HOSTED_FIELDS_INVALID_FIELD_KEY.code,
        message: '"' + key + '" is not a valid field.'
      });
    }

    field = options.fields[key];

    container = document.querySelector(field.selector);

    if (!container) {
      throw new BraintreeError({
        type: errors.HOSTED_FIELDS_INVALID_FIELD_SELECTOR.type,
        code: errors.HOSTED_FIELDS_INVALID_FIELD_SELECTOR.code,
        message: errors.HOSTED_FIELDS_INVALID_FIELD_SELECTOR.message,
        details: {
          fieldSelector: field.selector,
          fieldKey: key
        }
      });
    } else if (container.querySelector('iframe[name^="braintree-"]')) {
      throw new BraintreeError({
        type: errors.HOSTED_FIELDS_FIELD_DUPLICATE_IFRAME.type,
        code: errors.HOSTED_FIELDS_FIELD_DUPLICATE_IFRAME.code,
        message: errors.HOSTED_FIELDS_FIELD_DUPLICATE_IFRAME.message,
        details: {
          fieldSelector: field.selector,
          fieldKey: key
        }
      });
    }

    if (field.maxlength && typeof field.maxlength !== 'number') {
      throw new BraintreeError({
        type: errors.HOSTED_FIELDS_FIELD_PROPERTY_INVALID.type,
        code: errors.HOSTED_FIELDS_FIELD_PROPERTY_INVALID.code,
        message: 'The value for maxlength must be a number.',
        details: {
          fieldKey: key
        }
      });
    }

    if (field.minlength && typeof field.minlength !== 'number') {
      throw new BraintreeError({
        type: errors.HOSTED_FIELDS_FIELD_PROPERTY_INVALID.type,
        code: errors.HOSTED_FIELDS_FIELD_PROPERTY_INVALID.code,
        message: 'The value for minlength must be a number.',
        details: {
          fieldKey: key
        }
      });
    }

    frame = iFramer({
      type: key,
      name: 'braintree-hosted-field-' + key,
      style: constants.defaultIFrameStyle,
      title: 'Secure Credit Card Frame - ' + constants.allowedFields[key].label
    });

    this._injectedNodes.push.apply(this._injectedNodes, injectFrame(frame, container));
    this._setupLabelFocus(key, container);
    fields[key] = {
      frameElement: frame,
      containerElement: container
    };
    frameReadyPromise = new Promise(function (resolve) {
      frameReadyPromiseResolveFunctions[key] = resolve;
    });
    frameReadyPromises.push(frameReadyPromise);

    this._state.fields[key] = {
      isEmpty: true,
      isValid: false,
      isPotentiallyValid: true,
      isFocused: false,
      container: container
    };

    setTimeout(function () {
      // Edge has an intermittent issue where
      // the iframes load, but the JavaScript
      // can't message out to the parent page.
      // We can fix this by setting the src
      // to about:blank first followed by
      // the actual source. Both instances
      // of setting the src need to be in a
      // setTimeout to work.
      if (browserDetection.isIE() || browserDetection.isEdge()) {
        frame.src = 'about:blank';
        setTimeout(function () {
          frame.src = hostedFieldsUrl;
        }, 0);
      } else {
        frame.src = hostedFieldsUrl;
      }
    }, 0);
  }.bind(this));

  if (busOptions.styles) {
    Object.keys(busOptions.styles).forEach(function (selector) {
      var className = busOptions.styles[selector];

      if (typeof className === 'string') {
        busOptions.styles[selector] = getStylesFromClass(className);
      }
    });
  }

  failureTimeout = setTimeout(function () {
    analytics.sendEvent(self._clientInstanceOrPromise, 'custom.hosted-fields.load.timed-out');
    self._emit('timeout');
  }, INTEGRATION_TIMEOUT_MS);

  Promise.all(frameReadyPromises).then(function (results) {
    var reply = results[0];

    clearTimeout(failureTimeout);
    reply(busOptions);
    self._emit('ready');
  });

  this._bus.on(events.FRAME_READY, function (data, reply) {
    frameReadyPromiseResolveFunctions[data.field](reply);
  });

  this._bus.on(
    events.INPUT_EVENT,
    createInputEventHandler(fields).bind(this)
  );

  this._destructor.registerFunctionForTeardown(function () {
    var j, node, parent;

    for (j = 0; j < self._injectedNodes.length; j++) {
      node = self._injectedNodes[j];
      parent = node.parentNode;

      parent.removeChild(node);

      classlist.remove(
        parent,
        constants.externalClasses.FOCUSED,
        constants.externalClasses.INVALID,
        constants.externalClasses.VALID
      );
    }
  });

  this._destructor.registerFunctionForTeardown(function () {
    var methodNames = methods(HostedFields.prototype).concat(methods(EventEmitter.prototype));

    convertMethodsToError(self, methodNames);
  });
}

HostedFields.prototype = Object.create(EventEmitter.prototype, {
  constructor: HostedFields
});

HostedFields.prototype._setupLabelFocus = function (type, container) {
  var labels, i;
  var shouldSkipLabelFocus = browserDetection.isIos();
  var bus = this._bus;

  if (shouldSkipLabelFocus) { return; }
  if (container.id == null) { return; }

  function triggerFocus() {
    bus.emit(events.TRIGGER_INPUT_FOCUS, type);
  }

  labels = Array.prototype.slice.call(document.querySelectorAll('label[for="' + container.id + '"]'));
  labels = labels.concat(findParentTags(container, 'label'));

  for (i = 0; i < labels.length; i++) {
    labels[i].addEventListener('click', triggerFocus, false);
  }

  this._destructor.registerFunctionForTeardown(function () {
    for (i = 0; i < labels.length; i++) {
      labels[i].removeEventListener('click', triggerFocus, false);
    }
  });
};

HostedFields.prototype._attachInvalidFieldContainersToError = function (err) {
  if (!(err.details && err.details.invalidFieldKeys && err.details.invalidFieldKeys.length > 0)) {
    return;
  }
  err.details.invalidFields = {};
  err.details.invalidFieldKeys.forEach(function (field) {
    err.details.invalidFields[field] = this._fields[field].containerElement;
  }.bind(this));
};

/**
 * Cleanly remove anything set up by {@link module:braintree-web/hosted-fields.create|create}.
 * @public
 * @param {callback} [callback] Called on completion, containing an error if one occurred. No data is returned if teardown completes successfully. If no callback is provided, `teardown` returns a promise.
 * @example
 * hostedFieldsInstance.teardown(function (teardownErr) {
 *   if (teardownErr) {
 *     console.error('Could not tear down Hosted Fields!');
 *   } else {
 *     console.info('Hosted Fields has been torn down!');
 *   }
 * });
 * @returns {Promise|void} Returns a promise if no callback is provided.
 */
HostedFields.prototype.teardown = function () {
  var self = this;

  return new Promise(function (resolve, reject) {
    self._destructor.teardown(function (err) {
      analytics.sendEvent(self._clientInstanceOrPromise, 'custom.hosted-fields.teardown-completed');

      if (err) {
        reject(err);
      } else {
        resolve();
      }
    });
  });
};

/**
 * Tokenizes fields and returns a nonce payload.
 * @public
 * @param {object} [options] All tokenization options for the Hosted Fields component.
 * @param {boolean} [options.vault=false] When true, will vault the tokenized card. Cards will only be vaulted when using a client created with a client token that includes a customer ID.
 * @param {string} [options.cardholderName] When supplied, the cardholder name to be tokenized with the contents of the fields.
 * @param {string} [options.billingAddress.postalCode] When supplied, this postal code will be tokenized along with the contents of the fields. If a postal code is provided as part of the Hosted Fields configuration, the value of the field will be tokenized and this value will be ignored.
 * @param {string} [options.billingAddress.firstName] When supplied, this customer first name will be tokenized along with the contents of the fields.
 * @param {string} [options.billingAddress.lastName] When supplied, this customer last name will be tokenized along with the contents of the fields.
 * @param {string} [options.billingAddress.company] When supplied, this company name will be tokenized along with the contents of the fields.
 * @param {string} [options.billingAddress.streetAddress] When supplied, this street address will be tokenized along with the contents of the fields.
 * @param {string} [options.billingAddress.extendedAddress] When supplied, this extended address will be tokenized along with the contents of the fields.
 * @param {string} [options.billingAddress.locality] When supplied, this locality (the city) will be tokenized along with the contents of the fields.
 * @param {string} [options.billingAddress.region] When supplied, this region (the state) will be tokenized along with the contents of the fields.
 * @param {string} [options.billingAddress.countryCodeNumeric] When supplied, this numeric country code will be tokenized along with the contents of the fields.
 * @param {string} [options.billingAddress.countryCodeAlpha2] When supplied, this alpha 2 representation of a country will be tokenized along with the contents of the fields.
 * @param {string} [options.billingAddress.countryCodeAlpha3] When supplied, this alpha 3 representation of a country will be tokenized along with the contents of the fields.
 * @param {string} [options.billingAddress.countryName] When supplied, this country name will be tokenized along with the contents of the fields.
 *
 * @param {callback} [callback] The second argument, <code>data</code>, is a {@link HostedFields~tokenizePayload|tokenizePayload}. If no callback is provided, `tokenize` returns a function that resolves with a {@link HostedFields~tokenizePayload|tokenizePayload}.
 * @example <caption>Tokenize a card</caption>
 * hostedFieldsInstance.tokenize(function (tokenizeErr, payload) {
 *   if (tokenizeErr) {
 *     switch (tokenizeErr.code) {
 *       case 'HOSTED_FIELDS_FIELDS_EMPTY':
 *         // occurs when none of the fields are filled in
 *         console.error('All fields are empty! Please fill out the form.');
 *         break;
 *       case 'HOSTED_FIELDS_FIELDS_INVALID':
 *         // occurs when certain fields do not pass client side validation
 *         console.error('Some fields are invalid:', tokenizeErr.details.invalidFieldKeys);
 *
 *         // you can also programtically access the field containers for the invalid fields
 *         tokenizeErr.details.invalidFields.forEach(function (fieldContainer) {
 *           fieldContainer.className = 'invalid';
 *         });
 *         break;
 *       case 'HOSTED_FIELDS_TOKENIZATION_FAIL_ON_DUPLICATE':
 *         // occurs when:
 *         //   * the client token used for client authorization was generated
 *         //     with a customer ID and the fail on duplicate payment method
 *         //     option is set to true
 *         //   * the card being tokenized has previously been vaulted (with any customer)
 *         // See: https://developers.braintreepayments.com/reference/request/client-token/generate/#options.fail_on_duplicate_payment_method
 *         console.error('This payment method already exists in your vault.');
 *         break;
 *       case 'HOSTED_FIELDS_TOKENIZATION_CVV_VERIFICATION_FAILED':
 *         // occurs when:
 *         //   * the client token used for client authorization was generated
 *         //     with a customer ID and the verify card option is set to true
 *         //     and you have credit card verification turned on in the Braintree
 *         //     control panel
 *         //   * the cvv does not pass verfication (https://developers.braintreepayments.com/reference/general/testing/#avs-and-cvv/cid-responses)
 *         // See: https://developers.braintreepayments.com/reference/request/client-token/generate/#options.verify_card
 *         console.error('CVV did not pass verification');
 *         break;
 *       case 'HOSTED_FIELDS_FAILED_TOKENIZATION':
 *         // occurs for any other tokenization error on the server
 *         console.error('Tokenization failed server side. Is the card valid?');
 *         break;
 *       case 'HOSTED_FIELDS_TOKENIZATION_NETWORK_ERROR':
 *         // occurs when the Braintree gateway cannot be contacted
 *         console.error('Network error occurred when tokenizing.');
 *         break;
 *       default:
 *         console.error('Something bad happened!', tokenizeErr);
 *     }
 *   } else {
 *     console.log('Got nonce:', payload.nonce);
 *   }
 * });
 * @example <caption>Tokenize and vault a card</caption>
 * hostedFieldsInstance.tokenize({
 *   vault: true
 * }, function (tokenizeErr, payload) {
 *   if (tokenizeErr) {
 *     console.error(tokenizeErr);
 *   } else {
 *     console.log('Got nonce:', payload.nonce);
 *   }
 * });
 * @example <caption>Tokenize a card with cardholder name</caption>
 * hostedFieldsInstance.tokenize({
 *   cardholderName: 'First Last'
 * }, function (tokenizeErr, payload) {
 *   if (tokenizeErr) {
 *     console.error(tokenizeErr);
 *   } else {
 *     console.log('Got nonce:', payload.nonce);
 *   }
 * });
 * @example <caption>Tokenize a card with the postal code option</caption>
 * hostedFieldsInstance.tokenize({
 *   billingAddress: {
 *     postalCode: '11111'
 *   }
 * }, function (tokenizeErr, payload) {
 *   if (tokenizeErr) {
 *     console.error(tokenizeErr);
 *   } else {
 *     console.log('Got nonce:', payload.nonce);
 *   }
 * });
 * @example <caption>Tokenize a card with additional billing address options</caption>
 * hostedFieldsInstance.tokenize({
 *   billingAddress: {
 *     firstName: 'First',
 *     lastName: 'Last',
 *     company: 'Company',
 *     streetAddress: '123 Street',
 *     extendedAddress: 'Unit 1',
 *     // passing just one of the country options is sufficient to
 *     // associate the card details with a particular country
 *     // valid country names and codes can be found here:
 *     // https://developers.braintreepayments.com/reference/general/countries/ruby#list-of-countries
 *     countryName: 'United States',
 *     countryCodeAlpha2: 'US',
 *     countryCodeAlpha3: 'USA',
 *     countryCodeNumeric: '840'
 *   }
 * }, function (tokenizeErr, payload) {
 *   if (tokenizeErr) {
 *     console.error(tokenizeErr);
 *   } else {
 *     console.log('Got nonce:', payload.nonce);
 *   }
 * });
 * @returns {Promise|void} Returns a promise if no callback is provided.
 */
HostedFields.prototype.tokenize = function (options) {
  var self = this;

  if (!options) {
    options = {};
  }

  return new Promise(function (resolve, reject) {
    self._bus.emit(events.TOKENIZATION_REQUEST, options, function (response) {
      var err = response[0];
      var payload = response[1];

      if (err) {
        self._attachInvalidFieldContainersToError(err);
        reject(new BraintreeError(err));
      } else {
        resolve(payload);
      }
    });
  });
};

/**
 * Add a class to a {@link module:braintree-web/hosted-fields~field field}. Useful for updating field styles when events occur elsewhere in your checkout.
 * @public
 * @param {string} field The field you wish to add a class to. Must be a valid {@link module:braintree-web/hosted-fields~fieldOptions fieldOption}.
 * @param {string} classname The class to be added.
 * @param {callback} [callback] Callback executed on completion, containing an error if one occurred. No data is returned if the class is added successfully.
 *
 * @example
 * hostedFieldsInstance.addClass('number', 'custom-class', function (addClassErr) {
 *   if (addClassErr) {
 *     console.error(addClassErr);
 *   }
 * });
 * @returns {Promise|void} Returns a promise if no callback is provided.
 */
HostedFields.prototype.addClass = function (field, classname) {
  var err;

  if (!allowedFields.hasOwnProperty(field)) {
    err = new BraintreeError({
      type: errors.HOSTED_FIELDS_FIELD_INVALID.type,
      code: errors.HOSTED_FIELDS_FIELD_INVALID.code,
      message: '"' + field + '" is not a valid field. You must use a valid field option when adding a class.'
    });
  } else if (!this._fields.hasOwnProperty(field)) {
    err = new BraintreeError({
      type: errors.HOSTED_FIELDS_FIELD_NOT_PRESENT.type,
      code: errors.HOSTED_FIELDS_FIELD_NOT_PRESENT.code,
      message: 'Cannot add class to "' + field + '" field because it is not part of the current Hosted Fields options.'
    });
  } else {
    this._bus.emit(events.ADD_CLASS, field, classname);
  }

  if (err) {
    return Promise.reject(err);
  }

  return Promise.resolve();
};

/**
 * Removes a class to a {@link module:braintree-web/hosted-fields~field field}. Useful for updating field styles when events occur elsewhere in your checkout.
 * @public
 * @param {string} field The field you wish to remove a class from. Must be a valid {@link module:braintree-web/hosted-fields~fieldOptions fieldOption}.
 * @param {string} classname The class to be removed.
 * @param {callback} [callback] Callback executed on completion, containing an error if one occurred. No data is returned if the class is removed successfully.
 *
 * @example
 * hostedFieldsInstance.addClass('number', 'custom-class', function (addClassErr) {
 *   if (addClassErr) {
 *     console.error(addClassErr);
 *     return;
 *   }
 *
 *   // some time later...
 *   hostedFieldsInstance.removeClass('number', 'custom-class');
 * });
 * @returns {Promise|void} Returns a promise if no callback is provided.
 */
HostedFields.prototype.removeClass = function (field, classname) {
  var err;

  if (!allowedFields.hasOwnProperty(field)) {
    err = new BraintreeError({
      type: errors.HOSTED_FIELDS_FIELD_INVALID.type,
      code: errors.HOSTED_FIELDS_FIELD_INVALID.code,
      message: '"' + field + '" is not a valid field. You must use a valid field option when removing a class.'
    });
  } else if (!this._fields.hasOwnProperty(field)) {
    err = new BraintreeError({
      type: errors.HOSTED_FIELDS_FIELD_NOT_PRESENT.type,
      code: errors.HOSTED_FIELDS_FIELD_NOT_PRESENT.code,
      message: 'Cannot remove class from "' + field + '" field because it is not part of the current Hosted Fields options.'
    });
  } else {
    this._bus.emit(events.REMOVE_CLASS, field, classname);
  }

  if (err) {
    return Promise.reject(err);
  }

  return Promise.resolve();
};

/**
 * Sets an attribute of a {@link module:braintree-web/hosted-fields~field field}.
 * Supported attributes are `aria-invalid`, `aria-required`, `disabled`, and `placeholder`.
 *
 * @public
 * @param {object} options The options for the attribute you wish to set.
 * @param {string} options.field The field to which you wish to add an attribute. Must be a valid {@link module:braintree-web/hosted-fields~fieldOptions fieldOption}.
 * @param {string} options.attribute The name of the attribute you wish to add to the field.
 * @param {string} options.value The value for the attribute.
 * @param {callback} [callback] Callback executed on completion, containing an error if one occurred. No data is returned if the attribute is set successfully.
 *
 * @example <caption>Set the placeholder attribute of a field</caption>
 * hostedFieldsInstance.setAttribute({
 *   field: 'number',
 *   attribute: 'placeholder',
 *   value: '1111 1111 1111 1111'
 * }, function (attributeErr) {
 *   if (attributeErr) {
 *     console.error(attributeErr);
 *   }
 * });
 *
 * @example <caption>Set the aria-required attribute of a field</caption>
 * hostedFieldsInstance.setAttribute({
 *   field: 'number',
 *   attribute: 'aria-required',
 *   value: true
 * }, function (attributeErr) {
 *   if (attributeErr) {
 *     console.error(attributeErr);
 *   }
 * });
 *
 * @returns {Promise|void} Returns a promise if no callback is provided.
 */
HostedFields.prototype.setAttribute = function (options) {
  var attributeErr, err;

  if (!allowedFields.hasOwnProperty(options.field)) {
    err = new BraintreeError({
      type: errors.HOSTED_FIELDS_FIELD_INVALID.type,
      code: errors.HOSTED_FIELDS_FIELD_INVALID.code,
      message: '"' + options.field + '" is not a valid field. You must use a valid field option when setting an attribute.'
    });
  } else if (!this._fields.hasOwnProperty(options.field)) {
    err = new BraintreeError({
      type: errors.HOSTED_FIELDS_FIELD_NOT_PRESENT.type,
      code: errors.HOSTED_FIELDS_FIELD_NOT_PRESENT.code,
      message: 'Cannot set attribute for "' + options.field + '" field because it is not part of the current Hosted Fields options.'
    });
  } else {
    attributeErr = attributeValidationError(options.attribute, options.value);

    if (attributeErr) {
      err = attributeErr;
    } else {
      this._bus.emit(events.SET_ATTRIBUTE, options.field, options.attribute, options.value);
    }
  }

  if (err) {
    return Promise.reject(err);
  }

  return Promise.resolve();
};

/**
 * Sets a visually hidden message (for screenreaders) on a {@link module:braintree-web/hosted-fields~field field}.
 *
 * @public
 * @param {object} options The options for the attribute you wish to set.
 * @param {string} options.field The field to which you wish to add an attribute. Must be a valid {@link module:braintree-web/hosted-fields~field field}.
 * @param {string} options.message The message to set.
 *
 * @example <caption>Set an error message on a field</caption>
 * hostedFieldsInstance.setMessage({
 *   field: 'number',
 *   message: 'Invalid card number'
 * });
 *
 * @example <caption>Remove the message on a field</caption>
 * hostedFieldsInstance.setMessage({
 *   field: 'number',
 *   message: ''
 * });
 *
 * @returns {void}
 */
HostedFields.prototype.setMessage = function (options) {
  this._bus.emit(events.SET_MESSAGE, options.field, options.message);
};

/**
 * Removes a supported attribute from a {@link module:braintree-web/hosted-fields~field field}.
 *
 * @public
 * @param {object} options The options for the attribute you wish to remove.
 * @param {string} options.field The field from which you wish to remove an attribute. Must be a valid {@link module:braintree-web/hosted-fields~fieldOptions fieldOption}.
 * @param {string} options.attribute The name of the attribute you wish to remove from the field.
 * @param {callback} [callback] Callback executed on completion, containing an error if one occurred. No data is returned if the attribute is removed successfully.
 *
 * @example <caption>Remove the placeholder attribute of a field</caption>
 * hostedFieldsInstance.removeAttribute({
 *   field: 'number',
 *   attribute: 'placeholder'
 * }, function (attributeErr) {
 *   if (attributeErr) {
 *     console.error(attributeErr);
 *   }
 * });
 *
 * @returns {Promise|void} Returns a promise if no callback is provided.
 */
HostedFields.prototype.removeAttribute = function (options) {
  var attributeErr, err;

  if (!allowedFields.hasOwnProperty(options.field)) {
    err = new BraintreeError({
      type: errors.HOSTED_FIELDS_FIELD_INVALID.type,
      code: errors.HOSTED_FIELDS_FIELD_INVALID.code,
      message: '"' + options.field + '" is not a valid field. You must use a valid field option when removing an attribute.'
    });
  } else if (!this._fields.hasOwnProperty(options.field)) {
    err = new BraintreeError({
      type: errors.HOSTED_FIELDS_FIELD_NOT_PRESENT.type,
      code: errors.HOSTED_FIELDS_FIELD_NOT_PRESENT.code,
      message: 'Cannot remove attribute for "' + options.field + '" field because it is not part of the current Hosted Fields options.'
    });
  } else {
    attributeErr = attributeValidationError(options.attribute);

    if (attributeErr) {
      err = attributeErr;
    } else {
      this._bus.emit(events.REMOVE_ATTRIBUTE, options.field, options.attribute);
    }
  }

  if (err) {
    return Promise.reject(err);
  }

  return Promise.resolve();
};

/**
 * @deprecated since version 3.8.0. Use {@link HostedFields#setAttribute|setAttribute} instead.
 *
 * @public
 * @param {string} field The field whose placeholder you wish to change. Must be a valid {@link module:braintree-web/hosted-fields~fieldOptions fieldOption}.
 * @param {string} placeholder Will be used as the `placeholder` attribute of the input.
 * @param {callback} [callback] Callback executed on completion, containing an error if one occurred. No data is returned if the placeholder updated successfully.
 *
 * @returns {Promise|void} Returns a promise if no callback is provided.
 */
HostedFields.prototype.setPlaceholder = function (field, placeholder) {
  return this.setAttribute({
    field: field,
    attribute: 'placeholder',
    value: placeholder
  });
};

/**
 * Clear the value of a {@link module:braintree-web/hosted-fields~field field}.
 * @public
 * @param {string} field The field you wish to clear. Must be a valid {@link module:braintree-web/hosted-fields~fieldOptions fieldOption}.
 * @param {callback} [callback] Callback executed on completion, containing an error if one occurred. No data is returned if the field cleared successfully.
 * @returns {Promise|void} Returns a promise if no callback is provided.
 * @example
 * hostedFieldsInstance.clear('number', function (clearErr) {
 *   if (clearErr) {
 *     console.error(clearErr);
 *   }
 * });
 *
 * @example <caption>Clear several fields</caption>
 * hostedFieldsInstance.clear('number');
 * hostedFieldsInstance.clear('cvv');
 * hostedFieldsInstance.clear('expirationDate');
 */
HostedFields.prototype.clear = function (field) {
  var err;

  if (!allowedFields.hasOwnProperty(field)) {
    err = new BraintreeError({
      type: errors.HOSTED_FIELDS_FIELD_INVALID.type,
      code: errors.HOSTED_FIELDS_FIELD_INVALID.code,
      message: '"' + field + '" is not a valid field. You must use a valid field option when clearing a field.'
    });
  } else if (!this._fields.hasOwnProperty(field)) {
    err = new BraintreeError({
      type: errors.HOSTED_FIELDS_FIELD_NOT_PRESENT.type,
      code: errors.HOSTED_FIELDS_FIELD_NOT_PRESENT.code,
      message: 'Cannot clear "' + field + '" field because it is not part of the current Hosted Fields options.'
    });
  } else {
    this._bus.emit(events.CLEAR_FIELD, field);
  }

  if (err) {
    return Promise.reject(err);
  }

  return Promise.resolve();
};

/**
 * Programmatically focus a {@link module:braintree-web/hosted-fields~field field}.
 * @public
 * @param {string} field The field you want to focus. Must be a valid {@link module:braintree-web/hosted-fields~fieldOptions fieldOption}.
 * @param {callback} [callback] Callback executed on completion, containing an error if one occurred. No data is returned if the field focused successfully.
 * @returns {void}
 * @example
 * hostedFieldsInstance.focus('number', function (focusErr) {
 *   if (focusErr) {
 *     console.error(focusErr);
 *   }
 * });
 * @example <caption>Using an event listener</caption>
 * myElement.addEventListener('click', function (e) {
 *   // In Firefox, the focus method can be suppressed
 *   //   if the element has a tabindex property or the element
 *   //   is an anchor link with an href property.
 *   // In Mobile Safari, the focus method is unable to
 *   //   programatically open the keyboard, as only
 *   //   touch events are allowed to do so.
 *   e.preventDefault();
 *   hostedFieldsInstance.focus('number');
 * });
 */
HostedFields.prototype.focus = function (field) {
  var err;

  if (!allowedFields.hasOwnProperty(field)) {
    err = new BraintreeError({
      type: errors.HOSTED_FIELDS_FIELD_INVALID.type,
      code: errors.HOSTED_FIELDS_FIELD_INVALID.code,
      message: '"' + field + '" is not a valid field. You must use a valid field option when focusing a field.'
    });
  } else if (!this._fields.hasOwnProperty(field)) {
    err = new BraintreeError({
      type: errors.HOSTED_FIELDS_FIELD_NOT_PRESENT.type,
      code: errors.HOSTED_FIELDS_FIELD_NOT_PRESENT.code,
      message: 'Cannot focus "' + field + '" field because it is not part of the current Hosted Fields options.'
    });
  } else {
    this._bus.emit(events.TRIGGER_INPUT_FOCUS, field);
  }

  if (err) {
    return Promise.reject(err);
  }

  return Promise.resolve();
};

/**
 * Returns an {@link HostedFields~stateObject|object} that includes the state of all fields and possible card types.
 * @public
 * @returns {object} {@link HostedFields~stateObject|stateObject}
 * @example <caption>Check if all fields are valid</caption>
 * var state = hostedFieldsInstance.getState();
 *
 * var formValid = Object.keys(state.fields).every(function (key) {
 *   return state.fields[key].isValid;
 * });
 */
HostedFields.prototype.getState = function () {
  return this._state;
};

module.exports = wrapPromise.wrapPrototype(HostedFields);

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"../../lib/analytics":35,"../../lib/assets":36,"../../lib/assign":37,"../../lib/braintree-error":40,"../../lib/bus":43,"../../lib/classlist":44,"../../lib/constants":45,"../../lib/convert-methods-to-error":46,"../../lib/create-authorization-data":47,"../../lib/destructor":48,"../../lib/errors":50,"../../lib/event-emitter":51,"../../lib/methods":54,"../../lib/promise":56,"../../lib/vendor/uuid":59,"../shared/browser-detection":29,"../shared/constants":30,"../shared/errors":31,"../shared/find-parent-tags":32,"../shared/get-card-types":33,"./attribute-validation-error":23,"./compose-url":24,"./get-styles-from-class":25,"./inject-frame":27,"@braintree/iframer":10,"@braintree/wrap-promise":17}],27:[function(_dereq_,module,exports){
'use strict';

module.exports = function injectFrame(frame, container) {
  var clearboth = document.createElement('div');
  var fragment = document.createDocumentFragment();

  clearboth.style.clear = 'both';

  fragment.appendChild(frame);
  fragment.appendChild(clearboth);

  container.appendChild(fragment);

  return [frame, clearboth];
};

},{}],28:[function(_dereq_,module,exports){
'use strict';
/** @module braintree-web/hosted-fields */

var HostedFields = _dereq_('./external/hosted-fields');
var basicComponentVerification = _dereq_('../lib/basic-component-verification');
var errors = _dereq_('./shared/errors');
var supportsInputFormatting = _dereq_('restricted-input/supports-input-formatting');
var wrapPromise = _dereq_('@braintree/wrap-promise');
var BraintreeError = _dereq_('../lib/braintree-error');
var Promise = _dereq_('../lib/promise');
var VERSION = "3.38.1";

/**
 * Fields used in {@link module:braintree-web/hosted-fields~fieldOptions fields options}
 * @typedef {object} field
 * @property {string} selector A CSS selector to find the container where the hosted field will be inserted.
 * @property {string} [placeholder] Will be used as the `placeholder` attribute of the input. If `placeholder` is not natively supported by the browser, it will be polyfilled.
 * @property {string} [type] Will be used as the `type` attribute of the input. To mask `cvv` input, for instance, `type: "password"` can be used.
 * @property {boolean} [formatInput=true] Enable or disable automatic formatting on this field.
 * @property {object|boolean} [maskInput=false] Enable or disable input masking when input is not focused. If set to `true` instead of an object, the defaults for the `maskInput` parameters will be used.
 * @property {string} [maskInput.character=•] The character to use when masking the input. The default character ('•') uses a unicode symbol, so the webpage must support UTF-8 characters when using the default.
 * @property {Boolean} [maskInput.showLastFour=false] Only applicable for the credit card field. Whether or not to show the last 4 digits of the card when masking.
 * @property {object|boolean} [select] If truthy, this field becomes a `<select>` dropdown list. This can only be used for `expirationMonth` and `expirationYear` fields. If you do not use a `placeholder` property for the field, the current month/year will be the default selected value.
 * @property {string[]} [select.options] An array of 12 strings, one per month. This can only be used for the `expirationMonth` field. For example, the array can look like `['01 - January', '02 - February', ...]`.
 * @property {number} [maxlength] This option applies only to the CVV and postal code fields. Will be used as the `maxlength` attribute of the input if it is less than the default. The primary use cases for the `maxlength` option are: limiting the length of the CVV input for CVV-only verifications when the card type is known and limiting the length of the postal code input when cards are coming from a known region.
 * @property {number} [minlength=3] This option applies only to the cvv and postal code fields. Will be used as the `minlength` attribute of the input.
 * For postal code fields, the default value is 3, representing the Icelandic postal code length. This option's primary use case is to increase the `minlength`, e.g. for US customers, the postal code `minlength` can be set to 5.
 * For cvv fields, the default value is 3. The `minlength` attribute only applies to integrations capturing a cvv without a number field.
 * @property {string} [prefill] A value to prefill the field with. For example, when creating an update card form, you can prefill the expiration date fields with the old expiration date data.
 * @property {boolean} [rejectUnsupportedCards=false] Only allow card types that your merchant account is able to process. Unsupported card types will invalidate the card form. e.g. if you only process Visa cards, a customer entering a American Express card would get an invalid card field. This can only be used for the `number` field.
 */

/**
 * An object that has {@link module:braintree-web/hosted-fields~field field objects} for each field. Used in {@link module:braintree-web/hosted-fields~create create}.
 * @typedef {object} fieldOptions
 * @property {field} [number] A field for card number.
 * @property {field} [expirationDate] A field for expiration date in `MM/YYYY` format. This should not be used with the `expirationMonth` and `expirationYear` properties.
 * @property {field} [expirationMonth] A field for expiration month in `MM` format. This should be used with the `expirationYear` property.
 * @property {field} [expirationYear] A field for expiration year in `YYYY` format. This should be used with the `expirationMonth` property.
 * @property {field} [cvv] A field for 3 or 4 digit card verification code (like CVV or CID). If you wish to create a CVV-only payment method nonce to verify a card already stored in your Vault, omit all other fields to only collect CVV.
 * @property {field} [postalCode] A field for postal or region code.
 */

/**
 * An object that represents CSS that will be applied in each hosted field. This object looks similar to CSS. Typically, these styles involve fonts (such as `font-family` or `color`).
 *
 * You may also pass the name of a class on your site that contains the styles you would like to apply. The style properties will be automatically pulled off the class and applied to the Hosted Fields inputs. Note: this is recomended for `input` elements only. If using a `select` for the expiration date, unexpected styling may occur.
 *
 * These are the CSS properties that Hosted Fields supports. Any other CSS should be specified on your page and outside of any Braintree configuration. Trying to set unsupported properties will fail and put a warning in the console.
 *
 * Supported CSS properties are:
 * `appearance`
 * `color`
 * `direction`
 * `font-family`
 * `font-size-adjust`
 * `font-size`
 * `font-stretch`
 * `font-style`
 * `font-variant-alternates`
 * `font-variant-caps`
 * `font-variant-east-asian`
 * `font-variant-ligatures`
 * `font-variant-numeric`
 * `font-variant`
 * `font-weight`
 * `font`
 * `letter-spacing`
 * `line-height`
 * `opacity`
 * `outline`
 * `padding`
 * `text-shadow`
 * `transition`
 * `-moz-appearance`
 * `-moz-osx-font-smoothing`
 * `-moz-tap-highlight-color`
 * `-moz-transition`
 * `-webkit-appearance`
 * `-webkit-font-smoothing`
 * `-webkit-tap-highlight-color`
 * `-webkit-transition`
 * @typedef {object} styleOptions
 */

/**
 * @static
 * @function create
 * @param {object} options Creation options:
 * @param {Client} options.client A {@link Client} instance.
 * @param {fieldOptions} options.fields A {@link module:braintree-web/hosted-fields~fieldOptions set of options for each field}.
 * @param {styleOptions} [options.styles] {@link module:braintree-web/hosted-fields~styleOptions Styles} applied to each field.
 * @param {callback} [callback] The second argument, `data`, is the {@link HostedFields} instance. If no callback is provided, `create` returns a promise that resolves with the {@link HostedFields} instance.
 * @returns {void}
 * @example
 * braintree.hostedFields.create({
 *   client: clientInstance,
 *   styles: {
 *     'input': {
 *       'font-size': '16pt',
 *       'color': '#3A3A3A'
 *     },
 *     '.number': {
 *       'font-family': 'monospace'
 *     },
 *     '.valid': {
 *       'color': 'green'
 *     }
 *   },
 *   fields: {
 *     number: {
 *       selector: '#card-number'
 *     },
 *     cvv: {
 *       selector: '#cvv',
 *       placeholder: '•••'
 *     },
 *     expirationDate: {
 *       selector: '#expiration-date',
 *       type: 'month'
 *     }
 *   }
 * }, callback);
 * @example <caption>Applying styles with a class name</caption>
 * // in document head
 * <style>
 *   .braintree-input-class {
 *     color: black;
 *   }
 *   .braintree-valid-class {
 *     color: green;
 *   }
 *   .braintree-invalid-class {
 *     color: red;
 *   }
 * </style>
 * // in a script tag
 * braintree.hostedFields.create({
 *   client: clientInstance,
 *   styles: {
 *     'input': 'braintree-input-class',
 *     '.invalid': 'braintree-invalid-class',
 *     '.valid': {
 *       // you can also use the object syntax alongside
 *       // the class name syntax
 *       color: green;
 *     }
 *   },
 *   fields: {
 *     number: {
 *       selector: '#card-number'
 *     },
 *     // etc...
 *   }
 * }, callback);
 * @example <caption>Right to Left Language Support</caption>
 * braintree.hostedFields.create({
 *   client: clientInstance,
 *   styles: {
 *     'input': {
 *       // other styles
 *       direction: 'rtl'
 *     },
 *   },
 *   fields: {
 *     number: {
 *       selector: '#card-number',
 *       // Credit card formatting is not currently supported
 *       // with RTL languages, so we need to turn it off for the number input
 *       formatInput: false
 *     },
 *     cvv: {
 *       selector: '#cvv',
 *       placeholder: '•••'
 *     },
 *     expirationDate: {
 *       selector: '#expiration-date',
 *       type: 'month'
 *     }
 *   }
 * }, callback);
 * @example <caption>Setting up Hosted Fields to tokenize CVV only</caption>
 * braintree.hostedFields.create({
 *   client: clientInstance,
 *   fields: {
 *     // Only add the `cvv` option.
 *     cvv: {
 *       selector: '#cvv',
 *       placeholder: '•••'
 *     }
 *   }
 * }, callback);
 * @example <caption>Creating an expiration date update form with prefilled data</caption>
 * var storedCreditCardInformation = {
 *   // get this info from your server
 *   // with a payment method lookup
 *   month: '09',
 *   year: '2017'
 * };
 *
 * braintree.hostedFields.create({
 *   client: clientInstance,
 *   fields: {
 *     expirationMonth: {
 *       selector: '#expiration-month',
 *       prefill: storedCreditCardInformation.month
 *     },
 *     expirationYear: {
 *       selector: '#expiration-year',
 *       prefill: storedCreditCardInformation.year
 *     }
 *   }
 * }, callback);
 * @example <caption>Validate the card form for supported card types</caption>
 * braintree.hostedFields.create({
 *   client: clientInstance,
 *   fields: {
 *     number: {
 *       selector: '#card-number',
 *       rejectUnsupportedCards: true
 *     },
 *     cvv: {
 *       selector: '#cvv',
 *       placeholder: '•••'
 *     },
 *     expirationDate: {
 *       selector: '#expiration-date',
 *       type: 'month'
 *     }
 *   },
 * }, callback);
 */
function create(options) {
  return basicComponentVerification.verify({
    name: 'Hosted Fields',
    authorization: options.authorization,
    client: options.client
  }).then(function () {
    var integration = new HostedFields(options);

    return new Promise(function (resolve, reject) {
      integration.on('ready', function () {
        resolve(integration);
      });
      integration.on('timeout', function () {
        reject(new BraintreeError(errors.HOSTED_FIELDS_TIMEOUT));
      });
    });
  });
}

module.exports = {
  /**
   * @static
   * @function supportsInputFormatting
   * @description Returns false if input formatting will be automatically disabled due to browser incompatibility. Otherwise, returns true. For a list of unsupported browsers, [go here](https://github.com/braintree/restricted-input/blob/master/README.md#browsers-where-formatting-is-turned-off-automatically).
   * @returns {Boolean} Returns false if input formatting will be automatically disabled due to browser incompatibility. Otherwise, returns true.
   * @example
   * <caption>Conditionally choosing split expiration date inputs if formatting is unavailable</caption>
   * var canFormat = braintree.hostedFields.supportsInputFormatting();
   * var fields = {
   *   number: {
   *     selector: '#card-number'
   *   },
   *   cvv: {
   *     selector: '#cvv'
   *   }
   * };
   *
   * if (canFormat) {
   *   fields.expirationDate = {
   *     selection: '#expiration-date'
   *   };
   *   functionToCreateAndInsertExpirationDateDivToForm();
   * } else {
   *   fields.expirationMonth = {
   *     selection: '#expiration-month'
   *   };
   *   fields.expirationYear = {
   *     selection: '#expiration-year'
   *   };
   *   functionToCreateAndInsertExpirationMonthAndYearDivsToForm();
   * }
   *
   * braintree.hostedFields.create({
   *   client: clientInstance,
   *   styles: {
   *     // Styles
   *   },
   *   fields: fields
   * }, callback);
   */
  supportsInputFormatting: supportsInputFormatting,
  create: wrapPromise(create),
  /**
   * @description The current version of the SDK, i.e. `{@pkg version}`.
   * @type {string}
   */
  VERSION: VERSION
};

},{"../lib/basic-component-verification":38,"../lib/braintree-error":40,"../lib/promise":56,"./external/hosted-fields":26,"./shared/errors":31,"@braintree/wrap-promise":17,"restricted-input/supports-input-formatting":22}],29:[function(_dereq_,module,exports){
'use strict';

module.exports = {
  isIE: _dereq_('@braintree/browser-detection/is-ie'),
  isEdge: _dereq_('@braintree/browser-detection/is-edge'),
  isIe9: _dereq_('@braintree/browser-detection/is-ie9'),
  isIos: _dereq_('@braintree/browser-detection/is-ios'),
  isIosWebview: _dereq_('@braintree/browser-detection/is-ios-webview')
};

},{"@braintree/browser-detection/is-edge":3,"@braintree/browser-detection/is-ie":4,"@braintree/browser-detection/is-ie9":6,"@braintree/browser-detection/is-ios":8,"@braintree/browser-detection/is-ios-webview":7}],30:[function(_dereq_,module,exports){
'use strict';
/* eslint-disable no-reserved-keys */

var enumerate = _dereq_('../../lib/enumerate');
var errors = _dereq_('./errors');
var VERSION = "3.38.1";

var constants = {
  VERSION: VERSION,
  maxExpirationYearAge: 19,
  externalEvents: {
    FOCUS: 'focus',
    BLUR: 'blur',
    EMPTY: 'empty',
    NOT_EMPTY: 'notEmpty',
    VALIDITY_CHANGE: 'validityChange',
    CARD_TYPE_CHANGE: 'cardTypeChange'
  },
  defaultMaxLengths: {
    number: 19,
    postalCode: 8,
    expirationDate: 7,
    expirationMonth: 2,
    expirationYear: 4,
    cvv: 3
  },
  externalClasses: {
    FOCUSED: 'braintree-hosted-fields-focused',
    INVALID: 'braintree-hosted-fields-invalid',
    VALID: 'braintree-hosted-fields-valid'
  },
  defaultIFrameStyle: {
    border: 'none',
    width: '100%',
    height: '100%',
    'float': 'left'
  },
  tokenizationErrorCodes: {
    81724: errors.HOSTED_FIELDS_TOKENIZATION_FAIL_ON_DUPLICATE,
    81736: errors.HOSTED_FIELDS_TOKENIZATION_CVV_VERIFICATION_FAILED
  },
  allowedStyles: [
    '-moz-appearance',
    '-moz-osx-font-smoothing',
    '-moz-tap-highlight-color',
    '-moz-transition',
    '-webkit-appearance',
    '-webkit-font-smoothing',
    '-webkit-tap-highlight-color',
    '-webkit-transition',
    'appearance',
    'color',
    'direction',
    'font',
    'font-family',
    'font-size',
    'font-size-adjust',
    'font-stretch',
    'font-style',
    'font-variant',
    'font-variant-alternates',
    'font-variant-caps',
    'font-variant-east-asian',
    'font-variant-ligatures',
    'font-variant-numeric',
    'font-weight',
    'letter-spacing',
    'line-height',
    'padding',
    'opacity',
    'outline',
    'text-shadow',
    'transition'
  ],
  allowedFields: {
    number: {
      name: 'credit-card-number',
      label: 'Credit Card Number'
    },
    cvv: {
      name: 'cvv',
      label: 'CVV'
    },
    expirationDate: {
      name: 'expiration',
      label: 'Expiration Date'
    },
    expirationMonth: {
      name: 'expiration-month',
      label: 'Expiration Month'
    },
    expirationYear: {
      name: 'expiration-year',
      label: 'Expiration Year'
    },
    postalCode: {
      name: 'postal-code',
      label: 'Postal Code'
    }
  },
  allowedAttributes: {
    'aria-invalid': 'boolean',
    'aria-required': 'boolean',
    disabled: 'boolean',
    placeholder: 'string'
  },
  autocompleteMappings: {
    'credit-card-number': 'cc-number',
    expiration: 'cc-exp',
    'expiration-month': 'cc-exp-month',
    'expiration-year': 'cc-exp-year',
    cvv: 'cc-csc',
    'postal-code': 'billing postal-code'
  }
};

constants.events = enumerate([
  'FRAME_READY',
  'VALIDATE_STRICT',
  'CONFIGURATION',
  'TOKENIZATION_REQUEST',
  'INPUT_EVENT',
  'TRIGGER_INPUT_FOCUS',
  'ADD_CLASS',
  'REMOVE_CLASS',
  'SET_ATTRIBUTE',
  'REMOVE_ATTRIBUTE',
  'CLEAR_FIELD',
  'AUTOFILL_EXPIRATION_DATE',
  'SET_MESSAGE'
], 'hosted-fields:');

module.exports = constants;

},{"../../lib/enumerate":49,"./errors":31}],31:[function(_dereq_,module,exports){
'use strict';

/**
 * @name BraintreeError.Hosted Fields - Creation Error Codes
 * @description Errors that occur when [creating the Hosted Fields component](/current/module-braintree-web_hosted-fields.html#.create).
 * @property {UNKNOWN} HOSTED_FIELDS_TIMEOUT Occurs when Hosted Fields does not finish setting up within 60 seconds.
 * @property {MERCHANT} HOSTED_FIELDS_INVALID_FIELD_KEY Occurs when Hosted Fields is instantated with an invalid Field option.
 * @property {MERCHANT} HOSTED_FIELDS_INVALID_FIELD_SELECTOR Occurs when Hosted Fields given a field selector that is not valid.
 * @property {MERCHANT} HOSTED_FIELDS_FIELD_DUPLICATE_IFRAME Occurs when Hosted Fields given a field selector that already contains an iframe.
 * @property {MERCHANT} HOSTED_FIELDS_FIELD_PROPERTY_INVALID Occurs when a field configuration option is not valid.
 */

/**
 * @name BraintreeError.Hosted Fields - Field Manipulation Error Codes
 * @description Errors that occur when modifying fields through [`addClass`](/current/HostedFields.html#addClass), [`removeClass`](/current/HostedFields.html#removeClass), [`setAttribute`](/current/HostedFields.html#setAttribute), [`removeAttribute`](/current/HostedFields.html#removeAttribute), [`clear`](/current/HostedFields.html#clear), and [`focus`](/current/HostedFields.html#focus).
 * @property {MERCHANT} HOSTED_FIELDS_FIELD_INVALID Occurs when attempting to modify a field that is not a valid Hosted Fields option.
 * @property {MERCHANT} HOSTED_FIELDS_FIELD_NOT_PRESENT Occurs when attempting to modify a field that is not configured with Hosted Fields.
 */

/**
 * @name BraintreeError.Hosted Fields - Set Attribtue Error Codes
 * @description Errors that occur when using the [`setAttribtue` method](/current/HostedFields.html#setAttribute)
 * @property {MERCHANT} HOSTED_FIELDS_ATTRIBUTE_NOT_SUPPORTED Occurs when trying to set an attribtue that is not supported to be set.
 * @property {MERCHANT} HOSTED_FIELDS_ATTRIBUTE_VALUE_NOT_ALLOWED Occurs when the type of value for an attribue is not allowed to be set.
 */

/**
 * @name BraintreeError.Hosted Fields - Tokenize Error Codes
 * @description Errors that occur when [tokenizing the card details with Hosted Fields](/current/HostedFields.html#tokenize).
 * @property {NETWORK} HOSTED_FIELDS_TOKENIZATION_NETWORK_ERROR Occurs when the Braintree gateway cannot be contacted.
 * @property {CUSTOMER} HOSTED_FIELDS_TOKENIZATION_FAIL_ON_DUPLICATE Occurs when attempting to vault a card, but the client token being used is configured to fail if the card already exists in the vault.
 * @property {CUSTOMER} HOSTED_FIELDS_TOKENIZATION_CVV_VERIFICATION_FAILED Occurs when cvv verification is turned on in the Braintree control panel.
 * @property {CUSTOMER} HOSTED_FIELDS_FAILED_TOKENIZATION Occurs when the credit card details were sent to Braintree, but failed to tokenize.
 * @property {CUSTOMER} HOSTED_FIELDS_FIELDS_EMPTY Occurs when all the Hosted Fields inputs are empty.
 * @property {CUSTOMER} HOSTED_FIELDS_FIELDS_INVALID Occurs when one ore more fields are invalid.
 */

var BraintreeError = _dereq_('../../lib/braintree-error');

module.exports = {
  HOSTED_FIELDS_TIMEOUT: {
    type: BraintreeError.types.UNKNOWN,
    code: 'HOSTED_FIELDS_TIMEOUT',
    message: 'Hosted Fields timed out when attempting to set up.'
  },
  HOSTED_FIELDS_INVALID_FIELD_KEY: {
    type: BraintreeError.types.MERCHANT,
    code: 'HOSTED_FIELDS_INVALID_FIELD_KEY'
  },
  HOSTED_FIELDS_INVALID_FIELD_SELECTOR: {
    type: BraintreeError.types.MERCHANT,
    code: 'HOSTED_FIELDS_INVALID_FIELD_SELECTOR',
    message: 'Selector does not reference a valid DOM node.'
  },
  HOSTED_FIELDS_FIELD_DUPLICATE_IFRAME: {
    type: BraintreeError.types.MERCHANT,
    code: 'HOSTED_FIELDS_FIELD_DUPLICATE_IFRAME',
    message: 'Element already contains a Braintree iframe.'
  },
  HOSTED_FIELDS_FIELD_INVALID: {
    type: BraintreeError.types.MERCHANT,
    code: 'HOSTED_FIELDS_FIELD_INVALID'
  },
  HOSTED_FIELDS_FIELD_NOT_PRESENT: {
    type: BraintreeError.types.MERCHANT,
    code: 'HOSTED_FIELDS_FIELD_NOT_PRESENT'
  },
  HOSTED_FIELDS_TOKENIZATION_NETWORK_ERROR: {
    type: BraintreeError.types.NETWORK,
    code: 'HOSTED_FIELDS_TOKENIZATION_NETWORK_ERROR',
    message: 'A tokenization network error occurred.'
  },
  HOSTED_FIELDS_TOKENIZATION_FAIL_ON_DUPLICATE: {
    type: BraintreeError.types.CUSTOMER,
    code: 'HOSTED_FIELDS_TOKENIZATION_FAIL_ON_DUPLICATE',
    message: 'This credit card already exists in the merchant\'s vault.'
  },
  HOSTED_FIELDS_TOKENIZATION_CVV_VERIFICATION_FAILED: {
    type: BraintreeError.types.CUSTOMER,
    code: 'HOSTED_FIELDS_TOKENIZATION_CVV_VERIFICATION_FAILED',
    message: 'CVV verification failed during tokenization.'
  },
  HOSTED_FIELDS_FAILED_TOKENIZATION: {
    type: BraintreeError.types.CUSTOMER,
    code: 'HOSTED_FIELDS_FAILED_TOKENIZATION',
    message: 'The supplied card data failed tokenization.'
  },
  HOSTED_FIELDS_FIELDS_EMPTY: {
    type: BraintreeError.types.CUSTOMER,
    code: 'HOSTED_FIELDS_FIELDS_EMPTY',
    message: 'All fields are empty. Cannot tokenize empty card fields.'
  },
  HOSTED_FIELDS_FIELDS_INVALID: {
    type: BraintreeError.types.CUSTOMER,
    code: 'HOSTED_FIELDS_FIELDS_INVALID',
    message: 'Some payment input fields are invalid. Cannot tokenize invalid card fields.'
  },
  HOSTED_FIELDS_ATTRIBUTE_NOT_SUPPORTED: {
    type: BraintreeError.types.MERCHANT,
    code: 'HOSTED_FIELDS_ATTRIBUTE_NOT_SUPPORTED'
  },
  HOSTED_FIELDS_ATTRIBUTE_VALUE_NOT_ALLOWED: {
    type: BraintreeError.types.MERCHANT,
    code: 'HOSTED_FIELDS_ATTRIBUTE_VALUE_NOT_ALLOWED'
  },
  HOSTED_FIELDS_FIELD_PROPERTY_INVALID: {
    type: BraintreeError.types.MERCHANT,
    code: 'HOSTED_FIELDS_FIELD_PROPERTY_INVALID'
  }
};

},{"../../lib/braintree-error":40}],32:[function(_dereq_,module,exports){
'use strict';

function findParentTags(element, tag) {
  var parent = element.parentNode;
  var parents = [];

  while (parent != null) {
    if (parent.tagName != null && parent.tagName.toLowerCase() === tag) {
      parents.push(parent);
    }

    parent = parent.parentNode;
  }

  return parents;
}

module.exports = findParentTags;

},{}],33:[function(_dereq_,module,exports){
'use strict';

var creditCardType = _dereq_('credit-card-type');

module.exports = function (number) {
  var results = creditCardType(number);

  results.forEach(function (card) {
    // NEXT_MAJOR_VERSION credit-card-type fixed the mastercard enum
    // but we still pass master-card in the braintree API
    // in a major version bump, we can remove this and
    // this will be mastercard instead of master-card
    if (card.type === 'mastercard') {
      card.type = 'master-card';
    }
  });

  return results;
};

},{"credit-card-type":18}],34:[function(_dereq_,module,exports){
'use strict';

var createAuthorizationData = _dereq_('./create-authorization-data');
var jsonClone = _dereq_('./json-clone');
var constants = _dereq_('./constants');

function addMetadata(configuration, data) {
  var key;
  var attrs = data ? jsonClone(data) : {};
  var authAttrs = createAuthorizationData(configuration.authorization).attrs;
  var _meta = jsonClone(configuration.analyticsMetadata);

  attrs.braintreeLibraryVersion = constants.BRAINTREE_LIBRARY_VERSION;

  for (key in attrs._meta) {
    if (attrs._meta.hasOwnProperty(key)) {
      _meta[key] = attrs._meta[key];
    }
  }

  attrs._meta = _meta;

  if (authAttrs.tokenizationKey) {
    attrs.tokenizationKey = authAttrs.tokenizationKey;
  } else {
    attrs.authorizationFingerprint = authAttrs.authorizationFingerprint;
  }

  return attrs;
}

module.exports = addMetadata;

},{"./constants":45,"./create-authorization-data":47,"./json-clone":53}],35:[function(_dereq_,module,exports){
'use strict';

var Promise = _dereq_('./promise');
var constants = _dereq_('./constants');
var addMetadata = _dereq_('./add-metadata');

function _millisToSeconds(millis) {
  return Math.floor(millis / 1000);
}

function sendAnalyticsEvent(clientInstanceOrPromise, kind, callback) {
  var timestamp = _millisToSeconds(Date.now());

  return Promise.resolve(clientInstanceOrPromise).then(function (client) {
    var timestampInPromise = _millisToSeconds(Date.now());
    var configuration = client.getConfiguration();
    var request = client._request;
    var url = configuration.gatewayConfiguration.analytics.url;
    var data = {
      analytics: [{
        kind: constants.ANALYTICS_PREFIX + kind,
        isAsync: timestampInPromise !== timestamp,
        timestamp: timestamp
      }]
    };

    request({
      url: url,
      method: 'post',
      data: addMetadata(configuration, data),
      timeout: constants.ANALYTICS_REQUEST_TIMEOUT_MS
    }, callback);
  });
}

module.exports = {
  sendEvent: sendAnalyticsEvent
};

},{"./add-metadata":34,"./constants":45,"./promise":56}],36:[function(_dereq_,module,exports){
'use strict';

// TODO this logic is duplicated in braintree-web-drop-in
// Pull this out into a separate module

var Promise = _dereq_('./promise');

function loadScript(options) {
  var script = document.createElement('script');
  var attrs = options.dataAttributes || {};
  var container = options.container || document.head;

  script.src = options.src;
  script.id = options.id;
  script.async = true;

  Object.keys(attrs).forEach(function (key) {
    script.setAttribute('data-' + key, attrs[key]);
  });

  return new Promise(function (resolve, reject) {
    script.addEventListener('load', resolve);
    script.addEventListener('error', function () {
      reject(new Error(options.src + ' failed to load.'));
    });
    script.addEventListener('abort', function () {
      reject(new Error(options.src + ' has aborted.'));
    });
    container.appendChild(script);
  });
}

module.exports = {
  loadScript: loadScript
};

},{"./promise":56}],37:[function(_dereq_,module,exports){
'use strict';

var assignNormalized = typeof Object.assign === 'function' ? Object.assign : assignPolyfill;

function assignPolyfill(destination) {
  var i, source, key;

  for (i = 1; i < arguments.length; i++) {
    source = arguments[i];
    for (key in source) {
      if (source.hasOwnProperty(key)) {
        destination[key] = source[key];
      }
    }
  }

  return destination;
}

module.exports = {
  assign: assignNormalized,
  _assign: assignPolyfill
};

},{}],38:[function(_dereq_,module,exports){
'use strict';

var BraintreeError = _dereq_('./braintree-error');
var Promise = _dereq_('./promise');
var sharedErrors = _dereq_('./errors');
var VERSION = "3.38.1";

function basicComponentVerification(options) {
  var client, authorization, name;

  if (!options) {
    return Promise.reject(new BraintreeError({
      type: sharedErrors.INVALID_USE_OF_INTERNAL_FUNCTION.type,
      code: sharedErrors.INVALID_USE_OF_INTERNAL_FUNCTION.code,
      message: 'Options must be passed to basicComponentVerification function.'
    }));
  }

  name = options.name;
  client = options.client;
  authorization = options.authorization;

  if (client == null && authorization == null) {
    return Promise.reject(new BraintreeError({
      type: sharedErrors.INSTANTIATION_OPTION_REQUIRED.type,
      code: sharedErrors.INSTANTIATION_OPTION_REQUIRED.code,
      // NEXT_MAJOR_VERSION in major version, we expose passing in authorization for all components
      // instead of passing in a client instance. Leave this a silent feature for now.
      message: 'options.client is required when instantiating ' + name + '.'
    }));
  }

  if (!authorization && client.getVersion() !== VERSION) {
    return Promise.reject(new BraintreeError({
      type: sharedErrors.INCOMPATIBLE_VERSIONS.type,
      code: sharedErrors.INCOMPATIBLE_VERSIONS.code,
      message: 'Client (version ' + client.getVersion() + ') and ' + name + ' (version ' + VERSION + ') components must be from the same SDK version.'
    }));
  }

  return Promise.resolve();
}

module.exports = {
  verify: basicComponentVerification
};

},{"./braintree-error":40,"./errors":50,"./promise":56}],39:[function(_dereq_,module,exports){
'use strict';

var once = _dereq_('./once');

function call(fn, callback) {
  var isSync = fn.length === 0;

  if (isSync) {
    fn();
    callback(null);
  } else {
    fn(callback);
  }
}

module.exports = function (functions, cb) {
  var i;
  var length = functions.length;
  var remaining = length;
  var callback = once(cb);

  if (length === 0) {
    callback(null);

    return;
  }

  function finish(err) {
    if (err) {
      callback(err);

      return;
    }

    remaining -= 1;
    if (remaining === 0) {
      callback(null);
    }
  }

  for (i = 0; i < length; i++) {
    call(functions[i], finish);
  }
};

},{"./once":55}],40:[function(_dereq_,module,exports){
'use strict';

var enumerate = _dereq_('./enumerate');

/**
 * @class
 * @global
 * @param {object} options Construction options
 * @classdesc This class is used to report error conditions, frequently as the first parameter to callbacks throughout the Braintree SDK.
 * @description <strong>You cannot use this constructor directly. Interact with instances of this class through {@link callback callbacks}.</strong>
 */
function BraintreeError(options) {
  if (!BraintreeError.types.hasOwnProperty(options.type)) {
    throw new Error(options.type + ' is not a valid type.');
  }

  if (!options.code) {
    throw new Error('Error code required.');
  }

  if (!options.message) {
    throw new Error('Error message required.');
  }

  this.name = 'BraintreeError';

  /**
   * @type {string}
   * @description A code that corresponds to specific errors.
   */
  this.code = options.code;

  /**
   * @type {string}
   * @description A short description of the error.
   */
  this.message = options.message;

  /**
   * @type {BraintreeError.types}
   * @description The type of error.
   */
  this.type = options.type;

  /**
   * @type {object=}
   * @description Additional information about the error, such as an underlying network error response.
   */
  this.details = options.details;
}

BraintreeError.prototype = Object.create(Error.prototype);
BraintreeError.prototype.constructor = BraintreeError;

/**
 * Enum for {@link BraintreeError} types.
 * @name BraintreeError.types
 * @enum
 * @readonly
 * @memberof BraintreeError
 * @property {string} CUSTOMER An error caused by the customer.
 * @property {string} MERCHANT An error that is actionable by the merchant.
 * @property {string} NETWORK An error due to a network problem.
 * @property {string} INTERNAL An error caused by Braintree code.
 * @property {string} UNKNOWN An error where the origin is unknown.
 */
BraintreeError.types = enumerate([
  'CUSTOMER',
  'MERCHANT',
  'NETWORK',
  'INTERNAL',
  'UNKNOWN'
]);

BraintreeError.findRootError = function (err) {
  if (err instanceof BraintreeError && err.details && err.details.originalError) {
    return BraintreeError.findRootError(err.details.originalError);
  }

  return err;
};

module.exports = BraintreeError;

},{"./enumerate":49}],41:[function(_dereq_,module,exports){
'use strict';

var isVerifiedDomain = _dereq_('../is-verified-domain');

function checkOrigin(postMessageOrigin, merchantUrl) {
  var merchantOrigin, merchantHost;
  var a = document.createElement('a');

  a.href = merchantUrl;

  if (a.protocol === 'https:') {
    merchantHost = a.host.replace(/:443$/, '');
  } else if (a.protocol === 'http:') {
    merchantHost = a.host.replace(/:80$/, '');
  } else {
    merchantHost = a.host;
  }

  merchantOrigin = a.protocol + '//' + merchantHost;

  if (merchantOrigin === postMessageOrigin) { return true; }

  a.href = postMessageOrigin;

  return isVerifiedDomain(postMessageOrigin);
}

module.exports = {
  checkOrigin: checkOrigin
};

},{"../is-verified-domain":52}],42:[function(_dereq_,module,exports){
'use strict';

var enumerate = _dereq_('../enumerate');

module.exports = enumerate([
  'CONFIGURATION_REQUEST'
], 'bus:');

},{"../enumerate":49}],43:[function(_dereq_,module,exports){
'use strict';

var bus = _dereq_('framebus');
var events = _dereq_('./events');
var checkOrigin = _dereq_('./check-origin').checkOrigin;
var BraintreeError = _dereq_('../braintree-error');

function BraintreeBus(options) {
  options = options || {};

  this.channel = options.channel;
  if (!this.channel) {
    throw new BraintreeError({
      type: BraintreeError.types.INTERNAL,
      code: 'MISSING_CHANNEL_ID',
      message: 'Channel ID must be specified.'
    });
  }

  this.merchantUrl = options.merchantUrl;

  this._isDestroyed = false;
  this._isVerbose = false;

  this._listeners = [];

  this._log('new bus on channel ' + this.channel, [location.href]);
}

BraintreeBus.prototype.on = function (eventName, originalHandler) {
  var namespacedEvent, args;
  var handler = originalHandler;
  var self = this;

  if (this._isDestroyed) { return; }

  if (this.merchantUrl) {
    handler = function () {
      /* eslint-disable no-invalid-this */
      if (checkOrigin(this.origin, self.merchantUrl)) {
        originalHandler.apply(this, arguments);
      }
      /* eslint-enable no-invalid-this */
    };
  }

  namespacedEvent = this._namespaceEvent(eventName);
  args = Array.prototype.slice.call(arguments);
  args[0] = namespacedEvent;
  args[1] = handler;

  this._log('on', args);
  bus.on.apply(bus, args);

  this._listeners.push({
    eventName: eventName,
    handler: handler,
    originalHandler: originalHandler
  });
};

BraintreeBus.prototype.emit = function (eventName) {
  var args;

  if (this._isDestroyed) { return; }

  args = Array.prototype.slice.call(arguments);
  args[0] = this._namespaceEvent(eventName);

  this._log('emit', args);
  bus.emit.apply(bus, args);
};

BraintreeBus.prototype._offDirect = function (eventName) {
  var args = Array.prototype.slice.call(arguments);

  if (this._isDestroyed) { return; }

  args[0] = this._namespaceEvent(eventName);

  this._log('off', args);
  bus.off.apply(bus, args);
};

BraintreeBus.prototype.off = function (eventName, originalHandler) {
  var i, listener;
  var handler = originalHandler;

  if (this._isDestroyed) { return; }

  if (this.merchantUrl) {
    for (i = 0; i < this._listeners.length; i++) {
      listener = this._listeners[i];

      if (listener.originalHandler === originalHandler) {
        handler = listener.handler;
      }
    }
  }

  this._offDirect(eventName, handler);
};

BraintreeBus.prototype._namespaceEvent = function (eventName) {
  return ['braintree', this.channel, eventName].join(':');
};

BraintreeBus.prototype.teardown = function () {
  var listener, i;

  for (i = 0; i < this._listeners.length; i++) {
    listener = this._listeners[i];
    this._offDirect(listener.eventName, listener.handler);
  }

  this._listeners.length = 0;

  this._isDestroyed = true;
};

BraintreeBus.prototype._log = function (functionName, args) {
  if (this._isVerbose) {
    console.log(functionName, args); // eslint-disable-line no-console
  }
};

BraintreeBus.events = events;

module.exports = BraintreeBus;

},{"../braintree-error":40,"./check-origin":41,"./events":42,"framebus":19}],44:[function(_dereq_,module,exports){
'use strict';

function _classesOf(element) {
  return element.className.trim().split(/\s+/);
}

function add(element) {
  var toAdd = Array.prototype.slice.call(arguments, 1);
  var className = _classesOf(element).filter(function (classname) {
    return toAdd.indexOf(classname) === -1;
  }).concat(toAdd).join(' ');

  element.className = className;
}

function remove(element) {
  var toRemove = Array.prototype.slice.call(arguments, 1);
  var className = _classesOf(element).filter(function (classname) {
    return toRemove.indexOf(classname) === -1;
  }).join(' ');

  element.className = className;
}

function toggle(element, classname, adding) {
  if (adding) {
    add(element, classname);
  } else {
    remove(element, classname);
  }
}

module.exports = {
  add: add,
  remove: remove,
  toggle: toggle
};

},{}],45:[function(_dereq_,module,exports){
'use strict';

var VERSION = "3.38.1";
var PLATFORM = 'web';

var CLIENT_API_URLS = {
  production: 'https://api.braintreegateway.com:443',
  sandbox: 'https://api.sandbox.braintreegateway.com:443'
};

var ASSETS_URLS = {
  production: 'https://assets.braintreegateway.com',
  sandbox: 'https://assets.braintreegateway.com'
};

var GRAPHQL_URLS = {
  production: 'https://payments.braintree-api.com/graphql',
  sandbox: 'https://payments.sandbox.braintree-api.com/graphql'
};

// endRemoveIf(production)

module.exports = {
  ANALYTICS_PREFIX: PLATFORM + '.',
  ANALYTICS_REQUEST_TIMEOUT_MS: 2000,
  ASSETS_URLS: ASSETS_URLS,
  CLIENT_API_URLS: CLIENT_API_URLS,
  GRAPHQL_URLS: GRAPHQL_URLS,
  INTEGRATION_TIMEOUT_MS: 60000,
  VERSION: VERSION,
  INTEGRATION: 'custom',
  SOURCE: 'client',
  PLATFORM: PLATFORM,
  BRAINTREE_LIBRARY_VERSION: 'braintree/' + PLATFORM + '/' + VERSION
};

},{}],46:[function(_dereq_,module,exports){
'use strict';

var BraintreeError = _dereq_('./braintree-error');
var sharedErrors = _dereq_('./errors');

module.exports = function (instance, methodNames) {
  methodNames.forEach(function (methodName) {
    instance[methodName] = function () {
      throw new BraintreeError({
        type: sharedErrors.METHOD_CALLED_AFTER_TEARDOWN.type,
        code: sharedErrors.METHOD_CALLED_AFTER_TEARDOWN.code,
        message: methodName + ' cannot be called after teardown.'
      });
    };
  });
};

},{"./braintree-error":40,"./errors":50}],47:[function(_dereq_,module,exports){
'use strict';

var atob = _dereq_('../lib/vendor/polyfill').atob;
var CLIENT_API_URLS = _dereq_('../lib/constants').CLIENT_API_URLS;

function _isTokenizationKey(str) {
  return /^[a-zA-Z0-9]+_[a-zA-Z0-9]+_[a-zA-Z0-9_]+$/.test(str);
}

function _parseTokenizationKey(tokenizationKey) {
  var tokens = tokenizationKey.split('_');
  var environment = tokens[0];
  var merchantId = tokens.slice(2).join('_');

  return {
    merchantId: merchantId,
    environment: environment
  };
}

function createAuthorizationData(authorization) {
  var parsedClientToken, parsedTokenizationKey;
  var data = {
    attrs: {},
    configUrl: ''
  };

  if (_isTokenizationKey(authorization)) {
    parsedTokenizationKey = _parseTokenizationKey(authorization);
    data.environment = parsedTokenizationKey.environment;
    data.attrs.tokenizationKey = authorization;
    data.configUrl = CLIENT_API_URLS[parsedTokenizationKey.environment] + '/merchants/' + parsedTokenizationKey.merchantId + '/client_api/v1/configuration';
  } else {
    parsedClientToken = JSON.parse(atob(authorization));
    data.environment = parsedClientToken.environment;
    data.attrs.authorizationFingerprint = parsedClientToken.authorizationFingerprint;
    data.configUrl = parsedClientToken.configUrl;
    data.graphQL = parsedClientToken.graphQL;
  }

  return data;
}

module.exports = createAuthorizationData;

},{"../lib/constants":45,"../lib/vendor/polyfill":58}],48:[function(_dereq_,module,exports){
'use strict';

var batchExecuteFunctions = _dereq_('./batch-execute-functions');

function Destructor() {
  this._teardownRegistry = [];

  this._isTearingDown = false;
}

Destructor.prototype.registerFunctionForTeardown = function (fn) {
  if (typeof fn === 'function') {
    this._teardownRegistry.push(fn);
  }
};

Destructor.prototype.teardown = function (callback) {
  if (this._isTearingDown) {
    callback(new Error('Destructor is already tearing down'));

    return;
  }

  this._isTearingDown = true;

  batchExecuteFunctions(this._teardownRegistry, function (err) {
    this._teardownRegistry = [];
    this._isTearingDown = false;

    if (typeof callback === 'function') {
      callback(err);
    }
  }.bind(this));
};

module.exports = Destructor;

},{"./batch-execute-functions":39}],49:[function(_dereq_,module,exports){
'use strict';

function enumerate(values, prefix) {
  prefix = prefix == null ? '' : prefix;

  return values.reduce(function (enumeration, value) {
    enumeration[value] = prefix + value;

    return enumeration;
  }, {});
}

module.exports = enumerate;

},{}],50:[function(_dereq_,module,exports){
'use strict';

/**
 * @name BraintreeError.Shared Interal Error Codes
 * @ignore
 * @description These codes should never be experienced by the mechant directly.
 * @property {INTERNAL} INVALID_USE_OF_INTERNAL_FUNCTION Occurs when the client is created without a gateway configuration. Should never happen.
 */

/**
 * @name BraintreeError.Shared Errors - Component Creation Error Codes
 * @description Errors that occur when creating components.
 * @property {MERCHANT} INSTANTIATION_OPTION_REQUIRED Occurs when a compoennt is created that is missing a required option.
 * @property {MERCHANT} INCOMPATIBLE_VERSIONS Occurs when a component is created with a client with a different version than the component.
 */

/**
 * @name BraintreeError.Shared Errors - Component Instance Error Codes
 * @description Errors that occur when using instances of components.
 * @property {MERCHANT} METHOD_CALLED_AFTER_TEARDOWN Occurs when a method is called on a component instance after it has been torn down.
 * @property {MERCHANT} BRAINTREE_API_ACCESS_RESTRICTED Occurs when the client token or tokenization key does not have the correct permissions.
 */

var BraintreeError = _dereq_('./braintree-error');

module.exports = {
  INVALID_USE_OF_INTERNAL_FUNCTION: {
    type: BraintreeError.types.INTERNAL,
    code: 'INVALID_USE_OF_INTERNAL_FUNCTION'
  },
  INSTANTIATION_OPTION_REQUIRED: {
    type: BraintreeError.types.MERCHANT,
    code: 'INSTANTIATION_OPTION_REQUIRED'
  },
  INCOMPATIBLE_VERSIONS: {
    type: BraintreeError.types.MERCHANT,
    code: 'INCOMPATIBLE_VERSIONS'
  },
  METHOD_CALLED_AFTER_TEARDOWN: {
    type: BraintreeError.types.MERCHANT,
    code: 'METHOD_CALLED_AFTER_TEARDOWN'
  },
  BRAINTREE_API_ACCESS_RESTRICTED: {
    type: BraintreeError.types.MERCHANT,
    code: 'BRAINTREE_API_ACCESS_RESTRICTED',
    message: 'Your access is restricted and cannot use this part of the Braintree API.'
  }
};

},{"./braintree-error":40}],51:[function(_dereq_,module,exports){
'use strict';

function EventEmitter() {
  this._events = {};
}

EventEmitter.prototype.on = function (event, callback) {
  if (this._events[event]) {
    this._events[event].push(callback);
  } else {
    this._events[event] = [callback];
  }
};

EventEmitter.prototype._emit = function (event) {
  var i, args;
  var callbacks = this._events[event];

  if (!callbacks) { return; }

  args = Array.prototype.slice.call(arguments, 1);

  for (i = 0; i < callbacks.length; i++) {
    callbacks[i].apply(null, args);
  }
};

module.exports = EventEmitter;

},{}],52:[function(_dereq_,module,exports){
'use strict';

var parser;
var legalHosts = {
  'paypal.com': 1,
  'braintreepayments.com': 1,
  'braintreegateway.com': 1,
  'braintree-api.com': 1
};

// endRemoveIf(production)

function stripSubdomains(domain) {
  return domain.split('.').slice(-2).join('.');
}

function isVerifiedDomain(url) {
  var mainDomain;

  url = url.toLowerCase();

  if (!/^https:/.test(url)) {
    return false;
  }

  parser = parser || document.createElement('a');
  parser.href = url;
  mainDomain = stripSubdomains(parser.hostname);

  return legalHosts.hasOwnProperty(mainDomain);
}

module.exports = isVerifiedDomain;

},{}],53:[function(_dereq_,module,exports){
'use strict';

module.exports = function (value) {
  return JSON.parse(JSON.stringify(value));
};

},{}],54:[function(_dereq_,module,exports){
'use strict';

module.exports = function (obj) {
  return Object.keys(obj).filter(function (key) {
    return typeof obj[key] === 'function';
  });
};

},{}],55:[function(_dereq_,module,exports){
arguments[4][15][0].apply(exports,arguments)
},{"dup":15}],56:[function(_dereq_,module,exports){
(function (global){
'use strict';

var Promise = global.Promise || _dereq_('promise-polyfill');

module.exports = Promise;

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"promise-polyfill":20}],57:[function(_dereq_,module,exports){
'use strict';

function useMin(isDebug) {
  return isDebug ? '' : '.min';
}

module.exports = useMin;

},{}],58:[function(_dereq_,module,exports){
(function (global){
'use strict';

var atobNormalized = typeof global.atob === 'function' ? global.atob : atob;

function atob(base64String) {
  var a, b, c, b1, b2, b3, b4, i;
  var base64Matcher = new RegExp('^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{4})([=]{1,2})?$');
  var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
  var result = '';

  if (!base64Matcher.test(base64String)) {
    throw new Error('Non base64 encoded input passed to window.atob polyfill');
  }

  i = 0;
  do {
    b1 = characters.indexOf(base64String.charAt(i++));
    b2 = characters.indexOf(base64String.charAt(i++));
    b3 = characters.indexOf(base64String.charAt(i++));
    b4 = characters.indexOf(base64String.charAt(i++));

    a = (b1 & 0x3F) << 2 | b2 >> 4 & 0x3;
    b = (b2 & 0xF) << 4 | b3 >> 2 & 0xF;
    c = (b3 & 0x3) << 6 | b4 & 0x3F;

    result += String.fromCharCode(a) + (b ? String.fromCharCode(b) : '') + (c ? String.fromCharCode(c) : '');
  } while (i < base64String.length);

  return result;
}

module.exports = {
  atob: function (base64String) {
    return atobNormalized.call(global, base64String);
  },
  _atob: atob
};

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],59:[function(_dereq_,module,exports){
'use strict';

function uuid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0;
    var v = c === 'x' ? r : r & 0x3 | 0x8;

    return v.toString(16);
  });
}

module.exports = uuid;

},{}]},{},[28])(28)
});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49), __webpack_require__(449).setImmediate))

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49), __webpack_require__(448)))

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, setImmediate) {var require;var require;(function(f){if(true){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}(g.braintree || (g.braintree = {})).client = f()}})(function(){var define,module,exports;return (function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return require(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(_dereq_,module,exports){
(function (global){
'use strict';

var isIE11 = _dereq_('./is-ie11');

module.exports = function isIE(ua) {
  ua = ua || global.navigator.userAgent;
  return ua.indexOf('MSIE') !== -1 || isIE11(ua);
};

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"./is-ie11":2}],2:[function(_dereq_,module,exports){
'use strict';

module.exports = function isIe11(ua) {
  ua = ua || navigator.userAgent;
  return ua.indexOf('Trident/7') !== -1;
};

},{}],3:[function(_dereq_,module,exports){
'use strict';

module.exports = function isIe9(ua) {
  ua = ua || navigator.userAgent;
  return ua.indexOf('MSIE 9') !== -1;
};

},{}],4:[function(_dereq_,module,exports){
'use strict';

function deferred(fn) {
  return function () {
    // IE9 doesn't support passing arguments to setTimeout so we have to emulate it.
    var args = arguments;

    setTimeout(function () {
      fn.apply(null, args);
    }, 1);
  };
}

module.exports = deferred;

},{}],5:[function(_dereq_,module,exports){
'use strict';

function once(fn) {
  var called = false;

  return function () {
    if (!called) {
      called = true;
      fn.apply(null, arguments);
    }
  };
}

module.exports = once;

},{}],6:[function(_dereq_,module,exports){
'use strict';

function promiseOrCallback(promise, callback) { // eslint-disable-line consistent-return
  if (callback) {
    promise
      .then(function (data) {
        callback(null, data);
      })
      .catch(function (err) {
        callback(err);
      });
  } else {
    return promise;
  }
}

module.exports = promiseOrCallback;

},{}],7:[function(_dereq_,module,exports){
'use strict';

var deferred = _dereq_('./lib/deferred');
var once = _dereq_('./lib/once');
var promiseOrCallback = _dereq_('./lib/promise-or-callback');

function wrapPromise(fn) {
  return function () {
    var callback;
    var args = Array.prototype.slice.call(arguments);
    var lastArg = args[args.length - 1];

    if (typeof lastArg === 'function') {
      callback = args.pop();
      callback = once(deferred(callback));
    }
    return promiseOrCallback(fn.apply(this, args), callback); // eslint-disable-line no-invalid-this
  };
}

wrapPromise.wrapPrototype = function (target, options) {
  var methods, ignoreMethods, includePrivateMethods;

  options = options || {};
  ignoreMethods = options.ignoreMethods || [];
  includePrivateMethods = options.transformPrivateMethods === true;

  methods = Object.getOwnPropertyNames(target.prototype).filter(function (method) {
    var isNotPrivateMethod;
    var isNonConstructorFunction = method !== 'constructor' &&
      typeof target.prototype[method] === 'function';
    var isNotAnIgnoredMethod = ignoreMethods.indexOf(method) === -1;

    if (includePrivateMethods) {
      isNotPrivateMethod = true;
    } else {
      isNotPrivateMethod = method.charAt(0) !== '_';
    }

    return isNonConstructorFunction &&
      isNotPrivateMethod &&
      isNotAnIgnoredMethod;
  });

  methods.forEach(function (method) {
    var original = target.prototype[method];

    target.prototype[method] = wrapPromise(original);
  });

  return target;
};

module.exports = wrapPromise;

},{"./lib/deferred":4,"./lib/once":5,"./lib/promise-or-callback":6}],8:[function(_dereq_,module,exports){
'use strict';

var promiseFinally = function(callback) {
  var constructor = this.constructor;
  return this.then(
    function(value) {
      return constructor.resolve(callback()).then(function() {
        return value;
      });
    },
    function(reason) {
      return constructor.resolve(callback()).then(function() {
        return constructor.reject(reason);
      });
    }
  );
};

// Store setTimeout reference so promise-polyfill will be unaffected by
// other code modifying setTimeout (like sinon.useFakeTimers())
var setTimeoutFunc = setTimeout;

function noop() {}

// Polyfill for Function.prototype.bind
function bind(fn, thisArg) {
  return function() {
    fn.apply(thisArg, arguments);
  };
}

function Promise(fn) {
  if (!(this instanceof Promise))
    throw new TypeError('Promises must be constructed via new');
  if (typeof fn !== 'function') throw new TypeError('not a function');
  this._state = 0;
  this._handled = false;
  this._value = undefined;
  this._deferreds = [];

  doResolve(fn, this);
}

function handle(self, deferred) {
  while (self._state === 3) {
    self = self._value;
  }
  if (self._state === 0) {
    self._deferreds.push(deferred);
    return;
  }
  self._handled = true;
  Promise._immediateFn(function() {
    var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      (self._state === 1 ? resolve : reject)(deferred.promise, self._value);
      return;
    }
    var ret;
    try {
      ret = cb(self._value);
    } catch (e) {
      reject(deferred.promise, e);
      return;
    }
    resolve(deferred.promise, ret);
  });
}

function resolve(self, newValue) {
  try {
    // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
    if (newValue === self)
      throw new TypeError('A promise cannot be resolved with itself.');
    if (
      newValue &&
      (typeof newValue === 'object' || typeof newValue === 'function')
    ) {
      var then = newValue.then;
      if (newValue instanceof Promise) {
        self._state = 3;
        self._value = newValue;
        finale(self);
        return;
      } else if (typeof then === 'function') {
        doResolve(bind(then, newValue), self);
        return;
      }
    }
    self._state = 1;
    self._value = newValue;
    finale(self);
  } catch (e) {
    reject(self, e);
  }
}

function reject(self, newValue) {
  self._state = 2;
  self._value = newValue;
  finale(self);
}

function finale(self) {
  if (self._state === 2 && self._deferreds.length === 0) {
    Promise._immediateFn(function() {
      if (!self._handled) {
        Promise._unhandledRejectionFn(self._value);
      }
    });
  }

  for (var i = 0, len = self._deferreds.length; i < len; i++) {
    handle(self, self._deferreds[i]);
  }
  self._deferreds = null;
}

function Handler(onFulfilled, onRejected, promise) {
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, self) {
  var done = false;
  try {
    fn(
      function(value) {
        if (done) return;
        done = true;
        resolve(self, value);
      },
      function(reason) {
        if (done) return;
        done = true;
        reject(self, reason);
      }
    );
  } catch (ex) {
    if (done) return;
    done = true;
    reject(self, ex);
  }
}

Promise.prototype['catch'] = function(onRejected) {
  return this.then(null, onRejected);
};

Promise.prototype.then = function(onFulfilled, onRejected) {
  var prom = new this.constructor(noop);

  handle(this, new Handler(onFulfilled, onRejected, prom));
  return prom;
};

Promise.prototype['finally'] = promiseFinally;

Promise.all = function(arr) {
  return new Promise(function(resolve, reject) {
    if (!arr || typeof arr.length === 'undefined')
      throw new TypeError('Promise.all accepts an array');
    var args = Array.prototype.slice.call(arr);
    if (args.length === 0) return resolve([]);
    var remaining = args.length;

    function res(i, val) {
      try {
        if (val && (typeof val === 'object' || typeof val === 'function')) {
          var then = val.then;
          if (typeof then === 'function') {
            then.call(
              val,
              function(val) {
                res(i, val);
              },
              reject
            );
            return;
          }
        }
        args[i] = val;
        if (--remaining === 0) {
          resolve(args);
        }
      } catch (ex) {
        reject(ex);
      }
    }

    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.resolve = function(value) {
  if (value && typeof value === 'object' && value.constructor === Promise) {
    return value;
  }

  return new Promise(function(resolve) {
    resolve(value);
  });
};

Promise.reject = function(value) {
  return new Promise(function(resolve, reject) {
    reject(value);
  });
};

Promise.race = function(values) {
  return new Promise(function(resolve, reject) {
    for (var i = 0, len = values.length; i < len; i++) {
      values[i].then(resolve, reject);
    }
  });
};

// Use polyfill for setImmediate for performance gains
Promise._immediateFn =
  (typeof setImmediate === 'function' &&
    function(fn) {
      setImmediate(fn);
    }) ||
  function(fn) {
    setTimeoutFunc(fn, 0);
  };

Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
  if (typeof console !== 'undefined' && console) {
    console.warn('Possible Unhandled Promise Rejection:', err); // eslint-disable-line no-console
  }
};

module.exports = Promise;

},{}],9:[function(_dereq_,module,exports){
'use strict';

var isIe = _dereq_('@braintree/browser-detection/is-ie');
var isIe9 = _dereq_('@braintree/browser-detection/is-ie9');

module.exports = {
  isIe: isIe,
  isIe9: isIe9
};

},{"@braintree/browser-detection/is-ie":1,"@braintree/browser-detection/is-ie9":3}],10:[function(_dereq_,module,exports){
'use strict';

var BRAINTREE_VERSION = _dereq_('./constants').BRAINTREE_VERSION;

var GraphQL = _dereq_('./request/graphql');
var request = _dereq_('./request');
var isVerifiedDomain = _dereq_('../lib/is-verified-domain');
var BraintreeError = _dereq_('../lib/braintree-error');
var convertToBraintreeError = _dereq_('../lib/convert-to-braintree-error');
var createAuthorizationData = _dereq_('../lib/create-authorization-data');
var getGatewayConfiguration = _dereq_('./get-configuration').getConfiguration;
var addMetadata = _dereq_('../lib/add-metadata');
var Promise = _dereq_('../lib/promise');
var wrapPromise = _dereq_('@braintree/wrap-promise');
var once = _dereq_('../lib/once');
var deferred = _dereq_('../lib/deferred');
var assign = _dereq_('../lib/assign').assign;
var analytics = _dereq_('../lib/analytics');
var constants = _dereq_('./constants');
var errors = _dereq_('./errors');
var sharedErrors = _dereq_('../lib/errors');
var VERSION = _dereq_('../lib/constants').VERSION;
var GRAPHQL_URLS = _dereq_('../lib/constants').GRAPHQL_URLS;
var methods = _dereq_('../lib/methods');
var convertMethodsToError = _dereq_('../lib/convert-methods-to-error');

var cachedClients = {};

/**
 * This object is returned by {@link Client#getConfiguration|getConfiguration}. This information is used extensively by other Braintree modules to properly configure themselves.
 * @typedef {object} Client~configuration
 * @property {object} client The braintree-web/client parameters.
 * @property {string} client.authorization A tokenizationKey or clientToken.
 * @property {object} gatewayConfiguration Gateway-supplied configuration.
 * @property {object} analyticsMetadata Analytics-specific data.
 * @property {string} analyticsMetadata.sessionId Uniquely identifies a browsing session.
 * @property {string} analyticsMetadata.sdkVersion The braintree.js version.
 * @property {string} analyticsMetadata.merchantAppId Identifies the merchant's web app.
 */

/**
 * @class
 * @param {Client~configuration} configuration Options
 * @description <strong>Do not use this constructor directly. Use {@link module:braintree-web/client.create|braintree.client.create} instead.</strong>
 * @classdesc This class is required by many other Braintree components. It serves as the base API layer that communicates with our servers. It is also capable of being used to formulate direct calls to our servers, such as direct credit card tokenization. See {@link Client#request}.
 */
function Client(configuration) {
  var configurationJSON, gatewayConfiguration, braintreeApiConfiguration;

  configuration = configuration || {};

  configurationJSON = JSON.stringify(configuration);
  gatewayConfiguration = configuration.gatewayConfiguration;

  if (!gatewayConfiguration) {
    throw new BraintreeError(errors.CLIENT_MISSING_GATEWAY_CONFIGURATION);
  }

  [
    'assetsUrl',
    'clientApiUrl',
    'configUrl'
  ].forEach(function (property) {
    if (property in gatewayConfiguration && !isVerifiedDomain(gatewayConfiguration[property])) {
      throw new BraintreeError({
        type: errors.CLIENT_GATEWAY_CONFIGURATION_INVALID_DOMAIN.type,
        code: errors.CLIENT_GATEWAY_CONFIGURATION_INVALID_DOMAIN.code,
        message: property + ' property is on an invalid domain.'
      });
    }
  });

  /**
   * Returns a copy of the configuration values.
   * @public
   * @returns {Client~configuration} configuration
   */
  this.getConfiguration = function () {
    return JSON.parse(configurationJSON);
  };

  this._request = request;
  this._configuration = this.getConfiguration();

  this._clientApiBaseUrl = gatewayConfiguration.clientApiUrl + '/v1/';

  braintreeApiConfiguration = gatewayConfiguration.braintreeApi;
  if (braintreeApiConfiguration) {
    this._braintreeApi = {
      baseUrl: braintreeApiConfiguration.url + '/',
      accessToken: braintreeApiConfiguration.accessToken
    };

    if (!isVerifiedDomain(this._braintreeApi.baseUrl)) {
      throw new BraintreeError({
        type: errors.CLIENT_GATEWAY_CONFIGURATION_INVALID_DOMAIN.type,
        code: errors.CLIENT_GATEWAY_CONFIGURATION_INVALID_DOMAIN.code,
        message: 'braintreeApi URL is on an invalid domain.'
      });
    }
  }

  if (gatewayConfiguration.graphQL) {
    this._graphQL = new GraphQL({
      graphQL: gatewayConfiguration.graphQL
    });
  }
}

Client.initialize = function (options) {
  if (cachedClients[options.authorization]) {
    return Promise.resolve(cachedClients[options.authorization]);
  }

  return getGatewayConfiguration(options).then(function (configuration) {
    var client;

    if (options.debug) {
      configuration.isDebug = true;
    }

    client = new Client(configuration);
    cachedClients[options.authorization] = client;

    return client;
  });
};

// Primarily used for testing the client initalization call
Client.clearCache = function () {
  cachedClients = {};
};

/**
 * Used by other modules to formulate all network requests to the Braintree gateway. It is also capable of being used directly from your own form to tokenize credit card information. However, be sure to satisfy PCI compliance if you use direct card tokenization.
 * @public
 * @param {object} options Request options:
 * @param {string} options.method HTTP method, e.g. "get" or "post".
 * @param {string} options.endpoint Endpoint path, e.g. "payment_methods".
 * @param {object} options.data Data to send with the request.
 * @param {number} [options.timeout=60000] Set a timeout (in milliseconds) for the request.
 * @param {callback} [callback] The second argument, <code>data</code>, is the returned server data.
 * @example
 * <caption>Direct Credit Card Tokenization</caption>
 * var createClient = require('braintree-web/client').create;
 *
 * createClient({
 *   authorization: CLIENT_AUTHORIZATION
 * }, function (createErr, clientInstance) {
 *   var form = document.getElementById('my-form-id');
 *   var data = {
 *     creditCard: {
 *       number: form['cc-number'].value,
 *       cvv: form['cc-cvv'].value,
 *       expirationDate: form['cc-expiration-date'].value,
 *       billingAddress: {
 *         postalCode: form['cc-postal-code'].value
 *       },
 *       options: {
 *         validate: false
 *       }
 *     }
 *   };
 *
 *   // Warning: For a merchant to be eligible for the easiest level of PCI compliance (SAQ A),
 *   // payment fields cannot be hosted on your checkout page.
 *   // For an alternative to the following, use Hosted Fields.
 *   clientInstance.request({
 *     endpoint: 'payment_methods/credit_cards',
 *     method: 'post',
 *     data: data
 *   }, function (requestErr, response) {
 *     // More detailed example of handling API errors: https://codepen.io/braintree/pen/MbwjdM
 *     if (requestErr) { throw new Error(requestErr); }
 *
 *     console.log('Got nonce:', response.creditCards[0].nonce);
 *   });
 * });
 * @example
 * <caption>Tokenizing Fields for AVS Checks</caption>
 * var createClient = require('braintree-web/client').create;
 *
 * createClient({
 *   authorization: CLIENT_AUTHORIZATION
 * }, function (createErr, clientInstance) {
 *   var form = document.getElementById('my-form-id');
 *   var data = {
 *     creditCard: {
 *       number: form['cc-number'].value,
 *       cvv: form['cc-cvv'].value,
 *       expirationDate: form['cc-date'].value,
 *       // The billing address can be checked with AVS rules.
 *       // See: https://articles.braintreepayments.com/support/guides/fraud-tools/basic/avs-cvv-rules
 *       billingAddress: {
 *         postalCode: form['cc-postal-code'].value,
 *         streetAddress: form['cc-street-address'].value,
 *         countryName: form['cc-country-name'].value,
 *         countryCodeAlpha2: form['cc-country-alpha2'].value,
 *         countryCodeAlpha3: form['cc-country-alpha3'].value,
 *         countryCodeNumeric: form['cc-country-numeric'].value
 *       },
 *       options: {
 *         validate: false
 *       }
 *     }
 *   };
 *
 *   // Warning: For a merchant to be eligible for the easiest level of PCI compliance (SAQ A),
 *   // payment fields cannot be hosted on your checkout page.
 *   // For an alternative to the following, use Hosted Fields.
 *   clientInstance.request({
 *     endpoint: 'payment_methods/credit_cards',
 *     method: 'post',
 *     data: data
 *   }, function (requestErr, response) {
 *     // More detailed example of handling API errors: https://codepen.io/braintree/pen/MbwjdM
 *     if (requestErr) { throw new Error(requestErr); }
 *
 *     console.log('Got nonce:', response.creditCards[0].nonce);
 *   });
 * });
 * @returns {Promise|void} Returns a promise if no callback is provided.
 */
Client.prototype.request = function (options, callback) {
  var self = this; // eslint-disable-line no-invalid-this
  var requestPromise = new Promise(function (resolve, reject) {
    var optionName, api, baseUrl, requestOptions;

    if (options.api !== 'graphQLApi') {
      if (!options.method) {
        optionName = 'options.method';
      } else if (!options.endpoint) {
        optionName = 'options.endpoint';
      }
    }

    if (optionName) {
      throw new BraintreeError({
        type: errors.CLIENT_OPTION_REQUIRED.type,
        code: errors.CLIENT_OPTION_REQUIRED.code,
        message: optionName + ' is required when making a request.'
      });
    }

    if ('api' in options) {
      api = options.api;
    } else {
      api = 'clientApi';
    }

    requestOptions = {
      method: options.method,
      graphQL: self._graphQL,
      timeout: options.timeout,
      metadata: self._configuration.analyticsMetadata
    };

    if (api === 'clientApi') {
      baseUrl = self._clientApiBaseUrl;

      requestOptions.data = addMetadata(self._configuration, options.data);
    } else if (api === 'braintreeApi') {
      if (!self._braintreeApi) {
        throw new BraintreeError(sharedErrors.BRAINTREE_API_ACCESS_RESTRICTED);
      }

      baseUrl = self._braintreeApi.baseUrl;

      requestOptions.data = options.data;

      requestOptions.headers = {
        'Braintree-Version': constants.BRAINTREE_API_VERSION_HEADER,
        Authorization: 'Bearer ' + self._braintreeApi.accessToken
      };
    } else if (api === 'graphQLApi') {
      baseUrl = GRAPHQL_URLS[self._configuration.gatewayConfiguration.environment];
      options.endpoint = '';
      requestOptions.method = 'post';
      requestOptions.data = assign({
        clientSdkMetadata: {
          source: self._configuration.analyticsMetadata.source,
          integration: self._configuration.analyticsMetadata.integration,
          sessionId: self._configuration.analyticsMetadata.sessionId
        }
      }, options.data);

      requestOptions.headers = getAuthorizationHeadersForGraphQL(self._configuration.authorization);
    } else {
      throw new BraintreeError({
        type: errors.CLIENT_OPTION_INVALID.type,
        code: errors.CLIENT_OPTION_INVALID.code,
        message: 'options.api is invalid.'
      });
    }

    requestOptions.url = baseUrl + options.endpoint;
    requestOptions.sendAnalyticsEvent = function (kind) {
      analytics.sendEvent(self, kind);
    };

    self._request(requestOptions, function (err, data, status) {
      var resolvedData, requestError;

      requestError = formatRequestError(status, err);

      if (requestError) {
        reject(requestError);

        return;
      }

      if (api === 'graphQLApi' && data.errors) {
        reject(convertToBraintreeError(data.errors, {
          type: errors.CLIENT_GRAPHQL_REQUEST_ERROR.type,
          code: errors.CLIENT_GRAPHQL_REQUEST_ERROR.code,
          message: errors.CLIENT_GRAPHQL_REQUEST_ERROR.message
        }));

        return;
      }

      resolvedData = assign({_httpStatus: status}, data);

      resolve(resolvedData);
    });
  });

  if (typeof callback === 'function') {
    callback = once(deferred(callback));

    requestPromise.then(function (response) {
      callback(null, response, response._httpStatus);
    }).catch(function (err) {
      var status = err && err.details && err.details.httpStatus;

      callback(err, null, status);
    });

    return;
  }

  return requestPromise; // eslint-disable-line consistent-return
};

function formatRequestError(status, err) { // eslint-disable-line consistent-return
  var requestError;

  if (status === -1) {
    requestError = new BraintreeError(errors.CLIENT_REQUEST_TIMEOUT);
  } else if (status === 403) {
    requestError = new BraintreeError(errors.CLIENT_AUTHORIZATION_INSUFFICIENT);
  } else if (status === 429) {
    requestError = new BraintreeError(errors.CLIENT_RATE_LIMITED);
  } else if (status >= 500) {
    requestError = new BraintreeError(errors.CLIENT_GATEWAY_NETWORK);
  } else if (status < 200 || status >= 400) {
    requestError = convertToBraintreeError(err, {
      type: errors.CLIENT_REQUEST_ERROR.type,
      code: errors.CLIENT_REQUEST_ERROR.code,
      message: errors.CLIENT_REQUEST_ERROR.message
    });
  }

  if (requestError) {
    requestError.details = requestError.details || {};
    requestError.details.httpStatus = status;

    return requestError;
  }
}

Client.prototype.toJSON = function () {
  return this.getConfiguration();
};

/**
 * Returns the Client version.
 * @public
 * @returns {String} The created client's version.
 * @example
 * var createClient = require('braintree-web/client').create;
 *
 * createClient({
 *   authorization: CLIENT_AUTHORIZATION
 * }, function (createErr, clientInstance) {
 *   console.log(clientInstance.getVersion()); // Ex: 1.0.0
 * });
 * @returns {void}
 */
Client.prototype.getVersion = function () {
  return VERSION;
};

/**
 * Cleanly tear down anything set up by {@link module:braintree-web/client.create|create}.
 * @public
 * @param {callback} [callback] Called once teardown is complete. No data is returned if teardown completes successfully.
 * @example
 * clientInstance.teardown();
 * @example <caption>With callback</caption>
 * clientInstance.teardown(function () {
 *   // teardown is complete
 * });
 * @returns {Promise|void} Returns a promise if no callback is provided.
 */
Client.prototype.teardown = wrapPromise(function () {
  var self = this; // eslint-disable-line no-invalid-this

  delete cachedClients[self.getConfiguration().authorization];
  convertMethodsToError(self, methods(Client.prototype));

  return Promise.resolve();
});

function getAuthorizationHeadersForGraphQL(authorization) {
  var authAttrs = createAuthorizationData(authorization).attrs;
  var token = authAttrs.authorizationFingerprint || authAttrs.tokenizationKey;

  return {
    Authorization: 'Bearer ' + token,
    'Braintree-Version': BRAINTREE_VERSION
  };
}

module.exports = Client;

},{"../lib/add-metadata":31,"../lib/analytics":32,"../lib/assign":33,"../lib/braintree-error":34,"../lib/constants":35,"../lib/convert-methods-to-error":36,"../lib/convert-to-braintree-error":37,"../lib/create-authorization-data":38,"../lib/deferred":39,"../lib/errors":41,"../lib/is-verified-domain":43,"../lib/methods":45,"../lib/once":46,"../lib/promise":47,"./constants":11,"./errors":12,"./get-configuration":13,"./request":25,"./request/graphql":23,"@braintree/wrap-promise":7}],11:[function(_dereq_,module,exports){
'use strict';

module.exports = {
  BRAINTREE_API_VERSION_HEADER: '2017-04-03',
  BRAINTREE_VERSION: '2018-05-10'
};

},{}],12:[function(_dereq_,module,exports){
'use strict';

/**
 * @name BraintreeError.Client - Interal Error Codes
 * @ignore
 * @description These codes should never be experienced by the mechant directly.
 * @property {MERCHANT} CLIENT_GATEWAY_CONFIGURATION_INVALID_DOMAIN An error to prevent client creation for domains that are not allowed in the JS.
 * @property {INTERNAL} CLIENT_MISSING_GATEWAY_CONFIGURATION Occurs when the client is created without a gateway configuration. Should never happen.
 */

/**
 * @name BraintreeError.Client - Create Error Codes
 * @description Errors that may occur when [creating the client](/current/module-braintree-web_client.html#.create)
 * @property {MERCHANT} CLIENT_INVALID_AUTHORIZATION Occurs when client token cannot be parsed.
 */

/**
 * @name BraintreeError.Client - Request Error Codes
 * @description Errors that may occur when [using the request method](/current/Client.html#request)
 * @property {MERCHANT} CLIENT_OPTION_REQUIRED An option required in the request method was not provided. Usually `options.method` or `options.endpoint`
 * @property {MERCHANT} CLIENT_OPTION_INVALID The request option provided is invalid.
 * @property {MERCHANT} CLIENT_GATEWAY_NETWORK The Braintree gateway could not be contacted.
 * @property {NETWORK} CLIENT_REQUEST_TIMEOUT The request took too long to complete and timed out.
 * @property {NETWORK} CLIENT_REQUEST_ERROR The response from a request had status 400 or greater.
 * @property {NETWORK} CLIENT_GRAPHQL_REQUEST_ERROR The response from a request to GraphQL contained an error.
 * @property {MERCHANT} CLIENT_RATE_LIMITED The response from a request had a status of 429, indicating rate limiting.
 * @property {MERCHANT} CLIENT_AUTHORIZATION_INSUFFICIENT The user assocaited with the client token or tokenization key does not have permissions to make the request.
 */

var BraintreeError = _dereq_('../lib/braintree-error');

module.exports = {
  CLIENT_GATEWAY_CONFIGURATION_INVALID_DOMAIN: {
    type: BraintreeError.types.MERCHANT,
    code: 'CLIENT_GATEWAY_CONFIGURATION_INVALID_DOMAIN'
  },
  CLIENT_OPTION_REQUIRED: {
    type: BraintreeError.types.MERCHANT,
    code: 'CLIENT_OPTION_REQUIRED'
  },
  CLIENT_OPTION_INVALID: {
    type: BraintreeError.types.MERCHANT,
    code: 'CLIENT_OPTION_INVALID'
  },
  CLIENT_MISSING_GATEWAY_CONFIGURATION: {
    type: BraintreeError.types.INTERNAL,
    code: 'CLIENT_MISSING_GATEWAY_CONFIGURATION',
    message: 'Missing gatewayConfiguration.'
  },
  CLIENT_INVALID_AUTHORIZATION: {
    type: BraintreeError.types.MERCHANT,
    code: 'CLIENT_INVALID_AUTHORIZATION',
    message: 'Authorization is invalid. Make sure your client token or tokenization key is valid.'
  },
  CLIENT_GATEWAY_NETWORK: {
    type: BraintreeError.types.NETWORK,
    code: 'CLIENT_GATEWAY_NETWORK',
    message: 'Cannot contact the gateway at this time.'
  },
  CLIENT_REQUEST_TIMEOUT: {
    type: BraintreeError.types.NETWORK,
    code: 'CLIENT_REQUEST_TIMEOUT',
    message: 'Request timed out waiting for a reply.'
  },
  CLIENT_REQUEST_ERROR: {
    type: BraintreeError.types.NETWORK,
    code: 'CLIENT_REQUEST_ERROR',
    message: 'There was a problem with your request.'
  },
  CLIENT_GRAPHQL_REQUEST_ERROR: {
    type: BraintreeError.types.NETWORK,
    code: 'CLIENT_GRAPHQL_REQUEST_ERROR',
    message: 'There was a problem with your request.'
  },
  CLIENT_RATE_LIMITED: {
    type: BraintreeError.types.MERCHANT,
    code: 'CLIENT_RATE_LIMITED',
    message: 'You are being rate-limited; please try again in a few minutes.'
  },
  CLIENT_AUTHORIZATION_INSUFFICIENT: {
    type: BraintreeError.types.MERCHANT,
    code: 'CLIENT_AUTHORIZATION_INSUFFICIENT',
    message: 'The authorization used has insufficient privileges.'
  }
};

},{"../lib/braintree-error":34}],13:[function(_dereq_,module,exports){
(function (global){
'use strict';

var BraintreeError = _dereq_('../lib/braintree-error');
var Promise = _dereq_('../lib/promise');
var wrapPromise = _dereq_('@braintree/wrap-promise');
var request = _dereq_('./request');
var uuid = _dereq_('../lib/vendor/uuid');
var constants = _dereq_('../lib/constants');
var createAuthorizationData = _dereq_('../lib/create-authorization-data');
var errors = _dereq_('./errors');
var GraphQL = _dereq_('./request/graphql');
var isDateStringBeforeOrOn = _dereq_('../lib/is-date-string-before-or-on');

var BRAINTREE_VERSION = _dereq_('./constants').BRAINTREE_VERSION;

function getConfiguration(options) {
  return new Promise(function (resolve, reject) {
    var configuration, authData, attrs, configUrl, reqOptions;
    var sessionId = uuid();
    var analyticsMetadata = {
      merchantAppId: global.location.host,
      platform: constants.PLATFORM,
      sdkVersion: constants.VERSION,
      source: constants.SOURCE,
      integration: constants.INTEGRATION,
      integrationType: constants.INTEGRATION,
      sessionId: sessionId
    };

    try {
      authData = createAuthorizationData(options.authorization);
    } catch (err) {
      reject(new BraintreeError(errors.CLIENT_INVALID_AUTHORIZATION));

      return;
    }
    attrs = authData.attrs;
    configUrl = authData.configUrl;

    attrs._meta = analyticsMetadata;
    attrs.braintreeLibraryVersion = constants.BRAINTREE_LIBRARY_VERSION;
    attrs.configVersion = '3';

    reqOptions = {
      url: configUrl,
      method: 'GET',
      data: attrs
    };

    if (attrs.authorizationFingerprint && authData.graphQL) {
      if (isDateStringBeforeOrOn(authData.graphQL.date, BRAINTREE_VERSION)) {
        reqOptions.graphQL = new GraphQL({
          graphQL: {
            url: authData.graphQL.url,
            features: ['configuration']
          }
        });
      }

      reqOptions.metadata = analyticsMetadata;
    }

    request(reqOptions, function (err, response, status) {
      var errorTemplate;

      if (err) {
        if (status === 403) {
          errorTemplate = errors.CLIENT_AUTHORIZATION_INSUFFICIENT;
        } else {
          errorTemplate = errors.CLIENT_GATEWAY_NETWORK;
        }

        reject(new BraintreeError({
          type: errorTemplate.type,
          code: errorTemplate.code,
          message: errorTemplate.message,
          details: {
            originalError: err
          }
        }));

        return;
      }

      configuration = {
        authorization: options.authorization,
        authorizationType: attrs.tokenizationKey ? 'TOKENIZATION_KEY' : 'CLIENT_TOKEN',
        analyticsMetadata: analyticsMetadata,
        gatewayConfiguration: response
      };

      resolve(configuration);
    });
  });
}

module.exports = {
  getConfiguration: wrapPromise(getConfiguration)
};

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"../lib/braintree-error":34,"../lib/constants":35,"../lib/create-authorization-data":38,"../lib/is-date-string-before-or-on":42,"../lib/promise":47,"../lib/vendor/uuid":50,"./constants":11,"./errors":12,"./request":25,"./request/graphql":23,"@braintree/wrap-promise":7}],14:[function(_dereq_,module,exports){
'use strict';

var BraintreeError = _dereq_('../lib/braintree-error');
var Client = _dereq_('./client');
var VERSION = "3.38.1";
var Promise = _dereq_('../lib/promise');
var wrapPromise = _dereq_('@braintree/wrap-promise');
var sharedErrors = _dereq_('../lib/errors');

/** @module braintree-web/client */

/**
 * @function create
 * @description This function is the entry point for the <code>braintree.client</code> module. It is used for creating {@link Client} instances that service communication to Braintree servers.
 * @param {object} options Object containing all {@link Client} options:
 * @param {string} options.authorization A tokenizationKey or clientToken.
 * @param {callback} [callback] The second argument, <code>data</code>, is the {@link Client} instance.
 * @returns {Promise|void} Returns a promise if no callback is provided.
 * @example
 * var createClient = require('braintree-web/client').create;
 *
 * createClient({
 *   authorization: CLIENT_AUTHORIZATION
 * }, function (createErr, clientInstance) {
 *   // ...
 * });
 * @static
 */
function create(options) {
  if (!options.authorization) {
    return Promise.reject(new BraintreeError({
      type: sharedErrors.INSTANTIATION_OPTION_REQUIRED.type,
      code: sharedErrors.INSTANTIATION_OPTION_REQUIRED.code,
      message: 'options.authorization is required when instantiating a client.'
    }));
  }

  return Client.initialize(options);
}

module.exports = {
  create: wrapPromise(create),
  /**
   * @description The current version of the SDK, i.e. `{@pkg version}`.
   * @type {string}
   */
  VERSION: VERSION
};

},{"../lib/braintree-error":34,"../lib/errors":41,"../lib/promise":47,"./client":10,"@braintree/wrap-promise":7}],15:[function(_dereq_,module,exports){
'use strict';

var querystring = _dereq_('../../lib/querystring');
var browserDetection = _dereq_('../browser-detection');
var assign = _dereq_('../../lib/assign').assign;
var prepBody = _dereq_('./prep-body');
var parseBody = _dereq_('./parse-body');
var xhr = _dereq_('./xhr');
var isXHRAvailable = xhr.isAvailable;
var GraphQLRequest = _dereq_('./graphql/request');
var DefaultRequest = _dereq_('./default-request');

var MAX_TCP_RETRYCOUNT = 1;
var TCP_PRECONNECT_BUG_STATUS_CODE = 408;

function requestShouldRetry(status) {
  return (!status || status === TCP_PRECONNECT_BUG_STATUS_CODE) && browserDetection.isIe();
}

function graphQLRequestShouldRetryWithClientApi(body) {
  var errorClass = !body.data && body.errors &&
      body.errors[0] &&
      body.errors[0].extensions &&
      body.errors[0].extensions.errorClass;

  return errorClass === 'UNKNOWN' || errorClass === 'INTERNAL';
}

function _requestWithRetry(options, tcpRetryCount, cb) {
  var status, resBody, ajaxRequest, body, method, headers, parsedBody;
  var url = options.url;
  var graphQL = options.graphQL;
  var timeout = options.timeout;
  var req = xhr.getRequestObject();
  var callback = cb;
  var isGraphQLRequest = Boolean(graphQL && graphQL.isGraphQLRequest(url, options.data));

  options.headers = assign({'Content-Type': 'application/json'}, options.headers);

  if (isGraphQLRequest) {
    ajaxRequest = new GraphQLRequest(options);
  } else {
    ajaxRequest = new DefaultRequest(options);
  }

  url = ajaxRequest.getUrl();
  body = ajaxRequest.getBody();
  method = ajaxRequest.getMethod();
  headers = ajaxRequest.getHeaders();

  if (method === 'GET') {
    url = querystring.queryify(url, body);
    body = null;
  }

  if (isXHRAvailable) {
    req.onreadystatechange = function () {
      if (req.readyState !== 4) { return; }

      if (req.status === 0 && isGraphQLRequest) {
        // If a merchant experiences a connection
        // issue to the GraphQL endpoint (possibly
        // due to a Content Security Policy), retry
        // the request against the old client API.
        delete options.graphQL;
        _requestWithRetry(options, tcpRetryCount, cb);

        return;
      }

      parsedBody = parseBody(req.responseText);
      resBody = ajaxRequest.adaptResponseBody(parsedBody);
      status = ajaxRequest.determineStatus(req.status, parsedBody);

      if (status >= 400 || status < 200) {
        if (isGraphQLRequest && graphQLRequestShouldRetryWithClientApi(parsedBody)) {
          delete options.graphQL;
          _requestWithRetry(options, tcpRetryCount, cb);

          return;
        }

        if (tcpRetryCount < MAX_TCP_RETRYCOUNT && requestShouldRetry(status)) {
          tcpRetryCount++;
          _requestWithRetry(options, tcpRetryCount, cb);

          return;
        }
        callback(resBody || 'error', null, status || 500);
      } else {
        callback(null, resBody, status);
      }
    };
  } else {
    if (options.headers) {
      url = querystring.queryify(url, headers);
    }

    req.onload = function () {
      callback(null, parseBody(req.responseText), req.status);
    };

    req.onerror = function () {
      // XDomainRequest does not report a body or status for errors, so
      // hardcode to 'error' and 500, respectively
      callback('error', null, 500);
    };

    // This must remain for IE9 to work
    req.onprogress = function () {};

    req.ontimeout = function () {
      callback('timeout', null, -1);
    };
  }

  try {
    req.open(method, url, true);
  } catch (requestOpenError) {
    // If a merchant has a Content Security Policy and they have
    // not allowed our endpoints, some browsers may
    // synchronously throw an error. If it is not a GraphQL
    // request, we throw the error. If it is a GraphQL request
    // we remove the GraphQL option and try the request against
    // the old client API.
    if (!isGraphQLRequest) {
      throw requestOpenError;
    }

    delete options.graphQL;

    _requestWithRetry(options, tcpRetryCount, cb);

    return;
  }

  req.timeout = timeout;

  if (isXHRAvailable) {
    Object.keys(headers).forEach(function (headerKey) {
      req.setRequestHeader(headerKey, headers[headerKey]);
    });
  }

  try {
    req.send(prepBody(method, body));
  } catch (e) { /* ignored */ }
}

function request(options, cb) {
  _requestWithRetry(options, 0, cb);
}

module.exports = {
  request: request
};

},{"../../lib/assign":33,"../../lib/querystring":48,"../browser-detection":9,"./default-request":16,"./graphql/request":24,"./parse-body":28,"./prep-body":29,"./xhr":30}],16:[function(_dereq_,module,exports){
'use strict';

function DefaultRequest(options) {
  this._url = options.url;
  this._data = options.data;
  this._method = options.method;
  this._headers = options.headers;
}

DefaultRequest.prototype.getUrl = function () {
  return this._url;
};

DefaultRequest.prototype.getBody = function () {
  return this._data;
};

DefaultRequest.prototype.getMethod = function () {
  return this._method;
};

DefaultRequest.prototype.getHeaders = function () {
  return this._headers;
};

DefaultRequest.prototype.adaptResponseBody = function (parsedBody) {
  return parsedBody;
};

DefaultRequest.prototype.determineStatus = function (status) {
  return status;
};

module.exports = DefaultRequest;

},{}],17:[function(_dereq_,module,exports){
(function (global){
'use strict';

module.exports = function getUserAgent() {
  return global.navigator.userAgent;
};

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],18:[function(_dereq_,module,exports){
'use strict';

var errorResponseAdapter = _dereq_('./error');
var assign = _dereq_('../../../../lib/assign').assign;

/* eslint-disable camelcase */
var cardTypeTransforms = {
  creditCard: {
    AMERICAN_EXPRESS: 'American Express',
    DISCOVER: 'Discover',
    INTERNATIONAL_MAESTRO: 'Maestro',
    JCB: 'JCB',
    MASTERCARD: 'MasterCard',
    SOLO: 'Solo',
    UK_MAESTRO: 'UK Maestro',
    UNION_PAY: 'UnionPay',
    VISA: 'Visa'
  },
  applePayWeb: {
    VISA: 'visa',
    MASTERCARD: 'mastercard',
    DISCOVER: 'discover',
    AMERICAN_EXPRESS: 'amex'
  },
  visaCheckout: {
    VISA: 'Visa',
    MASTERCARD: 'MasterCard',
    DISCOVER: 'Discover',
    AMERICAN_EXPRESS: 'American Express'
  },
  googlePay: {
    VISA: 'visa',
    MASTERCARD: 'mastercard',
    DISCOVER: 'discover',
    AMERICAN_EXPRESS: 'amex'
  },
  masterpass: {
    VISA: 'visa',
    MASTERCARD: 'master',
    DISCOVER: 'discover',
    AMERICAN_EXPRESS: 'amex',
    DINERS: 'diners',
    INTERNATIONAL_MAESTRO: 'maestro',
    JCB: 'jcb'
  }
};
/* eslint-enable camelcase */

function configurationResponseAdapter(responseBody, ctx) {
  var adaptedResponse;

  if (responseBody.data && !responseBody.errors) {
    adaptedResponse = adaptConfigurationResponseBody(responseBody, ctx);
  } else {
    adaptedResponse = errorResponseAdapter(responseBody);
  }

  return adaptedResponse;
}

function adaptConfigurationResponseBody(body, ctx) {
  var configuration = body.data.clientConfiguration;
  var response;

  response = {
    environment: configuration.environment.toLowerCase(),
    clientApiUrl: configuration.clientApiUrl,
    assetsUrl: configuration.assetsUrl,
    analytics: {
      url: configuration.analyticsUrl
    },
    merchantId: configuration.merchantId,
    venmo: 'off'
  };

  if (configuration.supportedFeatures) {
    response.graphQL = {
      url: ctx._graphQL._config.url,
      features: configuration.supportedFeatures.map(function (feature) {
        return feature.toLowerCase();
      })
    };
  }

  if (configuration.braintreeApi) {
    response.braintreeApi = configuration.braintreeApi;
  }

  if (configuration.applePayWeb) {
    response.applePayWeb = configuration.applePayWeb;
    response.applePayWeb.supportedNetworks = mapCardTypes(configuration.applePayWeb.supportedCardBrands, cardTypeTransforms.applePayWeb);

    delete response.applePayWeb.supportedCardBrands;
  }

  if (configuration.ideal) {
    response.ideal = configuration.ideal;
  }

  if (configuration.kount) {
    response.kount = {
      kountMerchantId: configuration.kount.merchantId
    };
  }

  if (configuration.creditCard) {
    response.challenges = configuration.creditCard.challenges.map(function (challenge) {
      return challenge.toLowerCase();
    });

    response.creditCards = {
      supportedCardTypes: mapCardTypes(configuration.creditCard.supportedCardBrands, cardTypeTransforms.creditCard)
    };
    response.threeDSecureEnabled = configuration.creditCard.threeDSecureEnabled;
  } else {
    response.challenges = [];
    response.creditCards = {
      supportedCardTypes: []
    };
    response.threeDSecureEnabled = false;
  }

  if (configuration.googlePay) {
    response.androidPay = {
      displayName: configuration.googlePay.displayName,
      enabled: true,
      environment: configuration.googlePay.environment.toLowerCase(),
      googleAuthorizationFingerprint: configuration.googlePay.googleAuthorization,
      supportedNetworks: mapCardTypes(configuration.googlePay.supportedCardBrands, cardTypeTransforms.googlePay)
    };
  }

  if (configuration.venmo) {
    response.payWithVenmo = {
      merchantId: configuration.venmo.merchantId,
      accessToken: configuration.venmo.accessToken,
      environment: configuration.venmo.environment.toLowerCase()
    };
  }

  if (configuration.paypal) {
    response.paypalEnabled = true;
    response.paypal = assign({}, configuration.paypal);
    response.paypal.currencyIsoCode = response.paypal.currencyCode;
    response.paypal.environment = response.paypal.environment.toLowerCase();

    delete response.paypal.currencyCode;
  } else {
    response.paypalEnabled = false;
  }

  if (configuration.unionPay) {
    response.unionPay = {
      enabled: true,
      merchantAccountId: configuration.unionPay.merchantAccountId
    };
  }

  if (configuration.visaCheckout) {
    response.visaCheckout = {
      apikey: configuration.visaCheckout.apiKey,
      externalClientId: configuration.visaCheckout.externalClientId,
      supportedCardTypes: mapCardTypes(configuration.visaCheckout.supportedCardBrands, cardTypeTransforms.visaCheckout)
    };
  }

  if (configuration.masterpass) {
    response.masterpass = {
      merchantCheckoutId: configuration.masterpass.merchantCheckoutId,
      supportedNetworks: mapCardTypes(configuration.masterpass.supportedCardBrands, cardTypeTransforms.masterpass)
    };
  }

  if (configuration.usBankAccount) {
    response.usBankAccount = {
      routeId: configuration.usBankAccount.routeId,
      plaid: {
        publicKey: configuration.usBankAccount.plaidPublicKey
      }
    };
  }

  return response;
}

function mapCardTypes(cardTypes, cardTypeTransformMap) {
  return cardTypes.reduce(function (acc, type) {
    if (cardTypeTransformMap.hasOwnProperty(type)) {
      return acc.concat(cardTypeTransformMap[type]);
    }

    return acc;
  }, []);
}

module.exports = configurationResponseAdapter;

},{"../../../../lib/assign":33,"./error":20}],19:[function(_dereq_,module,exports){
'use strict';

var errorResponseAdapter = _dereq_('./error');

var CARD_BRAND_MAP = {
  /* eslint-disable camelcase */
  AMERICAN_EXPRESS: 'American Express',
  DINERS: 'Discover',
  DISCOVER: 'Discover',
  INTERNATIONAL_MAESTRO: 'Maestro',
  JCB: 'JCB',
  MASTERCARD: 'MasterCard',
  UK_MAESTRO: 'Maestro',
  UNION_PAY: 'Union Pay',
  VISA: 'Visa'
  /* eslint-enable camelcase */
};

var BIN_DATA_MAP = {
  YES: 'Yes',
  NO: 'No',
  UNKNOWN: 'Unknown'
};

function creditCardTokenizationResponseAdapter(responseBody) {
  var adaptedResponse;

  if (responseBody.data && !responseBody.errors) {
    adaptedResponse = adaptTokenizeCreditCardResponseBody(responseBody);
  } else {
    adaptedResponse = errorResponseAdapter(responseBody);
  }

  return adaptedResponse;
}

function adaptTokenizeCreditCardResponseBody(body) {
  var data = body.data.tokenizeCreditCard;
  var creditCard = data.creditCard;
  var lastTwo = creditCard.last4 ? creditCard.last4.substr(2, 4) : '';
  var binData = creditCard.binData;
  var response;

  if (binData) {
    ['commercial', 'debit', 'durbinRegulated', 'healthcare', 'payroll', 'prepaid'].forEach(function (key) {
      if (binData[key]) {
        binData[key] = BIN_DATA_MAP[binData[key]];
      } else {
        binData[key] = 'Unknown';
      }
    });

    ['issuingBank', 'countryOfIssuance', 'productId'].forEach(function (key) {
      if (!binData[key]) { binData[key] = 'Unknown'; }
    });
  }

  response = {
    creditCards: [
      {
        binData: binData,
        consumed: false,
        description: lastTwo ? 'ending in ' + lastTwo : '',
        nonce: data.token,
        details: {
          cardType: CARD_BRAND_MAP[creditCard.brandCode] || 'Unknown',
          lastFour: creditCard.last4 || '',
          lastTwo: lastTwo
        },
        type: 'CreditCard',
        threeDSecureInfo: null
      }
    ]
  };

  return response;
}

module.exports = creditCardTokenizationResponseAdapter;

},{"./error":20}],20:[function(_dereq_,module,exports){
'use strict';

function errorResponseAdapter(responseBody) {
  var response;
  var errorClass = responseBody.errors &&
    responseBody.errors[0] &&
    responseBody.errors[0].extensions &&
    responseBody.errors[0].extensions.errorClass;

  if (errorClass === 'VALIDATION') {
    response = userErrorResponseAdapter(responseBody);
  } else if (errorClass) {
    response = errorWithClassResponseAdapter(responseBody);
  } else {
    response = {error: {message: 'There was a problem serving your request'}, fieldErrors: []};
  }

  return response;
}

function errorWithClassResponseAdapter(responseBody) {
  return {error: {message: responseBody.errors[0].message}, fieldErrors: []};
}

function userErrorResponseAdapter(responseBody) {
  var fieldErrors = buildFieldErrors(responseBody.errors);

  return {error: {message: getLegacyMessage(fieldErrors)}, fieldErrors: fieldErrors};
}

function buildFieldErrors(errors) {
  var fieldErrors = [];

  errors.forEach(function (error) {
    addFieldError(error.extensions.inputPath.slice(1), error, fieldErrors);
  });

  return fieldErrors;
}

function addFieldError(inputPath, errorDetail, fieldErrors) {
  var fieldError;
  var legacyCode = errorDetail.extensions.legacyCode;
  var inputField = inputPath[0];

  if (inputPath.length === 1) {
    fieldErrors.push({
      code: legacyCode,
      field: inputField,
      message: errorDetail.message
    });

    return;
  }

  fieldErrors.forEach(function (candidate) {
    if (candidate.field === inputField) {
      fieldError = candidate;
    }
  });

  if (!fieldError) {
    fieldError = {field: inputField, fieldErrors: []};
    fieldErrors.push(fieldError);
  }

  addFieldError(inputPath.slice(1), errorDetail, fieldError.fieldErrors);
}

function getLegacyMessage(errors) {
  var legacyMessages = {
    creditCard: 'Credit card is invalid'
  };

  var field = errors[0].field;

  return legacyMessages[field];
}

module.exports = errorResponseAdapter;

},{}],21:[function(_dereq_,module,exports){
'use strict';

var CONFIGURATION_QUERY = 'query ClientConfiguration { ' +
'  clientConfiguration { ' +
'    analyticsUrl ' +
'    environment ' +
'    merchantId ' +
'    assetsUrl ' +
'    clientApiUrl ' +
'    creditCard { ' +
'      supportedCardBrands ' +
'      challenges ' +
'      threeDSecureEnabled ' +
'    } ' +
'    applePayWeb { ' +
'      countryCode ' +
'      currencyCode ' +
'      merchantIdentifier ' +
'      supportedCardBrands ' +
'    } ' +
'    googlePay { ' +
'      displayName ' +
'      supportedCardBrands ' +
'      environment ' +
'      googleAuthorization ' +
'    } ' +
'    ideal { ' +
'      routeId ' +
'      assetsUrl ' +
'    } ' +
'    kount { ' +
'      merchantId ' +
'    } ' +
'    masterpass { ' +
'      merchantCheckoutId ' +
'      supportedCardBrands ' +
'    } ' +
'    paypal { ' +
'      displayName ' +
'      clientId ' +
'      privacyUrl ' +
'      userAgreementUrl ' +
'      assetsUrl ' +
'      environment ' +
'      environmentNoNetwork ' +
'      unvettedMerchant ' +
'      braintreeClientId ' +
'      billingAgreementsEnabled ' +
'      merchantAccountId ' +
'      currencyCode ' +
'      payeeEmail ' +
'    } ' +
'    unionPay { ' +
'      merchantAccountId ' +
'    } ' +
'    usBankAccount { ' +
'      routeId ' +
'      plaidPublicKey ' +
'    } ' +
'    venmo { ' +
'      merchantId ' +
'      accessToken ' +
'      environment ' +
'    } ' +
'    visaCheckout { ' +
'      apiKey ' +
'      externalClientId ' +
'      supportedCardBrands ' +
'    } ' +
'    braintreeApi { ' +
'      accessToken ' +
'      url ' +
'    } ' +
'    supportedFeatures ' +
'  } ' +
'}';

function configuration() {
  return {
    query: CONFIGURATION_QUERY,
    operationName: 'ClientConfiguration'
  };
}

module.exports = configuration;

},{}],22:[function(_dereq_,module,exports){
'use strict';

var assign = _dereq_('../../../../lib/assign').assign;

var CREDIT_CARD_TOKENIZATION_MUTATION = 'mutation TokenizeCreditCard($input: TokenizeCreditCardInput!) { ' +
'  tokenizeCreditCard(input: $input) { ' +
'    token ' +
'    creditCard { ' +
'      brandCode ' +
'      last4 ' +
'      binData { ' +
'        prepaid ' +
'        healthcare ' +
'        debit ' +
'        durbinRegulated ' +
'        commercial ' +
'        payroll ' +
'        issuingBank ' +
'        countryOfIssuance ' +
'        productId ' +
'      } ' +
'    } ' +
'  } ' +
'}';

function createCreditCardTokenizationBody(body) {
  var cc = body.creditCard;
  var billingAddress = cc && cc.billingAddress;
  var expDate = cc && cc.expirationDate;
  var expirationMonth = cc && (cc.expirationMonth || (expDate && expDate.split('/')[0].trim()));
  var expirationYear = cc && (cc.expirationYear || (expDate && expDate.split('/')[1].trim()));
  var variables = {
    input: {
      creditCard: {
        number: cc && cc.number,
        expirationMonth: expirationMonth,
        expirationYear: expirationYear,
        cvv: cc && cc.cvv,
        cardholderName: cc && cc.cardholderName
      },
      options: {}
    }
  };

  if (billingAddress) {
    variables.input.creditCard.billingAddress = billingAddress;
  }

  variables.input = addValidationRule(body, variables.input);

  return variables;
}

function addValidationRule(body, input) {
  var validate;

  if (body.creditCard && body.creditCard.options && typeof body.creditCard.options.validate === 'boolean') {
    validate = body.creditCard.options.validate;
  } else if ((body.authorizationFingerprint && body.tokenizationKey) || body.authorizationFingerprint) {
    validate = true;
  } else if (body.tokenizationKey) {
    validate = false;
  }

  if (typeof validate === 'boolean') {
    input.options = assign({
      validate: validate
    }, input.options);
  }

  return input;
}

function creditCardTokenization(body) {
  return {
    query: CREDIT_CARD_TOKENIZATION_MUTATION,
    variables: createCreditCardTokenizationBody(body),
    operationName: 'TokenizeCreditCard'
  };
}

module.exports = creditCardTokenization;

},{"../../../../lib/assign":33}],23:[function(_dereq_,module,exports){
'use strict';

var browserDetection = _dereq_('../../browser-detection');

var features = {
  tokenize_credit_cards: 'payment_methods/credit_cards', // eslint-disable-line camelcase
  configuration: 'configuration'
};

var disallowedInputPaths = [
  'creditCard.options.unionPayEnrollment'
];

function GraphQL(config) {
  this._config = config.graphQL;
}

GraphQL.prototype.getGraphQLEndpoint = function () {
  return this._config.url;
};

GraphQL.prototype.isGraphQLRequest = function (url, body) {
  var featureEnabled;
  var path = this.getClientApiPath(url);

  if (!this._isGraphQLEnabled() || !path || browserDetection.isIe9()) {
    return false;
  }

  featureEnabled = this._config.features.some(function (feature) {
    return features[feature] === path;
  });

  if (containsDisallowedlistedKeys(body)) {
    return false;
  }

  return featureEnabled;
};

GraphQL.prototype.getClientApiPath = function (url) {
  var path;
  var clientApiPrefix = '/client_api/v1/';
  var pathParts = url.split(clientApiPrefix);

  if (pathParts.length > 1) {
    path = pathParts[1].split('?')[0];
  }

  return path;
};

GraphQL.prototype._isGraphQLEnabled = function () {
  return Boolean(this._config);
};

function containsDisallowedlistedKeys(body) {
  return disallowedInputPaths.some(function (keys) {
    var value = keys.split('.').reduce(function (accumulator, key) {
      return accumulator && accumulator[key];
    }, body);

    return value !== undefined; // eslint-disable-line no-undefined
  });
}

module.exports = GraphQL;

},{"../../browser-detection":9}],24:[function(_dereq_,module,exports){
'use strict';

var BRAINTREE_VERSION = _dereq_('../../constants').BRAINTREE_VERSION;

var assign = _dereq_('../../../lib/assign').assign;

var creditCardTokenizationBodyGenerator = _dereq_('./generators/credit-card-tokenization');
var creditCardTokenizationResponseAdapter = _dereq_('./adapters/credit-card-tokenization');

var configurationBodyGenerator = _dereq_('./generators/configuration');
var configurationResponseAdapter = _dereq_('./adapters/configuration');

var generators = {
  'payment_methods/credit_cards': creditCardTokenizationBodyGenerator,
  configuration: configurationBodyGenerator
};
var adapters = {
  'payment_methods/credit_cards': creditCardTokenizationResponseAdapter,
  configuration: configurationResponseAdapter
};

function GraphQLRequest(options) {
  var clientApiPath = options.graphQL.getClientApiPath(options.url);

  this._graphQL = options.graphQL;
  this._data = options.data;
  this._method = options.method;
  this._headers = options.headers;
  this._clientSdkMetadata = {
    source: options.metadata.source,
    integration: options.metadata.integration,
    sessionId: options.metadata.sessionId
  };
  this._sendAnalyticsEvent = options.sendAnalyticsEvent || Function.prototype;

  this._generator = generators[clientApiPath];
  this._adapter = adapters[clientApiPath];

  this._sendAnalyticsEvent('graphql.init');
}

GraphQLRequest.prototype.getUrl = function () {
  return this._graphQL.getGraphQLEndpoint();
};

GraphQLRequest.prototype.getBody = function () {
  var formattedBody = formatBodyKeys(this._data);
  var generatedBody = this._generator(formattedBody);
  var body = assign({clientSdkMetadata: this._clientSdkMetadata}, generatedBody);

  return JSON.stringify(body);
};

GraphQLRequest.prototype.getMethod = function () {
  return 'POST';
};

GraphQLRequest.prototype.getHeaders = function () {
  var authorization, headers;

  if (this._data.authorizationFingerprint) {
    this._sendAnalyticsEvent('graphql.authorization-fingerprint');
    authorization = this._data.authorizationFingerprint;
  } else {
    this._sendAnalyticsEvent('graphql.tokenization-key');
    authorization = this._data.tokenizationKey;
  }

  headers = {
    Authorization: 'Bearer ' + authorization,
    'Braintree-Version': BRAINTREE_VERSION
  };

  return assign({}, this._headers, headers);
};

GraphQLRequest.prototype.adaptResponseBody = function (parsedBody) {
  return this._adapter(parsedBody, this);
};

GraphQLRequest.prototype.determineStatus = function (httpStatus, parsedResponse) {
  var status, errorClass;

  if (httpStatus === 200) {
    errorClass = parsedResponse.errors &&
      parsedResponse.errors[0] &&
      parsedResponse.errors[0].extensions &&
      parsedResponse.errors[0].extensions.errorClass;

    if (parsedResponse.data && !parsedResponse.errors) {
      status = 200;
    } else if (errorClass === 'VALIDATION') {
      status = 422;
    } else if (errorClass === 'AUTHORIZATION') {
      status = 403;
    } else if (errorClass === 'AUTHENTICATION') {
      status = 401;
    } else if (isGraphQLError(errorClass, parsedResponse)) {
      status = 403;
    } else {
      status = 500;
    }
  } else if (!httpStatus) {
    status = 500;
  } else {
    status = httpStatus;
  }

  this._sendAnalyticsEvent('graphql.status.' + httpStatus);
  this._sendAnalyticsEvent('graphql.determinedStatus.' + status);

  return status;
};

function isGraphQLError(errorClass, parsedResponse) {
  return !errorClass && parsedResponse.errors[0].message;
}

function snakeCaseToCamelCase(snakeString) {
  if (snakeString.indexOf('_') === -1) {
    return snakeString;
  }

  return snakeString.toLowerCase().replace(/(\_\w)/g, function (match) {
    return match[1].toUpperCase();
  });
}

function formatBodyKeys(originalBody) {
  var body = {};

  Object.keys(originalBody).forEach(function (key) {
    var camelCaseKey = snakeCaseToCamelCase(key);

    if (typeof originalBody[key] === 'object') {
      body[camelCaseKey] = formatBodyKeys(originalBody[key]);
    } else if (typeof originalBody[key] === 'number') {
      body[camelCaseKey] = String(originalBody[key]);
    } else {
      body[camelCaseKey] = originalBody[key];
    }
  });

  return body;
}

module.exports = GraphQLRequest;

},{"../../../lib/assign":33,"../../constants":11,"./adapters/configuration":18,"./adapters/credit-card-tokenization":19,"./generators/configuration":21,"./generators/credit-card-tokenization":22}],25:[function(_dereq_,module,exports){
'use strict';

var ajaxIsAvaliable;
var once = _dereq_('../../lib/once');
var JSONPDriver = _dereq_('./jsonp-driver');
var AJAXDriver = _dereq_('./ajax-driver');
var getUserAgent = _dereq_('./get-user-agent');
var isHTTP = _dereq_('./is-http');

function isAjaxAvailable() {
  if (ajaxIsAvaliable == null) {
    ajaxIsAvaliable = !(isHTTP() && /MSIE\s(8|9)/.test(getUserAgent()));
  }

  return ajaxIsAvaliable;
}

module.exports = function (options, cb) {
  cb = once(cb || Function.prototype);
  options.method = (options.method || 'GET').toUpperCase();
  options.timeout = options.timeout == null ? 60000 : options.timeout;
  options.data = options.data || {};

  if (isAjaxAvailable()) {
    AJAXDriver.request(options, cb);
  } else {
    JSONPDriver.request(options, cb);
  }
};

},{"../../lib/once":46,"./ajax-driver":15,"./get-user-agent":17,"./is-http":26,"./jsonp-driver":27}],26:[function(_dereq_,module,exports){
(function (global){
'use strict';

module.exports = function () {
  return global.location.protocol === 'http:';
};

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],27:[function(_dereq_,module,exports){
(function (global){
'use strict';

var head;
var uuid = _dereq_('../../lib/vendor/uuid');
var querystring = _dereq_('../../lib/querystring');
var timeouts = {};

function _removeScript(script) {
  if (script && script.parentNode) {
    script.parentNode.removeChild(script);
  }
}

function _createScriptTag(url, callbackName) {
  var script = document.createElement('script');
  var done = false;

  script.src = url;
  script.async = true;
  script.onerror = function () {
    global[callbackName]({message: 'error', status: 500});
  };

  script.onload = script.onreadystatechange = function () {
    if (done) { return; }

    if (!this.readyState || this.readyState === 'loaded' || this.readyState === 'complete') {
      done = true;
      script.onload = script.onreadystatechange = null;
    }
  };

  return script;
}

function _cleanupGlobal(callbackName) {
  try {
    delete global[callbackName];
  } catch (_) {
    global[callbackName] = null;
  }
}

function _setupTimeout(timeout, callbackName) {
  timeouts[callbackName] = setTimeout(function () {
    timeouts[callbackName] = null;

    global[callbackName]({
      error: 'timeout',
      status: -1
    });

    global[callbackName] = function () {
      _cleanupGlobal(callbackName);
    };
  }, timeout);
}

function _setupGlobalCallback(script, callback, callbackName) {
  global[callbackName] = function (response) {
    var status = response.status || 500;
    var err = null;
    var data = null;

    delete response.status;

    if (status >= 400 || status < 200) {
      err = response;
    } else {
      data = response;
    }

    _cleanupGlobal(callbackName);
    _removeScript(script);

    clearTimeout(timeouts[callbackName]);
    callback(err, data, status);
  };
}

function request(options, callback) {
  var script;
  var callbackName = 'callback_json_' + uuid().replace(/-/g, '');
  var url = options.url;
  var attrs = options.data;
  var method = options.method;
  var timeout = options.timeout;

  url = querystring.queryify(url, attrs);
  url = querystring.queryify(url, {
    _method: method,
    callback: callbackName
  });

  script = _createScriptTag(url, callbackName);
  _setupGlobalCallback(script, callback, callbackName);
  _setupTimeout(timeout, callbackName);

  if (!head) {
    head = document.getElementsByTagName('head')[0];
  }

  head.appendChild(script);
}

module.exports = {
  request: request
};

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"../../lib/querystring":48,"../../lib/vendor/uuid":50}],28:[function(_dereq_,module,exports){
'use strict';

module.exports = function (body) {
  try {
    body = JSON.parse(body);
  } catch (e) { /* ignored */ }

  return body;
};

},{}],29:[function(_dereq_,module,exports){
'use strict';

module.exports = function (method, body) {
  if (typeof method !== 'string') {
    throw new Error('Method must be a string');
  }

  if (method.toLowerCase() !== 'get' && body != null) {
    body = typeof body === 'string' ? body : JSON.stringify(body);
  }

  return body;
};

},{}],30:[function(_dereq_,module,exports){
(function (global){
'use strict';

var isXHRAvailable = global.XMLHttpRequest && 'withCredentials' in new global.XMLHttpRequest();

function getRequestObject() {
  return isXHRAvailable ? new XMLHttpRequest() : new XDomainRequest();
}

module.exports = {
  isAvailable: isXHRAvailable,
  getRequestObject: getRequestObject
};

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],31:[function(_dereq_,module,exports){
'use strict';

var createAuthorizationData = _dereq_('./create-authorization-data');
var jsonClone = _dereq_('./json-clone');
var constants = _dereq_('./constants');

function addMetadata(configuration, data) {
  var key;
  var attrs = data ? jsonClone(data) : {};
  var authAttrs = createAuthorizationData(configuration.authorization).attrs;
  var _meta = jsonClone(configuration.analyticsMetadata);

  attrs.braintreeLibraryVersion = constants.BRAINTREE_LIBRARY_VERSION;

  for (key in attrs._meta) {
    if (attrs._meta.hasOwnProperty(key)) {
      _meta[key] = attrs._meta[key];
    }
  }

  attrs._meta = _meta;

  if (authAttrs.tokenizationKey) {
    attrs.tokenizationKey = authAttrs.tokenizationKey;
  } else {
    attrs.authorizationFingerprint = authAttrs.authorizationFingerprint;
  }

  return attrs;
}

module.exports = addMetadata;

},{"./constants":35,"./create-authorization-data":38,"./json-clone":44}],32:[function(_dereq_,module,exports){
'use strict';

var Promise = _dereq_('./promise');
var constants = _dereq_('./constants');
var addMetadata = _dereq_('./add-metadata');

function _millisToSeconds(millis) {
  return Math.floor(millis / 1000);
}

function sendAnalyticsEvent(clientInstanceOrPromise, kind, callback) {
  var timestamp = _millisToSeconds(Date.now());

  return Promise.resolve(clientInstanceOrPromise).then(function (client) {
    var timestampInPromise = _millisToSeconds(Date.now());
    var configuration = client.getConfiguration();
    var request = client._request;
    var url = configuration.gatewayConfiguration.analytics.url;
    var data = {
      analytics: [{
        kind: constants.ANALYTICS_PREFIX + kind,
        isAsync: timestampInPromise !== timestamp,
        timestamp: timestamp
      }]
    };

    request({
      url: url,
      method: 'post',
      data: addMetadata(configuration, data),
      timeout: constants.ANALYTICS_REQUEST_TIMEOUT_MS
    }, callback);
  });
}

module.exports = {
  sendEvent: sendAnalyticsEvent
};

},{"./add-metadata":31,"./constants":35,"./promise":47}],33:[function(_dereq_,module,exports){
'use strict';

var assignNormalized = typeof Object.assign === 'function' ? Object.assign : assignPolyfill;

function assignPolyfill(destination) {
  var i, source, key;

  for (i = 1; i < arguments.length; i++) {
    source = arguments[i];
    for (key in source) {
      if (source.hasOwnProperty(key)) {
        destination[key] = source[key];
      }
    }
  }

  return destination;
}

module.exports = {
  assign: assignNormalized,
  _assign: assignPolyfill
};

},{}],34:[function(_dereq_,module,exports){
'use strict';

var enumerate = _dereq_('./enumerate');

/**
 * @class
 * @global
 * @param {object} options Construction options
 * @classdesc This class is used to report error conditions, frequently as the first parameter to callbacks throughout the Braintree SDK.
 * @description <strong>You cannot use this constructor directly. Interact with instances of this class through {@link callback callbacks}.</strong>
 */
function BraintreeError(options) {
  if (!BraintreeError.types.hasOwnProperty(options.type)) {
    throw new Error(options.type + ' is not a valid type.');
  }

  if (!options.code) {
    throw new Error('Error code required.');
  }

  if (!options.message) {
    throw new Error('Error message required.');
  }

  this.name = 'BraintreeError';

  /**
   * @type {string}
   * @description A code that corresponds to specific errors.
   */
  this.code = options.code;

  /**
   * @type {string}
   * @description A short description of the error.
   */
  this.message = options.message;

  /**
   * @type {BraintreeError.types}
   * @description The type of error.
   */
  this.type = options.type;

  /**
   * @type {object=}
   * @description Additional information about the error, such as an underlying network error response.
   */
  this.details = options.details;
}

BraintreeError.prototype = Object.create(Error.prototype);
BraintreeError.prototype.constructor = BraintreeError;

/**
 * Enum for {@link BraintreeError} types.
 * @name BraintreeError.types
 * @enum
 * @readonly
 * @memberof BraintreeError
 * @property {string} CUSTOMER An error caused by the customer.
 * @property {string} MERCHANT An error that is actionable by the merchant.
 * @property {string} NETWORK An error due to a network problem.
 * @property {string} INTERNAL An error caused by Braintree code.
 * @property {string} UNKNOWN An error where the origin is unknown.
 */
BraintreeError.types = enumerate([
  'CUSTOMER',
  'MERCHANT',
  'NETWORK',
  'INTERNAL',
  'UNKNOWN'
]);

BraintreeError.findRootError = function (err) {
  if (err instanceof BraintreeError && err.details && err.details.originalError) {
    return BraintreeError.findRootError(err.details.originalError);
  }

  return err;
};

module.exports = BraintreeError;

},{"./enumerate":40}],35:[function(_dereq_,module,exports){
'use strict';

var VERSION = "3.38.1";
var PLATFORM = 'web';

var CLIENT_API_URLS = {
  production: 'https://api.braintreegateway.com:443',
  sandbox: 'https://api.sandbox.braintreegateway.com:443'
};

var ASSETS_URLS = {
  production: 'https://assets.braintreegateway.com',
  sandbox: 'https://assets.braintreegateway.com'
};

var GRAPHQL_URLS = {
  production: 'https://payments.braintree-api.com/graphql',
  sandbox: 'https://payments.sandbox.braintree-api.com/graphql'
};

// endRemoveIf(production)

module.exports = {
  ANALYTICS_PREFIX: PLATFORM + '.',
  ANALYTICS_REQUEST_TIMEOUT_MS: 2000,
  ASSETS_URLS: ASSETS_URLS,
  CLIENT_API_URLS: CLIENT_API_URLS,
  GRAPHQL_URLS: GRAPHQL_URLS,
  INTEGRATION_TIMEOUT_MS: 60000,
  VERSION: VERSION,
  INTEGRATION: 'custom',
  SOURCE: 'client',
  PLATFORM: PLATFORM,
  BRAINTREE_LIBRARY_VERSION: 'braintree/' + PLATFORM + '/' + VERSION
};

},{}],36:[function(_dereq_,module,exports){
'use strict';

var BraintreeError = _dereq_('./braintree-error');
var sharedErrors = _dereq_('./errors');

module.exports = function (instance, methodNames) {
  methodNames.forEach(function (methodName) {
    instance[methodName] = function () {
      throw new BraintreeError({
        type: sharedErrors.METHOD_CALLED_AFTER_TEARDOWN.type,
        code: sharedErrors.METHOD_CALLED_AFTER_TEARDOWN.code,
        message: methodName + ' cannot be called after teardown.'
      });
    };
  });
};

},{"./braintree-error":34,"./errors":41}],37:[function(_dereq_,module,exports){
'use strict';

var BraintreeError = _dereq_('./braintree-error');

function convertToBraintreeError(originalErr, btErrorObject) {
  if (originalErr instanceof BraintreeError) {
    return originalErr;
  }

  return new BraintreeError({
    type: btErrorObject.type,
    code: btErrorObject.code,
    message: btErrorObject.message,
    details: {
      originalError: originalErr
    }
  });
}

module.exports = convertToBraintreeError;

},{"./braintree-error":34}],38:[function(_dereq_,module,exports){
'use strict';

var atob = _dereq_('../lib/vendor/polyfill').atob;
var CLIENT_API_URLS = _dereq_('../lib/constants').CLIENT_API_URLS;

function _isTokenizationKey(str) {
  return /^[a-zA-Z0-9]+_[a-zA-Z0-9]+_[a-zA-Z0-9_]+$/.test(str);
}

function _parseTokenizationKey(tokenizationKey) {
  var tokens = tokenizationKey.split('_');
  var environment = tokens[0];
  var merchantId = tokens.slice(2).join('_');

  return {
    merchantId: merchantId,
    environment: environment
  };
}

function createAuthorizationData(authorization) {
  var parsedClientToken, parsedTokenizationKey;
  var data = {
    attrs: {},
    configUrl: ''
  };

  if (_isTokenizationKey(authorization)) {
    parsedTokenizationKey = _parseTokenizationKey(authorization);
    data.environment = parsedTokenizationKey.environment;
    data.attrs.tokenizationKey = authorization;
    data.configUrl = CLIENT_API_URLS[parsedTokenizationKey.environment] + '/merchants/' + parsedTokenizationKey.merchantId + '/client_api/v1/configuration';
  } else {
    parsedClientToken = JSON.parse(atob(authorization));
    data.environment = parsedClientToken.environment;
    data.attrs.authorizationFingerprint = parsedClientToken.authorizationFingerprint;
    data.configUrl = parsedClientToken.configUrl;
    data.graphQL = parsedClientToken.graphQL;
  }

  return data;
}

module.exports = createAuthorizationData;

},{"../lib/constants":35,"../lib/vendor/polyfill":49}],39:[function(_dereq_,module,exports){
'use strict';

module.exports = function (fn) {
  return function () {
    // IE9 doesn't support passing arguments to setTimeout so we have to emulate it.
    var args = arguments;

    setTimeout(function () {
      fn.apply(null, args);
    }, 1);
  };
};

},{}],40:[function(_dereq_,module,exports){
'use strict';

function enumerate(values, prefix) {
  prefix = prefix == null ? '' : prefix;

  return values.reduce(function (enumeration, value) {
    enumeration[value] = prefix + value;

    return enumeration;
  }, {});
}

module.exports = enumerate;

},{}],41:[function(_dereq_,module,exports){
'use strict';

/**
 * @name BraintreeError.Shared Interal Error Codes
 * @ignore
 * @description These codes should never be experienced by the mechant directly.
 * @property {INTERNAL} INVALID_USE_OF_INTERNAL_FUNCTION Occurs when the client is created without a gateway configuration. Should never happen.
 */

/**
 * @name BraintreeError.Shared Errors - Component Creation Error Codes
 * @description Errors that occur when creating components.
 * @property {MERCHANT} INSTANTIATION_OPTION_REQUIRED Occurs when a compoennt is created that is missing a required option.
 * @property {MERCHANT} INCOMPATIBLE_VERSIONS Occurs when a component is created with a client with a different version than the component.
 */

/**
 * @name BraintreeError.Shared Errors - Component Instance Error Codes
 * @description Errors that occur when using instances of components.
 * @property {MERCHANT} METHOD_CALLED_AFTER_TEARDOWN Occurs when a method is called on a component instance after it has been torn down.
 * @property {MERCHANT} BRAINTREE_API_ACCESS_RESTRICTED Occurs when the client token or tokenization key does not have the correct permissions.
 */

var BraintreeError = _dereq_('./braintree-error');

module.exports = {
  INVALID_USE_OF_INTERNAL_FUNCTION: {
    type: BraintreeError.types.INTERNAL,
    code: 'INVALID_USE_OF_INTERNAL_FUNCTION'
  },
  INSTANTIATION_OPTION_REQUIRED: {
    type: BraintreeError.types.MERCHANT,
    code: 'INSTANTIATION_OPTION_REQUIRED'
  },
  INCOMPATIBLE_VERSIONS: {
    type: BraintreeError.types.MERCHANT,
    code: 'INCOMPATIBLE_VERSIONS'
  },
  METHOD_CALLED_AFTER_TEARDOWN: {
    type: BraintreeError.types.MERCHANT,
    code: 'METHOD_CALLED_AFTER_TEARDOWN'
  },
  BRAINTREE_API_ACCESS_RESTRICTED: {
    type: BraintreeError.types.MERCHANT,
    code: 'BRAINTREE_API_ACCESS_RESTRICTED',
    message: 'Your access is restricted and cannot use this part of the Braintree API.'
  }
};

},{"./braintree-error":34}],42:[function(_dereq_,module,exports){
'use strict';

function convertDateStringToDate(dateString) {
  var splitDate = dateString.split('-');

  return new Date(splitDate[0], splitDate[1], splitDate[2]);
}

function isDateStringBeforeOrOn(firstDate, secondDate) {
  return convertDateStringToDate(firstDate) <= convertDateStringToDate(secondDate);
}

module.exports = isDateStringBeforeOrOn;

},{}],43:[function(_dereq_,module,exports){
'use strict';

var parser;
var legalHosts = {
  'paypal.com': 1,
  'braintreepayments.com': 1,
  'braintreegateway.com': 1,
  'braintree-api.com': 1
};

// endRemoveIf(production)

function stripSubdomains(domain) {
  return domain.split('.').slice(-2).join('.');
}

function isVerifiedDomain(url) {
  var mainDomain;

  url = url.toLowerCase();

  if (!/^https:/.test(url)) {
    return false;
  }

  parser = parser || document.createElement('a');
  parser.href = url;
  mainDomain = stripSubdomains(parser.hostname);

  return legalHosts.hasOwnProperty(mainDomain);
}

module.exports = isVerifiedDomain;

},{}],44:[function(_dereq_,module,exports){
'use strict';

module.exports = function (value) {
  return JSON.parse(JSON.stringify(value));
};

},{}],45:[function(_dereq_,module,exports){
'use strict';

module.exports = function (obj) {
  return Object.keys(obj).filter(function (key) {
    return typeof obj[key] === 'function';
  });
};

},{}],46:[function(_dereq_,module,exports){
arguments[4][5][0].apply(exports,arguments)
},{"dup":5}],47:[function(_dereq_,module,exports){
(function (global){
'use strict';

var Promise = global.Promise || _dereq_('promise-polyfill');

module.exports = Promise;

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"promise-polyfill":8}],48:[function(_dereq_,module,exports){
(function (global){
'use strict';

function _notEmpty(obj) {
  var key;

  for (key in obj) {
    if (obj.hasOwnProperty(key)) { return true; }
  }

  return false;
}

/* eslint-disable no-mixed-operators */
function _isArray(value) {
  return value && typeof value === 'object' && typeof value.length === 'number' &&
    Object.prototype.toString.call(value) === '[object Array]' || false;
}
/* eslint-enable no-mixed-operators */

function parse(url) {
  var query, params;

  url = url || global.location.href;

  if (!/\?/.test(url)) {
    return {};
  }

  query = url.replace(/#.*$/, '').replace(/^.*\?/, '').split('&');

  params = query.reduce(function (toReturn, keyValue) {
    var parts = keyValue.split('=');
    var key = decodeURIComponent(parts[0]);
    var value = decodeURIComponent(parts[1]);

    toReturn[key] = value;

    return toReturn;
  }, {});

  return params;
}

function stringify(params, namespace) {
  var k, v, p;
  var query = [];

  for (p in params) {
    if (!params.hasOwnProperty(p)) {
      continue;
    }

    v = params[p];

    if (namespace) {
      if (_isArray(params)) {
        k = namespace + '[]';
      } else {
        k = namespace + '[' + p + ']';
      }
    } else {
      k = p;
    }
    if (typeof v === 'object') {
      query.push(stringify(v, k));
    } else {
      query.push(encodeURIComponent(k) + '=' + encodeURIComponent(v));
    }
  }

  return query.join('&');
}

function queryify(url, params) {
  url = url || '';

  if (params != null && typeof params === 'object' && _notEmpty(params)) {
    url += url.indexOf('?') === -1 ? '?' : '';
    url += url.indexOf('=') !== -1 ? '&' : '';
    url += stringify(params);
  }

  return url;
}

module.exports = {
  parse: parse,
  stringify: stringify,
  queryify: queryify
};

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],49:[function(_dereq_,module,exports){
(function (global){
'use strict';

var atobNormalized = typeof global.atob === 'function' ? global.atob : atob;

function atob(base64String) {
  var a, b, c, b1, b2, b3, b4, i;
  var base64Matcher = new RegExp('^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{4})([=]{1,2})?$');
  var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
  var result = '';

  if (!base64Matcher.test(base64String)) {
    throw new Error('Non base64 encoded input passed to window.atob polyfill');
  }

  i = 0;
  do {
    b1 = characters.indexOf(base64String.charAt(i++));
    b2 = characters.indexOf(base64String.charAt(i++));
    b3 = characters.indexOf(base64String.charAt(i++));
    b4 = characters.indexOf(base64String.charAt(i++));

    a = (b1 & 0x3F) << 2 | b2 >> 4 & 0x3;
    b = (b2 & 0xF) << 4 | b3 >> 2 & 0xF;
    c = (b3 & 0x3) << 6 | b4 & 0x3F;

    result += String.fromCharCode(a) + (b ? String.fromCharCode(b) : '') + (c ? String.fromCharCode(c) : '');
  } while (i < base64String.length);

  return result;
}

module.exports = {
  atob: function (base64String) {
    return atobNormalized.call(global, base64String);
  },
  _atob: atob
};

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],50:[function(_dereq_,module,exports){
'use strict';

function uuid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0;
    var v = c === 'x' ? r : r & 0x3 | 0x8;

    return v.toString(16);
  });
}

module.exports = uuid;

},{}]},{},[14])(14)
});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49), __webpack_require__(449).setImmediate))

/***/ }),
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(422),
    isObjectLike = __webpack_require__(410);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__redux_ducks_countryConfiguration_duck__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_ducks_frontendConfiguration_duck__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_utils_Redux_Connect__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_formFields_IntlPhoneInput__ = __webpack_require__(482);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }







var selector = function selector(state) {
  return {
    supportedCountryCodes: __WEBPACK_IMPORTED_MODULE_1__redux_ducks_countryConfiguration_duck__["c" /* selectors */].getCountryCodes(state),
    locale: __WEBPACK_IMPORTED_MODULE_2__redux_ducks_frontendConfiguration_duck__["c" /* selectors */].getLanguage(state),
    countryCode: __WEBPACK_IMPORTED_MODULE_1__redux_ducks_countryConfiguration_duck__["c" /* selectors */].getCurrentCountryCode(state)
  };
};

var IntlPhoneInputContainer = function IntlPhoneInputContainer(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_utils_Redux_Connect__["a" /* default */], {
    selector: selector
  }, function (_ref) {
    var dispatch = _ref.dispatch,
        connectedProps = _objectWithoutProperties(_ref, ["dispatch"]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_formFields_IntlPhoneInput__["b" /* default */], _extends({}, connectedProps, props));
  });
};

/* harmony default export */ __webpack_exports__["a"] = (IntlPhoneInputContainer);

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Exposing intl-tel-input as a component
 */
module.exports = __webpack_require__(545);


/***/ }),
/* 545 */
/***/ (function(module, exports) {

/*
 * International Telephone Input v16.0.7
 * https://github.com/jackocnr/intl-tel-input.git
 * Licensed under the MIT license
 */

// wrap in UMD
(function(factory) {
    var intlTelInput = factory(window, document);
    if (typeof module === "object" && module.exports) module.exports = intlTelInput; else window.intlTelInput = intlTelInput;
})(function(window, document, undefined) {
    "use strict";
    return function() {
        // Array of country objects for the flag dropdown.
        // Here is the criteria for the plugin to support a given country/territory
        // - It has an iso2 code: https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2
        // - It has it's own country calling code (it is not a sub-region of another country): https://en.wikipedia.org/wiki/List_of_country_calling_codes
        // - It has a flag in the region-flags project: https://github.com/behdad/region-flags/tree/gh-pages/png
        // - It is supported by libphonenumber (it must be listed on this page): https://github.com/googlei18n/libphonenumber/blob/master/resources/ShortNumberMetadata.xml
        // Each country array has the following information:
        // [
        //    Country name,
        //    iso2 code,
        //    International dial code,
        //    Order (if >1 country with same dial code),
        //    Area codes
        // ]
        var allCountries = [ [ "Afghanistan (‫افغانستان‬‎)", "af", "93" ], [ "Albania (Shqipëri)", "al", "355" ], [ "Algeria (‫الجزائر‬‎)", "dz", "213" ], [ "American Samoa", "as", "1", 5, [ "684" ] ], [ "Andorra", "ad", "376" ], [ "Angola", "ao", "244" ], [ "Anguilla", "ai", "1", 6, [ "264" ] ], [ "Antigua and Barbuda", "ag", "1", 7, [ "268" ] ], [ "Argentina", "ar", "54" ], [ "Armenia (Հայաստան)", "am", "374" ], [ "Aruba", "aw", "297" ], [ "Australia", "au", "61", 0 ], [ "Austria (Österreich)", "at", "43" ], [ "Azerbaijan (Azərbaycan)", "az", "994" ], [ "Bahamas", "bs", "1", 8, [ "242" ] ], [ "Bahrain (‫البحرين‬‎)", "bh", "973" ], [ "Bangladesh (বাংলাদেশ)", "bd", "880" ], [ "Barbados", "bb", "1", 9, [ "246" ] ], [ "Belarus (Беларусь)", "by", "375" ], [ "Belgium (België)", "be", "32" ], [ "Belize", "bz", "501" ], [ "Benin (Bénin)", "bj", "229" ], [ "Bermuda", "bm", "1", 10, [ "441" ] ], [ "Bhutan (འབྲུག)", "bt", "975" ], [ "Bolivia", "bo", "591" ], [ "Bosnia and Herzegovina (Босна и Херцеговина)", "ba", "387" ], [ "Botswana", "bw", "267" ], [ "Brazil (Brasil)", "br", "55" ], [ "British Indian Ocean Territory", "io", "246" ], [ "British Virgin Islands", "vg", "1", 11, [ "284" ] ], [ "Brunei", "bn", "673" ], [ "Bulgaria (България)", "bg", "359" ], [ "Burkina Faso", "bf", "226" ], [ "Burundi (Uburundi)", "bi", "257" ], [ "Cambodia (កម្ពុជា)", "kh", "855" ], [ "Cameroon (Cameroun)", "cm", "237" ], [ "Canada", "ca", "1", 1, [ "204", "226", "236", "249", "250", "289", "306", "343", "365", "387", "403", "416", "418", "431", "437", "438", "450", "506", "514", "519", "548", "579", "581", "587", "604", "613", "639", "647", "672", "705", "709", "742", "778", "780", "782", "807", "819", "825", "867", "873", "902", "905" ] ], [ "Cape Verde (Kabu Verdi)", "cv", "238" ], [ "Caribbean Netherlands", "bq", "599", 1, [ "3", "4", "7" ] ], [ "Cayman Islands", "ky", "1", 12, [ "345" ] ], [ "Central African Republic (République centrafricaine)", "cf", "236" ], [ "Chad (Tchad)", "td", "235" ], [ "Chile", "cl", "56" ], [ "China (中国)", "cn", "86" ], [ "Christmas Island", "cx", "61", 2 ], [ "Cocos (Keeling) Islands", "cc", "61", 1 ], [ "Colombia", "co", "57" ], [ "Comoros (‫جزر القمر‬‎)", "km", "269" ], [ "Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo)", "cd", "243" ], [ "Congo (Republic) (Congo-Brazzaville)", "cg", "242" ], [ "Cook Islands", "ck", "682" ], [ "Costa Rica", "cr", "506" ], [ "Côte d’Ivoire", "ci", "225" ], [ "Croatia (Hrvatska)", "hr", "385" ], [ "Cuba", "cu", "53" ], [ "Curaçao", "cw", "599", 0 ], [ "Cyprus (Κύπρος)", "cy", "357" ], [ "Czech Republic (Česká republika)", "cz", "420" ], [ "Denmark (Danmark)", "dk", "45" ], [ "Djibouti", "dj", "253" ], [ "Dominica", "dm", "1", 13, [ "767" ] ], [ "Dominican Republic (República Dominicana)", "do", "1", 2, [ "809", "829", "849" ] ], [ "Ecuador", "ec", "593" ], [ "Egypt (‫مصر‬‎)", "eg", "20" ], [ "El Salvador", "sv", "503" ], [ "Equatorial Guinea (Guinea Ecuatorial)", "gq", "240" ], [ "Eritrea", "er", "291" ], [ "Estonia (Eesti)", "ee", "372" ], [ "Ethiopia", "et", "251" ], [ "Falkland Islands (Islas Malvinas)", "fk", "500" ], [ "Faroe Islands (Føroyar)", "fo", "298" ], [ "Fiji", "fj", "679" ], [ "Finland (Suomi)", "fi", "358", 0 ], [ "France", "fr", "33" ], [ "French Guiana (Guyane française)", "gf", "594" ], [ "French Polynesia (Polynésie française)", "pf", "689" ], [ "Gabon", "ga", "241" ], [ "Gambia", "gm", "220" ], [ "Georgia (საქართველო)", "ge", "995" ], [ "Germany (Deutschland)", "de", "49" ], [ "Ghana (Gaana)", "gh", "233" ], [ "Gibraltar", "gi", "350" ], [ "Greece (Ελλάδα)", "gr", "30" ], [ "Greenland (Kalaallit Nunaat)", "gl", "299" ], [ "Grenada", "gd", "1", 14, [ "473" ] ], [ "Guadeloupe", "gp", "590", 0 ], [ "Guam", "gu", "1", 15, [ "671" ] ], [ "Guatemala", "gt", "502" ], [ "Guernsey", "gg", "44", 1, [ "1481", "7781", "7839", "7911" ] ], [ "Guinea (Guinée)", "gn", "224" ], [ "Guinea-Bissau (Guiné Bissau)", "gw", "245" ], [ "Guyana", "gy", "592" ], [ "Haiti", "ht", "509" ], [ "Honduras", "hn", "504" ], [ "Hong Kong (香港)", "hk", "852" ], [ "Hungary (Magyarország)", "hu", "36" ], [ "Iceland (Ísland)", "is", "354" ], [ "India (भारत)", "in", "91" ], [ "Indonesia", "id", "62" ], [ "Iran (‫ایران‬‎)", "ir", "98" ], [ "Iraq (‫العراق‬‎)", "iq", "964" ], [ "Ireland", "ie", "353" ], [ "Isle of Man", "im", "44", 2, [ "1624", "74576", "7524", "7924", "7624" ] ], [ "Israel (‫ישראל‬‎)", "il", "972" ], [ "Italy (Italia)", "it", "39", 0 ], [ "Jamaica", "jm", "1", 4, [ "876", "658" ] ], [ "Japan (日本)", "jp", "81" ], [ "Jersey", "je", "44", 3, [ "1534", "7509", "7700", "7797", "7829", "7937" ] ], [ "Jordan (‫الأردن‬‎)", "jo", "962" ], [ "Kazakhstan (Казахстан)", "kz", "7", 1, [ "33", "7" ] ], [ "Kenya", "ke", "254" ], [ "Kiribati", "ki", "686" ], [ "Kosovo", "xk", "383" ], [ "Kuwait (‫الكويت‬‎)", "kw", "965" ], [ "Kyrgyzstan (Кыргызстан)", "kg", "996" ], [ "Laos (ລາວ)", "la", "856" ], [ "Latvia (Latvija)", "lv", "371" ], [ "Lebanon (‫لبنان‬‎)", "lb", "961" ], [ "Lesotho", "ls", "266" ], [ "Liberia", "lr", "231" ], [ "Libya (‫ليبيا‬‎)", "ly", "218" ], [ "Liechtenstein", "li", "423" ], [ "Lithuania (Lietuva)", "lt", "370" ], [ "Luxembourg", "lu", "352" ], [ "Macau (澳門)", "mo", "853" ], [ "Macedonia (FYROM) (Македонија)", "mk", "389" ], [ "Madagascar (Madagasikara)", "mg", "261" ], [ "Malawi", "mw", "265" ], [ "Malaysia", "my", "60" ], [ "Maldives", "mv", "960" ], [ "Mali", "ml", "223" ], [ "Malta", "mt", "356" ], [ "Marshall Islands", "mh", "692" ], [ "Martinique", "mq", "596" ], [ "Mauritania (‫موريتانيا‬‎)", "mr", "222" ], [ "Mauritius (Moris)", "mu", "230" ], [ "Mayotte", "yt", "262", 1, [ "269", "639" ] ], [ "Mexico (México)", "mx", "52" ], [ "Micronesia", "fm", "691" ], [ "Moldova (Republica Moldova)", "md", "373" ], [ "Monaco", "mc", "377" ], [ "Mongolia (Монгол)", "mn", "976" ], [ "Montenegro (Crna Gora)", "me", "382" ], [ "Montserrat", "ms", "1", 16, [ "664" ] ], [ "Morocco (‫المغرب‬‎)", "ma", "212", 0 ], [ "Mozambique (Moçambique)", "mz", "258" ], [ "Myanmar (Burma) (မြန်မာ)", "mm", "95" ], [ "Namibia (Namibië)", "na", "264" ], [ "Nauru", "nr", "674" ], [ "Nepal (नेपाल)", "np", "977" ], [ "Netherlands (Nederland)", "nl", "31" ], [ "New Caledonia (Nouvelle-Calédonie)", "nc", "687" ], [ "New Zealand", "nz", "64" ], [ "Nicaragua", "ni", "505" ], [ "Niger (Nijar)", "ne", "227" ], [ "Nigeria", "ng", "234" ], [ "Niue", "nu", "683" ], [ "Norfolk Island", "nf", "672" ], [ "North Korea (조선 민주주의 인민 공화국)", "kp", "850" ], [ "Northern Mariana Islands", "mp", "1", 17, [ "670" ] ], [ "Norway (Norge)", "no", "47", 0 ], [ "Oman (‫عُمان‬‎)", "om", "968" ], [ "Pakistan (‫پاکستان‬‎)", "pk", "92" ], [ "Palau", "pw", "680" ], [ "Palestine (‫فلسطين‬‎)", "ps", "970" ], [ "Panama (Panamá)", "pa", "507" ], [ "Papua New Guinea", "pg", "675" ], [ "Paraguay", "py", "595" ], [ "Peru (Perú)", "pe", "51" ], [ "Philippines", "ph", "63" ], [ "Poland (Polska)", "pl", "48" ], [ "Portugal", "pt", "351" ], [ "Puerto Rico", "pr", "1", 3, [ "787", "939" ] ], [ "Qatar (‫قطر‬‎)", "qa", "974" ], [ "Réunion (La Réunion)", "re", "262", 0 ], [ "Romania (România)", "ro", "40" ], [ "Russia (Россия)", "ru", "7", 0 ], [ "Rwanda", "rw", "250" ], [ "Saint Barthélemy", "bl", "590", 1 ], [ "Saint Helena", "sh", "290" ], [ "Saint Kitts and Nevis", "kn", "1", 18, [ "869" ] ], [ "Saint Lucia", "lc", "1", 19, [ "758" ] ], [ "Saint Martin (Saint-Martin (partie française))", "mf", "590", 2 ], [ "Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)", "pm", "508" ], [ "Saint Vincent and the Grenadines", "vc", "1", 20, [ "784" ] ], [ "Samoa", "ws", "685" ], [ "San Marino", "sm", "378" ], [ "São Tomé and Príncipe (São Tomé e Príncipe)", "st", "239" ], [ "Saudi Arabia (‫المملكة العربية السعودية‬‎)", "sa", "966" ], [ "Senegal (Sénégal)", "sn", "221" ], [ "Serbia (Србија)", "rs", "381" ], [ "Seychelles", "sc", "248" ], [ "Sierra Leone", "sl", "232" ], [ "Singapore", "sg", "65" ], [ "Sint Maarten", "sx", "1", 21, [ "721" ] ], [ "Slovakia (Slovensko)", "sk", "421" ], [ "Slovenia (Slovenija)", "si", "386" ], [ "Solomon Islands", "sb", "677" ], [ "Somalia (Soomaaliya)", "so", "252" ], [ "South Africa", "za", "27" ], [ "South Korea (대한민국)", "kr", "82" ], [ "South Sudan (‫جنوب السودان‬‎)", "ss", "211" ], [ "Spain (España)", "es", "34" ], [ "Sri Lanka (ශ්‍රී ලංකාව)", "lk", "94" ], [ "Sudan (‫السودان‬‎)", "sd", "249" ], [ "Suriname", "sr", "597" ], [ "Svalbard and Jan Mayen", "sj", "47", 1, [ "79" ] ], [ "Swaziland", "sz", "268" ], [ "Sweden (Sverige)", "se", "46" ], [ "Switzerland (Schweiz)", "ch", "41" ], [ "Syria (‫سوريا‬‎)", "sy", "963" ], [ "Taiwan (台灣)", "tw", "886" ], [ "Tajikistan", "tj", "992" ], [ "Tanzania", "tz", "255" ], [ "Thailand (ไทย)", "th", "66" ], [ "Timor-Leste", "tl", "670" ], [ "Togo", "tg", "228" ], [ "Tokelau", "tk", "690" ], [ "Tonga", "to", "676" ], [ "Trinidad and Tobago", "tt", "1", 22, [ "868" ] ], [ "Tunisia (‫تونس‬‎)", "tn", "216" ], [ "Turkey (Türkiye)", "tr", "90" ], [ "Turkmenistan", "tm", "993" ], [ "Turks and Caicos Islands", "tc", "1", 23, [ "649" ] ], [ "Tuvalu", "tv", "688" ], [ "U.S. Virgin Islands", "vi", "1", 24, [ "340" ] ], [ "Uganda", "ug", "256" ], [ "Ukraine (Україна)", "ua", "380" ], [ "United Arab Emirates (‫الإمارات العربية المتحدة‬‎)", "ae", "971" ], [ "United Kingdom", "gb", "44", 0 ], [ "United States", "us", "1", 0 ], [ "Uruguay", "uy", "598" ], [ "Uzbekistan (Oʻzbekiston)", "uz", "998" ], [ "Vanuatu", "vu", "678" ], [ "Vatican City (Città del Vaticano)", "va", "39", 1, [ "06698" ] ], [ "Venezuela", "ve", "58" ], [ "Vietnam (Việt Nam)", "vn", "84" ], [ "Wallis and Futuna (Wallis-et-Futuna)", "wf", "681" ], [ "Western Sahara (‫الصحراء الغربية‬‎)", "eh", "212", 1, [ "5288", "5289" ] ], [ "Yemen (‫اليمن‬‎)", "ye", "967" ], [ "Zambia", "zm", "260" ], [ "Zimbabwe", "zw", "263" ], [ "Åland Islands", "ax", "358", 1, [ "18" ] ] ];
        // loop over all of the countries above, restructuring the data to be objects with named keys
        for (var i = 0; i < allCountries.length; i++) {
            var c = allCountries[i];
            allCountries[i] = {
                name: c[0],
                iso2: c[1],
                dialCode: c[2],
                priority: c[3] || 0,
                areaCodes: c[4] || null
            };
        }
        "use strict";
        function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
                throw new TypeError("Cannot call a class as a function");
            }
        }
        function _defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }
        function _createClass(Constructor, protoProps, staticProps) {
            if (protoProps) _defineProperties(Constructor.prototype, protoProps);
            if (staticProps) _defineProperties(Constructor, staticProps);
            return Constructor;
        }
        window.intlTelInputGlobals = {
            getInstance: function getInstance(input) {
                var id = input.getAttribute("data-intl-tel-input-id");
                return window.intlTelInputGlobals.instances[id];
            },
            instances: {}
        };
        // these vars persist through all instances of the plugin
        var id = 0;
        var defaults = {
            // whether or not to allow the dropdown
            allowDropdown: true,
            // if there is just a dial code in the input: remove it on blur
            autoHideDialCode: true,
            // add a placeholder in the input with an example number for the selected country
            autoPlaceholder: "polite",
            // modify the parentClass
            customContainer: "",
            // modify the auto placeholder
            customPlaceholder: null,
            // append menu to specified element
            dropdownContainer: null,
            // don't display these countries
            excludeCountries: [],
            // format the input value during initialisation and on setNumber
            formatOnDisplay: true,
            // geoIp lookup function
            geoIpLookup: null,
            // inject a hidden input with this name, and on submit, populate it with the result of getNumber
            hiddenInput: "",
            // initial country
            initialCountry: "",
            // localized country names e.g. { 'de': 'Deutschland' }
            localizedCountries: null,
            // don't insert international dial codes
            nationalMode: true,
            // display only these countries
            onlyCountries: [],
            // number type to use for placeholders
            placeholderNumberType: "MOBILE",
            // the countries at the top of the list. defaults to united states and united kingdom
            preferredCountries: [ "us", "gb" ],
            // display the country dial code next to the selected flag so it's not part of the typed number
            separateDialCode: false,
            // specify the path to the libphonenumber script to enable validation/formatting
            utilsScript: ""
        };
        // https://en.wikipedia.org/wiki/List_of_North_American_Numbering_Plan_area_codes#Non-geographic_area_codes
        var regionlessNanpNumbers = [ "800", "822", "833", "844", "855", "866", "877", "880", "881", "882", "883", "884", "885", "886", "887", "888", "889" ];
        // keep track of if the window.load event has fired as impossible to check after the fact
        window.addEventListener("load", function() {
            // UPDATE: use a public static field so we can fudge it in the tests
            window.intlTelInputGlobals.windowLoaded = true;
        });
        // utility function to iterate over an object. can't use Object.entries or native forEach because
        // of IE11
        var forEachProp = function forEachProp(obj, callback) {
            var keys = Object.keys(obj);
            for (var i = 0; i < keys.length; i++) {
                callback(keys[i], obj[keys[i]]);
            }
        };
        // run a method on each instance of the plugin
        var forEachInstance = function forEachInstance(method) {
            forEachProp(window.intlTelInputGlobals.instances, function(key) {
                window.intlTelInputGlobals.instances[key][method]();
            });
        };
        // this is our plugin class that we will create an instance of
        // eslint-disable-next-line no-unused-vars
        var Iti = /*#__PURE__*/
        function() {
            function Iti(input, options) {
                var _this = this;
                _classCallCheck(this, Iti);
                this.id = id++;
                this.telInput = input;
                this.activeItem = null;
                this.highlightedItem = null;
                // process specified options / defaults
                // alternative to Object.assign, which isn't supported by IE11
                var customOptions = options || {};
                this.options = {};
                forEachProp(defaults, function(key, value) {
                    _this.options[key] = customOptions.hasOwnProperty(key) ? customOptions[key] : value;
                });
                this.hadInitialPlaceholder = Boolean(input.getAttribute("placeholder"));
            }
            _createClass(Iti, [ {
                key: "_init",
                value: function _init() {
                    var _this2 = this;
                    // if in nationalMode, disable options relating to dial codes
                    if (this.options.nationalMode) this.options.autoHideDialCode = false;
                    // if separateDialCode then doesn't make sense to A) insert dial code into input
                    // (autoHideDialCode), and B) display national numbers (because we're displaying the country
                    // dial code next to them)
                    if (this.options.separateDialCode) {
                        this.options.autoHideDialCode = this.options.nationalMode = false;
                    }
                    // we cannot just test screen size as some smartphones/website meta tags will report desktop
                    // resolutions
                    // Note: for some reason jasmine breaks if you put this in the main Plugin function with the
                    // rest of these declarations
                    // Note: to target Android Mobiles (and not Tablets), we must find 'Android' and 'Mobile'
                    this.isMobile = /Android.+Mobile|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
                    if (this.isMobile) {
                        // trigger the mobile dropdown css
                        document.body.classList.add("iti-mobile");
                        // on mobile, we want a full screen dropdown, so we must append it to the body
                        if (!this.options.dropdownContainer) this.options.dropdownContainer = document.body;
                    }
                    // these promises get resolved when their individual requests complete
                    // this way the dev can do something like iti.promise.then(...) to know when all requests are
                    // complete
                    if (typeof Promise !== "undefined") {
                        var autoCountryPromise = new Promise(function(resolve, reject) {
                            _this2.resolveAutoCountryPromise = resolve;
                            _this2.rejectAutoCountryPromise = reject;
                        });
                        var utilsScriptPromise = new Promise(function(resolve, reject) {
                            _this2.resolveUtilsScriptPromise = resolve;
                            _this2.rejectUtilsScriptPromise = reject;
                        });
                        this.promise = Promise.all([ autoCountryPromise, utilsScriptPromise ]);
                    } else {
                        // prevent errors when Promise doesn't exist
                        this.resolveAutoCountryPromise = this.rejectAutoCountryPromise = function() {};
                        this.resolveUtilsScriptPromise = this.rejectUtilsScriptPromise = function() {};
                    }
                    // in various situations there could be no country selected initially, but we need to be able
                    // to assume this variable exists
                    this.selectedCountryData = {};
                    // process all the data: onlyCountries, excludeCountries, preferredCountries etc
                    this._processCountryData();
                    // generate the markup
                    this._generateMarkup();
                    // set the initial state of the input value and the selected flag
                    this._setInitialState();
                    // start all of the event listeners: autoHideDialCode, input keydown, selectedFlag click
                    this._initListeners();
                    // utils script, and auto country
                    this._initRequests();
                }
            }, {
                key: "_processCountryData",
                value: function _processCountryData() {
                    // process onlyCountries or excludeCountries array if present
                    this._processAllCountries();
                    // process the countryCodes map
                    this._processCountryCodes();
                    // process the preferredCountries
                    this._processPreferredCountries();
                    // translate countries according to localizedCountries option
                    if (this.options.localizedCountries) this._translateCountriesByLocale();
                    // sort countries by name
                    if (this.options.onlyCountries.length || this.options.localizedCountries) {
                        this.countries.sort(this._countryNameSort);
                    }
                }
            }, {
                key: "_addCountryCode",
                value: function _addCountryCode(iso2, dialCode, priority) {
                    if (dialCode.length > this.dialCodeMaxLen) {
                        this.dialCodeMaxLen = dialCode.length;
                    }
                    if (!this.countryCodes.hasOwnProperty(dialCode)) {
                        this.countryCodes[dialCode] = [];
                    }
                    // bail if we already have this country for this dialCode
                    for (var i = 0; i < this.countryCodes[dialCode].length; i++) {
                        if (this.countryCodes[dialCode][i] === iso2) return;
                    }
                    // check for undefined as 0 is falsy
                    var index = priority !== undefined ? priority : this.countryCodes[dialCode].length;
                    this.countryCodes[dialCode][index] = iso2;
                }
            }, {
                key: "_processAllCountries",
                value: function _processAllCountries() {
                    if (this.options.onlyCountries.length) {
                        var lowerCaseOnlyCountries = this.options.onlyCountries.map(function(country) {
                            return country.toLowerCase();
                        });
                        this.countries = allCountries.filter(function(country) {
                            return lowerCaseOnlyCountries.indexOf(country.iso2) > -1;
                        });
                    } else if (this.options.excludeCountries.length) {
                        var lowerCaseExcludeCountries = this.options.excludeCountries.map(function(country) {
                            return country.toLowerCase();
                        });
                        this.countries = allCountries.filter(function(country) {
                            return lowerCaseExcludeCountries.indexOf(country.iso2) === -1;
                        });
                    } else {
                        this.countries = allCountries;
                    }
                }
            }, {
                key: "_translateCountriesByLocale",
                value: function _translateCountriesByLocale() {
                    for (var i = 0; i < this.countries.length; i++) {
                        var iso = this.countries[i].iso2.toLowerCase();
                        if (this.options.localizedCountries.hasOwnProperty(iso)) {
                            this.countries[i].name = this.options.localizedCountries[iso];
                        }
                    }
                }
            }, {
                key: "_countryNameSort",
                value: function _countryNameSort(a, b) {
                    return a.name.localeCompare(b.name);
                }
            }, {
                key: "_processCountryCodes",
                value: function _processCountryCodes() {
                    this.dialCodeMaxLen = 0;
                    this.countryCodes = {};
                    // first: add dial codes
                    for (var i = 0; i < this.countries.length; i++) {
                        var c = this.countries[i];
                        this._addCountryCode(c.iso2, c.dialCode, c.priority);
                    }
                    // next: add area codes
                    // this is a second loop over countries, to make sure we have all of the "root" countries
                    // already in the map, so that we can access them, as each time we add an area code substring
                    // to the map, we also need to include the "root" country's code, as that also matches
                    for (var _i = 0; _i < this.countries.length; _i++) {
                        var _c = this.countries[_i];
                        // area codes
                        if (_c.areaCodes) {
                            var rootCountryCode = this.countryCodes[_c.dialCode][0];
                            // for each area code
                            for (var j = 0; j < _c.areaCodes.length; j++) {
                                var areaCode = _c.areaCodes[j];
                                // for each digit in the area code to add all partial matches as well
                                for (var k = 1; k < areaCode.length; k++) {
                                    var partialDialCode = _c.dialCode + areaCode.substr(0, k);
                                    // start with the root country, as that also matches this dial code
                                    this._addCountryCode(rootCountryCode, partialDialCode);
                                    this._addCountryCode(_c.iso2, partialDialCode);
                                }
                                // add the full area code
                                this._addCountryCode(_c.iso2, _c.dialCode + areaCode);
                            }
                        }
                    }
                }
            }, {
                key: "_processPreferredCountries",
                value: function _processPreferredCountries() {
                    this.preferredCountries = [];
                    for (var i = 0; i < this.options.preferredCountries.length; i++) {
                        var countryCode = this.options.preferredCountries[i].toLowerCase();
                        var countryData = this._getCountryData(countryCode, false, true);
                        if (countryData) this.preferredCountries.push(countryData);
                    }
                }
            }, {
                key: "_createEl",
                value: function _createEl(name, attrs, container) {
                    var el = document.createElement(name);
                    if (attrs) forEachProp(attrs, function(key, value) {
                        return el.setAttribute(key, value);
                    });
                    if (container) container.appendChild(el);
                    return el;
                }
            }, {
                key: "_generateMarkup",
                value: function _generateMarkup() {
                    // prevent autocomplete as there's no safe, cross-browser event we can react to, so it can
                    // easily put the plugin in an inconsistent state e.g. the wrong flag selected for the
                    // autocompleted number, which on submit could mean wrong number is saved (esp in nationalMode)
                    this.telInput.setAttribute("autocomplete", "off");
                    // containers (mostly for positioning)
                    var parentClass = "iti";
                    if (this.options.allowDropdown) parentClass += " iti--allow-dropdown";
                    if (this.options.separateDialCode) parentClass += " iti--separate-dial-code";
                    if (this.options.customContainer) {
                        parentClass += " ";
                        parentClass += this.options.customContainer;
                    }
                    var wrapper = this._createEl("div", {
                        "class": parentClass
                    });
                    this.telInput.parentNode.insertBefore(wrapper, this.telInput);
                    this.flagsContainer = this._createEl("div", {
                        "class": "iti__flag-container"
                    }, wrapper);
                    wrapper.appendChild(this.telInput);
                    // selected flag (displayed to left of input)
                    this.selectedFlag = this._createEl("div", {
                        "class": "iti__selected-flag",
                        role: "combobox",
                        "aria-owns": "country-listbox"
                    }, this.flagsContainer);
                    this.selectedFlagInner = this._createEl("div", {
                        "class": "iti__flag"
                    }, this.selectedFlag);
                    if (this.options.separateDialCode) {
                        this.selectedDialCode = this._createEl("div", {
                            "class": "iti__selected-dial-code"
                        }, this.selectedFlag);
                    }
                    if (this.options.allowDropdown) {
                        // make element focusable and tab navigable
                        this.selectedFlag.setAttribute("tabindex", "0");
                        this.dropdownArrow = this._createEl("div", {
                            "class": "iti__arrow"
                        }, this.selectedFlag);
                        // country dropdown: preferred countries, then divider, then all countries
                        this.countryList = this._createEl("ul", {
                            "class": "iti__country-list iti__hide",
                            id: "country-listbox",
                            "aria-expanded": "false",
                            role: "listbox"
                        });
                        if (this.preferredCountries.length) {
                            this._appendListItems(this.preferredCountries, "iti__preferred");
                            this._createEl("li", {
                                "class": "iti__divider",
                                role: "separator",
                                "aria-disabled": "true"
                            }, this.countryList);
                        }
                        this._appendListItems(this.countries, "iti__standard");
                        // create dropdownContainer markup
                        if (this.options.dropdownContainer) {
                            this.dropdown = this._createEl("div", {
                                "class": "iti iti--container"
                            });
                            this.dropdown.appendChild(this.countryList);
                        } else {
                            this.flagsContainer.appendChild(this.countryList);
                        }
                    }
                    if (this.options.hiddenInput) {
                        var hiddenInputName = this.options.hiddenInput;
                        var name = this.telInput.getAttribute("name");
                        if (name) {
                            var i = name.lastIndexOf("[");
                            // if input name contains square brackets, then give the hidden input the same name,
                            // replacing the contents of the last set of brackets with the given hiddenInput name
                            if (i !== -1) hiddenInputName = "".concat(name.substr(0, i), "[").concat(hiddenInputName, "]");
                        }
                        this.hiddenInput = this._createEl("input", {
                            type: "hidden",
                            name: hiddenInputName
                        });
                        wrapper.appendChild(this.hiddenInput);
                    }
                }
            }, {
                key: "_appendListItems",
                value: function _appendListItems(countries, className) {
                    // we create so many DOM elements, it is faster to build a temp string
                    // and then add everything to the DOM in one go at the end
                    var tmp = "";
                    // for each country
                    for (var i = 0; i < countries.length; i++) {
                        var c = countries[i];
                        // open the list item
                        tmp += "<li class='iti__country ".concat(className, "' tabIndex='-1' id='iti-item-").concat(c.iso2, "' role='option' data-dial-code='").concat(c.dialCode, "' data-country-code='").concat(c.iso2, "'>");
                        // add the flag
                        tmp += "<div class='iti__flag-box'><div class='iti__flag iti__".concat(c.iso2, "'></div></div>");
                        // and the country name and dial code
                        tmp += "<span class='iti__country-name'>".concat(c.name, "</span>");
                        tmp += "<span class='iti__dial-code'>+".concat(c.dialCode, "</span>");
                        // close the list item
                        tmp += "</li>";
                    }
                    this.countryList.insertAdjacentHTML("beforeend", tmp);
                }
            }, {
                key: "_setInitialState",
                value: function _setInitialState() {
                    var val = this.telInput.value;
                    var dialCode = this._getDialCode(val);
                    var isRegionlessNanp = this._isRegionlessNanp(val);
                    var _this$options = this.options, initialCountry = _this$options.initialCountry, nationalMode = _this$options.nationalMode, autoHideDialCode = _this$options.autoHideDialCode, separateDialCode = _this$options.separateDialCode;
                    // if we already have a dial code, and it's not a regionlessNanp, we can go ahead and set the
                    // flag, else fall back to the default country
                    if (dialCode && !isRegionlessNanp) {
                        this._updateFlagFromNumber(val);
                    } else if (initialCountry !== "auto") {
                        // see if we should select a flag
                        if (initialCountry) {
                            this._setFlag(initialCountry.toLowerCase());
                        } else {
                            if (dialCode && isRegionlessNanp) {
                                // has intl dial code, is regionless nanp, and no initialCountry, so default to US
                                this._setFlag("us");
                            } else {
                                // no dial code and no initialCountry, so default to first in list
                                this.defaultCountry = this.preferredCountries.length ? this.preferredCountries[0].iso2 : this.countries[0].iso2;
                                if (!val) {
                                    this._setFlag(this.defaultCountry);
                                }
                            }
                        }
                        // if empty and no nationalMode and no autoHideDialCode then insert the default dial code
                        if (!val && !nationalMode && !autoHideDialCode && !separateDialCode) {
                            this.telInput.value = "+".concat(this.selectedCountryData.dialCode);
                        }
                    }
                    // NOTE: if initialCountry is set to auto, that will be handled separately
                    // format - note this wont be run after _updateDialCode as that's only called if no val
                    if (val) this._updateValFromNumber(val);
                }
            }, {
                key: "_initListeners",
                value: function _initListeners() {
                    this._initKeyListeners();
                    if (this.options.autoHideDialCode) this._initBlurListeners();
                    if (this.options.allowDropdown) this._initDropdownListeners();
                    if (this.hiddenInput) this._initHiddenInputListener();
                }
            }, {
                key: "_initHiddenInputListener",
                value: function _initHiddenInputListener() {
                    var _this3 = this;
                    this._handleHiddenInputSubmit = function() {
                        _this3.hiddenInput.value = _this3.getNumber();
                    };
                    if (this.telInput.form) this.telInput.form.addEventListener("submit", this._handleHiddenInputSubmit);
                }
            }, {
                key: "_getClosestLabel",
                value: function _getClosestLabel() {
                    var el = this.telInput;
                    while (el && el.tagName !== "LABEL") {
                        el = el.parentNode;
                    }
                    return el;
                }
            }, {
                key: "_initDropdownListeners",
                value: function _initDropdownListeners() {
                    var _this4 = this;
                    // hack for input nested inside label (which is valid markup): clicking the selected-flag to
                    // open the dropdown would then automatically trigger a 2nd click on the input which would
                    // close it again
                    this._handleLabelClick = function(e) {
                        // if the dropdown is closed, then focus the input, else ignore the click
                        if (_this4.countryList.classList.contains("iti__hide")) _this4.telInput.focus(); else e.preventDefault();
                    };
                    var label = this._getClosestLabel();
                    if (label) label.addEventListener("click", this._handleLabelClick);
                    // toggle country dropdown on click
                    this._handleClickSelectedFlag = function() {
                        // only intercept this event if we're opening the dropdown
                        // else let it bubble up to the top ("click-off-to-close" listener)
                        // we cannot just stopPropagation as it may be needed to close another instance
                        if (_this4.countryList.classList.contains("iti__hide") && !_this4.telInput.disabled && !_this4.telInput.readOnly) {
                            _this4._showDropdown();
                        }
                    };
                    this.selectedFlag.addEventListener("click", this._handleClickSelectedFlag);
                    // open dropdown list if currently focused
                    this._handleFlagsContainerKeydown = function(e) {
                        var isDropdownHidden = _this4.countryList.classList.contains("iti__hide");
                        if (isDropdownHidden && [ "ArrowUp", "Up", "ArrowDown", "Down", " ", "Enter" ].indexOf(e.key) !== -1) {
                            // prevent form from being submitted if "ENTER" was pressed
                            e.preventDefault();
                            // prevent event from being handled again by document
                            e.stopPropagation();
                            _this4._showDropdown();
                        }
                        // allow navigation from dropdown to input on TAB
                        if (e.key === "Tab") _this4._closeDropdown();
                    };
                    this.flagsContainer.addEventListener("keydown", this._handleFlagsContainerKeydown);
                }
            }, {
                key: "_initRequests",
                value: function _initRequests() {
                    var _this5 = this;
                    // if the user has specified the path to the utils script, fetch it on window.load, else resolve
                    if (this.options.utilsScript && !window.intlTelInputUtils) {
                        // if the plugin is being initialised after the window.load event has already been fired
                        if (window.intlTelInputGlobals.windowLoaded) {
                            window.intlTelInputGlobals.loadUtils(this.options.utilsScript);
                        } else {
                            // wait until the load event so we don't block any other requests e.g. the flags image
                            window.addEventListener("load", function() {
                                window.intlTelInputGlobals.loadUtils(_this5.options.utilsScript);
                            });
                        }
                    } else this.resolveUtilsScriptPromise();
                    if (this.options.initialCountry === "auto") this._loadAutoCountry(); else this.resolveAutoCountryPromise();
                }
            }, {
                key: "_loadAutoCountry",
                value: function _loadAutoCountry() {
                    // 3 options:
                    // 1) already loaded (we're done)
                    // 2) not already started loading (start)
                    // 3) already started loading (do nothing - just wait for loading callback to fire)
                    if (window.intlTelInputGlobals.autoCountry) {
                        this.handleAutoCountry();
                    } else if (!window.intlTelInputGlobals.startedLoadingAutoCountry) {
                        // don't do this twice!
                        window.intlTelInputGlobals.startedLoadingAutoCountry = true;
                        if (typeof this.options.geoIpLookup === "function") {
                            this.options.geoIpLookup(function(countryCode) {
                                window.intlTelInputGlobals.autoCountry = countryCode.toLowerCase();
                                // tell all instances the auto country is ready
                                // TODO: this should just be the current instances
                                // UPDATE: use setTimeout in case their geoIpLookup function calls this callback straight
                                // away (e.g. if they have already done the geo ip lookup somewhere else). Using
                                // setTimeout means that the current thread of execution will finish before executing
                                // this, which allows the plugin to finish initialising.
                                setTimeout(function() {
                                    return forEachInstance("handleAutoCountry");
                                });
                            }, function() {
                                return forEachInstance("rejectAutoCountryPromise");
                            });
                        }
                    }
                }
            }, {
                key: "_initKeyListeners",
                value: function _initKeyListeners() {
                    var _this6 = this;
                    // update flag on keyup
                    this._handleKeyupEvent = function() {
                        if (_this6._updateFlagFromNumber(_this6.telInput.value)) {
                            _this6._triggerCountryChange();
                        }
                    };
                    this.telInput.addEventListener("keyup", this._handleKeyupEvent);
                    // update flag on cut/paste events (now supported in all major browsers)
                    this._handleClipboardEvent = function() {
                        // hack because "paste" event is fired before input is updated
                        setTimeout(_this6._handleKeyupEvent);
                    };
                    this.telInput.addEventListener("cut", this._handleClipboardEvent);
                    this.telInput.addEventListener("paste", this._handleClipboardEvent);
                }
            }, {
                key: "_cap",
                value: function _cap(number) {
                    var max = this.telInput.getAttribute("maxlength");
                    return max && number.length > max ? number.substr(0, max) : number;
                }
            }, {
                key: "_initBlurListeners",
                value: function _initBlurListeners() {
                    var _this7 = this;
                    // on blur or form submit: if just a dial code then remove it
                    this._handleSubmitOrBlurEvent = function() {
                        _this7._removeEmptyDialCode();
                    };
                    if (this.telInput.form) this.telInput.form.addEventListener("submit", this._handleSubmitOrBlurEvent);
                    this.telInput.addEventListener("blur", this._handleSubmitOrBlurEvent);
                }
            }, {
                key: "_removeEmptyDialCode",
                value: function _removeEmptyDialCode() {
                    if (this.telInput.value.charAt(0) === "+") {
                        var numeric = this._getNumeric(this.telInput.value);
                        // if just a plus, or if just a dial code
                        if (!numeric || this.selectedCountryData.dialCode === numeric) {
                            this.telInput.value = "";
                        }
                    }
                }
            }, {
                key: "_getNumeric",
                value: function _getNumeric(s) {
                    return s.replace(/\D/g, "");
                }
            }, {
                key: "_trigger",
                value: function _trigger(name) {
                    // have to use old school document.createEvent as IE11 doesn't support `new Event()` syntax
                    var e = document.createEvent("Event");
                    e.initEvent(name, true, true);
                    // can bubble, and is cancellable
                    this.telInput.dispatchEvent(e);
                }
            }, {
                key: "_showDropdown",
                value: function _showDropdown() {
                    this.countryList.classList.remove("iti__hide");
                    this.countryList.setAttribute("aria-expanded", "true");
                    this._setDropdownPosition();
                    // update highlighting and scroll to active list item
                    if (this.activeItem) {
                        this._highlightListItem(this.activeItem, false);
                        this._scrollTo(this.activeItem, true);
                    }
                    // bind all the dropdown-related listeners: mouseover, click, click-off, keydown
                    this._bindDropdownListeners();
                    // update the arrow
                    this.dropdownArrow.classList.add("iti__arrow--up");
                    this._trigger("open:countrydropdown");
                }
            }, {
                key: "_toggleClass",
                value: function _toggleClass(el, className, shouldHaveClass) {
                    if (shouldHaveClass && !el.classList.contains(className)) el.classList.add(className); else if (!shouldHaveClass && el.classList.contains(className)) el.classList.remove(className);
                }
            }, {
                key: "_setDropdownPosition",
                value: function _setDropdownPosition() {
                    var _this8 = this;
                    if (this.options.dropdownContainer) {
                        this.options.dropdownContainer.appendChild(this.dropdown);
                    }
                    if (!this.isMobile) {
                        var pos = this.telInput.getBoundingClientRect();
                        // windowTop from https://stackoverflow.com/a/14384091/217866
                        var windowTop = window.pageYOffset || document.documentElement.scrollTop;
                        var inputTop = pos.top + windowTop;
                        var dropdownHeight = this.countryList.offsetHeight;
                        // dropdownFitsBelow = (dropdownBottom < windowBottom)
                        var dropdownFitsBelow = inputTop + this.telInput.offsetHeight + dropdownHeight < windowTop + window.innerHeight;
                        var dropdownFitsAbove = inputTop - dropdownHeight > windowTop;
                        // by default, the dropdown will be below the input. If we want to position it above the
                        // input, we add the dropup class.
                        this._toggleClass(this.countryList, "iti__country-list--dropup", !dropdownFitsBelow && dropdownFitsAbove);
                        // if dropdownContainer is enabled, calculate postion
                        if (this.options.dropdownContainer) {
                            // by default the dropdown will be directly over the input because it's not in the flow.
                            // If we want to position it below, we need to add some extra top value.
                            var extraTop = !dropdownFitsBelow && dropdownFitsAbove ? 0 : this.telInput.offsetHeight;
                            // calculate placement
                            this.dropdown.style.top = "".concat(inputTop + extraTop, "px");
                            this.dropdown.style.left = "".concat(pos.left + document.body.scrollLeft, "px");
                            // close menu on window scroll
                            this._handleWindowScroll = function() {
                                return _this8._closeDropdown();
                            };
                            window.addEventListener("scroll", this._handleWindowScroll);
                        }
                    }
                }
            }, {
                key: "_getClosestListItem",
                value: function _getClosestListItem(target) {
                    var el = target;
                    while (el && el !== this.countryList && !el.classList.contains("iti__country")) {
                        el = el.parentNode;
                    }
                    // if we reached the countryList element, then return null
                    return el === this.countryList ? null : el;
                }
            }, {
                key: "_bindDropdownListeners",
                value: function _bindDropdownListeners() {
                    var _this9 = this;
                    // when mouse over a list item, just highlight that one
                    // we add the class "highlight", so if they hit "enter" we know which one to select
                    this._handleMouseoverCountryList = function(e) {
                        // handle event delegation, as we're listening for this event on the countryList
                        var listItem = _this9._getClosestListItem(e.target);
                        if (listItem) _this9._highlightListItem(listItem, false);
                    };
                    this.countryList.addEventListener("mouseover", this._handleMouseoverCountryList);
                    // listen for country selection
                    this._handleClickCountryList = function(e) {
                        var listItem = _this9._getClosestListItem(e.target);
                        if (listItem) _this9._selectListItem(listItem);
                    };
                    this.countryList.addEventListener("click", this._handleClickCountryList);
                    // click off to close
                    // (except when this initial opening click is bubbling up)
                    // we cannot just stopPropagation as it may be needed to close another instance
                    var isOpening = true;
                    this._handleClickOffToClose = function() {
                        if (!isOpening) _this9._closeDropdown();
                        isOpening = false;
                    };
                    document.documentElement.addEventListener("click", this._handleClickOffToClose);
                    // listen for up/down scrolling, enter to select, or letters to jump to country name.
                    // use keydown as keypress doesn't fire for non-char keys and we want to catch if they
                    // just hit down and hold it to scroll down (no keyup event).
                    // listen on the document because that's where key events are triggered if no input has focus
                    var query = "";
                    var queryTimer = null;
                    this._handleKeydownOnDropdown = function(e) {
                        // prevent down key from scrolling the whole page,
                        // and enter key from submitting a form etc
                        e.preventDefault();
                        // up and down to navigate
                        if (e.key === "ArrowUp" || e.key === "Up" || e.key === "ArrowDown" || e.key === "Down") _this9._handleUpDownKey(e.key); else if (e.key === "Enter") _this9._handleEnterKey(); else if (e.key === "Escape") _this9._closeDropdown(); else if (/^[a-zA-ZÀ-ÿ ]$/.test(e.key)) {
                            // jump to countries that start with the query string
                            if (queryTimer) clearTimeout(queryTimer);
                            query += e.key.toLowerCase();
                            _this9._searchForCountry(query);
                            // if the timer hits 1 second, reset the query
                            queryTimer = setTimeout(function() {
                                query = "";
                            }, 1e3);
                        }
                    };
                    document.addEventListener("keydown", this._handleKeydownOnDropdown);
                }
            }, {
                key: "_handleUpDownKey",
                value: function _handleUpDownKey(key) {
                    var next = key === "ArrowUp" || key === "Up" ? this.highlightedItem.previousElementSibling : this.highlightedItem.nextElementSibling;
                    if (next) {
                        // skip the divider
                        if (next.classList.contains("iti__divider")) {
                            next = key === "ArrowUp" || key === "Up" ? next.previousElementSibling : next.nextElementSibling;
                        }
                        this._highlightListItem(next, true);
                    }
                }
            }, {
                key: "_handleEnterKey",
                value: function _handleEnterKey() {
                    if (this.highlightedItem) this._selectListItem(this.highlightedItem);
                }
            }, {
                key: "_searchForCountry",
                value: function _searchForCountry(query) {
                    for (var i = 0; i < this.countries.length; i++) {
                        if (this._startsWith(this.countries[i].name, query)) {
                            var listItem = this.countryList.querySelector("#iti-item-".concat(this.countries[i].iso2));
                            // update highlighting and scroll
                            this._highlightListItem(listItem, false);
                            this._scrollTo(listItem, true);
                            break;
                        }
                    }
                }
            }, {
                key: "_startsWith",
                value: function _startsWith(a, b) {
                    return a.substr(0, b.length).toLowerCase() === b;
                }
            }, {
                key: "_updateValFromNumber",
                value: function _updateValFromNumber(originalNumber) {
                    var number = originalNumber;
                    if (this.options.formatOnDisplay && window.intlTelInputUtils && this.selectedCountryData) {
                        var useNational = !this.options.separateDialCode && (this.options.nationalMode || number.charAt(0) !== "+");
                        var _intlTelInputUtils$nu = intlTelInputUtils.numberFormat, NATIONAL = _intlTelInputUtils$nu.NATIONAL, INTERNATIONAL = _intlTelInputUtils$nu.INTERNATIONAL;
                        var format = useNational ? NATIONAL : INTERNATIONAL;
                        number = intlTelInputUtils.formatNumber(number, this.selectedCountryData.iso2, format);
                    }
                    number = this._beforeSetNumber(number);
                    this.telInput.value = number;
                }
            }, {
                key: "_updateFlagFromNumber",
                value: function _updateFlagFromNumber(originalNumber) {
                    // if we're in nationalMode and we already have US/Canada selected, make sure the number starts
                    // with a +1 so _getDialCode will be able to extract the area code
                    // update: if we dont yet have selectedCountryData, but we're here (trying to update the flag
                    // from the number), that means we're initialising the plugin with a number that already has a
                    // dial code, so fine to ignore this bit
                    var number = originalNumber;
                    var selectedDialCode = this.selectedCountryData.dialCode;
                    var isNanp = selectedDialCode === "1";
                    if (number && this.options.nationalMode && isNanp && number.charAt(0) !== "+") {
                        if (number.charAt(0) !== "1") number = "1".concat(number);
                        number = "+".concat(number);
                    }
                    // update flag if user types area code for another country
                    if (this.options.separateDialCode && selectedDialCode && number.charAt(0) !== "+") {
                        number = "+".concat(selectedDialCode).concat(number);
                    }
                    // try and extract valid dial code from input
                    var dialCode = this._getDialCode(number);
                    var numeric = this._getNumeric(number);
                    var countryCode = null;
                    if (dialCode) {
                        var countryCodes = this.countryCodes[this._getNumeric(dialCode)];
                        // check if the right country is already selected. this should be false if the number is
                        // longer than the matched dial code because in this case we need to make sure that if
                        // there are multiple country matches, that the first one is selected (note: we could
                        // just check that here, but it requires the same loop that we already have later)
                        var alreadySelected = countryCodes.indexOf(this.selectedCountryData.iso2) !== -1 && numeric.length <= dialCode.length - 1;
                        var isRegionlessNanpNumber = selectedDialCode === "1" && this._isRegionlessNanp(numeric);
                        // only update the flag if:
                        // A) NOT (we currently have a NANP flag selected, and the number is a regionlessNanp)
                        // AND
                        // B) the right country is not already selected
                        if (!isRegionlessNanpNumber && !alreadySelected) {
                            // if using onlyCountries option, countryCodes[0] may be empty, so we must find the first
                            // non-empty index
                            for (var j = 0; j < countryCodes.length; j++) {
                                if (countryCodes[j]) {
                                    countryCode = countryCodes[j];
                                    break;
                                }
                            }
                        }
                    } else if (number.charAt(0) === "+" && numeric.length) {
                        // invalid dial code, so empty
                        // Note: use getNumeric here because the number has not been formatted yet, so could contain
                        // bad chars
                        countryCode = "";
                    } else if (!number || number === "+") {
                        // empty, or just a plus, so default
                        countryCode = this.defaultCountry;
                    }
                    if (countryCode !== null) {
                        return this._setFlag(countryCode);
                    }
                    return false;
                }
            }, {
                key: "_isRegionlessNanp",
                value: function _isRegionlessNanp(number) {
                    var numeric = this._getNumeric(number);
                    if (numeric.charAt(0) === "1") {
                        var areaCode = numeric.substr(1, 3);
                        return regionlessNanpNumbers.indexOf(areaCode) !== -1;
                    }
                    return false;
                }
            }, {
                key: "_highlightListItem",
                value: function _highlightListItem(listItem, shouldFocus) {
                    var prevItem = this.highlightedItem;
                    if (prevItem) prevItem.classList.remove("iti__highlight");
                    this.highlightedItem = listItem;
                    this.highlightedItem.classList.add("iti__highlight");
                    if (shouldFocus) this.highlightedItem.focus();
                }
            }, {
                key: "_getCountryData",
                value: function _getCountryData(countryCode, ignoreOnlyCountriesOption, allowFail) {
                    var countryList = ignoreOnlyCountriesOption ? allCountries : this.countries;
                    for (var i = 0; i < countryList.length; i++) {
                        if (countryList[i].iso2 === countryCode) {
                            return countryList[i];
                        }
                    }
                    if (allowFail) {
                        return null;
                    }
                    throw new Error("No country data for '".concat(countryCode, "'"));
                }
            }, {
                key: "_setFlag",
                value: function _setFlag(countryCode) {
                    var prevCountry = this.selectedCountryData.iso2 ? this.selectedCountryData : {};
                    // do this first as it will throw an error and stop if countryCode is invalid
                    this.selectedCountryData = countryCode ? this._getCountryData(countryCode, false, false) : {};
                    // update the defaultCountry - we only need the iso2 from now on, so just store that
                    if (this.selectedCountryData.iso2) {
                        this.defaultCountry = this.selectedCountryData.iso2;
                    }
                    this.selectedFlagInner.setAttribute("class", "iti__flag iti__".concat(countryCode));
                    // update the selected country's title attribute
                    var title = countryCode ? "".concat(this.selectedCountryData.name, ": +").concat(this.selectedCountryData.dialCode) : "Unknown";
                    this.selectedFlag.setAttribute("title", title);
                    if (this.options.separateDialCode) {
                        var dialCode = this.selectedCountryData.dialCode ? "+".concat(this.selectedCountryData.dialCode) : "";
                        this.selectedDialCode.innerHTML = dialCode;
                        // offsetWidth is zero if input is in a hidden container during initialisation
                        var selectedFlagWidth = this.selectedFlag.offsetWidth || this._getHiddenSelectedFlagWidth();
                        // add 6px of padding after the grey selected-dial-code box, as this is what we use in the css
                        this.telInput.style.paddingLeft = "".concat(selectedFlagWidth + 6, "px");
                    }
                    // and the input's placeholder
                    this._updatePlaceholder();
                    // update the active list item
                    if (this.options.allowDropdown) {
                        var prevItem = this.activeItem;
                        if (prevItem) {
                            prevItem.classList.remove("iti__active");
                            prevItem.setAttribute("aria-selected", "false");
                        }
                        if (countryCode) {
                            var nextItem = this.countryList.querySelector("#iti-item-".concat(countryCode));
                            nextItem.setAttribute("aria-selected", "true");
                            nextItem.classList.add("iti__active");
                            this.activeItem = nextItem;
                            this.countryList.setAttribute("aria-activedescendant", nextItem.getAttribute("id"));
                        }
                    }
                    // return if the flag has changed or not
                    return prevCountry.iso2 !== countryCode;
                }
            }, {
                key: "_getHiddenSelectedFlagWidth",
                value: function _getHiddenSelectedFlagWidth() {
                    // to get the right styling to apply, all we need is a shallow clone of the container,
                    // and then to inject a deep clone of the selectedFlag element
                    var containerClone = this.telInput.parentNode.cloneNode();
                    containerClone.style.visibility = "hidden";
                    document.body.appendChild(containerClone);
                    var selectedFlagClone = this.selectedFlag.cloneNode(true);
                    containerClone.appendChild(selectedFlagClone);
                    var width = selectedFlagClone.offsetWidth;
                    containerClone.parentNode.removeChild(containerClone);
                    return width;
                }
            }, {
                key: "_updatePlaceholder",
                value: function _updatePlaceholder() {
                    var shouldSetPlaceholder = this.options.autoPlaceholder === "aggressive" || !this.hadInitialPlaceholder && this.options.autoPlaceholder === "polite";
                    if (window.intlTelInputUtils && shouldSetPlaceholder) {
                        var numberType = intlTelInputUtils.numberType[this.options.placeholderNumberType];
                        var placeholder = this.selectedCountryData.iso2 ? intlTelInputUtils.getExampleNumber(this.selectedCountryData.iso2, this.options.nationalMode, numberType) : "";
                        placeholder = this._beforeSetNumber(placeholder);
                        if (typeof this.options.customPlaceholder === "function") {
                            placeholder = this.options.customPlaceholder(placeholder, this.selectedCountryData);
                        }
                        this.telInput.setAttribute("placeholder", placeholder);
                    }
                }
            }, {
                key: "_selectListItem",
                value: function _selectListItem(listItem) {
                    // update selected flag and active list item
                    var flagChanged = this._setFlag(listItem.getAttribute("data-country-code"));
                    this._closeDropdown();
                    this._updateDialCode(listItem.getAttribute("data-dial-code"), true);
                    // focus the input
                    this.telInput.focus();
                    // put cursor at end - this fix is required for FF and IE11 (with nationalMode=false i.e. auto
                    // inserting dial code), who try to put the cursor at the beginning the first time
                    var len = this.telInput.value.length;
                    this.telInput.setSelectionRange(len, len);
                    if (flagChanged) {
                        this._triggerCountryChange();
                    }
                }
            }, {
                key: "_closeDropdown",
                value: function _closeDropdown() {
                    this.countryList.classList.add("iti__hide");
                    this.countryList.setAttribute("aria-expanded", "false");
                    // update the arrow
                    this.dropdownArrow.classList.remove("iti__arrow--up");
                    // unbind key events
                    document.removeEventListener("keydown", this._handleKeydownOnDropdown);
                    document.documentElement.removeEventListener("click", this._handleClickOffToClose);
                    this.countryList.removeEventListener("mouseover", this._handleMouseoverCountryList);
                    this.countryList.removeEventListener("click", this._handleClickCountryList);
                    // remove menu from container
                    if (this.options.dropdownContainer) {
                        if (!this.isMobile) window.removeEventListener("scroll", this._handleWindowScroll);
                        if (this.dropdown.parentNode) this.dropdown.parentNode.removeChild(this.dropdown);
                    }
                    this._trigger("close:countrydropdown");
                }
            }, {
                key: "_scrollTo",
                value: function _scrollTo(element, middle) {
                    var container = this.countryList;
                    // windowTop from https://stackoverflow.com/a/14384091/217866
                    var windowTop = window.pageYOffset || document.documentElement.scrollTop;
                    var containerHeight = container.offsetHeight;
                    var containerTop = container.getBoundingClientRect().top + windowTop;
                    var containerBottom = containerTop + containerHeight;
                    var elementHeight = element.offsetHeight;
                    var elementTop = element.getBoundingClientRect().top + windowTop;
                    var elementBottom = elementTop + elementHeight;
                    var newScrollTop = elementTop - containerTop + container.scrollTop;
                    var middleOffset = containerHeight / 2 - elementHeight / 2;
                    if (elementTop < containerTop) {
                        // scroll up
                        if (middle) newScrollTop -= middleOffset;
                        container.scrollTop = newScrollTop;
                    } else if (elementBottom > containerBottom) {
                        // scroll down
                        if (middle) newScrollTop += middleOffset;
                        var heightDifference = containerHeight - elementHeight;
                        container.scrollTop = newScrollTop - heightDifference;
                    }
                }
            }, {
                key: "_updateDialCode",
                value: function _updateDialCode(newDialCodeBare, hasSelectedListItem) {
                    var inputVal = this.telInput.value;
                    // save having to pass this every time
                    var newDialCode = "+".concat(newDialCodeBare);
                    var newNumber;
                    if (inputVal.charAt(0) === "+") {
                        // there's a plus so we're dealing with a replacement (doesn't matter if nationalMode or not)
                        var prevDialCode = this._getDialCode(inputVal);
                        if (prevDialCode) {
                            // current number contains a valid dial code, so replace it
                            newNumber = inputVal.replace(prevDialCode, newDialCode);
                        } else {
                            // current number contains an invalid dial code, so ditch it
                            // (no way to determine where the invalid dial code ends and the rest of the number begins)
                            newNumber = newDialCode;
                        }
                    } else if (this.options.nationalMode || this.options.separateDialCode) {
                        // don't do anything
                        return;
                    } else {
                        // nationalMode is disabled
                        if (inputVal) {
                            // there is an existing value with no dial code: prefix the new dial code
                            newNumber = newDialCode + inputVal;
                        } else if (hasSelectedListItem || !this.options.autoHideDialCode) {
                            // no existing value and either they've just selected a list item, or autoHideDialCode is
                            // disabled: insert new dial code
                            newNumber = newDialCode;
                        } else {
                            return;
                        }
                    }
                    this.telInput.value = newNumber;
                }
            }, {
                key: "_getDialCode",
                value: function _getDialCode(number) {
                    var dialCode = "";
                    // only interested in international numbers (starting with a plus)
                    if (number.charAt(0) === "+") {
                        var numericChars = "";
                        // iterate over chars
                        for (var i = 0; i < number.length; i++) {
                            var c = number.charAt(i);
                            // if char is number (https://stackoverflow.com/a/8935649/217866)
                            if (!isNaN(parseInt(c, 10))) {
                                numericChars += c;
                                // if current numericChars make a valid dial code
                                if (this.countryCodes[numericChars]) {
                                    // store the actual raw string (useful for matching later)
                                    dialCode = number.substr(0, i + 1);
                                }
                                if (numericChars.length === this.dialCodeMaxLen) {
                                    break;
                                }
                            }
                        }
                    }
                    return dialCode;
                }
            }, {
                key: "_getFullNumber",
                value: function _getFullNumber() {
                    var val = this.telInput.value.trim();
                    var dialCode = this.selectedCountryData.dialCode;
                    var prefix;
                    var numericVal = this._getNumeric(val);
                    if (this.options.separateDialCode && val.charAt(0) !== "+" && dialCode && numericVal) {
                        // when using separateDialCode, it is visible so is effectively part of the typed number
                        prefix = "+".concat(dialCode);
                    } else {
                        prefix = "";
                    }
                    return prefix + val;
                }
            }, {
                key: "_beforeSetNumber",
                value: function _beforeSetNumber(originalNumber) {
                    var number = originalNumber;
                    if (this.options.separateDialCode) {
                        var dialCode = this._getDialCode(number);
                        // if there is a valid dial code
                        if (dialCode) {
                            // in case _getDialCode returned an area code as well
                            dialCode = "+".concat(this.selectedCountryData.dialCode);
                            // a lot of numbers will have a space separating the dial code and the main number, and
                            // some NANP numbers will have a hyphen e.g. +1 684-733-1234 - in both cases we want to get
                            // rid of it
                            // NOTE: don't just trim all non-numerics as may want to preserve an open parenthesis etc
                            var start = number[dialCode.length] === " " || number[dialCode.length] === "-" ? dialCode.length + 1 : dialCode.length;
                            number = number.substr(start);
                        }
                    }
                    return this._cap(number);
                }
            }, {
                key: "_triggerCountryChange",
                value: function _triggerCountryChange() {
                    this._trigger("countrychange");
                }
            }, {
                key: "handleAutoCountry",
                value: function handleAutoCountry() {
                    if (this.options.initialCountry === "auto") {
                        // we must set this even if there is an initial val in the input: in case the initial val is
                        // invalid and they delete it - they should see their auto country
                        this.defaultCountry = window.intlTelInputGlobals.autoCountry;
                        // if there's no initial value in the input, then update the flag
                        if (!this.telInput.value) {
                            this.setCountry(this.defaultCountry);
                        }
                        this.resolveAutoCountryPromise();
                    }
                }
            }, {
                key: "handleUtils",
                value: function handleUtils() {
                    // if the request was successful
                    if (window.intlTelInputUtils) {
                        // if there's an initial value in the input, then format it
                        if (this.telInput.value) {
                            this._updateValFromNumber(this.telInput.value);
                        }
                        this._updatePlaceholder();
                    }
                    this.resolveUtilsScriptPromise();
                }
            }, {
                key: "destroy",
                value: function destroy() {
                    var form = this.telInput.form;
                    if (this.options.allowDropdown) {
                        // make sure the dropdown is closed (and unbind listeners)
                        this._closeDropdown();
                        this.selectedFlag.removeEventListener("click", this._handleClickSelectedFlag);
                        this.flagsContainer.removeEventListener("keydown", this._handleFlagsContainerKeydown);
                        // label click hack
                        var label = this._getClosestLabel();
                        if (label) label.removeEventListener("click", this._handleLabelClick);
                    }
                    // unbind hiddenInput listeners
                    if (this.hiddenInput && form) form.removeEventListener("submit", this._handleHiddenInputSubmit);
                    // unbind autoHideDialCode listeners
                    if (this.options.autoHideDialCode) {
                        if (form) form.removeEventListener("submit", this._handleSubmitOrBlurEvent);
                        this.telInput.removeEventListener("blur", this._handleSubmitOrBlurEvent);
                    }
                    // unbind key events, and cut/paste events
                    this.telInput.removeEventListener("keyup", this._handleKeyupEvent);
                    this.telInput.removeEventListener("cut", this._handleClipboardEvent);
                    this.telInput.removeEventListener("paste", this._handleClipboardEvent);
                    // remove attribute of id instance: data-intl-tel-input-id
                    this.telInput.removeAttribute("data-intl-tel-input-id");
                    // remove markup (but leave the original input)
                    var wrapper = this.telInput.parentNode;
                    wrapper.parentNode.insertBefore(this.telInput, wrapper);
                    wrapper.parentNode.removeChild(wrapper);
                    delete window.intlTelInputGlobals.instances[this.id];
                }
            }, {
                key: "getExtension",
                value: function getExtension() {
                    if (window.intlTelInputUtils) {
                        return intlTelInputUtils.getExtension(this._getFullNumber(), this.selectedCountryData.iso2);
                    }
                    return "";
                }
            }, {
                key: "getNumber",
                value: function getNumber(format) {
                    if (window.intlTelInputUtils) {
                        var iso2 = this.selectedCountryData.iso2;
                        return intlTelInputUtils.formatNumber(this._getFullNumber(), iso2, format);
                    }
                    return "";
                }
            }, {
                key: "getNumberType",
                value: function getNumberType() {
                    if (window.intlTelInputUtils) {
                        return intlTelInputUtils.getNumberType(this._getFullNumber(), this.selectedCountryData.iso2);
                    }
                    return -99;
                }
            }, {
                key: "getSelectedCountryData",
                value: function getSelectedCountryData() {
                    return this.selectedCountryData;
                }
            }, {
                key: "getValidationError",
                value: function getValidationError() {
                    if (window.intlTelInputUtils) {
                        var iso2 = this.selectedCountryData.iso2;
                        return intlTelInputUtils.getValidationError(this._getFullNumber(), iso2);
                    }
                    return -99;
                }
            }, {
                key: "isValidNumber",
                value: function isValidNumber() {
                    var val = this._getFullNumber().trim();
                    var countryCode = this.options.nationalMode ? this.selectedCountryData.iso2 : "";
                    return window.intlTelInputUtils ? intlTelInputUtils.isValidNumber(val, countryCode) : null;
                }
            }, {
                key: "setCountry",
                value: function setCountry(originalCountryCode) {
                    var countryCode = originalCountryCode.toLowerCase();
                    // check if already selected
                    if (!this.selectedFlagInner.classList.contains("iti__".concat(countryCode))) {
                        this._setFlag(countryCode);
                        this._updateDialCode(this.selectedCountryData.dialCode, false);
                        this._triggerCountryChange();
                    }
                }
            }, {
                key: "setNumber",
                value: function setNumber(number) {
                    // we must update the flag first, which updates this.selectedCountryData, which is used for
                    // formatting the number before displaying it
                    var flagChanged = this._updateFlagFromNumber(number);
                    this._updateValFromNumber(number);
                    if (flagChanged) {
                        this._triggerCountryChange();
                    }
                }
            }, {
                key: "setPlaceholderNumberType",
                value: function setPlaceholderNumberType(type) {
                    this.options.placeholderNumberType = type;
                    this._updatePlaceholder();
                }
            } ]);
            return Iti;
        }();
        /********************
 *  STATIC METHODS
 ********************/
        // get the country data object
        window.intlTelInputGlobals.getCountryData = function() {
            return allCountries;
        };
        // inject a <script> element to load utils.js
        var injectScript = function injectScript(path, handleSuccess, handleFailure) {
            // inject a new script element into the page
            var script = document.createElement("script");
            script.onload = function() {
                forEachInstance("handleUtils");
                if (handleSuccess) handleSuccess();
            };
            script.onerror = function() {
                forEachInstance("rejectUtilsScriptPromise");
                if (handleFailure) handleFailure();
            };
            script.className = "iti-load-utils";
            script.async = true;
            script.src = path;
            document.body.appendChild(script);
        };
        // load the utils script
        window.intlTelInputGlobals.loadUtils = function(path) {
            // 2 options:
            // 1) not already started loading (start)
            // 2) already started loading (do nothing - just wait for the onload callback to fire, which will
            // trigger handleUtils on all instances, invoking their resolveUtilsScriptPromise functions)
            if (!window.intlTelInputUtils && !window.intlTelInputGlobals.startedLoadingUtilsScript) {
                // only do this once
                window.intlTelInputGlobals.startedLoadingUtilsScript = true;
                // if we have promises, then return a promise
                if (typeof Promise !== "undefined") {
                    return new Promise(function(resolve, reject) {
                        return injectScript(path, resolve, reject);
                    });
                }
                injectScript(path);
            }
            return null;
        };
        // default options
        window.intlTelInputGlobals.defaults = defaults;
        // version
        window.intlTelInputGlobals.version = "16.0.7";
        // convenience wrapper
        return function(input, options) {
            var iti = new Iti(input, options);
            iti._init();
            input.setAttribute("data-intl-tel-input-id", iti.id);
            window.intlTelInputGlobals.instances[iti.id] = iti;
            return iti;
        };
    }();
});

/***/ }),
/* 546 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var NumeralFormatter = function (numeralDecimalMark,
                                 numeralIntegerScale,
                                 numeralDecimalScale,
                                 numeralThousandsGroupStyle,
                                 numeralPositiveOnly,
                                 stripLeadingZeroes,
                                 prefix,
                                 signBeforePrefix,
                                 delimiter) {
    var owner = this;

    owner.numeralDecimalMark = numeralDecimalMark || '.';
    owner.numeralIntegerScale = numeralIntegerScale > 0 ? numeralIntegerScale : 0;
    owner.numeralDecimalScale = numeralDecimalScale >= 0 ? numeralDecimalScale : 2;
    owner.numeralThousandsGroupStyle = numeralThousandsGroupStyle || NumeralFormatter.groupStyle.thousand;
    owner.numeralPositiveOnly = !!numeralPositiveOnly;
    owner.stripLeadingZeroes = stripLeadingZeroes !== false;
    owner.prefix = (prefix || prefix === '') ? prefix : '';
    owner.signBeforePrefix = !!signBeforePrefix;
    owner.delimiter = (delimiter || delimiter === '') ? delimiter : ',';
    owner.delimiterRE = delimiter ? new RegExp('\\' + delimiter, 'g') : '';
};

NumeralFormatter.groupStyle = {
    thousand: 'thousand',
    lakh:     'lakh',
    wan:      'wan',
    none:     'none'    
};

NumeralFormatter.prototype = {
    getRawValue: function (value) {
        return value.replace(this.delimiterRE, '').replace(this.numeralDecimalMark, '.');
    },

    format: function (value) {
        var owner = this, parts, partSign, partSignAndPrefix, partInteger, partDecimal = '';

        // strip alphabet letters
        value = value.replace(/[A-Za-z]/g, '')
            // replace the first decimal mark with reserved placeholder
            .replace(owner.numeralDecimalMark, 'M')

            // strip non numeric letters except minus and "M"
            // this is to ensure prefix has been stripped
            .replace(/[^\dM-]/g, '')

            // replace the leading minus with reserved placeholder
            .replace(/^\-/, 'N')

            // strip the other minus sign (if present)
            .replace(/\-/g, '')

            // replace the minus sign (if present)
            .replace('N', owner.numeralPositiveOnly ? '' : '-')

            // replace decimal mark
            .replace('M', owner.numeralDecimalMark);

        // strip any leading zeros
        if (owner.stripLeadingZeroes) {
            value = value.replace(/^(-)?0+(?=\d)/, '$1');
        }

        partSign = value.slice(0, 1) === '-' ? '-' : '';
        if (typeof owner.prefix != 'undefined') {
            if (owner.signBeforePrefix) {
                partSignAndPrefix = partSign + owner.prefix;
            } else {
                partSignAndPrefix = owner.prefix + partSign;
            }
        } else {
            partSignAndPrefix = partSign;
        }
        
        partInteger = value;

        if (value.indexOf(owner.numeralDecimalMark) >= 0) {
            parts = value.split(owner.numeralDecimalMark);
            partInteger = parts[0];
            partDecimal = owner.numeralDecimalMark + parts[1].slice(0, owner.numeralDecimalScale);
        }

        if(partSign === '-') {
            partInteger = partInteger.slice(1);
        }

        if (owner.numeralIntegerScale > 0) {
          partInteger = partInteger.slice(0, owner.numeralIntegerScale);
        }

        switch (owner.numeralThousandsGroupStyle) {
        case NumeralFormatter.groupStyle.lakh:
            partInteger = partInteger.replace(/(\d)(?=(\d\d)+\d$)/g, '$1' + owner.delimiter);

            break;

        case NumeralFormatter.groupStyle.wan:
            partInteger = partInteger.replace(/(\d)(?=(\d{4})+$)/g, '$1' + owner.delimiter);

            break;

        case NumeralFormatter.groupStyle.thousand:
            partInteger = partInteger.replace(/(\d)(?=(\d{3})+$)/g, '$1' + owner.delimiter);

            break;
        }

        return partSignAndPrefix + partInteger.toString() + (owner.numeralDecimalScale > 0 ? partDecimal.toString() : '');
    }
};

var NumeralFormatter_1 = NumeralFormatter;

var DateFormatter = function (datePattern, dateMin, dateMax) {
    var owner = this;

    owner.date = [];
    owner.blocks = [];
    owner.datePattern = datePattern;
    owner.dateMin = dateMin
      .split('-')
      .reverse()
      .map(function(x) {
        return parseInt(x, 10);
      });
    if (owner.dateMin.length === 2) owner.dateMin.unshift(0);

    owner.dateMax = dateMax
      .split('-')
      .reverse()
      .map(function(x) {
        return parseInt(x, 10);
      });
    if (owner.dateMax.length === 2) owner.dateMax.unshift(0);
    
    owner.initBlocks();
};

DateFormatter.prototype = {
    initBlocks: function () {
        var owner = this;
        owner.datePattern.forEach(function (value) {
            if (value === 'Y') {
                owner.blocks.push(4);
            } else {
                owner.blocks.push(2);
            }
        });
    },

    getISOFormatDate: function () {
        var owner = this,
            date = owner.date;

        return date[2] ? (
            date[2] + '-' + owner.addLeadingZero(date[1]) + '-' + owner.addLeadingZero(date[0])
        ) : '';
    },

    getBlocks: function () {
        return this.blocks;
    },

    getValidatedDate: function (value) {
        var owner = this, result = '';

        value = value.replace(/[^\d]/g, '');

        owner.blocks.forEach(function (length, index) {
            if (value.length > 0) {
                var sub = value.slice(0, length),
                    sub0 = sub.slice(0, 1),
                    rest = value.slice(length);

                switch (owner.datePattern[index]) {
                case 'd':
                    if (sub === '00') {
                        sub = '01';
                    } else if (parseInt(sub0, 10) > 3) {
                        sub = '0' + sub0;
                    } else if (parseInt(sub, 10) > 31) {
                        sub = '31';
                    }

                    break;

                case 'm':
                    if (sub === '00') {
                        sub = '01';
                    } else if (parseInt(sub0, 10) > 1) {
                        sub = '0' + sub0;
                    } else if (parseInt(sub, 10) > 12) {
                        sub = '12';
                    }

                    break;
                }

                result += sub;

                // update remaining string
                value = rest;
            }
        });

        return this.getFixedDateString(result);
    },

    getFixedDateString: function (value) {
        var owner = this, datePattern = owner.datePattern, date = [],
            dayIndex = 0, monthIndex = 0, yearIndex = 0,
            dayStartIndex = 0, monthStartIndex = 0, yearStartIndex = 0,
            day, month, year, fullYearDone = false;

        // mm-dd || dd-mm
        if (value.length === 4 && datePattern[0].toLowerCase() !== 'y' && datePattern[1].toLowerCase() !== 'y') {
            dayStartIndex = datePattern[0] === 'd' ? 0 : 2;
            monthStartIndex = 2 - dayStartIndex;
            day = parseInt(value.slice(dayStartIndex, dayStartIndex + 2), 10);
            month = parseInt(value.slice(monthStartIndex, monthStartIndex + 2), 10);

            date = this.getFixedDate(day, month, 0);
        }

        // yyyy-mm-dd || yyyy-dd-mm || mm-dd-yyyy || dd-mm-yyyy || dd-yyyy-mm || mm-yyyy-dd
        if (value.length === 8) {
            datePattern.forEach(function (type, index) {
                switch (type) {
                case 'd':
                    dayIndex = index;
                    break;
                case 'm':
                    monthIndex = index;
                    break;
                default:
                    yearIndex = index;
                    break;
                }
            });

            yearStartIndex = yearIndex * 2;
            dayStartIndex = (dayIndex <= yearIndex) ? dayIndex * 2 : (dayIndex * 2 + 2);
            monthStartIndex = (monthIndex <= yearIndex) ? monthIndex * 2 : (monthIndex * 2 + 2);

            day = parseInt(value.slice(dayStartIndex, dayStartIndex + 2), 10);
            month = parseInt(value.slice(monthStartIndex, monthStartIndex + 2), 10);
            year = parseInt(value.slice(yearStartIndex, yearStartIndex + 4), 10);

            fullYearDone = value.slice(yearStartIndex, yearStartIndex + 4).length === 4;

            date = this.getFixedDate(day, month, year);
        }

        // mm-yy || yy-mm
        if (value.length === 4 && (datePattern[0] === 'y' || datePattern[1] === 'y')) {
            monthStartIndex = datePattern[0] === 'm' ? 0 : 2;
            yearStartIndex = 2 - monthStartIndex;
            month = parseInt(value.slice(monthStartIndex, monthStartIndex + 2), 10);
            year = parseInt(value.slice(yearStartIndex, yearStartIndex + 2), 10);

            fullYearDone = value.slice(yearStartIndex, yearStartIndex + 2).length === 2;

            date = [0, month, year];
        }

        // mm-yyyy || yyyy-mm
        if (value.length === 6 && (datePattern[0] === 'Y' || datePattern[1] === 'Y')) {
            monthStartIndex = datePattern[0] === 'm' ? 0 : 4;
            yearStartIndex = 2 - 0.5 * monthStartIndex;
            month = parseInt(value.slice(monthStartIndex, monthStartIndex + 2), 10);
            year = parseInt(value.slice(yearStartIndex, yearStartIndex + 4), 10);

            fullYearDone = value.slice(yearStartIndex, yearStartIndex + 4).length === 4;

            date = [0, month, year];
        }

        date = owner.getRangeFixedDate(date);
        owner.date = date;

        var result = date.length === 0 ? value : datePattern.reduce(function (previous, current) {
            switch (current) {
            case 'd':
                return previous + (date[0] === 0 ? '' : owner.addLeadingZero(date[0]));
            case 'm':
                return previous + (date[1] === 0 ? '' : owner.addLeadingZero(date[1]));
            case 'y':
                return previous + (fullYearDone ? owner.addLeadingZeroForYear(date[2], false) : '');
            case 'Y':
                return previous + (fullYearDone ? owner.addLeadingZeroForYear(date[2], true) : '');
            }
        }, '');

        return result;
    },

    getRangeFixedDate: function (date) {
        var owner = this,
            datePattern = owner.datePattern,
            dateMin = owner.dateMin || [],
            dateMax = owner.dateMax || [];

        if (!date.length || (dateMin.length < 3 && dateMax.length < 3)) return date;

        if (
          datePattern.find(function(x) {
            return x.toLowerCase() === 'y';
          }) &&
          date[2] === 0
        ) return date;

        if (dateMax.length && (dateMax[2] < date[2] || (
          dateMax[2] === date[2] && (dateMax[1] < date[1] || (
            dateMax[1] === date[1] && dateMax[0] < date[0]
          ))
        ))) return dateMax;

        if (dateMin.length && (dateMin[2] > date[2] || (
          dateMin[2] === date[2] && (dateMin[1] > date[1] || (
            dateMin[1] === date[1] && dateMin[0] > date[0]
          ))
        ))) return dateMin;

        return date;
    },

    getFixedDate: function (day, month, year) {
        day = Math.min(day, 31);
        month = Math.min(month, 12);
        year = parseInt((year || 0), 10);

        if ((month < 7 && month % 2 === 0) || (month > 8 && month % 2 === 1)) {
            day = Math.min(day, month === 2 ? (this.isLeapYear(year) ? 29 : 28) : 30);
        }

        return [day, month, year];
    },

    isLeapYear: function (year) {
        return ((year % 4 === 0) && (year % 100 !== 0)) || (year % 400 === 0);
    },

    addLeadingZero: function (number) {
        return (number < 10 ? '0' : '') + number;
    },

    addLeadingZeroForYear: function (number, fullYearMode) {
        if (fullYearMode) {
            return (number < 10 ? '000' : (number < 100 ? '00' : (number < 1000 ? '0' : ''))) + number;
        }

        return (number < 10 ? '0' : '') + number;
    }
};

var DateFormatter_1 = DateFormatter;

var TimeFormatter = function (timePattern, timeFormat) {
    var owner = this;

    owner.time = [];
    owner.blocks = [];
    owner.timePattern = timePattern;
    owner.timeFormat = timeFormat;
    owner.initBlocks();
};

TimeFormatter.prototype = {
    initBlocks: function () {
        var owner = this;
        owner.timePattern.forEach(function () {
            owner.blocks.push(2);
        });
    },

    getISOFormatTime: function () {
        var owner = this,
            time = owner.time;

        return time[2] ? (
            owner.addLeadingZero(time[0]) + ':' + owner.addLeadingZero(time[1]) + ':' + owner.addLeadingZero(time[2])
        ) : '';
    },

    getBlocks: function () {
        return this.blocks;
    },

    getTimeFormatOptions: function () {
        var owner = this;
        if (String(owner.timeFormat) === '12') {
            return {
                maxHourFirstDigit: 1,
                maxHours: 12,
                maxMinutesFirstDigit: 5,
                maxMinutes: 60
            };
        }

        return {
            maxHourFirstDigit: 2,
            maxHours: 23,
            maxMinutesFirstDigit: 5,
            maxMinutes: 60
        };
    },

    getValidatedTime: function (value) {
        var owner = this, result = '';

        value = value.replace(/[^\d]/g, '');

        var timeFormatOptions = owner.getTimeFormatOptions();

        owner.blocks.forEach(function (length, index) {
            if (value.length > 0) {
                var sub = value.slice(0, length),
                    sub0 = sub.slice(0, 1),
                    rest = value.slice(length);

                switch (owner.timePattern[index]) {

                case 'h':
                    if (parseInt(sub0, 10) > timeFormatOptions.maxHourFirstDigit) {
                        sub = '0' + sub0;
                    } else if (parseInt(sub, 10) > timeFormatOptions.maxHours) {
                        sub = timeFormatOptions.maxHours + '';
                    }

                    break;

                case 'm':
                case 's':
                    if (parseInt(sub0, 10) > timeFormatOptions.maxMinutesFirstDigit) {
                        sub = '0' + sub0;
                    } else if (parseInt(sub, 10) > timeFormatOptions.maxMinutes) {
                        sub = timeFormatOptions.maxMinutes + '';
                    }
                    break;
                }

                result += sub;

                // update remaining string
                value = rest;
            }
        });

        return this.getFixedTimeString(result);
    },

    getFixedTimeString: function (value) {
        var owner = this, timePattern = owner.timePattern, time = [],
            secondIndex = 0, minuteIndex = 0, hourIndex = 0,
            secondStartIndex = 0, minuteStartIndex = 0, hourStartIndex = 0,
            second, minute, hour;

        if (value.length === 6) {
            timePattern.forEach(function (type, index) {
                switch (type) {
                case 's':
                    secondIndex = index * 2;
                    break;
                case 'm':
                    minuteIndex = index * 2;
                    break;
                case 'h':
                    hourIndex = index * 2;
                    break;
                }
            });

            hourStartIndex = hourIndex;
            minuteStartIndex = minuteIndex;
            secondStartIndex = secondIndex;

            second = parseInt(value.slice(secondStartIndex, secondStartIndex + 2), 10);
            minute = parseInt(value.slice(minuteStartIndex, minuteStartIndex + 2), 10);
            hour = parseInt(value.slice(hourStartIndex, hourStartIndex + 2), 10);

            time = this.getFixedTime(hour, minute, second);
        }

        if (value.length === 4 && owner.timePattern.indexOf('s') < 0) {
            timePattern.forEach(function (type, index) {
                switch (type) {
                case 'm':
                    minuteIndex = index * 2;
                    break;
                case 'h':
                    hourIndex = index * 2;
                    break;
                }
            });

            hourStartIndex = hourIndex;
            minuteStartIndex = minuteIndex;

            second = 0;
            minute = parseInt(value.slice(minuteStartIndex, minuteStartIndex + 2), 10);
            hour = parseInt(value.slice(hourStartIndex, hourStartIndex + 2), 10);

            time = this.getFixedTime(hour, minute, second);
        }

        owner.time = time;

        return time.length === 0 ? value : timePattern.reduce(function (previous, current) {
            switch (current) {
            case 's':
                return previous + owner.addLeadingZero(time[2]);
            case 'm':
                return previous + owner.addLeadingZero(time[1]);
            case 'h':
                return previous + owner.addLeadingZero(time[0]);
            }
        }, '');
    },

    getFixedTime: function (hour, minute, second) {
        second = Math.min(parseInt(second || 0, 10), 60);
        minute = Math.min(minute, 60);
        hour = Math.min(hour, 60);

        return [hour, minute, second];
    },

    addLeadingZero: function (number) {
        return (number < 10 ? '0' : '') + number;
    }
};

var TimeFormatter_1 = TimeFormatter;

var PhoneFormatter = function (formatter, delimiter) {
    var owner = this;

    owner.delimiter = (delimiter || delimiter === '') ? delimiter : ' ';
    owner.delimiterRE = delimiter ? new RegExp('\\' + delimiter, 'g') : '';

    owner.formatter = formatter;
};

PhoneFormatter.prototype = {
    setFormatter: function (formatter) {
        this.formatter = formatter;
    },

    format: function (phoneNumber) {
        var owner = this;

        owner.formatter.clear();

        // only keep number and +
        phoneNumber = phoneNumber.replace(/[^\d+]/g, '');

        // strip non-leading +
        phoneNumber = phoneNumber.replace(/^\+/, 'B').replace(/\+/g, '').replace('B', '+');

        // strip delimiter
        phoneNumber = phoneNumber.replace(owner.delimiterRE, '');

        var result = '', current, validated = false;

        for (var i = 0, iMax = phoneNumber.length; i < iMax; i++) {
            current = owner.formatter.inputDigit(phoneNumber.charAt(i));

            // has ()- or space inside
            if (/[\s()-]/g.test(current)) {
                result = current;

                validated = true;
            } else {
                if (!validated) {
                    result = current;
                }
                // else: over length input
                // it turns to invalid number again
            }
        }

        // strip ()
        // e.g. US: 7161234567 returns (716) 123-4567
        result = result.replace(/[()]/g, '');
        // replace library delimiter with user customized delimiter
        result = result.replace(/[\s-]/g, owner.delimiter);

        return result;
    }
};

var PhoneFormatter_1 = PhoneFormatter;

var CreditCardDetector = {
    blocks: {
        uatp:          [4, 5, 6],
        amex:          [4, 6, 5],
        diners:        [4, 6, 4],
        discover:      [4, 4, 4, 4],
        mastercard:    [4, 4, 4, 4],
        dankort:       [4, 4, 4, 4],
        instapayment:  [4, 4, 4, 4],
        jcb15:         [4, 6, 5],
        jcb:           [4, 4, 4, 4],
        maestro:       [4, 4, 4, 4],
        visa:          [4, 4, 4, 4],
        mir:           [4, 4, 4, 4],
        unionPay:      [4, 4, 4, 4],
        general:       [4, 4, 4, 4]
    },

    re: {
        // starts with 1; 15 digits, not starts with 1800 (jcb card)
        uatp: /^(?!1800)1\d{0,14}/,

        // starts with 34/37; 15 digits
        amex: /^3[47]\d{0,13}/,

        // starts with 6011/65/644-649; 16 digits
        discover: /^(?:6011|65\d{0,2}|64[4-9]\d?)\d{0,12}/,

        // starts with 300-305/309 or 36/38/39; 14 digits
        diners: /^3(?:0([0-5]|9)|[689]\d?)\d{0,11}/,

        // starts with 51-55/2221–2720; 16 digits
        mastercard: /^(5[1-5]\d{0,2}|22[2-9]\d{0,1}|2[3-7]\d{0,2})\d{0,12}/,

        // starts with 5019/4175/4571; 16 digits
        dankort: /^(5019|4175|4571)\d{0,12}/,

        // starts with 637-639; 16 digits
        instapayment: /^63[7-9]\d{0,13}/,

        // starts with 2131/1800; 15 digits
        jcb15: /^(?:2131|1800)\d{0,11}/,

        // starts with 2131/1800/35; 16 digits
        jcb: /^(?:35\d{0,2})\d{0,12}/,

        // starts with 50/56-58/6304/67; 16 digits
        maestro: /^(?:5[0678]\d{0,2}|6304|67\d{0,2})\d{0,12}/,

        // starts with 22; 16 digits
        mir: /^220[0-4]\d{0,12}/,

        // starts with 4; 16 digits
        visa: /^4\d{0,15}/,

        // starts with 62; 16 digits
        unionPay: /^62\d{0,14}/
    },

    getStrictBlocks: function (block) {
      var total = block.reduce(function (prev, current) {
        return prev + current;
      }, 0);

      return block.concat(19 - total);
    },

    getInfo: function (value, strictMode) {
        var blocks = CreditCardDetector.blocks,
            re = CreditCardDetector.re;

        // Some credit card can have up to 19 digits number.
        // Set strictMode to true will remove the 16 max-length restrain,
        // however, I never found any website validate card number like
        // this, hence probably you don't want to enable this option.
        strictMode = !!strictMode;

        for (var key in re) {
            if (re[key].test(value)) {
                var matchedBlocks = blocks[key];
                return {
                    type: key,
                    blocks: strictMode ? this.getStrictBlocks(matchedBlocks) : matchedBlocks
                };
            }
        }

        return {
            type: 'unknown',
            blocks: strictMode ? this.getStrictBlocks(blocks.general) : blocks.general
        };
    }
};

var CreditCardDetector_1 = CreditCardDetector;

var Util = {
    noop: function () {
    },

    strip: function (value, re) {
        return value.replace(re, '');
    },

    getPostDelimiter: function (value, delimiter, delimiters) {
        // single delimiter
        if (delimiters.length === 0) {
            return value.slice(-delimiter.length) === delimiter ? delimiter : '';
        }

        // multiple delimiters
        var matchedDelimiter = '';
        delimiters.forEach(function (current) {
            if (value.slice(-current.length) === current) {
                matchedDelimiter = current;
            }
        });

        return matchedDelimiter;
    },

    getDelimiterREByDelimiter: function (delimiter) {
        return new RegExp(delimiter.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1'), 'g');
    },

    getNextCursorPosition: function (prevPos, oldValue, newValue, delimiter, delimiters) {
      // If cursor was at the end of value, just place it back.
      // Because new value could contain additional chars.
      if (oldValue.length === prevPos) {
          return newValue.length;
      }

      return prevPos + this.getPositionOffset(prevPos, oldValue, newValue, delimiter ,delimiters);
    },

    getPositionOffset: function (prevPos, oldValue, newValue, delimiter, delimiters) {
        var oldRawValue, newRawValue, lengthOffset;

        oldRawValue = this.stripDelimiters(oldValue.slice(0, prevPos), delimiter, delimiters);
        newRawValue = this.stripDelimiters(newValue.slice(0, prevPos), delimiter, delimiters);
        lengthOffset = oldRawValue.length - newRawValue.length;

        return (lengthOffset !== 0) ? (lengthOffset / Math.abs(lengthOffset)) : 0;
    },

    stripDelimiters: function (value, delimiter, delimiters) {
        var owner = this;

        // single delimiter
        if (delimiters.length === 0) {
            var delimiterRE = delimiter ? owner.getDelimiterREByDelimiter(delimiter) : '';

            return value.replace(delimiterRE, '');
        }

        // multiple delimiters
        delimiters.forEach(function (current) {
            current.split('').forEach(function (letter) {
                value = value.replace(owner.getDelimiterREByDelimiter(letter), '');
            });
        });

        return value;
    },

    headStr: function (str, length) {
        return str.slice(0, length);
    },

    getMaxLength: function (blocks) {
        return blocks.reduce(function (previous, current) {
            return previous + current;
        }, 0);
    },

    // strip prefix
    // Before type  |   After type    |     Return value
    // PEFIX-...    |   PEFIX-...     |     ''
    // PREFIX-123   |   PEFIX-123     |     123
    // PREFIX-123   |   PREFIX-23     |     23
    // PREFIX-123   |   PREFIX-1234   |     1234
    getPrefixStrippedValue: function (value, prefix, prefixLength, prevResult, delimiter, delimiters) {
        // No prefix
        if (prefixLength === 0) {
          return value;
        }

        // Pre result has issue
        // Revert to raw prefix
        if (prevResult.slice(0, prefixLength) !== prefix) {
          return '';
        }

        var prevValue = this.stripDelimiters(prevResult, delimiter, delimiters);

        // New value has issue, someone typed in between prefix letters
        // Revert to pre value
        if (value.slice(0, prefixLength) !== prefix) {
          return prevValue.slice(prefixLength);
        }

        // No issue, strip prefix for new value
        return value.slice(prefixLength);
    },

    getFirstDiffIndex: function (prev, current) {
        var index = 0;

        while (prev.charAt(index) === current.charAt(index)) {
            if (prev.charAt(index++) === '') {
                return -1;
            }
        }

        return index;
    },

    getFormattedValue: function (value, blocks, blocksLength, delimiter, delimiters, delimiterLazyShow) {
        var result = '',
            multipleDelimiters = delimiters.length > 0,
            currentDelimiter;

        // no options, normal input
        if (blocksLength === 0) {
            return value;
        }

        blocks.forEach(function (length, index) {
            if (value.length > 0) {
                var sub = value.slice(0, length),
                    rest = value.slice(length);

                if (multipleDelimiters) {
                    currentDelimiter = delimiters[delimiterLazyShow ? (index - 1) : index] || currentDelimiter;
                } else {
                    currentDelimiter = delimiter;
                }

                if (delimiterLazyShow) {
                    if (index > 0) {
                        result += currentDelimiter;
                    }

                    result += sub;
                } else {
                    result += sub;

                    if (sub.length === length && index < blocksLength - 1) {
                        result += currentDelimiter;
                    }
                }

                // update remaining string
                value = rest;
            }
        });

        return result;
    },

    // move cursor to the end
    // the first time user focuses on an input with prefix
    fixPrefixCursor: function (el, prefix, delimiter, delimiters) {
        if (!el) {
            return;
        }

        var val = el.value,
            appendix = delimiter || (delimiters[0] || ' ');

        if (!el.setSelectionRange || !prefix || (prefix.length + appendix.length) < val.length) {
            return;
        }

        var len = val.length * 2;

        // set timeout to avoid blink
        setTimeout(function () {
            el.setSelectionRange(len, len);
        }, 1);
    },

    // Check if input field is fully selected
    checkFullSelection: function(value) {
      try {
        var selection = window.getSelection() || document.getSelection() || {};
        return selection.toString().length === value.length;
      } catch (ex) {
        // Ignore
      }

      return false;
    },

    setSelection: function (element, position, doc) {
        if (element !== this.getActiveElement(doc)) {
            return;
        }

        // cursor is already in the end
        if (element && element.value.length <= position) {
          return;
        }

        if (element.createTextRange) {
            var range = element.createTextRange();

            range.move('character', position);
            range.select();
        } else {
            try {
                element.setSelectionRange(position, position);
            } catch (e) {
                // eslint-disable-next-line
                console.warn('The input element type does not support selection');
            }
        }
    },

    getActiveElement: function(parent) {
        var activeElement = parent.activeElement;
        if (activeElement && activeElement.shadowRoot) {
            return this.getActiveElement(activeElement.shadowRoot);
        }
        return activeElement;
    },

    isAndroid: function () {
        return navigator && /android/i.test(navigator.userAgent);
    },

    // On Android chrome, the keyup and keydown events
    // always return key code 229 as a composition that
    // buffers the user’s keystrokes
    // see https://github.com/nosir/cleave.js/issues/147
    isAndroidBackspaceKeydown: function (lastInputValue, currentInputValue) {
        if (!this.isAndroid() || !lastInputValue || !currentInputValue) {
            return false;
        }

        return currentInputValue === lastInputValue.slice(0, -1);
    }
};

var Util_1 = Util;

/**
 * Props Assignment
 *
 * Separate this, so react module can share the usage
 */
var DefaultProperties = {
    // Maybe change to object-assign
    // for now just keep it as simple
    assign: function (target, opts) {
        target = target || {};
        opts = opts || {};

        // credit card
        target.creditCard = !!opts.creditCard;
        target.creditCardStrictMode = !!opts.creditCardStrictMode;
        target.creditCardType = '';
        target.onCreditCardTypeChanged = opts.onCreditCardTypeChanged || (function () {});

        // phone
        target.phone = !!opts.phone;
        target.phoneRegionCode = opts.phoneRegionCode || 'AU';
        target.phoneFormatter = {};

        // time
        target.time = !!opts.time;
        target.timePattern = opts.timePattern || ['h', 'm', 's'];
        target.timeFormat = opts.timeFormat || '24';
        target.timeFormatter = {};

        // date
        target.date = !!opts.date;
        target.datePattern = opts.datePattern || ['d', 'm', 'Y'];
        target.dateMin = opts.dateMin || '';
        target.dateMax = opts.dateMax || '';
        target.dateFormatter = {};

        // numeral
        target.numeral = !!opts.numeral;
        target.numeralIntegerScale = opts.numeralIntegerScale > 0 ? opts.numeralIntegerScale : 0;
        target.numeralDecimalScale = opts.numeralDecimalScale >= 0 ? opts.numeralDecimalScale : 2;
        target.numeralDecimalMark = opts.numeralDecimalMark || '.';
        target.numeralThousandsGroupStyle = opts.numeralThousandsGroupStyle || 'thousand';
        target.numeralPositiveOnly = !!opts.numeralPositiveOnly;
        target.stripLeadingZeroes = opts.stripLeadingZeroes !== false;
        target.signBeforePrefix = !!opts.signBeforePrefix;

        // others
        target.numericOnly = target.creditCard || target.date || !!opts.numericOnly;

        target.uppercase = !!opts.uppercase;
        target.lowercase = !!opts.lowercase;

        target.prefix = (target.creditCard || target.date) ? '' : (opts.prefix || '');
        target.noImmediatePrefix = !!opts.noImmediatePrefix;
        target.prefixLength = target.prefix.length;
        target.rawValueTrimPrefix = !!opts.rawValueTrimPrefix;
        target.copyDelimiter = !!opts.copyDelimiter;

        target.initValue = (opts.initValue !== undefined && opts.initValue !== null) ? opts.initValue.toString() : '';

        target.delimiter =
            (opts.delimiter || opts.delimiter === '') ? opts.delimiter :
                (opts.date ? '/' :
                    (opts.time ? ':' :
                        (opts.numeral ? ',' :
                            (opts.phone ? ' ' :
                                ' '))));
        target.delimiterLength = target.delimiter.length;
        target.delimiterLazyShow = !!opts.delimiterLazyShow;
        target.delimiters = opts.delimiters || [];

        target.blocks = opts.blocks || [];
        target.blocksLength = target.blocks.length;

        target.root = (typeof commonjsGlobal === 'object' && commonjsGlobal) ? commonjsGlobal : window;
        target.document = opts.document || target.root.document;

        target.maxLength = 0;

        target.backspace = false;
        target.result = '';

        target.onValueChanged = opts.onValueChanged || (function () {});

        return target;
    }
};

var DefaultProperties_1 = DefaultProperties;

/**
 * Construct a new Cleave instance by passing the configuration object
 *
 * @param {String | HTMLElement} element
 * @param {Object} opts
 */
var Cleave = function (element, opts) {
    var owner = this;
    var hasMultipleElements = false;

    if (typeof element === 'string') {
        owner.element = document.querySelector(element);
        hasMultipleElements = document.querySelectorAll(element).length > 1;
    } else {
      if (typeof element.length !== 'undefined' && element.length > 0) {
        owner.element = element[0];
        hasMultipleElements = element.length > 1;
      } else {
        owner.element = element;
      }
    }

    if (!owner.element) {
        throw new Error('[cleave.js] Please check the element');
    }

    if (hasMultipleElements) {
      try {
        // eslint-disable-next-line
        console.warn('[cleave.js] Multiple input fields matched, cleave.js will only take the first one.');
      } catch (e) {
        // Old IE
      }
    }

    opts.initValue = owner.element.value;

    owner.properties = Cleave.DefaultProperties.assign({}, opts);

    owner.init();
};

Cleave.prototype = {
    init: function () {
        var owner = this, pps = owner.properties;

        // no need to use this lib
        if (!pps.numeral && !pps.phone && !pps.creditCard && !pps.time && !pps.date && (pps.blocksLength === 0 && !pps.prefix)) {
            owner.onInput(pps.initValue);

            return;
        }

        pps.maxLength = Cleave.Util.getMaxLength(pps.blocks);

        owner.isAndroid = Cleave.Util.isAndroid();
        owner.lastInputValue = '';

        owner.onChangeListener = owner.onChange.bind(owner);
        owner.onKeyDownListener = owner.onKeyDown.bind(owner);
        owner.onFocusListener = owner.onFocus.bind(owner);
        owner.onCutListener = owner.onCut.bind(owner);
        owner.onCopyListener = owner.onCopy.bind(owner);

        owner.element.addEventListener('input', owner.onChangeListener);
        owner.element.addEventListener('keydown', owner.onKeyDownListener);
        owner.element.addEventListener('focus', owner.onFocusListener);
        owner.element.addEventListener('cut', owner.onCutListener);
        owner.element.addEventListener('copy', owner.onCopyListener);


        owner.initPhoneFormatter();
        owner.initDateFormatter();
        owner.initTimeFormatter();
        owner.initNumeralFormatter();

        // avoid touch input field if value is null
        // otherwise Firefox will add red box-shadow for <input required />
        if (pps.initValue || (pps.prefix && !pps.noImmediatePrefix)) {
            owner.onInput(pps.initValue);
        }
    },

    initNumeralFormatter: function () {
        var owner = this, pps = owner.properties;

        if (!pps.numeral) {
            return;
        }

        pps.numeralFormatter = new Cleave.NumeralFormatter(
            pps.numeralDecimalMark,
            pps.numeralIntegerScale,
            pps.numeralDecimalScale,
            pps.numeralThousandsGroupStyle,
            pps.numeralPositiveOnly,
            pps.stripLeadingZeroes,
            pps.prefix,
            pps.signBeforePrefix,
            pps.delimiter
        );
    },

    initTimeFormatter: function() {
        var owner = this, pps = owner.properties;

        if (!pps.time) {
            return;
        }

        pps.timeFormatter = new Cleave.TimeFormatter(pps.timePattern, pps.timeFormat);
        pps.blocks = pps.timeFormatter.getBlocks();
        pps.blocksLength = pps.blocks.length;
        pps.maxLength = Cleave.Util.getMaxLength(pps.blocks);
    },

    initDateFormatter: function () {
        var owner = this, pps = owner.properties;

        if (!pps.date) {
            return;
        }

        pps.dateFormatter = new Cleave.DateFormatter(pps.datePattern, pps.dateMin, pps.dateMax);
        pps.blocks = pps.dateFormatter.getBlocks();
        pps.blocksLength = pps.blocks.length;
        pps.maxLength = Cleave.Util.getMaxLength(pps.blocks);
    },

    initPhoneFormatter: function () {
        var owner = this, pps = owner.properties;

        if (!pps.phone) {
            return;
        }

        // Cleave.AsYouTypeFormatter should be provided by
        // external google closure lib
        try {
            pps.phoneFormatter = new Cleave.PhoneFormatter(
                new pps.root.Cleave.AsYouTypeFormatter(pps.phoneRegionCode),
                pps.delimiter
            );
        } catch (ex) {
            throw new Error('[cleave.js] Please include phone-type-formatter.{country}.js lib');
        }
    },

    onKeyDown: function (event) {
        var owner = this, pps = owner.properties,
            charCode = event.which || event.keyCode,
            Util = Cleave.Util,
            currentValue = owner.element.value;

        // if we got any charCode === 8, this means, that this device correctly
        // sends backspace keys in event, so we do not need to apply any hacks
        owner.hasBackspaceSupport = owner.hasBackspaceSupport || charCode === 8;
        if (!owner.hasBackspaceSupport
          && Util.isAndroidBackspaceKeydown(owner.lastInputValue, currentValue)
        ) {
            charCode = 8;
        }

        owner.lastInputValue = currentValue;

        // hit backspace when last character is delimiter
        var postDelimiter = Util.getPostDelimiter(currentValue, pps.delimiter, pps.delimiters);
        if (charCode === 8 && postDelimiter) {
            pps.postDelimiterBackspace = postDelimiter;
        } else {
            pps.postDelimiterBackspace = false;
        }
    },

    onChange: function () {
        this.onInput(this.element.value);
    },

    onFocus: function () {
        var owner = this,
            pps = owner.properties;

        Cleave.Util.fixPrefixCursor(owner.element, pps.prefix, pps.delimiter, pps.delimiters);
    },

    onCut: function (e) {
        if (!Cleave.Util.checkFullSelection(this.element.value)) return;
        this.copyClipboardData(e);
        this.onInput('');
    },

    onCopy: function (e) {
        if (!Cleave.Util.checkFullSelection(this.element.value)) return;
        this.copyClipboardData(e);
    },

    copyClipboardData: function (e) {
        var owner = this,
            pps = owner.properties,
            Util = Cleave.Util,
            inputValue = owner.element.value,
            textToCopy = '';

        if (!pps.copyDelimiter) {
            textToCopy = Util.stripDelimiters(inputValue, pps.delimiter, pps.delimiters);
        } else {
            textToCopy = inputValue;
        }

        try {
            if (e.clipboardData) {
                e.clipboardData.setData('Text', textToCopy);
            } else {
                window.clipboardData.setData('Text', textToCopy);
            }

            e.preventDefault();
        } catch (ex) {
            //  empty
        }
    },

    onInput: function (value) {
        var owner = this, pps = owner.properties,
            Util = Cleave.Util;

        // case 1: delete one more character "4"
        // 1234*| -> hit backspace -> 123|
        // case 2: last character is not delimiter which is:
        // 12|34* -> hit backspace -> 1|34*
        // note: no need to apply this for numeral mode
        var postDelimiterAfter = Util.getPostDelimiter(value, pps.delimiter, pps.delimiters);
        if (!pps.numeral && pps.postDelimiterBackspace && !postDelimiterAfter) {
            value = Util.headStr(value, value.length - pps.postDelimiterBackspace.length);
        }

        // phone formatter
        if (pps.phone) {
            if (pps.prefix && (!pps.noImmediatePrefix || value.length)) {
                pps.result = pps.prefix + pps.phoneFormatter.format(value).slice(pps.prefix.length);
            } else {
                pps.result = pps.phoneFormatter.format(value);
            }
            owner.updateValueState();

            return;
        }

        // numeral formatter
        if (pps.numeral) {
            // Do not show prefix when noImmediatePrefix is specified
            // This mostly because we need to show user the native input placeholder
            if (pps.prefix && pps.noImmediatePrefix && value.length === 0) {
                pps.result = '';
            } else {
                pps.result = pps.numeralFormatter.format(value);
            }
            owner.updateValueState();

            return;
        }

        // date
        if (pps.date) {
            value = pps.dateFormatter.getValidatedDate(value);
        }

        // time
        if (pps.time) {
            value = pps.timeFormatter.getValidatedTime(value);
        }

        // strip delimiters
        value = Util.stripDelimiters(value, pps.delimiter, pps.delimiters);

        // strip prefix
        // var strippedPreviousResult = Util.stripDelimiters(pps.result, pps.delimiter, pps.delimiters);
        value = Util.getPrefixStrippedValue(value, pps.prefix, pps.prefixLength, pps.result, pps.delimiter, pps.delimiters);

        // strip non-numeric characters
        value = pps.numericOnly ? Util.strip(value, /[^\d]/g) : value;

        // convert case
        value = pps.uppercase ? value.toUpperCase() : value;
        value = pps.lowercase ? value.toLowerCase() : value;

        // prefix
        if (pps.prefix && (!pps.noImmediatePrefix || value.length)) {
            value = pps.prefix + value;

            // no blocks specified, no need to do formatting
            if (pps.blocksLength === 0) {
                pps.result = value;
                owner.updateValueState();

                return;
            }
        }

        // update credit card props
        if (pps.creditCard) {
            owner.updateCreditCardPropsByValue(value);
        }

        // strip over length characters
        value = Util.headStr(value, pps.maxLength);

        // apply blocks
        pps.result = Util.getFormattedValue(
            value,
            pps.blocks, pps.blocksLength,
            pps.delimiter, pps.delimiters, pps.delimiterLazyShow
        );

        owner.updateValueState();
    },

    updateCreditCardPropsByValue: function (value) {
        var owner = this, pps = owner.properties,
            Util = Cleave.Util,
            creditCardInfo;

        // At least one of the first 4 characters has changed
        if (Util.headStr(pps.result, 4) === Util.headStr(value, 4)) {
            return;
        }

        creditCardInfo = Cleave.CreditCardDetector.getInfo(value, pps.creditCardStrictMode);

        pps.blocks = creditCardInfo.blocks;
        pps.blocksLength = pps.blocks.length;
        pps.maxLength = Util.getMaxLength(pps.blocks);

        // credit card type changed
        if (pps.creditCardType !== creditCardInfo.type) {
            pps.creditCardType = creditCardInfo.type;

            pps.onCreditCardTypeChanged.call(owner, pps.creditCardType);
        }
    },

    updateValueState: function () {
        var owner = this,
            Util = Cleave.Util,
            pps = owner.properties;

        if (!owner.element) {
            return;
        }

        var endPos = owner.element.selectionEnd;
        var oldValue = owner.element.value;
        var newValue = pps.result;

        endPos = Util.getNextCursorPosition(endPos, oldValue, newValue, pps.delimiter, pps.delimiters);

        // fix Android browser type="text" input field
        // cursor not jumping issue
        if (owner.isAndroid) {
            window.setTimeout(function () {
                owner.element.value = newValue;
                Util.setSelection(owner.element, endPos, pps.document, false);
                owner.callOnValueChanged();
            }, 1);

            return;
        }

        owner.element.value = newValue;
        Util.setSelection(owner.element, endPos, pps.document, false);
        owner.callOnValueChanged();
    },

    callOnValueChanged: function () {
        var owner = this,
            pps = owner.properties;

        pps.onValueChanged.call(owner, {
            target: {
                value: pps.result,
                rawValue: owner.getRawValue()
            }
        });
    },

    setPhoneRegionCode: function (phoneRegionCode) {
        var owner = this, pps = owner.properties;

        pps.phoneRegionCode = phoneRegionCode;
        owner.initPhoneFormatter();
        owner.onChange();
    },

    setRawValue: function (value) {
        var owner = this, pps = owner.properties;

        value = value !== undefined && value !== null ? value.toString() : '';

        if (pps.numeral) {
            value = value.replace('.', pps.numeralDecimalMark);
        }

        pps.postDelimiterBackspace = false;

        owner.element.value = value;
        owner.onInput(value);
    },

    getRawValue: function () {
        var owner = this,
            pps = owner.properties,
            Util = Cleave.Util,
            rawValue = owner.element.value;

        if (pps.rawValueTrimPrefix) {
            rawValue = Util.getPrefixStrippedValue(rawValue, pps.prefix, pps.prefixLength, pps.result, pps.delimiter, pps.delimiters);
        }

        if (pps.numeral) {
            rawValue = pps.numeralFormatter.getRawValue(rawValue);
        } else {
            rawValue = Util.stripDelimiters(rawValue, pps.delimiter, pps.delimiters);
        }

        return rawValue;
    },

    getISOFormatDate: function () {
        var owner = this,
            pps = owner.properties;

        return pps.date ? pps.dateFormatter.getISOFormatDate() : '';
    },

    getISOFormatTime: function () {
        var owner = this,
            pps = owner.properties;

        return pps.time ? pps.timeFormatter.getISOFormatTime() : '';
    },

    getFormattedValue: function () {
        return this.element.value;
    },

    destroy: function () {
        var owner = this;

        owner.element.removeEventListener('input', owner.onChangeListener);
        owner.element.removeEventListener('keydown', owner.onKeyDownListener);
        owner.element.removeEventListener('focus', owner.onFocusListener);
        owner.element.removeEventListener('cut', owner.onCutListener);
        owner.element.removeEventListener('copy', owner.onCopyListener);
    },

    toString: function () {
        return '[Cleave Object]';
    }
};

Cleave.NumeralFormatter = NumeralFormatter_1;
Cleave.DateFormatter = DateFormatter_1;
Cleave.TimeFormatter = TimeFormatter_1;
Cleave.PhoneFormatter = PhoneFormatter_1;
Cleave.CreditCardDetector = CreditCardDetector_1;
Cleave.Util = Util_1;
Cleave.DefaultProperties = DefaultProperties_1;

// for angular directive
((typeof commonjsGlobal === 'object' && commonjsGlobal) ? commonjsGlobal : window)['Cleave'] = Cleave;

// CommonJS
var Cleave_1 = Cleave;

/* harmony default export */ __webpack_exports__["a"] = (Cleave_1);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(49)))

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./de-de/countries.json": [
		714,
		9
	],
	"./es-es/countries.json": [
		715,
		8
	],
	"./fr-ca/countries.json": [
		716,
		7
	],
	"./fr-fr/countries.json": [
		717,
		6
	],
	"./it-it/countries.json": [
		718,
		5
	],
	"./nb-no/countries.json": [
		719,
		4
	],
	"./nl-nl/countries.json": [
		720,
		3
	],
	"./sv-se/countries.json": [
		721,
		2
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 548;
module.exports = webpackAsyncContext;

/***/ }),
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(646),
    mapCacheDelete = __webpack_require__(662),
    mapCacheGet = __webpack_require__(664),
    mapCacheHas = __webpack_require__(665),
    mapCacheSet = __webpack_require__(666);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rover_utilities_reportError__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rover_utilities_userAgent__ = __webpack_require__(60);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




// Use this to give errors from this function a uniform format and something we can easily search for
var reportEmbeddedError = function reportEmbeddedError(message) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__rover_utilities_reportError__["a" /* default */])("FireEmbeddedWebEventError: ".concat(message)) || false;
}; // eslint-disable-next-line rover/no-platform-specific-globals-or-imports


var getAndroidRover = function getAndroidRover() {
  return window.rover;
};

var getiOSRover = function getiOSRover() {
  return (// eslint-disable-next-line rover/no-platform-specific-globals-or-imports
    window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.rover
  );
};

var Platforms = Object.freeze({
  android: 'android',
  ios: 'ios'
});

var getPlatform = function getPlatform() {
  if (Object(__WEBPACK_IMPORTED_MODULE_1__rover_utilities_userAgent__["a" /* isAndroid */])()) {
    return Platforms.android;
  } else if (Object(__WEBPACK_IMPORTED_MODULE_1__rover_utilities_userAgent__["h" /* isiOS */])()) {
    return Platforms.ios;
  }

  return null;
};

var getRover = function getRover(platform) {
  switch (platform) {
    case Platforms.android:
      return getAndroidRover();

    case Platforms.ios:
      return getiOSRover();

    default:
      return null;
  }
};

var prepareEventData = function prepareEventData(platform, message) {
  switch (platform) {
    case Platforms.android:
      return JSON.stringify(message);

    case Platforms.ios:
    default:
      return message;
  }
};

var fireEmbeddedWebEvent = function fireEmbeddedWebEvent(_ref) {
  var eventNames = _ref.eventNames,
      eventData = _ref.eventData;

  if (!Object(__WEBPACK_IMPORTED_MODULE_1__rover_utilities_userAgent__["f" /* isMobileEmbedded */])()) {
    return reportEmbeddedError("\"".concat(fireEmbeddedWebEvent.name, "\" called outside embedded context"));
  }

  var platform = getPlatform();

  if (!platform) {
    return reportEmbeddedError('Unable to determine platform');
  }

  var rover = getRover(platform);

  if (!rover) {
    return reportEmbeddedError("Unable to find embedded context object \"rover\" for platform: ".concat(platform));
  }

  if (!rover.postMessage) {
    return reportEmbeddedError("Embedded context did not have \"postMessage\" function for platform: ".concat(platform));
  }

  try {
    // Call postMessage off the `rover` object so that on android it doesn't lose the `this`
    // and we can avoid having postMessage.bind(rover)
    rover.postMessage(prepareEventData(platform, _objectSpread({
      action: 'event'
    }, eventNames, {}, eventData)));
  } catch (err) {
    return reportEmbeddedError("Error firing embedded web event: ".concat(err));
  }

  return true;
};

/* harmony default export */ __webpack_exports__["a"] = (fireEmbeddedWebEvent);

/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SERVICE_TYPE_CHOICES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GUARANTEE_SERVICE_TYPE_CHOICES; });
var SERVICE_TYPE_CHOICES = {
  boarding: 'overnight-boarding',
  traveling: 'overnight-traveling',
  dropIn: 'drop-in',
  dayCare: 'doggy-day-care',
  walking: 'dog-walking',
  onDemandWalking: 'on-demand-dog-walking'
};
var GUARANTEE_SERVICE_TYPE_CHOICES = [SERVICE_TYPE_CHOICES.boarding, SERVICE_TYPE_CHOICES.traveling, SERVICE_TYPE_CHOICES.dropIn, SERVICE_TYPE_CHOICES.dayCare, SERVICE_TYPE_CHOICES.walking];

/***/ }),
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(454);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 645 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(647),
    ListCache = __webpack_require__(464),
    Map = __webpack_require__(525);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(648),
    hashDelete = __webpack_require__(653),
    hashGet = __webpack_require__(654),
    hashHas = __webpack_require__(655),
    hashSet = __webpack_require__(656);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(430);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(524),
    isMasked = __webpack_require__(650),
    isObject = __webpack_require__(389),
    toSource = __webpack_require__(591);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(651);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(361);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 652 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 653 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(430);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(430);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(430);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 657 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(431);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(431);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(431);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(431);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(432);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 663 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(432);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(432);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(432);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(542);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/*!
 * Responsive Bootstrap Toolkit
 * Author:    Maciej Gurban
 * License:   MIT
 * Version:   2.6.3 (2016-06-21)
 * Origin:    https://github.com/maciej-gurban/responsive-bootstrap-toolkit
 */
var ResponsiveBootstrapToolkit=function(i){var e={detectionDivs:{bootstrap:{xs:i('<div class="device-xs visible-xs visible-xs-block"></div>'),sm:i('<div class="device-sm visible-sm visible-sm-block"></div>'),md:i('<div class="device-md visible-md visible-md-block"></div>'),lg:i('<div class="device-lg visible-lg visible-lg-block"></div>')},foundation:{small:i('<div class="device-xs show-for-small-only"></div>'),medium:i('<div class="device-sm show-for-medium-only"></div>'),large:i('<div class="device-md show-for-large-only"></div>'),xlarge:i('<div class="device-lg show-for-xlarge-only"></div>')}},applyDetectionDivs:function(){i(document).ready(function(){i.each(o.breakpoints,function(i){o.breakpoints[i].appendTo(".responsive-bootstrap-toolkit")})})},isAnExpression:function(i){return"<"==i.charAt(0)||">"==i.charAt(0)},splitExpression:function(i){var e=i.charAt(0),o="="==i.charAt(1),s=1+(o?1:0),n=i.slice(s);return{operator:e,orEqual:o,breakpointName:n}},isAnyActive:function(e){var s=!1;return i.each(e,function(i,e){return o.breakpoints[e].is(":visible")?(s=!0,!1):void 0}),s},isMatchingExpression:function(i){var s=e.splitExpression(i),n=Object.keys(o.breakpoints),r=n.indexOf(s.breakpointName);if(-1!==r){var t=0,a=0;"<"==s.operator&&(t=0,a=s.orEqual?++r:r),">"==s.operator&&(t=s.orEqual?r:++r,a=void 0);var l=n.slice(t,a);return e.isAnyActive(l)}}},o={interval:300,framework:null,breakpoints:null,is:function(i){return e.isAnExpression(i)?e.isMatchingExpression(i):o.breakpoints[i]&&o.breakpoints[i].is(":visible")},use:function(i,s){o.framework=i.toLowerCase(),"bootstrap"===o.framework||"foundation"===o.framework?o.breakpoints=e.detectionDivs[o.framework]:o.breakpoints=s,e.applyDetectionDivs()},current:function(){var e="unrecognized";return i.each(o.breakpoints,function(i){o.is(i)&&(e=i)}),e},changed:function(i,e){var s;return function(){clearTimeout(s),s=setTimeout(function(){i()},e||o.interval)}}};return i(document).ready(function(){i('<div class="responsive-bootstrap-toolkit"></div>').appendTo("body")}),null===o.framework&&o.use("bootstrap"),o}(jQuery);"undefined"!=typeof module&&module.exports&&(module.exports=ResponsiveBootstrapToolkit);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(208)))

/***/ }),
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(409),
    isKey = __webpack_require__(771),
    stringToPath = __webpack_require__(924),
    toString = __webpack_require__(927);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rover_globals_backbone__ = __webpack_require__(19);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1__rover_globals_backbone__["a" /* default */].Model.extend({
  url: function url() {
    if (this.instanceUrl) {
      return this.instanceUrl;
    }

    return this.get('url');
  },
  initialize: function initialize(options) {
    this.instanceUrl = options.instanceUrl;

    if (this.get('expiration_year')) {
      this.setExpired();
    } else {
      this.on('sync', this.setExpired, this);
    }
  },
  setExpired: function setExpired() {
    this.set('expired', __WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"].payment.validateCardExpiry(this.get('expiration_month'), this.get('expiration_year')) === false);
  },
  isNew: function isNew() {
    return false;
  }
}));

/***/ }),
/* 753 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rover_globals_underscore__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rover_globals_backbone__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rover_globals_Rover__ = __webpack_require__(14);



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1__rover_globals_backbone__["a" /* default */].Model.extend({
  url: function url() {
    return this.get('url');
  },
  defaults: {
    non_redeemable: 0.0,
    redeemable: 0.0,
    promo_code: null
  },
  initialize: function initialize() {
    this.methodModels = {};
  },
  getTotalRoverBucks: function getTotalRoverBucks() {
    var result = __WEBPACK_IMPORTED_MODULE_0__rover_globals_underscore__["default"].values(this.methodModels).reduce(function (memo, model) {
      return memo + parseFloat(model.getTotalRoverBucks());
    }, 0);

    return result.toFixed(2);
  },
  clearRoverBucksMethods: function clearRoverBucksMethods() {
    this.methodModels = {};
    this.triggerChange();
  },
  addRoverBucksMethod: function addRoverBucksMethod(methodModel) {
    this.methodModels[methodModel.url()] = methodModel;
    this.listenTo(methodModel, 'change', this.triggerChange);
    this.triggerChange();
  },
  getMethodModels: function getMethodModels() {
    return __WEBPACK_IMPORTED_MODULE_0__rover_globals_underscore__["default"].chain(this.methodModels).values().sortBy('sortOrder').value();
  },
  triggerChange: function triggerChange() {
    this.trigger('change');
  }
}));

/***/ }),
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(731),
    toKey = __webpack_require__(667);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(409),
    isSymbol = __webpack_require__(542);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 772 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 773 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_responsive_toolkit_dist_bootstrap_toolkit_min__ = __webpack_require__(668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_responsive_toolkit_dist_bootstrap_toolkit_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_responsive_toolkit_dist_bootstrap_toolkit_min__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rover_globals_jquery__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rover_globals_backbone__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rover_globals_underscore__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__rover_globals_Mustache__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rover_globals_Rover__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rover_utilities_currency__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__rover_utilities_translation__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__rover_shared_js_constants_service__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__rover_utilities_injector__ = __webpack_require__(43);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable filenames/match-regex */










/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2__rover_globals_backbone__["a" /* default */].View.extend({
  rendered: false,
  priceField: 'amountToPay',
  initialize: function initialize(options) {
    __WEBPACK_IMPORTED_MODULE_3__rover_globals_underscore__["default"].bindAll(this, 'render', 'modifyTotalPrice');

    this.priceModel = options.priceModel;
    this.listenTo(this.model, 'complete', this.render);
    this.listenTo(this.priceModel, 'change', this.render); // For app embedded price breakdown

    if (typeof options.showSummary === 'undefined') {
      this.showSummary = true;
    } else {
      this.showSummary = options.showSummary;
    }
  },
  modifyTotalPrice: function modifyTotalPrice(initial) {
    // Only modify the price display if this is rendered
    // This will be called before render happens if the wallet
    // loads before the conversation and updates the conversation model
    if (!this.rendered) {
      return;
    }

    var priceBreakdown = this.priceModel.getTotalPrice(); // Only modify the price if we know what the total roverBucksBalance is

    if (!priceBreakdown) {
      return;
    }

    if (__WEBPACK_IMPORTED_MODULE_5__rover_globals_Rover__["default"].context.isSitter) {
      Object(__WEBPACK_IMPORTED_MODULE_1__rover_globals_jquery__["default"])('.js-total-price').text(priceBreakdown.stayPriceDisplay);
    } else {
      if (priceBreakdown.roverBucksToUse !== '0.00') {
        this.$('.js-roverbucks-amount').text(priceBreakdown.roverBucksToUseDisplay);

        if (initial !== true) {
          this.$('.js-roverbucks-amount').parent().removeClass('highlight').addClass('highlight');
        }

        this.$('.js-has-roverbucks').show();
      } else {
        this.$('.js-has-roverbucks').hide();
      }

      Object(__WEBPACK_IMPORTED_MODULE_1__rover_globals_jquery__["default"])('.js-total-price').text(priceBreakdown["".concat(this.priceField, "Display")]);
    }

    Object(__WEBPACK_IMPORTED_MODULE_1__rover_globals_jquery__["default"])('.js-total-price-container').show();

    if (initial !== true) {
      Object(__WEBPACK_IMPORTED_MODULE_1__rover_globals_jquery__["default"])('.js-total-price').parent().removeClass('highlight').addClass('highlight');
    }
  },
  isRendered: function isRendered() {
    return this.rendered;
  },
  formatBookingAddOns: function formatBookingAddOns(addOns) {
    var petNameUrlMap = {};

    __WEBPACK_IMPORTED_MODULE_3__rover_globals_underscore__["default"].each(this.model.get('pets'), function (dog) {
      petNameUrlMap[dog.url] = {
        name: dog.name,
        webUrl: dog.web_url
      };
    });

    var stayCurrency = this.priceModel.requestableModel.get('stay_price_obj').currency_iso;
    return addOns.map(function (addOn, i) {
      var newInfo = {};

      if (addOn.pet) {
        newInfo.dogName = petNameUrlMap[addOn.pet].name;
        newInfo.dogUrl = petNameUrlMap[addOn.pet].webUrl;
      }

      var locale = Object(__WEBPACK_IMPORTED_MODULE_9__rover_utilities_injector__["a" /* default */])('Rover.context.language', undefined);
      newInfo.price_per_unit = Object(__WEBPACK_IMPORTED_MODULE_6__rover_utilities_currency__["a" /* formatCurrency */])(addOn.price_per_unit, stayCurrency, locale);
      newInfo.total_price = Object(__WEBPACK_IMPORTED_MODULE_6__rover_utilities_currency__["a" /* formatCurrency */])(addOn.total_price, stayCurrency, locale);
      newInfo.unit = __WEBPACK_IMPORTED_MODULE_7__rover_utilities_translation__["default"]._(__WEBPACK_IMPORTED_MODULE_8__rover_shared_js_constants_service__["a" /* SERVICE_ADD_ON_UNITS */][addOn.unit] ? __WEBPACK_IMPORTED_MODULE_8__rover_shared_js_constants_service__["a" /* SERVICE_ADD_ON_UNITS */][addOn.unit](addOn.num_units) : addOn.unit_description);
      if (i > 0) newInfo.notFirst = true;
      newInfo.oneTimeEvent = addOn.frequency === 'one_time_event';
      newInfo.perUnitEvent = addOn.frequency === 'per_unit_event';
      return _objectSpread({}, addOn, {}, newInfo);
    });
  },
  getContextData: function getContextData() {
    var data = this.model.toJSON();
    data.isMobileEmbedded = __WEBPACK_IMPORTED_MODULE_5__rover_globals_Rover__["default"].context.isMobileEmbedded;
    data.roverFeesLocalizedLink = __WEBPACK_IMPORTED_MODULE_5__rover_globals_Rover__["default"].context.roverFeesLocalizedLink;
    data.showSummary = this.showSummary;

    if (this.model.get('pets')) {
      data.dogLinks = this.model.get('pets').map(function (pet) {
        var renderablePet = _objectSpread({}, pet);

        if (__WEBPACK_IMPORTED_MODULE_5__rover_globals_Rover__["default"].context.isMobileEmbedded !== undefined) {
          renderablePet.isMobileEmbedded = __WEBPACK_IMPORTED_MODULE_5__rover_globals_Rover__["default"].context.isMobileEmbedded;
        }

        return __WEBPACK_IMPORTED_MODULE_4__rover_globals_Mustache__["default"].template('new_design/account_conversations/pet').render(renderablePet);
      }).join(', ');
    }

    data.alternativeRateAddOns = this.formatBookingAddOns(this.model.getAlternativeRateAddOns());
    data.nonAlternativeRateAddOns = this.formatBookingAddOns(this.model.getNonAlternativeRateAddOns());

    if (!__WEBPACK_IMPORTED_MODULE_5__rover_globals_Rover__["default"].context.isSitter) {
      data.nonAlternativeRateAddOns = data.nonAlternativeRateAddOns.concat(this.formatBookingAddOns(this.model.getActiveRequesterAddOns()));
    }

    data.hasNonAlternativeRateAddOns = data.nonAlternativeRateAddOns.length !== 0;
    data.booked = data.status === 'booked';
    data.isSitter = __WEBPACK_IMPORTED_MODULE_5__rover_globals_Rover__["default"].context.isSitter;
    data.unit = this.model.getUnit();
    var serviceType = this.model.getServiceType();
    data.serviceTypeName = serviceType ? serviceType.name : '';
    data.showPaymentInformation = data.booked && !serviceType.supports_sdv_based_payments;
    return data;
  },
  render: function render() {
    var data = this.getContextData();
    this.$el.html(this.template.render(data));
    this.rendered = true;
    this.modifyTotalPrice(true);
    this.trigger('rendered');
    this.$el.parents('.js-conversation-summary-container').show();

    if (__WEBPACK_IMPORTED_MODULE_0_responsive_toolkit_dist_bootstrap_toolkit_min___default.a.is('xs')) {
      this.$('[data-toggle="sticky-popover"]').off('mouseover');
      this.$('[data-toggle="sticky-popover"]').off('mouseleave');
    }

    __WEBPACK_IMPORTED_MODULE_5__rover_globals_Rover__["default"].stickyPopover(this.$('[data-toggle="sticky-popover"]'), {
      container: 'body'
    });
  }
}));

/***/ }),
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../globals/jquery.js
var jquery = __webpack_require__(9);

// EXTERNAL MODULE: ../globals/underscore.js
var underscore = __webpack_require__(27);

// EXTERNAL MODULE: ../globals/backbone.js
var backbone = __webpack_require__(19);

// EXTERNAL MODULE: ../globals/Mustache.js
var Mustache = __webpack_require__(134);

// EXTERNAL MODULE: ../utilities/Alerts.js
var Alerts = __webpack_require__(290);

// CONCATENATED MODULE: ./js/backbone/views/checkout/credit_card_view.js





/* harmony default export */ var credit_card_view = (backbone["a" /* default */].View.extend({
  template: Mustache["default"].template('new_design/account_conversations/creditcard'),
  events: {
    'click .js-remove-cc': 'confirmDelete'
  },
  paymentMethodMap: {
    Visa: ['visa', 'Visa'],
    MasterCard: ['mastercard', 'MasterCard'],
    Discover: ['discover', 'Discover'],
    'American Express': ['amex', 'AmEx']
  },
  initialize: function initialize(options) {
    underscore["default"].bindAll(this, 'render', 'confirmDelete', 'deleteCard');

    this.collectionView = options.collectionView;
  },
  confirmDelete: function confirmDelete() {
    if (confirm('Are you sure you want to remove this card?')) {
      this.deleteCard();
    }
  },
  deleteCard: function deleteCard() {
    var ccLength = this.collectionView.collection.models.length;
    Object(jquery["default"])('.js-payment-alerts-container').empty();

    if (ccLength >= 2) {
      this.$el.addClass('faded');
      this.$('.js-remove-cc').prop('disabled', true);
      var creditCardView = this;
      this.model.destroy({
        wait: true,
        success: function success() {
          creditCardView.remove();
          creditCardView.collectionView.trigger('cardRemoved');
          Alerts["a" /* default */].showToast({
            severity: 'success',
            message: 'Your card has been removed.'
          });
        },
        error: function error(model, xhr) {
          creditCardView.$el.removeClass('faded');
          creditCardView.$('.js-remove-cc').prop('disabled', false);

          if (xhr.status === 500) {
            Alerts["a" /* default */].showToast({
              severity: 'danger',
              message: 'We were unable to remove this credit card. Please contact Rover support for assistance.'
            });
          } else if (xhr.status === 422) {
            Alerts["a" /* default */].showToast({
              severity: 'danger',
              message: 'You must have at least one active card on your account. To delete this card, add another first.'
            });
          }
        }
      });
    } else {
      Alerts["a" /* default */].showToast({
        severity: 'danger',
        message: 'You must have at least one active card on your account. To delete this card, add another first.'
      });
    }
  },
  render: function render(data) {
    var renderData = data;
    var cardType = this.model.get('card_type');

    if (Object.prototype.hasOwnProperty.call(this.paymentMethodMap, cardType)) {
      renderData.cardIcon = this.paymentMethodMap[cardType][0];
      renderData.cardDisplay = this.paymentMethodMap[cardType][1];
      this.$el.html(this.template.render(renderData));
    }
  }
}));
// CONCATENATED MODULE: ./js/backbone/views/checkout/credit_card_collection_view.js





/* harmony default export */ var credit_card_collection_view = __webpack_exports__["a"] = (backbone["a" /* default */].View.extend({
  template: Mustache["default"].template('new_design/account_conversations/creditcard_list'),
  events: {
    'click input[name="cc"]': 'triggerCardSelected'
  },
  initialize: function initialize() {
    underscore["default"].bindAll(this, 'render', 'add', 'ensureCardSelected');

    this.rendered = false;
    this.listenTo(this.collection, 'reset', this.render);
    this.listenTo(this.collection, 'add', this.add);
    this.on('cardRemoved', this.ensureCardSelected, this);
  },
  isRendered: function isRendered() {
    return this.rendered;
  },
  getSelectedCC: function getSelectedCC() {
    return this.$('.js-creditcard:checked');
  },
  getSelectedCCURL: function getSelectedCCURL() {
    return this.getSelectedCC().val() || false;
  },
  ensureCardSelected: function ensureCardSelected() {
    if (!this.getSelectedCC().length) {
      this.$('.js-creditcard:last').prop('checked', true);
      this.triggerCardSelected();
    }
  },
  triggerCardSelected: function triggerCardSelected() {
    this.trigger('cardSelected');
  },
  add: function add(card) {
    var $newContainer = Object(jquery["default"])('<div class="js-creditcard-container"></div>');
    var ccView = new credit_card_view({
      model: card,
      el: $newContainer,
      collectionView: this
    });
    var data = card.toJSON();
    data.notFirst = this.$('.js-creditcard-container').length > 0;

    if (data.default_payment) {
      this.getSelectedCC().prop('checked', false);
      this.$('.js-creditcard.js-default-payment').removeClass('js-default-payment');
    }

    this.$('.js-creditcard-list').append($newContainer);
    ccView.render(data);
    this.$('.js-creditcard-list').show();
    this.trigger('rendered');
    this.triggerCardSelected();
  },
  render: function render() {
    var _this = this;

    this.$el.html(this.template.render());

    if (!this.collection.models.length) {
      this.rendered = true;
      this.trigger('initialRender');
      return;
    }

    this.$('.js-creditcard-list').empty();
    this.collection.models.forEach(function (card) {
      _this.add(card);
    });
    this.ensureCardSelected();
    this.rendered = true;
    this.trigger('initialRender');
  }
}));

/***/ }),
/* 887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rover_globals_underscore__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rover_globals_backbone__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rover_globals_Rover__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__rover_utilities_userAgent__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CreditCardModel__ = __webpack_require__(752);






/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2__rover_globals_backbone__["a" /* default */].Collection.extend({
  model: __WEBPACK_IMPORTED_MODULE_5__CreditCardModel__["a" /* default */],
  initialize: function initialize() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    __WEBPACK_IMPORTED_MODULE_1__rover_globals_underscore__["default"].bindAll(this, 'addNewCC');

    this.closeOnAddNewCC = options.closeOnAddNewCC || false;
  },
  addNewCC: function addNewCC(_ref) {
    var url = _ref.url;
    var newCCModel = new __WEBPACK_IMPORTED_MODULE_5__CreditCardModel__["a" /* default */]({
      instanceUrl: url
    });
    var that = this;
    that.closeMobileEmbedded();
    newCCModel.fetch({
      success: function success(model, creditCard) {
        that.add(new __WEBPACK_IMPORTED_MODULE_5__CreditCardModel__["a" /* default */](creditCard));
      }
    });
  },
  closeMobileEmbedded: function closeMobileEmbedded() {
    if (Object(__WEBPACK_IMPORTED_MODULE_4__rover_utilities_userAgent__["f" /* isMobileEmbedded */])() && this.closeOnAddNewCC) {
      if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.rover && window.webkit.messageHandlers.rover.postMessage) {
        window.webkit.messageHandlers.rover.postMessage({
          action: 'dialog-closed'
        });
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])(document).trigger({
          type: 'dialog-closed'
        });
      }
    }
  }
}));

/***/ }),
/* 888 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../globals/jquery.js
var jquery = __webpack_require__(9);

// EXTERNAL MODULE: ../globals/underscore.js
var underscore = __webpack_require__(27);

// EXTERNAL MODULE: ../globals/backbone.js
var backbone = __webpack_require__(19);

// EXTERNAL MODULE: ../globals/Rover.js
var Rover = __webpack_require__(14);

// EXTERNAL MODULE: ./js/backbone/models/CreditCardModel.js
var CreditCardModel = __webpack_require__(752);

// CONCATENATED MODULE: ./js/backbone/models/WalletMethodModel.js


var PAYMENT_METHOD_SORT_ORDER = ['promo', 'wallet'];
/* harmony default export */ var WalletMethodModel = (backbone["a" /* default */].Model.extend({
  sortOrder: PAYMENT_METHOD_SORT_ORDER.indexOf('wallet'),
  url: function url() {
    return this.get('url');
  },
  defaults: {
    non_redeemable: null,
    redeemable: null
  },
  getTotalRoverBucks: function getTotalRoverBucks() {
    if (this.get('non_redeemable') === null || this.get('redeemable') === null) {
      return '0.00';
    }

    return (parseFloat(this.get('non_redeemable')) + parseFloat(this.get('redeemable'))).toFixed(2);
  }
}));
// CONCATENATED MODULE: ./js/backbone/models/PaymentMethodCollection.js






/* harmony default export */ var PaymentMethodCollection = __webpack_exports__["a"] = (backbone["a" /* default */].Collection.extend({
  url: function url() {
    return Rover["default"].urls.paymentMethods;
  },
  initialize: function initialize(options) {
    this.on('sync', this.breakoutMethods, this);
    this.creditCardCollection = options.creditCardCollection;
    this.roverBucksModel = options.roverBucksModel;
  },
  breakoutMethods: function breakoutMethods() {
    var that = this;
    var creditCards = [];
    this.roverBucksModel.clearRoverBucksMethods();

    underscore["default"].each(this.models, function (model) {
      var type = model.get('type');

      if (type === 'wallet') {
        var m = new WalletMethodModel(model.toJSON());
        that.roverBucksModel.addRoverBucksMethod(m);
        that.roverBucksModel.set(model.toJSON());
      } else if (type === 'promo') {
        var _m = new Rover["default"].models.PromoMethodModel(model.toJSON());

        that.roverBucksModel.addRoverBucksMethod(_m);
      } else if (type === 'creditcard') {
        var creditCardModel = new CreditCardModel["a" /* default */](model.toJSON());

        if (creditCardModel.get('expired') !== true) {
          creditCards.push(creditCardModel);
        }
      }
    });

    if (that.creditCardCollection) {
      that.creditCardCollection.reset(creditCards);
    }
  }
}));

/***/ }),
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ../node_modules/lodash-es/_arrayAggregator.js
/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function arrayAggregator(array, setter, iteratee, accumulator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    var value = array[index];
    setter(accumulator, value, iteratee(value), array);
  }
  return accumulator;
}

/* harmony default export */ var _arrayAggregator = (arrayAggregator);

// EXTERNAL MODULE: ../node_modules/lodash-es/_baseEach.js + 1 modules
var _baseEach = __webpack_require__(112);

// CONCATENATED MODULE: ../node_modules/lodash-es/_baseAggregator.js


/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function baseAggregator(collection, setter, iteratee, accumulator) {
  Object(_baseEach["a" /* default */])(collection, function(value, key, collection) {
    setter(accumulator, value, iteratee(value), collection);
  });
  return accumulator;
}

/* harmony default export */ var _baseAggregator = (baseAggregator);

// EXTERNAL MODULE: ../node_modules/lodash-es/_baseIteratee.js + 9 modules
var _baseIteratee = __webpack_require__(61);

// EXTERNAL MODULE: ../node_modules/lodash-es/isArray.js
var isArray = __webpack_require__(5);

// CONCATENATED MODULE: ../node_modules/lodash-es/_createAggregator.js





/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */
function createAggregator(setter, initializer) {
  return function(collection, iteratee) {
    var func = Object(isArray["a" /* default */])(collection) ? _arrayAggregator : _baseAggregator,
        accumulator = initializer ? initializer() : {};

    return func(collection, setter, Object(_baseIteratee["a" /* default */])(iteratee, 2), accumulator);
  };
}

/* harmony default export */ var _createAggregator = __webpack_exports__["a"] = (createAggregator);


/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(770);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(925);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(926);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(572);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(928);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(454),
    arrayMap = __webpack_require__(772),
    isArray = __webpack_require__(409),
    isSymbol = __webpack_require__(542);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rover_globals_underscore__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rover_globals_Mustache__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rover_globals_Rover__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__rover_shared_js_constants_i18n_datetime_datetimeInjected__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__requestable_summary_view__ = __webpack_require__(773);



 // WARNING: DF from datetimeInjected is not SSR compatible.
// For newer code, use const DF = getDateTimeFormatMapForLang(<lang>) from '@rover/shared/js/constants/i18n/datetime'



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_5__requestable_summary_view__["a" /* default */].extend({
  template: __WEBPACK_IMPORTED_MODULE_2__rover_globals_Mustache__["default"].template('new_design/account_conversations/conversation'),
  getContextData: function getContextData() {
    var _this = this;

    var data = __WEBPACK_IMPORTED_MODULE_5__requestable_summary_view__["a" /* default */].prototype.getContextData.apply(this);

    __WEBPACK_IMPORTED_MODULE_1__rover_globals_underscore__["default"].each(['start_date', 'end_date'], function (prop) {
      data["".concat(prop, "_formatted")] = __WEBPACK_IMPORTED_MODULE_0_moment___default()(_this.model.get(prop)).format(__WEBPACK_IMPORTED_MODULE_4__rover_shared_js_constants_i18n_datetime_datetimeInjected__["b" /* default */].DATE_WEEK_SHORT);
    });

    data.supportsNonContiguousDates = this.model.supportsNonContiguousDates();
    data.datesList = this.model.datesList(__WEBPACK_IMPORTED_MODULE_4__rover_shared_js_constants_i18n_datetime_datetimeInjected__["b" /* default */].DATE_MED);

    if (this.model.supportsNumUnitsPerDay()) {
      data.numUnitsPerDay = this.model.getPerDaySummary();
    }

    return data;
  }
}));

/***/ }),
/* 930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rover_globals_Mustache__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rover_globals_Rover__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rover_shared_js_constants_i18n_datetime_datetimeInjected__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__requestable_summary_view__ = __webpack_require__(773);


 // WARNING: DF from datetimeInjected is not SSR compatible.
// For newer code, use const DF = getDateTimeFormatMapForLang(<lang>) from '@rover/shared/js/constants/i18n/datetime'



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_4__requestable_summary_view__["a" /* default */].extend({
  template: __WEBPACK_IMPORTED_MODULE_1__rover_globals_Mustache__["default"].template('new_design/account_conversations/recurring_billing'),
  priceField: 'totalPrice',
  getContextData: function getContextData() {
    var data = __WEBPACK_IMPORTED_MODULE_4__requestable_summary_view__["a" /* default */].prototype.getContextData.apply(this);
    data.daysList = this.model.daysList().join(', ');
    data.start_date_formatted = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.model.get('start_date')).format(__WEBPACK_IMPORTED_MODULE_3__rover_shared_js_constants_i18n_datetime_datetimeInjected__["b" /* default */].DATE_WEEK_SHORT);
    data.numUnitsPerDay = this.model.getPerDaySummary();
    return data;
  }
}));

/***/ }),
/* 931 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rover_globals_underscore__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rover_globals_backbone__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rover_utilities_currency__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rover_utilities_injector__ = __webpack_require__(43);




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1__rover_globals_backbone__["a" /* default */].Model.extend({
  defaults: {
    roverBucksBalance: null,
    requestableTotalPrice: null
  },
  initialize: function initialize(optionset) {
    var options = optionset || {};

    __WEBPACK_IMPORTED_MODULE_0__rover_globals_underscore__["default"].bindAll(this, 'updateRequestableTotalPrice', 'updateRoverBucksBalance');

    this.requestableModel = options.requestableModel;
    this.roverBucksModel = options.roverBucksModel;
    this.listenTo(this.requestableModel, 'change:total_price', this.updateRequestableTotalPrice);
    this.listenTo(this.roverBucksModel, 'change', this.updateRoverBucksBalance);
    this.updateRoverBucksBalance();
  },
  updateRequestableTotalPrice: function updateRequestableTotalPrice() {
    this.set('requestableTotalPrice', this.requestableModel.get('total_price'));
  },
  updateRoverBucksBalance: function updateRoverBucksBalance() {
    this.set('roverBucksBalance', this.roverBucksModel.getTotalRoverBucks());
  },
  roverBucksCoverCost: function roverBucksCoverCost() {
    return parseFloat(this.get('roverBucksBalance')) >= parseFloat(this.get('requestableTotalPrice'));
  },
  getTotalPrice: function getTotalPrice() {
    var requestableTotalPrice = parseFloat(this.get('requestableTotalPrice'));
    var totalPriceCurrencyIso = this.requestableModel.get('total_price_obj').currency_iso;
    var stayPriceCurrencyIso = this.requestableModel.get('stay_price_obj').currency_iso;
    var roverBucksBalance = null;
    var amountToPay = requestableTotalPrice;
    var roverBucksToUse = roverBucksBalance;

    if (this.get('roverBucksBalance') !== null) {
      roverBucksBalance = parseFloat(this.get('roverBucksBalance'));
    }

    roverBucksToUse = roverBucksBalance; // Only return total price if we know what the roverBucksBalance is, even if 0

    if (this.requestableModel.isPayingState() && roverBucksBalance === null) {
      return false;
    }

    if (this.roverBucksCoverCost()) {
      amountToPay = 0;
      roverBucksToUse = requestableTotalPrice;
    } else if (roverBucksBalance > 0) {
      amountToPay = requestableTotalPrice - roverBucksBalance;
    } else if (roverBucksBalance < 0) {
      roverBucksToUse = 0;
    }

    amountToPay = Math.round(amountToPay * 100) / 100;
    var locale = Object(__WEBPACK_IMPORTED_MODULE_3__rover_utilities_injector__["a" /* default */])('Rover.context.language', undefined);
    return {
      amountToPay: amountToPay.toFixed(2),
      totalPriceCurrencyIso: totalPriceCurrencyIso,
      amountToPayDisplay: Object(__WEBPACK_IMPORTED_MODULE_2__rover_utilities_currency__["a" /* formatCurrency */])(amountToPay.toFixed(2), totalPriceCurrencyIso, locale),
      roverBucksToUse: roverBucksToUse.toFixed(2),
      roverBucksToUseDisplay: Object(__WEBPACK_IMPORTED_MODULE_2__rover_utilities_currency__["a" /* formatCurrency */])(roverBucksToUse.toFixed(2), totalPriceCurrencyIso, locale),
      totalPrice: requestableTotalPrice.toFixed(2),
      totalPriceDisplay: Object(__WEBPACK_IMPORTED_MODULE_2__rover_utilities_currency__["a" /* formatCurrency */])(requestableTotalPrice.toFixed(2), totalPriceCurrencyIso, locale),
      stayPrice: this.requestableModel.get('stay_price'),
      stayPriceCurrencyIso: stayPriceCurrencyIso,
      stayPriceDisplay: Object(__WEBPACK_IMPORTED_MODULE_2__rover_utilities_currency__["a" /* formatCurrency */])(this.requestableModel.get('stay_price'), stayPriceCurrencyIso, locale)
    };
  }
}));

/***/ }),
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */,
/* 1126 */,
/* 1127 */,
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */,
/* 1134 */,
/* 1135 */,
/* 1136 */,
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */,
/* 1142 */,
/* 1143 */,
/* 1144 */,
/* 1145 */,
/* 1146 */,
/* 1147 */,
/* 1148 */,
/* 1149 */,
/* 1150 */,
/* 1151 */,
/* 1152 */,
/* 1153 */,
/* 1154 */,
/* 1155 */,
/* 1156 */,
/* 1157 */,
/* 1158 */,
/* 1159 */,
/* 1160 */,
/* 1161 */,
/* 1162 */,
/* 1163 */,
/* 1164 */,
/* 1165 */,
/* 1166 */,
/* 1167 */,
/* 1168 */,
/* 1169 */,
/* 1170 */,
/* 1171 */,
/* 1172 */,
/* 1173 */,
/* 1174 */,
/* 1175 */,
/* 1176 */,
/* 1177 */,
/* 1178 */,
/* 1179 */,
/* 1180 */,
/* 1181 */,
/* 1182 */,
/* 1183 */,
/* 1184 */,
/* 1185 */,
/* 1186 */,
/* 1187 */,
/* 1188 */,
/* 1189 */,
/* 1190 */,
/* 1191 */,
/* 1192 */,
/* 1193 */,
/* 1194 */,
/* 1195 */,
/* 1196 */,
/* 1197 */,
/* 1198 */,
/* 1199 */,
/* 1200 */,
/* 1201 */,
/* 1202 */,
/* 1203 */,
/* 1204 */,
/* 1205 */,
/* 1206 */,
/* 1207 */,
/* 1208 */,
/* 1209 */,
/* 1210 */,
/* 1211 */,
/* 1212 */,
/* 1213 */,
/* 1214 */,
/* 1215 */,
/* 1216 */,
/* 1217 */,
/* 1218 */,
/* 1219 */,
/* 1220 */,
/* 1221 */,
/* 1222 */,
/* 1223 */,
/* 1224 */,
/* 1225 */,
/* 1226 */,
/* 1227 */,
/* 1228 */,
/* 1229 */,
/* 1230 */,
/* 1231 */,
/* 1232 */,
/* 1233 */,
/* 1234 */,
/* 1235 */,
/* 1236 */,
/* 1237 */,
/* 1238 */,
/* 1239 */,
/* 1240 */,
/* 1241 */,
/* 1242 */,
/* 1243 */,
/* 1244 */,
/* 1245 */,
/* 1246 */,
/* 1247 */,
/* 1248 */,
/* 1249 */,
/* 1250 */,
/* 1251 */,
/* 1252 */,
/* 1253 */,
/* 1254 */,
/* 1255 */,
/* 1256 */,
/* 1257 */,
/* 1258 */,
/* 1259 */,
/* 1260 */,
/* 1261 */,
/* 1262 */,
/* 1263 */,
/* 1264 */,
/* 1265 */,
/* 1266 */,
/* 1267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mount; });
var reactCCFormContainer = '#react-ccform';

/**
 * Mounts the CreditCardForm into a given (or default) DOM element and
 * returns an "unmount" teardown function that can be used to clean up
 * if needed.
 */
var mount = function mount(appProps) {
  var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : reactCCFormContainer;
  var ReactDOM;
  var renderRootElement;
  var ConversationsCheckoutPageContainer; // bail if react is undefined, this helps us avoid loading react on the page when the experiment isn't running

  try {
    ReactDOM = __webpack_require__(81);
    renderRootElement = __webpack_require__(203)["default"];
    ConversationsCheckoutPageContainer = __webpack_require__(1268)["default"];
  } catch (e) {
    return function () {};
  }

  if (document.querySelector(id) && renderRootElement) {
    renderRootElement(ConversationsCheckoutPageContainer, id, appProps);

    if (false) {
      module.hot.accept('./ConversationsCheckoutPageContainer', function () {
        renderRootElement( // eslint-disable-next-line global-require
        require("./ConversationsCheckoutPageContainer")["default"], id, appProps);
      });
    }

    return function () {
      return ReactDOM.unmountComponentAtNode(document.querySelector(id));
    };
  }

  return function () {};
};

/***/ }),
/* 1268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ../react-lib/src/components/utils/Redux/index.js
var Redux = __webpack_require__(67);

// EXTERNAL MODULE: ../react-lib/src/redux/ducks/address.duck.js + 1 modules
var address_duck = __webpack_require__(317);

// EXTERNAL MODULE: ../react-lib/src/redux/ducks/currentUser.duck.js + 1 modules
var currentUser_duck = __webpack_require__(148);

// EXTERNAL MODULE: ../react-lib/src/redux/ducks/creditCards.duck.js + 1 modules
var creditCards_duck = __webpack_require__(366);

// EXTERNAL MODULE: ../react-lib/src/redux/ducks/countryConfiguration.duck.js + 2 modules
var countryConfiguration_duck = __webpack_require__(202);

// EXTERNAL MODULE: ../react-lib/src/redux/ducks/frontendConfiguration.duck.js + 3 modules
var frontendConfiguration_duck = __webpack_require__(149);

// EXTERNAL MODULE: ../react-lib/src/constants/phoneNumbers.constants.js
var phoneNumbers_constants = __webpack_require__(519);

// EXTERNAL MODULE: ../react-lib/src/lib/redux-duck/index.js + 2 modules
var redux_duck = __webpack_require__(21);

// CONCATENATED MODULE: ../react-lib/src/pages/conversations/ConversationsCheckoutPage/ConversationsCheckoutPage.duck.jsx
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var options = {
  name: 'conversationsCheckoutPage',
  initialState: {
    selectedCardId: '',
    errorMessage: '',
    loading: false,
    serviceType: ''
  },
  actions: {
    setSelectedCardId: function setSelectedCardId(selectedCardId) {
      return function (state) {
        return _objectSpread({}, state, {
          selectedCardId: selectedCardId
        });
      };
    },
    selectCardPending: function selectCardPending() {
      return function (state) {
        return _objectSpread({}, state, {
          errorMessage: '',
          loading: true
        });
      };
    },
    selectCardSuccess: function selectCardSuccess(_ref) {
      var selectedCardId = _ref.selectedCardId;
      return function (state) {
        return _objectSpread({}, state, {
          selectedCardId: selectedCardId,
          errorMessage: '',
          loading: false
        });
      };
    },
    selectCardFailure: function selectCardFailure(_ref2) {
      var errorMessage = _ref2.errorMessage;
      return function (state) {
        return _objectSpread({}, state, {
          errorMessage: errorMessage,
          loading: false
        });
      };
    },
    setServiceType: function setServiceType(serviceType) {
      return function (state) {
        return _objectSpread({}, state, {
          serviceType: serviceType
        });
      };
    }
  },
  effects: {
    selectCard: function selectCard(selectedCardId) {
      return (
        /*#__PURE__*/
        function () {
          var _ref3 = _asyncToGenerator(
          /*#__PURE__*/
          regeneratorRuntime.mark(function _callee2(dispatch, getState, duckActions) {
            var supportNumber, errorMessage;
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    if (document.querySelector('[name="cc"]:not([disabled])')) {
                      _context2.next = 3;
                      break;
                    }

                    dispatch(duckActions.selectCardSuccess({
                      selectedCardId: selectedCardId
                    }));
                    return _context2.abrupt("return");

                  case 3:
                    dispatch(duckActions.selectCardPending()); // NOTE(Ryan): fallback # is copied from ContactRoverSupoortSection.jsx

                    supportNumber = countryConfiguration_duck["c" /* selectors */].getCurrentCustomerSupportPhoneFormatted(getState()) || phoneNumbers_constants["a" /* US_ROVER_SUPPORT_NUMBER */];
                    _context2.prev = 5;
                    return _context2.delegateYield(
                    /*#__PURE__*/
                    regeneratorRuntime.mark(function _callee() {
                      var backboneRadioButton, retry, maxRetries, retryInterval;
                      return regeneratorRuntime.wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              // attempt to find backbone radio button,
                              // we need to retry in case the backbone collection/view is fetching/rerendering
                              retry = 0;
                              maxRetries = 20;
                              retryInterval = 500;

                            case 3:
                              if (!(!backboneRadioButton && retry < maxRetries)) {
                                _context.next = 12;
                                break;
                              }

                              backboneRadioButton = document.getElementById(selectedCardId);

                              if (!backboneRadioButton) {
                                _context.next = 7;
                                break;
                              }

                              return _context.abrupt("break", 12);

                            case 7:
                              _context.next = 9;
                              return new Promise(function (resolve) {
                                return setTimeout(resolve, retryInterval);
                              });

                            case 9:
                              retry += 1;
                              _context.next = 3;
                              break;

                            case 12:
                              if (!(!backboneRadioButton || !(backboneRadioButton instanceof HTMLInputElement))) {
                                _context.next = 15;
                                break;
                              }

                              // eslint-disable-next-line no-console
                              console.error("Cannot find Backbone radio button ID while selecting card: ".concat(selectedCardId));
                              throw new Error();

                            case 15:
                              // attept to click backbone radio button
                              backboneRadioButton.click(); // confirm we have selected the backbone radio button

                              if (backboneRadioButton.checked) {
                                _context.next = 19;
                                break;
                              }

                              // eslint-disable-next-line no-console
                              console.error("Failed to click/select Backbone radio button ID while selecting card: ".concat(selectedCardId));
                              throw new Error();

                            case 19:
                              _context.next = 21;
                              return new Promise(function (resolve) {
                                return setTimeout(resolve, 0);
                              });

                            case 21:
                              dispatch(duckActions.selectCardSuccess({
                                selectedCardId: selectedCardId
                              }));

                            case 22:
                            case "end":
                              return _context.stop();
                          }
                        }
                      }, _callee);
                    })(), "t0", 7);

                  case 7:
                    _context2.next = 13;
                    break;

                  case 9:
                    _context2.prev = 9;
                    _context2.t1 = _context2["catch"](5);
                    errorMessage =
                    /*i18n*/
                    {
                      id: "Error selecting card: please refresh the page and try again.  If the problem persists, please contact Customer Support at {supportNumber}",
                      values: {
                        supportNumber: supportNumber
                      }
                    };
                    dispatch(duckActions.selectCardFailure({
                      errorMessage: errorMessage
                    }));

                  case 13:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2, null, [[5, 9]]);
          }));

          return function (_x, _x2, _x3) {
            return _ref3.apply(this, arguments);
          };
        }()
      );
    },
    prefetchData: function prefetchData() {
      return (
        /*#__PURE__*/
        function () {
          var _ref4 = _asyncToGenerator(
          /*#__PURE__*/
          regeneratorRuntime.mark(function _callee3(dispatch, getState) {
            var personOpk;
            return regeneratorRuntime.wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    _context3.next = 2;
                    return dispatch(currentUser_duck["a" /* effects */].fetchCurrentUser());

                  case 2:
                    personOpk = currentUser_duck["c" /* selectors */].getOpk(getState());
                    _context3.next = 5;
                    return dispatch(address_duck["b" /* effects */].fetchAddress(personOpk));

                  case 5:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee3);
          }));

          return function (_x4, _x5) {
            return _ref4.apply(this, arguments);
          };
        }()
      );
    }
  },
  selectors: {
    getSelectedCardId: function getSelectedCardId(getState, createSelector) {
      return createSelector([getState], function (state) {
        return state.selectedCardId;
      });
    },
    getErrorMessage: function getErrorMessage(getState, createSelector) {
      return createSelector([getState], function (state) {
        return state.errorMessage;
      });
    },
    getLoading: function getLoading(getState, createSelector) {
      return createSelector([getState, creditCards_duck["d" /* selectors */].getLoading], function (_ref5, creditCardsLoading) {
        var loading = _ref5.loading;
        return loading || creditCardsLoading;
      });
    },
    getServiceType: function getServiceType(getState, createSelector) {
      return createSelector([getState], function (state) {
        return state.serviceType;
      });
    }
  }
};

var _ref6 = Object(redux_duck["a" /* createDuck */])(options),
    actions = _ref6.actions,
    selectors = _ref6.selectors,
    effects = _ref6.effects,
    reducer = _ref6.reducer;


// EXTERNAL MODULE: ../react-lib/src/components/utils/RoverLoading/index.js
var RoverLoading = __webpack_require__(312);

// EXTERNAL MODULE: ../react-lib/src/components/utils/Redux/Connect.jsx + 1 modules
var Connect = __webpack_require__(29);

// EXTERNAL MODULE: ../react-lib/src/components/notifications/SuccessOrErrorAlert/index.js + 2 modules
var SuccessOrErrorAlert = __webpack_require__(257);

// EXTERNAL MODULE: ../react-lib/src/containers/CreditCardFormContainer.jsx + 25 modules
var CreditCardFormContainer = __webpack_require__(533);

// CONCATENATED MODULE: ../react-lib/src/pages/conversations/ConversationsCheckoutPage/components/SelectPaymentMethodForm/SelectPaymentMethodForm.jsx
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }





var SelectPaymentMethodForm_SelectPaymentMethodForm = function SelectPaymentMethodForm(_ref) {
  var selectedCardId = _ref.selectedCardId,
      errorMessage = _ref.errorMessage,
      onChange = _ref.onChange,
      other = _objectWithoutProperties(_ref, ["selectedCardId", "errorMessage", "onChange"]);

  return react_default.a.createElement(react["Fragment"], null, react_default.a.createElement(SuccessOrErrorAlert["a" /* default */], {
    error: errorMessage
  }), react_default.a.createElement(CreditCardFormContainer["a" /* default */], _extends({}, other, {
    shouldSetDefaultCardOnChange: false,
    selectedCardId: selectedCardId,
    onChange: onChange,
    validationErrors: null,
    radioName: "react-cc"
  })));
};

/* harmony default export */ var components_SelectPaymentMethodForm_SelectPaymentMethodForm = (SelectPaymentMethodForm_SelectPaymentMethodForm);
// CONCATENATED MODULE: ../react-lib/src/pages/conversations/ConversationsCheckoutPage/components/SelectPaymentMethodForm/SelectPaymentMethodFormContainer.jsx
function SelectPaymentMethodFormContainer__extends() { SelectPaymentMethodFormContainer__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return SelectPaymentMethodFormContainer__extends.apply(this, arguments); }







var SelectPaymentMethodFormContainer_selector = function selector(state) {
  return {
    selectedCardId: selectors.getSelectedCardId(state) || creditCards_duck["d" /* selectors */].getDefaultCreditCardId(state),
    errorMessage: selectors.getErrorMessage(state)
  };
};

var SelectPaymentMethodFormContainer_effects = {
  onChange: effects.selectCard
};

var SelectPaymentMethodFormContainer_SelectPaymentMethodFormContainer = function SelectPaymentMethodFormContainer(props) {
  return react_default.a.createElement(Connect["a" /* default */], {
    selector: SelectPaymentMethodFormContainer_selector,
    effects: SelectPaymentMethodFormContainer_effects
  }, function (connectedProps) {
    return react_default.a.createElement(components_SelectPaymentMethodForm_SelectPaymentMethodForm, SelectPaymentMethodFormContainer__extends({}, props, connectedProps));
  });
};

/* harmony default export */ var SelectPaymentMethodForm_SelectPaymentMethodFormContainer = (SelectPaymentMethodFormContainer_SelectPaymentMethodFormContainer);
// CONCATENATED MODULE: ../react-lib/src/pages/conversations/ConversationsCheckoutPage/components/SelectPaymentMethodForm/index.js

// CONCATENATED MODULE: ../react-lib/src/pages/conversations/ConversationsCheckoutPage/ConversationsCheckoutPage.jsx
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }





var ConversationsCheckoutPage_ConversationsCheckoutPage =
/*#__PURE__*/
function (_Component) {
  _inherits(ConversationsCheckoutPage, _Component);

  function ConversationsCheckoutPage(props) {
    var _this;

    _classCallCheck(this, ConversationsCheckoutPage);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ConversationsCheckoutPage).call(this, props));
    _this.state = {
      ccFormIsDisabled: false
    };

    _this.disableCCForm = function () {
      _this.setState(function () {
        return {
          ccFormIsDisabled: true
        };
      });
    };

    props.recieveSetDisabledReactCCFormUIFunc(_this.disableCCForm);
    return _this;
  }

  _createClass(ConversationsCheckoutPage, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          setServiceType = _this$props.setServiceType,
          serviceType = _this$props.serviceType;
      setServiceType(serviceType);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.creditCards.length !== this.props.creditCards.length) {
        this.props.onAddOrRemoveCard();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var isLoading = this.props.isLoading;
      return react_default.a.createElement(RoverLoading["a" /* default */], {
        isLoading: isLoading
      }, react_default.a.createElement(SelectPaymentMethodForm_SelectPaymentMethodFormContainer, {
        disabled: this.state.ccFormIsDisabled
      }));
    }
  }]);

  return ConversationsCheckoutPage;
}(react["Component"]);

ConversationsCheckoutPage_ConversationsCheckoutPage.defaultProps = {
  recieveSetDisabledReactCCFormUIFunc: function recieveSetDisabledReactCCFormUIFunc() {}
};

// EXTERNAL MODULE: ../react-lib/src/redux/createAnalyticsSaga.js
var createAnalyticsSaga = __webpack_require__(498);

// CONCATENATED MODULE: ../react-lib/src/pages/conversations/ConversationsCheckoutPage/sagas/analytics.js




var analytics_getData = function getData(state, action) {
  switch (action.type) {
    case creditCards_duck["a" /* actions */].saveCreditCardSuccess.actionType:
      return {
        event: 'owner-conversion-checkout-save-card',
        serviceType: selectors.getServiceType(state)
      };

    default:
      return null;
  }
};

/* harmony default export */ var analytics = (Object(createAnalyticsSaga["a" /* default */])([creditCards_duck["a" /* actions */].saveCreditCardSuccess.actionType], analytics_getData));
// CONCATENATED MODULE: ../react-lib/src/pages/conversations/ConversationsCheckoutPage/sagas/index.js

/* harmony default export */ var sagas = ([analytics]);
// CONCATENATED MODULE: ../react-lib/src/pages/conversations/ConversationsCheckoutPage/ConversationsCheckoutPageContainer.jsx
function ConversationsCheckoutPageContainer__extends() { ConversationsCheckoutPageContainer__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return ConversationsCheckoutPageContainer__extends.apply(this, arguments); }












var ConversationsCheckoutPageContainer_selector = function selector(state) {
  return {
    creditCards: creditCards_duck["d" /* selectors */].getCreditCards(state),
    isLoading: selectors.getLoading(state)
  };
};

var ConversationsCheckoutPageContainer_actions = {
  setServiceType: actions.setServiceType
};

var ConversationsCheckoutPageContainer_ConversationsCheckoutPageContainer = function ConversationsCheckoutPageContainer(props) {
  return react_default.a.createElement(Redux["b" /* Provider */], {
    reducers: {
      address: address_duck["c" /* reducer */],
      currentUser: currentUser_duck["b" /* reducer */],
      creditCards: creditCards_duck["c" /* reducer */],
      countryConfiguration: countryConfiguration_duck["b" /* reducer */],
      conversationsCheckoutPage: reducer,
      frontendConfiguration: frontendConfiguration_duck["b" /* reducer */]
    },
    sagas: sagas
  }, react_default.a.createElement(Redux["a" /* Connect */], {
    selector: ConversationsCheckoutPageContainer_selector,
    actions: ConversationsCheckoutPageContainer_actions,
    onMount: [effects.prefetchData, creditCards_duck["b" /* effects */].fetchCreditCards, frontendConfiguration_duck["a" /* effects */].fetchFrontendConfiguration, countryConfiguration_duck["a" /* effects */].fetchConfiguration]
  }, function (redux) {
    return react_default.a.createElement(ConversationsCheckoutPage_ConversationsCheckoutPage, ConversationsCheckoutPageContainer__extends({}, redux, props));
  }));
};

/* harmony default export */ var ConversationsCheckoutPage_ConversationsCheckoutPageContainer = __webpack_exports__["default"] = (ConversationsCheckoutPageContainer_ConversationsCheckoutPageContainer);

/***/ }),
/* 1269 */,
/* 1270 */,
/* 1271 */,
/* 1272 */,
/* 1273 */,
/* 1274 */,
/* 1275 */,
/* 1276 */,
/* 1277 */,
/* 1278 */,
/* 1279 */,
/* 1280 */,
/* 1281 */,
/* 1282 */,
/* 1283 */,
/* 1284 */,
/* 1285 */,
/* 1286 */,
/* 1287 */,
/* 1288 */,
/* 1289 */,
/* 1290 */,
/* 1291 */,
/* 1292 */,
/* 1293 */,
/* 1294 */,
/* 1295 */,
/* 1296 */,
/* 1297 */,
/* 1298 */,
/* 1299 */,
/* 1300 */,
/* 1301 */,
/* 1302 */,
/* 1303 */,
/* 1304 */,
/* 1305 */,
/* 1306 */,
/* 1307 */,
/* 1308 */,
/* 1309 */,
/* 1310 */,
/* 1311 */,
/* 1312 */,
/* 1313 */,
/* 1314 */,
/* 1315 */,
/* 1316 */,
/* 1317 */,
/* 1318 */,
/* 1319 */,
/* 1320 */,
/* 1321 */,
/* 1322 */,
/* 1323 */,
/* 1324 */,
/* 1325 */,
/* 1326 */,
/* 1327 */,
/* 1328 */,
/* 1329 */,
/* 1330 */,
/* 1331 */,
/* 1332 */,
/* 1333 */,
/* 1334 */,
/* 1335 */,
/* 1336 */,
/* 1337 */,
/* 1338 */,
/* 1339 */,
/* 1340 */,
/* 1341 */,
/* 1342 */,
/* 1343 */,
/* 1344 */,
/* 1345 */,
/* 1346 */,
/* 1347 */,
/* 1348 */,
/* 1349 */,
/* 1350 */,
/* 1351 */,
/* 1352 */,
/* 1353 */,
/* 1354 */,
/* 1355 */,
/* 1356 */,
/* 1357 */,
/* 1358 */,
/* 1359 */,
/* 1360 */,
/* 1361 */,
/* 1362 */,
/* 1363 */,
/* 1364 */,
/* 1365 */,
/* 1366 */,
/* 1367 */,
/* 1368 */,
/* 1369 */,
/* 1370 */,
/* 1371 */,
/* 1372 */,
/* 1373 */,
/* 1374 */,
/* 1375 */,
/* 1376 */,
/* 1377 */,
/* 1378 */,
/* 1379 */,
/* 1380 */,
/* 1381 */,
/* 1382 */,
/* 1383 */,
/* 1384 */,
/* 1385 */,
/* 1386 */,
/* 1387 */,
/* 1388 */,
/* 1389 */,
/* 1390 */,
/* 1391 */,
/* 1392 */,
/* 1393 */,
/* 1394 */,
/* 1395 */,
/* 1396 */,
/* 1397 */,
/* 1398 */,
/* 1399 */,
/* 1400 */,
/* 1401 */,
/* 1402 */,
/* 1403 */,
/* 1404 */,
/* 1405 */,
/* 1406 */,
/* 1407 */,
/* 1408 */,
/* 1409 */,
/* 1410 */,
/* 1411 */,
/* 1412 */,
/* 1413 */,
/* 1414 */,
/* 1415 */,
/* 1416 */,
/* 1417 */,
/* 1418 */,
/* 1419 */,
/* 1420 */,
/* 1421 */,
/* 1422 */,
/* 1423 */,
/* 1424 */,
/* 1425 */,
/* 1426 */,
/* 1427 */,
/* 1428 */,
/* 1429 */,
/* 1430 */,
/* 1431 */,
/* 1432 */,
/* 1433 */,
/* 1434 */,
/* 1435 */,
/* 1436 */,
/* 1437 */,
/* 1438 */,
/* 1439 */,
/* 1440 */,
/* 1441 */,
/* 1442 */,
/* 1443 */,
/* 1444 */,
/* 1445 */,
/* 1446 */,
/* 1447 */,
/* 1448 */,
/* 1449 */,
/* 1450 */,
/* 1451 */,
/* 1452 */,
/* 1453 */,
/* 1454 */,
/* 1455 */,
/* 1456 */,
/* 1457 */,
/* 1458 */,
/* 1459 */,
/* 1460 */,
/* 1461 */,
/* 1462 */,
/* 1463 */,
/* 1464 */,
/* 1465 */,
/* 1466 */,
/* 1467 */,
/* 1468 */,
/* 1469 */,
/* 1470 */,
/* 1471 */,
/* 1472 */,
/* 1473 */,
/* 1474 */,
/* 1475 */,
/* 1476 */,
/* 1477 */,
/* 1478 */,
/* 1479 */,
/* 1480 */,
/* 1481 */,
/* 1482 */,
/* 1483 */,
/* 1484 */,
/* 1485 */,
/* 1486 */,
/* 1487 */,
/* 1488 */,
/* 1489 */,
/* 1490 */,
/* 1491 */,
/* 1492 */,
/* 1493 */,
/* 1494 */,
/* 1495 */,
/* 1496 */,
/* 1497 */,
/* 1498 */,
/* 1499 */,
/* 1500 */,
/* 1501 */,
/* 1502 */,
/* 1503 */,
/* 1504 */,
/* 1505 */,
/* 1506 */,
/* 1507 */,
/* 1508 */,
/* 1509 */,
/* 1510 */,
/* 1511 */,
/* 1512 */,
/* 1513 */,
/* 1514 */,
/* 1515 */,
/* 1516 */,
/* 1517 */,
/* 1518 */,
/* 1519 */,
/* 1520 */,
/* 1521 */,
/* 1522 */,
/* 1523 */,
/* 1524 */,
/* 1525 */,
/* 1526 */,
/* 1527 */,
/* 1528 */,
/* 1529 */,
/* 1530 */,
/* 1531 */,
/* 1532 */,
/* 1533 */,
/* 1534 */,
/* 1535 */,
/* 1536 */,
/* 1537 */,
/* 1538 */,
/* 1539 */,
/* 1540 */,
/* 1541 */,
/* 1542 */,
/* 1543 */,
/* 1544 */,
/* 1545 */,
/* 1546 */,
/* 1547 */,
/* 1548 */,
/* 1549 */,
/* 1550 */,
/* 1551 */,
/* 1552 */,
/* 1553 */,
/* 1554 */,
/* 1555 */,
/* 1556 */,
/* 1557 */,
/* 1558 */,
/* 1559 */,
/* 1560 */,
/* 1561 */,
/* 1562 */,
/* 1563 */,
/* 1564 */,
/* 1565 */,
/* 1566 */,
/* 1567 */,
/* 1568 */,
/* 1569 */,
/* 1570 */,
/* 1571 */,
/* 1572 */,
/* 1573 */,
/* 1574 */,
/* 1575 */,
/* 1576 */,
/* 1577 */,
/* 1578 */,
/* 1579 */,
/* 1580 */,
/* 1581 */,
/* 1582 */,
/* 1583 */,
/* 1584 */,
/* 1585 */,
/* 1586 */,
/* 1587 */,
/* 1588 */,
/* 1589 */,
/* 1590 */,
/* 1591 */,
/* 1592 */,
/* 1593 */,
/* 1594 */,
/* 1595 */,
/* 1596 */,
/* 1597 */,
/* 1598 */,
/* 1599 */,
/* 1600 */,
/* 1601 */,
/* 1602 */,
/* 1603 */,
/* 1604 */,
/* 1605 */,
/* 1606 */,
/* 1607 */,
/* 1608 */,
/* 1609 */,
/* 1610 */,
/* 1611 */,
/* 1612 */,
/* 1613 */,
/* 1614 */,
/* 1615 */,
/* 1616 */,
/* 1617 */,
/* 1618 */,
/* 1619 */,
/* 1620 */,
/* 1621 */,
/* 1622 */,
/* 1623 */,
/* 1624 */,
/* 1625 */,
/* 1626 */,
/* 1627 */,
/* 1628 */,
/* 1629 */,
/* 1630 */,
/* 1631 */,
/* 1632 */,
/* 1633 */,
/* 1634 */,
/* 1635 */,
/* 1636 */,
/* 1637 */,
/* 1638 */,
/* 1639 */,
/* 1640 */,
/* 1641 */,
/* 1642 */,
/* 1643 */,
/* 1644 */,
/* 1645 */,
/* 1646 */,
/* 1647 */,
/* 1648 */,
/* 1649 */,
/* 1650 */,
/* 1651 */,
/* 1652 */,
/* 1653 */,
/* 1654 */,
/* 1655 */,
/* 1656 */,
/* 1657 */,
/* 1658 */,
/* 1659 */,
/* 1660 */,
/* 1661 */,
/* 1662 */,
/* 1663 */,
/* 1664 */,
/* 1665 */,
/* 1666 */,
/* 1667 */,
/* 1668 */,
/* 1669 */,
/* 1670 */,
/* 1671 */,
/* 1672 */,
/* 1673 */,
/* 1674 */,
/* 1675 */,
/* 1676 */,
/* 1677 */,
/* 1678 */,
/* 1679 */,
/* 1680 */,
/* 1681 */,
/* 1682 */,
/* 1683 */,
/* 1684 */,
/* 1685 */,
/* 1686 */,
/* 1687 */,
/* 1688 */,
/* 1689 */,
/* 1690 */,
/* 1691 */,
/* 1692 */,
/* 1693 */,
/* 1694 */,
/* 1695 */,
/* 1696 */,
/* 1697 */,
/* 1698 */,
/* 1699 */,
/* 1700 */,
/* 1701 */,
/* 1702 */,
/* 1703 */,
/* 1704 */,
/* 1705 */,
/* 1706 */,
/* 1707 */,
/* 1708 */,
/* 1709 */,
/* 1710 */,
/* 1711 */,
/* 1712 */,
/* 1713 */,
/* 1714 */,
/* 1715 */,
/* 1716 */,
/* 1717 */,
/* 1718 */,
/* 1719 */,
/* 1720 */,
/* 1721 */,
/* 1722 */,
/* 1723 */,
/* 1724 */,
/* 1725 */,
/* 1726 */,
/* 1727 */,
/* 1728 */,
/* 1729 */,
/* 1730 */,
/* 1731 */,
/* 1732 */,
/* 1733 */,
/* 1734 */,
/* 1735 */,
/* 1736 */,
/* 1737 */,
/* 1738 */,
/* 1739 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1740);
__webpack_require__(1741);
module.exports = __webpack_require__(1742);


/***/ }),
/* 1740 */
/***/ (function(module, exports) {

/*!
 * Braintree End-to-End Encryption Library
 * http://www.braintreepayments.com
 *
 * Licensed under the MIT or GPL Version 2 licenses.
 *
 * Includes pidCrypt
 * Copyright (c) 2009 pidder <www.pidder.com>
 * Released under the GPL License.
 *
 * Includes SJCL
 * Copyright 2009-2010 Emily Stark, Mike Hamburg, Dan Boneh, Stanford University.
 * Released under the GPL Version 2 License.
 */

Braintree=(function(){function pidCrypt(){function getRandomBytes(len){if(!len)len=8;var bytes=new Array(len);var field=[];for(var i=0;i<256;i++)field[i]=i;for(i=0;i<bytes.length;i++)
bytes[i]=field[Math.floor(Math.random()*field.length)];return bytes}
this.setDefaults=function(){this.params.nBits=256;this.params.salt=getRandomBytes(8);this.params.salt=pidCryptUtil.byteArray2String(this.params.salt);this.params.salt=pidCryptUtil.convertToHex(this.params.salt);this.params.blockSize=16;this.params.UTF8=true;this.params.A0_PAD=true;}
this.debug=true;this.params={};this.params.dataIn='';this.params.dataOut='';this.params.decryptIn='';this.params.decryptOut='';this.params.encryptIn='';this.params.encryptOut='';this.params.key='';this.params.iv='';this.params.clear=true;this.setDefaults();this.errors='';this.warnings='';this.infos='';this.debugMsg='';this.setParams=function(pObj){if(!pObj)pObj={};for(var p in pObj)
this.params[p]=pObj[p];}
this.getParams=function(){return this.params;}
this.getParam=function(p){return this.params[p]||'';}
this.clearParams=function(){this.params={};}
this.getNBits=function(){return this.params.nBits;}
this.getOutput=function(){return this.params.dataOut;}
this.setError=function(str){this.error=str;}
this.appendError=function(str){this.errors+=str;return'';}
this.getErrors=function(){return this.errors;}
this.isError=function(){if(this.errors.length>0)
return true;return false}
this.appendInfo=function(str){this.infos+=str;return'';}
this.getInfos=function()
{return this.infos;}
this.setDebug=function(flag){this.debug=flag;}
this.appendDebug=function(str)
{this.debugMsg+=str;return'';}
this.isDebug=function(){return this.debug;}
this.getAllMessages=function(options){var defaults={lf:'\n',clr_mes:false,verbose:15};if(!options)options=defaults;for(var d in defaults)
if(typeof(options[d])=='undefined')options[d]=defaults[d];var mes='';var tmp='';for(var p in this.params){switch(p){case'encryptOut':tmp=pidCryptUtil.toByteArray(this.params[p].toString());tmp=pidCryptUtil.fragment(tmp.join(),64,options.lf)
break;case'key':case'iv':tmp=pidCryptUtil.formatHex(this.params[p],48);break;default:tmp=pidCryptUtil.fragment(this.params[p].toString(),64,options.lf);}
mes+='<p><b>'+p+'</b>:<pre>'+tmp+'</pre></p>';}
if(this.debug)mes+='debug: '+this.debug+options.lf;if(this.errors.length>0&&((options.verbose&1)==1))mes+='Errors:'+options.lf+this.errors+options.lf;if(this.warnings.length>0&&((options.verbose&2)==2))mes+='Warnings:'+options.lf+this.warnings+options.lf;if(this.infos.length>0&&((options.verbose&4)==4))mes+='Infos:'+options.lf+this.infos+options.lf;if(this.debug&&((options.verbose&8)==8))mes+='Debug messages:'+options.lf+this.debugMsg+options.lf;if(options.clr_mes)
this.errors=this.infos=this.warnings=this.debug='';return mes;}
this.getRandomBytes=function(len){return getRandomBytes(len);}}
pidCryptUtil={};pidCryptUtil.encodeBase64=function(str,utf8encode){if(!str)str="";var b64="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";utf8encode=(typeof utf8encode=='undefined')?false:utf8encode;var o1,o2,o3,bits,h1,h2,h3,h4,e=[],pad='',c,plain,coded;plain=utf8encode?pidCryptUtil.encodeUTF8(str):str;c=plain.length%3;if(c>0){while(c++<3){pad+='=';plain+='\0';}}
for(c=0;c<plain.length;c+=3){o1=plain.charCodeAt(c);o2=plain.charCodeAt(c+1);o3=plain.charCodeAt(c+2);bits=o1<<16|o2<<8|o3;h1=bits>>18&0x3f;h2=bits>>12&0x3f;h3=bits>>6&0x3f;h4=bits&0x3f;e[c/3]=b64.charAt(h1)+b64.charAt(h2)+b64.charAt(h3)+b64.charAt(h4);}
coded=e.join('');coded=coded.slice(0,coded.length-pad.length)+pad;return coded;}
pidCryptUtil.decodeBase64=function(str,utf8decode){if(!str)str="";var b64="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";utf8decode=(typeof utf8decode=='undefined')?false:utf8decode;var o1,o2,o3,h1,h2,h3,h4,bits,d=[],plain,coded;coded=utf8decode?pidCryptUtil.decodeUTF8(str):str;for(var c=0;c<coded.length;c+=4){h1=b64.indexOf(coded.charAt(c));h2=b64.indexOf(coded.charAt(c+1));h3=b64.indexOf(coded.charAt(c+2));h4=b64.indexOf(coded.charAt(c+3));bits=h1<<18|h2<<12|h3<<6|h4;o1=bits>>>16&0xff;o2=bits>>>8&0xff;o3=bits&0xff;d[c/4]=String.fromCharCode(o1,o2,o3);if(h4==0x40)d[c/4]=String.fromCharCode(o1,o2);if(h3==0x40)d[c/4]=String.fromCharCode(o1);}
plain=d.join('');plain=utf8decode?pidCryptUtil.decodeUTF8(plain):plain
return plain;}
pidCryptUtil.encodeUTF8=function(str){if(!str)str="";str=str.replace(/[\u0080-\u07ff]/g,function(c){var cc=c.charCodeAt(0);return String.fromCharCode(0xc0|cc>>6,0x80|cc&0x3f);});str=str.replace(/[\u0800-\uffff]/g,function(c){var cc=c.charCodeAt(0);return String.fromCharCode(0xe0|cc>>12,0x80|cc>>6&0x3F,0x80|cc&0x3f);});return str;}
pidCryptUtil.decodeUTF8=function(str){if(!str)str="";str=str.replace(/[\u00c0-\u00df][\u0080-\u00bf]/g,function(c){var cc=(c.charCodeAt(0)&0x1f)<<6|c.charCodeAt(1)&0x3f;return String.fromCharCode(cc);});str=str.replace(/[\u00e0-\u00ef][\u0080-\u00bf][\u0080-\u00bf]/g,function(c){var cc=((c.charCodeAt(0)&0x0f)<<12)|((c.charCodeAt(1)&0x3f)<<6)|(c.charCodeAt(2)&0x3f);return String.fromCharCode(cc);});return str;}
pidCryptUtil.convertToHex=function(str){if(!str)str="";var hs='';var hv='';for(var i=0;i<str.length;i++){hv=str.charCodeAt(i).toString(16);hs+=(hv.length==1)?'0'+hv:hv;}
return hs;}
pidCryptUtil.convertFromHex=function(str){if(!str)str="";var s="";for(var i=0;i<str.length;i+=2){s+=String.fromCharCode(parseInt(str.substring(i,i+2),16));}
return s}
pidCryptUtil.stripLineFeeds=function(str){if(!str)str="";var s='';s=str.replace(/\n/g,'');s=s.replace(/\r/g,'');return s;}
pidCryptUtil.toByteArray=function(str){if(!str)str="";var ba=[];for(var i=0;i<str.length;i++)
ba[i]=str.charCodeAt(i);return ba;}
pidCryptUtil.fragment=function(str,length,lf){if(!str)str="";if(!length||length>=str.length)return str;if(!lf)lf='\n'
var tmp='';for(var i=0;i<str.length;i+=length)
tmp+=str.substr(i,length)+lf;return tmp;}
pidCryptUtil.formatHex=function(str,length){if(!str)str="";if(!length)length=45;var str_new='';var j=0;var hex=str.toLowerCase();for(var i=0;i<hex.length;i+=2)
str_new+=hex.substr(i,2)+':';hex=this.fragment(str_new,length);return hex;}
pidCryptUtil.byteArray2String=function(b){var s='';for(var i=0;i<b.length;i++){s+=String.fromCharCode(b[i]);}
return s;}
function Arcfour(){this.i=0;this.j=0;this.S=new Array();}
function ARC4init(key){var i,j,t;for(i=0;i<256;++i)
this.S[i]=i;j=0;for(i=0;i<256;++i){j=(j+this.S[i]+key[i%key.length])&255;t=this.S[i];this.S[i]=this.S[j];this.S[j]=t;}
this.i=0;this.j=0;}
function ARC4next(){var t;this.i=(this.i+1)&255;this.j=(this.j+this.S[this.i])&255;t=this.S[this.i];this.S[this.i]=this.S[this.j];this.S[this.j]=t;return this.S[(t+this.S[this.i])&255];}
Arcfour.prototype.init=ARC4init;Arcfour.prototype.next=ARC4next;function prng_newstate(){return new Arcfour();}
var rng_psize=256;function SecureRandom(){this.rng_state;this.rng_pool;this.rng_pptr;this.rng_seed_int=function(x){this.rng_pool[this.rng_pptr++]^=x&255;this.rng_pool[this.rng_pptr++]^=(x>>8)&255;this.rng_pool[this.rng_pptr++]^=(x>>16)&255;this.rng_pool[this.rng_pptr++]^=(x>>24)&255;if(this.rng_pptr>=rng_psize)this.rng_pptr-=rng_psize;}
this.rng_seed_time=function(){this.rng_seed_int(new Date().getTime());}
if(this.rng_pool==null){this.rng_pool=new Array();this.rng_pptr=0;var t;if(navigator.appName=="Netscape"&&navigator.appVersion<"5"&&window.crypto&&window.crypto.random){var z=window.crypto.random(32);for(t=0;t<z.length;++t)
this.rng_pool[this.rng_pptr++]=z.charCodeAt(t)&255;}
while(this.rng_pptr<rng_psize){t=Math.floor(65536*Math.random());this.rng_pool[this.rng_pptr++]=t>>>8;this.rng_pool[this.rng_pptr++]=t&255;}
this.rng_pptr=0;this.rng_seed_time();}
this.rng_get_byte=function(){if(this.rng_state==null){this.rng_seed_time();this.rng_state=prng_newstate();this.rng_state.init(this.rng_pool);for(this.rng_pptr=0;this.rng_pptr<this.rng_pool.length;++this.rng_pptr)
this.rng_pool[this.rng_pptr]=0;this.rng_pptr=0;}
return this.rng_state.next();}
this.nextBytes=function(ba){var i;for(i=0;i<ba.length;++i)ba[i]=this.rng_get_byte();}}
function Stream(enc,pos){if(enc instanceof Stream){this.enc=enc.enc;this.pos=enc.pos;}else{this.enc=enc;this.pos=pos;}}
Stream.prototype.parseStringHex=function(start,end){if(typeof(end)=='undefined')end=this.enc.length;var s="";for(var i=start;i<end;++i){var h=this.get(i);s+=this.hexDigits.charAt(h>>4)+this.hexDigits.charAt(h&0xF);}
return s;}
Stream.prototype.get=function(pos){if(pos==undefined)
pos=this.pos++;if(pos>=this.enc.length)
throw'Requesting byte offset '+pos+' on a stream of length '+this.enc.length;return this.enc[pos];}
Stream.prototype.hexDigits="0123456789ABCDEF";Stream.prototype.hexDump=function(start,end){var s="";for(var i=start;i<end;++i){var h=this.get(i);s+=this.hexDigits.charAt(h>>4)+this.hexDigits.charAt(h&0xF);if((i&0xF)==0x7)
s+=' ';s+=((i&0xF)==0xF)?'\n':' ';}
return s;}
Stream.prototype.parseStringISO=function(start,end){var s="";for(var i=start;i<end;++i)
s+=String.fromCharCode(this.get(i));return s;}
Stream.prototype.parseStringUTF=function(start,end){var s="",c=0;for(var i=start;i<end;){var c=this.get(i++);if(c<128)
s+=String.fromCharCode(c);else
if((c>191)&&(c<224))
s+=String.fromCharCode(((c&0x1F)<<6)|(this.get(i++)&0x3F));else
s+=String.fromCharCode(((c&0x0F)<<12)|((this.get(i++)&0x3F)<<6)|(this.get(i++)&0x3F));}
return s;}
Stream.prototype.reTime=/^((?:1[89]|2\d)?\d\d)(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])([01]\d|2[0-3])(?:([0-5]\d)(?:([0-5]\d)(?:[.,](\d{1,3}))?)?)?(Z|[-+](?:[0]\d|1[0-2])([0-5]\d)?)?$/;Stream.prototype.parseTime=function(start,end){var s=this.parseStringISO(start,end);var m=this.reTime.exec(s);if(!m)
return"Unrecognized time: "+s;s=m[1]+"-"+m[2]+"-"+m[3]+" "+m[4];if(m[5]){s+=":"+m[5];if(m[6]){s+=":"+m[6];if(m[7])
s+="."+m[7];}}
if(m[8]){s+=" UTC";if(m[8]!='Z'){s+=m[8];if(m[9])
s+=":"+m[9];}}
return s;}
Stream.prototype.parseInteger=function(start,end){if((end-start)>4)
return undefined;var n=0;for(var i=start;i<end;++i)
n=(n<<8)|this.get(i);return n;}
Stream.prototype.parseOID=function(start,end){var s,n=0,bits=0;for(var i=start;i<end;++i){var v=this.get(i);n=(n<<7)|(v&0x7F);bits+=7;if(!(v&0x80)){if(s==undefined)
s=parseInt(n/40)+"."+(n%40);else
s+="."+((bits>=31)?"big":n);n=bits=0;}
s+=String.fromCharCode();}
return s;}
if(typeof(pidCrypt)!='undefined')
{pidCrypt.ASN1=function(stream,header,length,tag,sub){this.stream=stream;this.header=header;this.length=length;this.tag=tag;this.sub=sub;}
pidCrypt.ASN1.prototype.toHexTree=function(){var node={};node.type=this.typeName();if(node.type!='SEQUENCE')
node.value=this.stream.parseStringHex(this.posContent(),this.posEnd());if(this.sub!=null){node.sub=[];for(var i=0,max=this.sub.length;i<max;++i)
node.sub[i]=this.sub[i].toHexTree();}
return node;}
pidCrypt.ASN1.prototype.typeName=function(){if(this.tag==undefined)
return"unknown";var tagClass=this.tag>>6;var tagConstructed=(this.tag>>5)&1;var tagNumber=this.tag&0x1F;switch(tagClass){case 0:switch(tagNumber){case 0x00:return"EOC";case 0x01:return"BOOLEAN";case 0x02:return"INTEGER";case 0x03:return"BIT_STRING";case 0x04:return"OCTET_STRING";case 0x05:return"NULL";case 0x06:return"OBJECT_IDENTIFIER";case 0x07:return"ObjectDescriptor";case 0x08:return"EXTERNAL";case 0x09:return"REAL";case 0x0A:return"ENUMERATED";case 0x0B:return"EMBEDDED_PDV";case 0x0C:return"UTF8String";case 0x10:return"SEQUENCE";case 0x11:return"SET";case 0x12:return"NumericString";case 0x13:return"PrintableString";case 0x14:return"TeletexString";case 0x15:return"VideotexString";case 0x16:return"IA5String";case 0x17:return"UTCTime";case 0x18:return"GeneralizedTime";case 0x19:return"GraphicString";case 0x1A:return"VisibleString";case 0x1B:return"GeneralString";case 0x1C:return"UniversalString";case 0x1E:return"BMPString";default:return"Universal_"+tagNumber.toString(16);}
case 1:return"Application_"+tagNumber.toString(16);case 2:return"["+tagNumber+"]";case 3:return"Private_"+tagNumber.toString(16);}}
pidCrypt.ASN1.prototype.content=function(){if(this.tag==undefined)
return null;var tagClass=this.tag>>6;if(tagClass!=0)
return null;var tagNumber=this.tag&0x1F;var content=this.posContent();var len=Math.abs(this.length);switch(tagNumber){case 0x01:return(this.stream.get(content)==0)?"false":"true";case 0x02:return this.stream.parseInteger(content,content+len);case 0x06:return this.stream.parseOID(content,content+len);case 0x0C:return this.stream.parseStringUTF(content,content+len);case 0x12:case 0x13:case 0x14:case 0x15:case 0x16:case 0x1A:return this.stream.parseStringISO(content,content+len);case 0x17:case 0x18:return this.stream.parseTime(content,content+len);}
return null;}
pidCrypt.ASN1.prototype.toString=function(){return this.typeName()+"@"+this.stream.pos+"[header:"+this.header+",length:"+this.length+",sub:"+((this.sub==null)?'null':this.sub.length)+"]";}
pidCrypt.ASN1.prototype.print=function(indent){if(indent==undefined)indent='';document.writeln(indent+this);if(this.sub!=null){indent+='  ';for(var i=0,max=this.sub.length;i<max;++i)
this.sub[i].print(indent);}}
pidCrypt.ASN1.prototype.toPrettyString=function(indent){if(indent==undefined)indent='';var s=indent+this.typeName()+" @"+this.stream.pos;if(this.length>=0)
s+="+";s+=this.length;if(this.tag&0x20)
s+=" (constructed)";else
if(((this.tag==0x03)||(this.tag==0x04))&&(this.sub!=null))
s+=" (encapsulates)";s+="\n";if(this.sub!=null){indent+='  ';for(var i=0,max=this.sub.length;i<max;++i)
s+=this.sub[i].toPrettyString(indent);}
return s;}
pidCrypt.ASN1.prototype.toDOM=function(){var node=document.createElement("div");node.className="node";node.asn1=this;var head=document.createElement("div");head.className="head";var s=this.typeName();head.innerHTML=s;node.appendChild(head);this.head=head;var value=document.createElement("div");value.className="value";s="Offset: "+this.stream.pos+"<br/>";s+="Length: "+this.header+"+";if(this.length>=0)
s+=this.length;else
s+=(-this.length)+" (undefined)";if(this.tag&0x20)
s+="<br/>(constructed)";else if(((this.tag==0x03)||(this.tag==0x04))&&(this.sub!=null))
s+="<br/>(encapsulates)";var content=this.content();if(content!=null){s+="<br/>Value:<br/><b>"+content+"</b>";if((typeof(oids)=='object')&&(this.tag==0x06)){var oid=oids[content];if(oid){if(oid.d)s+="<br/>"+oid.d;if(oid.c)s+="<br/>"+oid.c;if(oid.w)s+="<br/>(warning!)";}}}
value.innerHTML=s;node.appendChild(value);var sub=document.createElement("div");sub.className="sub";if(this.sub!=null){for(var i=0,max=this.sub.length;i<max;++i)
sub.appendChild(this.sub[i].toDOM());}
node.appendChild(sub);head.switchNode=node;head.onclick=function(){var node=this.switchNode;node.className=(node.className=="node collapsed")?"node":"node collapsed";};return node;}
pidCrypt.ASN1.prototype.posStart=function(){return this.stream.pos;}
pidCrypt.ASN1.prototype.posContent=function(){return this.stream.pos+this.header;}
pidCrypt.ASN1.prototype.posEnd=function(){return this.stream.pos+this.header+Math.abs(this.length);}
pidCrypt.ASN1.prototype.toHexDOM_sub=function(node,className,stream,start,end){if(start>=end)
return;var sub=document.createElement("span");sub.className=className;sub.appendChild(document.createTextNode(stream.hexDump(start,end)));node.appendChild(sub);}
pidCrypt.ASN1.prototype.toHexDOM=function(){var node=document.createElement("span");node.className='hex';this.head.hexNode=node;this.head.onmouseover=function(){this.hexNode.className='hexCurrent';}
this.head.onmouseout=function(){this.hexNode.className='hex';}
this.toHexDOM_sub(node,"tag",this.stream,this.posStart(),this.posStart()+1);this.toHexDOM_sub(node,(this.length>=0)?"dlen":"ulen",this.stream,this.posStart()+1,this.posContent());if(this.sub==null)
node.appendChild(document.createTextNode(this.stream.hexDump(this.posContent(),this.posEnd())));else if(this.sub.length>0){var first=this.sub[0];var last=this.sub[this.sub.length-1];this.toHexDOM_sub(node,"intro",this.stream,this.posContent(),first.posStart());for(var i=0,max=this.sub.length;i<max;++i)
node.appendChild(this.sub[i].toHexDOM());this.toHexDOM_sub(node,"outro",this.stream,last.posEnd(),this.posEnd());}
return node;}
pidCrypt.ASN1.decodeLength=function(stream){var buf=stream.get();var len=buf&0x7F;if(len==buf)
return len;if(len>3)
throw"Length over 24 bits not supported at position "+(stream.pos-1);if(len==0)
return-1;buf=0;for(var i=0;i<len;++i)
buf=(buf<<8)|stream.get();return buf;}
pidCrypt.ASN1.hasContent=function(tag,len,stream){if(tag&0x20)
return true;if((tag<0x03)||(tag>0x04))
return false;var p=new Stream(stream);if(tag==0x03)p.get();var subTag=p.get();if((subTag>>6)&0x01)
return false;try{var subLength=pidCrypt.ASN1.decodeLength(p);return((p.pos-stream.pos)+subLength==len);}catch(exception){return false;}}
pidCrypt.ASN1.decode=function(stream){if(!(stream instanceof Stream))
stream=new Stream(stream,0);var streamStart=new Stream(stream);var tag=stream.get();var len=pidCrypt.ASN1.decodeLength(stream);var header=stream.pos-streamStart.pos;var sub=null;if(pidCrypt.ASN1.hasContent(tag,len,stream)){var start=stream.pos;if(tag==0x03)stream.get();sub=[];if(len>=0){var end=start+len;while(stream.pos<end)
sub[sub.length]=pidCrypt.ASN1.decode(stream);if(stream.pos!=end)
throw"Content size is not correct for container starting at offset "+start;}else{try{for(;;){var s=pidCrypt.ASN1.decode(stream);if(s.tag==0)
break;sub[sub.length]=s;}
len=start-stream.pos;}catch(e){throw"Exception while decoding undefined length content: "+e;}}}else
stream.pos+=len;return new pidCrypt.ASN1(streamStart,header,len,tag,sub);}
pidCrypt.ASN1.test=function(){var test=[{value:[0x27],expected:0x27},{value:[0x81,0xC9],expected:0xC9},{value:[0x83,0xFE,0xDC,0xBA],expected:0xFEDCBA}];for(var i=0,max=test.length;i<max;++i){var pos=0;var stream=new Stream(test[i].value,0);var res=pidCrypt.ASN1.decodeLength(stream);if(res!=test[i].expected)
document.write("In test["+i+"] expected "+test[i].expected+" got "+res+"\n");}}}
var dbits;var canary=0xdeadbeefcafe;var j_lm=((canary&0xffffff)==0xefcafe);function BigInteger(a,b,c){if(a!=null)
if("number"==typeof a)this.fromNumber(a,b,c);else if(b==null&&"string"!=typeof a)this.fromString(a,256);else this.fromString(a,b);}
function nbi(){return new BigInteger(null);}
function am1(i,x,w,j,c,n){while(--n>=0){var v=x*this[i++]+w[j]+c;c=Math.floor(v/0x4000000);w[j++]=v&0x3ffffff;}
return c;}
function am2(i,x,w,j,c,n){var xl=x&0x7fff,xh=x>>15;while(--n>=0){var l=this[i]&0x7fff;var h=this[i++]>>15;var m=xh*l+h*xl;l=xl*l+((m&0x7fff)<<15)+w[j]+(c&0x3fffffff);c=(l>>>30)+(m>>>15)+xh*h+(c>>>30);w[j++]=l&0x3fffffff;}
return c;}
function am3(i,x,w,j,c,n){var xl=x&0x3fff,xh=x>>14;while(--n>=0){var l=this[i]&0x3fff;var h=this[i++]>>14;var m=xh*l+h*xl;l=xl*l+((m&0x3fff)<<14)+w[j]+c;c=(l>>28)+(m>>14)+xh*h;w[j++]=l&0xfffffff;}
return c;}
if(j_lm&&(navigator.appName=="Microsoft Internet Explorer")){BigInteger.prototype.am=am2;dbits=30;}
else if(j_lm&&(navigator.appName!="Netscape")){BigInteger.prototype.am=am1;dbits=26;}
else{BigInteger.prototype.am=am3;dbits=28;}
BigInteger.prototype.DB=dbits;BigInteger.prototype.DM=((1<<dbits)-1);BigInteger.prototype.DV=(1<<dbits);var BI_FP=52;BigInteger.prototype.FV=Math.pow(2,BI_FP);BigInteger.prototype.F1=BI_FP-dbits;BigInteger.prototype.F2=2*dbits-BI_FP;var BI_RM="0123456789abcdefghijklmnopqrstuvwxyz";var BI_RC=new Array();var rr,vv;rr="0".charCodeAt(0);for(vv=0;vv<=9;++vv)BI_RC[rr++]=vv;rr="a".charCodeAt(0);for(vv=10;vv<36;++vv)BI_RC[rr++]=vv;rr="A".charCodeAt(0);for(vv=10;vv<36;++vv)BI_RC[rr++]=vv;function int2char(n){return BI_RM.charAt(n);}
function intAt(s,i){var c=BI_RC[s.charCodeAt(i)];return(c==null)?-1:c;}
function bnpCopyTo(r){for(var i=this.t-1;i>=0;--i)r[i]=this[i];r.t=this.t;r.s=this.s;}
function bnpFromInt(x){this.t=1;this.s=(x<0)?-1:0;if(x>0)this[0]=x;else if(x<-1)this[0]=x+DV;else this.t=0;}
function nbv(i){var r=nbi();r.fromInt(i);return r;}
function bnpFromString(s,b){var k;if(b==16)k=4;else if(b==8)k=3;else if(b==256)k=8;else if(b==2)k=1;else if(b==32)k=5;else if(b==4)k=2;else{this.fromRadix(s,b);return;}
this.t=0;this.s=0;var i=s.length,mi=false,sh=0;while(--i>=0){var x=(k==8)?s[i]&0xff:intAt(s,i);if(x<0){if(s.charAt(i)=="-")mi=true;continue;}
mi=false;if(sh==0)
this[this.t++]=x;else if(sh+k>this.DB){this[this.t-1]|=(x&((1<<(this.DB-sh))-1))<<sh;this[this.t++]=(x>>(this.DB-sh));}
else
this[this.t-1]|=x<<sh;sh+=k;if(sh>=this.DB)sh-=this.DB;}
if(k==8&&(s[0]&0x80)!=0){this.s=-1;if(sh>0)this[this.t-1]|=((1<<(this.DB-sh))-1)<<sh;}
this.clamp();if(mi)BigInteger.ZERO.subTo(this,this);}
function bnpClamp(){var c=this.s&this.DM;while(this.t>0&&this[this.t-1]==c)--this.t;}
function bnToString(b){if(this.s<0)return"-"+this.negate().toString(b);var k;if(b==16)k=4;else if(b==8)k=3;else if(b==2)k=1;else if(b==32)k=5;else if(b==4)k=2;else return this.toRadix(b);var km=(1<<k)-1,d,m=false,r="",i=this.t;var p=this.DB-(i*this.DB)%k;if(i-->0){if(p<this.DB&&(d=this[i]>>p)>0){m=true;r=int2char(d);}
while(i>=0){if(p<k){d=(this[i]&((1<<p)-1))<<(k-p);d|=this[--i]>>(p+=this.DB-k);}
else{d=(this[i]>>(p-=k))&km;if(p<=0){p+=this.DB;--i;}}
if(d>0)m=true;if(m)r+=int2char(d);}}
return m?r:"0";}
function bnNegate(){var r=nbi();BigInteger.ZERO.subTo(this,r);return r;}
function bnAbs(){return(this.s<0)?this.negate():this;}
function bnCompareTo(a){var r=this.s-a.s;if(r!=0)return r;var i=this.t;r=i-a.t;if(r!=0)return r;while(--i>=0)if((r=this[i]-a[i])!=0)return r;return 0;}
function nbits(x){var r=1,t;if((t=x>>>16)!=0){x=t;r+=16;}
if((t=x>>8)!=0){x=t;r+=8;}
if((t=x>>4)!=0){x=t;r+=4;}
if((t=x>>2)!=0){x=t;r+=2;}
if((t=x>>1)!=0){x=t;r+=1;}
return r;}
function bnBitLength(){if(this.t<=0)return 0;return this.DB*(this.t-1)+nbits(this[this.t-1]^(this.s&this.DM));}
function bnpDLShiftTo(n,r){var i;for(i=this.t-1;i>=0;--i)r[i+n]=this[i];for(i=n-1;i>=0;--i)r[i]=0;r.t=this.t+n;r.s=this.s;}
function bnpDRShiftTo(n,r){for(var i=n;i<this.t;++i)r[i-n]=this[i];r.t=Math.max(this.t-n,0);r.s=this.s;}
function bnpLShiftTo(n,r){var bs=n%this.DB;var cbs=this.DB-bs;var bm=(1<<cbs)-1;var ds=Math.floor(n/this.DB),c=(this.s<<bs)&this.DM,i;for(i=this.t-1;i>=0;--i){r[i+ds+1]=(this[i]>>cbs)|c;c=(this[i]&bm)<<bs;}
for(i=ds-1;i>=0;--i)r[i]=0;r[ds]=c;r.t=this.t+ds+1;r.s=this.s;r.clamp();}
function bnpRShiftTo(n,r){r.s=this.s;var ds=Math.floor(n/this.DB);if(ds>=this.t){r.t=0;return;}
var bs=n%this.DB;var cbs=this.DB-bs;var bm=(1<<bs)-1;r[0]=this[ds]>>bs;for(var i=ds+1;i<this.t;++i){r[i-ds-1]|=(this[i]&bm)<<cbs;r[i-ds]=this[i]>>bs;}
if(bs>0)r[this.t-ds-1]|=(this.s&bm)<<cbs;r.t=this.t-ds;r.clamp();}
function bnpSubTo(a,r){var i=0,c=0,m=Math.min(a.t,this.t);while(i<m){c+=this[i]-a[i];r[i++]=c&this.DM;c>>=this.DB;}
if(a.t<this.t){c-=a.s;while(i<this.t){c+=this[i];r[i++]=c&this.DM;c>>=this.DB;}
c+=this.s;}
else{c+=this.s;while(i<a.t){c-=a[i];r[i++]=c&this.DM;c>>=this.DB;}
c-=a.s;}
r.s=(c<0)?-1:0;if(c<-1)r[i++]=this.DV+c;else if(c>0)r[i++]=c;r.t=i;r.clamp();}
function bnpMultiplyTo(a,r){var x=this.abs(),y=a.abs();var i=x.t;r.t=i+y.t;while(--i>=0)r[i]=0;for(i=0;i<y.t;++i)r[i+x.t]=x.am(0,y[i],r,i,0,x.t);r.s=0;r.clamp();if(this.s!=a.s)BigInteger.ZERO.subTo(r,r);}
function bnpSquareTo(r){var x=this.abs();var i=r.t=2*x.t;while(--i>=0)r[i]=0;for(i=0;i<x.t-1;++i){var c=x.am(i,x[i],r,2*i,0,1);if((r[i+x.t]+=x.am(i+1,2*x[i],r,2*i+1,c,x.t-i-1))>=x.DV){r[i+x.t]-=x.DV;r[i+x.t+1]=1;}}
if(r.t>0)r[r.t-1]+=x.am(i,x[i],r,2*i,0,1);r.s=0;r.clamp();}
function bnpDivRemTo(m,q,r){var pm=m.abs();if(pm.t<=0)return;var pt=this.abs();if(pt.t<pm.t){if(q!=null)q.fromInt(0);if(r!=null)this.copyTo(r);return;}
if(r==null)r=nbi();var y=nbi(),ts=this.s,ms=m.s;var nsh=this.DB-nbits(pm[pm.t-1]);if(nsh>0){pm.lShiftTo(nsh,y);pt.lShiftTo(nsh,r);}
else{pm.copyTo(y);pt.copyTo(r);}
var ys=y.t;var y0=y[ys-1];if(y0==0)return;var yt=y0*(1<<this.F1)+((ys>1)?y[ys-2]>>this.F2:0);var d1=this.FV/yt,d2=(1<<this.F1)/yt,e=1<<this.F2;var i=r.t,j=i-ys,t=(q==null)?nbi():q;y.dlShiftTo(j,t);if(r.compareTo(t)>=0){r[r.t++]=1;r.subTo(t,r);}
BigInteger.ONE.dlShiftTo(ys,t);t.subTo(y,y);while(y.t<ys)y[y.t++]=0;while(--j>=0){var qd=(r[--i]==y0)?this.DM:Math.floor(r[i]*d1+(r[i-1]+e)*d2);if((r[i]+=y.am(0,qd,r,j,0,ys))<qd){y.dlShiftTo(j,t);r.subTo(t,r);while(r[i]<--qd)r.subTo(t,r);}}
if(q!=null){r.drShiftTo(ys,q);if(ts!=ms)BigInteger.ZERO.subTo(q,q);}
r.t=ys;r.clamp();if(nsh>0)r.rShiftTo(nsh,r);if(ts<0)BigInteger.ZERO.subTo(r,r);}
function bnMod(a){var r=nbi();this.abs().divRemTo(a,null,r);if(this.s<0&&r.compareTo(BigInteger.ZERO)>0)a.subTo(r,r);return r;}
function Classic(m){this.m=m;}
function cConvert(x){if(x.s<0||x.compareTo(this.m)>=0)return x.mod(this.m);else return x;}
function cRevert(x){return x;}
function cReduce(x){x.divRemTo(this.m,null,x);}
function cMulTo(x,y,r){x.multiplyTo(y,r);this.reduce(r);}
function cSqrTo(x,r){x.squareTo(r);this.reduce(r);}
Classic.prototype.convert=cConvert;Classic.prototype.revert=cRevert;Classic.prototype.reduce=cReduce;Classic.prototype.mulTo=cMulTo;Classic.prototype.sqrTo=cSqrTo;function bnpInvDigit(){if(this.t<1)return 0;var x=this[0];if((x&1)==0)return 0;var y=x&3;y=(y*(2-(x&0xf)*y))&0xf;y=(y*(2-(x&0xff)*y))&0xff;y=(y*(2-(((x&0xffff)*y)&0xffff)))&0xffff;y=(y*(2-x*y%this.DV))%this.DV;return(y>0)?this.DV-y:-y;}
function Montgomery(m){this.m=m;this.mp=m.invDigit();this.mpl=this.mp&0x7fff;this.mph=this.mp>>15;this.um=(1<<(m.DB-15))-1;this.mt2=2*m.t;}
function montConvert(x){var r=nbi();x.abs().dlShiftTo(this.m.t,r);r.divRemTo(this.m,null,r);if(x.s<0&&r.compareTo(BigInteger.ZERO)>0)this.m.subTo(r,r);return r;}
function montRevert(x){var r=nbi();x.copyTo(r);this.reduce(r);return r;}
function montReduce(x){while(x.t<=this.mt2)
x[x.t++]=0;for(var i=0;i<this.m.t;++i){var j=x[i]&0x7fff;var u0=(j*this.mpl+(((j*this.mph+(x[i]>>15)*this.mpl)&this.um)<<15))&x.DM;j=i+this.m.t;x[j]+=this.m.am(0,u0,x,i,0,this.m.t);while(x[j]>=x.DV){x[j]-=x.DV;x[++j]++;}}
x.clamp();x.drShiftTo(this.m.t,x);if(x.compareTo(this.m)>=0)x.subTo(this.m,x);}
function montSqrTo(x,r){x.squareTo(r);this.reduce(r);}
function montMulTo(x,y,r){x.multiplyTo(y,r);this.reduce(r);}
Montgomery.prototype.convert=montConvert;Montgomery.prototype.revert=montRevert;Montgomery.prototype.reduce=montReduce;Montgomery.prototype.mulTo=montMulTo;Montgomery.prototype.sqrTo=montSqrTo;function bnpIsEven(){return((this.t>0)?(this[0]&1):this.s)==0;}
function bnpExp(e,z){if(e>0xffffffff||e<1)return BigInteger.ONE;var r=nbi(),r2=nbi(),g=z.convert(this),i=nbits(e)-1;g.copyTo(r);while(--i>=0){z.sqrTo(r,r2);if((e&(1<<i))>0)z.mulTo(r2,g,r);else{var t=r;r=r2;r2=t;}}
return z.revert(r);}
function bnModPowInt(e,m){var z;if(e<256||m.isEven())z=new Classic(m);else z=new Montgomery(m);return this.exp(e,z);}
BigInteger.prototype.copyTo=bnpCopyTo;BigInteger.prototype.fromInt=bnpFromInt;BigInteger.prototype.fromString=bnpFromString;BigInteger.prototype.clamp=bnpClamp;BigInteger.prototype.dlShiftTo=bnpDLShiftTo;BigInteger.prototype.drShiftTo=bnpDRShiftTo;BigInteger.prototype.lShiftTo=bnpLShiftTo;BigInteger.prototype.rShiftTo=bnpRShiftTo;BigInteger.prototype.subTo=bnpSubTo;BigInteger.prototype.multiplyTo=bnpMultiplyTo;BigInteger.prototype.squareTo=bnpSquareTo;BigInteger.prototype.divRemTo=bnpDivRemTo;BigInteger.prototype.invDigit=bnpInvDigit;BigInteger.prototype.isEven=bnpIsEven;BigInteger.prototype.exp=bnpExp;BigInteger.prototype.toString=bnToString;BigInteger.prototype.negate=bnNegate;BigInteger.prototype.abs=bnAbs;BigInteger.prototype.compareTo=bnCompareTo;BigInteger.prototype.bitLength=bnBitLength;BigInteger.prototype.mod=bnMod;BigInteger.prototype.modPowInt=bnModPowInt;BigInteger.ZERO=nbv(0);BigInteger.ONE=nbv(1);function bnClone(){var r=nbi();this.copyTo(r);return r;}
function bnIntValue(){if(this.s<0){if(this.t==1)return this[0]-this.DV;else if(this.t==0)return-1;}
else if(this.t==1)return this[0];else if(this.t==0)return 0;return((this[1]&((1<<(32-this.DB))-1))<<this.DB)|this[0];}
function bnByteValue(){return(this.t==0)?this.s:(this[0]<<24)>>24;}
function bnShortValue(){return(this.t==0)?this.s:(this[0]<<16)>>16;}
function bnpChunkSize(r){return Math.floor(Math.LN2*this.DB/Math.log(r));}
function bnSigNum(){if(this.s<0)return-1;else if(this.t<=0||(this.t==1&&this[0]<=0))return 0;else return 1;}
function bnpToRadix(b){if(b==null)b=10;if(this.signum()==0||b<2||b>36)return"0";var cs=this.chunkSize(b);var a=Math.pow(b,cs);var d=nbv(a),y=nbi(),z=nbi(),r="";this.divRemTo(d,y,z);while(y.signum()>0){r=(a+z.intValue()).toString(b).substr(1)+r;y.divRemTo(d,y,z);}
return z.intValue().toString(b)+r;}
function bnpFromRadix(s,b){this.fromInt(0);if(b==null)b=10;var cs=this.chunkSize(b);var d=Math.pow(b,cs),mi=false,j=0,w=0;for(var i=0;i<s.length;++i){var x=intAt(s,i);if(x<0){if(s.charAt(i)=="-"&&this.signum()==0)mi=true;continue;}
w=b*w+x;if(++j>=cs){this.dMultiply(d);this.dAddOffset(w,0);j=0;w=0;}}
if(j>0){this.dMultiply(Math.pow(b,j));this.dAddOffset(w,0);}
if(mi)BigInteger.ZERO.subTo(this,this);}
function bnpFromNumber(a,b,c){if("number"==typeof b){if(a<2)this.fromInt(1);else{this.fromNumber(a,c);if(!this.testBit(a-1))
this.bitwiseTo(BigInteger.ONE.shiftLeft(a-1),op_or,this);if(this.isEven())this.dAddOffset(1,0);while(!this.isProbablePrime(b)){this.dAddOffset(2,0);if(this.bitLength()>a)this.subTo(BigInteger.ONE.shiftLeft(a-1),this);}}}
else{var x=new Array(),t=a&7;x.length=(a>>3)+1;b.nextBytes(x);if(t>0)x[0]&=((1<<t)-1);else x[0]=0;this.fromString(x,256);}}
function bnToByteArray(){var i=this.t,r=new Array();r[0]=this.s;var p=this.DB-(i*this.DB)%8,d,k=0;if(i-->0){if(p<this.DB&&(d=this[i]>>p)!=(this.s&this.DM)>>p)
r[k++]=d|(this.s<<(this.DB-p));while(i>=0){if(p<8){d=(this[i]&((1<<p)-1))<<(8-p);d|=this[--i]>>(p+=this.DB-8);}
else{d=(this[i]>>(p-=8))&0xff;if(p<=0){p+=this.DB;--i;}}
if((d&0x80)!=0)d|=-256;if(k==0&&(this.s&0x80)!=(d&0x80))++k;if(k>0||d!=this.s)r[k++]=d;}}
return r;}
function bnEquals(a){return(this.compareTo(a)==0);}
function bnMin(a){return(this.compareTo(a)<0)?this:a;}
function bnMax(a){return(this.compareTo(a)>0)?this:a;}
function bnpBitwiseTo(a,op,r){var i,f,m=Math.min(a.t,this.t);for(i=0;i<m;++i)r[i]=op(this[i],a[i]);if(a.t<this.t){f=a.s&this.DM;for(i=m;i<this.t;++i)r[i]=op(this[i],f);r.t=this.t;}
else{f=this.s&this.DM;for(i=m;i<a.t;++i)r[i]=op(f,a[i]);r.t=a.t;}
r.s=op(this.s,a.s);r.clamp();}
function op_and(x,y){return x&y;}
function bnAnd(a){var r=nbi();this.bitwiseTo(a,op_and,r);return r;}
function op_or(x,y){return x|y;}
function bnOr(a){var r=nbi();this.bitwiseTo(a,op_or,r);return r;}
function op_xor(x,y){return x^y;}
function bnXor(a){var r=nbi();this.bitwiseTo(a,op_xor,r);return r;}
function op_andnot(x,y){return x&~y;}
function bnAndNot(a){var r=nbi();this.bitwiseTo(a,op_andnot,r);return r;}
function bnNot(){var r=nbi();for(var i=0;i<this.t;++i)r[i]=this.DM&~this[i];r.t=this.t;r.s=~this.s;return r;}
function bnShiftLeft(n){var r=nbi();if(n<0)this.rShiftTo(-n,r);else this.lShiftTo(n,r);return r;}
function bnShiftRight(n){var r=nbi();if(n<0)this.lShiftTo(-n,r);else this.rShiftTo(n,r);return r;}
function lbit(x){if(x==0)return-1;var r=0;if((x&0xffff)==0){x>>=16;r+=16;}
if((x&0xff)==0){x>>=8;r+=8;}
if((x&0xf)==0){x>>=4;r+=4;}
if((x&3)==0){x>>=2;r+=2;}
if((x&1)==0)++r;return r;}
function bnGetLowestSetBit(){for(var i=0;i<this.t;++i)
if(this[i]!=0)return i*this.DB+lbit(this[i]);if(this.s<0)return this.t*this.DB;return-1;}
function cbit(x){var r=0;while(x!=0){x&=x-1;++r;}
return r;}
function bnBitCount(){var r=0,x=this.s&this.DM;for(var i=0;i<this.t;++i)r+=cbit(this[i]^x);return r;}
function bnTestBit(n){var j=Math.floor(n/this.DB);if(j>=this.t)return(this.s!=0);return((this[j]&(1<<(n%this.DB)))!=0);}
function bnpChangeBit(n,op){var r=BigInteger.ONE.shiftLeft(n);this.bitwiseTo(r,op,r);return r;}
function bnSetBit(n){return this.changeBit(n,op_or);}
function bnClearBit(n){return this.changeBit(n,op_andnot);}
function bnFlipBit(n){return this.changeBit(n,op_xor);}
function bnpAddTo(a,r){var i=0,c=0,m=Math.min(a.t,this.t);while(i<m){c+=this[i]+a[i];r[i++]=c&this.DM;c>>=this.DB;}
if(a.t<this.t){c+=a.s;while(i<this.t){c+=this[i];r[i++]=c&this.DM;c>>=this.DB;}
c+=this.s;}
else{c+=this.s;while(i<a.t){c+=a[i];r[i++]=c&this.DM;c>>=this.DB;}
c+=a.s;}
r.s=(c<0)?-1:0;if(c>0)r[i++]=c;else if(c<-1)r[i++]=this.DV+c;r.t=i;r.clamp();}
function bnAdd(a){var r=nbi();this.addTo(a,r);return r;}
function bnSubtract(a){var r=nbi();this.subTo(a,r);return r;}
function bnMultiply(a){var r=nbi();this.multiplyTo(a,r);return r;}
function bnDivide(a){var r=nbi();this.divRemTo(a,r,null);return r;}
function bnRemainder(a){var r=nbi();this.divRemTo(a,null,r);return r;}
function bnDivideAndRemainder(a){var q=nbi(),r=nbi();this.divRemTo(a,q,r);return new Array(q,r);}
function bnpDMultiply(n){this[this.t]=this.am(0,n-1,this,0,0,this.t);++this.t;this.clamp();}
function bnpDAddOffset(n,w){while(this.t<=w)this[this.t++]=0;this[w]+=n;while(this[w]>=this.DV){this[w]-=this.DV;if(++w>=this.t)this[this.t++]=0;++this[w];}}
function NullExp(){}
function nNop(x){return x;}
function nMulTo(x,y,r){x.multiplyTo(y,r);}
function nSqrTo(x,r){x.squareTo(r);}
NullExp.prototype.convert=nNop;NullExp.prototype.revert=nNop;NullExp.prototype.mulTo=nMulTo;NullExp.prototype.sqrTo=nSqrTo;function bnPow(e){return this.exp(e,new NullExp());}
function bnpMultiplyLowerTo(a,n,r){var i=Math.min(this.t+a.t,n);r.s=0;r.t=i;while(i>0)r[--i]=0;var j;for(j=r.t-this.t;i<j;++i)r[i+this.t]=this.am(0,a[i],r,i,0,this.t);for(j=Math.min(a.t,n);i<j;++i)this.am(0,a[i],r,i,0,n-i);r.clamp();}
function bnpMultiplyUpperTo(a,n,r){--n;var i=r.t=this.t+a.t-n;r.s=0;while(--i>=0)r[i]=0;for(i=Math.max(n-this.t,0);i<a.t;++i)
r[this.t+i-n]=this.am(n-i,a[i],r,0,0,this.t+i-n);r.clamp();r.drShiftTo(1,r);}
function Barrett(m){this.r2=nbi();this.q3=nbi();BigInteger.ONE.dlShiftTo(2*m.t,this.r2);this.mu=this.r2.divide(m);this.m=m;}
function barrettConvert(x){if(x.s<0||x.t>2*this.m.t)return x.mod(this.m);else if(x.compareTo(this.m)<0)return x;else{var r=nbi();x.copyTo(r);this.reduce(r);return r;}}
function barrettRevert(x){return x;}
function barrettReduce(x){x.drShiftTo(this.m.t-1,this.r2);if(x.t>this.m.t+1){x.t=this.m.t+1;x.clamp();}
this.mu.multiplyUpperTo(this.r2,this.m.t+1,this.q3);this.m.multiplyLowerTo(this.q3,this.m.t+1,this.r2);while(x.compareTo(this.r2)<0)x.dAddOffset(1,this.m.t+1);x.subTo(this.r2,x);while(x.compareTo(this.m)>=0)x.subTo(this.m,x);}
function barrettSqrTo(x,r){x.squareTo(r);this.reduce(r);}
function barrettMulTo(x,y,r){x.multiplyTo(y,r);this.reduce(r);}
Barrett.prototype.convert=barrettConvert;Barrett.prototype.revert=barrettRevert;Barrett.prototype.reduce=barrettReduce;Barrett.prototype.mulTo=barrettMulTo;Barrett.prototype.sqrTo=barrettSqrTo;function bnModPow(e,m){var i=e.bitLength(),k,r=nbv(1),z;if(i<=0)return r;else if(i<18)k=1;else if(i<48)k=3;else if(i<144)k=4;else if(i<768)k=5;else k=6;if(i<8)
z=new Classic(m);else if(m.isEven())
z=new Barrett(m);else
z=new Montgomery(m);var g=new Array(),n=3,k1=k-1,km=(1<<k)-1;g[1]=z.convert(this);if(k>1){var g2=nbi();z.sqrTo(g[1],g2);while(n<=km){g[n]=nbi();z.mulTo(g2,g[n-2],g[n]);n+=2;}}
var j=e.t-1,w,is1=true,r2=nbi(),t;i=nbits(e[j])-1;while(j>=0){if(i>=k1)w=(e[j]>>(i-k1))&km;else{w=(e[j]&((1<<(i+1))-1))<<(k1-i);if(j>0)w|=e[j-1]>>(this.DB+i-k1);}
n=k;while((w&1)==0){w>>=1;--n;}
if((i-=n)<0){i+=this.DB;--j;}
if(is1){g[w].copyTo(r);is1=false;}
else{while(n>1){z.sqrTo(r,r2);z.sqrTo(r2,r);n-=2;}
if(n>0)z.sqrTo(r,r2);else{t=r;r=r2;r2=t;}
z.mulTo(r2,g[w],r);}
while(j>=0&&(e[j]&(1<<i))==0){z.sqrTo(r,r2);t=r;r=r2;r2=t;if(--i<0){i=this.DB-1;--j;}}}
return z.revert(r);}
function bnGCD(a){var x=(this.s<0)?this.negate():this.clone();var y=(a.s<0)?a.negate():a.clone();if(x.compareTo(y)<0){var t=x;x=y;y=t;}
var i=x.getLowestSetBit(),g=y.getLowestSetBit();if(g<0)return x;if(i<g)g=i;if(g>0){x.rShiftTo(g,x);y.rShiftTo(g,y);}
while(x.signum()>0){if((i=x.getLowestSetBit())>0)x.rShiftTo(i,x);if((i=y.getLowestSetBit())>0)y.rShiftTo(i,y);if(x.compareTo(y)>=0){x.subTo(y,x);x.rShiftTo(1,x);}
else{y.subTo(x,y);y.rShiftTo(1,y);}}
if(g>0)y.lShiftTo(g,y);return y;}
function bnpModInt(n){if(n<=0)return 0;var d=this.DV%n,r=(this.s<0)?n-1:0;if(this.t>0)
if(d==0)r=this[0]%n;else for(var i=this.t-1;i>=0;--i)r=(d*r+this[i])%n;return r;}
function bnModInverse(m){var ac=m.isEven();if((this.isEven()&&ac)||m.signum()==0)return BigInteger.ZERO;var u=m.clone(),v=this.clone();var a=nbv(1),b=nbv(0),c=nbv(0),d=nbv(1);while(u.signum()!=0){while(u.isEven()){u.rShiftTo(1,u);if(ac){if(!a.isEven()||!b.isEven()){a.addTo(this,a);b.subTo(m,b);}
a.rShiftTo(1,a);}
else if(!b.isEven())b.subTo(m,b);b.rShiftTo(1,b);}
while(v.isEven()){v.rShiftTo(1,v);if(ac){if(!c.isEven()||!d.isEven()){c.addTo(this,c);d.subTo(m,d);}
c.rShiftTo(1,c);}
else if(!d.isEven())d.subTo(m,d);d.rShiftTo(1,d);}
if(u.compareTo(v)>=0){u.subTo(v,u);if(ac)a.subTo(c,a);b.subTo(d,b);}
else{v.subTo(u,v);if(ac)c.subTo(a,c);d.subTo(b,d);}}
if(v.compareTo(BigInteger.ONE)!=0)return BigInteger.ZERO;if(d.compareTo(m)>=0)return d.subtract(m);if(d.signum()<0)d.addTo(m,d);else return d;if(d.signum()<0)return d.add(m);else return d;}
var lowprimes=[2,3,5,7,11,13,17,19,23,29,31,37,41,43,47,53,59,61,67,71,73,79,83,89,97,101,103,107,109,113,127,131,137,139,149,151,157,163,167,173,179,181,191,193,197,199,211,223,227,229,233,239,241,251,257,263,269,271,277,281,283,293,307,311,313,317,331,337,347,349,353,359,367,373,379,383,389,397,401,409,419,421,431,433,439,443,449,457,461,463,467,479,487,491,499,503,509];var lplim=(1<<26)/lowprimes[lowprimes.length-1];function bnIsProbablePrime(t){var i,x=this.abs();if(x.t==1&&x[0]<=lowprimes[lowprimes.length-1]){for(i=0;i<lowprimes.length;++i)
if(x[0]==lowprimes[i])return true;return false;}
if(x.isEven())return false;i=1;while(i<lowprimes.length){var m=lowprimes[i],j=i+1;while(j<lowprimes.length&&m<lplim)m*=lowprimes[j++];m=x.modInt(m);while(i<j)if(m%lowprimes[i++]==0)return false;}
return x.millerRabin(t);}
function bnpMillerRabin(t){var n1=this.subtract(BigInteger.ONE);var k=n1.getLowestSetBit();if(k<=0)return false;var r=n1.shiftRight(k);t=(t+1)>>1;if(t>lowprimes.length)t=lowprimes.length;var a=nbi();for(var i=0;i<t;++i){a.fromInt(lowprimes[i]);var y=a.modPow(r,this);if(y.compareTo(BigInteger.ONE)!=0&&y.compareTo(n1)!=0){var j=1;while(j++<k&&y.compareTo(n1)!=0){y=y.modPowInt(2,this);if(y.compareTo(BigInteger.ONE)==0)return false;}
if(y.compareTo(n1)!=0)return false;}}
return true;}
BigInteger.prototype.chunkSize=bnpChunkSize;BigInteger.prototype.toRadix=bnpToRadix;BigInteger.prototype.fromRadix=bnpFromRadix;BigInteger.prototype.fromNumber=bnpFromNumber;BigInteger.prototype.bitwiseTo=bnpBitwiseTo;BigInteger.prototype.changeBit=bnpChangeBit;BigInteger.prototype.addTo=bnpAddTo;BigInteger.prototype.dMultiply=bnpDMultiply;BigInteger.prototype.dAddOffset=bnpDAddOffset;BigInteger.prototype.multiplyLowerTo=bnpMultiplyLowerTo;BigInteger.prototype.multiplyUpperTo=bnpMultiplyUpperTo;BigInteger.prototype.modInt=bnpModInt;BigInteger.prototype.millerRabin=bnpMillerRabin;BigInteger.prototype.clone=bnClone;BigInteger.prototype.intValue=bnIntValue;BigInteger.prototype.byteValue=bnByteValue;BigInteger.prototype.shortValue=bnShortValue;BigInteger.prototype.signum=bnSigNum;BigInteger.prototype.toByteArray=bnToByteArray;BigInteger.prototype.equals=bnEquals;BigInteger.prototype.min=bnMin;BigInteger.prototype.max=bnMax;BigInteger.prototype.and=bnAnd;BigInteger.prototype.or=bnOr;BigInteger.prototype.xor=bnXor;BigInteger.prototype.andNot=bnAndNot;BigInteger.prototype.not=bnNot;BigInteger.prototype.shiftLeft=bnShiftLeft;BigInteger.prototype.shiftRight=bnShiftRight;BigInteger.prototype.getLowestSetBit=bnGetLowestSetBit;BigInteger.prototype.bitCount=bnBitCount;BigInteger.prototype.testBit=bnTestBit;BigInteger.prototype.setBit=bnSetBit;BigInteger.prototype.clearBit=bnClearBit;BigInteger.prototype.flipBit=bnFlipBit;BigInteger.prototype.add=bnAdd;BigInteger.prototype.subtract=bnSubtract;BigInteger.prototype.multiply=bnMultiply;BigInteger.prototype.divide=bnDivide;BigInteger.prototype.remainder=bnRemainder;BigInteger.prototype.divideAndRemainder=bnDivideAndRemainder;BigInteger.prototype.modPow=bnModPow;BigInteger.prototype.modInverse=bnModInverse;BigInteger.prototype.pow=bnPow;BigInteger.prototype.gcd=bnGCD;BigInteger.prototype.isProbablePrime=bnIsProbablePrime;if(typeof(pidCrypt)!='undefined'&&typeof(BigInteger)!='undefined'&&typeof(SecureRandom)!='undefined'&&typeof(Arcfour)!='undefined')
{function parseBigInt(str,r){return new BigInteger(str,r);}
function linebrk(s,n){var ret="";var i=0;while(i+n<s.length){ret+=s.substring(i,i+n)+"\n";i+=n;}
return ret+s.substring(i,s.length);}
function byte2Hex(b){if(b<0x10)
return"0"+b.toString(16);else
return b.toString(16);}
function pkcs1unpad2(d,n){var b=d.toByteArray();var i=0;while(i<b.length&&b[i]==0)++i;if(b.length-i!=n-1||b[i]!=2)
return null;++i;while(b[i]!=0)
if(++i>=b.length)return null;var ret="";while(++i<b.length)
ret+=String.fromCharCode(b[i]);return ret;}
function pkcs1pad2(s,n){if(n<s.length+11){alert("Message too long for RSA");return null;}
var ba=new Array();var i=s.length-1;while(i>=0&&n>0){ba[--n]=s.charCodeAt(i--);};ba[--n]=0;var rng=new SecureRandom();var x=new Array();while(n>2){x[0]=0;while(x[0]==0)rng.nextBytes(x);ba[--n]=x[0];}
ba[--n]=2;ba[--n]=0;return new BigInteger(ba);}
pidCrypt.RSA=function(){this.n=null;this.e=0;this.d=null;this.p=null;this.q=null;this.dmp1=null;this.dmq1=null;this.coeff=null;}
pidCrypt.RSA.prototype.doPrivate=function(x){if(this.p==null||this.q==null)
return x.modPow(this.d,this.n);var xp=x.mod(this.p).modPow(this.dmp1,this.p);var xq=x.mod(this.q).modPow(this.dmq1,this.q);while(xp.compareTo(xq)<0)
xp=xp.add(this.p);return xp.subtract(xq).multiply(this.coeff).mod(this.p).multiply(this.q).add(xq);}
pidCrypt.RSA.prototype.setPublic=function(N,E,radix){if(typeof(radix)=='undefined')radix=16;if(N!=null&&E!=null&&N.length>0&&E.length>0){this.n=parseBigInt(N,radix);this.e=parseInt(E,radix);}
else
alert("Invalid RSA public key");}
pidCrypt.RSA.prototype.doPublic=function(x){return x.modPowInt(this.e,this.n);}
pidCrypt.RSA.prototype.encryptRaw=function(text){var m=pkcs1pad2(text,(this.n.bitLength()+7)>>3);if(m==null)return null;var c=this.doPublic(m);if(c==null)return null;var h=c.toString(16);if((h.length&1)==0)return h;else return"0"+h;}
pidCrypt.RSA.prototype.encrypt=function(text){text=pidCryptUtil.encodeBase64(text);return this.encryptRaw(text)}
pidCrypt.RSA.prototype.decryptRaw=function(ctext){var c=parseBigInt(ctext,16);var m=this.doPrivate(c);if(m==null)return null;return pkcs1unpad2(m,(this.n.bitLength()+7)>>3)}
pidCrypt.RSA.prototype.decrypt=function(ctext){var str=this.decryptRaw(ctext)
str=(str)?pidCryptUtil.decodeBase64(str):"";return str;}
pidCrypt.RSA.prototype.setPrivate=function(N,E,D,radix){if(typeof(radix)=='undefined')radix=16;if(N!=null&&E!=null&&N.length>0&&E.length>0){this.n=parseBigInt(N,radix);this.e=parseInt(E,radix);this.d=parseBigInt(D,radix);}
else
alert("Invalid RSA private key");}
pidCrypt.RSA.prototype.setPrivateEx=function(N,E,D,P,Q,DP,DQ,C,radix){if(typeof(radix)=='undefined')radix=16;if(N!=null&&E!=null&&N.length>0&&E.length>0){this.n=parseBigInt(N,radix);this.e=parseInt(E,radix);this.d=parseBigInt(D,radix);this.p=parseBigInt(P,radix);this.q=parseBigInt(Q,radix);this.dmp1=parseBigInt(DP,radix);this.dmq1=parseBigInt(DQ,radix);this.coeff=parseBigInt(C,radix);}
else
alert("Invalid RSA private key");}
pidCrypt.RSA.prototype.generate=function(B,E){var rng=new SecureRandom();var qs=B>>1;this.e=parseInt(E,16);var ee=new BigInteger(E,16);for(;;){for(;;){this.p=new BigInteger(B-qs,1,rng);if(this.p.subtract(BigInteger.ONE).gcd(ee).compareTo(BigInteger.ONE)==0&&this.p.isProbablePrime(10))break;}
for(;;){this.q=new BigInteger(qs,1,rng);if(this.q.subtract(BigInteger.ONE).gcd(ee).compareTo(BigInteger.ONE)==0&&this.q.isProbablePrime(10))break;}
if(this.p.compareTo(this.q)<=0){var t=this.p;this.p=this.q;this.q=t;}
var p1=this.p.subtract(BigInteger.ONE);var q1=this.q.subtract(BigInteger.ONE);var phi=p1.multiply(q1);if(phi.gcd(ee).compareTo(BigInteger.ONE)==0){this.n=this.p.multiply(this.q);this.d=ee.modInverse(phi);this.dmp1=this.d.mod(p1);this.dmq1=this.d.mod(q1);this.coeff=this.q.modInverse(this.p);break;}}}
pidCrypt.RSA.prototype.getASNData=function(tree){var params={};var data=[];var p=0;if(tree.value&&tree.type=='INTEGER')
data[p++]=tree.value;if(tree.sub)
for(var i=0;i<tree.sub.length;i++)
data=data.concat(this.getASNData(tree.sub[i]));return data;}
pidCrypt.RSA.prototype.setKeyFromASN=function(key,asntree){var keys=['N','E','D','P','Q','DP','DQ','C'];var params={};var asnData=this.getASNData(asntree);switch(key){case'Public':case'public':for(var i=0;i<asnData.length;i++)
params[keys[i]]=asnData[i].toLowerCase();this.setPublic(params.N,params.E,16);break;case'Private':case'private':for(var i=1;i<asnData.length;i++)
params[keys[i-1]]=asnData[i].toLowerCase();this.setPrivateEx(params.N,params.E,params.D,params.P,params.Q,params.DP,params.DQ,params.C,16);break;}}
pidCrypt.RSA.prototype.setPublicKeyFromASN=function(asntree){this.setKeyFromASN('public',asntree);}
pidCrypt.RSA.prototype.setPrivateKeyFromASN=function(asntree){this.setKeyFromASN('private',asntree);}
pidCrypt.RSA.prototype.getParameters=function(){var params={}
if(this.n!=null)params.n=this.n;params.e=this.e;if(this.d!=null)params.d=this.d;if(this.p!=null)params.p=this.p;if(this.q!=null)params.q=this.q;if(this.dmp1!=null)params.dmp1=this.dmp1;if(this.dmq1!=null)params.dmq1=this.dmq1;if(this.coeff!=null)params.c=this.coeff;return params;}}"use strict";var sjcl={cipher:{},hash:{},keyexchange:{},mode:{},misc:{},codec:{},exception:{corrupt:function(message){this.toString=function(){return"CORRUPT: "+this.message;};this.message=message;},invalid:function(message){this.toString=function(){return"INVALID: "+this.message;};this.message=message;},bug:function(message){this.toString=function(){return"BUG: "+this.message;};this.message=message;},notReady:function(message){this.toString=function(){return"NOT READY: "+this.message;};this.message=message;}}};sjcl.cipher.aes=function(key){if(!this._tables[0][0][0]){this._precompute();}
var i,j,tmp,encKey,decKey,sbox=this._tables[0][4],decTable=this._tables[1],keyLen=key.length,rcon=1;if(keyLen!==4&&keyLen!==6&&keyLen!==8){throw new sjcl.exception.invalid("invalid aes key size");}
this._key=[encKey=key.slice(0),decKey=[]];for(i=keyLen;i<4*keyLen+28;i++){tmp=encKey[i-1];if(i%keyLen===0||(keyLen===8&&i%keyLen===4)){tmp=sbox[tmp>>>24]<<24^sbox[tmp>>16&255]<<16^sbox[tmp>>8&255]<<8^sbox[tmp&255];if(i%keyLen===0){tmp=tmp<<8^tmp>>>24^rcon<<24;rcon=rcon<<1^(rcon>>7)*283;}}
encKey[i]=encKey[i-keyLen]^tmp;}
for(j=0;i;j++,i--){tmp=encKey[j&3?i:i-4];if(i<=4||j<4){decKey[j]=tmp;}else{decKey[j]=decTable[0][sbox[tmp>>>24]]^decTable[1][sbox[tmp>>16&255]]^decTable[2][sbox[tmp>>8&255]]^decTable[3][sbox[tmp&255]];}}};sjcl.cipher.aes.prototype={encrypt:function(data){return this._crypt(data,0);},decrypt:function(data){return this._crypt(data,1);},_tables:[[[],[],[],[],[]],[[],[],[],[],[]]],_precompute:function(){var encTable=this._tables[0],decTable=this._tables[1],sbox=encTable[4],sboxInv=decTable[4],i,x,xInv,d=[],th=[],x2,x4,x8,s,tEnc,tDec;for(i=0;i<256;i++){th[(d[i]=i<<1^(i>>7)*283)^i]=i;}
for(x=xInv=0;!sbox[x];x^=x2||1,xInv=th[xInv]||1){s=xInv^xInv<<1^xInv<<2^xInv<<3^xInv<<4;s=s>>8^s&255^99;sbox[x]=s;sboxInv[s]=x;x8=d[x4=d[x2=d[x]]];tDec=x8*0x1010101^x4*0x10001^x2*0x101^x*0x1010100;tEnc=d[s]*0x101^s*0x1010100;for(i=0;i<4;i++){encTable[i][x]=tEnc=tEnc<<24^tEnc>>>8;decTable[i][s]=tDec=tDec<<24^tDec>>>8;}}
for(i=0;i<5;i++){encTable[i]=encTable[i].slice(0);decTable[i]=decTable[i].slice(0);}},_crypt:function(input,dir){if(input.length!==4){throw new sjcl.exception.invalid("invalid aes block size");}
var key=this._key[dir],a=input[0]^key[0],b=input[dir?3:1]^key[1],c=input[2]^key[2],d=input[dir?1:3]^key[3],a2,b2,c2,nInnerRounds=key.length/4-2,i,kIndex=4,out=[0,0,0,0],table=this._tables[dir],t0=table[0],t1=table[1],t2=table[2],t3=table[3],sbox=table[4];for(i=0;i<nInnerRounds;i++){a2=t0[a>>>24]^t1[b>>16&255]^t2[c>>8&255]^t3[d&255]^key[kIndex];b2=t0[b>>>24]^t1[c>>16&255]^t2[d>>8&255]^t3[a&255]^key[kIndex+1];c2=t0[c>>>24]^t1[d>>16&255]^t2[a>>8&255]^t3[b&255]^key[kIndex+2];d=t0[d>>>24]^t1[a>>16&255]^t2[b>>8&255]^t3[c&255]^key[kIndex+3];kIndex+=4;a=a2;b=b2;c=c2;}
for(i=0;i<4;i++){out[dir?3&-i:i]=sbox[a>>>24]<<24^sbox[b>>16&255]<<16^sbox[c>>8&255]<<8^sbox[d&255]^key[kIndex++];a2=a;a=b;b=c;c=d;d=a2;}
return out;}};sjcl.bitArray={bitSlice:function(a,bstart,bend){a=sjcl.bitArray._shiftRight(a.slice(bstart/32),32-(bstart&31)).slice(1);return(bend===undefined)?a:sjcl.bitArray.clamp(a,bend-bstart);},extract:function(a,bstart,blength){var x,sh=Math.floor((-bstart-blength)&31);if((bstart+blength-1^bstart)&-32){x=(a[bstart/32|0]<<(32-sh))^(a[bstart/32+1|0]>>>sh);}else{x=a[bstart/32|0]>>>sh;}
return x&((1<<blength)-1);},concat:function(a1,a2){if(a1.length===0||a2.length===0){return a1.concat(a2);}
var out,i,last=a1[a1.length-1],shift=sjcl.bitArray.getPartial(last);if(shift===32){return a1.concat(a2);}else{return sjcl.bitArray._shiftRight(a2,shift,last|0,a1.slice(0,a1.length-1));}},bitLength:function(a){var l=a.length,x;if(l===0){return 0;}
x=a[l-1];return(l-1)*32+sjcl.bitArray.getPartial(x);},clamp:function(a,len){if(a.length*32<len){return a;}
a=a.slice(0,Math.ceil(len/32));var l=a.length;len=len&31;if(l>0&&len){a[l-1]=sjcl.bitArray.partial(len,a[l-1]&0x80000000>>(len-1),1);}
return a;},partial:function(len,x,_end){if(len===32){return x;}
return(_end?x|0:x<<(32-len))+len*0x10000000000;},getPartial:function(x){return Math.round(x/0x10000000000)||32;},equal:function(a,b){if(sjcl.bitArray.bitLength(a)!==sjcl.bitArray.bitLength(b)){return false;}
var x=0,i;for(i=0;i<a.length;i++){x|=a[i]^b[i];}
return(x===0);},_shiftRight:function(a,shift,carry,out){var i,last2=0,shift2;if(out===undefined){out=[];}
for(;shift>=32;shift-=32){out.push(carry);carry=0;}
if(shift===0){return out.concat(a);}
for(i=0;i<a.length;i++){out.push(carry|a[i]>>>shift);carry=a[i]<<(32-shift);}
last2=a.length?a[a.length-1]:0;shift2=sjcl.bitArray.getPartial(last2);out.push(sjcl.bitArray.partial(shift+shift2&31,(shift+shift2>32)?carry:out.pop(),1));return out;},_xor4:function(x,y){return[x[0]^y[0],x[1]^y[1],x[2]^y[2],x[3]^y[3]];}};sjcl.codec.hex={fromBits:function(arr){var out="",i,x;for(i=0;i<arr.length;i++){out+=((arr[i]|0)+0xF00000000000).toString(16).substr(4);}
return out.substr(0,sjcl.bitArray.bitLength(arr)/4);},toBits:function(str){var i,out=[],len;str=str.replace(/\s|0x/g,"");len=str.length;str=str+"00000000";for(i=0;i<str.length;i+=8){out.push(parseInt(str.substr(i,8),16)^0);}
return sjcl.bitArray.clamp(out,len*4);}};sjcl.codec.utf8String={fromBits:function(arr){var out="",bl=sjcl.bitArray.bitLength(arr),i,tmp;for(i=0;i<bl/8;i++){if((i&3)===0){tmp=arr[i/4];}
out+=String.fromCharCode(tmp>>>24);tmp<<=8;}
return decodeURIComponent(escape(out));},toBits:function(str){str=unescape(encodeURIComponent(str));var out=[],i,tmp=0;for(i=0;i<str.length;i++){tmp=tmp<<8|str.charCodeAt(i);if((i&3)===3){out.push(tmp);tmp=0;}}
if(i&3){out.push(sjcl.bitArray.partial(8*(i&3),tmp));}
return out;}};sjcl.codec.base64={_chars:"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",fromBits:function(arr,_noEquals){var out="",i,bits=0,c=sjcl.codec.base64._chars,ta=0,bl=sjcl.bitArray.bitLength(arr);for(i=0;out.length*6<bl;){out+=c.charAt((ta^arr[i]>>>bits)>>>26);if(bits<6){ta=arr[i]<<(6-bits);bits+=26;i++;}else{ta<<=6;bits-=6;}}
while((out.length&3)&&!_noEquals){out+="=";}
return out;},toBits:function(str){str=str.replace(/\s|=/g,'');var out=[],i,bits=0,c=sjcl.codec.base64._chars,ta=0,x;for(i=0;i<str.length;i++){x=c.indexOf(str.charAt(i));if(x<0){throw new sjcl.exception.invalid("this isn't base64!");}
if(bits>26){bits-=26;out.push(ta^x>>>bits);ta=x<<(32-bits);}else{bits+=6;ta^=x<<(32-bits);}}
if(bits&56){out.push(sjcl.bitArray.partial(bits&56,ta,1));}
return out;}};if(sjcl.beware===undefined){sjcl.beware={};}
sjcl.beware["CBC mode is dangerous because it doesn't protect message integrity."]=function(){sjcl.mode.cbc={name:"cbc",encrypt:function(prp,plaintext,iv,adata){if(adata&&adata.length){throw new sjcl.exception.invalid("cbc can't authenticate data");}
if(sjcl.bitArray.bitLength(iv)!==128){throw new sjcl.exception.invalid("cbc iv must be 128 bits");}
var i,w=sjcl.bitArray,xor=w._xor4,bl=w.bitLength(plaintext),bp=0,output=[];if(bl&7){throw new sjcl.exception.invalid("pkcs#5 padding only works for multiples of a byte");}
for(i=0;bp+128<=bl;i+=4,bp+=128){iv=prp.encrypt(xor(iv,plaintext.slice(i,i+4)));output.splice(i,0,iv[0],iv[1],iv[2],iv[3]);}
bl=(16-((bl>>3)&15))*0x1010101;iv=prp.encrypt(xor(iv,w.concat(plaintext,[bl,bl,bl,bl]).slice(i,i+4)));output.splice(i,0,iv[0],iv[1],iv[2],iv[3]);return output;},decrypt:function(prp,ciphertext,iv,adata){if(adata&&adata.length){throw new sjcl.exception.invalid("cbc can't authenticate data");}
if(sjcl.bitArray.bitLength(iv)!==128){throw new sjcl.exception.invalid("cbc iv must be 128 bits");}
if((sjcl.bitArray.bitLength(ciphertext)&127)||!ciphertext.length){throw new sjcl.exception.corrupt("cbc ciphertext must be a positive multiple of the block size");}
var i,w=sjcl.bitArray,xor=w._xor4,bi,bo,output=[];adata=adata||[];for(i=0;i<ciphertext.length;i+=4){bi=ciphertext.slice(i,i+4);bo=xor(iv,prp.decrypt(bi));output.splice(i,0,bo[0],bo[1],bo[2],bo[3]);iv=bi;}
bi=output[i-1]&255;if(bi==0||bi>16){throw new sjcl.exception.corrupt("pkcs#5 padding corrupt");}
bo=bi*0x1010101;if(!w.equal(w.bitSlice([bo,bo,bo,bo],0,bi*8),w.bitSlice(output,output.length*32-bi*8,output.length*32))){throw new sjcl.exception.corrupt("pkcs#5 padding corrupt");}
return w.bitSlice(output,0,output.length*32-bi*8);}};};sjcl.hash.sha256=function(hash){if(!this._key[0]){this._precompute();}
if(hash){this._h=hash._h.slice(0);this._buffer=hash._buffer.slice(0);this._length=hash._length;}else{this.reset();}};sjcl.hash.sha256.hash=function(data){return(new sjcl.hash.sha256()).update(data).finalize();};sjcl.hash.sha256.prototype={blockSize:512,reset:function(){this._h=this._init.slice(0);this._buffer=[];this._length=0;return this;},update:function(data){if(typeof data==="string"){data=sjcl.codec.utf8String.toBits(data);}
var i,b=this._buffer=sjcl.bitArray.concat(this._buffer,data),ol=this._length,nl=this._length=ol+sjcl.bitArray.bitLength(data);for(i=512+ol&-512;i<=nl;i+=512){this._block(b.splice(0,16));}
return this;},finalize:function(){var i,b=this._buffer,h=this._h;b=sjcl.bitArray.concat(b,[sjcl.bitArray.partial(1,1)]);for(i=b.length+2;i&15;i++){b.push(0);}
b.push(Math.floor(this._length/0x100000000));b.push(this._length|0);while(b.length){this._block(b.splice(0,16));}
this.reset();return h;},_init:[],_key:[],_precompute:function(){var i=0,prime=2,factor;function frac(x){return(x-Math.floor(x))*0x100000000|0;}
outer:for(;i<64;prime++){for(factor=2;factor*factor<=prime;factor++){if(prime%factor===0){continue outer;}}
if(i<8){this._init[i]=frac(Math.pow(prime,1/2));}
this._key[i]=frac(Math.pow(prime,1/3));i++;}},_block:function(words){var i,tmp,a,b,w=words.slice(0),h=this._h,k=this._key,h0=h[0],h1=h[1],h2=h[2],h3=h[3],h4=h[4],h5=h[5],h6=h[6],h7=h[7];for(i=0;i<64;i++){if(i<16){tmp=w[i];}else{a=w[(i+1)&15];b=w[(i+14)&15];tmp=w[i&15]=((a>>>7^a>>>18^a>>>3^a<<25^a<<14)+
(b>>>17^b>>>19^b>>>10^b<<15^b<<13)+
w[i&15]+w[(i+9)&15])|0;}
tmp=(tmp+h7+(h4>>>6^h4>>>11^h4>>>25^h4<<26^h4<<21^h4<<7)+(h6^h4&(h5^h6))+k[i]);h7=h6;h6=h5;h5=h4;h4=h3+tmp|0;h3=h2;h2=h1;h1=h0;h0=(tmp+((h1&h2)^(h3&(h1^h2)))+(h1>>>2^h1>>>13^h1>>>22^h1<<30^h1<<19^h1<<10))|0;}
h[0]=h[0]+h0|0;h[1]=h[1]+h1|0;h[2]=h[2]+h2|0;h[3]=h[3]+h3|0;h[4]=h[4]+h4|0;h[5]=h[5]+h5|0;h[6]=h[6]+h6|0;h[7]=h[7]+h7|0;}};sjcl.random={randomWords:function(nwords,paranoia){var out=[],i,readiness=this.isReady(paranoia),g;if(readiness===this._NOT_READY){throw new sjcl.exception.notReady("generator isn't seeded");}else if(readiness&this._REQUIRES_RESEED){this._reseedFromPools(!(readiness&this._READY));}
for(i=0;i<nwords;i+=4){if((i+1)%this._MAX_WORDS_PER_BURST===0){this._gate();}
g=this._gen4words();out.push(g[0],g[1],g[2],g[3]);}
this._gate();return out.slice(0,nwords);},setDefaultParanoia:function(paranoia){this._defaultParanoia=paranoia;},addEntropy:function(data,estimatedEntropy,source){source=source||"user";var id,i,ty=0,tmp,t=(new Date()).valueOf(),robin=this._robins[source],oldReady=this.isReady();id=this._collectorIds[source];if(id===undefined){id=this._collectorIds[source]=this._collectorIdNext++;}
if(robin===undefined){robin=this._robins[source]=0;}
this._robins[source]=(this._robins[source]+1)%this._pools.length;switch(typeof(data)){case"number":data=[data];ty=1;break;case"object":if(estimatedEntropy===undefined){estimatedEntropy=0;for(i=0;i<data.length;i++){tmp=data[i];while(tmp>0){estimatedEntropy++;tmp=tmp>>>1;}}}
this._pools[robin].update([id,this._eventId++,ty||2,estimatedEntropy,t,data.length].concat(data));break;case"string":if(estimatedEntropy===undefined){estimatedEntropy=data.length;}
this._pools[robin].update([id,this._eventId++,3,estimatedEntropy,t,data.length]);this._pools[robin].update(data);break;default:throw new sjcl.exception.bug("random: addEntropy only supports number, array or string");}
this._poolEntropy[robin]+=estimatedEntropy;this._poolStrength+=estimatedEntropy;if(oldReady===this._NOT_READY){if(this.isReady()!==this._NOT_READY){this._fireEvent("seeded",Math.max(this._strength,this._poolStrength));}
this._fireEvent("progress",this.getProgress());}},isReady:function(paranoia){var entropyRequired=this._PARANOIA_LEVELS[(paranoia!==undefined)?paranoia:this._defaultParanoia];if(this._strength&&this._strength>=entropyRequired){return(this._poolEntropy[0]>this._BITS_PER_RESEED&&(new Date()).valueOf()>this._nextReseed)?this._REQUIRES_RESEED|this._READY:this._READY;}else{return(this._poolStrength>=entropyRequired)?this._REQUIRES_RESEED|this._NOT_READY:this._NOT_READY;}},getProgress:function(paranoia){var entropyRequired=this._PARANOIA_LEVELS[paranoia?paranoia:this._defaultParanoia];if(this._strength>=entropyRequired){return 1.0;}else{return(this._poolStrength>entropyRequired)?1.0:this._poolStrength/entropyRequired;}},startCollectors:function(){if(this._collectorsStarted){return;}
if(window.addEventListener){window.addEventListener("load",this._loadTimeCollector,false);window.addEventListener("mousemove",this._mouseCollector,false);}else if(document.attachEvent){document.attachEvent("onload",this._loadTimeCollector);document.attachEvent("onmousemove",this._mouseCollector);}
else{throw new sjcl.exception.bug("can't attach event");}
this._collectorsStarted=true;},stopCollectors:function(){if(!this._collectorsStarted){return;}
if(window.removeEventListener){window.removeEventListener("load",this._loadTimeCollector);window.removeEventListener("mousemove",this._mouseCollector);}else if(window.detachEvent){window.detachEvent("onload",this._loadTimeCollector);window.detachEvent("onmousemove",this._mouseCollector);}
this._collectorsStarted=false;},addEventListener:function(name,callback){this._callbacks[name][this._callbackI++]=callback;},removeEventListener:function(name,cb){var i,j,cbs=this._callbacks[name],jsTemp=[];for(j in cbs){if(cbs.hasOwnProperty(j)&&cbs[j]===cb){jsTemp.push(j);}}
for(i=0;i<jsTemp.length;i++){j=jsTemp[i];delete cbs[j];}},_pools:[new sjcl.hash.sha256()],_poolEntropy:[0],_reseedCount:0,_robins:{},_eventId:0,_collectorIds:{},_collectorIdNext:0,_strength:0,_poolStrength:0,_nextReseed:0,_key:[0,0,0,0,0,0,0,0],_counter:[0,0,0,0],_cipher:undefined,_defaultParanoia:6,_collectorsStarted:false,_callbacks:{progress:{},seeded:{}},_callbackI:0,_NOT_READY:0,_READY:1,_REQUIRES_RESEED:2,_MAX_WORDS_PER_BURST:65536,_PARANOIA_LEVELS:[0,48,64,96,128,192,256,384,512,768,1024],_MILLISECONDS_PER_RESEED:30000,_BITS_PER_RESEED:80,_gen4words:function(){for(var i=0;i<4;i++){this._counter[i]=this._counter[i]+1|0;if(this._counter[i]){break;}}
return this._cipher.encrypt(this._counter);},_gate:function(){this._key=this._gen4words().concat(this._gen4words());this._cipher=new sjcl.cipher.aes(this._key);},_reseed:function(seedWords){this._key=sjcl.hash.sha256.hash(this._key.concat(seedWords));this._cipher=new sjcl.cipher.aes(this._key);for(var i=0;i<4;i++){this._counter[i]=this._counter[i]+1|0;if(this._counter[i]){break;}}},_reseedFromPools:function(full){var reseedData=[],strength=0,i;this._nextReseed=reseedData[0]=(new Date()).valueOf()+this._MILLISECONDS_PER_RESEED;for(i=0;i<16;i++){reseedData.push(Math.random()*0x100000000|0);}
for(i=0;i<this._pools.length;i++){reseedData=reseedData.concat(this._pools[i].finalize());strength+=this._poolEntropy[i];this._poolEntropy[i]=0;if(!full&&(this._reseedCount&(1<<i))){break;}}
if(this._reseedCount>=1<<this._pools.length){this._pools.push(new sjcl.hash.sha256());this._poolEntropy.push(0);}
this._poolStrength-=strength;if(strength>this._strength){this._strength=strength;}
this._reseedCount++;this._reseed(reseedData);},_mouseCollector:function(ev){var x=ev.x||ev.clientX||ev.offsetX,y=ev.y||ev.clientY||ev.offsetY;sjcl.random.addEntropy([x,y],2,"mouse");},_loadTimeCollector:function(ev){var d=new Date();sjcl.random.addEntropy(d,2,"loadtime");},_fireEvent:function(name,arg){var j,cbs=sjcl.random._callbacks[name],cbsTemp=[];for(j in cbs){if(cbs.hasOwnProperty(j)){cbsTemp.push(cbs[j]);}}
for(j=0;j<cbsTemp.length;j++){cbsTemp[j](arg);}}};for(k in sjcl.beware){if(sjcl.beware.hasOwnProperty(k)){sjcl.beware[k]();}}
Braintree={pidCrypt:pidCrypt,pidCryptUtil:pidCryptUtil,sjcl:sjcl};Braintree.create=function(publicKey){var my={publicKey:publicKey};var generateAesKey=function(){return{key:sjcl.random.randomWords(8,0),encrypt:function(plainText){var aes=new sjcl.cipher.aes(this.key);var iv=sjcl.random.randomWords(4,0);var plainTextBits=sjcl.codec.utf8String.toBits(plainText);var cipherTextBits=sjcl.mode.cbc.encrypt(aes,plainTextBits,iv);return sjcl.codec.base64.fromBits(sjcl.bitArray.concat(iv,cipherTextBits));},encryptKeyWithRsa:function(rsaKey){var encryptedKeyHex=rsaKey.encryptRaw(sjcl.codec.base64.fromBits(this.key));return pidCryptUtil.encodeBase64(pidCryptUtil.convertFromHex(encryptedKeyHex));}};};var rsaKey=function(){var key=pidCryptUtil.decodeBase64(my.publicKey);var rsa=new pidCrypt.RSA();var keyBytes=pidCryptUtil.toByteArray(key);var asn=pidCrypt.ASN1.decode(keyBytes);var tree=asn.toHexTree();rsa.setPublicKeyFromASN(tree);return rsa;};var encrypt=function(text){var key=generateAesKey();var aesEncryptedData=key.encrypt(text);return"$bt2$"+key.encryptKeyWithRsa(rsaKey())+"$"+aesEncryptedData;};return{encrypt:encrypt,publicKey:my.publicKey,version:'1.1.1'};};return Braintree;})();


/***/ }),
/* 1741 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rover_globals_backbone__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rover_globals_Rover__ = __webpack_require__(14);



__WEBPACK_IMPORTED_MODULE_2__rover_globals_Rover__["default"].models = __WEBPACK_IMPORTED_MODULE_2__rover_globals_Rover__["default"].models || {};
__WEBPACK_IMPORTED_MODULE_2__rover_globals_Rover__["default"].models.RedemptionModel = __WEBPACK_IMPORTED_MODULE_1__rover_globals_backbone__["a" /* default */].Model.extend({
  url: function url() {
    return __WEBPACK_IMPORTED_MODULE_2__rover_globals_Rover__["default"].urls.redemptionUrl;
  },
  defaults: {
    code: null
  }
});
var PAYMENT_METHOD_SORT_ORDER = ['promo', 'wallet'];
__WEBPACK_IMPORTED_MODULE_2__rover_globals_Rover__["default"].models.PromoMethodModel = __WEBPACK_IMPORTED_MODULE_1__rover_globals_backbone__["a" /* default */].Model.extend({
  sortOrder: PAYMENT_METHOD_SORT_ORDER.indexOf('promo'),
  url: function url() {
    return this.get('url');
  },
  defaults: {
    non_redeemable: null
  },
  getTotalRoverBucks: function getTotalRoverBucks() {
    if (this.get('non_redeemable') === null) {
      return '0.00';
    }

    return parseFloat(this.get('non_redeemable')).toFixed(2);
  }
});

/***/ }),
/* 1742 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ../utilities/Alerts.js
var Alerts = __webpack_require__(290);

// EXTERNAL MODULE: ../globals/jquery.js
var jquery = __webpack_require__(9);

// CONCATENATED MODULE: ../utilities/scroll.js


var scroll_ScrollTrigger = function ScrollTrigger(instanceOptions, callback) {
  /**
   * Triggers callback when `instanceOptions.$element` is at least `offset`
   * pixels above the bottom of the viewport.
   *
   * @type {{$element: jQuery element, offset: number}}
   */
  var defaultOptions = {
    $element: null,
    offset: 50
  };
  var options = Object.assign({}, defaultOptions, instanceOptions);
  var $window = Object(jquery["default"])(window);

  var scrollHandler = function scrollHandler() {
    var viewportBottom = $window.scrollTop() + $window.height();
    var triggerHeight = options.$element.offset().top + 50;

    if (viewportBottom >= triggerHeight) {
      callback(options.$element);
      $window.off('scroll', scrollHandler);
    }
  };

  $window.on('scroll', scrollHandler);
};

/* harmony default export */ var utilities_scroll = (scroll_ScrollTrigger);
// EXTERNAL MODULE: ../globals/underscore.js
var underscore = __webpack_require__(27);

// EXTERNAL MODULE: ../globals/Rover.js
var Rover = __webpack_require__(14);

// EXTERNAL MODULE: ../globals/dataLayer.js
var dataLayer = __webpack_require__(144);

// EXTERNAL MODULE: ../globals/currentUser/index.js + 1 modules
var currentUser = __webpack_require__(400);

// EXTERNAL MODULE: ../utilities/translation.js
var translation = __webpack_require__(37);

// EXTERNAL MODULE: ../utilities/userAgent.js
var userAgent = __webpack_require__(60);

// EXTERNAL MODULE: ../utilities/fireEmbeddedWebEvent.js
var fireEmbeddedWebEvent = __webpack_require__(618);

// EXTERNAL MODULE: ../react-lib/src/pages/conversations/ConversationsCheckoutPage/index.js
var ConversationsCheckoutPage = __webpack_require__(1267);

// EXTERNAL MODULE: ./js/models/conversation.js
var conversation = __webpack_require__(617);

// EXTERNAL MODULE: ./js/backbone/views/checkout/credit_card_collection_view.js + 1 modules
var credit_card_collection_view = __webpack_require__(886);

// EXTERNAL MODULE: ../globals/backbone.js
var backbone = __webpack_require__(19);

// EXTERNAL MODULE: ../globals/Mustache.js
var Mustache = __webpack_require__(134);

// CONCATENATED MODULE: ./js/backbone/views/checkout/optional_requester_addon_view.js




/* harmony default export */ var optional_requester_addon_view = (backbone["a" /* default */].View.extend({
  template: Mustache["default"].template('new_design/account_conversations/requester_add_on'),
  events: {
    'change .js-requester-add-on-selection': 'toggleActive'
  },
  initialize: function initialize(options) {
    underscore["default"].bindAll(this, 'toggleActive', 'toggleDisabled', 'isValid', 'render');

    this.addOn = options.addOn;
    this.requestableModel = options.requestableModel;
    this.requestableModel.on('changing:requester_add_ons', this.toggleDisabled);
    this.$form = this.$('js-requester-add-on-form');
    this.$navbar = Object(jquery["default"])('.js-header-navbar');
  },
  toggleDisabled: function toggleDisabled(slug, value) {
    this.$('input').attr('disabled', value);
  },
  toggleActive: function toggleActive() {
    this.toggleDisabled(this.addOn.slug, true);
    this.requestableModel.toggleRequesterAddOn(this.addOn.slug, this.$('.js-requester-add-on-selection:checked').val() === 'true');
  },
  isValid: function isValid() {
    if (!this.$form.length) {
      return true;
    }

    if (this.$form.length && this.$form.valid()) {
      return true;
    }

    if (this.$el.offset().top < Object(jquery["default"])(window).scrollTop() - this.$navbar.height() - 30) {
      Object(jquery["default"])('html,body').animate({
        scrollTop: this.$el.offset().top - this.$navbar.height() - 30
      }, 'fast');
      return false;
    }

    return false;
  },
  render: function render() {
    this.$el.html(this.template.render(this.addOn));
    this.$('[data-toggle="popover"]').popover();
    this.$form.validate();
  }
}));
// CONCATENATED MODULE: ./js/backbone/views/checkout/optional_requester_addons_list_view.js





/* harmony default export */ var optional_requester_addons_list_view = (backbone["a" /* default */].View.extend({
  initialize: function initialize(options) {
    underscore["default"].bindAll(this, 'render');

    this.requestableModel = options.requestableModel;
    this.listenTo(this.requestableModel, 'complete', this.render);
    this.listenTo(this.requestableModel, 'change:requester_add_ons', this.render);
  },
  render: function render() {
    var self = this;
    self.$el.hide();
    self.$el.empty();

    underscore["default"].each(self.requestableModel.getOptionalRequesterAddOns(), function (addOn) {
      var addOnContainer = Object(jquery["default"])("<div class=\"js-requester-add-on-".concat(addOn.slug, "-container\"></div>"));
      self.$el.append(addOnContainer);
      var addOnView = new optional_requester_addon_view({
        addOn: addOn,
        requestableModel: self.requestableModel,
        el: addOnContainer
      });
      addOnView.render();
    });

    self.$el.show();
  }
}));
// EXTERNAL MODULE: ../utilities/url.js + 1 modules
var url = __webpack_require__(350);

// EXTERNAL MODULE: ../node_modules/moment/moment.js
var moment = __webpack_require__(31);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ../shared/js/constants/i18n/datetime/datetimeInjected.js + 1 modules
var datetimeInjected = __webpack_require__(141);

// EXTERNAL MODULE: ./js/constants/serviceConstants.js
var serviceConstants = __webpack_require__(619);

// CONCATENATED MODULE: ../react-lib/src/pages/conversations/EmergencyFormPage/index.js
var reactEmergencyContactContainer = '#js-emergency-form';
var mount = function mount(appProps) {
  var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : reactEmergencyContactContainer;
  var ReactDOM;
  var renderRootElement;
  var EmergencyFormPageContainer;

  try {
    ReactDOM = __webpack_require__(81);
    renderRootElement = __webpack_require__(203)["default"];
    EmergencyFormPageContainer = __webpack_require__(1743)["default"];
  } catch (e) {
    return function () {};
  }

  renderRootElement(EmergencyFormPageContainer, id, appProps);

  if (false) {
    module.hot.accept('./EmergencyFormPageContainer', function () {
      renderRootElement( // eslint-disable-next-line global-require
      require("./EmergencyFormPageContainer")["default"], id, appProps);
    });
  } // eslint-disable-next-line rover/no-platform-specific-globals-or-imports


  return function () {
    return ReactDOM.unmountComponentAtNode(document.querySelector(id));
  };
};
// CONCATENATED MODULE: ./js/backbone/views/checkout/confirmation_view.js
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable filenames/match-regex */






 // WARNING: DF from datetimeInjected is not SSR compatible.
// For newer code, use const DF = getDateTimeFormatMapForLang(<lang>) from '@rover/shared/js/constants/i18n/datetime'




/* harmony default export */ var confirmation_view = (backbone["a" /* default */].View.extend({
  template: Mustache["default"].template('new_design/account_conversations/confirmation'),
  initialize: function initialize(options) {
    this.requestableModel = options.requestableModel;
    this.relationshipModel = options.relationshipModel;
    this.showCallback = options.showCallback;
  },
  render: function render() {
    var _this = this;

    var data = this.requestableModel.toJSON();
    var state = this.requestableModel.getState();
    data.isSitter = Rover["default"].context.isSitter;
    data.isMobileEmbedded = Rover["default"].context.isMobileEmbedded;

    if (data.serviceModel) {
      data.serviceModel = data.serviceModel.toJSON();
      data.serviceModel.meta.cancellation_policy = Rover["default"].utils.capitalizeFirstLetter(data.serviceModel.meta.cancellation_policy);
    }

    if (state === 'booked') {
      data.booked = true;
    } else if (state === 'requested') {
      if (data.isSitter) {
        // Sitters need to accept back on the conversation page
        Object(url["redirect"])(data.web_url);
      }

      data.requested = true;
    }

    if (data.pets && data.pets.length) {
      data.multiplePets = data.pets && data.pets.length > 1;
      data.dogs = Rover["default"].utils.simpleSyndeticJoin(underscore["default"].map(data.pets, function (dog) {
        return dog.name;
      }));
      data.pets = data.pets.map(function (pet) {
        var newInfo = {};
        newInfo.urls = Rover["default"].urls.petEditURLs[pet.url];

        if (pet.care_instructions) {
          newInfo.care_instructions = pet.care_instructions;
        }

        return _objectSpread({}, pet, {}, newInfo);
      });
    }

    if (data.pets && data.pets.length) {
      data.emergency_contact_information = data.pets[0].emergency_contact_information || '[None entered]';

      if (data.pets[0].urls) {
        data.editEmergencyContactUrl = data.pets[0].urls.editEmergencyContact;
      }
    }

    underscore["default"].each(['start_date', 'end_date'], function (prop) {
      data["".concat(prop, "_formatted")] = moment_default()(data[prop]).format(datetimeInjected["b" /* default */].MONTH_DAY_SHORT);
    });

    if (data.service_type === serviceConstants["b" /* SERVICE_TYPE_CHOICES */].boarding) {
      data.overnight = true;
    } else if (data.service_type === serviceConstants["b" /* SERVICE_TYPE_CHOICES */].traveling) {
      data.traveling = true;
    }

    data.showfaq = serviceConstants["a" /* GUARANTEE_SERVICE_TYPE_CHOICES */].includes(data.service_type);
    data.relationship = this.relationshipModel.toJSON();
    data.accountPaymentsURL = Rover["default"].urls.accountPayments;
    data.guaranteeURL = Rover["default"].urls.guarantee;
    this.$el.html(this.template.render(data));

    if (Object(jquery["default"])('.js-payment-methods').is(':visible')) {
      Object(jquery["default"])('.js-payment-methods').fadeOut('fast', function () {
        _this.$el.fadeIn('fast');

        if (jquery["default"].isFunction(_this.showCallback)) {
          _this.showCallback();
        }
      });
    } else {
      this.$el.show();

      if (jquery["default"].isFunction(this.showCallback)) {
        this.showCallback();
      }
    }

    this.$('[data-toggle="popover"]').popover();

    if (Object(jquery["default"])('#js-emergency-form').length) {
      var appProps = {
        showfaq: data.showfaq,
        conversationUrl: data.web_url,
        pets: data.pets
      };
      mount(appProps);
    }
  }
}));
// EXTERNAL MODULE: ./js/backbone/views/checkout/conversation_view.js
var conversation_view = __webpack_require__(929);

// EXTERNAL MODULE: ./js/backbone/models/CreditCardCollection.js
var CreditCardCollection = __webpack_require__(887);

// EXTERNAL MODULE: ./js/backbone/views/checkout/recurring_billing_summary_view.js
var recurring_billing_summary_view = __webpack_require__(930);

// CONCATENATED MODULE: ./js/backbone/views/checkout/redemption_view.js








/* harmony default export */ var redemption_view = (backbone["a" /* default */].View.extend({
  template: Mustache["default"].template('new_design/account_conversations/redemption'),
  events: {
    'click .js-redeem': 'redeemCode',
    'change .js-redemption-code': 'toggleRedeem',
    'keyup .js-redemption-code': 'toggleRedeem'
  },
  initialize: function initialize(options) {
    underscore["default"].bindAll(this, 'redeemCode', 'toggleRedeem', 'showError');

    this.roverBucksModel = options.roverBucksModel;
    this.paymentMethodCollection = options.paymentMethodCollection;
    this.resetAttempts();
  },
  render: function render() {
    this.$el.html(this.template.render({
      conversation_opk: Rover["default"].conversation_opk
    }));
  },
  toggleRedeem: function toggleRedeem() {
    this.$('.js-redeem').prop('disabled', jquery["default"].trim(this.$('.js-redemption-code').val()) === '');
  },
  showError: function showError(error) {
    Alerts["a" /* default */].showToast({
      severity: 'danger',
      message: error,
      container: this.$('.js-redemption-alert-container'),
      showHideButton: false
    });
  },
  showSuccess: function showSuccess(data) {
    var message = translation["default"]._(
    /* i18n: {0} will be a promo code name e.g ONEFREEGROOMING  */
    {
      id: "Redeemed code {0}!",
      values: {
        0: data.code
      }
    });

    Alerts["a" /* default */].showToast({
      severity: 'success',
      message: message,
      container: this.$('.js-redemption-alert-container'),
      showHideButton: false
    });
  },
  redeemCode: function redeemCode() {
    var redemptionCodeInputVal = jquery["default"].trim(this.$('.js-redemption-code').val());
    var redemptionIntendedconversationOpkVal = jquery["default"].trim(this.$('.js-redemption-intended-conversation-opk').val());
    dataLayer["a" /* default */].push({
      event: 'owner-conversion-checkout-promo-code',
      promoCode: redemptionCodeInputVal
    });
    this.$('.js-redemption-alert-container').empty();
    var redemptionModel = new Rover["default"].models.RedemptionModel();
    redemptionModel.set('code', redemptionCodeInputVal);
    redemptionModel.set('intended_conversation_opk', redemptionIntendedconversationOpkVal);
    this.disableForm();
    this.trySave(redemptionModel);
  },
  DELAYS: [0, 500, 1500],
  getDelay: function getDelay() {
    return this.DELAYS[this.attempts];
  },
  maxAttemptsExceeded: function maxAttemptsExceeded() {
    return this.attempts >= this.DELAYS.length;
  },
  resetAttempts: function resetAttempts() {
    this.attempts = 0;
  },
  trySave: function trySave(redemptionModel) {
    var _this = this;

    if (this.maxAttemptsExceeded()) {
      this.redemptionFailure("We're unable to process the code at this time. Please try again shortly.");
      return;
    }

    setTimeout(function () {
      redemptionModel.save(null, {
        success: function success(model, data, options) {
          if (options.xhr.status === 202) {
            _this.attempts += 1;

            _this.trySave(model);

            return;
          }

          _this.redemptionSuccess(data);
        },
        error: function error(model, data) {
          var error;

          if (data.responseJSON) {
            error = data.responseJSON.error_description;
          }

          _this.redemptionFailure(error);
        }
      });
    }, this.getDelay());
  },
  redemptionSuccess: function redemptionSuccess(data) {
    this.$('.js-redemption-code').val('').trigger('change');
    this.paymentMethodCollection.fetch();
    this.showSuccess(data);
    this.enableForm();
    this.resetAttempts();
  },
  redemptionFailure: function redemptionFailure() {
    var errorMessage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Error redeeming code';
    this.showError(errorMessage);
    this.enableForm();
    this.resetAttempts();
  },
  enableForm: function enableForm() {
    this.$('.js-redemption-code').prop('disabled', false);
    this.$('.js-redeem').btn('reset');
  },
  disableForm: function disableForm() {
    this.$('.js-redemption-code').prop('disabled', true);
    this.$('.js-redeem').btn('loading');
  }
}));
// EXTERNAL MODULE: ./js/backbone/models/PaymentMethodCollection.js + 1 modules
var PaymentMethodCollection = __webpack_require__(888);

// EXTERNAL MODULE: ./js/backbone/models/PriceModel.js
var PriceModel = __webpack_require__(931);

// CONCATENATED MODULE: ./js/backbone/models/RelationshipModel.js

/* harmony default export */ var RelationshipModel = (backbone["a" /* default */].Model.extend({}));
// EXTERNAL MODULE: ./js/backbone/models/RoverBucksModel.js
var RoverBucksModel = __webpack_require__(753);

// EXTERNAL MODULE: ../utilities/device.js
var device = __webpack_require__(401);

// EXTERNAL MODULE: ../utilities/stripe.client.js + 2 modules
var stripe_client = __webpack_require__(460);

// CONCATENATED MODULE: ./js/backbone/models/PaymentModel.js
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }








/* harmony default export */ var PaymentModel = (backbone["a" /* default */].Model.extend({
  url: function url() {
    return this.requestableModel.get('url');
  },
  initialize: function initialize(options) {
    this.requestableModel = options.requestableModel;
    this.roverBucksModel = options.roverBucksModel;
    this.creditCardCollectionView = options.creditCardCollectionView;
    this.priceModel = options.priceModel;
  },
  pay: function () {
    var _pay = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee(options) {
      var paymentInfo, data, state;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.getPaymentBreakdown(options);

            case 2:
              paymentInfo = _context.sent;

              if (paymentInfo) {
                _context.next = 5;
                break;
              }

              return _context.abrupt("return");

            case 5:
              data = {
                request: {
                  status: '',
                  request_version: null,
                  payment_info: paymentInfo
                },
                source: this.getSource(),
                booking_add_ons: this.requestableModel.getActiveBookingAddOns(),
                requester_add_ons: this.requestableModel.get('requester_add_ons')
              };
              data = underscore["default"].extend(data, this.requestableModel.getDatesData());
              state = this.requestableModel.getState();

              if (!(state === 'pay')) {
                _context.next = 13;
                break;
              }

              data.request.status = 'accepted';
              data.request.request_version = this.requestableModel.get('request').request_version;
              _context.next = 18;
              break;

            case 13:
              if (!(state === 'authorize')) {
                _context.next = 17;
                break;
              }

              data.request.status = 'pending';
              _context.next = 18;
              break;

            case 17:
              return _context.abrupt("return", false);

            case 18:
              this.set('data', data);
              this.save(null, options);
              return _context.abrupt("return", true);

            case 21:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function pay(_x) {
      return _pay.apply(this, arguments);
    }

    return pay;
  }(),
  isNew: function isNew() {
    // Always PUT
    return false;
  },
  toJSON: function toJSON() {
    // `data` is the only attribute we care about here
    return this.get('data');
  },
  getSource: function getSource() {
    if (Object(jquery["default"])('body').hasClass('js-mobile-embedded')) {
      return Object(jquery["default"])('body').data('mobile-embedded-source');
    }

    return Object(device["isMobileBrowser"])() ? 'mobile_web' : 'web';
  },

  /** see https://docs.google.com/presentation/d/1u0oZM5lCxiMbz1BQaGrVM2Mq8FtSoy-pwBxO4qB6BlE/
   */
  logPaymentIntentCreatedEvent: function logPaymentIntentCreatedEvent(success, serviceType, conversationOpk) {
    Object(dataLayer["b" /* pushEventWithDebug */])({
      event: 'ext-api-stripe-checkout-payment-intents-request-book',
      submitStatus: success ? 'success' : 'fail',
      usePaymentIntents: true,
      serviceType: serviceType,
      conversationId: conversationOpk
    });
  },

  /** see https://docs.google.com/presentation/d/1u0oZM5lCxiMbz1BQaGrVM2Mq8FtSoy-pwBxO4qB6BlE/
   */
  logPaymentIntentRequiredEvent: function logPaymentIntentRequiredEvent(requiresAction, serviceType, conversationOpk) {
    if (requiresAction) {
      Object(dataLayer["b" /* pushEventWithDebug */])({
        event: 'ext-api-stripe-checkout-modal-required',
        serviceType: serviceType,
        conversationId: conversationOpk
      });
    }
  },

  /** see https://docs.google.com/presentation/d/1u0oZM5lCxiMbz1BQaGrVM2Mq8FtSoy-pwBxO4qB6BlE/
   */
  logPaymentIntentCompletedEvent: function logPaymentIntentCompletedEvent(success, serviceType, conversationOpk) {
    Object(dataLayer["b" /* pushEventWithDebug */])({
      event: 'ext-api-stripe-checkout-modal-complete',
      submitStatus: success ? 'success' : 'fail',
      serviceType: serviceType,
      conversationId: conversationOpk
    });
  },
  getPaymentBreakdown: function () {
    var _getPaymentBreakdown = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee2(options) {
      var totalPrice, selectedCC, selectedCCURL, usesPaymentIntent, ret, paymentInfo, paymentIntentError, serviceType, _ref, clientSecret, requiresAction, opk, message;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              totalPrice = this.priceModel.getTotalPrice();
              selectedCC = this.creditCardCollectionView.getSelectedCC();
              selectedCCURL = selectedCC.val();
              usesPaymentIntent = selectedCC.data('uses-payment-intent');
              ret = [];

              if (totalPrice.roverBucksToUse !== '0.00') {
                ret = ret.concat(this.spreadRoverBucks(totalPrice.roverBucksToUse));
              }

              if (!this.priceModel.roverBucksCoverCost()) {
                _context2.next = 10;
                break;
              }

              return _context2.abrupt("return", ret);

            case 10:
              if (!selectedCCURL) {
                _context2.next = 39;
                break;
              }

              paymentInfo = {
                url: selectedCCURL,
                amount: totalPrice.amountToPay
              };

              if (!usesPaymentIntent) {
                _context2.next = 37;
                break;
              }

              paymentIntentError = options.paymentIntentError;
              serviceType = this.requestableModel.get('service_type');
              _context2.prev = 15;
              _context2.next = 18;
              return Object(stripe_client["b" /* createPaymentIntent */])(Rover["default"].conversation_opk, selectedCCURL, totalPrice.amountToPay, totalPrice.totalPriceCurrencyIso);

            case 18:
              _ref = _context2.sent;
              clientSecret = _ref.clientSecret;
              requiresAction = _ref.requiresAction;
              opk = _ref.opk;
              this.logPaymentIntentCreatedEvent(true, serviceType, Rover["default"].conversation_opk);
              this.logPaymentIntentRequiredEvent(requiresAction, serviceType, Rover["default"].conversation_opk);
              _context2.next = 26;
              return Object(stripe_client["a" /* authenticatePaymentIntent */])(clientSecret, requiresAction, opk);

            case 26:
              paymentInfo.payment_intent_opk = _context2.sent;
              this.logPaymentIntentCompletedEvent(true, serviceType, Rover["default"].conversation_opk);
              _context2.next = 37;
              break;

            case 30:
              _context2.prev = 30;
              _context2.t0 = _context2["catch"](15);
              message = null;

              if (_context2.t0.type === 'PaymentIntentCreationError') {
                this.logPaymentIntentCreatedEvent(false, serviceType, Rover["default"].conversation_opk); // since the error messages contain untranslated strings
                // which seem to be formatted differently
                // use the errorType to determine if it is meant
                // to be displayed to the user

                if (_context2.t0.errorType === 'payment_intent_creation') {
                  message = _context2.t0.message;
                }
              }

              if (_context2.t0.type === 'PaymentIntentAuthenticationError') {
                this.logPaymentIntentCompletedEvent(false, serviceType, Rover["default"].conversation_opk);
              }

              paymentIntentError(message);
              return _context2.abrupt("return");

            case 37:
              ret.push(paymentInfo);
              return _context2.abrupt("return", ret);

            case 39:
              return _context2.abrupt("return", false);

            case 40:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this, [[15, 30]]);
    }));

    function getPaymentBreakdown(_x2) {
      return _getPaymentBreakdown.apply(this, arguments);
    }

    return getPaymentBreakdown;
  }(),
  spreadRoverBucks: function spreadRoverBucks(amount) {
    var buckAmount = amount;
    var methods = [];

    var methodModels = underscore["default"].values(this.roverBucksModel.getMethodModels());

    var i = 0;

    for (i = 0; i < methodModels.length; i += 1) {
      var method = methodModels[i];
      var amt = Math.min(buckAmount, method.getTotalRoverBucks());

      if (amt !== 0) {
        methods.push({
          url: method.url(),
          amount: amt.toFixed(2)
        });
        buckAmount -= amt;

        if (buckAmount <= 0) {
          break;
        }
      }
    }

    return methods;
  }
}));
// CONCATENATED MODULE: ./js/pages/checkout.js
function checkout_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function checkout__objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { checkout_ownKeys(source, true).forEach(function (key) { checkout__defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { checkout_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function checkout__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

























Object(jquery["default"])(function () {
  if (!Object(jquery["default"])('body.js-checkout').length) {
    return;
  }

  var confirmationShown = false;
  var requestableModel = false;
  var summaryView = false; // eslint-disable-next-line no-unused-vars

  var optionalRequesterAddOnsListView = false;
  var creditCardCollection = false;
  var creditCardCollectionView = false;
  var paymentModel = false;
  var priceModel = false;
  var relationshipModel = false;
  var roverBucksModel = false;
  var serviceModel = false;
  var errorMessage = null;
  var unmountReactCCForm;
  var setDisabledReactCCFormUI;

  var hideCreditCardInput = function hideCreditCardInput() {
    if (!creditCardCollection.length) {
      Object(jquery["default"])('.js-creditcard-section').hide();
    }

    Object(jquery["default"])('.js-authorize-text').hide();
    Object(jquery["default"])('.js-creditcard:checked').prop('checked', false);
    Object(jquery["default"])('.js-creditcard, .js-remove-cc').prop('disabled', true);
    Object(jquery["default"])('.js-creditcard-list').addClass('disabled');
    Object(jquery["default"])('.js-payment-alerts-container').empty();
    Alerts["a" /* default */].showToast({
      severity: 'info',
      message: translation["default"]._('Good news! Your Rover credit covers the cost of this booking.'),
      container: Object(jquery["default"])('.js-payment-alerts-container'),
      showHideButton: false
    });

    if (setDisabledReactCCFormUI) {
      setDisabledReactCCFormUI();
    }
  };

  var showCreditCardInput = function showCreditCardInput() {
    Object(jquery["default"])('.js-payment-alerts-container').empty();
    Object(jquery["default"])('.js-creditcard, .js-remove-cc').prop('disabled', false);
    Object(jquery["default"])('.js-creditcard-section').show();
    Object(jquery["default"])('.js-authorize-text').show();

    if (creditCardCollection.length) {
      Object(jquery["default"])('.js-creditcard.js-default-payment').prop('checked', true);
      Object(jquery["default"])('.js-creditcard-list').removeClass('disabled').show();
    } else if (Rover["default"].context.hasPaidWithPaypal) {
      Alerts["a" /* default */].showToast({
        severity: 'warning',
        message: translation["default"]._('We no longer support Paypal for sending payment to your sitter. Please add a credit or debit card.'),
        container: Object(jquery["default"])('.js-payment-alerts-container')
      });
    }
  };

  var showMainContainer = function showMainContainer() {
    Object(jquery["default"])('.js-main-container').removeClass('padding-x8 rover-loading');
    Object(jquery["default"])('[data-toggle="popover"]').popover();
  };
  /**
   * @param paymentState
   */


  var showConfirmation = function showConfirmation() {
    if (confirmationShown) {
      return;
    }

    confirmationShown = true;
    new confirmation_view({
      requestableModel: requestableModel,
      relationshipModel: relationshipModel,
      el: '.js-confirmation',
      showCallback: showMainContainer
    }).render();
    Rover["default"].utils.scrollTo('.js-main-container');
  };

  var shouldShowPayments = function shouldShowPayments() {
    return requestableModel.isPayingState();
  };
  /**
   * We can choose if we show credit card input or now as soon as we know
   * the roverbucks you have, your credit cards have been rendered, and the
   * conversation has been rendered
   *
   * @param initial
   */


  var setInputsState = function setInputsState() {
    if (!shouldShowPayments()) {
      return;
    }

    if (!roverBucksModel) {
      return;
    }

    var roverBucks = roverBucksModel.get('non_redeemable');
    var creditCardsRendered = creditCardCollectionView.isRendered() === true;
    var conversationRendered = summaryView.isRendered() === true;

    if (roverBucks !== null && creditCardsRendered && conversationRendered) {
      if (!priceModel.roverBucksCoverCost()) {
        showCreditCardInput();
      } else {
        hideCreditCardInput();
      }

      Object(jquery["default"])('.js-payment-methods').show();
      showMainContainer();
    }
  };

  var setInputsStateInitial = function setInputsStateInitial() {
    setInputsState(true);
    var state = requestableModel.getState();

    if (state === 'authorize') {
      Object(jquery["default"])('.js-submit').text(translation["default"]._('Request to Book')).attr('data-loading-text', translation["default"]._('Loading...'));
      Object(jquery["default"])('.js-authorize-text').show();
    } else if (state === 'pay') {
      Object(jquery["default"])('.js-submit').text(translation["default"]._('Pay Now')).attr('data-loading-text', translation["default"]._('Loading...'));
      Object(jquery["default"])('.js-authorize-text').hide();
    }
  };

  var canProceed = function canProceed() {
    var selectedCreditCard = Object(jquery["default"])('.js-creditcard:checked').length;
    var payingEntirelyWithRoverbucks = priceModel.roverBucksCoverCost();
    var showSubmit = selectedCreditCard || payingEntirelyWithRoverbucks;
    Object(jquery["default"])('.js-submit').prop('disabled', !showSubmit);
  };

  var resetState = function resetState() {
    return Object(jquery["default"])('.js-submit').prop('disabled', true);
  };

  var getEventDataFromRequestable = function getEventDataFromRequestable(model) {
    var _ref, _ref2;

    var pets = model.get('pets');
    var petTypes = pets && pets.length > 0 ? underscore["default"].uniq((_ref = []).concat.apply(_ref, _toConsumableArray(pets.map(function (p) {
      return p.pet_type;
    })))) : [];
    var petBreeds = pets && pets.length > 0 ? underscore["default"].uniq((_ref2 = []).concat.apply(_ref2, _toConsumableArray(pets.map(function (p) {
      return p.breeds;
    })))) : [];
    return {
      dropOffDate: model.getDatesData().start_date,
      pickUpDate: model.getDatesData().end_date,
      service_type: model.getServiceType().slug,
      pet_type: petTypes.length > 1 ? 'both' : petTypes[0],
      pet_breeds: petBreeds.join(','),
      zipCode: currentUser["a" /* default */] ? currentUser["a" /* default */].zip : undefined
    };
  };

  var fireBookingCreatedMobileEmbedded = function fireBookingCreatedMobileEmbedded(eventDataFromRequestable) {
    var facebookEvent = 'fb_mobile_purchase';
    var isNewCustomer = currentUser["a" /* default */] ? currentUser["a" /* default */].is_new_customer : false;
    var kochavaEvent = isNewCustomer ? 'New Booking' : 'Repeat Booking';
    var firebaseEvent = isNewCustomer ? 'purchase' : 'spend_credits';
    var branchEvent = isNewCustomer ? 'PURCHASE' : 'SPEND_CREDITS';
    var eventNames = {
      facebook_event: facebookEvent,
      kochava_event: kochavaEvent,
      firebase_event: firebaseEvent,
      branch_event: branchEvent
    };

    var eventData = checkout__objectSpread({}, eventDataFromRequestable, {
      isNewCustomer: isNewCustomer
    });

    Object(fireEmbeddedWebEvent["a" /* default */])({
      eventData: eventData,
      eventNames: eventNames
    });
  };

  var fireAchievementsMobileEmbedded = function fireAchievementsMobileEmbedded(data, eventDataFromRequestable) {
    var firebaseEvent = {
      1: 'achieve_level',
      3: 'unlock_achievement'
    }[data.provider_booking_count];
    var branchEvent = {
      1: 'ACHIEVE_LEVEL',
      3: 'UNLOCK_ACHIEVEMENT'
    }[data.provider_booking_count];

    if (firebaseEvent && branchEvent) {
      var eventNames = {
        firebase_event: firebaseEvent,
        branch_event: branchEvent
      };
      var eventData = eventDataFromRequestable;
      Object(fireEmbeddedWebEvent["a" /* default */])({
        eventNames: eventNames,
        eventData: eventData
      });
    }
  };

  var handlePaymentSuccess = function handlePaymentSuccess(model, data, options) {
    var state = requestableModel.getState();
    var eventDataFromRequestable = getEventDataFromRequestable(requestableModel);

    if (state === 'authorize') {
      dataLayer["a" /* default */].push(checkout__objectSpread({
        event: 'owner-conversion-checkout-request-book',
        submitStatus: 'success',
        conversationId: requestableModel.getOpk(),
        is_new_customer: currentUser["a" /* default */] ? currentUser["a" /* default */].is_new_customer : undefined
      }, eventDataFromRequestable));
    } else if (state === 'pay') {
      dataLayer["a" /* default */].push(checkout__objectSpread({
        event: 'owner-conversion-checkout-pay-now',
        submitStatus: 'success',
        conversationId: requestableModel.getOpk(),
        is_new_customer: currentUser["a" /* default */] ? currentUser["a" /* default */].is_new_customer : undefined
      }, eventDataFromRequestable));
    } // Fire Create Booking event via postMessage for mobile embedded


    if (Object(userAgent["f" /* isMobileEmbedded */])()) {
      fireBookingCreatedMobileEmbedded(eventDataFromRequestable);
      fireAchievementsMobileEmbedded(data, eventDataFromRequestable);
    } // if the response contains a tracking URL, insert its contents in an iframe


    var trackingUrl = options.xhr.getResponseHeader('X-Rover-Event-Tracking-URL');

    if (trackingUrl) {
      var $iframe = Object(jquery["default"])("<iframe name=\"booking-tracking\" src=\"".concat(trackingUrl, "\"></iframe>"));
      $iframe.appendTo(Object(jquery["default"])('body'));
    }

    requestableModel.set(data);
    requestableModel.trigger('paid');
  };

  var showPaymentError = function showPaymentError(error) {
    Alerts["a" /* default */].showToast({
      severity: 'danger',
      message: error,
      container: Object(jquery["default"])('.js-payment-alerts-container')
    });
    Rover["default"].utils.scrollTo('.js-payment-alerts-container');
  };

  var submitPaymentErrorEvent = function submitPaymentErrorEvent() {
    var state = requestableModel.getState();

    if (state === 'authorize') {
      dataLayer["a" /* default */].push({
        event: 'owner-conversion-checkout-request-book',
        submitStatus: 'fail',
        serviceType: requestableModel.getServiceType().slug,
        conversationId: requestableModel.getOpk()
      });
    } else if (state === 'pay') {
      dataLayer["a" /* default */].push({
        event: 'owner-conversion-checkout-transaction',
        serviceType: requestableModel.getServiceType().slug,
        conversationId: requestableModel.getOpk(),
        revenue: requestableModel.get('total_price')
      });
      dataLayer["a" /* default */].push({
        event: 'owner-conversion-checkout-pay-now',
        submitStatus: 'fail',
        serviceType: requestableModel.getServiceType().slug,
        conversationId: requestableModel.getOpk()
      });
    }
  };

  var getDefaultErrorMessage = function getDefaultErrorMessage() {
    return translation["default"]._(
    /* i18n: {0} is a phone number */
    {
      id: "There was an error submitting your request - please try again. If you continue to have issues, contact customer support at {0}.",
      values: {
        0: Rover["default"].context.customerSupportPhone
      }
    });
  };

  var handlePaymentError = function handlePaymentError(model, response) {
    submitPaymentErrorEvent();
    var responseJSON = response.responseJSON;
    errorMessage = responseJSON.error_description || getDefaultErrorMessage();
    var nonFieldErrors = responseJSON.non_field_errors || [];

    if (response.status === 409) {
      errorMessage = translation["default"]._('It seems that the conversation was updated in the meantime. We reloaded the latest state of the conversation. Please review the "Stay Summary" section on the right and try again.');
      requestableModel.fetch().done(function () {
        Object(jquery["default"])('.js-submit').btn('reset');
        setInputsStateInitial();
        showPaymentError(errorMessage);
      });
    } else if (response.status === 400 && nonFieldErrors.includes('start_date cannot be in the past')) {
      errorMessage = translation["default"]._('This conversation has a start date in the past. It will need to be changed before it can be booked.');
      showPaymentError(errorMessage);
    } else if (response.status === 400 && responseJSON.error_type === 'conversation_missing_location') {
      errorMessage = nonFieldErrors[0] || errorMessage;
      showPaymentError(errorMessage);
    } else {
      Object(jquery["default"])('.js-submit').btn('reset');
      showPaymentError(errorMessage);
    }
  };

  var handlePaymentIntentError = function handlePaymentIntentError(message) {
    submitPaymentErrorEvent();
    Object(jquery["default"])('.js-submit').btn('reset');
    showPaymentError(message || getDefaultErrorMessage());
  };

  var makePayment = function makePayment() {
    return paymentModel.pay({
      success: handlePaymentSuccess,
      error: handlePaymentError,
      // use a separate method instead of piggyback on handlePaymentError
      // since it has specific signature of Backbone model
      paymentIntentError: handlePaymentIntentError
    });
  };

  var handleSubmit = function handleSubmit() {
    Object(jquery["default"])('.js-submit').btn('loading');
    Object(jquery["default"])('.js-payment-alerts-container').empty(); // If you are paying entirely with Rover Bucks and you have no
    // credit cards on files

    if (priceModel.roverBucksCoverCost() && creditCardCollection.models.length === 0) {
      Object(jquery["default"])('.js-select-payment-method').fadeOut('fast', function () {
        Object(jquery["default"])('.js-needs-cc').fadeIn('fast');
      });

      if (unmountReactCCForm) {
        unmountReactCCForm();
      }

      unmountReactCCForm = Object(ConversationsCheckoutPage["a" /* mount */])({
        onAddOrRemoveCard: function onAddOrRemoveCard() {
          return makePayment();
        },
        serviceType: requestableModel.getServiceType().slug
      }, '#react-add-ccform');
    } else {
      makePayment();
    }
  };

  var initPaymentsHasRun = false;

  var initPayments = function initPayments() {
    if (initPaymentsHasRun) {
      return;
    }

    initPaymentsHasRun = true;
    creditCardCollection = new CreditCardCollection["a" /* default */]();
    creditCardCollectionView = new credit_card_collection_view["a" /* default */]({
      collection: creditCardCollection,
      el: '.js-creditcard-list-container'
    });
    priceModel.on('change', setInputsState);
    priceModel.on('change', canProceed);
    var paymentMethodCollection = new PaymentMethodCollection["a" /* default */]({
      creditCardCollection: creditCardCollection,
      roverBucksModel: roverBucksModel
    }); // attempt to mount react ccform

    unmountReactCCForm = Object(ConversationsCheckoutPage["a" /* mount */])({
      onAddOrRemoveCard: function onAddOrRemoveCard() {
        return paymentMethodCollection.fetch({
          reset: true
        });
      },
      recieveSetDisabledReactCCFormUIFunc: function recieveSetDisabledReactCCFormUIFunc(func) {
        return setDisabledReactCCFormUI = func;
      },
      serviceType: requestableModel.getServiceType().slug
    });
    paymentMethodCollection.fetch().then(canProceed);
    new redemption_view({
      el: '.js-redemption-container',
      roverBucksModel: roverBucksModel,
      paymentMethodCollection: paymentMethodCollection
    }).render();
    paymentModel = new PaymentModel({
      roverBucksModel: roverBucksModel,
      requestableModel: requestableModel,
      priceModel: priceModel,
      creditCardCollectionView: creditCardCollectionView
    });
    creditCardCollectionView.on('initialRender', setInputsStateInitial);
    creditCardCollectionView.on('initialRender', canProceed);
    creditCardCollectionView.on('rendered', canProceed);
    creditCardCollection.on('add', setInputsState);
  };

  var setMainPaneState = function setMainPaneState() {
    var state = requestableModel.getState();

    if (shouldShowPayments()) {
      initPayments();
      dataLayer["a" /* default */].push({
        event: 'purchase-intent'
      });
    } else if (['requested', 'booked'].indexOf(state) !== -1) {
      showConfirmation(state);
    } else {
      window.location = requestableModel.get('web_url');
    }

    setInputsStateInitial(); // Tell native webviews they can close the loading indicator

    if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.rover && window.webkit.messageHandlers.rover.postMessage) {
      window.webkit.messageHandlers.rover.postMessage({
        action: 'hide-loading-indicator'
      });
    } else {
      Object(jquery["default"])(document).trigger('hide-loading-indicator');
    }
  };

  var addBindings = function addBindings() {
    requestableModel.on('complete paid', setMainPaneState);
    Object(jquery["default"])('.js-creditcard').on('change', canProceed);
    Object(jquery["default"])('.js-submit').on('click', handleSubmit);
  };

  var initHighlightCancellationMessageOnScroll = function initHighlightCancellationMessageOnScroll() {
    var $el = Object(jquery["default"])('.js-cancellation-message');
    if (!$el.length) return; // eslint-disable-next-line no-unused-vars

    var scrollHandler = new utilities_scroll({
      $element: $el,
      offset: 50
    }, function () {
      $el.addClass('remove-highlight');
    });
  };

  var init = function init() {
    var SummaryView;
    resetState();

    if (Rover["default"].context.requestableType === 'recurring-billing') {
      requestableModel = new Rover["default"].models.RecurringBillingModel({
        url: Rover["default"].urls.recurringBillingDetail
      });
      SummaryView = recurring_billing_summary_view["a" /* default */];
    } else {
      requestableModel = new conversation["default"]({
        url: Rover["default"].urls.conversationDetail
      });
      SummaryView = conversation_view["a" /* default */];
    }

    roverBucksModel = new RoverBucksModel["a" /* default */]();
    priceModel = new PriceModel["a" /* default */]({
      requestableModel: requestableModel,
      roverBucksModel: roverBucksModel
    });
    summaryView = new SummaryView({
      model: requestableModel,
      priceModel: priceModel,
      el: '.js-conversation-summary'
    });
    optionalRequesterAddOnsListView = new optional_requester_addons_list_view({
      requestableModel: requestableModel,
      el: '.js-requester-add-ons-container'
    });
    requestableModel.on('changing:requester_add_ons', function (slug, value) {
      if (value) {
        canProceed();
      } else {
        Object(jquery["default"])('.js-submit').attr('disabled', value);
      }
    });
    addBindings();
    var conversationDeferred = jquery["default"].Deferred();
    requestableModel.fetch({
      success: function success() {
        relationshipModel = new RelationshipModel(requestableModel.getRelationship());
        conversationDeferred.resolve();
      },
      error: function error(model) {
        // eslint-disable-next-line no-param-reassign
        model.fetchFailed = true;
        conversationDeferred.resolve();
      }
    });
    serviceModel = new Rover["default"].models.ServiceModel({
      url: Rover["default"].urls.serviceDetail
    });
    requestableModel.set('serviceModel', serviceModel);
    var serviceDeferred = jquery["default"].Deferred();
    serviceModel.fetch({
      error: function error(model) {
        // eslint-disable-next-line no-param-reassign
        model.fetchFailed = true;
        serviceDeferred.resolve();
      },
      success: serviceDeferred.resolve
    }); // eslint-disable-next-line consistent-return

    jquery["default"].when(conversationDeferred.promise(), serviceDeferred.promise()).always(function () {
      // If both models have data fire the complete event
      if (!requestableModel.fetchFailed && !serviceModel.fetchFailed) {
        return requestableModel.trigger('complete');
      } // If the conversation model succeeded, is in the booked state, and
      // the service model failed, unset serviceModel from the
      // conversation and continue on.


      if (!requestableModel.fetchFailed && serviceModel.fetchFailed && requestableModel.isBooked()) {
        requestableModel.unset('serviceModel');
        return requestableModel.trigger('complete');
      }
    });
    Rover["default"].stickyPopover(Object(jquery["default"])('[data-toggle="sticky-popover"]'), {
      container: 'body'
    });
    initHighlightCancellationMessageOnScroll();
  };

  init();
});

/***/ }),
/* 1743 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ../react-lib/src/components/utils/Redux/index.js
var Redux = __webpack_require__(67);

// EXTERNAL MODULE: ../utilities/object-utilities.js
var object_utilities = __webpack_require__(22);

// EXTERNAL MODULE: ../react-lib/src/redux/ducks/frontendConfiguration.duck.js + 3 modules
var frontendConfiguration_duck = __webpack_require__(149);

// EXTERNAL MODULE: ../react-lib/src/redux/ducks/countryConfiguration.duck.js + 2 modules
var countryConfiguration_duck = __webpack_require__(202);

// EXTERNAL MODULE: ../react-lib/src/apis/pet.api.js
var pet_api = __webpack_require__(523);

// EXTERNAL MODULE: ../react-lib/src/redux/ducks/pets.duck.js
var pets_duck = __webpack_require__(372);

// EXTERNAL MODULE: ../react-lib/src/redux/ducks/personSummary.duck.js
var personSummary_duck = __webpack_require__(453);

// EXTERNAL MODULE: ../node_modules/lodash-es/_baseAssignValue.js
var _baseAssignValue = __webpack_require__(52);

// EXTERNAL MODULE: ../node_modules/lodash-es/_createAggregator.js + 2 modules
var _createAggregator = __webpack_require__(922);

// CONCATENATED MODULE: ../node_modules/lodash-es/keyBy.js



/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the last element responsible for generating the key. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * var array = [
 *   { 'dir': 'left', 'code': 97 },
 *   { 'dir': 'right', 'code': 100 }
 * ];
 *
 * _.keyBy(array, function(o) {
 *   return String.fromCharCode(o.code);
 * });
 * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
 *
 * _.keyBy(array, 'dir');
 * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
 */
var keyBy = Object(_createAggregator["a" /* default */])(function(result, value, key) {
  Object(_baseAssignValue["a" /* default */])(result, key, value);
});

/* harmony default export */ var lodash_es_keyBy = (keyBy);

// EXTERNAL MODULE: ../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(1);

// EXTERNAL MODULE: ../react-lib/src/components/buttons/Button/index.js + 1 modules
var Button = __webpack_require__(13);

// EXTERNAL MODULE: ../react-lib/src/styles/index.js + 3 modules
var styles = __webpack_require__(2);

// EXTERNAL MODULE: ./js/constants/translationConstants.js
var translationConstants = __webpack_require__(215);

// EXTERNAL MODULE: ../react-lib/src/components/utils/RoverLoading/index.js
var RoverLoading = __webpack_require__(312);

// EXTERNAL MODULE: ../react-lib/src/components/buttons/LinkButton/LinkButton.jsx
var LinkButton = __webpack_require__(385);

// EXTERNAL MODULE: ../utilities/userAgent.js
var userAgent = __webpack_require__(60);

// EXTERNAL MODULE: ../node_modules/lodash-es/_baseKeys.js + 1 modules
var _baseKeys = __webpack_require__(159);

// EXTERNAL MODULE: ../node_modules/lodash-es/_getTag.js + 2 modules
var _getTag = __webpack_require__(63);

// EXTERNAL MODULE: ../node_modules/lodash-es/isArguments.js + 1 modules
var isArguments = __webpack_require__(40);

// EXTERNAL MODULE: ../node_modules/lodash-es/isArray.js
var isArray = __webpack_require__(5);

// EXTERNAL MODULE: ../node_modules/lodash-es/isArrayLike.js
var isArrayLike = __webpack_require__(23);

// EXTERNAL MODULE: ../node_modules/lodash-es/isBuffer.js
var isBuffer = __webpack_require__(38);

// EXTERNAL MODULE: ../node_modules/lodash-es/_isPrototype.js
var _isPrototype = __webpack_require__(75);

// EXTERNAL MODULE: ../node_modules/lodash-es/isTypedArray.js + 1 modules
var isTypedArray = __webpack_require__(48);

// CONCATENATED MODULE: ../node_modules/lodash-es/isEmpty.js









/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var isEmpty_hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (Object(isArrayLike["a" /* default */])(value) &&
      (Object(isArray["a" /* default */])(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        Object(isBuffer["a" /* default */])(value) || Object(isTypedArray["a" /* default */])(value) || Object(isArguments["a" /* default */])(value))) {
    return !value.length;
  }
  var tag = Object(_getTag["a" /* default */])(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (Object(_isPrototype["a" /* default */])(value)) {
    return !Object(_baseKeys["a" /* default */])(value).length;
  }
  for (var key in value) {
    if (isEmpty_hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

/* harmony default export */ var lodash_es_isEmpty = (isEmpty);

// EXTERNAL MODULE: ../react-lib/src/components/typography/index.js + 6 modules
var typography = __webpack_require__(315);

// EXTERNAL MODULE: ../react-lib/src/components/formFields/FormGroup/index.js
var FormGroup = __webpack_require__(129);

// EXTERNAL MODULE: ../react-lib/src/components/formFields/Textarea/index.js
var Textarea = __webpack_require__(481);

// CONCATENATED MODULE: ../react-lib/src/pages/conversations/EmergencyFormPage/components/CareInstructions/CareInstruction.jsx







var UpdateButton = Object(styled_components_browser_esm["default"])(Button["b" /* default */]).withConfig({
  displayName: "CareInstruction__UpdateButton",
  componentId: "sc-1yzj6s2-0"
})(["padding:0;"]);

var CareInstruction_CareInstruction = function CareInstruction(_ref) {
  var pet = _ref.pet,
      hasMultiplePets = _ref.hasMultiplePets,
      handleCareInstructionsChange = _ref.handleCareInstructionsChange,
      value = _ref.value,
      isEditing = _ref.isEditing,
      toggleEditing = _ref.toggleEditing;
  var inputId = "care-instructions-".concat(pet.id);
  return react_default.a.createElement(FormGroup["b" /* default */], null, hasMultiplePets && react_default.a.createElement("label", {
    htmlFor: inputId
  }, pet.name), isEditing ? react_default.a.createElement(Textarea["a" /* default */], {
    autoExpand: true,
    onChange: handleCareInstructionsChange,
    value: value,
    id: inputId
  }) : react_default.a.createElement(typography["b" /* Paragraph */], {
    marginBottom: "1x"
  }, value), !isEditing && react_default.a.createElement(UpdateButton, {
    buttonType: Button["a" /* ButtonType */].TEXT,
    onClick: function onClick() {
      return toggleEditing(pet);
    }
  }, translationConstants["d" /* CareInstructionsConstants */].updateButton));
};

/* harmony default export */ var CareInstructions_CareInstruction = (CareInstruction_CareInstruction);
// EXTERNAL MODULE: ../icons/index.js + 99 modules
var icons = __webpack_require__(39);

// CONCATENATED MODULE: ../react-lib/src/pages/conversations/EmergencyFormPage/components/common/SectionTitle.jsx






var SectionTitleWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "SectionTitle__SectionTitleWrapper",
  componentId: "sc-1708ns1-0"
})(["position:relative;"]);
var SectionTitleHeading = Object(styled_components_browser_esm["default"])(typography["a" /* Heading */]).withConfig({
  displayName: "SectionTitle__SectionTitleHeading",
  componentId: "sc-1708ns1-1"
})(["margin-bottom:0;"]);
var Circle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "SectionTitle__Circle",
  componentId: "sc-1708ns1-2"
})(["border:1px solid ", ";width:30px;height:30px;border-radius:50%;position:absolute;left:-45px;"], styles["d" /* DSToken */].BORDER_COLOR_PRIMARY);
var StyledAlertSuccess = Object(styled_components_browser_esm["default"])(icons["AlertSuccess"]).withConfig({
  displayName: "SectionTitle__StyledAlertSuccess",
  componentId: "sc-1708ns1-3"
})(["fill:", ";position:absolute;left:-45px;"], styles["d" /* DSToken */].INTERACTIVE_TEXT_COLOR_PRIMARY_ACTIVE);
var StyledSubHeading = Object(styled_components_browser_esm["default"])(typography["c" /* Text */]).withConfig({
  displayName: "SectionTitle__StyledSubHeading",
  componentId: "sc-1708ns1-4"
})(["color:", ";margin-bottom:", ";"], function (props) {
  return props.isComplete ? styles["d" /* DSToken */].INTERACTIVE_TEXT_COLOR_PRIMARY_ACTIVE : styles["d" /* DSToken */].TEXT_COLOR_ERROR;
}, styles["d" /* DSToken */].SPACE_2X);

var SectionTitle_renderSubheading = function renderSubheading(isComplete) {
  return isComplete ? react_default.a.createElement(StyledSubHeading, {
    as: "div",
    size: "200",
    isComplete: isComplete
  }, translationConstants["i" /* ContactInfoConstants */].complete) : react_default.a.createElement(StyledSubHeading, {
    as: "div",
    size: "200",
    isComplete: isComplete
  }, translationConstants["i" /* ContactInfoConstants */].incomplete);
};

var SectionTitle_SectionTitle = function SectionTitle(_ref) {
  var isComplete = _ref.isComplete,
      titleText = _ref.titleText;
  return react_default.a.createElement(SectionTitleWrapper, null, isComplete ? react_default.a.createElement(StyledAlertSuccess, null) : react_default.a.createElement(Circle, null), react_default.a.createElement(SectionTitleHeading, {
    size: "300"
  }, titleText), SectionTitle_renderSubheading(isComplete));
};

/* harmony default export */ var common_SectionTitle = (SectionTitle_SectionTitle);
// CONCATENATED MODULE: ../react-lib/src/pages/conversations/EmergencyFormPage/components/common/SectionSaveButton.jsx



var SaveButtonWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "SectionSaveButton__SaveButtonWrapper",
  componentId: "sc-1r1yku4-0"
})(["text-align:center;"]);

var SectionSaveButton_SectionSaveButton = function SectionSaveButton(_ref) {
  var isComplete = _ref.isComplete,
      buttonText = _ref.buttonText,
      saveMethod = _ref.saveMethod,
      wantingToEdit = _ref.wantingToEdit,
      disabled = _ref.disabled;
  return react_default.a.createElement("div", null, !isComplete || Object.values(wantingToEdit).some(function (currentlyEditing) {
    return currentlyEditing;
  }) ? react_default.a.createElement(SaveButtonWrapper, null, react_default.a.createElement(Button["b" /* default */], {
    disabled: disabled,
    marginBottom: "8x",
    onClick: saveMethod
  }, buttonText)) : react_default.a.createElement("div", null));
};

SectionSaveButton_SectionSaveButton.defaultProps = {
  wantingToEdit: {},
  disabled: false
};
/* harmony default export */ var common_SectionSaveButton = (SectionSaveButton_SectionSaveButton);
// CONCATENATED MODULE: ../react-lib/src/pages/conversations/EmergencyFormPage/components/CareInstructions/CareInstructions.jsx
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }








var SectionWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CareInstructions__SectionWrapper",
  componentId: "a33l3u-0"
})(["margin-left:45px;margin-right:45px;"]);

var CareInstructions_CareInstructions = function CareInstructions(_ref) {
  var pets = _ref.pets,
      handleSave = _ref.handleSave,
      handleUpdate = _ref.handleUpdate,
      isCareComplete = _ref.isCareComplete;

  var _useState = Object(react["useState"])({}),
      _useState2 = _slicedToArray(_useState, 2),
      currentlyEditing = _useState2[0],
      setCurrentlyEditing = _useState2[1];

  var toggleEditing = function toggleEditing(pet) {
    return setCurrentlyEditing(_objectSpread({}, currentlyEditing, _defineProperty({}, pet.url, !currentlyEditing[pet.url])));
  };

  var isFormComplete = lodash_es_isEmpty(currentlyEditing) && isCareComplete;

  var save = function save() {
    handleSave();
    setCurrentlyEditing({});
  };

  pets.forEach(function (pet) {
    if (!pet.careInstructions && !currentlyEditing[pet.url]) {
      toggleEditing(pet);
    }
  });
  return react_default.a.createElement(SectionWrapper, null, react_default.a.createElement(common_SectionTitle, {
    isComplete: isFormComplete,
    titleText: translationConstants["d" /* CareInstructionsConstants */].title
  }), pets.map(function (pet) {
    return react_default.a.createElement(CareInstructions_CareInstruction, {
      key: pet.url,
      pet: pet,
      hasMultiplePets: pets.length > 1,
      handleCareInstructionsChange: function handleCareInstructionsChange(careInstructions) {
        return handleUpdate(_objectSpread({}, pet, {
          careInstructions: careInstructions
        }));
      },
      value: pet.careInstructions,
      isEditing: currentlyEditing[pet.url],
      toggleEditing: toggleEditing
    });
  }), react_default.a.createElement(common_SectionSaveButton, {
    isComplete: isFormComplete,
    buttonText: translationConstants["d" /* CareInstructionsConstants */].save,
    saveMethod: save,
    currentlyEditing: currentlyEditing
  }));
};

/* harmony default export */ var components_CareInstructions_CareInstructions = (CareInstructions_CareInstructions);
// CONCATENATED MODULE: ../react-lib/src/pages/conversations/EmergencyFormPage/components/CareInstructions/index.js

// EXTERNAL MODULE: ../node_modules/lodash/get.js
var get = __webpack_require__(923);
var get_default = /*#__PURE__*/__webpack_require__.n(get);

// EXTERNAL MODULE: ../react-lib/src/containers/IntlPhoneInputContainer.jsx
var IntlPhoneInputContainer = __webpack_require__(543);

// EXTERNAL MODULE: ../react-lib/src/components/layouts/HorizontalLayout/index.js
var HorizontalLayout = __webpack_require__(109);

// EXTERNAL MODULE: ../react-lib/src/components/layouts/VerticalLayout/index.js
var VerticalLayout = __webpack_require__(227);

// EXTERNAL MODULE: ../react-lib/src/components/formFields/TextInput/index.js + 1 modules
var TextInput = __webpack_require__(214);

// CONCATENATED MODULE: ../react-lib/src/pages/conversations/EmergencyFormPage/components/ContactInfo/ContactInfo.jsx
function ContactInfo__slicedToArray(arr, i) { return ContactInfo__arrayWithHoles(arr) || ContactInfo__iterableToArrayLimit(arr, i) || ContactInfo__nonIterableRest(); }

function ContactInfo__nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function ContactInfo__iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function ContactInfo__arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }












var ContactInfo_SectionWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ContactInfo__SectionWrapper",
  componentId: "sc-16uzuq1-0"
})(["margin:0px 45px 15px 45px;"]);
var ContactInfo_UpdateButton = Object(styled_components_browser_esm["default"])(Button["b" /* default */]).withConfig({
  displayName: "ContactInfo__UpdateButton",
  componentId: "sc-16uzuq1-1"
})(["padding:0;"]);
var FormWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ContactInfo__FormWrapper",
  componentId: "sc-16uzuq1-2"
})(["display:flex;justify-content:space-between;"]);
var StyledTextInput = Object(styled_components_browser_esm["default"])(TextInput["a" /* default */]).withConfig({
  displayName: "ContactInfo__StyledTextInput",
  componentId: "sc-16uzuq1-3"
})(["flex-grow:0.4;"]);

var ContactInfo_renderForm = function renderForm(contactName, setContactName, phoneNumber, setPhoneValidation, phoneIsValid, submitEmergencyContactForm, phoneValidationMessage) {
  return react_default.a.createElement(ContactInfo_SectionWrapper, null, react_default.a.createElement(common_SectionTitle, {
    isComplete: false,
    titleText: translationConstants["i" /* ContactInfoConstants */].emergencyContactInfo
  }), react_default.a.createElement(FormWrapper, null, react_default.a.createElement(StyledTextInput, {
    label: translationConstants["i" /* ContactInfoConstants */].contactName,
    value: contactName,
    onChange: setContactName
  }), react_default.a.createElement(IntlPhoneInputContainer["a" /* default */], {
    validationError: phoneValidationMessage,
    onChange: setPhoneValidation
  })), react_default.a.createElement(common_SectionSaveButton, {
    isComplete: false,
    buttonText: translationConstants["i" /* ContactInfoConstants */].save,
    saveMethod: submitEmergencyContactForm
  }));
};

var ContactInfo_renderComplete = function renderComplete(emergencyContactPhoneNumber, emergencyContactName, toggleContactInfoForm) {
  return react_default.a.createElement(ContactInfo_SectionWrapper, null, react_default.a.createElement(VerticalLayout["a" /* default */], null, react_default.a.createElement(common_SectionTitle, {
    isComplete: true,
    titleText: translationConstants["i" /* ContactInfoConstants */].emergencyContactInfo
  }), react_default.a.createElement(HorizontalLayout["b" /* default */], null, react_default.a.createElement(typography["b" /* Paragraph */], {
    marginBottom: "1x"
  }, emergencyContactName, " ", emergencyContactPhoneNumber)), react_default.a.createElement(ContactInfo_UpdateButton, {
    buttonType: Button["a" /* ButtonType */].TEXT,
    onClick: function onClick() {
      return toggleContactInfoForm();
    }
  }, translationConstants["i" /* ContactInfoConstants */].updateEmergencyContactInfo)));
};

var ContactInfo_ContactInfo = function ContactInfo(props) {
  var personSummary = props.personSummary,
      savePersonSummaryPrivate = props.savePersonSummaryPrivate,
      isContactComplete = props.isContactComplete;
  var emergencyContactName = personSummary["private"].emergencyContactName || '';
  var emergencyContactPhoneNumber = personSummary["private"].emergencyContactPhoneNumber || '';

  var _useState = Object(react["useState"])(false),
      _useState2 = ContactInfo__slicedToArray(_useState, 2),
      overrideContactFormVisible = _useState2[0],
      setOverrideContactFormVisible = _useState2[1];

  var _useState3 = Object(react["useState"])(emergencyContactName),
      _useState4 = ContactInfo__slicedToArray(_useState3, 2),
      contactName = _useState4[0],
      setContactName = _useState4[1];

  var _useState5 = Object(react["useState"])(emergencyContactPhoneNumber),
      _useState6 = ContactInfo__slicedToArray(_useState5, 2),
      phoneNumber = _useState6[0],
      setPhoneNumber = _useState6[1];

  var _useState7 = Object(react["useState"])(false),
      _useState8 = ContactInfo__slicedToArray(_useState7, 2),
      phoneIsValid = _useState8[0],
      setPhoneIsValid = _useState8[1];

  var _useState9 = Object(react["useState"])(''),
      _useState10 = ContactInfo__slicedToArray(_useState9, 2),
      phoneValidationMessage = _useState10[0],
      setPhoneValidationMessage = _useState10[1];

  var setPhoneValidation = Object(react["useCallback"])(function (validationNumber, validated) {
    setPhoneValidationMessage('');
    setPhoneNumber(validationNumber);
    setPhoneIsValid(validated);
  });

  var resetForm = function resetForm() {
    setOverrideContactFormVisible(false);
    setPhoneIsValid(false);
    setPhoneValidationMessage('');
  };

  var submitEmergencyContactForm = function submitEmergencyContactForm() {
    if (!phoneIsValid) {
      setPhoneValidationMessage(translationConstants["i" /* ContactInfoConstants */].phoneNumberInvalid);
    }

    if (contactName.length !== 0 && phoneIsValid) {
      var personData = {
        emergencyContactPhoneNumber: phoneNumber,
        emergencyContactName: contactName
      };
      savePersonSummaryPrivate({
        personData: personData,
        personUrl: personSummary.urls["private"]
      });
      resetForm();
    }
  };

  var mainContent = overrideContactFormVisible || !isContactComplete ? ContactInfo_renderForm(contactName, setContactName, phoneNumber, setPhoneValidation, phoneIsValid, submitEmergencyContactForm, phoneValidationMessage) : ContactInfo_renderComplete(emergencyContactPhoneNumber, emergencyContactName, function () {
    return setOverrideContactFormVisible(!overrideContactFormVisible);
  });
  return react_default.a.createElement("div", null, mainContent);
};

/* harmony default export */ var components_ContactInfo_ContactInfo = (ContactInfo_ContactInfo);
// CONCATENATED MODULE: ../react-lib/src/pages/conversations/EmergencyFormPage/components/ContactInfo/ContactInfoContainer.jsx




var ContactInfoContainer_ContactInfoContainer = function ContactInfoContainer(props) {
  return react_default.a.createElement(react_default.a.Fragment, null, get_default()(props.personSummary, 'private', false) ? react_default.a.createElement(components_ContactInfo_ContactInfo, props) : null);
};

/* harmony default export */ var ContactInfo_ContactInfoContainer = (ContactInfoContainer_ContactInfoContainer);
// CONCATENATED MODULE: ../react-lib/src/pages/conversations/EmergencyFormPage/components/VetInfo/PetVetInfo.jsx







var PetVetInfo_UpdateButton = Object(styled_components_browser_esm["default"])(Button["b" /* default */]).withConfig({
  displayName: "PetVetInfo__UpdateButton",
  componentId: "sc-1aaeo99-0"
})(["padding:0;"]);

var PetVetInfo_PetVetInfo = function PetVetInfo(_ref) {
  var pet = _ref.pet,
      hasMultiplePets = _ref.hasMultiplePets,
      handleVetInfoChange = _ref.handleVetInfoChange,
      value = _ref.value,
      isEditing = _ref.isEditing,
      toggleEditing = _ref.toggleEditing;
  var inputId = "vet-info-".concat(pet.id);
  return react_default.a.createElement(FormGroup["b" /* default */], null, hasMultiplePets && react_default.a.createElement("label", {
    htmlFor: inputId
  }, pet.name), isEditing ? react_default.a.createElement(Textarea["a" /* default */], {
    autoExpand: true,
    onChange: handleVetInfoChange,
    value: value,
    id: inputId
  }) : react_default.a.createElement(typography["b" /* Paragraph */], {
    size: "200",
    marginBottom: "1x"
  }, value), !isEditing && react_default.a.createElement(PetVetInfo_UpdateButton, {
    buttonType: Button["a" /* ButtonType */].TEXT,
    onClick: function onClick() {
      return toggleEditing(pet);
    }
  }, translationConstants["y" /* VetInfoConstants */].updateButton));
};

/* harmony default export */ var VetInfo_PetVetInfo = (PetVetInfo_PetVetInfo);
// CONCATENATED MODULE: ../react-lib/src/pages/conversations/EmergencyFormPage/components/VetInfo/VetInfo.jsx
function VetInfo_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function VetInfo__objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { VetInfo_ownKeys(source, true).forEach(function (key) { VetInfo__defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { VetInfo_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function VetInfo__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function VetInfo__slicedToArray(arr, i) { return VetInfo__arrayWithHoles(arr) || VetInfo__iterableToArrayLimit(arr, i) || VetInfo__nonIterableRest(); }

function VetInfo__nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function VetInfo__iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function VetInfo__arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }








var VetInfo_SectionWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "VetInfo__SectionWrapper",
  componentId: "sc-1gx1t2i-0"
})(["margin-left:45px;margin-right:45px;"]);

var VetInfo_VetInfo = function VetInfo(_ref) {
  var pets = _ref.pets,
      handleSave = _ref.handleSave,
      handleUpdate = _ref.handleUpdate,
      isVetComplete = _ref.isVetComplete;

  var _useState = Object(react["useState"])({}),
      _useState2 = VetInfo__slicedToArray(_useState, 2),
      currentlyEditing = _useState2[0],
      setCurrentlyEditing = _useState2[1];

  var toggleEditing = function toggleEditing(pet) {
    return setCurrentlyEditing(VetInfo__objectSpread({}, currentlyEditing, VetInfo__defineProperty({}, pet.url, !currentlyEditing[pet.url])));
  };

  var isFormComplete = lodash_es_isEmpty(currentlyEditing) && isVetComplete;

  var save = function save() {
    handleSave();
    setCurrentlyEditing({});
  };

  pets.forEach(function (pet) {
    if (!pet.veterinaryInformation && !currentlyEditing[pet.url]) {
      toggleEditing(pet);
    }
  });
  return react_default.a.createElement(VetInfo_SectionWrapper, null, react_default.a.createElement(common_SectionTitle, {
    isComplete: isFormComplete,
    titleText: translationConstants["y" /* VetInfoConstants */].title
  }), pets.map(function (pet) {
    return react_default.a.createElement(VetInfo_PetVetInfo, {
      key: pet.url,
      pet: pet,
      hasMultiplePets: pets.length > 1,
      handleVetInfoChange: function handleVetInfoChange(veterinaryInformation) {
        return handleUpdate(VetInfo__objectSpread({}, pet, {
          veterinaryInformation: veterinaryInformation
        }));
      },
      value: pet.veterinaryInformation,
      isEditing: currentlyEditing[pet.url],
      toggleEditing: toggleEditing
    });
  }), react_default.a.createElement(common_SectionSaveButton, {
    isComplete: isFormComplete,
    buttonText: translationConstants["y" /* VetInfoConstants */].save,
    saveMethod: save,
    currentlyEditing: currentlyEditing
  }));
};

/* harmony default export */ var components_VetInfo_VetInfo = (VetInfo_VetInfo);
// CONCATENATED MODULE: ../react-lib/src/pages/conversations/EmergencyFormPage/components/VetInfo/index.js

// CONCATENATED MODULE: ../react-lib/src/pages/conversations/EmergencyFormPage/EmergencyFormPage.jsx
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function EmergencyFormPage_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function EmergencyFormPage__objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { EmergencyFormPage_ownKeys(source, true).forEach(function (key) { EmergencyFormPage__defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { EmergencyFormPage_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function EmergencyFormPage__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }













// Heading wrapper is used around an h3 tag over an actual Heading component
// to match sizing with titles in confirmation.mustache
var HeadingWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "EmergencyFormPage__HeadingWrapper",
  componentId: "ip9h7b-0"
})(["text-align:center;"]);
var EmergencyFormWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "EmergencyFormPage__EmergencyFormWrapper",
  componentId: "ip9h7b-1"
})(["padding-top:", ";padding-bottom:", ";margin-bottom:", ";border-bottom:", ";"], styles["d" /* DSToken */].SPACE_8X, styles["d" /* DSToken */].SPACE_8X, function (props) {
  return props.showfaq ? styles["d" /* DSToken */].SPACE_8X : 0;
}, function (props) {
  return props.showfaq ? "1px solid ".concat(styles["d" /* DSToken */].BORDER_COLOR_PRIMARY) : "none";
});
var ButtonWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "EmergencyFormPage__ButtonWrapper",
  componentId: "ip9h7b-2"
})(["text-align:center;margin-top:", ";"], styles["d" /* DSToken */].SPACE_8X);
var MutedTextWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "EmergencyFormPage__MutedTextWrapper",
  componentId: "ip9h7b-3"
})(["text-align:center;margin-bottom:", ";"], styles["d" /* DSToken */].SPACE_5X);
var MutedText = styled_components_browser_esm["default"].p.withConfig({
  displayName: "EmergencyFormPage__MutedText",
  componentId: "ip9h7b-4"
})(["margin-bottom:", ";color:", ";"], styles["d" /* DSToken */].SPACE_4X, styles["d" /* DSToken */].TEXT_COLOR_SECONDARY);
var EmergencyFormRoverLoading = Object(styled_components_browser_esm["default"])(RoverLoading["a" /* default */]).withConfig({
  displayName: "EmergencyFormPage__EmergencyFormRoverLoading",
  componentId: "ip9h7b-5"
})(["padding-bottom:80px;"]);

var EmergencyFormPage_EmergencyFormPage =
/*#__PURE__*/
function (_Component) {
  _inherits(EmergencyFormPage, _Component);

  function EmergencyFormPage() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, EmergencyFormPage);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(EmergencyFormPage)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      pets: lodash_es_keyBy(_this.props.pets, function (pet) {
        return pet.url;
      })
    };

    _this.handleUpdate = function (pet) {
      _this.setState(function (state) {
        return {
          pets: EmergencyFormPage__objectSpread({}, state.pets, EmergencyFormPage__defineProperty({}, pet.url, pet))
        };
      });
    };

    _this.handleSave = function () {
      var pets = Object.values(_this.state.pets); // $FlowFixMe flow always returns Array<mixed> from Object.values ...

      pets.forEach(function (pet) {
        return _this.props.savePet(pet);
      });
    };

    return _this;
  }

  _createClass(EmergencyFormPage, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          pets = _this$props.pets,
          getIsPetsLoading = _this$props.getIsPetsLoading,
          isVetComplete = _this$props.isVetComplete,
          isCareComplete = _this$props.isCareComplete,
          isContactComplete = _this$props.isContactComplete,
          conversationUrl = _this$props.conversationUrl,
          showfaq = _this$props.showfaq,
          personSummary = _this$props.personSummary,
          getIsPersonSummaryLoading = _this$props.getIsPersonSummaryLoading,
          savePersonSummaryPrivate = _this$props.savePersonSummaryPrivate;
      var petNames = pets.map(function (a) {
        return a.name;
      });
      var petConjuction = petNames.join(', ');
      var loadingComplete = !getIsPetsLoading && !getIsPersonSummaryLoading;
      var title = translationConstants["l" /* EmergencyFormConstants */].missedPetsSafetyInfo;

      if (isVetComplete && isCareComplete && isContactComplete) {
        title = translationConstants["l" /* EmergencyFormConstants */].petsSafetyInfo;
      }

      var renderReturnButton = function renderReturnButton() {
        var button = '';

        if (!Object(userAgent["f" /* isMobileEmbedded */])()) {
          button = react_default.a.createElement(ButtonWrapper, null, react_default.a.createElement(LinkButton["b" /* default */], {
            href: conversationUrl,
            buttonType: Button["a" /* ButtonType */].PRIMARY
          }, translationConstants["l" /* EmergencyFormConstants */].returnButton));
        }

        return button;
      };

      return loadingComplete ? react_default.a.createElement(EmergencyFormWrapper, {
        showfaq: showfaq
      }, react_default.a.createElement(HeadingWrapper, null, react_default.a.createElement("h3", null, title)), react_default.a.createElement(MutedTextWrapper, null, react_default.a.createElement(MutedText, null, translationConstants["l" /* EmergencyFormConstants */].filtersSitter(petConjuction))), react_default.a.createElement(components_VetInfo_VetInfo, {
        pets: Object.values(this.state.pets),
        handleUpdate: this.handleUpdate,
        handleSave: this.handleSave,
        isVetComplete: isVetComplete
      }), react_default.a.createElement(ContactInfo_ContactInfoContainer, {
        personSummary: personSummary,
        savePersonSummaryPrivate: savePersonSummaryPrivate,
        isContactComplete: isContactComplete
      }), react_default.a.createElement(components_CareInstructions_CareInstructions, {
        pets: Object.values(this.state.pets),
        handleUpdate: this.handleUpdate,
        handleSave: this.handleSave,
        isCareComplete: isCareComplete
      }), renderReturnButton()) : react_default.a.createElement(EmergencyFormRoverLoading, {
        isLoading: !loadingComplete
      });
    }
  }]);

  return EmergencyFormPage;
}(react["Component"]);

/* harmony default export */ var conversations_EmergencyFormPage_EmergencyFormPage = (EmergencyFormPage_EmergencyFormPage);
// CONCATENATED MODULE: ../react-lib/src/pages/conversations/EmergencyFormPage/EmergencyFormPageContainer.jsx
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }











var validEmergencyContactInfo = function validEmergencyContactInfo(summary) {
  var privateSummary = summary["private"] || {};
  var emergencyContactName = privateSummary.emergencyContactName || '';
  var emergencyContactPhoneNumber = privateSummary.emergencyContactPhoneNumber || '';
  return emergencyContactName && emergencyContactName.length && emergencyContactPhoneNumber && !!emergencyContactPhoneNumber.length;
};

var EmergencyFormPageContainer_selector = function selector(state) {
  return {
    pets: pets_duck["d" /* selectors */].getPets(state),
    getIsPetsLoading: pets_duck["d" /* selectors */].getIsLoading(state),
    getIsPersonSummaryLoading: personSummary_duck["c" /* selectors */].getIsLoading(state),
    isVetComplete: pets_duck["d" /* selectors */].getPets(state).every(function (pet) {
      return pet.veterinaryInformation;
    }),
    isCareComplete: pets_duck["d" /* selectors */].getPets(state).every(function (pet) {
      return pet.careInstructions;
    }),
    isContactComplete: validEmergencyContactInfo(personSummary_duck["c" /* selectors */].getPersonSummary(state)),
    personSummary: personSummary_duck["c" /* selectors */].getPersonSummary(state)
  };
};

var effects = {
  savePet: pets_duck["b" /* effects */].savePet,
  savePersonSummaryPrivate: personSummary_duck["a" /* effects */].savePersonSummaryPrivate
};

var EmergencyFormPageContainer_EmergencyFormContainer = function EmergencyFormContainer(_ref) {
  var petsProp = _ref.pets,
      props = _objectWithoutProperties(_ref, ["pets"]);

  return react_default.a.createElement(Redux["b" /* Provider */], {
    reducers: {
      frontendConfiguration: frontendConfiguration_duck["b" /* reducer */],
      pets: pets_duck["c" /* reducer */],
      personSummary: personSummary_duck["b" /* reducer */],
      countryConfiguration: countryConfiguration_duck["b" /* reducer */]
    }
  }, react_default.a.createElement(Redux["a" /* Connect */], {
    selector: EmergencyFormPageContainer_selector,
    effects: effects,
    onMount: [frontendConfiguration_duck["a" /* effects */].fetchFrontendConfiguration, function () {
      return pets_duck["a" /* actions */].fetchPetsSuccess(Object(object_utilities["a" /* camelize */])(petsProp, true).map(pet_api["g" /* scrubAPetData */]));
    }, personSummary_duck["a" /* effects */].fetchPersonSummary]
  }, function (redux) {
    return react_default.a.createElement(conversations_EmergencyFormPage_EmergencyFormPage, _extends({}, redux, props));
  }));
};

/* harmony default export */ var EmergencyFormPageContainer = __webpack_exports__["default"] = (EmergencyFormPageContainer_EmergencyFormContainer);

/***/ })
],[1739]);


// WEBPACK FOOTER //
// coreembedded.8130e6a0f7404db1.js